[
    {
        "name": "Atorvastatin",
        "route": "Oral Pill",
        "fullName": "Atorvastatin (Oral Pill)",
        "totalCount": 3649,
        "searchTerms": [
            "ATORVASTATIN",
            "ATORVASTATIN (Oral)",
            "Atorvastatin",
            "Atorvastatin (Oral Pill)",
            "Atorvastatin (Oral)",
            "LIPITOR",
            "LIPITOR 40MG",
            "Lipitor",
            "Lipitor 40 mg",
            "atorvastatin",
            "atorvastatin (Oral)",
            "atorvastatin (oral pill)",
            "atorvastatin (oral)",
            "atorvastatin 10 MG Oral Tablet",
            "atorvastatin 10 mg oral tablet",
            "atorvastatin 20 MG Oral Tablet",
            "atorvastatin 20 mg oral tablet",
            "atorvastatin 40 MG Oral Tablet",
            "atorvastatin 40 mg oral tablet",
            "atorvastatin 80 MG Oral Tablet",
            "atorvastatin 80 mg oral tablet",
            "lipitor",
            "lipitor 40 mg",
            "lipitor 40mg"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "35%"
            },
            {
                "value": "20 mg",
                "pct": "27%"
            },
            {
                "value": "80 mg",
                "pct": "19%"
            },
            {
                "value": "10 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "amLODIPine",
        "route": "Oral Pill",
        "fullName": "amLODIPine (Oral Pill)",
        "totalCount": 2462,
        "searchTerms": [
            "AMLODIPINE",
            "AMLODIPINE (Oral)",
            "Amlodipine",
            "Amlodipine (Oral)",
            "NORVASC",
            "Norvasc",
            "amLODIPine",
            "amLODIPine (Oral Pill)",
            "amLODIPine (Oral)",
            "amlodipine",
            "amlodipine (oral pill)",
            "amlodipine (oral)",
            "amlodipine 10 MG Oral Tablet",
            "amlodipine 10 mg oral tablet",
            "amlodipine 2.5 MG Oral Tablet",
            "amlodipine 2.5 mg oral tablet",
            "amlodipine 5 MG Oral Tablet",
            "amlodipine 5 mg oral tablet",
            "norvasc"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "50%"
            },
            {
                "value": "10 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "84%"
            }
        ]
    },
    {
        "name": "TYLENOL",
        "route": "Oral Pill",
        "fullName": "TYLENOL (Oral Pill)",
        "totalCount": 2189,
        "searchTerms": [
            "TYLENOL",
            "TYLENOL (Oral Pill)",
            "Tylenol",
            "Tylenol (Oral)",
            "acetaminophen 325 MG Oral Capsule",
            "acetaminophen 325 MG Oral Tablet",
            "acetaminophen 325 mg oral capsule",
            "acetaminophen 325 mg oral tablet",
            "acetaminophen 500 MG Oral Tablet",
            "acetaminophen 500 mg oral tablet",
            "tylenol",
            "tylenol (oral pill)",
            "tylenol (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "48%"
            },
            {
                "value": "325 mg",
                "pct": "43%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "65%"
            },
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "Losartan",
        "route": "Oral Pill",
        "fullName": "Losartan (Oral Pill)",
        "totalCount": 1562,
        "searchTerms": [
            "COZAAR",
            "Cozaar",
            "LOSARTAN",
            "LOSARTAN (Oral)",
            "Losartan",
            "Losartan (Oral Pill)",
            "Losartan (Oral)",
            "cozaar",
            "losartan",
            "losartan (Oral)",
            "losartan (oral pill)",
            "losartan (oral)",
            "losartan potassium 100 MG Oral Tablet",
            "losartan potassium 100 mg oral tablet",
            "losartan potassium 25 MG Oral Tablet",
            "losartan potassium 25 mg oral tablet",
            "losartan potassium 50 MG Oral Tablet",
            "losartan potassium 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "37%"
            },
            {
                "value": "50 mg",
                "pct": "34%"
            },
            {
                "value": "25 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "79%"
            }
        ]
    },
    {
        "name": "Aspirin",
        "route": "Oral Pill",
        "fullName": "Aspirin (Oral Pill)",
        "totalCount": 1557,
        "searchTerms": [
            "ASPIRIN",
            "ASPIRIN (Oral)",
            "Aspirin",
            "Aspirin (Oral Pill)",
            "Aspirin (Oral)",
            "BAYER ASPIRIN",
            "BAYER LOW DOSE",
            "Bayer",
            "Bayer Advanced Aspirin",
            "Bayer Aspirin",
            "Bayer Children's",
            "Bayer Low Dose",
            "Bayer Low Dose Aspirin",
            "Bayer Regimen",
            "ECOTRIN",
            "Ecotrin",
            "Ecotrin Low Strength",
            "Ninoprin",
            "aspirin",
            "aspirin (Oral)",
            "aspirin (oral pill)",
            "aspirin (oral)",
            "aspirin 325 MG Delayed Release Oral Tablet",
            "aspirin 325 MG Oral Tablet",
            "aspirin 325 mg delayed release oral tablet",
            "aspirin 325 mg oral tablet",
            "aspirin 650 MG Oral Tablet",
            "aspirin 650 mg oral tablet",
            "aspirin 81 MG Delayed Release Oral Tablet",
            "aspirin 81 MG Oral Tablet",
            "aspirin 81 mg delayed release oral tablet",
            "aspirin 81 mg oral tablet",
            "bayer",
            "bayer advanced aspirin",
            "bayer aspirin",
            "bayer children's",
            "bayer low dose",
            "bayer low dose aspirin",
            "bayer regimen",
            "ecotrin",
            "ecotrin low strength",
            "ninoprin"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "98%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "47%"
            }
        ]
    },
    {
        "name": "Metoprolol XR",
        "route": "Oral Pill",
        "fullName": "Metoprolol XR (Oral Pill)",
        "totalCount": 1532,
        "searchTerms": [
            "24 HR metoprolol succinate 100 MG Extended Release Oral Capsule",
            "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet",
            "24 HR metoprolol succinate 200 MG Extended Release Oral Capsule",
            "24 HR metoprolol succinate 25 MG Extended Release Oral Capsule",
            "24 HR metoprolol succinate 25 MG Extended Release Oral Tablet",
            "24 HR metoprolol succinate 50 MG Extended Release Oral Capsule",
            "24 HR metoprolol succinate 50 MG Extended Release Oral Tablet",
            "24 hr metoprolol succinate 100 mg extended release oral capsule",
            "24 hr metoprolol succinate 100 mg extended release oral tablet",
            "24 hr metoprolol succinate 200 mg extended release oral capsule",
            "24 hr metoprolol succinate 25 mg extended release oral capsule",
            "24 hr metoprolol succinate 25 mg extended release oral tablet",
            "24 hr metoprolol succinate 50 mg extended release oral capsule",
            "24 hr metoprolol succinate 50 mg extended release oral tablet",
            "Metoprolol XR",
            "Metoprolol XR (Oral Pill)",
            "metoprolol xr",
            "metoprolol xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "46%"
            },
            {
                "value": "50 mg",
                "pct": "36%"
            },
            {
                "value": "100 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            },
            {
                "value": "Twice daily",
                "pct": "16%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "49%"
            }
        ]
    },
    {
        "name": "Albuterol",
        "route": "Inhalant",
        "fullName": "Albuterol (Inhalant)",
        "totalCount": 1450,
        "searchTerms": [
            "200 ACTUAT albuterol 0.09 MG/ACTUAT Dry Powder Inhaler",
            "200 actuat albuterol 0.09 mg/actuat dry powder inhaler",
            "ALBUTEROL",
            "Albuterol",
            "Albuterol (Inhalant)",
            "NDA020503 200 ACTUAT albuterol 0.09 MG/ACTUAT Metered Dose Inhaler",
            "NDA020983 200 ACTUAT albuterol 0.09 MG/ACTUAT Metered Dose Inhaler",
            "NDA021457 200 ACTUAT albuterol 0.09 MG/ACTUAT Metered Dose Inhaler",
            "Sensor 200 ACTUAT albuterol 0.09 MG/ACTUAT Dry Powder Inhaler",
            "albuterol",
            "albuterol (inhalant)",
            "albuterol 5 MG/ML Inhalation Solution",
            "albuterol 5 mg/ml inhalation solution",
            "nda020503 200 actuat albuterol 0.09 mg/actuat metered dose inhaler",
            "nda020983 200 actuat albuterol 0.09 mg/actuat metered dose inhaler",
            "nda021457 200 actuat albuterol 0.09 mg/actuat metered dose inhaler",
            "sensor 200 actuat albuterol 0.09 mg/actuat dry powder inhaler"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "85%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "56%"
            },
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "15%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "Gabapentin",
        "route": "Oral Pill",
        "fullName": "Gabapentin (Oral Pill)",
        "totalCount": 1262,
        "searchTerms": [
            "GABAPENTIN",
            "GABAPENTIN (Oral)",
            "Gabapentin",
            "Gabapentin (Oral Pill)",
            "Gabapentin (Oral)",
            "NEURONTIN",
            "Neurontin",
            "Once-Daily gabapentin 300 MG Oral Tablet",
            "Once-Daily gabapentin 600 MG Oral Tablet",
            "gabapentin",
            "gabapentin (Oral)",
            "gabapentin (oral pill)",
            "gabapentin (oral)",
            "gabapentin 100 MG Oral Capsule",
            "gabapentin 100 mg oral capsule",
            "gabapentin 300 MG Oral Capsule",
            "gabapentin 300 mg oral capsule",
            "gabapentin 400 MG Oral Capsule",
            "gabapentin 400 mg oral capsule",
            "gabapentin 600 MG Oral Tablet",
            "gabapentin 600 mg oral tablet",
            "gabapentin 800 MG Oral Tablet",
            "gabapentin 800 mg oral tablet",
            "neurontin",
            "once-daily gabapentin 300 mg oral tablet",
            "once-daily gabapentin 600 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "41%"
            },
            {
                "value": "100 mg",
                "pct": "35%"
            },
            {
                "value": "600 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "30%"
            },
            {
                "value": "Once daily",
                "pct": "27%"
            },
            {
                "value": "Twice daily",
                "pct": "26%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "52%"
            },
            {
                "code": "G62.9",
                "description": "Polyneuropathy, unspecified",
                "pct": "32%"
            }
        ]
    },
    {
        "name": "Lisinopril",
        "route": "Oral Pill",
        "fullName": "Lisinopril (Oral Pill)",
        "totalCount": 1235,
        "searchTerms": [
            "LISINOPRIL",
            "LISINOPRIL (Oral)",
            "Lisinopril",
            "Lisinopril (Oral Pill)",
            "Lisinopril (Oral)",
            "Prinivil",
            "ZESTRIL",
            "Zestril",
            "Zestril/Prinivil",
            "lisinopril",
            "lisinopril (Oral)",
            "lisinopril (oral pill)",
            "lisinopril (oral)",
            "lisinopril 10 MG Oral Tablet",
            "lisinopril 10 mg oral tablet",
            "lisinopril 2.5 MG Oral Tablet",
            "lisinopril 2.5 mg oral tablet",
            "lisinopril 20 MG Oral Tablet",
            "lisinopril 20 mg oral tablet",
            "lisinopril 30 MG Oral Tablet",
            "lisinopril 30 mg oral tablet",
            "lisinopril 40 MG Oral Tablet",
            "lisinopril 40 mg oral tablet",
            "lisinopril 5 MG Oral Tablet",
            "lisinopril 5 mg oral tablet",
            "prinivil",
            "zestril",
            "zestril/prinivil"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "24%"
            },
            {
                "value": "40 mg",
                "pct": "23%"
            },
            {
                "value": "10 mg",
                "pct": "21%"
            },
            {
                "value": "5 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "80%"
            }
        ]
    },
    {
        "name": "ELIQUIS",
        "route": "Oral Pill",
        "fullName": "ELIQUIS (Oral Pill)",
        "totalCount": 1138,
        "searchTerms": [
            "Apixaban",
            "ELIQUIS",
            "ELIQUIS (Oral Pill)",
            "ELIQUIS (Oral)",
            "Eliquis",
            "Eliquis (Oral)",
            "apixaban",
            "apixaban 2.5 MG Oral Tablet",
            "apixaban 2.5 mg oral tablet",
            "apixaban 5 MG Oral Tablet",
            "apixaban 5 mg oral tablet",
            "eliquis",
            "eliquis (oral pill)",
            "eliquis (oral)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "66%"
            },
            {
                "value": "2.5 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "65%"
            },
            {
                "value": "Once daily",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I48.91",
                "description": "Unspecified atrial fibrillation",
                "pct": "39%"
            },
            {
                "code": "I82.40",
                "description": "Acute embolism and thombos unsp deep veins of low extrm",
                "pct": "22%"
            }
        ]
    },
    {
        "name": "Levothyroxine",
        "route": "Oral Pill",
        "fullName": "Levothyroxine (Oral Pill)",
        "totalCount": 1111,
        "searchTerms": [
            "LEVOTHYROXINE",
            "LEVOTHYROXINE (Oral)",
            "Levothroid",
            "Levothyroxine",
            "Levothyroxine (Oral Pill)",
            "Levothyroxine (Oral)",
            "SYNTHROID",
            "Synthroid",
            "Unithroid",
            "levothroid",
            "levothyroxine",
            "levothyroxine (Oral)",
            "levothyroxine (oral pill)",
            "levothyroxine (oral)",
            "levothyroxine sodium 0.1 MG Oral Tablet",
            "levothyroxine sodium 0.1 mg oral tablet",
            "levothyroxine sodium 0.175 MG Oral Capsule",
            "levothyroxine sodium 0.175 mg oral capsule",
            "levothyroxine sodium 0.2 MG Oral Capsule",
            "levothyroxine sodium 0.2 mg oral capsule",
            "synthroid",
            "unithroid"
        ],
        "dosages": [
            {
                "value": "50 mcg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [
            {
                "value": "Best taken on an empty stomach 30–60 minutes before breakfast",
                "pct": "10%"
            }
        ],
        "diagnoses": [
            {
                "code": "E03.9",
                "description": "Hypothyroidism, unspecified",
                "pct": "71%"
            },
            {
                "code": "E03",
                "description": "Other hypothyroidism",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "Rosuvastatin",
        "route": "Oral Pill",
        "fullName": "Rosuvastatin (Oral Pill)",
        "totalCount": 1103,
        "searchTerms": [
            "CRESTOR",
            "Crestor",
            "ROSUVASTATIN",
            "ROSUVASTATIN (Oral)",
            "Rosuvastatin",
            "Rosuvastatin (Oral Pill)",
            "Rosuvastatin (Oral)",
            "crestor",
            "rosuvastatin",
            "rosuvastatin (Oral)",
            "rosuvastatin (oral pill)",
            "rosuvastatin (oral)",
            "rosuvastatin 10 MG Oral Capsule",
            "rosuvastatin 10 mg oral capsule",
            "rosuvastatin 20 MG Oral Capsule",
            "rosuvastatin 20 mg oral capsule",
            "rosuvastatin 40 MG Oral Capsule",
            "rosuvastatin 40 mg oral capsule",
            "rosuvastatin 5 MG Oral Capsule",
            "rosuvastatin 5 mg oral capsule",
            "rosuvastatin calcium 10 MG Oral Tablet",
            "rosuvastatin calcium 10 mg oral tablet",
            "rosuvastatin calcium 20 MG Oral Tablet",
            "rosuvastatin calcium 20 mg oral tablet",
            "rosuvastatin calcium 40 MG Oral Tablet",
            "rosuvastatin calcium 40 mg oral tablet",
            "rosuvastatin calcium 5 MG Oral Tablet",
            "rosuvastatin calcium 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "32%"
            },
            {
                "value": "20 mg",
                "pct": "32%"
            },
            {
                "value": "40 mg",
                "pct": "21%"
            },
            {
                "value": "5 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "65%"
            }
        ]
    },
    {
        "name": "Omeprazole",
        "route": "Oral Pill",
        "fullName": "Omeprazole (Oral Pill)",
        "totalCount": 1071,
        "searchTerms": [
            "OMEPRAZOLE",
            "OMEPRAZOLE (Oral)",
            "Omeprazole",
            "Omeprazole (Oral Pill)",
            "Omeprazole (Oral)",
            "PRILOSEC",
            "Prilosec",
            "Prilosec 40 Ext-Release",
            "omeprazole",
            "omeprazole (Oral)",
            "omeprazole (oral pill)",
            "omeprazole (oral)",
            "omeprazole 10 MG Delayed Release Oral Capsule",
            "omeprazole 10 mg delayed release oral capsule",
            "omeprazole 20 MG Delayed Release Oral Capsule",
            "omeprazole 20 MG Delayed Release Oral Tablet",
            "omeprazole 20 mg delayed release oral capsule",
            "omeprazole 20 mg delayed release oral tablet",
            "omeprazole 40 MG Delayed Release Oral Capsule",
            "omeprazole 40 mg delayed release oral capsule",
            "prilosec",
            "prilosec 40 ext-release"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "55%"
            },
            {
                "value": "20 mg",
                "pct": "44%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "68%"
            },
            {
                "code": "K21",
                "description": "Gastro-esophageal reflux disease",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "metFORMIN",
        "route": "Oral Pill",
        "fullName": "metFORMIN (Oral Pill)",
        "totalCount": 1038,
        "searchTerms": [
            "GLUCOPHAGE",
            "GLUCOPHAGE XR",
            "Glucophage",
            "METFORMIN",
            "METFORMIN (Oral)",
            "Metformin",
            "Metformin (Oral)",
            "glucophage",
            "glucophage xr",
            "metFORMIN",
            "metFORMIN (Oral Pill)",
            "metFORMIN (Oral)",
            "metformin",
            "metformin (oral pill)",
            "metformin (oral)",
            "metformin hydrochloride 1000 MG Oral Tablet",
            "metformin hydrochloride 1000 mg oral tablet",
            "metformin hydrochloride 500 MG Oral Tablet",
            "metformin hydrochloride 500 mg oral tablet",
            "metformin hydrochloride 850 MG Oral Tablet",
            "metformin hydrochloride 850 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "55%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "59%"
            },
            {
                "value": "Once daily",
                "pct": "37%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "68%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "22%"
            }
        ]
    },
    {
        "name": "Tamsulosin",
        "route": "Oral Pill",
        "fullName": "Tamsulosin (Oral Pill)",
        "totalCount": 997,
        "searchTerms": [
            "Flomax",
            "TAMSULOSIN",
            "TAMSULOSIN (Oral)",
            "Tamsulosin",
            "Tamsulosin (Oral Pill)",
            "Tamsulosin (Oral)",
            "flomax",
            "tamsulosin",
            "tamsulosin (Oral)",
            "tamsulosin (oral pill)",
            "tamsulosin (oral)",
            "tamsulosin hydrochloride 0.4 MG Oral Capsule",
            "tamsulosin hydrochloride 0.4 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "0.4 mg",
                "pct": "99%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N40.1",
                "description": "Enlarged prostate with lower urinary tract symptoms",
                "pct": "61%"
            },
            {
                "code": "N40",
                "description": "Enlarged prostate",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "Metoprolol",
        "route": "Oral Pill",
        "fullName": "Metoprolol (Oral Pill)",
        "totalCount": 962,
        "searchTerms": [
            "Lopressor",
            "METOPROLOL",
            "METOPROLOL (Oral)",
            "Metoprolol",
            "Metoprolol (Oral Pill)",
            "Metoprolol (Oral)",
            "Toprol XL",
            "Toprol XL (Extended-release)",
            "Toprol-XL",
            "lopressor",
            "metoprolol",
            "metoprolol (Oral)",
            "metoprolol (oral pill)",
            "metoprolol (oral)",
            "metoprolol tartrate 100 MG Oral Tablet",
            "metoprolol tartrate 100 mg oral tablet",
            "metoprolol tartrate 25 MG Oral Tablet",
            "metoprolol tartrate 25 mg oral tablet",
            "metoprolol tartrate 37.5 MG Oral Tablet",
            "metoprolol tartrate 37.5 mg oral tablet",
            "metoprolol tartrate 50 MG Oral Tablet",
            "metoprolol tartrate 50 mg oral tablet",
            "metoprolol tartrate 75 MG Oral Tablet",
            "metoprolol tartrate 75 mg oral tablet",
            "toprol xl",
            "toprol xl (extended-release)",
            "toprol-xl"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "49%"
            },
            {
                "value": "50 mg",
                "pct": "30%"
            },
            {
                "value": "100 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            },
            {
                "value": "Twice daily",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "79%"
            }
        ]
    },
    {
        "name": "Furosemide",
        "route": "Oral Pill",
        "fullName": "Furosemide (Oral Pill)",
        "totalCount": 936,
        "searchTerms": [
            "FUROSEMIDE",
            "FUROSEMIDE (Oral)",
            "Furosemide",
            "Furosemide (Oral Pill)",
            "Furosemide (Oral)",
            "LASIX",
            "Lasix",
            "furosemide",
            "furosemide (Oral)",
            "furosemide (oral pill)",
            "furosemide (oral)",
            "furosemide 20 MG Oral Tablet",
            "furosemide 20 mg oral tablet",
            "furosemide 40 MG Oral Tablet",
            "furosemide 40 mg oral tablet",
            "furosemide 80 MG Oral Tablet",
            "furosemide 80 mg oral tablet",
            "lasix"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "53%"
            },
            {
                "value": "40 mg",
                "pct": "41%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "39%"
            },
            {
                "code": "R60.9",
                "description": "Edema, unspecified",
                "pct": "36%"
            }
        ]
    },
    {
        "name": "Pantoprazole",
        "route": "Oral Pill",
        "fullName": "Pantoprazole (Oral Pill)",
        "totalCount": 910,
        "searchTerms": [
            "PANTOPRAZOLE",
            "PANTOPRAZOLE (Oral)",
            "PROTONIX",
            "Pantoprazole",
            "Pantoprazole (Oral Pill)",
            "Pantoprazole (Oral)",
            "Protonix",
            "pantoprazole",
            "pantoprazole (Oral)",
            "pantoprazole (oral pill)",
            "pantoprazole (oral)",
            "pantoprazole 20 MG Delayed Release Oral Tablet",
            "pantoprazole 20 mg delayed release oral tablet",
            "pantoprazole 40 MG Delayed Release Oral Tablet",
            "pantoprazole 40 mg delayed release oral tablet",
            "protonix"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "84%"
            },
            {
                "value": "20 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "68%"
            },
            {
                "code": "K21",
                "description": "Gastro-esophageal reflux disease",
                "pct": "10%"
            }
        ]
    },
    {
        "name": "Famotidine",
        "route": "Oral Pill",
        "fullName": "Famotidine (Oral Pill)",
        "totalCount": 899,
        "searchTerms": [
            "FAMOTIDINE",
            "FAMOTIDINE (Oral)",
            "Famotidine",
            "Famotidine (Oral Pill)",
            "Famotidine (Oral)",
            "Famotidine40",
            "OTC Pepcid",
            "PEPCID",
            "PEPCID AC MAX STRENGTH",
            "Pepcid",
            "Pepcid AC",
            "Pepcid AC Max",
            "Pepcid AC Max Strength",
            "Pepcid/Zantac-360",
            "famotidine",
            "famotidine (Oral)",
            "famotidine (oral pill)",
            "famotidine (oral)",
            "famotidine 10 MG Oral Tablet",
            "famotidine 10 mg oral tablet",
            "famotidine 20 MG Oral Tablet",
            "famotidine 20 mg oral tablet",
            "famotidine 40 MG Oral Tablet",
            "famotidine 40 mg oral tablet",
            "famotidine40",
            "otc pepcid",
            "pepcid",
            "pepcid ac",
            "pepcid ac max",
            "pepcid ac max strength",
            "pepcid/zantac-360"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "63%"
            },
            {
                "value": "40 mg",
                "pct": "34%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            },
            {
                "value": "Twice daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "73%"
            },
            {
                "code": "K21",
                "description": "Gastro-esophageal reflux disease",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "JARDIANCE",
        "route": "Oral Pill",
        "fullName": "JARDIANCE (Oral Pill)",
        "totalCount": 823,
        "searchTerms": [
            "JARDIANCE",
            "JARDIANCE (Oral Pill)",
            "JARDIANCE (Oral)",
            "Jardiance",
            "Jardiance (Oral)",
            "empagliflozin 10 MG Oral Tablet",
            "empagliflozin 10 mg oral tablet",
            "empagliflozin 25 MG Oral Tablet",
            "empagliflozin 25 mg oral tablet",
            "jardiance",
            "jardiance (oral pill)",
            "jardiance (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "57%"
            },
            {
                "value": "25 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "63%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "traZODone",
        "route": "Oral Pill",
        "fullName": "traZODone (Oral Pill)",
        "totalCount": 815,
        "searchTerms": [
            "Desyrel",
            "TRAZODONE",
            "Trazodone",
            "Trazodone (Oral)",
            "desyrel",
            "traZODone",
            "traZODone (Oral Pill)",
            "traZODone (Oral)",
            "trazodone",
            "trazodone (Oral)",
            "trazodone (oral pill)",
            "trazodone (oral)",
            "trazodone hydrochloride 100 MG Oral Tablet",
            "trazodone hydrochloride 100 mg oral tablet",
            "trazodone hydrochloride 150 MG Oral Tablet",
            "trazodone hydrochloride 150 mg oral tablet",
            "trazodone hydrochloride 300 MG Oral Tablet",
            "trazodone hydrochloride 300 mg oral tablet",
            "trazodone hydrochloride 50 MG Oral Tablet",
            "trazodone hydrochloride 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "56%"
            },
            {
                "value": "100 mg",
                "pct": "29%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "48%"
            },
            {
                "value": "At bedtime",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "55%"
            },
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "Gabapentin XR",
        "route": "Oral Pill",
        "fullName": "Gabapentin XR (Oral Pill)",
        "totalCount": 759,
        "searchTerms": [
            "Gabapentin XR",
            "Gabapentin XR (Oral Pill)",
            "gabapentin enacarbil 300 MG Extended Release Oral Tablet",
            "gabapentin enacarbil 300 mg extended release oral tablet",
            "gabapentin enacarbil 600 MG Extended Release Oral Tablet",
            "gabapentin enacarbil 600 mg extended release oral tablet",
            "gabapentin xr",
            "gabapentin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "49%"
            },
            {
                "value": "100 mg",
                "pct": "24%"
            },
            {
                "value": "600 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "31%"
            },
            {
                "value": "Three times daily",
                "pct": "25%"
            },
            {
                "value": "Twice daily",
                "pct": "23%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Carvedilol",
        "route": "Oral Pill",
        "fullName": "Carvedilol (Oral Pill)",
        "totalCount": 742,
        "searchTerms": [
            "CARVEDILOL",
            "CARVEDILOL (Oral)",
            "COREG",
            "COREG 25 MG",
            "Carvedilol",
            "Carvedilol (Oral Pill)",
            "Carvedilol (Oral)",
            "Coreg",
            "carvedilol",
            "carvedilol (Oral)",
            "carvedilol (oral pill)",
            "carvedilol (oral)",
            "carvedilol 12.5 MG Oral Tablet",
            "carvedilol 12.5 mg oral tablet",
            "carvedilol 25 MG Oral Tablet",
            "carvedilol 25 mg oral tablet",
            "carvedilol 3.125 MG Oral Tablet",
            "carvedilol 3.125 mg oral tablet",
            "carvedilol 6.25 MG Oral Tablet",
            "carvedilol 6.25 mg oral tablet",
            "coreg",
            "coreg 25 mg"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "30%"
            },
            {
                "value": "12.5 mg",
                "pct": "28%"
            },
            {
                "value": "6.25 mg",
                "pct": "22%"
            },
            {
                "value": "3.125 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "68%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "68%"
            },
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "20%"
            }
        ]
    },
    {
        "name": "SENNA-TIME",
        "route": "Oral Pill",
        "fullName": "SENNA-TIME (Oral Pill)",
        "totalCount": 706,
        "searchTerms": [
            "SENNA-TIME",
            "SENNA-TIME (Oral Pill)",
            "SENNA-TIME (Oral)",
            "Senna-Time",
            "Senna-Time (Oral)",
            "senna-time",
            "senna-time (oral pill)",
            "senna-time (oral)",
            "sennosides, USP 8.6 MG Oral Tablet",
            "sennosides, usp 8.6 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "8.6 mg",
                "pct": "98%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "52%"
            },
            {
                "value": "At bedtime",
                "pct": "18%"
            },
            {
                "value": "Twice daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "76%"
            }
        ]
    },
    {
        "name": "Acetaminophen",
        "route": "Oral Pill",
        "fullName": "Acetaminophen (Oral Pill)",
        "totalCount": 686,
        "searchTerms": [
            "ACETAMINOPHEN",
            "ACETAMINOPHEN (Oral)",
            "Acetaminophen",
            "Acetaminophen (Oral Pill)",
            "Acetaminophen (Oral)",
            "F T Pain Rel X Str",
            "MAPAP ARTHRITIS PAIN",
            "Mapap Arthritis",
            "PANADOL",
            "Panadol",
            "Panadol/Tylenol",
            "TYLENOL",
            "TYLENOL EXTRA STRENGTH",
            "TYLENOL GO TAB EXTRA",
            "Tylenol",
            "Tylenol #3 (likely Acetaminophen/Codeine)",
            "Tylenol 8 Hour",
            "Tylenol Arthritis",
            "Tylenol Extra",
            "Tylenol Extra Strength",
            "acetaminophen",
            "acetaminophen (Oral)",
            "acetaminophen (oral pill)",
            "acetaminophen (oral)",
            "acetaminophen 325 MG Oral Capsule",
            "acetaminophen 325 MG Oral Tablet",
            "acetaminophen 325 mg oral capsule",
            "acetaminophen 325 mg oral tablet",
            "acetaminophen 500 MG Oral Capsule",
            "acetaminophen 500 MG Oral Tablet",
            "acetaminophen 500 mg oral capsule",
            "acetaminophen 500 mg oral tablet",
            "acetaminophen 650 MG Oral Tablet",
            "acetaminophen 650 mg oral tablet",
            "acetaminophen 80 MG Oral Tablet",
            "acetaminophen 80 mg oral tablet",
            "f t pain rel x str",
            "mapap arthritis",
            "mapap arthritis pain",
            "panadol",
            "panadol/tylenol",
            "tylenol",
            "tylenol #3 (likely acetaminophen/codeine)",
            "tylenol 8 hour",
            "tylenol arthritis",
            "tylenol extra",
            "tylenol extra strength",
            "tylenol go tab extra"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "53%"
            },
            {
                "value": "325 mg",
                "pct": "29%"
            },
            {
                "value": "650 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "84%"
            },
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "27%"
            }
        ]
    },
    {
        "name": "Vitamin B12",
        "route": "Oral Pill",
        "fullName": "Vitamin B12 (Oral Pill)",
        "totalCount": 649,
        "searchTerms": [
            "VITAMIN B12",
            "Vitamin B12",
            "Vitamin B12 (Oral Pill)",
            "Vitamin B12 (Oral)",
            "Vitamin b12",
            "vitamin B12 0.05 MG Oral Tablet",
            "vitamin B12 0.5 MG Oral Tablet",
            "vitamin B12 2.5 MG Oral Tablet",
            "vitamin B12 5 MG Oral Capsule",
            "vitamin b12",
            "vitamin b12 (oral pill)",
            "vitamin b12 (oral)",
            "vitamin b12 0.05 mg oral tablet",
            "vitamin b12 0.5 mg oral tablet",
            "vitamin b12 2.5 mg oral tablet",
            "vitamin b12 5 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "1000 mcg",
                "pct": "24%"
            },
            {
                "value": "1 mg",
                "pct": "22%"
            },
            {
                "value": "0.05 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D51.9",
                "description": "Vitamin B12 deficiency anemia, unspecified",
                "pct": "37%"
            },
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "Clopidogrel",
        "route": "Oral Pill",
        "fullName": "Clopidogrel (Oral Pill)",
        "totalCount": 646,
        "searchTerms": [
            "CLOPIDOGREL",
            "CLOPIDOGREL (Oral)",
            "Clopidogrel",
            "Clopidogrel (Oral Pill)",
            "Clopidogrel (Oral)",
            "PLAVIX",
            "Plavix",
            "clopidogrel",
            "clopidogrel (Oral)",
            "clopidogrel (oral pill)",
            "clopidogrel (oral)",
            "clopidogrel 300 MG Oral Tablet",
            "clopidogrel 300 mg oral tablet",
            "clopidogrel 75 MG Oral Tablet",
            "clopidogrel 75 mg oral tablet",
            "plavix"
        ],
        "dosages": [
            {
                "value": "75 mg",
                "pct": "99%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "53%"
            },
            {
                "code": "I25.2",
                "description": "Old myocardial infarction",
                "pct": "11%"
            },
            {
                "code": "Z86.73",
                "description": "Prsnl hx of TIA (TIA, 10), and cereb infrc w/o resid deficits",
                "pct": "10%"
            }
        ]
    },
    {
        "name": "Docusate",
        "route": "Oral Pill",
        "fullName": "Docusate (Oral Pill)",
        "totalCount": 627,
        "searchTerms": [
            "Colace",
            "DOCUSATE",
            "DOCUSATE (Oral)",
            "Docusate",
            "Docusate (Oral Pill)",
            "Docusate (Oral)",
            "colace",
            "docusate",
            "docusate (oral pill)",
            "docusate (oral)",
            "docusate calcium 240 MG Oral Capsule",
            "docusate calcium 240 mg oral capsule",
            "docusate sodium 100 MG Oral Capsule",
            "docusate sodium 100 MG Oral Tablet",
            "docusate sodium 100 mg oral capsule",
            "docusate sodium 100 mg oral tablet",
            "docusate sodium 250 MG Oral Capsule",
            "docusate sodium 250 mg oral capsule",
            "docusate sodium 50 MG Oral Capsule",
            "docusate sodium 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "96%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "46%"
            },
            {
                "value": "Twice daily",
                "pct": "22%"
            },
            {
                "value": "Three times daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "Sertraline",
        "route": "Oral Pill",
        "fullName": "Sertraline (Oral Pill)",
        "totalCount": 606,
        "searchTerms": [
            "SERTRALINE",
            "SERTRALINE (Oral)",
            "Sertraline",
            "Sertraline (Oral Pill)",
            "Sertraline (Oral)",
            "ZOLOFT",
            "Zoloft",
            "sertraline",
            "sertraline (Oral)",
            "sertraline (oral pill)",
            "sertraline (oral)",
            "sertraline 100 MG Oral Tablet",
            "sertraline 100 mg oral tablet",
            "sertraline 150 MG Oral Tablet",
            "sertraline 150 mg oral tablet",
            "sertraline 200 MG Oral Tablet",
            "sertraline 200 mg oral tablet",
            "sertraline 25 MG Oral Tablet",
            "sertraline 25 mg oral tablet",
            "sertraline 50 MG Oral Tablet",
            "sertraline 50 mg oral tablet",
            "zoloft"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "38%"
            },
            {
                "value": "50 mg",
                "pct": "38%"
            },
            {
                "value": "25 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "45%"
            },
            {
                "code": "F41.1",
                "description": "Generalized anxiety disorder",
                "pct": "25%"
            }
        ]
    },
    {
        "name": "Ibuprofen",
        "route": "Oral Pill",
        "fullName": "Ibuprofen (Oral Pill)",
        "totalCount": 602,
        "searchTerms": [
            "Advil",
            "IBU 600 MG",
            "IBUPROFEN",
            "IBUPROFEN (Oral)",
            "Ibuprofen",
            "Ibuprofen (Oral Pill)",
            "Ibuprofen (Oral)",
            "MOTRIN",
            "Motrin",
            "advil",
            "ibu 600 mg",
            "ibuprofen",
            "ibuprofen (Oral)",
            "ibuprofen (oral pill)",
            "ibuprofen (oral)",
            "ibuprofen 100 MG Oral Tablet",
            "ibuprofen 100 mg oral tablet",
            "ibuprofen 200 MG Oral Capsule",
            "ibuprofen 200 MG Oral Tablet",
            "ibuprofen 200 mg oral capsule",
            "ibuprofen 200 mg oral tablet",
            "ibuprofen 400 MG Oral Tablet",
            "ibuprofen 400 mg oral tablet",
            "ibuprofen 600 MG Oral Tablet",
            "ibuprofen 600 mg oral tablet",
            "ibuprofen 800 MG Oral Tablet",
            "ibuprofen 800 mg oral tablet",
            "motrin"
        ],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "37%"
            },
            {
                "value": "800 mg",
                "pct": "23%"
            },
            {
                "value": "400 mg",
                "pct": "19%"
            },
            {
                "value": "200 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "65%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "50%"
            },
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "28%"
            },
            {
                "code": "M25.50",
                "description": "Pain in unspecified joint",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "ECOTRIN",
        "route": "Oral Pill",
        "fullName": "ECOTRIN (Oral Pill)",
        "totalCount": 595,
        "searchTerms": [
            "ECOTRIN",
            "ECOTRIN (Oral Pill)",
            "Ecotrin",
            "Ecotrin (Oral)",
            "aspirin 325 MG Delayed Release Oral Tablet",
            "aspirin 325 mg delayed release oral tablet",
            "aspirin 81 MG Delayed Release Oral Tablet",
            "aspirin 81 mg delayed release oral tablet",
            "ecotrin",
            "ecotrin (oral pill)",
            "ecotrin (oral)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Montelukast",
        "route": "Oral Pill",
        "fullName": "Montelukast (Oral Pill)",
        "totalCount": 591,
        "searchTerms": [
            "MONTELUKAST",
            "MONTELUKAST (Oral)",
            "Montelukast",
            "Montelukast (Oral Pill)",
            "Montelukast (Oral)",
            "SINGULAIR",
            "Singulair",
            "montelukast",
            "montelukast (Oral)",
            "montelukast (oral pill)",
            "montelukast (oral)",
            "montelukast 10 MG Oral Tablet",
            "montelukast 10 mg oral tablet",
            "singulair"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "54%"
            },
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "19%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "Escitalopram",
        "route": "Oral Pill",
        "fullName": "Escitalopram (Oral Pill)",
        "totalCount": 581,
        "searchTerms": [
            "ESCITALOPRAM",
            "ESCITALOPRAM (Oral)",
            "Escitalopram",
            "Escitalopram (Oral Pill)",
            "Escitalopram (Oral)",
            "Lexapro",
            "Lexapro 20mg Tab",
            "escitalopram",
            "escitalopram (Oral)",
            "escitalopram (oral pill)",
            "escitalopram (oral)",
            "escitalopram 10 MG Oral Tablet",
            "escitalopram 10 mg oral tablet",
            "escitalopram 20 MG Oral Tablet",
            "escitalopram 20 mg oral tablet",
            "escitalopram 5 MG Oral Tablet",
            "escitalopram 5 mg oral tablet",
            "lexapro",
            "lexapro 20mg tab"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "49%"
            },
            {
                "value": "20 mg",
                "pct": "30%"
            },
            {
                "value": "5 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.1",
                "description": "Generalized anxiety disorder",
                "pct": "47%"
            },
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "37%"
            }
        ]
    },
    {
        "name": "Mirtazapine",
        "route": "Oral Pill",
        "fullName": "Mirtazapine (Oral Pill)",
        "totalCount": 563,
        "searchTerms": [
            "MIRTAZAPINE",
            "MIRTAZAPINE (Oral)",
            "Mirtazapine",
            "Mirtazapine (Oral Pill)",
            "Mirtazapine (Oral)",
            "REMERON",
            "Remeron",
            "mirtazapine",
            "mirtazapine (Oral)",
            "mirtazapine (oral pill)",
            "mirtazapine (oral)",
            "mirtazapine 15 MG Oral Tablet",
            "mirtazapine 15 mg oral tablet",
            "mirtazapine 30 MG Oral Tablet",
            "mirtazapine 30 mg oral tablet",
            "mirtazapine 45 MG Oral Tablet",
            "mirtazapine 45 mg oral tablet",
            "mirtazapine 7.5 MG Oral Tablet",
            "mirtazapine 7.5 mg oral tablet",
            "remeron"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "47%"
            },
            {
                "value": "7.5 mg",
                "pct": "29%"
            },
            {
                "value": "30 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            },
            {
                "value": "At bedtime",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "68%"
            }
        ]
    },
    {
        "name": "Meloxicam",
        "route": "Oral Pill",
        "fullName": "Meloxicam (Oral Pill)",
        "totalCount": 551,
        "searchTerms": [
            "MELOXICAM",
            "MOBIC",
            "Meloxicam",
            "Meloxicam (Oral Pill)",
            "Meloxicam (Oral)",
            "Mobic",
            "meloxicam",
            "meloxicam (Oral)",
            "meloxicam (oral pill)",
            "meloxicam (oral)",
            "meloxicam 10 MG Oral Capsule",
            "meloxicam 10 mg oral capsule",
            "meloxicam 15 MG Oral Tablet",
            "meloxicam 15 mg oral tablet",
            "meloxicam 5 MG Oral Capsule",
            "meloxicam 5 mg oral capsule",
            "meloxicam 7.5 MG Oral Tablet",
            "meloxicam 7.5 mg oral tablet",
            "mobic"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "72%"
            },
            {
                "value": "7.5 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "57%"
            }
        ]
    },
    {
        "name": "Meclizine",
        "route": "Oral Pill",
        "fullName": "Meclizine (Oral Pill)",
        "totalCount": 546,
        "searchTerms": [
            "Antivert",
            "Antivert 25",
            "Dramamine",
            "MECLIZINE",
            "MECLIZINE (Oral)",
            "Meclizine",
            "Meclizine (Oral Pill)",
            "Meclizine (Oral)",
            "antivert",
            "antivert 25",
            "dramamine",
            "meclizine",
            "meclizine (Oral)",
            "meclizine (oral pill)",
            "meclizine (oral)",
            "meclizine hydrochloride 12.5 MG Oral Tablet",
            "meclizine hydrochloride 12.5 mg oral tablet",
            "meclizine hydrochloride 25 MG Oral Tablet",
            "meclizine hydrochloride 25 mg oral tablet",
            "meclizine hydrochloride 50 MG Oral Tablet",
            "meclizine hydrochloride 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "51%"
            },
            {
                "value": "12.5 mg",
                "pct": "48%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "40%"
            },
            {
                "value": "As needed",
                "pct": "21%"
            },
            {
                "value": "Twice daily",
                "pct": "17%"
            },
            {
                "value": "Three times daily",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R42",
                "description": "Dizziness and giddiness",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "MINIPRIN",
        "route": "Oral Pill",
        "fullName": "MINIPRIN (Oral Pill)",
        "totalCount": 542,
        "searchTerms": [
            "MINIPRIN",
            "MINIPRIN (Oral Pill)",
            "aspirin 81 MG Delayed Release Oral Tablet",
            "aspirin 81 mg delayed release oral tablet",
            "miniprin",
            "miniprin (oral pill)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "98%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Donepezil",
        "route": "Oral Pill",
        "fullName": "Donepezil (Oral Pill)",
        "totalCount": 527,
        "searchTerms": [
            "Aricept",
            "Donepezil",
            "Donepezil (Oral Pill)",
            "Donepezil (Oral)",
            "aricept",
            "donepezil",
            "donepezil (Oral)",
            "donepezil (oral pill)",
            "donepezil (oral)",
            "donepezil hydrochloride 10 MG Oral Tablet",
            "donepezil hydrochloride 10 mg oral tablet",
            "donepezil hydrochloride 23 MG Oral Tablet",
            "donepezil hydrochloride 23 mg oral tablet",
            "donepezil hydrochloride 5 MG Oral Tablet",
            "donepezil hydrochloride 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "51%"
            },
            {
                "value": "5 mg",
                "pct": "46%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G30.9",
                "description": "Alzheimer's disease, unspecified",
                "pct": "63%"
            },
            {
                "code": "F03",
                "description": "Unspecified dementia",
                "pct": "16%"
            }
        ]
    },
    {
        "name": "JANUVIA",
        "route": "Oral Pill",
        "fullName": "JANUVIA (Oral Pill)",
        "totalCount": 525,
        "searchTerms": [
            "JANUVIA",
            "JANUVIA (Oral Pill)",
            "JANUVIA (Oral)",
            "Januvia",
            "Januvia (Oral)",
            "Sitagliptin Phosphate",
            "januvia",
            "januvia (oral pill)",
            "januvia (oral)",
            "sitagliptin 100 MG Oral Tablet",
            "sitagliptin 100 mg oral tablet",
            "sitagliptin 25 MG Oral Tablet",
            "sitagliptin 25 mg oral tablet",
            "sitagliptin 50 MG Oral Tablet",
            "sitagliptin 50 mg oral tablet",
            "sitagliptin phosphate"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "57%"
            },
            {
                "value": "50 mg",
                "pct": "24%"
            },
            {
                "value": "25 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "65%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "QUEtiapine",
        "route": "Oral Pill",
        "fullName": "QUEtiapine (Oral Pill)",
        "totalCount": 506,
        "searchTerms": [
            "QUETIAPINE",
            "QUETIAPINE (Oral)",
            "QUEtiapine",
            "QUEtiapine (Oral Pill)",
            "QUEtiapine (Oral)",
            "Quetiapine",
            "Quetiapine (Oral)",
            "Seroquel",
            "quetiapine",
            "quetiapine (Oral)",
            "quetiapine (oral pill)",
            "quetiapine (oral)",
            "quetiapine 100 MG Oral Tablet",
            "quetiapine 100 mg oral tablet",
            "quetiapine 150 MG Oral Tablet",
            "quetiapine 150 mg oral tablet",
            "quetiapine 200 MG Oral Tablet",
            "quetiapine 200 mg oral tablet",
            "quetiapine 25 MG Oral Tablet",
            "quetiapine 25 mg oral tablet",
            "quetiapine 300 MG Oral Tablet",
            "quetiapine 300 mg oral tablet",
            "quetiapine 400 MG Oral Tablet",
            "quetiapine 400 mg oral tablet",
            "quetiapine 50 MG Oral Tablet",
            "quetiapine 50 mg oral tablet",
            "seroquel"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "34%"
            },
            {
                "value": "50 mg",
                "pct": "29%"
            },
            {
                "value": "100 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "58%"
            },
            {
                "value": "At bedtime",
                "pct": "24%"
            },
            {
                "value": "Twice daily",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "32%"
            },
            {
                "code": "F31.9",
                "description": "Bipolar disorder, unspecified",
                "pct": "17%"
            }
        ]
    },
    {
        "name": "Ferrous sulfate",
        "route": "Oral Pill",
        "fullName": "Ferrous sulfate (Oral Pill)",
        "totalCount": 499,
        "searchTerms": [
            "FERROUS SULFATE",
            "Feosol",
            "Feratab",
            "Ferrous Sulfate",
            "Ferrous Sulfate (Oral)",
            "Ferrous sulfate",
            "Ferrous sulfate (Oral Pill)",
            "feosol",
            "feratab",
            "ferrous sulfate",
            "ferrous sulfate (Oral)",
            "ferrous sulfate (oral pill)",
            "ferrous sulfate (oral)",
            "ferrous sulfate 134 MG Oral Tablet",
            "ferrous sulfate 134 mg oral tablet",
            "ferrous sulfate 324 MG Delayed Release Oral Tablet",
            "ferrous sulfate 324 mg delayed release oral tablet",
            "ferrous sulfate 325 MG Delayed Release Oral Tablet",
            "ferrous sulfate 325 MG Oral Tablet",
            "ferrous sulfate 325 mg delayed release oral tablet",
            "ferrous sulfate 325 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "325 mg",
                "pct": "71%"
            },
            {
                "value": "324 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "77%"
            },
            {
                "value": "Twice daily",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D50.9",
                "description": "Iron deficiency anemia, unspecified",
                "pct": "67%"
            },
            {
                "code": "D50",
                "description": "Iron deficiency anemia",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "Simvastatin",
        "route": "Oral Pill",
        "fullName": "Simvastatin (Oral Pill)",
        "totalCount": 479,
        "searchTerms": [
            "SIMVASTATIN",
            "SIMVASTATIN (Oral)",
            "Simvastatin",
            "Simvastatin (Oral Pill)",
            "Simvastatin (Oral)",
            "ZOCOR",
            "Zocor",
            "Zocor 10mg",
            "simvastatin",
            "simvastatin (Oral)",
            "simvastatin (oral pill)",
            "simvastatin (oral)",
            "simvastatin 10 MG Oral Tablet",
            "simvastatin 10 mg oral tablet",
            "simvastatin 20 MG Oral Tablet",
            "simvastatin 20 mg oral tablet",
            "simvastatin 40 MG Oral Tablet",
            "simvastatin 40 mg oral tablet",
            "simvastatin 5 MG Oral Tablet",
            "simvastatin 5 mg oral tablet",
            "simvastatin 80 MG Oral Tablet",
            "simvastatin 80 mg oral tablet",
            "zocor",
            "zocor 10mg"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "45%"
            },
            {
                "value": "40 mg",
                "pct": "29%"
            },
            {
                "value": "10 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            },
            {
                "value": "At bedtime",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "69%"
            }
        ]
    },
    {
        "name": "NIFEdipine XR",
        "route": "Oral Pill",
        "fullName": "NIFEdipine XR (Oral Pill)",
        "totalCount": 460,
        "searchTerms": [
            "24 HR nifedipine 30 MG Extended Release Oral Tablet",
            "24 HR nifedipine 60 MG Extended Release Oral Tablet",
            "24 HR nifedipine 90 MG Extended Release Oral Tablet",
            "24 hr nifedipine 30 mg extended release oral tablet",
            "24 hr nifedipine 60 mg extended release oral tablet",
            "24 hr nifedipine 90 mg extended release oral tablet",
            "NIFEdipine XR",
            "NIFEdipine XR (Oral Pill)",
            "Nifedipine XR",
            "Nifedipine XR (Oral)",
            "Osmotic 24 HR nifedipine 30 MG Extended Release Oral Tablet",
            "Osmotic 24 HR nifedipine 60 MG Extended Release Oral Tablet",
            "Osmotic 24 HR nifedipine 90 MG Extended Release Oral Tablet",
            "nifedipine xr",
            "nifedipine xr (oral pill)",
            "nifedipine xr (oral)",
            "osmotic 24 hr nifedipine 30 mg extended release oral tablet",
            "osmotic 24 hr nifedipine 60 mg extended release oral tablet",
            "osmotic 24 hr nifedipine 90 mg extended release oral tablet"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "38%"
            },
            {
                "value": "60 mg",
                "pct": "36%"
            },
            {
                "value": "90 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "65%"
            }
        ]
    },
    {
        "name": "LIPITOR",
        "route": "Oral Pill",
        "fullName": "LIPITOR (Oral Pill)",
        "totalCount": 459,
        "searchTerms": [
            "LIPITOR",
            "LIPITOR (Oral Pill)",
            "Lipitor",
            "Lipitor (Oral)",
            "atorvastatin 10 MG Oral Tablet",
            "atorvastatin 10 mg oral tablet",
            "atorvastatin 20 MG Oral Tablet",
            "atorvastatin 20 mg oral tablet",
            "atorvastatin 40 MG Oral Tablet",
            "atorvastatin 40 mg oral tablet",
            "atorvastatin 80 MG Oral Tablet",
            "atorvastatin 80 mg oral tablet",
            "lipitor",
            "lipitor (oral pill)",
            "lipitor (oral)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "33%"
            },
            {
                "value": "40 mg",
                "pct": "31%"
            },
            {
                "value": "10 mg",
                "pct": "20%"
            },
            {
                "value": "80 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            },
            {
                "value": "At bedtime",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "36%"
            }
        ]
    },
    {
        "name": "Ergocalciferol",
        "route": "Oral Pill",
        "fullName": "Ergocalciferol (Oral Pill)",
        "totalCount": 456,
        "searchTerms": [
            "DELTALIN",
            "DRISDOL",
            "Drisdol",
            "ERGOCALCIFEROL",
            "ERGOCALCIFEROL (Oral)",
            "Ergocalciferol",
            "Ergocalciferol (Oral Pill)",
            "Ergocalciferol (Oral)",
            "deltalin",
            "drisdol",
            "ergocalciferol",
            "ergocalciferol (Oral)",
            "ergocalciferol (oral pill)",
            "ergocalciferol (oral)",
            "ergocalciferol 0.01 MG Oral Tablet",
            "ergocalciferol 0.01 mg oral tablet",
            "ergocalciferol 0.05 MG Oral Tablet",
            "ergocalciferol 0.05 mg oral tablet",
            "ergocalciferol 0.0625 MG Oral Capsule",
            "ergocalciferol 0.0625 mg oral capsule",
            "ergocalciferol 1.25 MG Oral Capsule",
            "ergocalciferol 1.25 mg oral capsule",
            "ergocalciferol 2000 UNT Oral Capsule",
            "ergocalciferol 2000 unt oral capsule"
        ],
        "dosages": [
            {
                "value": "1.25 mg",
                "pct": "32%"
            },
            {
                "value": "0.05 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "48%"
            },
            {
                "value": "Once daily",
                "pct": "23%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "63%"
            },
            {
                "code": "E55",
                "description": "Vitamin D deficiency",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "LANTUS",
        "route": "Injectable",
        "fullName": "LANTUS (Injectable)",
        "totalCount": 455,
        "searchTerms": [
            "3 ML insulin glargine 100 UNT/ML Pen Injector",
            "3 ml insulin glargine 100 unt/ml pen injector",
            "LANTUS",
            "LANTUS (Injectable)",
            "insulin glargine 100 UNT/ML Injectable Solution",
            "insulin glargine 100 unt/ml injectable solution",
            "lantus",
            "lantus (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "54%"
            },
            {
                "value": "At bedtime",
                "pct": "23%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rotate injection sites",
                "pct": "11%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "62%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "14%"
            }
        ]
    },
    {
        "name": "NexIUM",
        "route": "Oral Pill",
        "fullName": "NexIUM (Oral Pill)",
        "totalCount": 444,
        "searchTerms": [
            "NEXIUM",
            "NexIUM",
            "NexIUM (Oral Pill)",
            "Nexium",
            "Nexium (Oral)",
            "esomeprazole 20 MG Delayed Release Oral Capsule",
            "esomeprazole 20 MG Delayed Release Oral Tablet",
            "esomeprazole 20 mg delayed release oral capsule",
            "esomeprazole 20 mg delayed release oral tablet",
            "esomeprazole 40 MG Delayed Release Oral Capsule",
            "esomeprazole 40 mg delayed release oral capsule",
            "nexium",
            "nexium (oral pill)",
            "nexium (oral)"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "59%"
            },
            {
                "value": "20 mg",
                "pct": "39%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "57%"
            }
        ]
    },
    {
        "name": "Diclofenac",
        "route": "Topical",
        "fullName": "Diclofenac (Topical)",
        "totalCount": 437,
        "searchTerms": [
            "DICLOFENAC",
            "Diclofenac",
            "Diclofenac (Topical)",
            "diclofenac",
            "diclofenac (topical)",
            "diclofenac epolamine 0.013 MG/MG Medicated Patch",
            "diclofenac epolamine 0.013 mg/mg medicated patch",
            "diclofenac sodium 0.01 MG/MG Topical Gel",
            "diclofenac sodium 0.01 mg/mg topical gel",
            "diclofenac sodium 0.03 MG/MG Topical Gel",
            "diclofenac sodium 0.03 mg/mg topical gel",
            "diclofenac sodium 15 MG/ML Topical Solution",
            "diclofenac sodium 15 mg/ml topical solution",
            "diclofenac sodium 20 MG/ML Topical Solution",
            "diclofenac sodium 20 mg/ml topical solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "30%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            },
            {
                "value": "As needed",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "57%"
            }
        ]
    },
    {
        "name": "DULoxetine",
        "route": "Oral Pill",
        "fullName": "DULoxetine (Oral Pill)",
        "totalCount": 428,
        "searchTerms": [
            "CYMBALTA",
            "Cymbalta",
            "DULoxetine",
            "DULoxetine (Oral Pill)",
            "DULoxetine (Oral)",
            "Drizalma",
            "Duloxetine",
            "Duloxetine (Oral)",
            "Sprinkle duloxetine 20 MG Delayed Release Oral Capsule",
            "Sprinkle duloxetine 30 MG Delayed Release Oral Capsule",
            "Sprinkle duloxetine 40 MG Delayed Release Oral Capsule",
            "Sprinkle duloxetine 60 MG Delayed Release Oral Capsule",
            "cymbalta",
            "drizalma",
            "duloxetine",
            "duloxetine (Oral)",
            "duloxetine (oral pill)",
            "duloxetine (oral)",
            "duloxetine 20 MG Delayed Release Oral Capsule",
            "duloxetine 20 mg delayed release oral capsule",
            "duloxetine 30 MG Delayed Release Oral Capsule",
            "duloxetine 30 mg delayed release oral capsule",
            "duloxetine 40 MG Delayed Release Oral Capsule",
            "duloxetine 40 mg delayed release oral capsule",
            "duloxetine 60 MG Delayed Release Oral Capsule",
            "duloxetine 60 mg delayed release oral capsule",
            "sprinkle duloxetine 20 mg delayed release oral capsule",
            "sprinkle duloxetine 30 mg delayed release oral capsule",
            "sprinkle duloxetine 40 mg delayed release oral capsule",
            "sprinkle duloxetine 60 mg delayed release oral capsule"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "39%"
            },
            {
                "value": "30 mg",
                "pct": "37%"
            },
            {
                "value": "20 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "40%"
            },
            {
                "code": "F41.1",
                "description": "Generalized anxiety disorder",
                "pct": "21%"
            }
        ]
    },
    {
        "name": "hydrALAZINE",
        "route": "Oral Pill",
        "fullName": "hydrALAZINE (Oral Pill)",
        "totalCount": 411,
        "searchTerms": [
            "APRESOLINE",
            "Apresoline",
            "HYDRALAZINE",
            "HYDRALAZINE (Oral)",
            "Hydralazine",
            "Hydralazine (Oral)",
            "apresoline",
            "hydrALAZINE",
            "hydrALAZINE (Oral Pill)",
            "hydrALAZINE (Oral)",
            "hydralazine",
            "hydralazine (oral pill)",
            "hydralazine (oral)",
            "hydralazine hydrochloride 10 MG Oral Tablet",
            "hydralazine hydrochloride 10 mg oral tablet",
            "hydralazine hydrochloride 100 MG Oral Tablet",
            "hydralazine hydrochloride 100 mg oral tablet",
            "hydralazine hydrochloride 25 MG Oral Tablet",
            "hydralazine hydrochloride 25 mg oral tablet",
            "hydralazine hydrochloride 50 MG Oral Tablet",
            "hydralazine hydrochloride 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "42%"
            },
            {
                "value": "50 mg",
                "pct": "33%"
            },
            {
                "value": "100 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "33%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            },
            {
                "value": "Once daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "73%"
            }
        ]
    },
    {
        "name": "ASPIR-LOW",
        "route": "Oral Pill",
        "fullName": "ASPIR-LOW (Oral Pill)",
        "totalCount": 401,
        "searchTerms": [
            "ASPIR-LOW",
            "ASPIR-LOW (Oral Pill)",
            "Aspir-Low",
            "Aspir-Low (Oral)",
            "Ecotrin Adult",
            "aspir-low",
            "aspir-low (oral pill)",
            "aspir-low (oral)",
            "aspirin 81 MG Delayed Release Oral Tablet",
            "aspirin 81 mg delayed release oral tablet",
            "ecotrin adult"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LASIX",
        "route": "Oral Pill",
        "fullName": "LASIX (Oral Pill)",
        "totalCount": 395,
        "searchTerms": [
            "LASIX",
            "LASIX (Oral Pill)",
            "Lasix",
            "furosemide 20 MG Oral Tablet",
            "furosemide 20 mg oral tablet",
            "furosemide 40 MG Oral Tablet",
            "furosemide 40 mg oral tablet",
            "furosemide 80 MG Oral Tablet",
            "furosemide 80 mg oral tablet",
            "lasix",
            "lasix (oral pill)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "54%"
            },
            {
                "value": "40 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "14%"
            },
            {
                "code": "R60.9",
                "description": "Edema, unspecified",
                "pct": "14%"
            }
        ]
    },
    {
        "name": "DIALYVITE VITAMIN D3 MAX",
        "route": "Oral Pill",
        "fullName": "DIALYVITE VITAMIN D3 MAX (Oral Pill)",
        "totalCount": 388,
        "searchTerms": [
            "DIALYVITE VITAMIN D3 MAX",
            "DIALYVITE VITAMIN D3 MAX (Oral Pill)",
            "cholecalciferol 1.25 MG Oral Tablet",
            "cholecalciferol 1.25 mg oral tablet",
            "dialyvite vitamin d3 max",
            "dialyvite vitamin d3 max (oral pill)"
        ],
        "dosages": [
            {
                "value": "1.25 mg",
                "pct": "61%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "48%"
            },
            {
                "value": "Weekly",
                "pct": "37%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "61%"
            },
            {
                "code": "E55",
                "description": "Vitamin D deficiency",
                "pct": "14%"
            }
        ]
    },
    {
        "name": "Hydrochlorothiazide",
        "route": "Oral Pill",
        "fullName": "Hydrochlorothiazide (Oral Pill)",
        "totalCount": 387,
        "searchTerms": [
            "Esidrix",
            "HYDROCHLOROTHIAZIDE",
            "HYDROCHLOROTHIAZIDE (Oral)",
            "HydroChlorothiazide",
            "Hydrochlorothiazide",
            "Hydrochlorothiazide (Oral Pill)",
            "Hydrochlorothiazide (Oral)",
            "Hydrodiuril",
            "Microzide",
            "Oretic",
            "esidrix",
            "hydroCHLOROthiazide",
            "hydroCHLOROthiazide (Oral Pill)",
            "hydroCHLOROthiazide (Oral)",
            "hydrochlorothiazide",
            "hydrochlorothiazide (oral pill)",
            "hydrochlorothiazide (oral)",
            "hydrochlorothiazide 12.5 MG Oral Capsule",
            "hydrochlorothiazide 12.5 mg oral capsule",
            "hydrochlorothiazide 25 MG Oral Tablet",
            "hydrochlorothiazide 25 mg oral tablet",
            "hydrochlorothiazide 50 MG Oral Tablet",
            "hydrochlorothiazide 50 mg oral tablet",
            "hydrodiuril",
            "microzide",
            "oretic"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "52%"
            },
            {
                "value": "12.5 mg",
                "pct": "44%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "87%"
            },
            {
                "code": "R60.9",
                "description": "Edema, unspecified",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "NEURONTIN",
        "route": "Oral Pill",
        "fullName": "NEURONTIN (Oral Pill)",
        "totalCount": 378,
        "searchTerms": [
            "NEURONTIN",
            "NEURONTIN (Oral Pill)",
            "Neurontin",
            "Neurontin (Oral)",
            "gabapentin 100 MG Oral Capsule",
            "gabapentin 100 mg oral capsule",
            "gabapentin 300 MG Oral Capsule",
            "gabapentin 300 mg oral capsule",
            "gabapentin 400 MG Oral Capsule",
            "gabapentin 400 mg oral capsule",
            "gabapentin 600 MG Oral Tablet",
            "gabapentin 600 mg oral tablet",
            "gabapentin 800 MG Oral Tablet",
            "gabapentin 800 mg oral tablet",
            "neurontin",
            "neurontin (oral pill)",
            "neurontin (oral)"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "46%"
            },
            {
                "value": "100 mg",
                "pct": "34%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "34%"
            },
            {
                "value": "Once daily",
                "pct": "20%"
            },
            {
                "value": "Twice daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "clonazePAM",
        "route": "Oral Pill",
        "fullName": "clonazePAM (Oral Pill)",
        "totalCount": 375,
        "searchTerms": [
            "CLONAZEPAM",
            "CLONAZEPAM (Oral)",
            "Clonazepam",
            "Clonazepam (Oral)",
            "KLONOPIN",
            "Klonopin",
            "clonazePAM",
            "clonazePAM (Oral Pill)",
            "clonazePAM (Oral)",
            "clonazepam",
            "clonazepam (oral pill)",
            "clonazepam (oral)",
            "clonazepam 0.5 MG Oral Tablet",
            "clonazepam 0.5 mg oral tablet",
            "clonazepam 1 MG Oral Tablet",
            "clonazepam 1 mg oral tablet",
            "clonazepam 2 MG Oral Tablet",
            "clonazepam 2 mg oral tablet",
            "klonopin"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "53%"
            },
            {
                "value": "1 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "36%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            },
            {
                "value": "Three times daily",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "44%"
            },
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "16%"
            },
            {
                "code": "F41",
                "description": "Other anxiety disorders",
                "pct": "10%"
            }
        ]
    },
    {
        "name": "Finasteride",
        "route": "Oral Pill",
        "fullName": "Finasteride (Oral Pill)",
        "totalCount": 374,
        "searchTerms": [
            "FINASTERIDE",
            "FINASTERIDE (Oral)",
            "Finasteride",
            "Finasteride (Oral Pill)",
            "Finasteride (Oral)",
            "PROSCAR",
            "Proscar",
            "finasteride",
            "finasteride (oral pill)",
            "finasteride (oral)",
            "finasteride 1 MG Oral Tablet",
            "finasteride 1 mg oral tablet",
            "finasteride 5 MG Oral Tablet",
            "finasteride 5 mg oral tablet",
            "proscar"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "97%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N40.1",
                "description": "Enlarged prostate with lower urinary tract symptoms",
                "pct": "57%"
            },
            {
                "code": "N40",
                "description": "Enlarged prostate",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "buPROPion XR",
        "route": "Oral Pill",
        "fullName": "buPROPion XR (Oral Pill)",
        "totalCount": 370,
        "searchTerms": [
            "12 HR bupropion hydrochloride 100 MG Extended Release Oral Tablet",
            "12 HR bupropion hydrochloride 150 MG Extended Release Oral Tablet",
            "12 HR bupropion hydrochloride 200 MG Extended Release Oral Tablet",
            "12 hr bupropion hydrochloride 100 mg extended release oral tablet",
            "12 hr bupropion hydrochloride 150 mg extended release oral tablet",
            "12 hr bupropion hydrochloride 200 mg extended release oral tablet",
            "24 HR bupropion hydrobromide 174 MG Extended Release Oral Tablet",
            "24 HR bupropion hydrochloride 150 MG Extended Release Oral Tablet",
            "24 HR bupropion hydrochloride 300 MG Extended Release Oral Tablet",
            "24 HR bupropion hydrochloride 450 MG Extended Release Oral Tablet",
            "24 hr bupropion hydrobromide 174 mg extended release oral tablet",
            "24 hr bupropion hydrochloride 150 mg extended release oral tablet",
            "24 hr bupropion hydrochloride 300 mg extended release oral tablet",
            "24 hr bupropion hydrochloride 450 mg extended release oral tablet",
            "Smoking Cessation 12 HR bupropion hydrochloride 150 MG Extended Release Oral Tablet",
            "buPROPion XR",
            "buPROPion XR (Oral Pill)",
            "bupropion xr",
            "bupropion xr (oral pill)",
            "smoking cessation 12 hr bupropion hydrochloride 150 mg extended release oral tablet"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "63%"
            },
            {
                "value": "300 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "38%"
            },
            {
                "code": "F33",
                "description": "Major depressive disorder, recurrent",
                "pct": "16%"
            }
        ]
    },
    {
        "name": "Ezetimibe",
        "route": "Oral Pill",
        "fullName": "Ezetimibe (Oral Pill)",
        "totalCount": 365,
        "searchTerms": [
            "EZETIMIBE",
            "EZETIMIBE (Oral)",
            "Ezetimibe",
            "Ezetimibe (Oral Pill)",
            "Ezetimibe (Oral)",
            "ZETIA",
            "Zetia",
            "Zetia Tabs",
            "ezetimibe",
            "ezetimibe (Oral)",
            "ezetimibe (oral pill)",
            "ezetimibe (oral)",
            "ezetimibe 10 MG Oral Tablet",
            "ezetimibe 10 mg oral tablet",
            "zetia",
            "zetia tabs"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "77%"
            }
        ]
    },
    {
        "name": "metFORMIN/Saxagliptin XR",
        "route": "Oral Pill",
        "fullName": "metFORMIN/Saxagliptin XR (Oral Pill)",
        "totalCount": 363,
        "searchTerms": [
            "24 HR metformin hydrochloride 1000 MG / saxagliptin 2.5 MG Extended Release Oral Tablet",
            "24 HR metformin hydrochloride 1000 MG / saxagliptin 5 MG Extended Release Oral Tablet",
            "24 HR metformin hydrochloride 500 MG / saxagliptin 5 MG Extended Release Oral Tablet",
            "24 hr metformin hydrochloride 1000 mg / saxagliptin 2.5 mg extended release oral tablet",
            "24 hr metformin hydrochloride 1000 mg / saxagliptin 5 mg extended release oral tablet",
            "24 hr metformin hydrochloride 500 mg / saxagliptin 5 mg extended release oral tablet",
            "metFORMIN/Saxagliptin XR",
            "metFORMIN/Saxagliptin XR (Oral Pill)",
            "metformin/saxagliptin xr",
            "metformin/saxagliptin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "500-5 mg",
                "pct": "21%"
            },
            {
                "value": "500 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "44%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ZOCOR",
        "route": "Oral Pill",
        "fullName": "ZOCOR (Oral Pill)",
        "totalCount": 356,
        "searchTerms": [
            "ZOCOR",
            "ZOCOR (Oral Pill)",
            "Zocor",
            "simvastatin 10 MG Oral Tablet",
            "simvastatin 10 mg oral tablet",
            "simvastatin 20 MG Oral Tablet",
            "simvastatin 20 mg oral tablet",
            "simvastatin 40 MG Oral Tablet",
            "simvastatin 40 mg oral tablet",
            "simvastatin 5 MG Oral Tablet",
            "simvastatin 5 mg oral tablet",
            "zocor",
            "zocor (oral pill)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "50%"
            },
            {
                "value": "40 mg",
                "pct": "22%"
            },
            {
                "value": "10 mg",
                "pct": "22%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "65%"
            },
            {
                "value": "At bedtime",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LINZESS",
        "route": "Oral Pill",
        "fullName": "LINZESS (Oral Pill)",
        "totalCount": 348,
        "searchTerms": [
            "LINZESS",
            "LINZESS (Oral Pill)",
            "LINZESS (Oral)",
            "Linaclotide",
            "Linzess",
            "Linzess (Oral)",
            "linaclotide",
            "linaclotide 0.072 MG Oral Capsule",
            "linaclotide 0.072 mg oral capsule",
            "linaclotide 0.145 MG Oral Capsule",
            "linaclotide 0.145 mg oral capsule",
            "linaclotide 0.29 MG Oral Capsule",
            "linaclotide 0.29 mg oral capsule",
            "linzess",
            "linzess (oral pill)",
            "linzess (oral)"
        ],
        "dosages": [
            {
                "value": "0.145 mg",
                "pct": "48%"
            },
            {
                "value": "0.29 mg",
                "pct": "20%"
            },
            {
                "value": "0.072 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "70%"
            }
        ]
    },
    {
        "name": "Benztropine",
        "route": "Oral Pill",
        "fullName": "Benztropine (Oral Pill)",
        "totalCount": 346,
        "searchTerms": [
            "BENZTROPINE",
            "BENZTROPINE (Oral)",
            "Benztropine",
            "Benztropine (Oral Pill)",
            "Benztropine (Oral)",
            "Cogentin",
            "benztropine",
            "benztropine (Oral)",
            "benztropine (oral pill)",
            "benztropine (oral)",
            "benztropine mesylate 0.5 MG Oral Tablet",
            "benztropine mesylate 0.5 mg oral tablet",
            "benztropine mesylate 1 MG Oral Tablet",
            "benztropine mesylate 1 mg oral tablet",
            "benztropine mesylate 2 MG Oral Tablet",
            "benztropine mesylate 2 mg oral tablet",
            "cogentin"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "50%"
            },
            {
                "value": "0.5 mg",
                "pct": "30%"
            },
            {
                "value": "2 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "47%"
            },
            {
                "value": "Once daily",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G20",
                "description": "Parkinson's disease",
                "pct": "26%"
            },
            {
                "code": "G25",
                "description": "Other extrapyramidal and movement disorders",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "Memantine",
        "route": "Oral Pill",
        "fullName": "Memantine (Oral Pill)",
        "totalCount": 346,
        "searchTerms": [
            "MEMANTINE",
            "MEMANTINE (Oral)",
            "Memantine",
            "Memantine (Oral Pill)",
            "Memantine (Oral)",
            "NAMENDA",
            "Namenda",
            "Namenda XR",
            "memantine",
            "memantine (Oral)",
            "memantine (oral pill)",
            "memantine (oral)",
            "memantine hydrochloride 10 MG Oral Tablet",
            "memantine hydrochloride 10 mg oral tablet",
            "memantine hydrochloride 5 MG Oral Tablet",
            "memantine hydrochloride 5 mg oral tablet",
            "namenda",
            "namenda xr"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "61%"
            },
            {
                "value": "5 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "58%"
            },
            {
                "value": "Twice daily",
                "pct": "37%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G30.9",
                "description": "Alzheimer's disease, unspecified",
                "pct": "67%"
            },
            {
                "code": "F03",
                "description": "Unspecified dementia",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "Lidocaine",
        "route": "Topical",
        "fullName": "Lidocaine (Topical)",
        "totalCount": 339,
        "searchTerms": [
            "Asper Flex",
            "LIDOCAINE",
            "Lidocaine",
            "Lidocaine (Topical)",
            "asper flex",
            "lidocaine",
            "lidocaine (topical)",
            "lidocaine 40 MG/ML Topical Cream",
            "lidocaine 40 mg/ml topical cream",
            "lidocaine 50 MG/ML Topical Cream",
            "lidocaine 50 mg/ml topical cream",
            "lidocaine hydrochloride 0.025 MG/MG Topical Gel",
            "lidocaine hydrochloride 0.025 mg/mg topical gel",
            "lidocaine hydrochloride 0.04 MG/MG Topical Gel",
            "lidocaine hydrochloride 0.04 mg/mg topical gel",
            "lidocaine hydrochloride 20 MG/ML Topical Solution",
            "lidocaine hydrochloride 20 MG/ML Topical Spray",
            "lidocaine hydrochloride 20 mg/ml topical solution",
            "lidocaine hydrochloride 20 mg/ml topical spray",
            "lidocaine hydrochloride 30 MG/ML Topical Cream",
            "lidocaine hydrochloride 30 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "43%"
            },
            {
                "value": "As needed",
                "pct": "18%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            },
            {
                "value": "Every 12 hours",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "37%"
            },
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "32%"
            }
        ]
    },
    {
        "name": "Spironolactone",
        "route": "Oral Pill",
        "fullName": "Spironolactone (Oral Pill)",
        "totalCount": 338,
        "searchTerms": [
            "Aldactazide",
            "Aldactone",
            "SPIRONOLACTONE",
            "SPIRONOLACTONE (Oral)",
            "Spironolactone",
            "Spironolactone (Oral Pill)",
            "Spironolactone (Oral)",
            "aldactazide",
            "aldactone",
            "spironolactone",
            "spironolactone (Oral)",
            "spironolactone (oral pill)",
            "spironolactone (oral)",
            "spironolactone 100 MG Oral Tablet",
            "spironolactone 100 mg oral tablet",
            "spironolactone 25 MG Oral Tablet",
            "spironolactone 25 mg oral tablet",
            "spironolactone 50 MG Oral Tablet",
            "spironolactone 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "84%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "40%"
            },
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "37%"
            },
            {
                "code": "R60.9",
                "description": "Edema, unspecified",
                "pct": "25%"
            }
        ]
    },
    {
        "name": "Cyclobenzaprine",
        "route": "Oral Pill",
        "fullName": "Cyclobenzaprine (Oral Pill)",
        "totalCount": 335,
        "searchTerms": [
            "CYCLOBENZAPRINE",
            "CYCLOBENZAPRINE (Oral)",
            "Cyclobenzaprine",
            "Cyclobenzaprine (Oral Pill)",
            "Cyclobenzaprine (Oral)",
            "Flexeril",
            "cyclobenzaprine",
            "cyclobenzaprine (Oral)",
            "cyclobenzaprine (oral pill)",
            "cyclobenzaprine (oral)",
            "cyclobenzaprine hydrochloride 10 MG Oral Tablet",
            "cyclobenzaprine hydrochloride 10 mg oral tablet",
            "cyclobenzaprine hydrochloride 5 MG Oral Tablet",
            "cyclobenzaprine hydrochloride 5 mg oral tablet",
            "cyclobenzaprine hydrochloride 7.5 MG Oral Tablet",
            "cyclobenzaprine hydrochloride 7.5 mg oral tablet",
            "flexeril"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "54%"
            },
            {
                "value": "5 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "36%"
            },
            {
                "value": "Twice daily",
                "pct": "20%"
            },
            {
                "value": "Three times daily",
                "pct": "14%"
            },
            {
                "value": "As needed",
                "pct": "13%"
            },
            {
                "value": "At bedtime",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M62.838",
                "description": "Other muscle spasm",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "TYLENOL XR",
        "route": "Oral Pill",
        "fullName": "TYLENOL XR (Oral Pill)",
        "totalCount": 333,
        "searchTerms": [
            "8 HR acetaminophen 650 MG Extended Release Oral Tablet",
            "8 hr acetaminophen 650 mg extended release oral tablet",
            "TYLENOL",
            "TYLENOL XR",
            "TYLENOL XR (Oral Pill)",
            "tylenol",
            "tylenol xr",
            "tylenol xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "650 mg",
                "pct": "60%"
            },
            {
                "value": "500 mg",
                "pct": "29%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "56%"
            },
            {
                "value": "Once daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "36%"
            },
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "Latanoprost",
        "route": "Ophthalmic",
        "fullName": "Latanoprost (Ophthalmic)",
        "totalCount": 328,
        "searchTerms": [
            "LATANOPROST",
            "Latanoprost",
            "Latanoprost (Ophthalmic)",
            "XALATAN",
            "Xalatan",
            "latanoprost",
            "latanoprost (ophthalmic)",
            "latanoprost 0.05 MG/ML Ophthalmic Solution",
            "latanoprost 0.05 MG/ML Ophthalmic Suspension",
            "latanoprost 0.05 mg/ml ophthalmic solution",
            "latanoprost 0.05 mg/ml ophthalmic suspension",
            "xalatan"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            },
            {
                "value": "At bedtime",
                "pct": "18%"
            }
        ],
        "adminNotes": [
            {
                "value": "Avoid touching dropper tip to eye or surfaces",
                "pct": "13%"
            }
        ],
        "diagnoses": [
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "61%"
            },
            {
                "code": "H40",
                "description": "Glaucoma",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "VASCEPA",
        "route": "Oral Pill",
        "fullName": "VASCEPA (Oral Pill)",
        "totalCount": 324,
        "searchTerms": [
            "VASCEPA",
            "VASCEPA (Oral Pill)",
            "VASCEPA (Oral)",
            "Vascepa",
            "Vascepa (Oral)",
            "icosapent ethyl 1000 MG Oral Capsule",
            "icosapent ethyl 1000 mg oral capsule",
            "icosapent ethyl 500 MG Oral Capsule",
            "icosapent ethyl 500 mg oral capsule",
            "vascepa",
            "vascepa (oral pill)",
            "vascepa (oral)"
        ],
        "dosages": [
            {
                "value": "1 g",
                "pct": "10%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "58%"
            },
            {
                "value": "Once daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "30%"
            },
            {
                "code": "E78.1",
                "description": "Pure hyperglyceridemia",
                "pct": "27%"
            },
            {
                "code": "E78",
                "description": "Disorders of lipoprotein metabolism and other lipidemias",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "OZEMPIC",
        "route": "Injectable",
        "fullName": "OZEMPIC (Injectable)",
        "totalCount": 321,
        "searchTerms": [
            "0.25 MG, 0.5 MG Dose 1.5 ML semaglutide 1.34 MG/ML Pen Injector",
            "0.25 mg, 0.5 mg dose 1.5 ml semaglutide 1.34 mg/ml pen injector",
            "1 MG Dose 1.5 ML semaglutide 1.34 MG/ML Pen Injector",
            "1 mg dose 1.5 ml semaglutide 1.34 mg/ml pen injector",
            "OZEMPIC",
            "OZEMPIC (Injectable)",
            "ozempic",
            "ozempic (injectable)"
        ],
        "dosages": [
            {
                "value": "1.34 mg",
                "pct": "34%"
            },
            {
                "value": "0.68 mg",
                "pct": "22%"
            },
            {
                "value": "2.68 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "87%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rotate injection sites",
                "pct": "15%"
            },
            {
                "value": "Do not share pens",
                "pct": "12%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "58%"
            },
            {
                "code": "E66.3",
                "description": "Overweight",
                "pct": "18%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "SYMBICORT",
        "route": "Inhalant",
        "fullName": "SYMBICORT (Inhalant)",
        "totalCount": 310,
        "searchTerms": [
            "120 ACTUAT budesonide 0.08 MG/ACTUAT / formoterol fumarate 0.0045 MG/ACTUAT Metered Dose Inhaler",
            "120 ACTUAT budesonide 0.16 MG/ACTUAT / formoterol fumarate 0.0045 MG/ACTUAT Metered Dose Inhaler",
            "120 actuat budesonide 0.08 mg/actuat / formoterol fumarate 0.0045 mg/actuat metered dose inhaler",
            "120 actuat budesonide 0.16 mg/actuat / formoterol fumarate 0.0045 mg/actuat metered dose inhaler",
            "60 ACTUAT budesonide 0.08 MG/ACTUAT / formoterol fumarate 0.0045 MG/ACTUAT Metered Dose Inhaler",
            "60 ACTUAT budesonide 0.16 MG/ACTUAT / formoterol fumarate 0.0045 MG/ACTUAT Metered Dose Inhaler",
            "60 actuat budesonide 0.08 mg/actuat / formoterol fumarate 0.0045 mg/actuat metered dose inhaler",
            "60 actuat budesonide 0.16 mg/actuat / formoterol fumarate 0.0045 mg/actuat metered dose inhaler",
            "SYMBICORT",
            "SYMBICORT (Inhalant)",
            "symbicort",
            "symbicort (inhalant)"
        ],
        "dosages": [
            {
                "value": "160-4.5 mcg",
                "pct": "59%"
            },
            {
                "value": "80-4.5 mcg",
                "pct": "37%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "64%"
            },
            {
                "value": "Once daily",
                "pct": "17%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rinse mouth after inhaled corticosteroid",
                "pct": "15%"
            },
            {
                "value": "Spacer used with MDI",
                "pct": "13%"
            }
        ],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "42%"
            },
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "18%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "16%"
            }
        ]
    },
    {
        "name": "Allopurinol",
        "route": "Oral Pill",
        "fullName": "Allopurinol (Oral Pill)",
        "totalCount": 307,
        "searchTerms": [
            "ALLOPURINOL",
            "ALLOPURINOL (Oral)",
            "Allopurinol",
            "Allopurinol (Oral Pill)",
            "Allopurinol (Oral)",
            "ZYLOPRIM",
            "Zyloprim",
            "allopurinol",
            "allopurinol (Oral)",
            "allopurinol (oral pill)",
            "allopurinol (oral)",
            "allopurinol 100 MG Oral Tablet",
            "allopurinol 100 mg oral tablet",
            "allopurinol 300 MG Oral Tablet",
            "allopurinol 300 mg oral tablet",
            "zyloprim"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "71%"
            },
            {
                "value": "300 mg",
                "pct": "24%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M10.9",
                "description": "Gout, unspecified",
                "pct": "61%"
            },
            {
                "code": "M10",
                "description": "Gout",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "SYNTHROID",
        "route": "Oral Pill",
        "fullName": "SYNTHROID (Oral Pill)",
        "totalCount": 304,
        "searchTerms": [
            "SYNTHROID",
            "SYNTHROID (Oral Pill)",
            "SYNTHROID (Oral)",
            "Synthroid",
            "Synthroid (Oral)",
            "levothyroxine sodium 0.025 MG Oral Tablet",
            "levothyroxine sodium 0.025 mg oral tablet",
            "levothyroxine sodium 0.05 MG Oral Tablet",
            "levothyroxine sodium 0.05 mg oral tablet",
            "levothyroxine sodium 0.075 MG Oral Tablet",
            "levothyroxine sodium 0.075 mg oral tablet",
            "levothyroxine sodium 0.088 MG Oral Tablet",
            "levothyroxine sodium 0.088 mg oral tablet",
            "levothyroxine sodium 0.1 MG Oral Tablet",
            "levothyroxine sodium 0.1 mg oral tablet",
            "levothyroxine sodium 0.112 MG Oral Tablet",
            "levothyroxine sodium 0.112 mg oral tablet",
            "levothyroxine sodium 0.125 MG Oral Tablet",
            "levothyroxine sodium 0.125 mg oral tablet",
            "levothyroxine sodium 0.137 MG Oral Tablet",
            "levothyroxine sodium 0.137 mg oral tablet",
            "levothyroxine sodium 0.15 MG Oral Tablet",
            "levothyroxine sodium 0.15 mg oral tablet",
            "levothyroxine sodium 0.175 MG Oral Tablet",
            "levothyroxine sodium 0.175 mg oral tablet",
            "levothyroxine sodium 0.2 MG Oral Tablet",
            "levothyroxine sodium 0.2 mg oral tablet",
            "synthroid",
            "synthroid (oral pill)",
            "synthroid (oral)"
        ],
        "dosages": [
            {
                "value": "0.075 mg",
                "pct": "15%"
            },
            {
                "value": "0.025 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E03.9",
                "description": "Hypothyroidism, unspecified",
                "pct": "42%"
            }
        ]
    },
    {
        "name": "NORVASC",
        "route": "Oral Pill",
        "fullName": "NORVASC (Oral Pill)",
        "totalCount": 302,
        "searchTerms": [
            "NORVASC",
            "NORVASC (Oral Pill)",
            "Norvasc",
            "Norvasc (Oral)",
            "amlodipine 10 MG Oral Tablet",
            "amlodipine 10 mg oral tablet",
            "amlodipine 2.5 MG Oral Tablet",
            "amlodipine 2.5 mg oral tablet",
            "amlodipine 5 MG Oral Tablet",
            "amlodipine 5 mg oral tablet",
            "norvasc",
            "norvasc (oral pill)",
            "norvasc (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "52%"
            },
            {
                "value": "5 mg",
                "pct": "37%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "glipiZIDE",
        "route": "Oral Pill",
        "fullName": "glipiZIDE (Oral Pill)",
        "totalCount": 302,
        "searchTerms": [
            "GLIPIZIDE",
            "GLIPIZIDE (Oral)",
            "Glipizide",
            "Glipizide (Oral)",
            "Glucotrol",
            "glipiZIDE",
            "glipiZIDE (Oral Pill)",
            "glipiZIDE (Oral)",
            "glipizide",
            "glipizide (oral pill)",
            "glipizide (oral)",
            "glipizide 10 MG Oral Tablet",
            "glipizide 10 mg oral tablet",
            "glipizide 5 MG Oral Tablet",
            "glipizide 5 mg oral tablet",
            "glucotrol"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "48%"
            },
            {
                "value": "5 mg",
                "pct": "46%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "65%"
            },
            {
                "value": "Twice daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "61%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "20%"
            }
        ]
    },
    {
        "name": "hydrOXYzine",
        "route": "Oral Pill",
        "fullName": "hydrOXYzine (Oral Pill)",
        "totalCount": 294,
        "searchTerms": [
            "Atarax",
            "HYDROXYZINE",
            "HYDROXYZINE (Oral)",
            "HYDROXYzine",
            "HYDROXYzine (Oral)",
            "Hydroxyzine",
            "Hydroxyzine (Oral)",
            "atarax",
            "hydrOXYzine",
            "hydrOXYzine (Oral Pill)",
            "hydrOXYzine (Oral)",
            "hydroxyzine",
            "hydroxyzine (oral pill)",
            "hydroxyzine (oral)",
            "hydroxyzine hydrochloride 10 MG Oral Tablet",
            "hydroxyzine hydrochloride 10 mg oral tablet",
            "hydroxyzine hydrochloride 25 MG Oral Tablet",
            "hydroxyzine hydrochloride 25 mg oral tablet",
            "hydroxyzine hydrochloride 50 MG Oral Tablet",
            "hydroxyzine hydrochloride 50 mg oral tablet",
            "hydroxyzine pamoate 100 MG Oral Capsule",
            "hydroxyzine pamoate 100 mg oral capsule",
            "hydroxyzine pamoate 25 MG Oral Capsule",
            "hydroxyzine pamoate 25 mg oral capsule",
            "hydroxyzine pamoate 50 MG Oral Capsule",
            "hydroxyzine pamoate 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "54%"
            },
            {
                "value": "50 mg",
                "pct": "27%"
            },
            {
                "value": "10 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "39%"
            },
            {
                "value": "As needed",
                "pct": "16%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            },
            {
                "value": "At bedtime",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "60%"
            }
        ]
    },
    {
        "name": "Loratadine",
        "route": "Oral Pill",
        "fullName": "Loratadine (Oral Pill)",
        "totalCount": 293,
        "searchTerms": [
            "CLARITIN",
            "Claritin",
            "Claritin 24 Hour",
            "Claritin-D 24 Hour",
            "LORATADINE",
            "LORATADINE (Oral)",
            "Loratadine",
            "Loratadine (Oral Pill)",
            "Loratadine (Oral)",
            "claritin",
            "claritin 24 hour",
            "claritin-d 24 hour",
            "loratadine",
            "loratadine (Oral)",
            "loratadine (oral pill)",
            "loratadine (oral)",
            "loratadine 10 MG Oral Capsule",
            "loratadine 10 MG Oral Tablet",
            "loratadine 10 mg oral capsule",
            "loratadine 10 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "GLUCOPHAGE",
        "route": "Oral Pill",
        "fullName": "GLUCOPHAGE (Oral Pill)",
        "totalCount": 292,
        "searchTerms": [
            "GLUCOPHAGE",
            "GLUCOPHAGE (Oral Pill)",
            "glucophage",
            "glucophage (oral pill)",
            "metformin hydrochloride 1000 MG Oral Tablet",
            "metformin hydrochloride 1000 mg oral tablet",
            "metformin hydrochloride 500 MG Oral Tablet",
            "metformin hydrochloride 500 mg oral tablet",
            "metformin hydrochloride 850 MG Oral Tablet",
            "metformin hydrochloride 850 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "66%"
            },
            {
                "value": "Once daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "predniSONE",
        "route": "Oral Pill",
        "fullName": "predniSONE (Oral Pill)",
        "totalCount": 288,
        "searchTerms": [
            "DELTASONE",
            "Deltasone",
            "PREDNISONE",
            "PREDNISONE (Oral)",
            "Prednisone",
            "Prednisone (Oral)",
            "deltasone",
            "predniSONE",
            "predniSONE (Oral Pill)",
            "predniSONE (Oral)",
            "prednisone",
            "prednisone (oral pill)",
            "prednisone (oral)",
            "prednisone 1 MG Delayed Release Oral Tablet",
            "prednisone 1 MG Oral Tablet",
            "prednisone 1 mg delayed release oral tablet",
            "prednisone 1 mg oral tablet",
            "prednisone 10 MG Oral Tablet",
            "prednisone 10 mg oral tablet",
            "prednisone 2 MG Delayed Release Oral Tablet",
            "prednisone 2 mg delayed release oral tablet",
            "prednisone 2.5 MG Oral Tablet",
            "prednisone 2.5 mg oral tablet",
            "prednisone 20 MG Oral Tablet",
            "prednisone 20 mg oral tablet",
            "prednisone 5 MG Delayed Release Oral Tablet",
            "prednisone 5 MG Oral Tablet",
            "prednisone 5 mg delayed release oral tablet",
            "prednisone 5 mg oral tablet",
            "prednisone 50 MG Oral Tablet",
            "prednisone 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "40%"
            },
            {
                "value": "20 mg",
                "pct": "23%"
            },
            {
                "value": "10 mg",
                "pct": "22%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M06.9",
                "description": "Rheumatoid arthritis, unspecified",
                "pct": "27%"
            },
            {
                "code": "J45.901",
                "description": "Unspecified asthma with (acute) exacerbation",
                "pct": "15%"
            },
            {
                "code": "J44.1",
                "description": "Chronic obstructive pulmonary disease w (acute) exacerbation",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "SEROquel",
        "route": "Oral Pill",
        "fullName": "SEROquel (Oral Pill)",
        "totalCount": 287,
        "searchTerms": [
            "SEROQUEL",
            "SEROQUEL (Oral Pill)",
            "SEROquel",
            "SEROquel (Oral Pill)",
            "Seroquel",
            "Seroquel (Oral)",
            "quetiapine 100 MG Oral Tablet",
            "quetiapine 100 mg oral tablet",
            "quetiapine 200 MG Oral Tablet",
            "quetiapine 200 mg oral tablet",
            "quetiapine 25 MG Oral Tablet",
            "quetiapine 25 mg oral tablet",
            "quetiapine 300 MG Oral Tablet",
            "quetiapine 300 mg oral tablet",
            "quetiapine 400 MG Oral Tablet",
            "quetiapine 400 mg oral tablet",
            "quetiapine 50 MG Oral Tablet",
            "quetiapine 50 mg oral tablet",
            "seroquel",
            "seroquel (oral pill)",
            "seroquel (oral)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "30%"
            },
            {
                "value": "25 mg",
                "pct": "28%"
            },
            {
                "value": "50 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "57%"
            },
            {
                "value": "At bedtime",
                "pct": "22%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "17%"
            }
        ]
    },
    {
        "name": "OLANZapine",
        "route": "Oral Pill",
        "fullName": "OLANZapine (Oral Pill)",
        "totalCount": 285,
        "searchTerms": [
            "OLANZAPINE",
            "OLANZAPINE (Oral)",
            "OLANZapine",
            "OLANZapine (Oral Pill)",
            "OLANZapine (Oral)",
            "Olanzapine",
            "Olanzapine (Oral)",
            "ZYPREXA",
            "Zyprexa",
            "olanzapine",
            "olanzapine (Oral)",
            "olanzapine (oral pill)",
            "olanzapine (oral)",
            "olanzapine 10 MG Oral Tablet",
            "olanzapine 10 mg oral tablet",
            "olanzapine 15 MG Oral Tablet",
            "olanzapine 15 mg oral tablet",
            "olanzapine 2.5 MG Oral Tablet",
            "olanzapine 2.5 mg oral tablet",
            "olanzapine 20 MG Oral Tablet",
            "olanzapine 20 mg oral tablet",
            "olanzapine 5 MG Oral Tablet",
            "olanzapine 5 mg oral tablet",
            "olanzapine 7.5 MG Oral Tablet",
            "olanzapine 7.5 mg oral tablet",
            "zyprexa"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "24%"
            },
            {
                "value": "10 mg",
                "pct": "24%"
            },
            {
                "value": "5 mg",
                "pct": "15%"
            },
            {
                "value": "2.5 mg",
                "pct": "14%"
            },
            {
                "value": "15 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "59%"
            },
            {
                "value": "At bedtime",
                "pct": "26%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "52%"
            },
            {
                "code": "F31.9",
                "description": "Bipolar disorder, unspecified",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "Calcium citrate/Vitamin D",
        "route": "Oral Pill",
        "fullName": "Calcium citrate/Vitamin D (Oral Pill)",
        "totalCount": 280,
        "searchTerms": [
            "Calcium citrate/Vitamin D",
            "Calcium citrate/Vitamin D (Oral Pill)",
            "calcium citrate 1190 MG / vitamin D 200 UNT Oral Tablet",
            "calcium citrate 1190 mg / vitamin d 200 unt oral tablet",
            "calcium citrate/vitamin d",
            "calcium citrate/vitamin d (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "47%"
            },
            {
                "value": "Twice daily",
                "pct": "21%"
            },
            {
                "value": "Weekly",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Folic acid",
        "route": "Oral Pill",
        "fullName": "Folic acid (Oral Pill)",
        "totalCount": 278,
        "searchTerms": [
            "519910201",
            "FOLIC ACID",
            "FOLIC ACID (Oral)",
            "Folic Acid",
            "Folic Acid (Oral)",
            "Folic acid",
            "Folic acid (Oral Pill)",
            "Folic acid (Oral)",
            "Folicet",
            "folic acid",
            "folic acid (oral pill)",
            "folic acid (oral)",
            "folic acid 0.4 MG Oral Tablet",
            "folic acid 0.4 mg oral tablet",
            "folic acid 0.8 MG Oral Tablet",
            "folic acid 0.8 mg oral tablet",
            "folic acid 1 MG Oral Tablet",
            "folic acid 1 mg oral tablet",
            "folicet"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "90%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "95%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D52.9",
                "description": "Folate deficiency anemia, unspecified",
                "pct": "72%"
            }
        ]
    },
    {
        "name": "Atenolol",
        "route": "Oral Pill",
        "fullName": "Atenolol (Oral Pill)",
        "totalCount": 276,
        "searchTerms": [
            "ATENOLOL",
            "ATENOLOL (Oral)",
            "Atenolol",
            "Atenolol (Oral Pill)",
            "Atenolol (Oral)",
            "TENORMIN",
            "Tenormin",
            "atenolol",
            "atenolol (oral pill)",
            "atenolol (oral)",
            "atenolol 100 MG Oral Tablet",
            "atenolol 100 mg oral tablet",
            "atenolol 25 MG Oral Tablet",
            "atenolol 25 mg oral tablet",
            "atenolol 50 MG Oral Tablet",
            "atenolol 50 mg oral tablet",
            "tenormin"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "50%"
            },
            {
                "value": "50 mg",
                "pct": "36%"
            },
            {
                "value": "100 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "62%"
            },
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "14%"
            }
        ]
    },
    {
        "name": "Vitamin D3",
        "route": "Supplement",
        "fullName": "Vitamin D3 (Supplement)",
        "totalCount": 272,
        "searchTerms": [
            "VITAMIN D3",
            "Vitamin D3",
            "Vitamin D3 (Supplement)",
            "vitamin d3",
            "vitamin d3 (supplement)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [
            {
                "value": "Supplement",
                "pct": "12%"
            }
        ],
        "diagnoses": []
    },
    {
        "name": "MIRALAX",
        "route": "Oral Solution Powder",
        "fullName": "MIRALAX (Oral Solution Powder)",
        "totalCount": 270,
        "searchTerms": [
            "MIRALAX",
            "MIRALAX (Oral Solution Powder)",
            "miralax",
            "miralax (oral solution powder)",
            "polyethylene glycol 3350 17000 MG Powder for Oral Solution",
            "polyethylene glycol 3350 17000 mg powder for oral solution"
        ],
        "dosages": [
            {
                "value": "17 g",
                "pct": "98%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "Esomeprazole",
        "route": "Oral Pill",
        "fullName": "Esomeprazole (Oral Pill)",
        "totalCount": 266,
        "searchTerms": [
            "ESOMEPRAZOLE",
            "ESOMEPRAZOLE (Oral)",
            "Esomeprazole",
            "Esomeprazole (Oral Pill)",
            "Esomeprazole (Oral)",
            "Nexium",
            "esomeprazole",
            "esomeprazole (oral pill)",
            "esomeprazole (oral)",
            "esomeprazole 20 MG Delayed Release Oral Capsule",
            "esomeprazole 20 MG Delayed Release Oral Tablet",
            "esomeprazole 20 mg delayed release oral capsule",
            "esomeprazole 20 mg delayed release oral tablet",
            "esomeprazole 40 MG Delayed Release Oral Capsule",
            "esomeprazole 40 mg delayed release oral capsule",
            "esomeprazole strontium 24.65 MG Delayed Release Oral Capsule",
            "esomeprazole strontium 24.65 mg delayed release oral capsule",
            "esomeprazole strontium 49.3 MG Delayed Release Oral Capsule",
            "esomeprazole strontium 49.3 mg delayed release oral capsule",
            "nexium"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "63%"
            },
            {
                "value": "20 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "55%"
            },
            {
                "code": "K21",
                "description": "Gastro-esophageal reflux disease",
                "pct": "16%"
            }
        ]
    },
    {
        "name": "XARELTO",
        "route": "Oral Pill",
        "fullName": "XARELTO (Oral Pill)",
        "totalCount": 262,
        "searchTerms": [
            "XARELTO",
            "XARELTO (Oral Pill)",
            "XARELTO (Oral)",
            "Xarelto",
            "Xarelto (Oral)",
            "rivaroxaban 10 MG Oral Tablet",
            "rivaroxaban 10 mg oral tablet",
            "rivaroxaban 15 MG Oral Tablet",
            "rivaroxaban 15 mg oral tablet",
            "rivaroxaban 2.5 MG Oral Tablet",
            "rivaroxaban 2.5 mg oral tablet",
            "rivaroxaban 20 MG Oral Tablet",
            "rivaroxaban 20 mg oral tablet",
            "xarelto",
            "xarelto (oral pill)",
            "xarelto (oral)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "54%"
            },
            {
                "value": "15 mg",
                "pct": "21%"
            },
            {
                "value": "10 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I48.91",
                "description": "Unspecified atrial fibrillation",
                "pct": "38%"
            },
            {
                "code": "I82.40",
                "description": "Acute embolism and thombos unsp deep veins of low extrm",
                "pct": "21%"
            }
        ]
    },
    {
        "name": "Fluticasone",
        "route": "Inhalant",
        "fullName": "Fluticasone (Inhalant)",
        "totalCount": 259,
        "searchTerms": [
            "14 ACTUAT fluticasone furoate 0.1 MG/ACTUAT Dry Powder Inhaler",
            "14 ACTUAT fluticasone furoate 0.2 MG/ACTUAT Dry Powder Inhaler",
            "14 actuat fluticasone furoate 0.1 mg/actuat dry powder inhaler",
            "14 actuat fluticasone furoate 0.2 mg/actuat dry powder inhaler",
            "28 ACTUAT fluticasone propionate 0.25 MG/ACTUAT Dry Powder Inhaler",
            "28 actuat fluticasone propionate 0.25 mg/actuat dry powder inhaler",
            "30 ACTUAT fluticasone furoate 0.1 MG/ACTUAT Dry Powder Inhaler",
            "30 ACTUAT fluticasone furoate 0.2 MG/ACTUAT Dry Powder Inhaler",
            "30 actuat fluticasone furoate 0.1 mg/actuat dry powder inhaler",
            "30 actuat fluticasone furoate 0.2 mg/actuat dry powder inhaler",
            "FLUTICASONE",
            "Fluticasone",
            "Fluticasone (Inhalant)",
            "fluticasone",
            "fluticasone (inhalant)"
        ],
        "dosages": [
            {
                "value": "50 mcg",
                "pct": "54%"
            },
            {
                "value": "250 mcg",
                "pct": "17%"
            },
            {
                "value": "100 mcg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "49%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            },
            {
                "value": "As needed",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "30%"
            },
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "18%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "GLUCOPHAGE XR",
        "route": "Oral Pill",
        "fullName": "GLUCOPHAGE XR (Oral Pill)",
        "totalCount": 257,
        "searchTerms": [
            "24 HR metformin hydrochloride 500 MG Extended Release Oral Tablet",
            "24 HR metformin hydrochloride 750 MG Extended Release Oral Tablet",
            "24 hr metformin hydrochloride 500 mg extended release oral tablet",
            "24 hr metformin hydrochloride 750 mg extended release oral tablet",
            "GLUCOPHAGE",
            "GLUCOPHAGE XR",
            "GLUCOPHAGE XR (Oral Pill)",
            "glucophage",
            "glucophage xr",
            "glucophage xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "84%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "61%"
            },
            {
                "value": "Once daily",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RisperDAL",
        "route": "Oral Pill",
        "fullName": "RisperDAL (Oral Pill)",
        "totalCount": 256,
        "searchTerms": [
            "RISPERDAL",
            "RisperDAL",
            "RisperDAL (Oral Pill)",
            "risperdal",
            "risperdal (oral pill)",
            "risperidone 0.25 MG Oral Tablet",
            "risperidone 0.25 mg oral tablet",
            "risperidone 0.5 MG Oral Tablet",
            "risperidone 0.5 mg oral tablet",
            "risperidone 1 MG Oral Tablet",
            "risperidone 1 mg oral tablet",
            "risperidone 2 MG Oral Tablet",
            "risperidone 2 mg oral tablet",
            "risperidone 3 MG Oral Tablet",
            "risperidone 3 mg oral tablet",
            "risperidone 4 MG Oral Tablet",
            "risperidone 4 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "23%"
            },
            {
                "value": "2 mg",
                "pct": "23%"
            },
            {
                "value": "3 mg",
                "pct": "18%"
            },
            {
                "value": "4 mg",
                "pct": "14%"
            },
            {
                "value": "0.5 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "39%"
            },
            {
                "value": "Twice daily",
                "pct": "31%"
            },
            {
                "value": "At bedtime",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "32%"
            }
        ]
    },
    {
        "name": "Enalapril",
        "route": "Oral Pill",
        "fullName": "Enalapril (Oral Pill)",
        "totalCount": 255,
        "searchTerms": [
            "Enalapril",
            "Enalapril (Oral Pill)",
            "Enalapril (Oral)",
            "VASOTEC",
            "Vasotec",
            "enalapril",
            "enalapril (Oral)",
            "enalapril (oral pill)",
            "enalapril (oral)",
            "enalapril maleate 10 MG Oral Tablet",
            "enalapril maleate 10 mg oral tablet",
            "enalapril maleate 2.5 MG Oral Tablet",
            "enalapril maleate 2.5 mg oral tablet",
            "enalapril maleate 20 MG Oral Tablet",
            "enalapril maleate 20 mg oral tablet",
            "enalapril maleate 5 MG Oral Tablet",
            "enalapril maleate 5 mg oral tablet",
            "vasotec"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "34%"
            },
            {
                "value": "10 mg",
                "pct": "28%"
            },
            {
                "value": "5 mg",
                "pct": "20%"
            },
            {
                "value": "2.5 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "74%"
            },
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "Cholecalciferol",
        "route": "Oral Pill",
        "fullName": "Cholecalciferol (Oral Pill)",
        "totalCount": 251,
        "searchTerms": [
            "CHOLECALCIFEROL",
            "Cholecalciferol",
            "Cholecalciferol (Oral Pill)",
            "Cholecalciferol (Oral)",
            "cholecalciferol",
            "cholecalciferol (oral pill)",
            "cholecalciferol (oral)",
            "cholecalciferol 0.1 MG Oral Capsule",
            "cholecalciferol 0.1 MG Oral Tablet",
            "cholecalciferol 0.1 mg oral capsule",
            "cholecalciferol 0.1 mg oral tablet",
            "cholecalciferol 0.35 MG Oral Capsule",
            "cholecalciferol 0.35 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "0.05 mg",
                "pct": "25%"
            },
            {
                "value": "0.025 mg",
                "pct": "19%"
            },
            {
                "value": "1.25 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            },
            {
                "value": "Weekly",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "67%"
            },
            {
                "code": "E55",
                "description": "Vitamin D deficiency",
                "pct": "20%"
            }
        ]
    },
    {
        "name": "Torsemide",
        "route": "Oral Pill",
        "fullName": "Torsemide (Oral Pill)",
        "totalCount": 248,
        "searchTerms": [
            "Demadex",
            "TORSEMIDE",
            "TORSEMIDE (Oral)",
            "Torsemide",
            "Torsemide (Oral Pill)",
            "Torsemide (Oral)",
            "demadex",
            "torsemide",
            "torsemide (Oral)",
            "torsemide (oral pill)",
            "torsemide (oral)",
            "torsemide 10 MG Oral Tablet",
            "torsemide 10 mg oral tablet",
            "torsemide 100 MG Oral Tablet",
            "torsemide 100 mg oral tablet",
            "torsemide 20 MG Oral Tablet",
            "torsemide 20 mg oral tablet",
            "torsemide 5 MG Oral Tablet",
            "torsemide 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "65%"
            },
            {
                "value": "10 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "63%"
            }
        ]
    },
    {
        "name": "Melatonin",
        "route": "Oral Pill",
        "fullName": "Melatonin (Oral Pill)",
        "totalCount": 245,
        "searchTerms": [
            "MELATONIN",
            "Melatonin",
            "Melatonin (Oral Pill)",
            "melatonin",
            "melatonin (oral pill)",
            "melatonin 10 MG Oral Capsule",
            "melatonin 10 MG Oral Tablet",
            "melatonin 10 mg oral capsule",
            "melatonin 10 mg oral tablet",
            "melatonin 20 MG Oral Capsule",
            "melatonin 20 mg oral capsule",
            "melatonin 3 MG Oral Tablet",
            "melatonin 3 mg oral tablet",
            "melatonin 5 MG Oral Capsule",
            "melatonin 5 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "37%"
            },
            {
                "value": "3 mg",
                "pct": "31%"
            },
            {
                "value": "10 mg",
                "pct": "24%"
            }
        ],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "53%"
            },
            {
                "value": "Once daily",
                "pct": "39%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "63%"
            },
            {
                "code": "G47",
                "description": "Sleep disorders",
                "pct": "14%"
            }
        ]
    },
    {
        "name": "NovoLOG",
        "route": "Injectable",
        "fullName": "NovoLOG (Injectable)",
        "totalCount": 245,
        "searchTerms": [
            "3 ML insulin aspart, human 100 UNT/ML Cartridge",
            "3 ML insulin aspart, human 100 UNT/ML Pen Injector",
            "3 ml insulin aspart, human 100 unt/ml cartridge",
            "3 ml insulin aspart, human 100 unt/ml pen injector",
            "NOVOLOG",
            "NovoLOG",
            "NovoLOG (Injectable)",
            "insulin aspart, human 100 UNT/ML Injectable Solution",
            "insulin aspart, human 100 unt/ml injectable solution",
            "novolog",
            "novolog (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "24%"
            },
            {
                "value": "With meals",
                "pct": "20%"
            },
            {
                "value": "Once daily",
                "pct": "12%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rotate injection sites",
                "pct": "19%"
            },
            {
                "value": "Do not share pens",
                "pct": "11%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "64%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "20%"
            }
        ]
    },
    {
        "name": "Baclofen",
        "route": "Oral Pill",
        "fullName": "Baclofen (Oral Pill)",
        "totalCount": 244,
        "searchTerms": [
            "BACLOFEN",
            "BACLOFEN (Oral)",
            "Baclofen",
            "Baclofen (Oral Pill)",
            "Baclofen (Oral)",
            "Lioresal",
            "baclofen",
            "baclofen (Oral)",
            "baclofen (oral pill)",
            "baclofen (oral)",
            "baclofen 10 MG Oral Tablet",
            "baclofen 10 mg oral tablet",
            "baclofen 20 MG Oral Tablet",
            "baclofen 20 mg oral tablet",
            "baclofen 5 MG Oral Tablet",
            "baclofen 5 mg oral tablet",
            "lioresal"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "62%"
            },
            {
                "value": "20 mg",
                "pct": "22%"
            },
            {
                "value": "5 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "25%"
            },
            {
                "value": "Once daily",
                "pct": "22%"
            },
            {
                "value": "Twice daily",
                "pct": "21%"
            },
            {
                "value": "As needed",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M62.838",
                "description": "Other muscle spasm",
                "pct": "64%"
            }
        ]
    },
    {
        "name": "AMLODIPINE BESYLATE",
        "route": "Oral Pill",
        "fullName": "AMLODIPINE BESYLATE (Oral Pill)",
        "totalCount": 243,
        "searchTerms": [
            "AMLODIPINE BESYLATE",
            "AMLODIPINE BESYLATE (Oral)",
            "Amlodipine Besylate",
            "Amlodipine Besylate (Oral)",
            "NORVASC 10 MG",
            "Norvasc",
            "amLODIPine BESYLATE",
            "amLODIPine BESYLATE (Oral)",
            "amLODIPine Besylate",
            "amLODIPine Besylate (Oral)",
            "amlodipine besylate",
            "amlodipine besylate (oral)",
            "norvasc",
            "norvasc 10 mg"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "48%"
            },
            {
                "value": "5 mg",
                "pct": "42%"
            },
            {
                "value": "2.5 mg",
                "pct": "10%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "95%"
            }
        ]
    },
    {
        "name": "COLACE",
        "route": "Oral Pill",
        "fullName": "COLACE (Oral Pill)",
        "totalCount": 243,
        "searchTerms": [
            "COLACE",
            "COLACE (Oral Pill)",
            "Colace",
            "Colace (Oral)",
            "colace",
            "colace (oral pill)",
            "colace (oral)",
            "docusate sodium 100 MG Oral Capsule",
            "docusate sodium 100 mg oral capsule",
            "docusate sodium 50 MG Oral Capsule",
            "docusate sodium 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "94%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "41%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "47%"
            }
        ]
    },
    {
        "name": "Acetaminophen/oxyCODONE",
        "route": "Oral Pill",
        "fullName": "Acetaminophen/oxyCODONE (Oral Pill)",
        "totalCount": 241,
        "searchTerms": [
            "Acetaminophen/oxyCODONE",
            "Acetaminophen/oxyCODONE (Oral Pill)",
            "acetaminophen 300 MG / oxycodone hydrochloride 10 MG Oral Tablet",
            "acetaminophen 300 MG / oxycodone hydrochloride 2.5 MG Oral Tablet",
            "acetaminophen 300 MG / oxycodone hydrochloride 5 MG Oral Tablet",
            "acetaminophen 300 MG / oxycodone hydrochloride 7.5 MG Oral Tablet",
            "acetaminophen 300 mg / oxycodone hydrochloride 10 mg oral tablet",
            "acetaminophen 300 mg / oxycodone hydrochloride 2.5 mg oral tablet",
            "acetaminophen 300 mg / oxycodone hydrochloride 5 mg oral tablet",
            "acetaminophen 300 mg / oxycodone hydrochloride 7.5 mg oral tablet",
            "acetaminophen 325 MG / oxycodone hydrochloride 10 MG Oral Tablet",
            "acetaminophen 325 MG / oxycodone hydrochloride 5 MG Oral Tablet",
            "acetaminophen 325 MG / oxycodone hydrochloride 7.5 MG Oral Tablet",
            "acetaminophen 325 mg / oxycodone hydrochloride 10 mg oral tablet",
            "acetaminophen 325 mg / oxycodone hydrochloride 5 mg oral tablet",
            "acetaminophen 325 mg / oxycodone hydrochloride 7.5 mg oral tablet",
            "acetaminophen 400 MG / oxycodone hydrochloride 10 MG Oral Tablet",
            "acetaminophen 400 MG / oxycodone hydrochloride 5 MG Oral Tablet",
            "acetaminophen 400 mg / oxycodone hydrochloride 10 mg oral tablet",
            "acetaminophen 400 mg / oxycodone hydrochloride 5 mg oral tablet",
            "acetaminophen/oxycodone",
            "acetaminophen/oxycodone (oral pill)"
        ],
        "dosages": [
            {
                "value": "325-5 mg",
                "pct": "26%"
            },
            {
                "value": "325-10 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "48%"
            },
            {
                "value": "Once daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "46%"
            }
        ]
    },
    {
        "name": "PLAVIX",
        "route": "Oral Pill",
        "fullName": "PLAVIX (Oral Pill)",
        "totalCount": 238,
        "searchTerms": [
            "PLAVIX",
            "PLAVIX (Oral Pill)",
            "Plavix",
            "Plavix (Oral)",
            "clopidogrel 300 MG Oral Tablet",
            "clopidogrel 300 mg oral tablet",
            "clopidogrel 75 MG Oral Tablet",
            "clopidogrel 75 mg oral tablet",
            "plavix",
            "plavix (oral pill)",
            "plavix (oral)"
        ],
        "dosages": [
            {
                "value": "75 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "37%"
            }
        ]
    },
    {
        "name": "FARXIGA",
        "route": "Oral Pill",
        "fullName": "FARXIGA (Oral Pill)",
        "totalCount": 237,
        "searchTerms": [
            "Dapagliflozin",
            "FARXIGA",
            "FARXIGA (Oral Pill)",
            "FARXIGA (Oral)",
            "Farxiga",
            "Farxiga (Oral)",
            "dapagliflozin",
            "dapagliflozin 10 MG Oral Tablet",
            "dapagliflozin 10 mg oral tablet",
            "dapagliflozin 5 MG Oral Tablet",
            "dapagliflozin 5 mg oral tablet",
            "farxiga",
            "farxiga (oral pill)",
            "farxiga (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "76%"
            },
            {
                "value": "5 mg",
                "pct": "22%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "55%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "14%"
            },
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "10%"
            }
        ]
    },
    {
        "name": "Alendronate",
        "route": "Oral Pill",
        "fullName": "Alendronate (Oral Pill)",
        "totalCount": 236,
        "searchTerms": [
            "ALENDRONATE",
            "ALENDRONATE (Oral)",
            "Alendronate",
            "Alendronate (Oral Pill)",
            "Alendronate (Oral)",
            "FOSAMAX",
            "Fosamax",
            "alendronate",
            "alendronate (Oral)",
            "alendronate (oral pill)",
            "alendronate (oral)",
            "alendronic acid 10 MG Oral Tablet",
            "alendronic acid 10 mg oral tablet",
            "alendronic acid 35 MG Oral Tablet",
            "alendronic acid 35 mg oral tablet",
            "alendronic acid 40 MG Oral Tablet",
            "alendronic acid 40 mg oral tablet",
            "alendronic acid 5 MG Oral Tablet",
            "alendronic acid 5 mg oral tablet",
            "alendronic acid 70 MG Oral Tablet",
            "alendronic acid 70 mg oral tablet",
            "fosamax"
        ],
        "dosages": [
            {
                "value": "70 mg",
                "pct": "89%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "72%"
            }
        ],
        "adminNotes": [
            {
                "value": "Take with a full glass of water",
                "pct": "12%"
            },
            {
                "value": "Remain upright for at least 30 minutes after taking",
                "pct": "12%"
            }
        ],
        "diagnoses": [
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "64%"
            },
            {
                "code": "M81",
                "description": "Osteoporosis without current pathological fracture",
                "pct": "17%"
            }
        ]
    },
    {
        "name": "ADVIL",
        "route": "Oral Pill",
        "fullName": "ADVIL (Oral Pill)",
        "totalCount": 236,
        "searchTerms": [
            "ADVIL",
            "ADVIL (Oral Pill)",
            "Advil",
            "Advil (Oral)",
            "advil",
            "advil (oral pill)",
            "advil (oral)",
            "ibuprofen 100 MG Oral Tablet",
            "ibuprofen 100 mg oral tablet",
            "ibuprofen 200 MG Oral Capsule",
            "ibuprofen 200 MG Oral Tablet",
            "ibuprofen 200 mg oral capsule",
            "ibuprofen 200 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "56%"
            },
            {
                "value": "600 mg",
                "pct": "17%"
            },
            {
                "value": "400 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "56%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            },
            {
                "value": "Once daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "30%"
            },
            {
                "code": "M25.50",
                "description": "Pain in unspecified joint",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "DRISDOL",
        "route": "Oral Pill",
        "fullName": "DRISDOL (Oral Pill)",
        "totalCount": 236,
        "searchTerms": [
            "DRISDOL",
            "DRISDOL (Oral Pill)",
            "Drisdol",
            "Drisdol (Oral)",
            "drisdol",
            "drisdol (oral pill)",
            "drisdol (oral)",
            "ergocalciferol 1.25 MG Oral Capsule",
            "ergocalciferol 1.25 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "1.25 mg",
                "pct": "82%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "48%"
            },
            {
                "value": "Qw po",
                "pct": "31%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "61%"
            }
        ]
    },
    {
        "name": "DEPAKOTE XR",
        "route": "Oral Pill",
        "fullName": "DEPAKOTE XR (Oral Pill)",
        "totalCount": 235,
        "searchTerms": [
            "24 HR divalproex sodium 250 MG Extended Release Oral Tablet",
            "24 HR divalproex sodium 500 MG Extended Release Oral Tablet",
            "24 hr divalproex sodium 250 mg extended release oral tablet",
            "24 hr divalproex sodium 500 mg extended release oral tablet",
            "DEPAKOTE",
            "DEPAKOTE XR",
            "DEPAKOTE XR (Oral Pill)",
            "depakote",
            "depakote xr",
            "depakote xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "69%"
            },
            {
                "value": "250 mg",
                "pct": "22%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "45%"
            },
            {
                "value": "Twice daily",
                "pct": "34%"
            },
            {
                "value": "At bedtime",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "22%"
            }
        ]
    },
    {
        "name": "busPIRone",
        "route": "Oral Pill",
        "fullName": "busPIRone (Oral Pill)",
        "totalCount": 235,
        "searchTerms": [
            "BUSPIRONE",
            "BuSpar",
            "Buspar Dividose",
            "Buspirone",
            "Buspirone (Oral)",
            "busPIRone",
            "busPIRone (Oral Pill)",
            "busPIRone (Oral)",
            "buspar",
            "buspar dividose",
            "buspirone",
            "buspirone (oral pill)",
            "buspirone (oral)",
            "buspirone hydrochloride 10 MG Oral Tablet",
            "buspirone hydrochloride 10 mg oral tablet",
            "buspirone hydrochloride 15 MG Oral Tablet",
            "buspirone hydrochloride 15 mg oral tablet",
            "buspirone hydrochloride 30 MG Oral Tablet",
            "buspirone hydrochloride 30 mg oral tablet",
            "buspirone hydrochloride 5 MG Oral Tablet",
            "buspirone hydrochloride 5 mg oral tablet",
            "buspirone hydrochloride 7.5 MG Oral Tablet",
            "buspirone hydrochloride 7.5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "37%"
            },
            {
                "value": "5 mg",
                "pct": "26%"
            },
            {
                "value": "15 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "45%"
            },
            {
                "value": "Once daily",
                "pct": "37%"
            },
            {
                "value": "Three times daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "56%"
            },
            {
                "code": "F41",
                "description": "Other anxiety disorders",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "ENTRESTO",
        "route": "Oral Pill",
        "fullName": "ENTRESTO (Oral Pill)",
        "totalCount": 230,
        "searchTerms": [
            "ENTRESTO",
            "ENTRESTO (Oral Pill)",
            "ENTRESTO (Oral)",
            "Entresto",
            "Entresto (Oral)",
            "Sacubitril/Valsartan",
            "entresto",
            "entresto (oral pill)",
            "entresto (oral)",
            "sacubitril 24 MG / valsartan 26 MG Oral Tablet",
            "sacubitril 24 mg / valsartan 26 mg oral tablet",
            "sacubitril 49 MG / valsartan 51 MG Oral Tablet",
            "sacubitril 49 mg / valsartan 51 mg oral tablet",
            "sacubitril 97 MG / valsartan 103 MG Oral Tablet",
            "sacubitril 97 mg / valsartan 103 mg oral tablet",
            "sacubitril/valsartan"
        ],
        "dosages": [
            {
                "value": "24-26 mg",
                "pct": "65%"
            },
            {
                "value": "97-103 mg",
                "pct": "17%"
            },
            {
                "value": "49-51 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "63%"
            },
            {
                "value": "Once daily",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "36%"
            },
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "LORazepam",
        "route": "Oral Pill",
        "fullName": "LORazepam (Oral Pill)",
        "totalCount": 230,
        "searchTerms": [
            "ATIVAN",
            "Ativan",
            "LORAZEPAM",
            "LORazepam",
            "LORazepam (Oral Pill)",
            "LORazepam (Oral)",
            "Lorazepam",
            "Lorazepam (Oral)",
            "ativan",
            "lorazepam",
            "lorazepam (oral pill)",
            "lorazepam (oral)",
            "lorazepam 0.5 MG Oral Tablet",
            "lorazepam 0.5 mg oral tablet",
            "lorazepam 1 MG Oral Tablet",
            "lorazepam 1 mg oral tablet",
            "lorazepam 2 MG Oral Tablet",
            "lorazepam 2 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "63%"
            },
            {
                "value": "1 mg",
                "pct": "30%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "38%"
            },
            {
                "value": "Twice daily",
                "pct": "20%"
            },
            {
                "value": "As needed",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "72%"
            },
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "14%"
            }
        ]
    },
    {
        "name": "Cetirizine",
        "route": "Oral Pill",
        "fullName": "Cetirizine (Oral Pill)",
        "totalCount": 228,
        "searchTerms": [
            "CETIRIZINE",
            "CETIRIZINE (Oral)",
            "Cetirizine",
            "Cetirizine (Oral Pill)",
            "Cetirizine (Oral)",
            "ZyrTEC",
            "ZyrTEC Allergy",
            "Zyrtec",
            "Zyrtec Allergy",
            "cetirizine",
            "cetirizine (Oral)",
            "cetirizine (oral pill)",
            "cetirizine (oral)",
            "cetirizine hydrochloride 10 MG Oral Capsule",
            "cetirizine hydrochloride 10 MG Oral Tablet",
            "cetirizine hydrochloride 10 mg oral capsule",
            "cetirizine hydrochloride 10 mg oral tablet",
            "cetirizine hydrochloride 5 MG Oral Tablet",
            "cetirizine hydrochloride 5 mg oral tablet",
            "zyrtec",
            "zyrtec allergy"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "74%"
            }
        ]
    },
    {
        "name": "Hydrochlorothiazide/Losartan",
        "route": "Oral Pill",
        "fullName": "Hydrochlorothiazide/Losartan (Oral Pill)",
        "totalCount": 225,
        "searchTerms": [
            "Hydrochlorothiazide/Losartan",
            "Hydrochlorothiazide/Losartan (Oral Pill)",
            "hydroCHLOROthiazide/Losartan",
            "hydroCHLOROthiazide/Losartan (Oral Pill)",
            "hydrochlorothiazide 12.5 MG / losartan potassium 100 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / losartan potassium 50 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / losartan potassium 100 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / losartan potassium 50 mg oral tablet",
            "hydrochlorothiazide 25 MG / losartan potassium 100 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / losartan potassium 100 mg oral tablet",
            "hydrochlorothiazide/losartan",
            "hydrochlorothiazide/losartan (oral pill)"
        ],
        "dosages": [
            {
                "value": "12.5-100 mg",
                "pct": "34%"
            },
            {
                "value": "25-100 mg",
                "pct": "32%"
            },
            {
                "value": "12.5-50 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "77%"
            }
        ]
    },
    {
        "name": "Nitroglycerin",
        "route": "Sublingual",
        "fullName": "Nitroglycerin (Sublingual)",
        "totalCount": 221,
        "searchTerms": [
            "NITROGLYCERIN",
            "Nitroglycerin",
            "Nitroglycerin (Sublingual)",
            "Nitrostat",
            "nitroglycerin",
            "nitroglycerin (sublingual)",
            "nitroglycerin 0.3 MG Sublingual Tablet",
            "nitroglycerin 0.3 mg sublingual tablet",
            "nitroglycerin 0.4 MG Sublingual Powder",
            "nitroglycerin 0.4 MG Sublingual Tablet",
            "nitroglycerin 0.4 mg sublingual powder",
            "nitroglycerin 0.4 mg sublingual tablet",
            "nitrostat"
        ],
        "dosages": [
            {
                "value": "0.4 mg",
                "pct": "88%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "69%"
            },
            {
                "value": "Once daily",
                "pct": "17%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "56%"
            },
            {
                "code": "I20.9",
                "description": "Angina pectoris, unspecified",
                "pct": "16%"
            }
        ]
    },
    {
        "name": "PEPCID",
        "route": "Oral Pill",
        "fullName": "PEPCID (Oral Pill)",
        "totalCount": 218,
        "searchTerms": [
            "PEPCID",
            "PEPCID (Oral Pill)",
            "famotidine 10 MG Oral Tablet",
            "famotidine 10 mg oral tablet",
            "famotidine 20 MG Oral Tablet",
            "famotidine 20 mg oral tablet",
            "famotidine 40 MG Oral Tablet",
            "famotidine 40 mg oral tablet",
            "pepcid",
            "pepcid (oral pill)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "69%"
            },
            {
                "value": "40 mg",
                "pct": "27%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "60%"
            },
            {
                "value": "Twice daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "CREON",
        "route": "Oral Pill",
        "fullName": "CREON (Oral Pill)",
        "totalCount": 217,
        "searchTerms": [
            "CREON",
            "CREON (Oral Pill)",
            "CREON (Oral)",
            "Creon",
            "Creon (Oral)",
            "amylase 120000 UNT / lipase 24000 UNT / protease 76000 UNT Delayed Release Oral Capsule",
            "amylase 120000 unt / lipase 24000 unt / protease 76000 unt delayed release oral capsule",
            "amylase 15000 UNT / lipase 3000 UNT / protease 9500 UNT Delayed Release Oral Capsule",
            "amylase 15000 unt / lipase 3000 unt / protease 9500 unt delayed release oral capsule",
            "amylase 180000 UNT / lipase 36000 UNT / protease 114000 UNT Delayed Release Oral Capsule",
            "amylase 180000 unt / lipase 36000 unt / protease 114000 unt delayed release oral capsule",
            "amylase 30000 UNT / lipase 6000 UNT / protease 19000 UNT Delayed Release Oral Capsule",
            "amylase 30000 unt / lipase 6000 unt / protease 19000 unt delayed release oral capsule",
            "amylase 60000 UNT / lipase 12000 UNT / protease 38000 UNT Delayed Release Oral Capsule",
            "amylase 60000 unt / lipase 12000 unt / protease 38000 unt delayed release oral capsule",
            "creon",
            "creon (oral pill)",
            "creon (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "53%"
            },
            {
                "value": "Once daily",
                "pct": "20%"
            },
            {
                "value": "Twice daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K86.81",
                "description": "Exocrine pancreatic insufficiency",
                "pct": "59%"
            }
        ]
    },
    {
        "name": "Albuterol/Ipratropium",
        "route": "Inhalant",
        "fullName": "Albuterol/Ipratropium (Inhalant)",
        "totalCount": 216,
        "searchTerms": [
            "120 ACTUAT albuterol 0.1 MG/ACTUAT / ipratropium bromide 0.02 MG/ACTUAT Inhalation Spray",
            "120 actuat albuterol 0.1 mg/actuat / ipratropium bromide 0.02 mg/actuat inhalation spray",
            "Albuterol/Ipratropium",
            "Albuterol/Ipratropium (Inhalant)",
            "albuterol 0.833 MG/ML / ipratropium bromide 0.167 MG/ML Inhalation Solution",
            "albuterol 0.833 mg/ml / ipratropium bromide 0.167 mg/ml inhalation solution",
            "albuterol/ipratropium",
            "albuterol/ipratropium (inhalant)"
        ],
        "dosages": [
            {
                "value": "0.833-0.167 mg",
                "pct": "54%"
            },
            {
                "value": "100-20 mcg",
                "pct": "27%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "42%"
            },
            {
                "value": "Once daily",
                "pct": "23%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "25%"
            },
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "17%"
            }
        ]
    },
    {
        "name": "Citalopram",
        "route": "Oral Pill",
        "fullName": "Citalopram (Oral Pill)",
        "totalCount": 215,
        "searchTerms": [
            "CITALOPRAM",
            "CITALOPRAM (Oral)",
            "Celexa",
            "Citalopram",
            "Citalopram (Oral Pill)",
            "Citalopram (Oral)",
            "celexa",
            "citalopram",
            "citalopram (Oral)",
            "citalopram (oral pill)",
            "citalopram (oral)",
            "citalopram 10 MG Oral Tablet",
            "citalopram 10 mg oral tablet",
            "citalopram 20 MG Oral Tablet",
            "citalopram 20 mg oral tablet",
            "citalopram 40 MG Oral Tablet",
            "citalopram 40 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "49%"
            },
            {
                "value": "10 mg",
                "pct": "33%"
            },
            {
                "value": "40 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "51%"
            },
            {
                "code": "F33",
                "description": "Major depressive disorder, recurrent",
                "pct": "17%"
            }
        ]
    },
    {
        "name": "AMBIEN",
        "route": "Oral Pill",
        "fullName": "AMBIEN (Oral Pill)",
        "totalCount": 215,
        "searchTerms": [
            "AMBIEN",
            "AMBIEN (Oral Pill)",
            "Ambien",
            "Ambien (Oral)",
            "ambien",
            "ambien (oral pill)",
            "ambien (oral)",
            "zolpidem tartrate 10 MG Oral Tablet",
            "zolpidem tartrate 10 mg oral tablet",
            "zolpidem tartrate 5 MG Oral Tablet",
            "zolpidem tartrate 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "84%"
            },
            {
                "value": "5 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "50%"
            },
            {
                "value": "Once daily",
                "pct": "43%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "VENTOLIN",
        "route": "Inhalant",
        "fullName": "VENTOLIN (Inhalant)",
        "totalCount": 214,
        "searchTerms": [
            "NDA020983 200 ACTUAT albuterol 0.09 MG/ACTUAT Metered Dose Inhaler",
            "NDA020983 60 ACTUAT albuterol 0.09 MG/ACTUAT Metered Dose Inhaler",
            "VENTOLIN",
            "VENTOLIN (Inhalant)",
            "nda020983 200 actuat albuterol 0.09 mg/actuat metered dose inhaler",
            "nda020983 60 actuat albuterol 0.09 mg/actuat metered dose inhaler",
            "ventolin",
            "ventolin (inhalant)"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "94%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "47%"
            },
            {
                "value": "Once daily",
                "pct": "21%"
            }
        ],
        "adminNotes": [
            {
                "value": "Shake well before use",
                "pct": "13%"
            }
        ],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "38%"
            },
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "20%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "16%"
            }
        ]
    },
    {
        "name": "ATORVASTATIN CALCIUM",
        "route": "Oral Pill",
        "fullName": "ATORVASTATIN CALCIUM (Oral Pill)",
        "totalCount": 213,
        "searchTerms": [
            "ATORVASTATIN CALCIUM",
            "ATORVASTATIN CALCIUM (Oral)",
            "Atorvastatin Calcium",
            "Atorvastatin Calcium (Oral)",
            "LIPITOR",
            "LIPITOR 80 MG",
            "Lipitor",
            "Lipitor 20 MG Tablet",
            "atorvastatin Calcium",
            "atorvastatin Calcium (Oral)",
            "atorvastatin calcium",
            "atorvastatin calcium (oral)",
            "lipitor",
            "lipitor 20 mg tablet",
            "lipitor 80 mg"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "33%"
            },
            {
                "value": "20 mg",
                "pct": "30%"
            },
            {
                "value": "80 mg",
                "pct": "20%"
            },
            {
                "value": "10 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "98%"
            }
        ]
    },
    {
        "name": "CRESTOR",
        "route": "Oral Pill",
        "fullName": "CRESTOR (Oral Pill)",
        "totalCount": 212,
        "searchTerms": [
            "CRESTOR",
            "CRESTOR (Oral Pill)",
            "Crestor",
            "Crestor (Oral)",
            "crestor",
            "crestor (oral pill)",
            "crestor (oral)",
            "rosuvastatin calcium 10 MG Oral Tablet",
            "rosuvastatin calcium 10 mg oral tablet",
            "rosuvastatin calcium 20 MG Oral Tablet",
            "rosuvastatin calcium 20 mg oral tablet",
            "rosuvastatin calcium 40 MG Oral Tablet",
            "rosuvastatin calcium 40 mg oral tablet",
            "rosuvastatin calcium 5 MG Oral Tablet",
            "rosuvastatin calcium 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "30%"
            },
            {
                "value": "40 mg",
                "pct": "25%"
            },
            {
                "value": "20 mg",
                "pct": "24%"
            },
            {
                "value": "5 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            },
            {
                "value": "At bedtime",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "43%"
            }
        ]
    },
    {
        "name": "BASAGLAR",
        "route": "Injectable",
        "fullName": "BASAGLAR (Injectable)",
        "totalCount": 211,
        "searchTerms": [
            "3 ML insulin glargine 100 UNT/ML Pen Injector",
            "3 ml insulin glargine 100 unt/ml pen injector",
            "BASAGLAR",
            "BASAGLAR (Injectable)",
            "Lantus",
            "Sensor 3 ML insulin glargine 100 UNT/ML Pen Injector",
            "basaglar",
            "basaglar (injectable)",
            "lantus",
            "sensor 3 ml insulin glargine 100 unt/ml pen injector"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "At bedtime",
                "pct": "26%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "52%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "FLUoxetine",
        "route": "Oral Pill",
        "fullName": "FLUoxetine (Oral Pill)",
        "totalCount": 210,
        "searchTerms": [
            "FLUOXETINE",
            "FLUoxetine",
            "FLUoxetine (Oral Pill)",
            "FLUoxetine (Oral)",
            "Fluoxetine",
            "Fluoxetine (Oral)",
            "PROZAC",
            "PROzac",
            "Prozac",
            "Prozac 10 mg Cap",
            "fluOXETINE",
            "fluOXETINE (Oral)",
            "fluoxetine",
            "fluoxetine (oral pill)",
            "fluoxetine (oral)",
            "fluoxetine 10 MG Oral Capsule",
            "fluoxetine 10 MG Oral Tablet",
            "fluoxetine 10 mg oral capsule",
            "fluoxetine 10 mg oral tablet",
            "fluoxetine 20 MG Oral Capsule",
            "fluoxetine 20 MG Oral Tablet",
            "fluoxetine 20 mg oral capsule",
            "fluoxetine 20 mg oral tablet",
            "fluoxetine 40 MG Oral Capsule",
            "fluoxetine 40 mg oral capsule",
            "fluoxetine 60 MG Oral Tablet",
            "fluoxetine 60 mg oral tablet",
            "fluoxetine 90 MG Delayed Release Oral Capsule",
            "fluoxetine 90 mg delayed release oral capsule",
            "prozac",
            "prozac 10 mg cap"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "38%"
            },
            {
                "value": "20 mg",
                "pct": "37%"
            },
            {
                "value": "10 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "61%"
            },
            {
                "code": "F33",
                "description": "Major depressive disorder, recurrent",
                "pct": "10%"
            }
        ]
    },
    {
        "name": "Pravastatin",
        "route": "Oral Pill",
        "fullName": "Pravastatin (Oral Pill)",
        "totalCount": 209,
        "searchTerms": [
            "PRAVACHOL",
            "PRAVASTATIN",
            "Pravastatin",
            "Pravastatin (Oral Pill)",
            "Pravastatin (Oral)",
            "pravachol",
            "pravastatin",
            "pravastatin (oral pill)",
            "pravastatin (oral)",
            "pravastatin sodium 10 MG Oral Tablet",
            "pravastatin sodium 10 mg oral tablet",
            "pravastatin sodium 20 MG Oral Tablet",
            "pravastatin sodium 20 mg oral tablet",
            "pravastatin sodium 40 MG Oral Tablet",
            "pravastatin sodium 40 mg oral tablet",
            "pravastatin sodium 80 MG Oral Tablet",
            "pravastatin sodium 80 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "42%"
            },
            {
                "value": "20 mg",
                "pct": "33%"
            },
            {
                "value": "10 mg",
                "pct": "15%"
            },
            {
                "value": "80 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "64%"
            }
        ]
    },
    {
        "name": "ARIPiprazole",
        "route": "Oral Pill",
        "fullName": "ARIPiprazole (Oral Pill)",
        "totalCount": 208,
        "searchTerms": [
            "ABILIFY",
            "ARIPIPRAZOLE",
            "ARIPiprazole",
            "ARIPiprazole (Oral Pill)",
            "ARIPiprazole (Oral)",
            "Abilify",
            "Aripiprazole",
            "Aripiprazole (Oral)",
            "Sensor aripiprazole 10 MG Oral Tablet",
            "Sensor aripiprazole 15 MG Oral Tablet",
            "Sensor aripiprazole 2 MG Oral Tablet",
            "Sensor aripiprazole 20 MG Oral Tablet",
            "Sensor aripiprazole 30 MG Oral Tablet",
            "Sensor aripiprazole 5 MG Oral Tablet",
            "abilify",
            "aripiprazole",
            "aripiprazole (oral pill)",
            "aripiprazole (oral)",
            "sensor aripiprazole 10 mg oral tablet",
            "sensor aripiprazole 15 mg oral tablet",
            "sensor aripiprazole 2 mg oral tablet",
            "sensor aripiprazole 20 mg oral tablet",
            "sensor aripiprazole 30 mg oral tablet",
            "sensor aripiprazole 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "27%"
            },
            {
                "value": "5 mg",
                "pct": "22%"
            },
            {
                "value": "2 mg",
                "pct": "22%"
            },
            {
                "value": "15 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "34%"
            },
            {
                "code": "F31.9",
                "description": "Bipolar disorder, unspecified",
                "pct": "20%"
            },
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "Multivitamin",
        "route": "Oral Pill",
        "fullName": "Multivitamin (Oral Pill)",
        "totalCount": 207,
        "searchTerms": [
            "MULTIVITAMIN",
            "Multivitamin",
            "Multivitamin (Oral)",
            "multivitamin",
            "multivitamin (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FLOMAX",
        "route": "Oral Pill",
        "fullName": "FLOMAX (Oral Pill)",
        "totalCount": 205,
        "searchTerms": [
            "FLOMAX",
            "FLOMAX (Oral Pill)",
            "Flomax",
            "flomax",
            "flomax (oral pill)",
            "tamsulosin hydrochloride 0.4 MG Oral Capsule",
            "tamsulosin hydrochloride 0.4 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "0.4 mg",
                "pct": "99%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "72%"
            },
            {
                "value": "At bedtime",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N40.1",
                "description": "Enlarged prostate with lower urinary tract symptoms",
                "pct": "31%"
            },
            {
                "code": "N40",
                "description": "Enlarged prostate",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "PROTONIX",
        "route": "Oral Pill",
        "fullName": "PROTONIX (Oral Pill)",
        "totalCount": 204,
        "searchTerms": [
            "PROTONIX",
            "PROTONIX (Oral Pill)",
            "pantoprazole 20 MG Delayed Release Oral Tablet",
            "pantoprazole 20 mg delayed release oral tablet",
            "pantoprazole 40 MG Delayed Release Oral Tablet",
            "pantoprazole 40 mg delayed release oral tablet",
            "protonix",
            "protonix (oral pill)"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "89%"
            },
            {
                "value": "20 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "38%"
            }
        ]
    },
    {
        "name": "Glimepiride",
        "route": "Oral Pill",
        "fullName": "Glimepiride (Oral Pill)",
        "totalCount": 202,
        "searchTerms": [
            "Amaryl",
            "GLIMEPIRIDE",
            "Glimepiride",
            "Glimepiride (Oral Pill)",
            "Glimepiride (Oral)",
            "amaryl",
            "glimepiride",
            "glimepiride (oral pill)",
            "glimepiride (oral)",
            "glimepiride 1 MG Oral Tablet",
            "glimepiride 1 mg oral tablet",
            "glimepiride 2 MG Oral Tablet",
            "glimepiride 2 mg oral tablet",
            "glimepiride 3 MG Oral Tablet",
            "glimepiride 3 mg oral tablet",
            "glimepiride 4 MG Oral Tablet",
            "glimepiride 4 mg oral tablet",
            "glimepiride 6 MG Oral Tablet",
            "glimepiride 6 mg oral tablet",
            "glimepiride 8 MG Oral Tablet",
            "glimepiride 8 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "35%"
            },
            {
                "value": "2 mg",
                "pct": "34%"
            },
            {
                "value": "1 mg",
                "pct": "24%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "68%"
            },
            {
                "value": "Twice daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "70%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "risperiDONE",
        "route": "Oral Pill",
        "fullName": "risperiDONE (Oral Pill)",
        "totalCount": 202,
        "searchTerms": [
            "RISPERDAL",
            "RISPERIDONE",
            "RisperDAL",
            "Risperdal",
            "Risperidone",
            "Risperidone (Oral)",
            "risperdal",
            "risperiDONE",
            "risperiDONE (Oral Pill)",
            "risperiDONE (Oral)",
            "risperidone",
            "risperidone (Oral)",
            "risperidone (oral pill)",
            "risperidone (oral)",
            "risperidone 0.25 MG Oral Tablet",
            "risperidone 0.25 mg oral tablet",
            "risperidone 0.5 MG Oral Tablet",
            "risperidone 0.5 mg oral tablet",
            "risperidone 1 MG Oral Tablet",
            "risperidone 1 mg oral tablet",
            "risperidone 2 MG Oral Tablet",
            "risperidone 2 mg oral tablet",
            "risperidone 3 MG Oral Tablet",
            "risperidone 3 mg oral tablet",
            "risperidone 4 MG Oral Tablet",
            "risperidone 4 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "26%"
            },
            {
                "value": "0.5 mg",
                "pct": "20%"
            },
            {
                "value": "2 mg",
                "pct": "18%"
            },
            {
                "value": "3 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "54%"
            },
            {
                "value": "Twice daily",
                "pct": "22%"
            },
            {
                "value": "At bedtime",
                "pct": "17%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "41%"
            },
            {
                "code": "F31.9",
                "description": "Bipolar disorder, unspecified",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "DEXILANT",
        "route": "Oral Pill",
        "fullName": "DEXILANT (Oral Pill)",
        "totalCount": 201,
        "searchTerms": [
            "DEXILANT",
            "DEXILANT (Oral Pill)",
            "Dexilant",
            "Dexilant (Oral)",
            "dexilant",
            "dexilant (oral pill)",
            "dexilant (oral)",
            "dexlansoprazole 30 MG Delayed Release Oral Capsule",
            "dexlansoprazole 30 mg delayed release oral capsule",
            "dexlansoprazole 60 MG Delayed Release Oral Capsule",
            "dexlansoprazole 60 mg delayed release oral capsule"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "90%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "TRULICITY",
        "route": "Injectable",
        "fullName": "TRULICITY (Injectable)",
        "totalCount": 196,
        "searchTerms": [
            "0.5 ML dulaglutide 1.5 MG/ML Auto-Injector",
            "0.5 ML dulaglutide 3 MG/ML Auto-Injector",
            "0.5 ml dulaglutide 1.5 mg/ml auto-injector",
            "0.5 ml dulaglutide 3 mg/ml auto-injector",
            "TRULICITY",
            "TRULICITY (Injectable)",
            "trulicity",
            "trulicity (injectable)"
        ],
        "dosages": [
            {
                "value": "1.5 mg",
                "pct": "60%"
            },
            {
                "value": "3 mg",
                "pct": "16%"
            },
            {
                "value": "0.75 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "77%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rotate injection sites",
                "pct": "14%"
            },
            {
                "value": "Do not share pens",
                "pct": "10%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "64%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "17%"
            }
        ]
    },
    {
        "name": "Pregabalin",
        "route": "Oral Pill",
        "fullName": "Pregabalin (Oral Pill)",
        "totalCount": 194,
        "searchTerms": [
            "Lyrica",
            "PREGABALIN",
            "PREGABALIN (Oral)",
            "Pregabalin",
            "Pregabalin (Oral Pill)",
            "Pregabalin (Oral)",
            "lyrica",
            "pregabalin",
            "pregabalin (Oral)",
            "pregabalin (oral pill)",
            "pregabalin (oral)",
            "pregabalin 100 MG Oral Capsule",
            "pregabalin 100 mg oral capsule",
            "pregabalin 150 MG Oral Capsule",
            "pregabalin 150 mg oral capsule",
            "pregabalin 200 MG Oral Capsule",
            "pregabalin 200 mg oral capsule",
            "pregabalin 25 MG Oral Capsule",
            "pregabalin 25 mg oral capsule",
            "pregabalin 300 MG Oral Capsule",
            "pregabalin 300 mg oral capsule",
            "pregabalin 50 MG Oral Capsule",
            "pregabalin 50 mg oral capsule",
            "pregabalin 75 MG Oral Capsule",
            "pregabalin 75 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "75 mg",
                "pct": "20%"
            },
            {
                "value": "150 mg",
                "pct": "17%"
            },
            {
                "value": "100 mg",
                "pct": "17%"
            },
            {
                "value": "50 mg",
                "pct": "16%"
            },
            {
                "value": "25 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "45%"
            },
            {
                "value": "Once daily",
                "pct": "23%"
            },
            {
                "value": "Three times daily",
                "pct": "16%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M79.7",
                "description": "Fibromyalgia",
                "pct": "22%"
            },
            {
                "code": "B02.29",
                "description": "Other postherpetic nervous system involvement",
                "pct": "21%"
            },
            {
                "code": "E11.40",
                "description": "Type 2 diabetes mellitus with diabetic neuropathy, unsp",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "Naproxen",
        "route": "Oral Pill",
        "fullName": "Naproxen (Oral Pill)",
        "totalCount": 193,
        "searchTerms": [
            "NAPROSYN",
            "NAPROXEN",
            "NAPROXEN (Oral)",
            "Naprosyn",
            "Naproxen",
            "Naproxen (Oral Pill)",
            "Naproxen (Oral)",
            "Naproxen 500 mg Tablet",
            "naprosyn",
            "naproxen",
            "naproxen (Oral)",
            "naproxen (oral pill)",
            "naproxen (oral)",
            "naproxen 250 MG Oral Tablet",
            "naproxen 250 mg oral tablet",
            "naproxen 500 MG Oral Tablet",
            "naproxen 500 mg oral tablet",
            "naproxen 500 mg tablet",
            "naproxen sodium 220 MG Oral Capsule",
            "naproxen sodium 220 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "73%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "48%"
            },
            {
                "value": "As needed",
                "pct": "23%"
            },
            {
                "value": "Once daily",
                "pct": "17%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "49%"
            },
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "TRELEGY",
        "route": "Inhalant",
        "fullName": "TRELEGY (Inhalant)",
        "totalCount": 192,
        "searchTerms": [
            "14 ACTUAT fluticasone furoate 0.1 MG/ACTUAT / umeclidinium 0.0625 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "14 actuat fluticasone furoate 0.1 mg/actuat / umeclidinium 0.0625 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "30 ACTUAT fluticasone furoate 0.1 MG/ACTUAT / umeclidinium 0.0625 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "30 actuat fluticasone furoate 0.1 mg/actuat / umeclidinium 0.0625 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "TRELEGY",
            "TRELEGY (Inhalant)",
            "Trelegy",
            "trelegy",
            "trelegy (inhalant)"
        ],
        "dosages": [
            {
                "value": "100-62.5-25 mcg",
                "pct": "69%"
            },
            {
                "value": "200-62.5-25 mcg",
                "pct": "27%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rinse mouth after inhaled corticosteroid",
                "pct": "11%"
            }
        ],
        "diagnoses": [
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "45%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "Valsartan",
        "route": "Oral Pill",
        "fullName": "Valsartan (Oral Pill)",
        "totalCount": 184,
        "searchTerms": [
            "Diovan",
            "VALSARTAN",
            "VALSARTAN (Oral)",
            "Valsartan",
            "Valsartan (Oral Pill)",
            "Valsartan (Oral)",
            "diovan",
            "valsartan",
            "valsartan (oral pill)",
            "valsartan (oral)",
            "valsartan 160 MG Oral Tablet",
            "valsartan 160 mg oral tablet",
            "valsartan 320 MG Oral Tablet",
            "valsartan 320 mg oral tablet",
            "valsartan 40 MG Oral Tablet",
            "valsartan 40 mg oral tablet",
            "valsartan 80 MG Oral Tablet",
            "valsartan 80 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "160 mg",
                "pct": "35%"
            },
            {
                "value": "320 mg",
                "pct": "23%"
            },
            {
                "value": "80 mg",
                "pct": "22%"
            },
            {
                "value": "40 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "77%"
            }
        ]
    },
    {
        "name": "Zolpidem",
        "route": "Sublingual",
        "fullName": "Zolpidem (Sublingual)",
        "totalCount": 183,
        "searchTerms": [
            "ZOLPIDEM",
            "Zolpidem",
            "Zolpidem (Sublingual)",
            "zolpidem",
            "zolpidem (sublingual)",
            "zolpidem tartrate 1.75 MG Sublingual Tablet",
            "zolpidem tartrate 1.75 mg sublingual tablet",
            "zolpidem tartrate 10 MG Sublingual Tablet",
            "zolpidem tartrate 10 mg sublingual tablet",
            "zolpidem tartrate 3.5 MG Sublingual Tablet",
            "zolpidem tartrate 3.5 mg sublingual tablet",
            "zolpidem tartrate 5 MG Sublingual Tablet",
            "zolpidem tartrate 5 mg sublingual tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "57%"
            },
            {
                "value": "5 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "53%"
            },
            {
                "value": "At bedtime",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "tiZANidine",
        "route": "Oral Pill",
        "fullName": "tiZANidine (Oral Pill)",
        "totalCount": 182,
        "searchTerms": [
            "TIZANIDINE",
            "Tizanidine",
            "Tizanidine (Oral)",
            "Zanaflex",
            "tiZANidine",
            "tiZANidine (Oral Pill)",
            "tiZANidine (Oral)",
            "tizanidine",
            "tizanidine (Oral)",
            "tizanidine (oral pill)",
            "tizanidine (oral)",
            "tizanidine 2 MG Oral Capsule",
            "tizanidine 2 MG Oral Tablet",
            "tizanidine 2 mg oral capsule",
            "tizanidine 2 mg oral tablet",
            "tizanidine 4 MG Oral Capsule",
            "tizanidine 4 MG Oral Tablet",
            "tizanidine 4 mg oral capsule",
            "tizanidine 4 mg oral tablet",
            "zanaflex"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "57%"
            },
            {
                "value": "2 mg",
                "pct": "41%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "30%"
            },
            {
                "value": "As needed",
                "pct": "19%"
            },
            {
                "value": "Three times daily",
                "pct": "15%"
            },
            {
                "value": "Twice daily",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M62.838",
                "description": "Other muscle spasm",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "PriLOSEC",
        "route": "Oral Pill",
        "fullName": "PriLOSEC (Oral Pill)",
        "totalCount": 175,
        "searchTerms": [
            "PRILOSEC",
            "PriLOSEC",
            "PriLOSEC (Oral Pill)",
            "omeprazole 10 MG Delayed Release Oral Capsule",
            "omeprazole 10 mg delayed release oral capsule",
            "omeprazole 20 MG Delayed Release Oral Capsule",
            "omeprazole 20 MG Delayed Release Oral Tablet",
            "omeprazole 20 mg delayed release oral capsule",
            "omeprazole 20 mg delayed release oral tablet",
            "omeprazole 40 MG Delayed Release Oral Capsule",
            "omeprazole 40 mg delayed release oral capsule",
            "prilosec",
            "prilosec (oral pill)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "66%"
            },
            {
                "value": "40 mg",
                "pct": "34%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "40%"
            }
        ]
    },
    {
        "name": "Celecoxib",
        "route": "Oral Pill",
        "fullName": "Celecoxib (Oral Pill)",
        "totalCount": 175,
        "searchTerms": [
            "CELECOXIB",
            "CeleBREX",
            "Celebrex",
            "Celecoxib",
            "Celecoxib (Oral Pill)",
            "Celecoxib (Oral)",
            "celebrex",
            "celecoxib",
            "celecoxib (Oral)",
            "celecoxib (oral pill)",
            "celecoxib (oral)",
            "celecoxib 100 MG Oral Capsule",
            "celecoxib 100 mg oral capsule",
            "celecoxib 200 MG Oral Capsule",
            "celecoxib 200 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "78%"
            },
            {
                "value": "100 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "60%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "59%"
            }
        ]
    },
    {
        "name": "Zolpidem",
        "route": "Oral Pill",
        "fullName": "Zolpidem (Oral Pill)",
        "totalCount": 175,
        "searchTerms": [
            "Ambien",
            "ZOLPIDEM",
            "ZOLPIDEM (Oral)",
            "Zolpidem",
            "Zolpidem (Oral Pill)",
            "Zolpidem (Oral)",
            "ambien",
            "zolpidem",
            "zolpidem (Oral)",
            "zolpidem (oral pill)",
            "zolpidem (oral)",
            "zolpidem tartrate 10 MG Oral Tablet",
            "zolpidem tartrate 10 mg oral tablet",
            "zolpidem tartrate 5 MG Oral Tablet",
            "zolpidem tartrate 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "67%"
            },
            {
                "value": "5 mg",
                "pct": "30%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "49%"
            },
            {
                "value": "At bedtime",
                "pct": "46%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "72%"
            }
        ]
    },
    {
        "name": "Fenofibrate",
        "route": "Oral Pill",
        "fullName": "Fenofibrate (Oral Pill)",
        "totalCount": 174,
        "searchTerms": [
            "FENOFIBRATE",
            "FENOFIBRATE (Oral)",
            "Fenofibrate",
            "Fenofibrate (Oral Pill)",
            "Fenofibrate (Oral)",
            "Lofibra",
            "Tricor",
            "fenofibrate",
            "fenofibrate (oral pill)",
            "fenofibrate (oral)",
            "fenofibrate 134 MG Oral Capsule",
            "fenofibrate 134 mg oral capsule",
            "fenofibrate 145 MG Oral Tablet",
            "fenofibrate 145 mg oral tablet",
            "fenofibrate 160 MG Oral Tablet",
            "fenofibrate 160 mg oral tablet",
            "fenofibrate 200 MG Oral Capsule",
            "fenofibrate 200 mg oral capsule",
            "fenofibrate 30 MG Oral Capsule",
            "fenofibrate 30 mg oral capsule",
            "fenofibrate 43 MG Oral Capsule",
            "fenofibrate 43 mg oral capsule",
            "fenofibrate 48 MG Oral Tablet",
            "fenofibrate 48 mg oral tablet",
            "fenofibrate 50 MG Oral Tablet",
            "fenofibrate 50 mg oral tablet",
            "fenofibrate 54 MG Oral Tablet",
            "fenofibrate 54 mg oral tablet",
            "fenofibrate 67 MG Oral Capsule",
            "fenofibrate 67 mg oral capsule",
            "fenofibrate 90 MG Oral Capsule",
            "fenofibrate 90 mg oral capsule",
            "fenofibric acid 135 MG Delayed Release Oral Capsule",
            "fenofibric acid 135 mg delayed release oral capsule",
            "fenofibric acid 35 MG Oral Tablet",
            "fenofibric acid 35 mg oral tablet",
            "lofibra",
            "tricor"
        ],
        "dosages": [
            {
                "value": "145 mg",
                "pct": "32%"
            },
            {
                "value": "160 mg",
                "pct": "16%"
            },
            {
                "value": "48 mg",
                "pct": "16%"
            },
            {
                "value": "134 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.1",
                "description": "Pure hyperglyceridemia",
                "pct": "43%"
            },
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "levETIRAcetam",
        "route": "Oral Pill",
        "fullName": "levETIRAcetam (Oral Pill)",
        "totalCount": 172,
        "searchTerms": [
            "KEPPRA",
            "Keppra",
            "LEVETIRACETAM",
            "LEVETIRACETAM (Oral)",
            "Levetiracetam",
            "Levetiracetam (Oral)",
            "keppra",
            "levETIRAceTam",
            "levETIRAceTam (Oral)",
            "levETIRAcetam",
            "levETIRAcetam (Oral Pill)",
            "levETIRAcetam (Oral)",
            "levetiracetam",
            "levetiracetam (oral pill)",
            "levetiracetam (oral)",
            "levetiracetam 1000 MG Oral Tablet",
            "levetiracetam 1000 mg oral tablet",
            "levetiracetam 500 MG Oral Tablet",
            "levetiracetam 500 mg oral tablet",
            "levetiracetam 750 MG Oral Tablet",
            "levetiracetam 750 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "40%"
            },
            {
                "value": "750 mg",
                "pct": "29%"
            },
            {
                "value": "250 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "73%"
            },
            {
                "value": "Every 12 hours",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "73%"
            }
        ]
    },
    {
        "name": "ZOLOFT",
        "route": "Oral Pill",
        "fullName": "ZOLOFT (Oral Pill)",
        "totalCount": 171,
        "searchTerms": [
            "ZOLOFT",
            "ZOLOFT (Oral Pill)",
            "Zoloft",
            "Zoloft (Oral)",
            "sertraline 100 MG Oral Tablet",
            "sertraline 100 mg oral tablet",
            "sertraline 25 MG Oral Tablet",
            "sertraline 25 mg oral tablet",
            "sertraline 50 MG Oral Tablet",
            "sertraline 50 mg oral tablet",
            "zoloft",
            "zoloft (oral pill)",
            "zoloft (oral)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "34%"
            },
            {
                "value": "50 mg",
                "pct": "33%"
            },
            {
                "value": "25 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "32%"
            }
        ]
    },
    {
        "name": "Olmesartan",
        "route": "Oral Pill",
        "fullName": "Olmesartan (Oral Pill)",
        "totalCount": 171,
        "searchTerms": [
            "BENICAR",
            "Benicar",
            "OLMESARTAN",
            "OLMESARTAN (Oral)",
            "Olmesartan",
            "Olmesartan (Oral Pill)",
            "Olmesartan (Oral)",
            "benicar",
            "olmesartan",
            "olmesartan (oral pill)",
            "olmesartan (oral)",
            "olmesartan medoxomil 20 MG Oral Tablet",
            "olmesartan medoxomil 20 mg oral tablet",
            "olmesartan medoxomil 40 MG Oral Tablet",
            "olmesartan medoxomil 40 mg oral tablet",
            "olmesartan medoxomil 5 MG Oral Tablet",
            "olmesartan medoxomil 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "49%"
            },
            {
                "value": "20 mg",
                "pct": "37%"
            },
            {
                "value": "5 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "80%"
            }
        ]
    },
    {
        "name": "Magnesium oxide",
        "route": "Oral Pill",
        "fullName": "Magnesium oxide (Oral Pill)",
        "totalCount": 171,
        "searchTerms": [
            "MAG-OX 400",
            "MAGNESIUM OXIDE",
            "Mag-Ox",
            "Magnesium Oxide",
            "Magnesium Oxide (Oral)",
            "Magnesium oxide",
            "Magnesium oxide (Oral Pill)",
            "mag-ox",
            "mag-ox 400",
            "magnesium oxide",
            "magnesium oxide (oral pill)",
            "magnesium oxide (oral)",
            "magnesium oxide 140 MG Oral Capsule",
            "magnesium oxide 140 mg oral capsule",
            "magnesium oxide 250 MG Oral Tablet",
            "magnesium oxide 250 mg oral tablet",
            "magnesium oxide 400 MG Oral Capsule",
            "magnesium oxide 400 MG Oral Tablet",
            "magnesium oxide 400 mg oral capsule",
            "magnesium oxide 400 mg oral tablet",
            "magnesium oxide 420 MG Oral Tablet",
            "magnesium oxide 420 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "84%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "77%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E83.42",
                "description": "Hypomagnesemia",
                "pct": "32%"
            },
            {
                "code": "E61.2",
                "description": "Magnesium deficiency",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "traMADol XR",
        "route": "Oral Pill",
        "fullName": "traMADol XR (Oral Pill)",
        "totalCount": 170,
        "searchTerms": [
            "24 HR tramadol hydrochloride 100 MG Extended Release Oral Capsule",
            "24 HR tramadol hydrochloride 150 MG Extended Release Oral Capsule",
            "24 HR tramadol hydrochloride 200 MG Extended Release Oral Capsule",
            "24 HR tramadol hydrochloride 300 MG Extended Release Oral Capsule",
            "24 hr tramadol hydrochloride 100 mg extended release oral capsule",
            "24 hr tramadol hydrochloride 150 mg extended release oral capsule",
            "24 hr tramadol hydrochloride 200 mg extended release oral capsule",
            "24 hr tramadol hydrochloride 300 mg extended release oral capsule",
            "Matrix Delivery 24 HR tramadol hydrochloride 100 MG Extended Release Oral Tablet",
            "Matrix Delivery 24 HR tramadol hydrochloride 200 MG Extended Release Oral Tablet",
            "Matrix Delivery 24 HR tramadol hydrochloride 300 MG Extended Release Oral Tablet",
            "matrix delivery 24 hr tramadol hydrochloride 100 mg extended release oral tablet",
            "matrix delivery 24 hr tramadol hydrochloride 200 mg extended release oral tablet",
            "matrix delivery 24 hr tramadol hydrochloride 300 mg extended release oral tablet",
            "traMADol XR",
            "traMADol XR (Oral Pill)",
            "tramadol xr",
            "tramadol xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "74%"
            },
            {
                "value": "100 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "30%"
            },
            {
                "value": "Once daily",
                "pct": "23%"
            },
            {
                "value": "Twice daily",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Chlorthalidone",
        "route": "Oral Pill",
        "fullName": "Chlorthalidone (Oral Pill)",
        "totalCount": 168,
        "searchTerms": [
            "Chlorthalidone",
            "Chlorthalidone (Oral Pill)",
            "Chlorthalidone (Oral)",
            "Thalitone",
            "chlorthalidone",
            "chlorthalidone (Oral)",
            "chlorthalidone (oral pill)",
            "chlorthalidone (oral)",
            "chlorthalidone 25 MG Oral Tablet",
            "chlorthalidone 25 mg oral tablet",
            "chlorthalidone 50 MG Oral Tablet",
            "chlorthalidone 50 mg oral tablet",
            "thalitone"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "85%"
            },
            {
                "value": "50 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "Oxybutynin XR",
        "route": "Oral Pill",
        "fullName": "Oxybutynin XR (Oral Pill)",
        "totalCount": 166,
        "searchTerms": [
            "24 HR oxybutynin chloride 10 MG Extended Release Oral Tablet",
            "24 HR oxybutynin chloride 15 MG Extended Release Oral Tablet",
            "24 HR oxybutynin chloride 5 MG Extended Release Oral Tablet",
            "24 hr oxybutynin chloride 10 mg extended release oral tablet",
            "24 hr oxybutynin chloride 15 mg extended release oral tablet",
            "24 hr oxybutynin chloride 5 mg extended release oral tablet",
            "Oxybutynin XR",
            "Oxybutynin XR (Oral Pill)",
            "oxyBUTYnin XR",
            "oxyBUTYnin XR (Oral Pill)",
            "oxybutynin xr",
            "oxybutynin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "54%"
            },
            {
                "value": "10 mg",
                "pct": "31%"
            },
            {
                "value": "15 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [
            {
                "value": "Do not crush extended-release tablets",
                "pct": "12%"
            }
        ],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "53%"
            }
        ]
    },
    {
        "name": "ADVAIR",
        "route": "Inhalant",
        "fullName": "ADVAIR (Inhalant)",
        "totalCount": 161,
        "searchTerms": [
            "120 ACTUAT fluticasone propionate 0.045 MG/ACTUAT / salmeterol 0.021 MG/ACTUAT Metered Dose Inhaler",
            "120 ACTUAT fluticasone propionate 0.115 MG/ACTUAT / salmeterol 0.021 MG/ACTUAT Metered Dose Inhaler",
            "120 actuat fluticasone propionate 0.045 mg/actuat / salmeterol 0.021 mg/actuat metered dose inhaler",
            "120 actuat fluticasone propionate 0.115 mg/actuat / salmeterol 0.021 mg/actuat metered dose inhaler",
            "14 ACTUAT fluticasone propionate 0.1 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "14 ACTUAT fluticasone propionate 0.25 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "14 ACTUAT fluticasone propionate 0.5 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "14 actuat fluticasone propionate 0.1 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "14 actuat fluticasone propionate 0.25 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "14 actuat fluticasone propionate 0.5 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "60 ACTUAT fluticasone propionate 0.045 MG/ACTUAT / salmeterol 0.021 MG/ACTUAT Metered Dose Inhaler",
            "60 ACTUAT fluticasone propionate 0.1 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "60 ACTUAT fluticasone propionate 0.115 MG/ACTUAT / salmeterol 0.021 MG/ACTUAT Metered Dose Inhaler",
            "60 ACTUAT fluticasone propionate 0.23 MG/ACTUAT / salmeterol 0.021 MG/ACTUAT Metered Dose Inhaler",
            "60 ACTUAT fluticasone propionate 0.25 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "60 ACTUAT fluticasone propionate 0.5 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "60 actuat fluticasone propionate 0.045 mg/actuat / salmeterol 0.021 mg/actuat metered dose inhaler",
            "60 actuat fluticasone propionate 0.1 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "60 actuat fluticasone propionate 0.115 mg/actuat / salmeterol 0.021 mg/actuat metered dose inhaler",
            "60 actuat fluticasone propionate 0.23 mg/actuat / salmeterol 0.021 mg/actuat metered dose inhaler",
            "60 actuat fluticasone propionate 0.25 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "60 actuat fluticasone propionate 0.5 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "ADVAIR",
            "ADVAIR (Inhalant)",
            "advair",
            "advair (inhalant)"
        ],
        "dosages": [
            {
                "value": "250-50 mcg",
                "pct": "42%"
            },
            {
                "value": "100-50 mcg",
                "pct": "24%"
            },
            {
                "value": "500-50 mcg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "52%"
            },
            {
                "value": "Once daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "38%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "25%"
            }
        ]
    },
    {
        "name": "ALPRAZolam",
        "route": "Oral Pill",
        "fullName": "ALPRAZolam (Oral Pill)",
        "totalCount": 160,
        "searchTerms": [
            "ALPRAZOLAM",
            "ALPRAZOLAM (Oral)",
            "ALPRAZolam",
            "ALPRAZolam (Oral Pill)",
            "ALPRAZolam (Oral)",
            "Alprazolam",
            "Alprazolam (Oral)",
            "XANAX",
            "Xanax",
            "alprazolam",
            "alprazolam (oral pill)",
            "alprazolam (oral)",
            "alprazolam 0.25 MG Oral Tablet",
            "alprazolam 0.25 mg oral tablet",
            "alprazolam 0.5 MG Oral Tablet",
            "alprazolam 0.5 mg oral tablet",
            "alprazolam 1 MG Oral Tablet",
            "alprazolam 1 mg oral tablet",
            "alprazolam 2 MG Oral Tablet",
            "alprazolam 2 mg oral tablet",
            "xanax"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "32%"
            },
            {
                "value": "0.25 mg",
                "pct": "28%"
            },
            {
                "value": "1 mg",
                "pct": "26%"
            },
            {
                "value": "2 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "33%"
            },
            {
                "value": "Twice daily",
                "pct": "24%"
            },
            {
                "value": "As needed",
                "pct": "13%"
            },
            {
                "value": "Three times daily",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "74%"
            }
        ]
    },
    {
        "name": "VOLTAREN",
        "route": "Topical",
        "fullName": "VOLTAREN (Topical)",
        "totalCount": 160,
        "searchTerms": [
            "VOLTAREN",
            "VOLTAREN (Topical)",
            "Voltaren",
            "diclofenac sodium 0.01 MG/MG Topical Gel",
            "diclofenac sodium 0.01 mg/mg topical gel",
            "voltaren",
            "voltaren (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "39%"
            },
            {
                "value": "Twice daily",
                "pct": "26%"
            },
            {
                "value": "Four times daily",
                "pct": "11%"
            },
            {
                "value": "As needed",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LEXAPRO",
        "route": "Oral Pill",
        "fullName": "LEXAPRO (Oral Pill)",
        "totalCount": 158,
        "searchTerms": [
            "LEXAPRO",
            "LEXAPRO (Oral Pill)",
            "Lexapro",
            "Lexapro (Oral)",
            "escitalopram 10 MG Oral Tablet",
            "escitalopram 10 mg oral tablet",
            "escitalopram 20 MG Oral Tablet",
            "escitalopram 20 mg oral tablet",
            "escitalopram 5 MG Oral Tablet",
            "escitalopram 5 mg oral tablet",
            "lexapro",
            "lexapro (oral pill)",
            "lexapro (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "47%"
            },
            {
                "value": "20 mg",
                "pct": "31%"
            },
            {
                "value": "5 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.1",
                "description": "Generalized anxiety disorder",
                "pct": "27%"
            },
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "Benzonatate",
        "route": "Oral Pill",
        "fullName": "Benzonatate (Oral Pill)",
        "totalCount": 155,
        "searchTerms": [
            "BENZONATATE",
            "BENZONATATE (Oral)",
            "Benzonatate",
            "Benzonatate (Oral Pill)",
            "Benzonatate (Oral)",
            "TESSALON PERLES",
            "Tessalon",
            "Tessalon Perles",
            "benzonatate",
            "benzonatate (Oral)",
            "benzonatate (oral pill)",
            "benzonatate (oral)",
            "benzonatate 100 MG Oral Capsule",
            "benzonatate 100 mg oral capsule",
            "benzonatate 150 MG Oral Capsule",
            "benzonatate 150 mg oral capsule",
            "benzonatate 200 MG Oral Capsule",
            "benzonatate 200 mg oral capsule",
            "tessalon",
            "tessalon perles"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "64%"
            },
            {
                "value": "200 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "57%"
            },
            {
                "value": "As needed",
                "pct": "12%"
            },
            {
                "value": "Once daily",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R05.9",
                "description": "Cough, unspecified",
                "pct": "66%"
            },
            {
                "code": "R05",
                "description": "Cough",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "TRADJENTA",
        "route": "Oral Pill",
        "fullName": "TRADJENTA (Oral Pill)",
        "totalCount": 153,
        "searchTerms": [
            "TRADJENTA",
            "TRADJENTA (Oral Pill)",
            "TRADJENTA (Oral)",
            "Tradjenta",
            "Tradjenta (Oral)",
            "linagliptin 5 MG Oral Tablet",
            "linagliptin 5 mg oral tablet",
            "tradjenta",
            "tradjenta (oral pill)",
            "tradjenta (oral)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "74%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "MYRBETRIQ XR",
        "route": "Oral Pill",
        "fullName": "MYRBETRIQ XR (Oral Pill)",
        "totalCount": 152,
        "searchTerms": [
            "24 HR mirabegron 25 MG Extended Release Oral Tablet",
            "24 HR mirabegron 50 MG Extended Release Oral Tablet",
            "24 hr mirabegron 25 mg extended release oral tablet",
            "24 hr mirabegron 50 mg extended release oral tablet",
            "MYRBETRIQ",
            "MYRBETRIQ XR",
            "MYRBETRIQ XR (Oral Pill)",
            "myrbetriq",
            "myrbetriq xr",
            "myrbetriq xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "52%"
            },
            {
                "value": "50 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "44%"
            }
        ]
    },
    {
        "name": "Labetalol",
        "route": "Oral Pill",
        "fullName": "Labetalol (Oral Pill)",
        "totalCount": 149,
        "searchTerms": [
            "Labetalol",
            "Labetalol (Oral Pill)",
            "Labetalol (Oral)",
            "Normodyne",
            "Trandate",
            "labetalol",
            "labetalol (Oral)",
            "labetalol (oral pill)",
            "labetalol (oral)",
            "labetalol hydrochloride 100 MG Oral Tablet",
            "labetalol hydrochloride 100 mg oral tablet",
            "labetalol hydrochloride 200 MG Oral Tablet",
            "labetalol hydrochloride 200 mg oral tablet",
            "labetalol hydrochloride 300 MG Oral Tablet",
            "labetalol hydrochloride 300 mg oral tablet",
            "normodyne",
            "trandate"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "44%"
            },
            {
                "value": "100 mg",
                "pct": "34%"
            },
            {
                "value": "300 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "64%"
            },
            {
                "value": "Once daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "70%"
            }
        ]
    },
    {
        "name": "LOSARTAN POTASSIUM",
        "route": "Oral Pill",
        "fullName": "LOSARTAN POTASSIUM (Oral Pill)",
        "totalCount": 149,
        "searchTerms": [
            "COZAAR",
            "Cozaar",
            "Hyzaar",
            "LOSARTAN POTASSIUM",
            "LOSARTAN POTASSIUM (Oral)",
            "Losartan Potassium",
            "Losartan Potassium (Oral)",
            "cozaar",
            "hyzaar",
            "losartan potassium",
            "losartan potassium (oral)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "40%"
            },
            {
                "value": "100 mg",
                "pct": "38%"
            },
            {
                "value": "25 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ferrous sulfate XR",
        "route": "Oral Pill",
        "fullName": "Ferrous sulfate XR (Oral Pill)",
        "totalCount": 147,
        "searchTerms": [
            "24 HR ferrous sulfate 142 MG Extended Release Oral Tablet",
            "24 hr ferrous sulfate 142 mg extended release oral tablet",
            "Ferrous sulfate XR",
            "Ferrous sulfate XR (Oral Pill)",
            "ferrous sulfate 140 MG Extended Release Oral Tablet",
            "ferrous sulfate 140 mg extended release oral tablet",
            "ferrous sulfate 143 MG Extended Release Oral Tablet",
            "ferrous sulfate 143 mg extended release oral tablet",
            "ferrous sulfate 144 MG Extended Release Oral Tablet",
            "ferrous sulfate 144 mg extended release oral tablet",
            "ferrous sulfate 160 MG Extended Release Oral Tablet",
            "ferrous sulfate 160 mg extended release oral tablet",
            "ferrous sulfate 168 MG Extended Release Oral Tablet",
            "ferrous sulfate 168 mg extended release oral tablet",
            "ferrous sulfate xr",
            "ferrous sulfate xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "325 mg",
                "pct": "82%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "KEPPRA",
        "route": "Oral Pill",
        "fullName": "KEPPRA (Oral Pill)",
        "totalCount": 147,
        "searchTerms": [
            "KEPPRA",
            "KEPPRA (Oral Pill)",
            "Keppra",
            "Keppra (Oral)",
            "keppra",
            "keppra (oral pill)",
            "keppra (oral)",
            "levetiracetam 1000 MG Oral Tablet",
            "levetiracetam 1000 mg oral tablet",
            "levetiracetam 250 MG Oral Tablet",
            "levetiracetam 250 mg oral tablet",
            "levetiracetam 500 MG Oral Tablet",
            "levetiracetam 500 mg oral tablet",
            "levetiracetam 750 MG Oral Tablet",
            "levetiracetam 750 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "50%"
            },
            {
                "value": "750 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "57%"
            },
            {
                "value": "Once daily",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "48%"
            },
            {
                "code": "G40",
                "description": "Epilepsy and recurrent seizures",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "Calcium carbonate/Ergocalciferol",
        "route": "Oral Pill",
        "fullName": "Calcium carbonate/Ergocalciferol (Oral Pill)",
        "totalCount": 146,
        "searchTerms": [
            "Calcium carbonate/Ergocalciferol",
            "Calcium carbonate/Ergocalciferol (Oral Pill)",
            "calcium carbonate 625 MG / ergocalciferol 125 UNT Oral Tablet",
            "calcium carbonate 625 mg / ergocalciferol 125 unt oral tablet",
            "calcium carbonate/ergocalciferol",
            "calcium carbonate/ergocalciferol (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "52%"
            },
            {
                "value": "Twice daily",
                "pct": "31%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "cloZAPine",
        "route": "Oral Pill",
        "fullName": "cloZAPine (Oral Pill)",
        "totalCount": 142,
        "searchTerms": [
            "Clozapine",
            "Clozapine (Oral)",
            "Clozaril",
            "cloZAPine",
            "cloZAPine (Oral Pill)",
            "clozapine",
            "clozapine (oral pill)",
            "clozapine (oral)",
            "clozapine 100 MG Oral Tablet",
            "clozapine 100 mg oral tablet",
            "clozapine 200 MG Oral Tablet",
            "clozapine 200 mg oral tablet",
            "clozapine 25 MG Oral Tablet",
            "clozapine 25 mg oral tablet",
            "clozapine 50 MG Oral Tablet",
            "clozapine 50 mg oral tablet",
            "clozaril"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "32%"
            },
            {
                "value": "200 mg",
                "pct": "23%"
            },
            {
                "value": "50 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "43%"
            },
            {
                "value": "At bedtime",
                "pct": "28%"
            },
            {
                "value": "Twice daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "55%"
            }
        ]
    },
    {
        "name": "Haloperidol",
        "route": "Oral Pill",
        "fullName": "Haloperidol (Oral Pill)",
        "totalCount": 142,
        "searchTerms": [
            "HALOPERIDOL",
            "Haldol",
            "Haloperidol",
            "Haloperidol (Oral Pill)",
            "Haloperidol (Oral)",
            "haldol",
            "haloperidol",
            "haloperidol (oral pill)",
            "haloperidol (oral)",
            "haloperidol 0.5 MG Oral Tablet",
            "haloperidol 0.5 mg oral tablet",
            "haloperidol 1 MG Oral Tablet",
            "haloperidol 1 mg oral tablet",
            "haloperidol 10 MG Oral Tablet",
            "haloperidol 10 mg oral tablet",
            "haloperidol 2 MG Oral Tablet",
            "haloperidol 2 mg oral tablet",
            "haloperidol 20 MG Oral Tablet",
            "haloperidol 20 mg oral tablet",
            "haloperidol 5 MG Oral Tablet",
            "haloperidol 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "35%"
            },
            {
                "value": "10 mg",
                "pct": "34%"
            },
            {
                "value": "1 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "44%"
            },
            {
                "value": "Twice daily",
                "pct": "31%"
            },
            {
                "value": "At bedtime",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "42%"
            }
        ]
    },
    {
        "name": "BIKTARVY",
        "route": "Oral Pill",
        "fullName": "BIKTARVY (Oral Pill)",
        "totalCount": 139,
        "searchTerms": [
            "BIKTARVY",
            "BIKTARVY (Oral Pill)",
            "Biktarvy",
            "Biktarvy (Oral)",
            "bictegravir 50 MG / emtricitabine 200 MG / tenofovir alafenamide 25 MG Oral Tablet",
            "bictegravir 50 mg / emtricitabine 200 mg / tenofovir alafenamide 25 mg oral tablet",
            "biktarvy",
            "biktarvy (oral pill)",
            "biktarvy (oral)"
        ],
        "dosages": [
            {
                "value": "50-200-25 mg",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "96%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B20",
                "description": "Human immunodeficiency virus [HIV] disease",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "Isosorbide dinitrate",
        "route": "Oral Pill",
        "fullName": "Isosorbide dinitrate (Oral Pill)",
        "totalCount": 138,
        "searchTerms": [
            "Isosorbide Dinitrate",
            "Isosorbide Dinitrate (Oral)",
            "Isosorbide dinitrate",
            "Isosorbide dinitrate (Oral Pill)",
            "Isosorbide dinitrate (Oral)",
            "isosorbide dinitrate",
            "isosorbide dinitrate (oral pill)",
            "isosorbide dinitrate (oral)",
            "isosorbide dinitrate 20 MG Oral Tablet",
            "isosorbide dinitrate 20 mg oral tablet",
            "isosorbide dinitrate 30 MG Oral Tablet",
            "isosorbide dinitrate 30 mg oral tablet",
            "isosorbide dinitrate 40 MG Oral Tablet",
            "isosorbide dinitrate 40 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "68%"
            },
            {
                "value": "10 mg",
                "pct": "10%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            },
            {
                "value": "Three times daily",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "30%"
            }
        ]
    },
    {
        "name": "Oxygen",
        "route": "Inhalant",
        "fullName": "Oxygen (Inhalant)",
        "totalCount": 138,
        "searchTerms": [
            "OXYGEN",
            "Oxygen",
            "Oxygen (Inhalant)",
            "oxygen",
            "oxygen (inhalant)",
            "oxygen 21 % Gas for Inhalation",
            "oxygen 21 % gas for inhalation",
            "oxygen 99 % Gas for Inhalation",
            "oxygen 99 % gas for inhalation",
            "oxygen 99.5 % Gas for Inhalation",
            "oxygen 99.5 % gas for inhalation",
            "oxygen 99.6 % Gas for Inhalation",
            "oxygen 99.6 % gas for inhalation",
            "oxygen 99.8 % Gas for Inhalation",
            "oxygen 99.8 % gas for inhalation",
            "oxygen 99.9 % Gas for Inhalation",
            "oxygen 99.9 % gas for inhalation"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "34%"
            },
            {
                "value": "At bedtime",
                "pct": "17%"
            },
            {
                "value": "Continuous",
                "pct": "10%"
            },
            {
                "value": "Once daily",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "37%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "TYLENOL PM",
        "route": "Oral Pill",
        "fullName": "TYLENOL PM (Oral Pill)",
        "totalCount": 137,
        "searchTerms": [
            "TYLENOL PM",
            "TYLENOL PM (Oral Pill)",
            "acetaminophen 500 MG / diphenhydramine hydrochloride 25 MG Oral Tablet",
            "acetaminophen 500 mg / diphenhydramine hydrochloride 25 mg oral tablet",
            "tylenol pm",
            "tylenol pm (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "45%"
            },
            {
                "value": "500-25 mg",
                "pct": "41%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "23%"
            },
            {
                "value": "Every 6 hours",
                "pct": "19%"
            },
            {
                "value": "Once daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RESTASIS",
        "route": "Ophthalmic",
        "fullName": "RESTASIS (Ophthalmic)",
        "totalCount": 137,
        "searchTerms": [
            "RESTASIS",
            "RESTASIS (Ophthalmic)",
            "cyclosporine 0.5 MG/ML Ophthalmic Suspension",
            "cyclosporine 0.5 mg/ml ophthalmic suspension",
            "restasis",
            "restasis (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "65%"
            },
            {
                "value": "Once daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [
            {
                "value": "Avoid touching dropper tip to eye or surfaces",
                "pct": "10%"
            }
        ],
        "diagnoses": [
            {
                "code": "H04.123",
                "description": "Dry eye syndrome of bilateral lacrimal glands",
                "pct": "73%"
            }
        ]
    },
    {
        "name": "cloNIDine XR",
        "route": "Oral Pill",
        "fullName": "cloNIDine XR (Oral Pill)",
        "totalCount": 135,
        "searchTerms": [
            "12 HR clonidine hydrochloride 0.1 MG Extended Release Oral Tablet",
            "12 HR clonidine hydrochloride 0.2 MG Extended Release Oral Tablet",
            "12 hr clonidine hydrochloride 0.1 mg extended release oral tablet",
            "12 hr clonidine hydrochloride 0.2 mg extended release oral tablet",
            "cloNIDine XR",
            "cloNIDine XR (Oral Pill)",
            "clonidine xr",
            "clonidine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "0.1 mg",
                "pct": "76%"
            },
            {
                "value": "0.2 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "44%"
            },
            {
                "value": "Twice daily",
                "pct": "23%"
            },
            {
                "value": "As needed",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FLONASE",
        "route": "Nasal",
        "fullName": "FLONASE (Nasal)",
        "totalCount": 135,
        "searchTerms": [
            "FLONASE",
            "FLONASE (Nasal)",
            "flonase",
            "flonase (nasal)",
            "fluticasone propionate 0.05 MG/ACTUAT Metered Dose Nasal Spray",
            "fluticasone propionate 0.05 mg/actuat metered dose nasal spray"
        ],
        "dosages": [
            {
                "value": "50 mcg",
                "pct": "97%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DEPAKOTE",
        "route": "Oral Pill",
        "fullName": "DEPAKOTE (Oral Pill)",
        "totalCount": 134,
        "searchTerms": [
            "DEPAKOTE",
            "DEPAKOTE (Oral Pill)",
            "depakote",
            "depakote (oral pill)",
            "divalproex sodium 125 MG Delayed Release Oral Capsule",
            "divalproex sodium 125 MG Delayed Release Oral Tablet",
            "divalproex sodium 125 mg delayed release oral capsule",
            "divalproex sodium 125 mg delayed release oral tablet",
            "divalproex sodium 250 MG Delayed Release Oral Tablet",
            "divalproex sodium 250 mg delayed release oral tablet",
            "divalproex sodium 500 MG Delayed Release Oral Tablet",
            "divalproex sodium 500 mg delayed release oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "46%"
            },
            {
                "value": "125 mg",
                "pct": "21%"
            },
            {
                "value": "250 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "35%"
            },
            {
                "value": "Once daily",
                "pct": "32%"
            },
            {
                "value": "At bedtime",
                "pct": "19%"
            }
        ],
        "adminNotes": [
            {
                "value": "Do not crush enteric-coated tablets",
                "pct": "11%"
            }
        ],
        "diagnoses": [
            {
                "code": "F31.9",
                "description": "Bipolar disorder, unspecified",
                "pct": "30%"
            },
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "25%"
            }
        ]
    },
    {
        "name": "Vitamin C",
        "route": "Oral Pill",
        "fullName": "Vitamin C (Oral Pill)",
        "totalCount": 133,
        "searchTerms": [
            "VITAMIN C",
            "Vitamin C",
            "Vitamin C (Oral)",
            "vitamin c",
            "vitamin c (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "50%"
            },
            {
                "value": "1000 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [
            {
                "value": "Supplement",
                "pct": "12%"
            }
        ],
        "diagnoses": []
    },
    {
        "name": "Pioglitazone",
        "route": "Oral Pill",
        "fullName": "Pioglitazone (Oral Pill)",
        "totalCount": 131,
        "searchTerms": [
            "Actos",
            "PIOGLITAZONE",
            "PIOGLITAZONE (Oral)",
            "Pioglitazone",
            "Pioglitazone (Oral Pill)",
            "Pioglitazone (Oral)",
            "actos",
            "pioglitazone",
            "pioglitazone (oral pill)",
            "pioglitazone (oral)",
            "pioglitazone 15 MG Oral Tablet",
            "pioglitazone 15 mg oral tablet",
            "pioglitazone 30 MG Oral Tablet",
            "pioglitazone 30 mg oral tablet",
            "pioglitazone 45 MG Oral Tablet",
            "pioglitazone 45 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "56%"
            },
            {
                "value": "45 mg",
                "pct": "26%"
            },
            {
                "value": "15 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "98%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "62%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "25%"
            }
        ]
    },
    {
        "name": "Triamcinolone",
        "route": "Topical",
        "fullName": "Triamcinolone (Topical)",
        "totalCount": 130,
        "searchTerms": [
            "Triamcinolone",
            "Triamcinolone (Topical)",
            "triamcinolone",
            "triamcinolone (topical)",
            "triamcinolone acetonide 0.00025 MG/MG Topical Ointment",
            "triamcinolone acetonide 0.00025 mg/mg topical ointment",
            "triamcinolone acetonide 0.001 MG/MG Topical Ointment",
            "triamcinolone acetonide 0.001 mg/mg topical ointment",
            "triamcinolone acetonide 0.005 MG/MG Topical Ointment",
            "triamcinolone acetonide 0.005 mg/mg topical ointment",
            "triamcinolone acetonide 0.147 MG/ML Topical Spray",
            "triamcinolone acetonide 0.147 mg/ml topical spray",
            "triamcinolone acetonide 0.25 MG/ML Topical Cream",
            "triamcinolone acetonide 0.25 mg/ml topical cream",
            "triamcinolone acetonide 1 MG/ML Topical Cream",
            "triamcinolone acetonide 1 MG/ML Topical Lotion",
            "triamcinolone acetonide 1 mg/ml topical cream",
            "triamcinolone acetonide 1 mg/ml topical lotion",
            "triamcinolone acetonide 5 MG/ML Topical Cream",
            "triamcinolone acetonide 5 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "40%"
            },
            {
                "value": "Once daily",
                "pct": "36%"
            },
            {
                "value": "As needed",
                "pct": "12%"
            }
        ],
        "adminNotes": [
            {
                "value": "Apply a thin layer to affected area",
                "pct": "19%"
            },
            {
                "value": "Avoid contact with eyes",
                "pct": "13%"
            }
        ],
        "diagnoses": [
            {
                "code": "L30.9",
                "description": "Dermatitis, unspecified",
                "pct": "51%"
            }
        ]
    },
    {
        "name": "MICROZIDE",
        "route": "Oral Pill",
        "fullName": "MICROZIDE (Oral Pill)",
        "totalCount": 130,
        "searchTerms": [
            "MICROZIDE",
            "MICROZIDE (Oral Pill)",
            "hydrochlorothiazide 12.5 MG Oral Capsule",
            "hydrochlorothiazide 12.5 mg oral capsule",
            "microzide",
            "microzide (oral pill)"
        ],
        "dosages": [
            {
                "value": "12.5 mg",
                "pct": "56%"
            },
            {
                "value": "25 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SINGULAIR",
        "route": "Oral Pill",
        "fullName": "SINGULAIR (Oral Pill)",
        "totalCount": 129,
        "searchTerms": [
            "SINGULAIR",
            "SINGULAIR (Oral Pill)",
            "Singulair",
            "Singulair (Oral)",
            "montelukast 10 MG Oral Tablet",
            "montelukast 10 mg oral tablet",
            "singulair",
            "singulair (oral pill)",
            "singulair (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "98%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            },
            {
                "value": "At bedtime",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "24%"
            }
        ]
    },
    {
        "name": "METFORMIN HCL",
        "route": "Oral Pill",
        "fullName": "METFORMIN HCL (Oral Pill)",
        "totalCount": 129,
        "searchTerms": [
            "GLUCOPHAGE",
            "Glucophage",
            "METFORMIN HCL",
            "METFORMIN HCL (Oral)",
            "Metformin HCL",
            "Metformin HCL (Oral)",
            "Metformin HCl",
            "Metformin HCl (Oral)",
            "Metformin Hcl",
            "Metformin Hcl (Oral)",
            "glucophage",
            "metFORMIN HCL",
            "metFORMIN HCL (Oral)",
            "metFORMIN HCl",
            "metFORMIN HCl (Oral)",
            "metformin HCL",
            "metformin hcl",
            "metformin hcl (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "46%"
            },
            {
                "value": "1000 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "65%"
            },
            {
                "value": "Once daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [
            {
                "value": "Take with meals",
                "pct": "25%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "97%"
            }
        ]
    },
    {
        "name": "Propranolol",
        "route": "Oral Pill",
        "fullName": "Propranolol (Oral Pill)",
        "totalCount": 128,
        "searchTerms": [
            "Inderal",
            "Propranolol",
            "Propranolol (Oral Pill)",
            "Propranolol (Oral)",
            "inderal",
            "propranolol",
            "propranolol (oral pill)",
            "propranolol (oral)",
            "propranolol hydrochloride 10 MG Oral Tablet",
            "propranolol hydrochloride 10 mg oral tablet",
            "propranolol hydrochloride 20 MG Oral Tablet",
            "propranolol hydrochloride 20 mg oral tablet",
            "propranolol hydrochloride 40 MG Oral Tablet",
            "propranolol hydrochloride 40 mg oral tablet",
            "propranolol hydrochloride 80 MG Oral Tablet",
            "propranolol hydrochloride 80 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "42%"
            },
            {
                "value": "20 mg",
                "pct": "33%"
            },
            {
                "value": "60 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            },
            {
                "value": "Twice daily",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "33%"
            },
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "24%"
            }
        ]
    },
    {
        "name": "BREO",
        "route": "Inhalant",
        "fullName": "BREO (Inhalant)",
        "totalCount": 127,
        "searchTerms": [
            "14 ACTUAT fluticasone furoate 0.1 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "14 ACTUAT fluticasone furoate 0.2 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "14 actuat fluticasone furoate 0.1 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "14 actuat fluticasone furoate 0.2 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "30 ACTUAT fluticasone furoate 0.1 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "30 ACTUAT fluticasone furoate 0.2 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "30 actuat fluticasone furoate 0.1 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "30 actuat fluticasone furoate 0.2 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "BREO",
            "BREO (Inhalant)",
            "breo",
            "breo (inhalant)"
        ],
        "dosages": [
            {
                "value": "100-25 mcg",
                "pct": "58%"
            },
            {
                "value": "200-25 mcg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "34%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "23%"
            }
        ]
    },
    {
        "name": "Amiodarone",
        "route": "Oral Pill",
        "fullName": "Amiodarone (Oral Pill)",
        "totalCount": 126,
        "searchTerms": [
            "AMIODARONE",
            "AMIODArone",
            "AMIODArone (Oral)",
            "Amiodarone",
            "Amiodarone (Oral Pill)",
            "Amiodarone (Oral)",
            "amiodarone",
            "amiodarone (Oral)",
            "amiodarone (oral pill)",
            "amiodarone (oral)",
            "amiodarone hydrochloride 100 MG Oral Tablet",
            "amiodarone hydrochloride 100 mg oral tablet",
            "amiodarone hydrochloride 200 MG Oral Tablet",
            "amiodarone hydrochloride 200 mg oral tablet",
            "amiodarone hydrochloride 300 MG Oral Tablet",
            "amiodarone hydrochloride 300 mg oral tablet",
            "amiodarone hydrochloride 400 MG Oral Tablet",
            "amiodarone hydrochloride 400 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "77%"
            },
            {
                "value": "100 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I48.91",
                "description": "Unspecified atrial fibrillation",
                "pct": "40%"
            },
            {
                "code": "I49.9",
                "description": "Cardiac arrhythmia, unspecified",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "Budesonide/Formoterol",
        "route": "Inhalant",
        "fullName": "Budesonide/Formoterol (Inhalant)",
        "totalCount": 126,
        "searchTerms": [
            "120 ACTUAT budesonide 0.08 MG/ACTUAT / formoterol fumarate 0.0045 MG/ACTUAT Metered Dose Inhaler",
            "120 ACTUAT budesonide 0.16 MG/ACTUAT / formoterol fumarate 0.0045 MG/ACTUAT Metered Dose Inhaler",
            "120 actuat budesonide 0.08 mg/actuat / formoterol fumarate 0.0045 mg/actuat metered dose inhaler",
            "120 actuat budesonide 0.16 mg/actuat / formoterol fumarate 0.0045 mg/actuat metered dose inhaler",
            "60 ACTUAT budesonide 0.08 MG/ACTUAT / formoterol fumarate 0.0045 MG/ACTUAT Metered Dose Inhaler",
            "60 ACTUAT budesonide 0.16 MG/ACTUAT / formoterol fumarate 0.0045 MG/ACTUAT Metered Dose Inhaler",
            "60 actuat budesonide 0.08 mg/actuat / formoterol fumarate 0.0045 mg/actuat metered dose inhaler",
            "60 actuat budesonide 0.16 mg/actuat / formoterol fumarate 0.0045 mg/actuat metered dose inhaler",
            "Budesonide/Formoterol",
            "Budesonide/Formoterol (Inhalant)",
            "budesonide/formoterol",
            "budesonide/formoterol (inhalant)"
        ],
        "dosages": [
            {
                "value": "160-4.5 mcg",
                "pct": "59%"
            },
            {
                "value": "80-4.5 mcg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "58%"
            },
            {
                "value": "Once daily",
                "pct": "17%"
            },
            {
                "value": "As needed",
                "pct": "11%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rinse mouth after inhaled corticosteroid",
                "pct": "12%"
            }
        ],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "36%"
            },
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "18%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "14%"
            }
        ]
    },
    {
        "name": "JANUMET",
        "route": "Oral Pill",
        "fullName": "JANUMET (Oral Pill)",
        "totalCount": 125,
        "searchTerms": [
            "JANUMET",
            "JANUMET (Oral Pill)",
            "JANUMET (Oral)",
            "Janumet",
            "Janumet (Oral)",
            "janumet",
            "janumet (oral pill)",
            "janumet (oral)",
            "metformin hydrochloride 1000 MG / sitagliptin 50 MG Oral Tablet",
            "metformin hydrochloride 1000 mg / sitagliptin 50 mg oral tablet",
            "metformin hydrochloride 500 MG / sitagliptin 50 MG Oral Tablet",
            "metformin hydrochloride 500 mg / sitagliptin 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500-50 mg",
                "pct": "34%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "72%"
            },
            {
                "value": "Once daily",
                "pct": "22%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "71%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "amLODIPine/Hydrochlorothiazide/Olmesartan",
        "route": "Oral Pill",
        "fullName": "amLODIPine/Hydrochlorothiazide/Olmesartan (Oral Pill)",
        "totalCount": 124,
        "searchTerms": [
            "amLODIPine/Hydrochlorothiazide/Olmesartan",
            "amLODIPine/Hydrochlorothiazide/Olmesartan (Oral Pill)",
            "amLODIPine/hydroCHLOROthiazide/Olmesartan",
            "amLODIPine/hydroCHLOROthiazide/Olmesartan (Oral Pill)",
            "amlodipine 5 MG / hydrochlorothiazide 25 MG / olmesartan medoxomil 40 MG Oral Tablet",
            "amlodipine 5 mg / hydrochlorothiazide 25 mg / olmesartan medoxomil 40 mg oral tablet",
            "amlodipine/hydrochlorothiazide/olmesartan",
            "amlodipine/hydrochlorothiazide/olmesartan (oral pill)"
        ],
        "dosages": [
            {
                "value": "5-25-40 mg",
                "pct": "59%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "57%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROAIR",
        "route": "Inhalant",
        "fullName": "PROAIR (Inhalant)",
        "totalCount": 124,
        "searchTerms": [
            "200 ACTUAT albuterol 0.09 MG/ACTUAT Dry Powder Inhaler",
            "200 actuat albuterol 0.09 mg/actuat dry powder inhaler",
            "NDA021457 200 ACTUAT albuterol 0.09 MG/ACTUAT Metered Dose Inhaler",
            "PROAIR",
            "PROAIR (Inhalant)",
            "Sensor 200 ACTUAT albuterol 0.09 MG/ACTUAT Dry Powder Inhaler",
            "nda021457 200 actuat albuterol 0.09 mg/actuat metered dose inhaler",
            "proair",
            "proair (inhalant)",
            "sensor 200 actuat albuterol 0.09 mg/actuat dry powder inhaler"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "93%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "42%"
            },
            {
                "value": "Once daily",
                "pct": "17%"
            },
            {
                "value": "Twice daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ABILIFY",
        "route": "Oral Pill",
        "fullName": "ABILIFY (Oral Pill)",
        "totalCount": 123,
        "searchTerms": [
            "ABILIFY",
            "ABILIFY (Oral Pill)",
            "Abilify",
            "Abilify (Oral)",
            "Sensor aripiprazole 10 MG Oral Tablet",
            "Sensor aripiprazole 15 MG Oral Tablet",
            "Sensor aripiprazole 2 MG Oral Tablet",
            "Sensor aripiprazole 20 MG Oral Tablet",
            "Sensor aripiprazole 30 MG Oral Tablet",
            "Sensor aripiprazole 5 MG Oral Tablet",
            "abilify",
            "abilify (oral pill)",
            "abilify (oral)",
            "aripiprazole 10 MG Oral Tablet",
            "aripiprazole 10 mg oral tablet",
            "aripiprazole 15 MG Oral Tablet",
            "aripiprazole 15 mg oral tablet",
            "aripiprazole 20 MG Oral Tablet",
            "aripiprazole 20 mg oral tablet",
            "aripiprazole 5 MG Oral Tablet",
            "aripiprazole 5 mg oral tablet",
            "sensor aripiprazole 10 mg oral tablet",
            "sensor aripiprazole 15 mg oral tablet",
            "sensor aripiprazole 2 mg oral tablet",
            "sensor aripiprazole 20 mg oral tablet",
            "sensor aripiprazole 30 mg oral tablet",
            "sensor aripiprazole 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "23%"
            },
            {
                "value": "5 mg",
                "pct": "21%"
            },
            {
                "value": "2 mg",
                "pct": "20%"
            },
            {
                "value": "20 mg",
                "pct": "11%"
            },
            {
                "value": "30 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "69%"
            },
            {
                "value": "At bedtime",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Mounjaro",
        "route": "Injectable",
        "fullName": "Mounjaro (Injectable)",
        "totalCount": 120,
        "searchTerms": [
            "MOUNJARO",
            "MOUNJARO (Injectable)",
            "Mounjaro",
            "Mounjaro (Injectable)",
            "mounjaro",
            "mounjaro (injectable)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "39%"
            },
            {
                "value": "10 mg",
                "pct": "18%"
            },
            {
                "value": "15 mg",
                "pct": "18%"
            },
            {
                "value": "7.5 mg",
                "pct": "10%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "90%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rotate injection sites",
                "pct": "20%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "58%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "CLARITIN",
        "route": "Oral Pill",
        "fullName": "CLARITIN (Oral Pill)",
        "totalCount": 120,
        "searchTerms": [
            "CLARITIN",
            "CLARITIN (Oral Pill)",
            "Claritin",
            "Claritin (Oral)",
            "claritin",
            "claritin (oral pill)",
            "claritin (oral)",
            "loratadine 10 MG Oral Capsule",
            "loratadine 10 MG Oral Tablet",
            "loratadine 10 mg oral capsule",
            "loratadine 10 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "95%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "47%"
            }
        ]
    },
    {
        "name": "JANUMET XR",
        "route": "Oral Pill",
        "fullName": "JANUMET XR (Oral Pill)",
        "totalCount": 120,
        "searchTerms": [
            "24 HR metformin hydrochloride 1000 MG / sitagliptin 100 MG Extended Release Oral Tablet",
            "24 HR metformin hydrochloride 1000 MG / sitagliptin 50 MG Extended Release Oral Tablet",
            "24 HR metformin hydrochloride 500 MG / sitagliptin 50 MG Extended Release Oral Tablet",
            "24 hr metformin hydrochloride 1000 mg / sitagliptin 100 mg extended release oral tablet",
            "24 hr metformin hydrochloride 1000 mg / sitagliptin 50 mg extended release oral tablet",
            "24 hr metformin hydrochloride 500 mg / sitagliptin 50 mg extended release oral tablet",
            "JANUMET",
            "JANUMET XR",
            "JANUMET XR (Oral Pill)",
            "Janumet XR",
            "Janumet XR (Oral)",
            "janumet",
            "janumet xr",
            "janumet xr (oral pill)",
            "janumet xr (oral)"
        ],
        "dosages": [
            {
                "value": "500-50 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "45%"
            },
            {
                "value": "Once daily",
                "pct": "43%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "48%"
            }
        ]
    },
    {
        "name": "PARoxetine",
        "route": "Oral Pill",
        "fullName": "PARoxetine (Oral Pill)",
        "totalCount": 120,
        "searchTerms": [
            "PARoxetine",
            "PARoxetine (Oral Pill)",
            "PARoxetine (Oral)",
            "Paroxetine",
            "Paroxetine (Oral)",
            "Paxil",
            "paroxetine",
            "paroxetine (oral pill)",
            "paroxetine (oral)",
            "paroxetine hydrochloride 10 MG Oral Tablet",
            "paroxetine hydrochloride 10 mg oral tablet",
            "paroxetine hydrochloride 20 MG Oral Tablet",
            "paroxetine hydrochloride 20 mg oral tablet",
            "paroxetine hydrochloride 30 MG Oral Tablet",
            "paroxetine hydrochloride 30 mg oral tablet",
            "paroxetine hydrochloride 40 MG Oral Tablet",
            "paroxetine hydrochloride 40 mg oral tablet",
            "paroxetine mesylate 10 MG Oral Tablet",
            "paroxetine mesylate 10 mg oral tablet",
            "paroxetine mesylate 20 MG Oral Tablet",
            "paroxetine mesylate 20 mg oral tablet",
            "paroxetine mesylate 30 MG Oral Tablet",
            "paroxetine mesylate 30 mg oral tablet",
            "paroxetine mesylate 40 MG Oral Tablet",
            "paroxetine mesylate 40 mg oral tablet",
            "paroxetine mesylate 7.5 MG Oral Capsule",
            "paroxetine mesylate 7.5 mg oral capsule",
            "paxil"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "34%"
            },
            {
                "value": "10 mg",
                "pct": "24%"
            },
            {
                "value": "40 mg",
                "pct": "20%"
            },
            {
                "value": "30 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "48%"
            },
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "Senna",
        "route": "Oral Pill",
        "fullName": "Senna (Oral Pill)",
        "totalCount": 117,
        "searchTerms": [
            "Onelax Senna",
            "SENNA",
            "SENNA (Oral)",
            "Senna",
            "Senna (Oral)",
            "Senno",
            "Senokot",
            "onelax senna",
            "senna",
            "senna (Oral)",
            "senna (oral)",
            "senno",
            "senokot"
        ],
        "dosages": [
            {
                "value": "8.6 mg",
                "pct": "74%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "57%"
            },
            {
                "value": "At bedtime",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "77%"
            }
        ]
    },
    {
        "name": "SPIRIVA",
        "route": "Inhalant",
        "fullName": "SPIRIVA (Inhalant)",
        "totalCount": 117,
        "searchTerms": [
            "10 ACTUAT tiotropium 0.0025 MG/ACTUAT Inhalation Spray",
            "10 actuat tiotropium 0.0025 mg/actuat inhalation spray",
            "28 ACTUAT tiotropium 0.00125 MG/ACTUAT Inhalation Spray",
            "28 ACTUAT tiotropium 0.0025 MG/ACTUAT Inhalation Spray",
            "28 actuat tiotropium 0.00125 mg/actuat inhalation spray",
            "28 actuat tiotropium 0.0025 mg/actuat inhalation spray",
            "60 ACTUAT tiotropium 0.00125 MG/ACTUAT Inhalation Spray",
            "60 ACTUAT tiotropium 0.0025 MG/ACTUAT Inhalation Spray",
            "60 actuat tiotropium 0.00125 mg/actuat inhalation spray",
            "60 actuat tiotropium 0.0025 mg/actuat inhalation spray",
            "SPIRIVA",
            "SPIRIVA (Inhalant)",
            "spiriva",
            "spiriva (inhalant)",
            "tiotropium 0.018 MG Inhalation Powder",
            "tiotropium 0.018 mg inhalation powder"
        ],
        "dosages": [
            {
                "value": "2.5 mcg",
                "pct": "52%"
            },
            {
                "value": "0.018 mg",
                "pct": "26%"
            },
            {
                "value": "1.25 mcg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "47%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "27%"
            }
        ]
    },
    {
        "name": "METOPROLOL SUCCINATE",
        "route": "Oral Pill",
        "fullName": "METOPROLOL SUCCINATE (Oral Pill)",
        "totalCount": 117,
        "searchTerms": [
            "METOPROLOL SUCCINATE",
            "METOPROLOL SUCCINATE (Oral)",
            "Metoprolol Succinate",
            "Metoprolol Succinate (Oral)",
            "Metoprolol Succinate ER",
            "Metoprolol succinate",
            "Metoprolol succinate (Oral)",
            "TOPROL XL",
            "TOPROL XL TAB",
            "Toprol XL",
            "Toprol XL 25 MG",
            "metoprolol succinate",
            "metoprolol succinate (Oral)",
            "metoprolol succinate (oral)",
            "metoprolol succinate er",
            "toprol xl",
            "toprol xl 25 mg",
            "toprol xl tab"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "43%"
            },
            {
                "value": "50 mg",
                "pct": "32%"
            },
            {
                "value": "100 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "97%"
            }
        ]
    },
    {
        "name": "INVEGA",
        "route": "Injectable",
        "fullName": "INVEGA (Injectable)",
        "totalCount": 116,
        "searchTerms": [
            "0.25 ML paliperidone palmitate 156 MG/ML Prefilled Syringe",
            "0.25 ml paliperidone palmitate 156 mg/ml prefilled syringe",
            "0.5 ML paliperidone palmitate 156 MG/ML Prefilled Syringe",
            "0.5 ml paliperidone palmitate 156 mg/ml prefilled syringe",
            "0.75 ML paliperidone palmitate 156 MG/ML Prefilled Syringe",
            "0.75 ml paliperidone palmitate 156 mg/ml prefilled syringe",
            "0.875 ML paliperidone palmitate 312 MG/ML Prefilled Syringe",
            "0.875 ml paliperidone palmitate 312 mg/ml prefilled syringe",
            "1 ML paliperidone palmitate 156 MG/ML Prefilled Syringe",
            "1 ml paliperidone palmitate 156 mg/ml prefilled syringe",
            "1.315 ML paliperidone palmitate 312 MG/ML Prefilled Syringe",
            "1.315 ml paliperidone palmitate 312 mg/ml prefilled syringe",
            "1.5 ML paliperidone palmitate 156 MG/ML Prefilled Syringe",
            "1.5 ml paliperidone palmitate 156 mg/ml prefilled syringe",
            "1.75 ML paliperidone palmitate 312 MG/ML Prefilled Syringe",
            "1.75 ml paliperidone palmitate 312 mg/ml prefilled syringe",
            "2.625 ML paliperidone palmitate 312 MG/ML Prefilled Syringe",
            "2.625 ml paliperidone palmitate 312 mg/ml prefilled syringe",
            "INVEGA",
            "INVEGA (Injectable)",
            "invega",
            "invega (injectable)"
        ],
        "dosages": [
            {
                "value": "156 mg",
                "pct": "30%"
            },
            {
                "value": "234 mg",
                "pct": "24%"
            }
        ],
        "frequencies": [
            {
                "value": "Monthly",
                "pct": "53%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Sacubitril/Valsartan",
        "route": "Oral Pill",
        "fullName": "Sacubitril/Valsartan (Oral Pill)",
        "totalCount": 115,
        "searchTerms": [
            "Entresto",
            "Sacubitril/Valsartan",
            "Sacubitril/Valsartan (Oral Pill)",
            "Sacubitril/Valsartan (Oral)",
            "entresto",
            "sacubitril 24 MG / valsartan 26 MG Oral Tablet",
            "sacubitril 24 mg / valsartan 26 mg oral tablet",
            "sacubitril 49 MG / valsartan 51 MG Oral Tablet",
            "sacubitril 49 mg / valsartan 51 mg oral tablet",
            "sacubitril 97 MG / valsartan 103 MG Oral Tablet",
            "sacubitril 97 mg / valsartan 103 mg oral tablet",
            "sacubitril/valsartan",
            "sacubitril/valsartan (oral pill)",
            "sacubitril/valsartan (oral)"
        ],
        "dosages": [
            {
                "value": "24-26 mg",
                "pct": "50%"
            },
            {
                "value": "97-103 mg",
                "pct": "21%"
            },
            {
                "value": "49-51 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "71%"
            },
            {
                "value": "Once daily",
                "pct": "16%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "66%"
            },
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "16%"
            }
        ]
    },
    {
        "name": "MOTRIN",
        "route": "Oral Pill",
        "fullName": "MOTRIN (Oral Pill)",
        "totalCount": 115,
        "searchTerms": [
            "MOTRIN",
            "MOTRIN (Oral Pill)",
            "ibuprofen 100 MG Oral Tablet",
            "ibuprofen 100 mg oral tablet",
            "ibuprofen 200 MG Oral Capsule",
            "ibuprofen 200 MG Oral Tablet",
            "ibuprofen 200 mg oral capsule",
            "ibuprofen 200 mg oral tablet",
            "motrin",
            "motrin (oral pill)"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "57%"
            },
            {
                "value": "600 mg",
                "pct": "16%"
            },
            {
                "value": "400 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "58%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "36%"
            },
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "23%"
            }
        ]
    },
    {
        "name": "traMADol",
        "route": "Oral Pill",
        "fullName": "traMADol (Oral Pill)",
        "totalCount": 115,
        "searchTerms": [
            "TRAMADOL",
            "Tramadol",
            "Tramadol (Oral)",
            "Ultram",
            "traMADol",
            "traMADol (Oral Pill)",
            "traMADol (Oral)",
            "tramadol",
            "tramadol (oral pill)",
            "tramadol (oral)",
            "tramadol hydrochloride 100 MG Oral Tablet",
            "tramadol hydrochloride 100 mg oral tablet",
            "tramadol hydrochloride 50 MG Oral Tablet",
            "tramadol hydrochloride 50 mg oral tablet",
            "ultram"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "96%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "66%"
            },
            {
                "value": "Once daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "48%"
            },
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "38%"
            }
        ]
    },
    {
        "name": "levETIRAcetam XR",
        "route": "Oral Pill",
        "fullName": "levETIRAcetam XR (Oral Pill)",
        "totalCount": 111,
        "searchTerms": [
            "24 HR levetiracetam 1000 MG Extended Release Oral Tablet",
            "24 HR levetiracetam 1500 MG Extended Release Oral Tablet",
            "24 hr levetiracetam 1000 mg extended release oral tablet",
            "24 hr levetiracetam 1500 mg extended release oral tablet",
            "levETIRAcetam XR",
            "levETIRAcetam XR (Oral Pill)",
            "levetiracetam xr",
            "levetiracetam xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "39%"
            },
            {
                "value": "750 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "58%"
            },
            {
                "value": "Once daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ZyPREXA",
        "route": "Oral Pill",
        "fullName": "ZyPREXA (Oral Pill)",
        "totalCount": 109,
        "searchTerms": [
            "ZYPREXA",
            "ZyPREXA",
            "ZyPREXA (Oral Pill)",
            "Zyprexa",
            "Zyprexa (Oral)",
            "olanzapine 10 MG Oral Tablet",
            "olanzapine 10 mg oral tablet",
            "olanzapine 15 MG Oral Tablet",
            "olanzapine 15 mg oral tablet",
            "olanzapine 2.5 MG Oral Tablet",
            "olanzapine 2.5 mg oral tablet",
            "olanzapine 20 MG Oral Tablet",
            "olanzapine 20 mg oral tablet",
            "olanzapine 5 MG Oral Tablet",
            "olanzapine 5 mg oral tablet",
            "olanzapine 7.5 MG Oral Tablet",
            "olanzapine 7.5 mg oral tablet",
            "zyprexa",
            "zyprexa (oral pill)",
            "zyprexa (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "38%"
            },
            {
                "value": "5 mg",
                "pct": "19%"
            },
            {
                "value": "20 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "61%"
            },
            {
                "value": "At bedtime",
                "pct": "17%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Diclofenac",
        "route": "Oral Pill",
        "fullName": "Diclofenac (Oral Pill)",
        "totalCount": 109,
        "searchTerms": [
            "Diclofenac",
            "Diclofenac (Oral Pill)",
            "Diclofenac (Oral)",
            "Voltaren",
            "diclofenac",
            "diclofenac (oral pill)",
            "diclofenac (oral)",
            "diclofenac 18 MG Oral Capsule",
            "diclofenac 18 mg oral capsule",
            "diclofenac 35 MG Oral Capsule",
            "diclofenac 35 mg oral capsule",
            "diclofenac sodium 75 MG Delayed Release Oral Tablet",
            "diclofenac sodium 75 mg delayed release oral tablet",
            "voltaren"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "33%"
            },
            {
                "value": "75 mg",
                "pct": "29%"
            },
            {
                "value": "25 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "48%"
            },
            {
                "value": "Once daily",
                "pct": "28%"
            },
            {
                "value": "As needed",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "47%"
            }
        ]
    },
    {
        "name": "Insulin analog, glargine",
        "route": "Injectable",
        "fullName": "Insulin analog, glargine (Injectable)",
        "totalCount": 109,
        "searchTerms": [
            "1.5 ML insulin glargine 300 UNT/ML Pen Injector",
            "1.5 ml insulin glargine 300 unt/ml pen injector",
            "3 ML insulin glargine 300 UNT/ML Pen Injector",
            "3 ml insulin glargine 300 unt/ml pen injector",
            "Insulin analog, glargine",
            "Insulin analog, glargine (Injectable)",
            "Sensor 3 ML insulin glargine 100 UNT/ML Pen Injector",
            "insulin analog, glargine",
            "insulin analog, glargine (injectable)",
            "insulin glargine 100 UNT/ML Injectable Solution",
            "insulin glargine 100 unt/ml injectable solution",
            "sensor 3 ml insulin glargine 100 unt/ml pen injector"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "At bedtime",
                "pct": "30%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rotate injection sites",
                "pct": "16%"
            },
            {
                "value": "Do not share pens",
                "pct": "15%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "44%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "21%"
            }
        ]
    },
    {
        "name": "Brimonidine",
        "route": "Ophthalmic",
        "fullName": "Brimonidine (Ophthalmic)",
        "totalCount": 109,
        "searchTerms": [
            "BRIMONIDINE",
            "Brimonidine",
            "Brimonidine (Ophthalmic)",
            "brimonidine",
            "brimonidine (ophthalmic)",
            "brimonidine tartrate 0.25 MG/ML Ophthalmic Solution",
            "brimonidine tartrate 0.25 mg/ml ophthalmic solution",
            "brimonidine tartrate 1 MG/ML Ophthalmic Solution",
            "brimonidine tartrate 1 mg/ml ophthalmic solution",
            "brimonidine tartrate 1.5 MG/ML Ophthalmic Solution",
            "brimonidine tartrate 1.5 mg/ml ophthalmic solution",
            "brimonidine tartrate 2 MG/ML Ophthalmic Solution",
            "brimonidine tartrate 2 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "55%"
            },
            {
                "value": "Three times daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [
            {
                "value": "Avoid touching dropper tip to eye or surfaces",
                "pct": "10%"
            }
        ],
        "diagnoses": [
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "38%"
            },
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "36%"
            },
            {
                "code": "H40",
                "description": "Glaucoma",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "XANAX",
        "route": "Oral Pill",
        "fullName": "XANAX (Oral Pill)",
        "totalCount": 108,
        "searchTerms": [
            "XANAX",
            "XANAX (Oral Pill)",
            "alprazolam 0.25 MG Oral Tablet",
            "alprazolam 0.25 mg oral tablet",
            "alprazolam 0.5 MG Oral Tablet",
            "alprazolam 0.5 mg oral tablet",
            "alprazolam 1 MG Oral Tablet",
            "alprazolam 1 mg oral tablet",
            "alprazolam 2 MG Oral Tablet",
            "alprazolam 2 mg oral tablet",
            "xanax",
            "xanax (oral pill)"
        ],
        "dosages": [
            {
                "value": "0.25 mg",
                "pct": "32%"
            },
            {
                "value": "0.5 mg",
                "pct": "26%"
            },
            {
                "value": "1 mg",
                "pct": "20%"
            },
            {
                "value": "2 mg",
                "pct": "10%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "31%"
            },
            {
                "value": "Twice daily",
                "pct": "17%"
            },
            {
                "value": "As needed",
                "pct": "12%"
            },
            {
                "value": "Three times daily",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "28%"
            }
        ]
    },
    {
        "name": "ANIMI-3 WITH VITAMIN D",
        "route": "Oral Pill",
        "fullName": "ANIMI-3 WITH VITAMIN D (Oral Pill)",
        "totalCount": 108,
        "searchTerms": [
            "ANIMI-3 WITH VITAMIN D",
            "ANIMI-3 WITH VITAMIN D (Oral Pill)",
            "animi-3 with vitamin d",
            "animi-3 with vitamin d (oral pill)",
            "cholecalciferol 1000 UNT / folic acid 1 MG / omega-3 acid ethyl esters (USP) 500 MG / phytosterols 200 MG / pyridoxine hydrochloride 12.5 MG / vitamin B12 0.5 MG Oral Capsule",
            "cholecalciferol 1000 unt / folic acid 1 mg / omega-3 acid ethyl esters (usp) 500 mg / phytosterols 200 mg / pyridoxine hydrochloride 12.5 mg / vitamin b12 0.5 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "76%"
            },
            {
                "value": "Weekly",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "47%"
            },
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "33%"
            },
            {
                "code": "E55",
                "description": "Vitamin D deficiency",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "NAMENDA",
        "route": "Oral Pill",
        "fullName": "NAMENDA (Oral Pill)",
        "totalCount": 108,
        "searchTerms": [
            "NAMENDA",
            "NAMENDA (Oral Pill)",
            "memantine hydrochloride 10 MG Oral Tablet",
            "memantine hydrochloride 10 mg oral tablet",
            "memantine hydrochloride 5 MG Oral Tablet",
            "memantine hydrochloride 5 mg oral tablet",
            "namenda",
            "namenda (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "67%"
            },
            {
                "value": "5 mg",
                "pct": "29%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "56%"
            },
            {
                "value": "Twice daily",
                "pct": "31%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G30.9",
                "description": "Alzheimer's disease, unspecified",
                "pct": "57%"
            }
        ]
    },
    {
        "name": "HALDOL",
        "route": "Injectable",
        "fullName": "HALDOL (Injectable)",
        "totalCount": 107,
        "searchTerms": [
            "1 ML haloperidol 5 MG/ML Injection",
            "1 ML haloperidol decanoate 100 MG/ML Injection",
            "1 ML haloperidol decanoate 50 MG/ML Injection",
            "1 ml haloperidol 5 mg/ml injection",
            "1 ml haloperidol decanoate 100 mg/ml injection",
            "1 ml haloperidol decanoate 50 mg/ml injection",
            "HALDOL",
            "HALDOL (Injectable)",
            "Haldol",
            "haldol",
            "haldol (injectable)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "32%"
            },
            {
                "value": "5 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Monthly",
                "pct": "50%"
            },
            {
                "value": "Once daily",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "56%"
            }
        ]
    },
    {
        "name": "COREG",
        "route": "Oral Pill",
        "fullName": "COREG (Oral Pill)",
        "totalCount": 105,
        "searchTerms": [
            "COREG",
            "COREG (Oral Pill)",
            "Coreg",
            "Coreg (Oral)",
            "carvedilol 12.5 MG Oral Tablet",
            "carvedilol 12.5 mg oral tablet",
            "carvedilol 25 MG Oral Tablet",
            "carvedilol 25 mg oral tablet",
            "carvedilol 3.125 MG Oral Tablet",
            "carvedilol 3.125 mg oral tablet",
            "carvedilol 6.25 MG Oral Tablet",
            "carvedilol 6.25 mg oral tablet",
            "coreg",
            "coreg (oral pill)",
            "coreg (oral)"
        ],
        "dosages": [
            {
                "value": "6.25 mg",
                "pct": "27%"
            },
            {
                "value": "25 mg",
                "pct": "24%"
            },
            {
                "value": "3.125 mg",
                "pct": "24%"
            },
            {
                "value": "12.5 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "72%"
            },
            {
                "value": "Once daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Valproate XR",
        "route": "Oral Pill",
        "fullName": "Valproate XR (Oral Pill)",
        "totalCount": 105,
        "searchTerms": [
            "24 HR divalproex sodium 250 MG Extended Release Oral Tablet",
            "24 HR divalproex sodium 500 MG Extended Release Oral Tablet",
            "24 hr divalproex sodium 250 mg extended release oral tablet",
            "24 hr divalproex sodium 500 mg extended release oral tablet",
            "Valproate XR",
            "Valproate XR (Oral Pill)",
            "valproate xr",
            "valproate xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "75%"
            },
            {
                "value": "250 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "51%"
            },
            {
                "value": "Once daily",
                "pct": "30%"
            },
            {
                "value": "At bedtime",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HumaLOG",
        "route": "Injectable",
        "fullName": "HumaLOG (Injectable)",
        "totalCount": 105,
        "searchTerms": [
            "0.5 UNT Doses 3 ML insulin lispro 100 UNT/ML Pen Injector",
            "0.5 unt doses 3 ml insulin lispro 100 unt/ml pen injector",
            "3 ML insulin lispro 100 UNT/ML Cartridge",
            "3 ML insulin lispro 100 UNT/ML Pen Injector",
            "3 ML insulin lispro 200 UNT/ML Pen Injector",
            "3 ml insulin lispro 100 unt/ml cartridge",
            "3 ml insulin lispro 100 unt/ml pen injector",
            "3 ml insulin lispro 200 unt/ml pen injector",
            "HUMALOG",
            "HumaLOG",
            "HumaLOG (Injectable)",
            "humalog",
            "humalog (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "25%"
            },
            {
                "value": "With meals",
                "pct": "15%"
            },
            {
                "value": "Once daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "48%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "16%"
            }
        ]
    },
    {
        "name": "Vitamin D",
        "route": "Oral Pill",
        "fullName": "Vitamin D (Oral Pill)",
        "totalCount": 104,
        "searchTerms": [
            "DRISDOL",
            "Drisdol",
            "VITAMIN D",
            "Vitamin D",
            "Vitamin D (Oral)",
            "drisdol",
            "vitamin d",
            "vitamin d (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "49%"
            },
            {
                "value": "Weekly",
                "pct": "34%"
            }
        ],
        "adminNotes": [
            {
                "value": "lquid",
                "pct": "11%"
            }
        ],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "26%"
            }
        ]
    },
    {
        "name": "Dicyclomine",
        "route": "Oral Pill",
        "fullName": "Dicyclomine (Oral Pill)",
        "totalCount": 104,
        "searchTerms": [
            "Bentyl",
            "Dicyclomine",
            "Dicyclomine (Oral Pill)",
            "Dicyclomine (Oral)",
            "bentyl",
            "dicyclomine",
            "dicyclomine (Oral)",
            "dicyclomine (oral pill)",
            "dicyclomine (oral)",
            "dicyclomine hydrochloride 10 MG Oral Capsule",
            "dicyclomine hydrochloride 10 MG Oral Tablet",
            "dicyclomine hydrochloride 10 mg oral capsule",
            "dicyclomine hydrochloride 10 mg oral tablet",
            "dicyclomine hydrochloride 20 MG Oral Tablet",
            "dicyclomine hydrochloride 20 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "59%"
            },
            {
                "value": "20 mg",
                "pct": "37%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "34%"
            },
            {
                "value": "Twice daily",
                "pct": "21%"
            },
            {
                "value": "Three times daily",
                "pct": "16%"
            },
            {
                "value": "Four times daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K58.9",
                "description": "Irritable bowel syndrome without diarrhea",
                "pct": "52%"
            }
        ]
    },
    {
        "name": "Warfarin",
        "route": "Oral Pill",
        "fullName": "Warfarin (Oral Pill)",
        "totalCount": 102,
        "searchTerms": [
            "WARFARIN",
            "Warfarin",
            "Warfarin (Oral Pill)",
            "Warfarin (Oral)",
            "warfarin",
            "warfarin (oral pill)",
            "warfarin (oral)",
            "warfarin sodium 1 MG Oral Tablet",
            "warfarin sodium 1 mg oral tablet",
            "warfarin sodium 10 MG Oral Tablet",
            "warfarin sodium 10 mg oral tablet",
            "warfarin sodium 2 MG Oral Tablet",
            "warfarin sodium 2 mg oral tablet",
            "warfarin sodium 2.5 MG Oral Tablet",
            "warfarin sodium 2.5 mg oral tablet",
            "warfarin sodium 3 MG Oral Tablet",
            "warfarin sodium 3 mg oral tablet",
            "warfarin sodium 4 MG Oral Tablet",
            "warfarin sodium 4 mg oral tablet",
            "warfarin sodium 5 MG Oral Tablet",
            "warfarin sodium 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "24%"
            },
            {
                "value": "3 mg",
                "pct": "14%"
            },
            {
                "value": "4 mg",
                "pct": "13%"
            },
            {
                "value": "1 mg",
                "pct": "11%"
            },
            {
                "value": "2 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "65%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I48.91",
                "description": "Unspecified atrial fibrillation",
                "pct": "17%"
            },
            {
                "code": "Z95.2",
                "description": "Presence of prosthetic heart valve",
                "pct": "12%"
            },
            {
                "code": "I82.40",
                "description": "Acute embolism and thombos unsp deep veins of low extrm",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "Naproxen XR",
        "route": "Oral Pill",
        "fullName": "Naproxen XR (Oral Pill)",
        "totalCount": 102,
        "searchTerms": [
            "24 HR naproxen 375 MG Extended Release Oral Tablet",
            "24 HR naproxen 500 MG Extended Release Oral Tablet",
            "24 HR naproxen 750 MG Extended Release Oral Tablet",
            "24 hr naproxen 375 mg extended release oral tablet",
            "24 hr naproxen 500 mg extended release oral tablet",
            "24 hr naproxen 750 mg extended release oral tablet",
            "Naproxen XR",
            "Naproxen XR (Oral Pill)",
            "naproxen xr",
            "naproxen xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "85%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "38%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            },
            {
                "value": "As needed",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Colchicine",
        "route": "Oral Pill",
        "fullName": "Colchicine (Oral Pill)",
        "totalCount": 101,
        "searchTerms": [
            "COLCHICINE",
            "Colchicine",
            "Colchicine (Oral Pill)",
            "Colchicine (Oral)",
            "Colcrys",
            "colchicine",
            "colchicine (Oral)",
            "colchicine (oral pill)",
            "colchicine (oral)",
            "colchicine 0.6 MG Oral Capsule",
            "colchicine 0.6 MG Oral Tablet",
            "colchicine 0.6 mg oral capsule",
            "colchicine 0.6 mg oral tablet",
            "colcrys"
        ],
        "dosages": [
            {
                "value": "0.6 mg",
                "pct": "98%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "68%"
            },
            {
                "value": "Twice daily",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M10.9",
                "description": "Gout, unspecified",
                "pct": "51%"
            },
            {
                "code": "M10",
                "description": "Gout",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "Ondansetron",
        "route": "Oral Pill",
        "fullName": "Ondansetron (Oral Pill)",
        "totalCount": 101,
        "searchTerms": [
            "ONDANSETRON",
            "ONDANSETRON (Oral)",
            "Ondansetron",
            "Ondansetron (Oral Pill)",
            "Ondansetron (Oral)",
            "Zofran",
            "ondansetron",
            "ondansetron (Oral)",
            "ondansetron (oral pill)",
            "ondansetron (oral)",
            "ondansetron 16 MG Oral Tablet",
            "ondansetron 16 mg oral tablet",
            "ondansetron 24 MG Oral Tablet",
            "ondansetron 24 mg oral tablet",
            "ondansetron 4 MG Oral Tablet",
            "ondansetron 4 mg oral tablet",
            "ondansetron 8 MG Oral Tablet",
            "ondansetron 8 mg oral tablet",
            "zofran"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "71%"
            },
            {
                "value": "8 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "63%"
            },
            {
                "value": "Once daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R11.0",
                "description": "Nausea",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "ECPIRIN",
        "route": "Oral Pill",
        "fullName": "ECPIRIN (Oral Pill)",
        "totalCount": 100,
        "searchTerms": [
            "ECPIRIN",
            "ECPIRIN (Oral Pill)",
            "aspirin 325 MG Delayed Release Oral Tablet",
            "aspirin 325 mg delayed release oral tablet",
            "ecpirin",
            "ecpirin (oral pill)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "47%"
            },
            {
                "value": "325 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "lamoTRIgine",
        "route": "Oral Pill",
        "fullName": "lamoTRIgine (Oral Pill)",
        "totalCount": 100,
        "searchTerms": [
            "Lamictal",
            "Lamotrigine",
            "Lamotrigine (Oral)",
            "lamictal",
            "lamoTRIgine",
            "lamoTRIgine (Oral Pill)",
            "lamoTRIgine (Oral)",
            "lamotrigine",
            "lamotrigine (oral pill)",
            "lamotrigine (oral)",
            "lamotrigine 100 MG Oral Tablet",
            "lamotrigine 100 mg oral tablet",
            "lamotrigine 150 MG Oral Tablet",
            "lamotrigine 150 mg oral tablet",
            "lamotrigine 200 MG Oral Tablet",
            "lamotrigine 200 mg oral tablet",
            "lamotrigine 50 MG Oral Tablet",
            "lamotrigine 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "31%"
            },
            {
                "value": "100 mg",
                "pct": "29%"
            },
            {
                "value": "150 mg",
                "pct": "19%"
            },
            {
                "value": "25 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "56%"
            },
            {
                "value": "Twice daily",
                "pct": "35%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F31.9",
                "description": "Bipolar disorder, unspecified",
                "pct": "41%"
            },
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "38%"
            }
        ]
    },
    {
        "name": "cloNIDine",
        "route": "Oral Pill",
        "fullName": "cloNIDine (Oral Pill)",
        "totalCount": 100,
        "searchTerms": [
            "Catapres",
            "Clonidine",
            "Clonidine (Oral)",
            "catapres",
            "cloNIDine",
            "cloNIDine (Oral Pill)",
            "clonidine",
            "clonidine (Oral)",
            "clonidine (oral pill)",
            "clonidine (oral)",
            "clonidine hydrochloride 0.1 MG Oral Tablet",
            "clonidine hydrochloride 0.1 mg oral tablet",
            "clonidine hydrochloride 0.2 MG Oral Tablet",
            "clonidine hydrochloride 0.2 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.1 mg",
                "pct": "72%"
            },
            {
                "value": "0.2 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "36%"
            },
            {
                "value": "Once daily",
                "pct": "32%"
            },
            {
                "value": "At bedtime",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "64%"
            }
        ]
    },
    {
        "name": "Lithium carbonate",
        "route": "Oral Pill",
        "fullName": "Lithium carbonate (Oral Pill)",
        "totalCount": 100,
        "searchTerms": [
            "Eskalith CR",
            "Lithium Carbonate",
            "Lithium Carbonate (Oral)",
            "Lithium carbonate",
            "Lithium carbonate (Oral Pill)",
            "Lithobid",
            "eskalith cr",
            "lithium carbonate",
            "lithium carbonate (oral pill)",
            "lithium carbonate (oral)",
            "lithium carbonate 150 MG Oral Capsule",
            "lithium carbonate 150 mg oral capsule",
            "lithium carbonate 300 MG Oral Capsule",
            "lithium carbonate 300 MG Oral Tablet",
            "lithium carbonate 300 mg oral capsule",
            "lithium carbonate 300 mg oral tablet",
            "lithium carbonate 600 MG Oral Capsule",
            "lithium carbonate 600 mg oral capsule",
            "lithobid"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "49%"
            },
            {
                "value": "600 mg",
                "pct": "25%"
            },
            {
                "value": "150 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "45%"
            },
            {
                "value": "Twice daily",
                "pct": "33%"
            },
            {
                "value": "At bedtime",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F31.9",
                "description": "Bipolar disorder, unspecified",
                "pct": "56%"
            },
            {
                "code": "F31",
                "description": "Bipolar disorder",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "Ranolazine XR",
        "route": "Oral Pill",
        "fullName": "Ranolazine XR (Oral Pill)",
        "totalCount": 99,
        "searchTerms": [
            "12 HR ranolazine 1000 MG Extended Release Oral Tablet",
            "12 HR ranolazine 500 MG Extended Release Oral Tablet",
            "12 hr ranolazine 1000 mg extended release oral tablet",
            "12 hr ranolazine 500 mg extended release oral tablet",
            "Ranolazine XR",
            "Ranolazine XR (Oral Pill)",
            "ranolazine xr",
            "ranolazine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "84%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "68%"
            },
            {
                "value": "Once daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "47%"
            },
            {
                "code": "I20.9",
                "description": "Angina pectoris, unspecified",
                "pct": "26%"
            }
        ]
    },
    {
        "name": "Apixaban",
        "route": "Oral Pill",
        "fullName": "Apixaban (Oral Pill)",
        "totalCount": 99,
        "searchTerms": [
            "APIXABAN",
            "Apixaban",
            "Apixaban (Oral Pill)",
            "Apixaban (Oral)",
            "apixaban",
            "apixaban (Oral)",
            "apixaban (oral pill)",
            "apixaban (oral)",
            "apixaban 2.5 MG Oral Tablet",
            "apixaban 2.5 mg oral tablet",
            "apixaban 5 MG Oral Tablet",
            "apixaban 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "62%"
            },
            {
                "value": "2.5 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "56%"
            },
            {
                "value": "Every 12 hours",
                "pct": "26%"
            },
            {
                "value": "Once daily",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I48.91",
                "description": "Unspecified atrial fibrillation",
                "pct": "53%"
            },
            {
                "code": "I82.40",
                "description": "Acute embolism and thombos unsp deep veins of low extrm",
                "pct": "24%"
            }
        ]
    },
    {
        "name": "Fluticasone",
        "route": "Nasal",
        "fullName": "Fluticasone (Nasal)",
        "totalCount": 99,
        "searchTerms": [
            "Fluticasone",
            "Fluticasone (Nasal)",
            "fluticasone",
            "fluticasone (nasal)",
            "fluticasone furoate 0.0275 MG/ACTUAT Metered Dose Nasal Spray",
            "fluticasone furoate 0.0275 mg/actuat metered dose nasal spray",
            "fluticasone propionate 0.05 MG/ACTUAT Metered Dose Nasal Spray",
            "fluticasone propionate 0.05 mg/actuat metered dose nasal spray"
        ],
        "dosages": [
            {
                "value": "50 mcg",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "64%"
            },
            {
                "value": "Twice daily",
                "pct": "18%"
            },
            {
                "value": "As needed",
                "pct": "12%"
            }
        ],
        "adminNotes": [
            {
                "value": "Shake gently before use",
                "pct": "11%"
            }
        ],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "61%"
            },
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "Pantoprazole",
        "route": "Injectable",
        "fullName": "Pantoprazole (Injectable)",
        "totalCount": 98,
        "searchTerms": [
            "Pantoprazole",
            "Pantoprazole (Injectable)",
            "pantoprazole",
            "pantoprazole (injectable)",
            "pantoprazole 40 MG Injection",
            "pantoprazole 40 mg injection"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "diphenhydrAMINE",
        "route": "Oral Pill",
        "fullName": "diphenhydrAMINE (Oral Pill)",
        "totalCount": 98,
        "searchTerms": [
            "Diphenhydramine",
            "Diphenhydramine (Oral)",
            "diphenhydrAMINE",
            "diphenhydrAMINE (Oral Pill)",
            "diphenhydrAMINE (Oral)",
            "diphenhydramine",
            "diphenhydramine (oral pill)",
            "diphenhydramine (oral)",
            "diphenhydramine hydrochloride 25 MG Oral Capsule",
            "diphenhydramine hydrochloride 25 MG Oral Tablet",
            "diphenhydramine hydrochloride 25 mg oral capsule",
            "diphenhydramine hydrochloride 25 mg oral tablet",
            "diphenhydramine hydrochloride 50 MG Oral Capsule",
            "diphenhydramine hydrochloride 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "68%"
            },
            {
                "value": "50 mg",
                "pct": "29%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "31%"
            },
            {
                "value": "Once daily",
                "pct": "31%"
            },
            {
                "value": "At bedtime",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "39%"
            }
        ]
    },
    {
        "name": "Lactate",
        "route": "Topical",
        "fullName": "Lactate (Topical)",
        "totalCount": 98,
        "searchTerms": [
            "Lactate",
            "Lactate (Topical)",
            "ammonium lactate 100 MG/ML Topical Cream",
            "ammonium lactate 100 mg/ml topical cream",
            "ammonium lactate 120 MG/ML Topical Cream",
            "ammonium lactate 120 MG/ML Topical Lotion",
            "ammonium lactate 120 mg/ml topical cream",
            "ammonium lactate 120 mg/ml topical lotion",
            "ammonium lactate 50 MG/ML Topical Lotion",
            "ammonium lactate 50 mg/ml topical lotion",
            "lactate",
            "lactate (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "51%"
            },
            {
                "value": "Twice daily",
                "pct": "20%"
            },
            {
                "value": "As needed",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ascorbic acid",
        "route": "Oral Pill",
        "fullName": "Ascorbic acid (Oral Pill)",
        "totalCount": 98,
        "searchTerms": [
            "ASCORBIC ACID",
            "Ascorbic acid",
            "Ascorbic acid (Oral Pill)",
            "ascorbic acid",
            "ascorbic acid (oral pill)",
            "ascorbic acid 1000 MG Oral Capsule",
            "ascorbic acid 1000 mg oral capsule",
            "ascorbic acid 250 MG Oral Tablet",
            "ascorbic acid 250 mg oral tablet",
            "ascorbic acid 500 MG Oral Capsule",
            "ascorbic acid 500 MG Oral Tablet",
            "ascorbic acid 500 mg oral capsule",
            "ascorbic acid 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "79%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "67%"
            },
            {
                "code": "E56",
                "description": "Other vitamin deficiencies",
                "pct": "10%"
            }
        ]
    },
    {
        "name": "Clotrimazole",
        "route": "Topical",
        "fullName": "Clotrimazole (Topical)",
        "totalCount": 97,
        "searchTerms": [
            "Clotrimazole",
            "Clotrimazole (Topical)",
            "clotrimazole",
            "clotrimazole (topical)",
            "clotrimazole 10 MG/ML Topical Cream",
            "clotrimazole 10 MG/ML Topical Lotion",
            "clotrimazole 10 MG/ML Topical Solution",
            "clotrimazole 10 mg/ml topical cream",
            "clotrimazole 10 mg/ml topical lotion",
            "clotrimazole 10 mg/ml topical solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "46%"
            },
            {
                "value": "Once daily",
                "pct": "37%"
            }
        ],
        "adminNotes": [
            {
                "value": "Wash hands before and after application",
                "pct": "10%"
            }
        ],
        "diagnoses": [
            {
                "code": "B35.9",
                "description": "Dermatophytosis, unspecified",
                "pct": "44%"
            }
        ]
    },
    {
        "name": "Cetirizine",
        "route": "Oral Disintegrating",
        "fullName": "Cetirizine (Oral Disintegrating)",
        "totalCount": 97,
        "searchTerms": [
            "Cetirizine",
            "Cetirizine (Oral Disintegrating)",
            "cetirizine",
            "cetirizine (oral disintegrating)",
            "cetirizine hydrochloride 10 MG Disintegrating Oral Tablet",
            "cetirizine hydrochloride 10 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "98%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "glipiZIDE XR",
        "route": "Oral Pill",
        "fullName": "glipiZIDE XR (Oral Pill)",
        "totalCount": 97,
        "searchTerms": [
            "24 HR glipizide 10 MG Extended Release Oral Tablet",
            "24 HR glipizide 2.5 MG Extended Release Oral Tablet",
            "24 HR glipizide 5 MG Extended Release Oral Tablet",
            "24 hr glipizide 10 mg extended release oral tablet",
            "24 hr glipizide 2.5 mg extended release oral tablet",
            "24 hr glipizide 5 mg extended release oral tablet",
            "glipiZIDE XR",
            "glipiZIDE XR (Oral Pill)",
            "glipizide xr",
            "glipizide xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "35%"
            },
            {
                "value": "2.5 mg",
                "pct": "33%"
            },
            {
                "value": "5 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "66%"
            }
        ]
    },
    {
        "name": "Repaglinide",
        "route": "Oral Pill",
        "fullName": "Repaglinide (Oral Pill)",
        "totalCount": 96,
        "searchTerms": [
            "Prandin",
            "REPAGLINIDE",
            "REPAGLINIDE (Oral)",
            "Repaglinide",
            "Repaglinide (Oral Pill)",
            "Repaglinide (Oral)",
            "prandin",
            "repaglinide",
            "repaglinide (oral pill)",
            "repaglinide (oral)",
            "repaglinide 0.5 MG Oral Tablet",
            "repaglinide 0.5 mg oral tablet",
            "repaglinide 1 MG Oral Tablet",
            "repaglinide 1 mg oral tablet",
            "repaglinide 2 MG Oral Tablet",
            "repaglinide 2 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "41%"
            },
            {
                "value": "0.5 mg",
                "pct": "32%"
            },
            {
                "value": "2 mg",
                "pct": "27%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "42%"
            },
            {
                "value": "Twice daily",
                "pct": "25%"
            },
            {
                "value": "Once daily",
                "pct": "22%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "71%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "16%"
            }
        ]
    },
    {
        "name": "TRIBENZOR",
        "route": "Oral Pill",
        "fullName": "TRIBENZOR (Oral Pill)",
        "totalCount": 96,
        "searchTerms": [
            "TRIBENZOR",
            "TRIBENZOR (Oral Pill)",
            "amlodipine 10 MG / hydrochlorothiazide 25 MG / olmesartan medoxomil 40 MG Oral Tablet",
            "amlodipine 10 mg / hydrochlorothiazide 25 mg / olmesartan medoxomil 40 mg oral tablet",
            "amlodipine 5 MG / hydrochlorothiazide 12.5 MG / olmesartan medoxomil 20 MG Oral Tablet",
            "amlodipine 5 MG / hydrochlorothiazide 12.5 MG / olmesartan medoxomil 40 MG Oral Tablet",
            "amlodipine 5 MG / hydrochlorothiazide 25 MG / olmesartan medoxomil 40 MG Oral Tablet",
            "amlodipine 5 mg / hydrochlorothiazide 12.5 mg / olmesartan medoxomil 20 mg oral tablet",
            "amlodipine 5 mg / hydrochlorothiazide 12.5 mg / olmesartan medoxomil 40 mg oral tablet",
            "amlodipine 5 mg / hydrochlorothiazide 25 mg / olmesartan medoxomil 40 mg oral tablet",
            "tribenzor",
            "tribenzor (oral pill)"
        ],
        "dosages": [
            {
                "value": "5-12.5-40 mg",
                "pct": "62%"
            },
            {
                "value": "5-25-40 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Amitriptyline",
        "route": "Oral Pill",
        "fullName": "Amitriptyline (Oral Pill)",
        "totalCount": 95,
        "searchTerms": [
            "AMITRIPTYLINE",
            "Amitriptyline",
            "Amitriptyline (Oral Pill)",
            "Amitriptyline (Oral)",
            "amitriptyline",
            "amitriptyline (oral pill)",
            "amitriptyline (oral)",
            "amitriptyline hydrochloride 10 MG Oral Tablet",
            "amitriptyline hydrochloride 10 mg oral tablet",
            "amitriptyline hydrochloride 100 MG Oral Tablet",
            "amitriptyline hydrochloride 100 mg oral tablet",
            "amitriptyline hydrochloride 150 MG Oral Tablet",
            "amitriptyline hydrochloride 150 mg oral tablet",
            "amitriptyline hydrochloride 25 MG Oral Tablet",
            "amitriptyline hydrochloride 25 mg oral tablet",
            "amitriptyline hydrochloride 50 MG Oral Tablet",
            "amitriptyline hydrochloride 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "38%"
            },
            {
                "value": "25 mg",
                "pct": "28%"
            },
            {
                "value": "50 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            },
            {
                "value": "At bedtime",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "47%"
            }
        ]
    },
    {
        "name": "oxyCODONE",
        "route": "Oral Pill",
        "fullName": "oxyCODONE (Oral Pill)",
        "totalCount": 94,
        "searchTerms": [
            "OXYCODONE",
            "OXYCODONE (Oral)",
            "Oxaydo",
            "Oxycodone",
            "Oxycodone (Oral)",
            "Roxicodone",
            "oxaydo",
            "oxyCODONE",
            "oxyCODONE (Oral Pill)",
            "oxycodone",
            "oxycodone (oral pill)",
            "oxycodone (oral)",
            "oxycodone hydrochloride 15 MG Oral Tablet",
            "oxycodone hydrochloride 15 mg oral tablet",
            "oxycodone hydrochloride 20 MG Oral Tablet",
            "oxycodone hydrochloride 20 mg oral tablet",
            "oxycodone hydrochloride 30 MG Oral Tablet",
            "oxycodone hydrochloride 30 mg oral tablet",
            "oxycodone hydrochloride 5 MG Oral Capsule",
            "oxycodone hydrochloride 5 mg oral capsule",
            "roxicodone"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "51%"
            },
            {
                "value": "10 mg",
                "pct": "18%"
            },
            {
                "value": "30 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "52%"
            },
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "52%"
            }
        ]
    },
    {
        "name": "Carbidopa/Levodopa XR",
        "route": "Oral Pill",
        "fullName": "Carbidopa/Levodopa XR (Oral Pill)",
        "totalCount": 94,
        "searchTerms": [
            "8 HR carbidopa 23.75 MG / levodopa 95 MG Extended Release Oral Capsule",
            "8 HR carbidopa 36.25 MG / levodopa 145 MG Extended Release Oral Capsule",
            "8 HR carbidopa 48.75 MG / levodopa 195 MG Extended Release Oral Capsule",
            "8 HR carbidopa 61.25 MG / levodopa 245 MG Extended Release Oral Capsule",
            "8 hr carbidopa 23.75 mg / levodopa 95 mg extended release oral capsule",
            "8 hr carbidopa 36.25 mg / levodopa 145 mg extended release oral capsule",
            "8 hr carbidopa 48.75 mg / levodopa 195 mg extended release oral capsule",
            "8 hr carbidopa 61.25 mg / levodopa 245 mg extended release oral capsule",
            "Carbidopa/Levodopa XR",
            "Carbidopa/Levodopa XR (Oral Pill)",
            "carbidopa 25 MG / levodopa 100 MG Extended Release Oral Tablet",
            "carbidopa 25 mg / levodopa 100 mg extended release oral tablet",
            "carbidopa 50 MG / levodopa 200 MG Extended Release Oral Tablet",
            "carbidopa 50 mg / levodopa 200 mg extended release oral tablet",
            "carbidopa/levodopa xr",
            "carbidopa/levodopa xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "25-100 mg",
                "pct": "34%"
            },
            {
                "value": "23.75-95 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "44%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ramipril",
        "route": "Oral Pill",
        "fullName": "Ramipril (Oral Pill)",
        "totalCount": 93,
        "searchTerms": [
            "ALTACE",
            "Altace",
            "RAMIPRIL",
            "Ramipril",
            "Ramipril (Oral Pill)",
            "Ramipril (Oral)",
            "altace",
            "ramipril",
            "ramipril (oral pill)",
            "ramipril (oral)",
            "ramipril 1.25 MG Oral Tablet",
            "ramipril 1.25 mg oral tablet",
            "ramipril 10 MG Oral Capsule",
            "ramipril 10 MG Oral Tablet",
            "ramipril 10 mg oral capsule",
            "ramipril 10 mg oral tablet",
            "ramipril 2.5 MG Oral Capsule",
            "ramipril 2.5 MG Oral Tablet",
            "ramipril 2.5 mg oral capsule",
            "ramipril 2.5 mg oral tablet",
            "ramipril 5 MG Oral Capsule",
            "ramipril 5 MG Oral Tablet",
            "ramipril 5 mg oral capsule",
            "ramipril 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "43%"
            },
            {
                "value": "5 mg",
                "pct": "29%"
            },
            {
                "value": "2.5 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "65%"
            }
        ]
    },
    {
        "name": "Mirtazapine",
        "route": "Oral Disintegrating",
        "fullName": "Mirtazapine (Oral Disintegrating)",
        "totalCount": 93,
        "searchTerms": [
            "Mirtazapine",
            "Mirtazapine (Oral Disintegrating)",
            "mirtazapine",
            "mirtazapine (oral disintegrating)",
            "mirtazapine 15 MG Disintegrating Oral Tablet",
            "mirtazapine 15 mg disintegrating oral tablet",
            "mirtazapine 30 MG Disintegrating Oral Tablet",
            "mirtazapine 30 mg disintegrating oral tablet",
            "mirtazapine 45 MG Disintegrating Oral Tablet",
            "mirtazapine 45 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "59%"
            },
            {
                "value": "30 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "53%"
            },
            {
                "value": "At bedtime",
                "pct": "31%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dorzolamide/Timolol",
        "route": "Ophthalmic",
        "fullName": "Dorzolamide/Timolol (Ophthalmic)",
        "totalCount": 93,
        "searchTerms": [
            "COSOPT",
            "Dorzolamide/Timolol",
            "Dorzolamide/Timolol (Ophthalmic)",
            "Preservative-Free dorzolamide 20 MG/ML / timolol 5 MG/ML Ophthalmic Solution",
            "cosopt",
            "dorzolamide 20 MG/ML / timolol 5 MG/ML Ophthalmic Solution",
            "dorzolamide 20 mg/ml / timolol 5 mg/ml ophthalmic solution",
            "dorzolamide/timolol",
            "dorzolamide/timolol (ophthalmic)",
            "preservative-free dorzolamide 20 mg/ml / timolol 5 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "55%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "38%"
            },
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "Insulin analog, lispro",
        "route": "Injectable",
        "fullName": "Insulin analog, lispro (Injectable)",
        "totalCount": 93,
        "searchTerms": [
            "0.5 UNT Doses 3 ML insulin lispro 100 UNT/ML Pen Injector",
            "0.5 unt doses 3 ml insulin lispro 100 unt/ml pen injector",
            "3 ML insulin lispro 100 UNT/ML Cartridge",
            "3 ML insulin lispro 100 UNT/ML Pen Injector",
            "3 ML insulin lispro 200 UNT/ML Pen Injector",
            "3 ml insulin lispro 100 unt/ml cartridge",
            "3 ml insulin lispro 100 unt/ml pen injector",
            "3 ml insulin lispro 200 unt/ml pen injector",
            "Insulin analog, lispro",
            "Insulin analog, lispro (Injectable)",
            "insulin analog, lispro",
            "insulin analog, lispro (injectable)",
            "insulin lispro 100 UNT/ML Injectable Solution",
            "insulin lispro 100 unt/ml injectable solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "30%"
            },
            {
                "value": "With meals",
                "pct": "22%"
            },
            {
                "value": "Once daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "43%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "17%"
            }
        ]
    },
    {
        "name": "ZESTRIL",
        "route": "Oral Pill",
        "fullName": "ZESTRIL (Oral Pill)",
        "totalCount": 92,
        "searchTerms": [
            "ZESTRIL",
            "ZESTRIL (Oral Pill)",
            "lisinopril 10 MG Oral Tablet",
            "lisinopril 10 mg oral tablet",
            "lisinopril 2.5 MG Oral Tablet",
            "lisinopril 2.5 mg oral tablet",
            "lisinopril 20 MG Oral Tablet",
            "lisinopril 20 mg oral tablet",
            "lisinopril 40 MG Oral Tablet",
            "lisinopril 40 mg oral tablet",
            "lisinopril 5 MG Oral Tablet",
            "lisinopril 5 mg oral tablet",
            "zestril",
            "zestril (oral pill)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "39%"
            },
            {
                "value": "10 mg",
                "pct": "36%"
            },
            {
                "value": "2.5 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "REMERON",
        "route": "Oral Pill",
        "fullName": "REMERON (Oral Pill)",
        "totalCount": 92,
        "searchTerms": [
            "REMERON",
            "REMERON (Oral Pill)",
            "Remeron",
            "Remeron (Oral)",
            "mirtazapine 15 MG Oral Tablet",
            "mirtazapine 15 mg oral tablet",
            "mirtazapine 30 MG Oral Tablet",
            "mirtazapine 30 mg oral tablet",
            "mirtazapine 45 MG Oral Tablet",
            "mirtazapine 45 mg oral tablet",
            "remeron",
            "remeron (oral pill)",
            "remeron (oral)"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "63%"
            },
            {
                "value": "30 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "47%"
            },
            {
                "value": "At bedtime",
                "pct": "41%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "42%"
            }
        ]
    },
    {
        "name": "NAMZARIC XR",
        "route": "Oral Pill",
        "fullName": "NAMZARIC XR (Oral Pill)",
        "totalCount": 92,
        "searchTerms": [
            "24 HR donepezil hydrochloride 10 MG / memantine hydrochloride 14 MG Extended Release Oral Capsule",
            "24 HR donepezil hydrochloride 10 MG / memantine hydrochloride 21 MG Extended Release Oral Capsule",
            "24 HR donepezil hydrochloride 10 MG / memantine hydrochloride 28 MG Extended Release Oral Capsule",
            "24 HR donepezil hydrochloride 10 MG / memantine hydrochloride 7 MG Extended Release Oral Capsule",
            "24 hr donepezil hydrochloride 10 mg / memantine hydrochloride 14 mg extended release oral capsule",
            "24 hr donepezil hydrochloride 10 mg / memantine hydrochloride 21 mg extended release oral capsule",
            "24 hr donepezil hydrochloride 10 mg / memantine hydrochloride 28 mg extended release oral capsule",
            "24 hr donepezil hydrochloride 10 mg / memantine hydrochloride 7 mg extended release oral capsule",
            "NAMZARIC",
            "NAMZARIC XR",
            "NAMZARIC XR (Oral Pill)",
            "namzaric",
            "namzaric xr",
            "namzaric xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10-14 mg",
                "pct": "26%"
            },
            {
                "value": "10-28 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "amLODIPine/Perindopril",
        "route": "Oral Pill",
        "fullName": "amLODIPine/Perindopril (Oral Pill)",
        "totalCount": 90,
        "searchTerms": [
            "amLODIPine/Perindopril",
            "amLODIPine/Perindopril (Oral Pill)",
            "amlodipine 10 MG / perindopril arginine 14 MG Oral Tablet",
            "amlodipine 10 mg / perindopril arginine 14 mg oral tablet",
            "amlodipine 2.5 MG / perindopril arginine 3.5 MG Oral Tablet",
            "amlodipine 2.5 mg / perindopril arginine 3.5 mg oral tablet",
            "amlodipine 5 MG / perindopril arginine 7 MG Oral Tablet",
            "amlodipine 5 mg / perindopril arginine 7 mg oral tablet",
            "amlodipine/perindopril",
            "amlodipine/perindopril (oral pill)"
        ],
        "dosages": [
            {
                "value": "10-14 mg",
                "pct": "34%"
            },
            {
                "value": "5 mg",
                "pct": "23%"
            },
            {
                "value": "2.5-3.5 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Midodrine",
        "route": "Oral Pill",
        "fullName": "Midodrine (Oral Pill)",
        "totalCount": 88,
        "searchTerms": [
            "Midodrine",
            "Midodrine (Oral Pill)",
            "Midodrine (Oral)",
            "Proamatine",
            "midodrine",
            "midodrine (Oral)",
            "midodrine (oral pill)",
            "midodrine (oral)",
            "midodrine hydrochloride 10 MG Oral Tablet",
            "midodrine hydrochloride 10 mg oral tablet",
            "midodrine hydrochloride 2.5 MG Oral Tablet",
            "midodrine hydrochloride 2.5 mg oral tablet",
            "midodrine hydrochloride 5 MG Oral Tablet",
            "midodrine hydrochloride 5 mg oral tablet",
            "proamatine"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "43%"
            },
            {
                "value": "10 mg",
                "pct": "35%"
            },
            {
                "value": "2.5 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "34%"
            },
            {
                "value": "Once daily",
                "pct": "25%"
            },
            {
                "value": "Twice daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I95.1",
                "description": "Orthostatic hypotension",
                "pct": "60%"
            }
        ]
    },
    {
        "name": "Carbidopa/Levodopa",
        "route": "Oral Pill",
        "fullName": "Carbidopa/Levodopa (Oral Pill)",
        "totalCount": 87,
        "searchTerms": [
            "Carbidopa/Levodopa",
            "Carbidopa/Levodopa (Oral Pill)",
            "Carbidopa/Levodopa (Oral)",
            "Sinemet",
            "carbidopa 10 MG / levodopa 100 MG Oral Tablet",
            "carbidopa 10 mg / levodopa 100 mg oral tablet",
            "carbidopa 25 MG / levodopa 100 MG Oral Tablet",
            "carbidopa 25 MG / levodopa 250 MG Oral Tablet",
            "carbidopa 25 mg / levodopa 100 mg oral tablet",
            "carbidopa 25 mg / levodopa 250 mg oral tablet",
            "carbidopa/levodopa",
            "carbidopa/levodopa (oral pill)",
            "carbidopa/levodopa (oral)",
            "sinemet"
        ],
        "dosages": [
            {
                "value": "25-100 mg",
                "pct": "71%"
            },
            {
                "value": "10-100 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "45%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            },
            {
                "value": "Four times daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G20",
                "description": "Parkinson's disease",
                "pct": "86%"
            }
        ]
    },
    {
        "name": "Vitamin D - Supplement",
        "route": "Oral Pill",
        "fullName": "Vitamin D - Supplement (Oral Pill)",
        "totalCount": 87,
        "searchTerms": [
            "D-1000",
            "Drisdol",
            "Thera-D 2000",
            "VITAMIN D - Supplement",
            "VITAMIN D - Supplement (Oral)",
            "Vitamin D - Supplement",
            "Vitamin D - Supplement (Oral)",
            "d-1000",
            "drisdol",
            "thera-d 2000",
            "vitamin D - Supplement",
            "vitamin D - Supplement (Oral)",
            "vitamin d - supplement",
            "vitamin d - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "51%"
            },
            {
                "value": "Weekly",
                "pct": "46%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "98%"
            },
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "URO-MAG",
        "route": "Oral Pill",
        "fullName": "URO-MAG (Oral Pill)",
        "totalCount": 87,
        "searchTerms": [
            "URO-MAG",
            "URO-MAG (Oral Pill)",
            "magnesium oxide 140 MG Oral Capsule",
            "magnesium oxide 140 mg oral capsule",
            "uro-mag",
            "uro-mag (oral pill)"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "61%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Bisacodyl",
        "route": "Oral Pill",
        "fullName": "Bisacodyl (Oral Pill)",
        "totalCount": 86,
        "searchTerms": [
            "Bisacodyl",
            "Bisacodyl (Oral Pill)",
            "Bisacodyl (Oral)",
            "Dulcolax",
            "bisacodyl",
            "bisacodyl (Oral)",
            "bisacodyl (oral pill)",
            "bisacodyl (oral)",
            "bisacodyl 5 MG Delayed Release Oral Tablet",
            "bisacodyl 5 mg delayed release oral tablet",
            "dulcolax"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "76%"
            },
            {
                "value": "As needed",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "85%"
            }
        ]
    },
    {
        "name": "Meclizine",
        "route": "Oral Disintegrating",
        "fullName": "Meclizine (Oral Disintegrating)",
        "totalCount": 86,
        "searchTerms": [
            "Meclizine",
            "Meclizine (Oral Disintegrating)",
            "meclizine",
            "meclizine (oral disintegrating)",
            "meclizine hydrochloride 25 MG Disintegrating Oral Tablet",
            "meclizine hydrochloride 25 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "81%"
            },
            {
                "value": "12.5 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "44%"
            },
            {
                "value": "Three times daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TRESIBA",
        "route": "Injectable",
        "fullName": "TRESIBA (Injectable)",
        "totalCount": 86,
        "searchTerms": [
            "3 ML insulin degludec 100 UNT/ML Pen Injector",
            "3 ML insulin degludec 200 UNT/ML Pen Injector",
            "3 ml insulin degludec 100 unt/ml pen injector",
            "3 ml insulin degludec 200 unt/ml pen injector",
            "TRESIBA",
            "TRESIBA (Injectable)",
            "Tresiba",
            "insulin degludec 100 UNT/ML Injectable Solution",
            "insulin degludec 100 unt/ml injectable solution",
            "tresiba",
            "tresiba (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "57%"
            },
            {
                "value": "At bedtime",
                "pct": "14%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rotate injection sites",
                "pct": "15%"
            },
            {
                "value": "Do not share pens",
                "pct": "15%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "41%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "26%"
            }
        ]
    },
    {
        "name": "TAMSULOSIN HCL",
        "route": "Oral Pill",
        "fullName": "TAMSULOSIN HCL (Oral Pill)",
        "totalCount": 86,
        "searchTerms": [
            "FLOMAX",
            "Flomax",
            "Flomax 0.4 MG Caps",
            "TAMSULOSIN HCL",
            "TAMSULOSIN HCL (Oral)",
            "Tamsulosin HCL",
            "Tamsulosin HCL (Oral)",
            "Tamsulosin HCl",
            "Tamsulosin HCl (Oral)",
            "flomax",
            "flomax 0.4 mg caps",
            "tamsulosin HCL",
            "tamsulosin hcl",
            "tamsulosin hcl (oral)"
        ],
        "dosages": [
            {
                "value": "0.4 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            },
            {
                "value": "At bedtime",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N40.1",
                "description": "Enlarged prostate with lower urinary tract symptoms",
                "pct": "92%"
            }
        ]
    },
    {
        "name": "Lactulose",
        "route": "Oral Liquid",
        "fullName": "Lactulose (Oral Liquid)",
        "totalCount": 85,
        "searchTerms": [
            "LACTULOSE",
            "Lactulose",
            "Lactulose (Oral Liquid)",
            "lactulose",
            "lactulose (oral liquid)",
            "lactulose 667 MG/ML Oral Solution",
            "lactulose 667 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "10 g",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            },
            {
                "value": "As needed",
                "pct": "16%"
            },
            {
                "value": "Twice daily",
                "pct": "15%"
            },
            {
                "value": "Three times daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "64%"
            }
        ]
    },
    {
        "name": "Doxazosin",
        "route": "Oral Pill",
        "fullName": "Doxazosin (Oral Pill)",
        "totalCount": 84,
        "searchTerms": [
            "Doxazosin",
            "Doxazosin (Oral Pill)",
            "Doxazosin (Oral)",
            "doxazosin",
            "doxazosin (Oral)",
            "doxazosin (oral pill)",
            "doxazosin (oral)",
            "doxazosin 1 MG Oral Tablet",
            "doxazosin 1 mg oral tablet",
            "doxazosin 2 MG Oral Tablet",
            "doxazosin 2 mg oral tablet",
            "doxazosin 4 MG Oral Tablet",
            "doxazosin 4 mg oral tablet",
            "doxazosin 8 MG Oral Tablet",
            "doxazosin 8 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "38%"
            },
            {
                "value": "2 mg",
                "pct": "30%"
            },
            {
                "value": "1 mg",
                "pct": "18%"
            },
            {
                "value": "8 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "76%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "44%"
            }
        ]
    },
    {
        "name": "NIFEdipine",
        "route": "Oral Pill",
        "fullName": "NIFEdipine (Oral Pill)",
        "totalCount": 84,
        "searchTerms": [
            "Adalat CC",
            "NIFEDIPINE",
            "NIFEDIPINE (Oral)",
            "NIFEdipine",
            "NIFEdipine (Oral Pill)",
            "NIFEdipine (Oral)",
            "Nifedipine",
            "Nifedipine (Oral)",
            "PROCARDIA XL",
            "Procardia XL",
            "adalat cc",
            "nifedipine",
            "nifedipine (oral pill)",
            "nifedipine (oral)",
            "nifedipine 10 MG Oral Capsule",
            "nifedipine 10 mg oral capsule",
            "nifedipine 20 MG Oral Capsule",
            "nifedipine 20 mg oral capsule",
            "procardia xl"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "33%"
            },
            {
                "value": "30 mg",
                "pct": "19%"
            },
            {
                "value": "10 mg",
                "pct": "19%"
            },
            {
                "value": "90 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "92%"
            }
        ]
    },
    {
        "name": "Dorzolamide",
        "route": "Ophthalmic",
        "fullName": "Dorzolamide (Ophthalmic)",
        "totalCount": 84,
        "searchTerms": [
            "COSOPT",
            "Dorzolamide",
            "Dorzolamide (Ophthalmic)",
            "cosopt",
            "dorzolamide",
            "dorzolamide (ophthalmic)",
            "dorzolamide 20 MG/ML Ophthalmic Solution",
            "dorzolamide 20 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "61%"
            },
            {
                "value": "Once daily",
                "pct": "15%"
            },
            {
                "value": "Three times daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "54%"
            },
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "21%"
            },
            {
                "code": "H40",
                "description": "Glaucoma",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "Timolol",
        "route": "Ophthalmic",
        "fullName": "Timolol (Ophthalmic)",
        "totalCount": 83,
        "searchTerms": [
            "24 HR timolol 5 MG/ML Ophthalmic Solution",
            "24 hr timolol 5 mg/ml ophthalmic solution",
            "Preservative-Free timolol 2.5 MG/ML Ophthalmic Solution",
            "Preservative-Free timolol 5 MG/ML Ophthalmic Solution",
            "TIMOLOL",
            "Timolol",
            "Timolol (Ophthalmic)",
            "preservative-free timolol 2.5 mg/ml ophthalmic solution",
            "preservative-free timolol 5 mg/ml ophthalmic solution",
            "timolol",
            "timolol (ophthalmic)",
            "timolol 2.5 MG/ML Ophthalmic Solution",
            "timolol 2.5 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "42%"
            },
            {
                "value": "Once daily",
                "pct": "41%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "38%"
            },
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "28%"
            }
        ]
    },
    {
        "name": "LYRICA",
        "route": "Oral Pill",
        "fullName": "LYRICA (Oral Pill)",
        "totalCount": 83,
        "searchTerms": [
            "LYRICA",
            "LYRICA (Oral Pill)",
            "Lyrica",
            "lyrica",
            "lyrica (oral pill)",
            "pregabalin 100 MG Oral Capsule",
            "pregabalin 100 mg oral capsule",
            "pregabalin 150 MG Oral Capsule",
            "pregabalin 150 mg oral capsule",
            "pregabalin 200 MG Oral Capsule",
            "pregabalin 200 mg oral capsule",
            "pregabalin 225 MG Oral Capsule",
            "pregabalin 225 mg oral capsule",
            "pregabalin 25 MG Oral Capsule",
            "pregabalin 25 mg oral capsule",
            "pregabalin 300 MG Oral Capsule",
            "pregabalin 300 mg oral capsule",
            "pregabalin 50 MG Oral Capsule",
            "pregabalin 50 mg oral capsule",
            "pregabalin 75 MG Oral Capsule",
            "pregabalin 75 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "28%"
            },
            {
                "value": "75 mg",
                "pct": "24%"
            },
            {
                "value": "50 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "34%"
            },
            {
                "value": "Twice daily",
                "pct": "29%"
            },
            {
                "value": "Three times daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M79.7",
                "description": "Fibromyalgia",
                "pct": "30%"
            }
        ]
    },
    {
        "name": "Calcium carbonate/Cholecalciferol",
        "route": "Oral Pill",
        "fullName": "Calcium carbonate/Cholecalciferol (Oral Pill)",
        "totalCount": 82,
        "searchTerms": [
            "Calcium carbonate/Cholecalciferol",
            "Calcium carbonate/Cholecalciferol (Oral Pill)",
            "calcium carbonate 1500 MG / cholecalciferol 1000 UNT Oral Capsule",
            "calcium carbonate 1500 mg / cholecalciferol 1000 unt oral capsule",
            "calcium carbonate 2500 MG / cholecalciferol 800 UNT Oral Tablet",
            "calcium carbonate 2500 mg / cholecalciferol 800 unt oral tablet",
            "calcium carbonate 600 MG / cholecalciferol 125 UNT Oral Tablet",
            "calcium carbonate 600 mg / cholecalciferol 125 unt oral tablet",
            "calcium carbonate/cholecalciferol",
            "calcium carbonate/cholecalciferol (oral pill)"
        ],
        "dosages": [
            {
                "value": "600-0.01 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "59%"
            },
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "BYSTOLIC",
        "route": "Oral Pill",
        "fullName": "BYSTOLIC (Oral Pill)",
        "totalCount": 82,
        "searchTerms": [
            "BYSTOLIC",
            "BYSTOLIC (Oral Pill)",
            "Bystolic",
            "Bystolic (Oral)",
            "bystolic",
            "bystolic (oral pill)",
            "bystolic (oral)",
            "nebivolol 10 MG Oral Tablet",
            "nebivolol 10 mg oral tablet",
            "nebivolol 2.5 MG Oral Tablet",
            "nebivolol 2.5 mg oral tablet",
            "nebivolol 20 MG Oral Tablet",
            "nebivolol 20 mg oral tablet",
            "nebivolol 5 MG Oral Tablet",
            "nebivolol 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "45%"
            },
            {
                "value": "10 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Methocarbamol",
        "route": "Oral Pill",
        "fullName": "Methocarbamol (Oral Pill)",
        "totalCount": 80,
        "searchTerms": [
            "METHOCARBAMOL",
            "METHOCARBAMOL (Oral)",
            "Methocarbamol",
            "Methocarbamol (Oral Pill)",
            "Methocarbamol (Oral)",
            "ROBAXIN",
            "Robaxin",
            "methocarbamol",
            "methocarbamol (Oral)",
            "methocarbamol (oral pill)",
            "methocarbamol (oral)",
            "methocarbamol 500 MG Oral Tablet",
            "methocarbamol 500 mg oral tablet",
            "methocarbamol 750 MG Oral Tablet",
            "methocarbamol 750 mg oral tablet",
            "robaxin"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "66%"
            },
            {
                "value": "750 mg",
                "pct": "31%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "22%"
            },
            {
                "value": "Three times daily",
                "pct": "21%"
            },
            {
                "value": "As needed",
                "pct": "18%"
            },
            {
                "value": "Twice daily",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M62.838",
                "description": "Other muscle spasm",
                "pct": "70%"
            }
        ]
    },
    {
        "name": "ARICEPT",
        "route": "Oral Pill",
        "fullName": "ARICEPT (Oral Pill)",
        "totalCount": 80,
        "searchTerms": [
            "ARICEPT",
            "ARICEPT (Oral Pill)",
            "Aricept",
            "aricept",
            "aricept (oral pill)",
            "donepezil hydrochloride 10 MG Oral Tablet",
            "donepezil hydrochloride 10 mg oral tablet",
            "donepezil hydrochloride 23 MG Oral Tablet",
            "donepezil hydrochloride 23 mg oral tablet",
            "donepezil hydrochloride 5 MG Oral Tablet",
            "donepezil hydrochloride 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "60%"
            },
            {
                "value": "5 mg",
                "pct": "34%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "76%"
            },
            {
                "value": "At bedtime",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G30.9",
                "description": "Alzheimer's disease, unspecified",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "Venlafaxine XR",
        "route": "Oral Pill",
        "fullName": "Venlafaxine XR (Oral Pill)",
        "totalCount": 79,
        "searchTerms": [
            "24 HR venlafaxine 150 MG Extended Release Oral Capsule",
            "24 HR venlafaxine 37.5 MG Extended Release Oral Capsule",
            "24 HR venlafaxine 75 MG Extended Release Oral Capsule",
            "24 hr venlafaxine 150 mg extended release oral capsule",
            "24 hr venlafaxine 37.5 mg extended release oral capsule",
            "24 hr venlafaxine 75 mg extended release oral capsule",
            "Venlafaxine XR",
            "Venlafaxine XR (Oral Pill)",
            "Venlafaxine XR (Oral)",
            "venlafaxine xr",
            "venlafaxine xr (oral pill)",
            "venlafaxine xr (oral)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "49%"
            },
            {
                "value": "37.5 mg",
                "pct": "28%"
            },
            {
                "value": "75 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "41%"
            },
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "Vitamin D3 - Supplement",
        "route": "Oral Pill",
        "fullName": "Vitamin D3 - Supplement (Oral Pill)",
        "totalCount": 79,
        "searchTerms": [
            "Deltalin",
            "VITAMIN D3 - Supplement",
            "VITAMIN D3 - Supplement (Oral)",
            "Vitamin D-1000 (1000 IU)",
            "Vitamin D3",
            "Vitamin D3 - Supplement",
            "Vitamin D3 - Supplement (Oral)",
            "deltalin",
            "vitamin d-1000 (1000 iu)",
            "vitamin d3",
            "vitamin d3 - supplement",
            "vitamin d3 - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "50 mcg",
                "pct": "18%"
            },
            {
                "value": "25 mcg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "99%"
            },
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "Doxepin",
        "route": "Oral Pill",
        "fullName": "Doxepin (Oral Pill)",
        "totalCount": 78,
        "searchTerms": [
            "Doxepin",
            "Doxepin (Oral Pill)",
            "Doxepin (Oral)",
            "doxepin",
            "doxepin (oral pill)",
            "doxepin (oral)",
            "doxepin 6 MG Oral Tablet",
            "doxepin 6 mg oral tablet",
            "doxepin hydrochloride 10 MG Oral Capsule",
            "doxepin hydrochloride 10 mg oral capsule",
            "doxepin hydrochloride 100 MG Oral Capsule",
            "doxepin hydrochloride 100 mg oral capsule",
            "doxepin hydrochloride 150 MG Oral Capsule",
            "doxepin hydrochloride 150 mg oral capsule",
            "doxepin hydrochloride 25 MG Oral Capsule",
            "doxepin hydrochloride 25 mg oral capsule",
            "doxepin hydrochloride 50 MG Oral Capsule",
            "doxepin hydrochloride 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "31%"
            },
            {
                "value": "25 mg",
                "pct": "21%"
            },
            {
                "value": "100 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            },
            {
                "value": "At bedtime",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "52%"
            }
        ]
    },
    {
        "name": "Dapagliflozin",
        "route": "Oral Pill",
        "fullName": "Dapagliflozin (Oral Pill)",
        "totalCount": 78,
        "searchTerms": [
            "Dapagliflozin",
            "Dapagliflozin (Oral Pill)",
            "Dapagliflozin (Oral)",
            "Farxiga",
            "dapagliflozin",
            "dapagliflozin (Oral)",
            "dapagliflozin (oral pill)",
            "dapagliflozin (oral)",
            "dapagliflozin 10 MG Oral Tablet",
            "dapagliflozin 10 mg oral tablet",
            "dapagliflozin 5 MG Oral Tablet",
            "dapagliflozin 5 mg oral tablet",
            "farxiga"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "79%"
            },
            {
                "value": "5 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "96%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "65%"
            },
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "14%"
            }
        ]
    },
    {
        "name": "Isosorbide XR",
        "route": "Oral Pill",
        "fullName": "Isosorbide XR (Oral Pill)",
        "totalCount": 78,
        "searchTerms": [
            "24 HR isosorbide mononitrate 120 MG Extended Release Oral Tablet",
            "24 HR isosorbide mononitrate 30 MG Extended Release Oral Tablet",
            "24 HR isosorbide mononitrate 60 MG Extended Release Oral Tablet",
            "24 hr isosorbide mononitrate 120 mg extended release oral tablet",
            "24 hr isosorbide mononitrate 30 mg extended release oral tablet",
            "24 hr isosorbide mononitrate 60 mg extended release oral tablet",
            "Isosorbide XR",
            "Isosorbide XR (Oral Pill)",
            "isosorbide xr",
            "isosorbide xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "58%"
            },
            {
                "value": "60 mg",
                "pct": "21%"
            },
            {
                "value": "120 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "60%"
            },
            {
                "code": "I25",
                "description": "Chronic ischemic heart disease",
                "pct": "12%"
            },
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "10%"
            }
        ]
    },
    {
        "name": "Ranitidine",
        "route": "Oral Pill",
        "fullName": "Ranitidine (Oral Pill)",
        "totalCount": 78,
        "searchTerms": [
            "RANITIDINE",
            "Ranitidine",
            "Ranitidine (Oral Pill)",
            "ranitidine",
            "ranitidine (Oral)",
            "ranitidine (oral pill)",
            "ranitidine (oral)",
            "ranitidine 150 MG Oral Tablet",
            "ranitidine 150 mg oral tablet",
            "ranitidine 75 MG Oral Tablet",
            "ranitidine 75 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "87%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "72%"
            },
            {
                "value": "Twice daily",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LUMIGAN",
        "route": "Ophthalmic",
        "fullName": "LUMIGAN (Ophthalmic)",
        "totalCount": 77,
        "searchTerms": [
            "LUMIGAN",
            "LUMIGAN (Ophthalmic)",
            "bimatoprost 0.1 MG/ML Ophthalmic Solution",
            "bimatoprost 0.1 mg/ml ophthalmic solution",
            "lumigan",
            "lumigan (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "65%"
            },
            {
                "value": "At bedtime",
                "pct": "17%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "54%"
            }
        ]
    },
    {
        "name": "Hydrochlorothiazide/Valsartan",
        "route": "Oral Pill",
        "fullName": "Hydrochlorothiazide/Valsartan (Oral Pill)",
        "totalCount": 75,
        "searchTerms": [
            "Hydrochlorothiazide/Valsartan",
            "Hydrochlorothiazide/Valsartan (Oral Pill)",
            "hydroCHLOROthiazide/Valsartan",
            "hydroCHLOROthiazide/Valsartan (Oral Pill)",
            "hydrochlorothiazide 12.5 MG / valsartan 160 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / valsartan 320 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / valsartan 80 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / valsartan 160 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / valsartan 320 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / valsartan 80 mg oral tablet",
            "hydrochlorothiazide 25 MG / valsartan 160 MG Oral Tablet",
            "hydrochlorothiazide 25 MG / valsartan 320 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / valsartan 160 mg oral tablet",
            "hydrochlorothiazide 25 mg / valsartan 320 mg oral tablet",
            "hydrochlorothiazide/valsartan",
            "hydrochlorothiazide/valsartan (oral pill)"
        ],
        "dosages": [
            {
                "value": "12.5-160 mg",
                "pct": "36%"
            },
            {
                "value": "12.5-80 mg",
                "pct": "15%"
            },
            {
                "value": "12.5-320 mg",
                "pct": "13%"
            },
            {
                "value": "25-160 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "69%"
            }
        ]
    },
    {
        "name": "DOCUSATE SODIUM",
        "route": "Oral Pill",
        "fullName": "DOCUSATE SODIUM (Oral Pill)",
        "totalCount": 75,
        "searchTerms": [
            "Colace",
            "DOCUSATE SODIUM",
            "DOCUSATE SODIUM (Oral)",
            "Docusate Sodium",
            "Docusate Sodium (Oral)",
            "Docusate sodium",
            "Docusate sodium (Oral)",
            "Doss",
            "colace",
            "docusate sodium",
            "docusate sodium (Oral)",
            "docusate sodium (oral)",
            "doss"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "99%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "43%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            },
            {
                "value": "As needed",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Melatonin XR",
        "route": "Oral Pill",
        "fullName": "Melatonin XR (Oral Pill)",
        "totalCount": 74,
        "searchTerms": [
            "Melatonin XR",
            "Melatonin XR (Oral Pill)",
            "melatonin 1 MG Extended Release Oral Tablet",
            "melatonin 1 mg extended release oral tablet",
            "melatonin 10 MG Extended Release Oral Tablet",
            "melatonin 10 mg extended release oral tablet",
            "melatonin xr",
            "melatonin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "42%"
            },
            {
                "value": "3 mg",
                "pct": "24%"
            },
            {
                "value": "5 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "53%"
            },
            {
                "value": "Once daily",
                "pct": "36%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "78%"
            }
        ]
    },
    {
        "name": "Prazosin",
        "route": "Oral Pill",
        "fullName": "Prazosin (Oral Pill)",
        "totalCount": 74,
        "searchTerms": [
            "PRAZOSIN",
            "Prazosin",
            "Prazosin (Oral Pill)",
            "Prazosin (Oral)",
            "prazosin",
            "prazosin (oral pill)",
            "prazosin (oral)",
            "prazosin 1 MG Oral Capsule",
            "prazosin 1 mg oral capsule",
            "prazosin 2 MG Oral Capsule",
            "prazosin 2 mg oral capsule",
            "prazosin 5 MG Oral Capsule",
            "prazosin 5 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "46%"
            },
            {
                "value": "1 mg",
                "pct": "30%"
            },
            {
                "value": "5 mg",
                "pct": "22%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "54%"
            },
            {
                "value": "At bedtime",
                "pct": "26%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "Sevelamer",
        "route": "Oral Pill",
        "fullName": "Sevelamer (Oral Pill)",
        "totalCount": 73,
        "searchTerms": [
            "Sevelamer",
            "Sevelamer (Oral Pill)",
            "Sevelamer (Oral)",
            "sevelamer",
            "sevelamer (Oral)",
            "sevelamer (oral pill)",
            "sevelamer (oral)",
            "sevelamer carbonate 800 MG Oral Tablet",
            "sevelamer carbonate 800 mg oral tablet",
            "sevelamer hydrochloride 400 MG Oral Tablet",
            "sevelamer hydrochloride 400 mg oral tablet",
            "sevelamer hydrochloride 800 MG Oral Tablet",
            "sevelamer hydrochloride 800 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "800 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "66%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N18",
                "description": "Chronic kidney disease (CKD)",
                "pct": "23%"
            },
            {
                "code": "N18.9",
                "description": "Chronic kidney disease, unspecified",
                "pct": "23%"
            },
            {
                "code": "E83.39",
                "description": "Other disorders of phosphorus metabolism",
                "pct": "20%"
            }
        ]
    },
    {
        "name": "Calcitriol",
        "route": "Oral Pill",
        "fullName": "Calcitriol (Oral Pill)",
        "totalCount": 73,
        "searchTerms": [
            "CALCITRIOL",
            "CALCITRIOL (Oral)",
            "Calcitriol",
            "Calcitriol (Oral Pill)",
            "Calcitriol (Oral)",
            "Rocaltrol",
            "calcitriol",
            "calcitriol (oral pill)",
            "calcitriol (oral)",
            "calcitriol 0.00025 MG Oral Capsule",
            "calcitriol 0.00025 mg oral capsule",
            "calcitriol 0.0005 MG Oral Capsule",
            "calcitriol 0.0005 mg oral capsule",
            "rocaltrol"
        ],
        "dosages": [
            {
                "value": "0.25 mcg",
                "pct": "70%"
            },
            {
                "value": "0.5 mcg",
                "pct": "27%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E83.51",
                "description": "Hypocalcemia",
                "pct": "40%"
            },
            {
                "code": "N18.9",
                "description": "Chronic kidney disease, unspecified",
                "pct": "19%"
            },
            {
                "code": "M81",
                "description": "Osteoporosis without current pathological fracture",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "Alendronate",
        "route": "Effervescent",
        "fullName": "Alendronate (Effervescent)",
        "totalCount": 73,
        "searchTerms": [
            "Alendronate",
            "Alendronate (Effervescent)",
            "alendronate",
            "alendronate (effervescent)",
            "alendronic acid 70 MG Effervescent Oral Tablet",
            "alendronic acid 70 mg effervescent oral tablet"
        ],
        "dosages": [
            {
                "value": "70 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "55%"
            },
            {
                "value": "Qw",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "WELLBUTRIN XR",
        "route": "Oral Pill",
        "fullName": "WELLBUTRIN XR (Oral Pill)",
        "totalCount": 73,
        "searchTerms": [
            "12 HR bupropion hydrochloride 100 MG Extended Release Oral Tablet",
            "12 HR bupropion hydrochloride 150 MG Extended Release Oral Tablet",
            "12 HR bupropion hydrochloride 200 MG Extended Release Oral Tablet",
            "12 hr bupropion hydrochloride 100 mg extended release oral tablet",
            "12 hr bupropion hydrochloride 150 mg extended release oral tablet",
            "12 hr bupropion hydrochloride 200 mg extended release oral tablet",
            "24 HR bupropion hydrochloride 150 MG Extended Release Oral Tablet",
            "24 HR bupropion hydrochloride 300 MG Extended Release Oral Tablet",
            "24 hr bupropion hydrochloride 150 mg extended release oral tablet",
            "24 hr bupropion hydrochloride 300 mg extended release oral tablet",
            "WELLBUTRIN",
            "WELLBUTRIN XR",
            "WELLBUTRIN XR (Oral Pill)",
            "wellbutrin",
            "wellbutrin xr",
            "wellbutrin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "55%"
            },
            {
                "value": "300 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "Magnesium sulfate",
        "route": "Oral Granules",
        "fullName": "Magnesium sulfate (Oral Granules)",
        "totalCount": 73,
        "searchTerms": [
            "Magnesium sulfate",
            "Magnesium sulfate (Oral Granules)",
            "magnesium sulfate",
            "magnesium sulfate (oral granules)",
            "magnesium sulfate 1000 MG Oral Granules",
            "magnesium sulfate 1000 mg oral granules"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "48%"
            },
            {
                "value": "1 g",
                "pct": "22%"
            },
            {
                "value": "500 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ketoconazole",
        "route": "Topical",
        "fullName": "Ketoconazole (Topical)",
        "totalCount": 73,
        "searchTerms": [
            "KETOCONAZOLE",
            "Ketoconazole",
            "Ketoconazole (Topical)",
            "Nizoral",
            "ketoconazole",
            "ketoconazole (topical)",
            "ketoconazole 0.02 MG/MG Topical Gel",
            "ketoconazole 0.02 mg/mg topical gel",
            "ketoconazole 20 MG/ML Topical Cream",
            "ketoconazole 20 mg/ml topical cream",
            "nizoral"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "49%"
            },
            {
                "value": "Twice daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [
            {
                "value": "Avoid contact with eyes",
                "pct": "21%"
            },
            {
                "value": "mouth",
                "pct": "21%"
            },
            {
                "value": "and mucous membranes",
                "pct": "21%"
            }
        ],
        "diagnoses": [
            {
                "code": "B35.9",
                "description": "Dermatophytosis, unspecified",
                "pct": "25%"
            },
            {
                "code": "L21.9",
                "description": "Seborrheic dermatitis, unspecified",
                "pct": "21%"
            }
        ]
    },
    {
        "name": "Potassium chloride",
        "route": "Oral Pill",
        "fullName": "Potassium chloride (Oral Pill)",
        "totalCount": 72,
        "searchTerms": [
            "K-DUR 20",
            "K-Dur",
            "Klor-Con M20",
            "Klotrix",
            "POTASSIUM CHLORIDE",
            "POTASSIUM CHLORIDE (Oral)",
            "Potassium Chloride",
            "Potassium Chloride (Oral)",
            "Potassium chloride",
            "Potassium chloride (Oral Pill)",
            "k-dur",
            "k-dur 20",
            "klor-con m20",
            "klotrix",
            "potassium chloride",
            "potassium chloride (oral pill)",
            "potassium chloride (oral)",
            "potassium chloride 1.33 MEQ Oral Tablet",
            "potassium chloride 1.33 meq oral tablet"
        ],
        "dosages": [
            {
                "value": "10 meq",
                "pct": "44%"
            },
            {
                "value": "20 meq",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E87.6",
                "description": "Hypokalemia",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "Oxybutynin",
        "route": "Oral Pill",
        "fullName": "Oxybutynin (Oral Pill)",
        "totalCount": 72,
        "searchTerms": [
            "Ditropan XL",
            "OXYBUTYNIN",
            "Oxybutynin",
            "Oxybutynin (Oral Pill)",
            "Oxybutynin (Oral)",
            "ditropan xl",
            "oxyBUTYnin",
            "oxyBUTYnin (Oral Pill)",
            "oxybutynin",
            "oxybutynin (Oral)",
            "oxybutynin (oral pill)",
            "oxybutynin (oral)",
            "oxybutynin chloride 5 MG Oral Tablet",
            "oxybutynin chloride 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "82%"
            },
            {
                "value": "10 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "76%"
            },
            {
                "value": "Twice daily",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "63%"
            }
        ]
    },
    {
        "name": "TEARS AGAIN EYE DROPS",
        "route": "Ophthalmic",
        "fullName": "TEARS AGAIN EYE DROPS (Ophthalmic)",
        "totalCount": 72,
        "searchTerms": [
            "TEARS AGAIN EYE DROPS",
            "TEARS AGAIN EYE DROPS (Ophthalmic)",
            "polyvinyl alcohol 0.014 ML/ML Ophthalmic Solution",
            "polyvinyl alcohol 0.014 ml/ml ophthalmic solution",
            "tears again eye drops",
            "tears again eye drops (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Four times daily",
                "pct": "65%"
            },
            {
                "value": "Once daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ROSUVASTATIN CALCIUM",
        "route": "Oral Pill",
        "fullName": "ROSUVASTATIN CALCIUM (Oral Pill)",
        "totalCount": 72,
        "searchTerms": [
            "CRESTOR",
            "Crestor",
            "Crestor 20mg",
            "ROSUVASTATIN CALCIUM",
            "ROSUVASTATIN CALCIUM (Oral)",
            "Rosuvastatin Calcium",
            "Rosuvastatin Calcium (Oral)",
            "crestor",
            "crestor 20mg",
            "rosuvastatin calcium",
            "rosuvastatin calcium (oral)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "33%"
            },
            {
                "value": "40 mg",
                "pct": "28%"
            },
            {
                "value": "10 mg",
                "pct": "26%"
            },
            {
                "value": "5 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            },
            {
                "value": "At bedtime",
                "pct": "17%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "91%"
            },
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "17%"
            }
        ]
    },
    {
        "name": "ZETIA",
        "route": "Oral Pill",
        "fullName": "ZETIA (Oral Pill)",
        "totalCount": 71,
        "searchTerms": [
            "ZETIA",
            "ZETIA (Oral Pill)",
            "Zetia",
            "Zetia (Oral)",
            "ezetimibe 10 MG Oral Tablet",
            "ezetimibe 10 mg oral tablet",
            "zetia",
            "zetia (oral pill)",
            "zetia (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "97%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "53%"
            }
        ]
    },
    {
        "name": "Polyethylene glycol 3350",
        "route": "Oral Solution Powder",
        "fullName": "Polyethylene glycol 3350 (Oral Solution Powder)",
        "totalCount": 71,
        "searchTerms": [
            "MiraLAX; mix/dissolve in liquid; take 1 capful; take as directed by prescriber",
            "Polyethylene glycol 3350",
            "Polyethylene glycol 3350 (Oral Solution Powder)",
            "miralax; mix/dissolve in liquid; take 1 capful; take as directed by prescriber",
            "polyethylene glycol 3350",
            "polyethylene glycol 3350 (oral solution powder)",
            "polyethylene glycol 3350 17000 MG Powder for Oral Solution",
            "polyethylene glycol 3350 17000 mg powder for oral solution"
        ],
        "dosages": [
            {
                "value": "17 g",
                "pct": "99%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "79%"
            }
        ]
    },
    {
        "name": "KlonoPIN",
        "route": "Oral Pill",
        "fullName": "KlonoPIN (Oral Pill)",
        "totalCount": 71,
        "searchTerms": [
            "KLONOPIN",
            "KlonoPIN",
            "KlonoPIN (Oral Pill)",
            "clonazepam 0.5 MG Oral Tablet",
            "clonazepam 0.5 mg oral tablet",
            "clonazepam 1 MG Oral Tablet",
            "clonazepam 1 mg oral tablet",
            "clonazepam 2 MG Oral Tablet",
            "clonazepam 2 mg oral tablet",
            "klonopin",
            "klonopin (oral pill)"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "49%"
            },
            {
                "value": "1 mg",
                "pct": "31%"
            },
            {
                "value": "2 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "31%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Hydrochlorothiazide/Lisinopril",
        "route": "Oral Pill",
        "fullName": "Hydrochlorothiazide/Lisinopril (Oral Pill)",
        "totalCount": 70,
        "searchTerms": [
            "Hydrochlorothiazide/Lisinopril",
            "Hydrochlorothiazide/Lisinopril (Oral Pill)",
            "hydroCHLOROthiazide/Lisinopril",
            "hydroCHLOROthiazide/Lisinopril (Oral Pill)",
            "hydrochlorothiazide 12.5 MG / lisinopril 10 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / lisinopril 20 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / lisinopril 10 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / lisinopril 20 mg oral tablet",
            "hydrochlorothiazide 25 MG / lisinopril 20 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / lisinopril 20 mg oral tablet",
            "hydrochlorothiazide/lisinopril",
            "hydrochlorothiazide/lisinopril (oral pill)"
        ],
        "dosages": [
            {
                "value": "12.5-20 mg",
                "pct": "43%"
            },
            {
                "value": "12.5-10 mg",
                "pct": "30%"
            },
            {
                "value": "25-20 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "81%"
            }
        ]
    },
    {
        "name": "Isosorbide",
        "route": "Oral Pill",
        "fullName": "Isosorbide (Oral Pill)",
        "totalCount": 70,
        "searchTerms": [
            "IMDUR",
            "Isosorbide",
            "Isosorbide (Oral Pill)",
            "Isosorbide (Oral)",
            "imdur",
            "isosorbide",
            "isosorbide (oral pill)",
            "isosorbide (oral)",
            "isosorbide mononitrate 10 MG Oral Tablet",
            "isosorbide mononitrate 10 mg oral tablet",
            "isosorbide mononitrate 20 MG Oral Tablet",
            "isosorbide mononitrate 20 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "40%"
            },
            {
                "value": "10 mg",
                "pct": "24%"
            },
            {
                "value": "60 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            },
            {
                "value": "Twice daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "37%"
            }
        ]
    },
    {
        "name": "oxyCODONE XR",
        "route": "Oral Pill",
        "fullName": "oxyCODONE XR (Oral Pill)",
        "totalCount": 69,
        "searchTerms": [
            "12 HR oxycodone hydrochloride 10 MG Extended Release Oral Tablet",
            "12 HR oxycodone hydrochloride 15 MG Extended Release Oral Tablet",
            "12 HR oxycodone hydrochloride 30 MG Extended Release Oral Tablet",
            "12 hr oxycodone hydrochloride 10 mg extended release oral tablet",
            "12 hr oxycodone hydrochloride 15 mg extended release oral tablet",
            "12 hr oxycodone hydrochloride 30 mg extended release oral tablet",
            "oxyCODONE XR",
            "oxyCODONE XR (Oral Pill)",
            "oxycodone xr",
            "oxycodone xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "33%"
            },
            {
                "value": "5 mg",
                "pct": "26%"
            },
            {
                "value": "30 mg",
                "pct": "17%"
            },
            {
                "value": "15 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "38%"
            },
            {
                "value": "Once daily",
                "pct": "16%"
            },
            {
                "value": "Every 12 hours",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "33%"
            }
        ]
    },
    {
        "name": "Methotrexate",
        "route": "Oral Pill",
        "fullName": "Methotrexate (Oral Pill)",
        "totalCount": 69,
        "searchTerms": [
            "Methotrexate",
            "Methotrexate (Oral Pill)",
            "Methotrexate (Oral)",
            "Rheumatrex",
            "Rheumatrex Dose Pack",
            "methotrexate",
            "methotrexate (Oral)",
            "methotrexate (oral pill)",
            "methotrexate (oral)",
            "methotrexate 10 MG Oral Tablet",
            "methotrexate 10 mg oral tablet",
            "methotrexate 2.5 MG Oral Tablet",
            "methotrexate 2.5 mg oral tablet",
            "rheumatrex",
            "rheumatrex dose pack"
        ],
        "dosages": [
            {
                "value": "2.5 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "75%"
            },
            {
                "value": "Once daily",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M06.9",
                "description": "Rheumatoid arthritis, unspecified",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "Hydrocortisone",
        "route": "Topical",
        "fullName": "Hydrocortisone (Topical)",
        "totalCount": 69,
        "searchTerms": [
            "HYDROCORTISONE",
            "Hydrocortisone",
            "Hydrocortisone (Topical)",
            "Hytone",
            "hydrocortisone",
            "hydrocortisone (topical)",
            "hydrocortisone 0.025 MG/MG Topical Ointment",
            "hydrocortisone 0.025 mg/mg topical ointment",
            "hydrocortisone 10 MG/ML Topical Lotion",
            "hydrocortisone 10 mg/ml topical lotion",
            "hydrocortisone acetate 10 MG/ML Topical Cream",
            "hydrocortisone acetate 10 mg/ml topical cream",
            "hytone"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "45%"
            },
            {
                "value": "Once daily",
                "pct": "32%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "L30.9",
                "description": "Dermatitis, unspecified",
                "pct": "73%"
            }
        ]
    },
    {
        "name": "INCRUSE",
        "route": "Inhalant",
        "fullName": "INCRUSE (Inhalant)",
        "totalCount": 69,
        "searchTerms": [
            "30 ACTUAT umeclidinium 0.0625 MG/ACTUAT Dry Powder Inhaler",
            "30 actuat umeclidinium 0.0625 mg/actuat dry powder inhaler",
            "7 ACTUAT umeclidinium 0.0625 MG/ACTUAT Dry Powder Inhaler",
            "7 actuat umeclidinium 0.0625 mg/actuat dry powder inhaler",
            "INCRUSE",
            "INCRUSE (Inhalant)",
            "incruse",
            "incruse (inhalant)"
        ],
        "dosages": [
            {
                "value": "62.5 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "Cilostazol",
        "route": "Oral Pill",
        "fullName": "Cilostazol (Oral Pill)",
        "totalCount": 68,
        "searchTerms": [
            "Cilostazol",
            "Cilostazol (Oral Pill)",
            "Cilostazol (Oral)",
            "Pletal",
            "cilostazol",
            "cilostazol (oral pill)",
            "cilostazol (oral)",
            "cilostazol 100 MG Oral Tablet",
            "cilostazol 100 mg oral tablet",
            "cilostazol 50 MG Oral Tablet",
            "cilostazol 50 mg oral tablet",
            "pletal"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "51%"
            },
            {
                "value": "100 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "66%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I73.9",
                "description": "Peripheral vascular disease, unspecified",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "Bumetanide",
        "route": "Oral Pill",
        "fullName": "Bumetanide (Oral Pill)",
        "totalCount": 68,
        "searchTerms": [
            "Bumetanide",
            "Bumetanide (Oral Pill)",
            "Bumetanide (Oral)",
            "Bumex",
            "bumetanide",
            "bumetanide (Oral)",
            "bumetanide (oral pill)",
            "bumetanide (oral)",
            "bumetanide 0.5 MG Oral Tablet",
            "bumetanide 0.5 mg oral tablet",
            "bumetanide 1 MG Oral Tablet",
            "bumetanide 1 mg oral tablet",
            "bumetanide 2 MG Oral Tablet",
            "bumetanide 2 mg oral tablet",
            "bumex"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "47%"
            },
            {
                "value": "2 mg",
                "pct": "38%"
            },
            {
                "value": "0.5 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "63%"
            },
            {
                "value": "Twice daily",
                "pct": "26%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "53%"
            }
        ]
    },
    {
        "name": "ASPIRIN EC",
        "route": "Oral Pill",
        "fullName": "ASPIRIN EC (Oral Pill)",
        "totalCount": 68,
        "searchTerms": [
            "ASPIRIN EC",
            "ASPIRIN EC (Oral)",
            "Aspirin EC",
            "Aspirin EC (Oral)",
            "Aspirin Ec",
            "Aspirin Ec (Oral)",
            "Bayer",
            "Bayer Low Dose",
            "Bayer Low Dose Aspirin",
            "Ecotrin",
            "MAJOR",
            "aspirin ec",
            "aspirin ec (oral)",
            "bayer",
            "bayer low dose",
            "bayer low dose aspirin",
            "ecotrin",
            "major"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [
            {
                "value": "Enteric coated",
                "pct": "60%"
            },
            {
                "value": "Enteric Coated",
                "pct": "11%"
            }
        ],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "69%"
            },
            {
                "code": "Z86.73",
                "description": "Prsnl hx of TIA (TIA, 10), and cereb infrc w/o resid deficits",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "TYLENOL SINUS CONGESTION AND PAIN DAYTIME",
        "route": "Oral Pill",
        "fullName": "TYLENOL SINUS CONGESTION AND PAIN DAYTIME (Oral Pill)",
        "totalCount": 67,
        "searchTerms": [
            "TYLENOL SINUS CONGESTION AND PAIN DAYTIME",
            "TYLENOL SINUS CONGESTION AND PAIN DAYTIME (Oral Pill)",
            "acetaminophen 325 MG / phenylephrine hydrochloride 5 MG Oral Tablet",
            "acetaminophen 325 mg / phenylephrine hydrochloride 5 mg oral tablet",
            "tylenol sinus congestion and pain daytime",
            "tylenol sinus congestion and pain daytime (oral pill)"
        ],
        "dosages": [
            {
                "value": "325-5 mg",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RYBELSUS",
        "route": "Oral Pill",
        "fullName": "RYBELSUS (Oral Pill)",
        "totalCount": 67,
        "searchTerms": [
            "RYBELSUS",
            "RYBELSUS (Oral Pill)",
            "RYBELSUS (Oral)",
            "Rybelsus",
            "Rybelsus (Oral)",
            "rybelsus",
            "rybelsus (oral pill)",
            "rybelsus (oral)",
            "semaglutide 14 MG Oral Tablet",
            "semaglutide 14 mg oral tablet",
            "semaglutide 3 MG Oral Tablet",
            "semaglutide 3 mg oral tablet",
            "semaglutide 7 MG Oral Tablet",
            "semaglutide 7 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "14 mg",
                "pct": "45%"
            },
            {
                "value": "7 mg",
                "pct": "31%"
            },
            {
                "value": "3 mg",
                "pct": "22%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "96%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "50%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "Azelastine",
        "route": "Ophthalmic",
        "fullName": "Azelastine (Ophthalmic)",
        "totalCount": 67,
        "searchTerms": [
            "AZELASTINE",
            "Azelastine",
            "Azelastine (Ophthalmic)",
            "azelastine",
            "azelastine (ophthalmic)",
            "azelastine hydrochloride 0.5 MG/ML Ophthalmic Solution",
            "azelastine hydrochloride 0.5 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "60%"
            },
            {
                "value": "Once daily",
                "pct": "28%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H10.10",
                "description": "Acute atopic conjunctivitis, unspecified eye",
                "pct": "48%"
            }
        ]
    },
    {
        "name": "Levothyroxine",
        "route": "Injectable",
        "fullName": "Levothyroxine (Injectable)",
        "totalCount": 65,
        "searchTerms": [
            "5 ML levothyroxine sodium 0.1 MG/ML Injection",
            "5 ml levothyroxine sodium 0.1 mg/ml injection",
            "Levothyroxine",
            "Levothyroxine (Injectable)",
            "levothyroxine",
            "levothyroxine (injectable)",
            "levothyroxine sodium 0.1 MG Injection",
            "levothyroxine sodium 0.1 mg injection",
            "levothyroxine sodium 0.2 MG Injection",
            "levothyroxine sodium 0.2 mg injection"
        ],
        "dosages": [
            {
                "value": "0.1 mg",
                "pct": "42%"
            },
            {
                "value": "0.2 mg",
                "pct": "14%"
            },
            {
                "value": "25 mcg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "49%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Loperamide",
        "route": "Oral Pill",
        "fullName": "Loperamide (Oral Pill)",
        "totalCount": 65,
        "searchTerms": [
            "LOPERAMIDE",
            "Loperamide",
            "Loperamide (Oral Pill)",
            "Loperamide (Oral)",
            "loperamide",
            "loperamide (oral pill)",
            "loperamide (oral)",
            "loperamide hydrochloride 2 MG Oral Capsule",
            "loperamide hydrochloride 2 MG Oral Tablet",
            "loperamide hydrochloride 2 mg oral capsule",
            "loperamide hydrochloride 2 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "97%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            },
            {
                "value": "As needed",
                "pct": "35%"
            },
            {
                "value": "Twice daily",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R19.7",
                "description": "Diarrhea, unspecified",
                "pct": "61%"
            }
        ]
    },
    {
        "name": "amLODIPine/Benazepril",
        "route": "Oral Pill",
        "fullName": "amLODIPine/Benazepril (Oral Pill)",
        "totalCount": 65,
        "searchTerms": [
            "Amlodipine/Benazepril",
            "Amlodipine/Benazepril (Oral)",
            "Lotrel",
            "amLODIPine/Benazepril",
            "amLODIPine/Benazepril (Oral Pill)",
            "amlodipine 10 MG / benazepril hydrochloride 20 MG Oral Capsule",
            "amlodipine 10 MG / benazepril hydrochloride 40 MG Oral Capsule",
            "amlodipine 10 mg / benazepril hydrochloride 20 mg oral capsule",
            "amlodipine 10 mg / benazepril hydrochloride 40 mg oral capsule",
            "amlodipine 2.5 MG / benazepril hydrochloride 10 MG Oral Capsule",
            "amlodipine 2.5 mg / benazepril hydrochloride 10 mg oral capsule",
            "amlodipine 5 MG / benazepril hydrochloride 10 MG Oral Capsule",
            "amlodipine 5 MG / benazepril hydrochloride 20 MG Oral Capsule",
            "amlodipine 5 MG / benazepril hydrochloride 40 MG Oral Capsule",
            "amlodipine 5 mg / benazepril hydrochloride 10 mg oral capsule",
            "amlodipine 5 mg / benazepril hydrochloride 20 mg oral capsule",
            "amlodipine 5 mg / benazepril hydrochloride 40 mg oral capsule",
            "amlodipine/benazepril",
            "amlodipine/benazepril (oral pill)",
            "amlodipine/benazepril (oral)",
            "lotrel"
        ],
        "dosages": [
            {
                "value": "10-40 mg",
                "pct": "29%"
            },
            {
                "value": "10-20 mg",
                "pct": "17%"
            },
            {
                "value": "5-20 mg",
                "pct": "14%"
            },
            {
                "value": "5-10 mg",
                "pct": "14%"
            },
            {
                "value": "5-40 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "95%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "90%"
            }
        ]
    },
    {
        "name": "Mupirocin",
        "route": "Topical",
        "fullName": "Mupirocin (Topical)",
        "totalCount": 64,
        "searchTerms": [
            "Bactroban",
            "MUPIROCIN",
            "Mupirocin",
            "Mupirocin (Topical)",
            "bactroban",
            "mupirocin",
            "mupirocin (topical)",
            "mupirocin 0.02 MG/MG Topical Ointment",
            "mupirocin 0.02 mg/mg topical ointment",
            "mupirocin 20 MG/ML Topical Cream",
            "mupirocin 20 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "38%"
            },
            {
                "value": "Once daily",
                "pct": "34%"
            }
        ],
        "adminNotes": [
            {
                "value": "Apply a thin layer to affected area",
                "pct": "20%"
            },
            {
                "value": "Wash hands before and after application",
                "pct": "20%"
            }
        ],
        "diagnoses": [
            {
                "code": "L08.9",
                "description": "Local infection of the skin and subcutaneous tissue, unsp",
                "pct": "64%"
            }
        ]
    },
    {
        "name": "Donepezil/Memantine XR",
        "route": "Oral Pill",
        "fullName": "Donepezil/Memantine XR (Oral Pill)",
        "totalCount": 64,
        "searchTerms": [
            "24 HR donepezil hydrochloride 10 MG / memantine hydrochloride 14 MG Extended Release Oral Capsule",
            "24 HR donepezil hydrochloride 10 MG / memantine hydrochloride 21 MG Extended Release Oral Capsule",
            "24 HR donepezil hydrochloride 10 MG / memantine hydrochloride 28 MG Extended Release Oral Capsule",
            "24 HR donepezil hydrochloride 10 MG / memantine hydrochloride 7 MG Extended Release Oral Capsule",
            "24 hr donepezil hydrochloride 10 mg / memantine hydrochloride 14 mg extended release oral capsule",
            "24 hr donepezil hydrochloride 10 mg / memantine hydrochloride 21 mg extended release oral capsule",
            "24 hr donepezil hydrochloride 10 mg / memantine hydrochloride 28 mg extended release oral capsule",
            "24 hr donepezil hydrochloride 10 mg / memantine hydrochloride 7 mg extended release oral capsule",
            "Donepezil/Memantine XR",
            "Donepezil/Memantine XR (Oral Pill)",
            "donepezil/memantine xr",
            "donepezil/memantine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10-28 mg",
                "pct": "27%"
            },
            {
                "value": "10 mg",
                "pct": "25%"
            },
            {
                "value": "10-14 mg",
                "pct": "14%"
            },
            {
                "value": "10-7 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "41%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dutasteride",
        "route": "Oral Pill",
        "fullName": "Dutasteride (Oral Pill)",
        "totalCount": 64,
        "searchTerms": [
            "Dutasteride",
            "Dutasteride (Oral Pill)",
            "Dutasteride (Oral)",
            "dutasteride",
            "dutasteride (oral pill)",
            "dutasteride (oral)",
            "dutasteride 0.5 MG Oral Capsule",
            "dutasteride 0.5 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "97%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NAMENDA XR",
        "route": "Oral Pill",
        "fullName": "NAMENDA XR (Oral Pill)",
        "totalCount": 64,
        "searchTerms": [
            "24 HR memantine hydrochloride 14 MG Extended Release Oral Capsule",
            "24 HR memantine hydrochloride 21 MG Extended Release Oral Capsule",
            "24 HR memantine hydrochloride 28 MG Extended Release Oral Capsule",
            "24 HR memantine hydrochloride 7 MG Extended Release Oral Capsule",
            "24 hr memantine hydrochloride 14 mg extended release oral capsule",
            "24 hr memantine hydrochloride 21 mg extended release oral capsule",
            "24 hr memantine hydrochloride 28 mg extended release oral capsule",
            "24 hr memantine hydrochloride 7 mg extended release oral capsule",
            "NAMENDA",
            "NAMENDA XR",
            "NAMENDA XR (Oral Pill)",
            "namenda",
            "namenda xr",
            "namenda xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "28 mg",
                "pct": "31%"
            },
            {
                "value": "14 mg",
                "pct": "30%"
            },
            {
                "value": "21 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Simvastatin",
        "route": "Oral Liquid",
        "fullName": "Simvastatin (Oral Liquid)",
        "totalCount": 63,
        "searchTerms": [
            "Simvastatin",
            "Simvastatin (Oral Liquid)",
            "simvastatin",
            "simvastatin (oral liquid)",
            "simvastatin 4 MG/ML Oral Suspension",
            "simvastatin 4 mg/ml oral suspension",
            "simvastatin 8 MG/ML Oral Suspension",
            "simvastatin 8 mg/ml oral suspension"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "56%"
            },
            {
                "value": "40 mg",
                "pct": "25%"
            },
            {
                "value": "10 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "51%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Melatonin",
        "route": "Oral Disintegrating",
        "fullName": "Melatonin (Oral Disintegrating)",
        "totalCount": 63,
        "searchTerms": [
            "Melatonin",
            "Melatonin (Oral Disintegrating)",
            "melatonin",
            "melatonin (oral disintegrating)",
            "melatonin 10 MG Disintegrating Oral Tablet",
            "melatonin 10 mg disintegrating oral tablet",
            "melatonin 3 MG Disintegrating Oral Tablet",
            "melatonin 3 mg disintegrating oral tablet",
            "melatonin 5 MG Disintegrating Oral Tablet",
            "melatonin 5 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "56%"
            },
            {
                "value": "3 mg",
                "pct": "37%"
            }
        ],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "43%"
            },
            {
                "value": "Once daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LEVEMIR",
        "route": "Injectable",
        "fullName": "LEVEMIR (Injectable)",
        "totalCount": 62,
        "searchTerms": [
            "3 ML insulin detemir 100 UNT/ML Pen Injector",
            "3 ml insulin detemir 100 unt/ml pen injector",
            "LEVEMIR",
            "LEVEMIR (Injectable)",
            "Levemir",
            "insulin detemir 100 UNT/ML Injectable Solution",
            "insulin detemir 100 unt/ml injectable solution",
            "levemir",
            "levemir (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "35%"
            },
            {
                "value": "At bedtime",
                "pct": "21%"
            },
            {
                "value": "Twice daily",
                "pct": "16%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Venlafaxine",
        "route": "Oral Pill",
        "fullName": "Venlafaxine (Oral Pill)",
        "totalCount": 62,
        "searchTerms": [
            "VENLAFAXINE",
            "Venlafaxine",
            "Venlafaxine (Oral Pill)",
            "Venlafaxine (Oral)",
            "venlafaxine",
            "venlafaxine (oral pill)",
            "venlafaxine (oral)",
            "venlafaxine 100 MG Oral Tablet",
            "venlafaxine 100 mg oral tablet",
            "venlafaxine 25 MG Oral Tablet",
            "venlafaxine 25 mg oral tablet",
            "venlafaxine 50 MG Oral Tablet",
            "venlafaxine 50 mg oral tablet",
            "venlafaxine 75 MG Oral Tablet",
            "venlafaxine 75 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "75 mg",
                "pct": "50%"
            },
            {
                "value": "100 mg",
                "pct": "13%"
            },
            {
                "value": "37.5 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "76%"
            },
            {
                "value": "Twice daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "56%"
            }
        ]
    },
    {
        "name": "FOLACIN",
        "route": "Oral Pill",
        "fullName": "FOLACIN (Oral Pill)",
        "totalCount": 62,
        "searchTerms": [
            "FOLACIN",
            "FOLACIN (Oral Pill)",
            "folacin",
            "folacin (oral pill)",
            "folic acid 0.8 MG Oral Tablet",
            "folic acid 0.8 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "81%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CYMBALTA",
        "route": "Oral Pill",
        "fullName": "CYMBALTA (Oral Pill)",
        "totalCount": 61,
        "searchTerms": [
            "CYMBALTA",
            "CYMBALTA (Oral Pill)",
            "Cymbalta",
            "Cymbalta (Oral)",
            "cymbalta",
            "cymbalta (oral pill)",
            "cymbalta (oral)",
            "duloxetine 20 MG Delayed Release Oral Capsule",
            "duloxetine 20 mg delayed release oral capsule",
            "duloxetine 30 MG Delayed Release Oral Capsule",
            "duloxetine 30 mg delayed release oral capsule",
            "duloxetine 60 MG Delayed Release Oral Capsule",
            "duloxetine 60 mg delayed release oral capsule"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "51%"
            },
            {
                "value": "30 mg",
                "pct": "26%"
            },
            {
                "value": "20 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "valACYclovir",
        "route": "Oral Pill",
        "fullName": "valACYclovir (Oral Pill)",
        "totalCount": 61,
        "searchTerms": [
            "Valacyclovir",
            "Valacyclovir (Oral)",
            "Valtrex",
            "valACYclovir",
            "valACYclovir (Oral Pill)",
            "valACYclovir (Oral)",
            "valacyclovir",
            "valacyclovir (oral pill)",
            "valacyclovir (oral)",
            "valacyclovir 1000 MG Oral Tablet",
            "valacyclovir 1000 mg oral tablet",
            "valacyclovir 500 MG Oral Tablet",
            "valacyclovir 500 mg oral tablet",
            "valtrex"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "61%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "64%"
            },
            {
                "value": "Twice daily",
                "pct": "16%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B00.9",
                "description": "Herpesviral infection, unspecified",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "Calcium citrate/Cholecalciferol",
        "route": "Oral Pill",
        "fullName": "Calcium citrate/Cholecalciferol (Oral Pill)",
        "totalCount": 61,
        "searchTerms": [
            "Calcium citrate/Cholecalciferol",
            "Calcium citrate/Cholecalciferol (Oral Pill)",
            "calcium citrate 250 MG / cholecalciferol 100 UNT Oral Tablet",
            "calcium citrate 250 mg / cholecalciferol 100 unt oral tablet",
            "calcium citrate/cholecalciferol",
            "calcium citrate/cholecalciferol (oral pill)"
        ],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            },
            {
                "value": "Twice daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "28%"
            }
        ]
    },
    {
        "name": "Topiramate XR",
        "route": "Oral Pill",
        "fullName": "Topiramate XR (Oral Pill)",
        "totalCount": 61,
        "searchTerms": [
            "24 HR topiramate 100 MG Extended Release Oral Capsule",
            "24 HR topiramate 200 MG Extended Release Oral Capsule",
            "24 HR topiramate 25 MG Extended Release Oral Capsule",
            "24 HR topiramate 50 MG Extended Release Oral Capsule",
            "24 hr topiramate 100 mg extended release oral capsule",
            "24 hr topiramate 200 mg extended release oral capsule",
            "24 hr topiramate 25 mg extended release oral capsule",
            "24 hr topiramate 50 mg extended release oral capsule",
            "Topiramate XR",
            "Topiramate XR (Oral Pill)",
            "topiramate xr",
            "topiramate xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "43%"
            },
            {
                "value": "50 mg",
                "pct": "31%"
            },
            {
                "value": "25 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "41%"
            },
            {
                "value": "Twice daily",
                "pct": "34%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Telmisartan",
        "route": "Oral Pill",
        "fullName": "Telmisartan (Oral Pill)",
        "totalCount": 61,
        "searchTerms": [
            "Micardis",
            "TELMISARTAN",
            "TELMISARTAN (Oral)",
            "Telmisartan",
            "Telmisartan (Oral Pill)",
            "Telmisartan (Oral)",
            "micardis",
            "telmisartan",
            "telmisartan (oral pill)",
            "telmisartan (oral)",
            "telmisartan 20 MG Oral Tablet",
            "telmisartan 20 mg oral tablet",
            "telmisartan 40 MG Oral Tablet",
            "telmisartan 40 mg oral tablet",
            "telmisartan 80 MG Oral Tablet",
            "telmisartan 80 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "46%"
            },
            {
                "value": "80 mg",
                "pct": "39%"
            },
            {
                "value": "20 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "95%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "79%"
            }
        ]
    },
    {
        "name": "COZAAR",
        "route": "Oral Pill",
        "fullName": "COZAAR (Oral Pill)",
        "totalCount": 60,
        "searchTerms": [
            "COZAAR",
            "COZAAR (Oral Pill)",
            "Cozaar",
            "Cozaar (Oral)",
            "cozaar",
            "cozaar (oral pill)",
            "cozaar (oral)",
            "losartan potassium 100 MG Oral Tablet",
            "losartan potassium 100 mg oral tablet",
            "losartan potassium 25 MG Oral Tablet",
            "losartan potassium 25 mg oral tablet",
            "losartan potassium 50 MG Oral Tablet",
            "losartan potassium 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "45%"
            },
            {
                "value": "50 mg",
                "pct": "28%"
            },
            {
                "value": "25 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Hydroxychloroquine",
        "route": "Oral Pill",
        "fullName": "Hydroxychloroquine (Oral Pill)",
        "totalCount": 60,
        "searchTerms": [
            "Hydroxychloroquine",
            "Hydroxychloroquine (Oral Pill)",
            "Hydroxychloroquine (Oral)",
            "PLAQUENIL",
            "hydroxychloroquine",
            "hydroxychloroquine (oral pill)",
            "hydroxychloroquine (oral)",
            "hydroxychloroquine sulfate 200 MG Oral Tablet",
            "hydroxychloroquine sulfate 200 mg oral tablet",
            "plaquenil"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "98%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "53%"
            },
            {
                "value": "Twice daily",
                "pct": "37%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M06.9",
                "description": "Rheumatoid arthritis, unspecified",
                "pct": "63%"
            }
        ]
    },
    {
        "name": "Olopatadine",
        "route": "Ophthalmic",
        "fullName": "Olopatadine (Ophthalmic)",
        "totalCount": 60,
        "searchTerms": [
            "Olopatadine",
            "Olopatadine (Ophthalmic)",
            "olopatadine",
            "olopatadine (ophthalmic)",
            "olopatadine 1 MG/ML Ophthalmic Solution",
            "olopatadine 1 mg/ml ophthalmic solution",
            "olopatadine 2 MG/ML Ophthalmic Solution",
            "olopatadine 2 mg/ml ophthalmic solution",
            "olopatadine 7 MG/ML Ophthalmic Solution",
            "olopatadine 7 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "52%"
            },
            {
                "value": "Twice daily",
                "pct": "43%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H10.10",
                "description": "Acute atopic conjunctivitis, unspecified eye",
                "pct": "42%"
            }
        ]
    },
    {
        "name": "levETIRAcetam",
        "route": "Oral Suspension Tablet",
        "fullName": "levETIRAcetam (Oral Suspension Tablet)",
        "totalCount": 60,
        "searchTerms": [
            "levETIRAcetam",
            "levETIRAcetam (Oral Suspension Tablet)",
            "levetiracetam",
            "levetiracetam (oral suspension tablet)",
            "levetiracetam 1000 MG Tablet for Oral Suspension",
            "levetiracetam 1000 mg tablet for oral suspension",
            "levetiracetam 250 MG Tablet for Oral Suspension",
            "levetiracetam 250 mg tablet for oral suspension",
            "levetiracetam 500 MG Tablet for Oral Suspension",
            "levetiracetam 500 mg tablet for oral suspension",
            "levetiracetam 750 MG Tablet for Oral Suspension",
            "levetiracetam 750 mg tablet for oral suspension"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "42%"
            },
            {
                "value": "750 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "55%"
            },
            {
                "value": "Once daily",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Irbesartan",
        "route": "Oral Pill",
        "fullName": "Irbesartan (Oral Pill)",
        "totalCount": 60,
        "searchTerms": [
            "Avapro",
            "IRBESARTAN",
            "Irbesartan",
            "Irbesartan (Oral Pill)",
            "Irbesartan (Oral)",
            "avapro",
            "irbesartan",
            "irbesartan (oral pill)",
            "irbesartan (oral)",
            "irbesartan 150 MG Oral Tablet",
            "irbesartan 150 mg oral tablet",
            "irbesartan 300 MG Oral Tablet",
            "irbesartan 300 mg oral tablet",
            "irbesartan 75 MG Oral Tablet",
            "irbesartan 75 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "45%"
            },
            {
                "value": "300 mg",
                "pct": "42%"
            },
            {
                "value": "75 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "77%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "63%"
            }
        ]
    },
    {
        "name": "FLOVENT",
        "route": "Inhalant",
        "fullName": "FLOVENT (Inhalant)",
        "totalCount": 60,
        "searchTerms": [
            "120 ACTUAT fluticasone propionate 0.044 MG/ACTUAT Metered Dose Inhaler",
            "120 ACTUAT fluticasone propionate 0.11 MG/ACTUAT Metered Dose Inhaler",
            "120 ACTUAT fluticasone propionate 0.22 MG/ACTUAT Metered Dose Inhaler",
            "120 actuat fluticasone propionate 0.044 mg/actuat metered dose inhaler",
            "120 actuat fluticasone propionate 0.11 mg/actuat metered dose inhaler",
            "120 actuat fluticasone propionate 0.22 mg/actuat metered dose inhaler",
            "28 ACTUAT fluticasone propionate 0.25 MG/ACTUAT Dry Powder Inhaler",
            "28 actuat fluticasone propionate 0.25 mg/actuat dry powder inhaler",
            "60 ACTUAT fluticasone propionate 0.05 MG/ACTUAT Dry Powder Inhaler",
            "60 ACTUAT fluticasone propionate 0.1 MG/ACTUAT Dry Powder Inhaler",
            "60 ACTUAT fluticasone propionate 0.25 MG/ACTUAT Dry Powder Inhaler",
            "60 actuat fluticasone propionate 0.05 mg/actuat dry powder inhaler",
            "60 actuat fluticasone propionate 0.1 mg/actuat dry powder inhaler",
            "60 actuat fluticasone propionate 0.25 mg/actuat dry powder inhaler",
            "FLOVENT",
            "FLOVENT (Inhalant)",
            "flovent",
            "flovent (inhalant)"
        ],
        "dosages": [
            {
                "value": "110 mcg",
                "pct": "28%"
            },
            {
                "value": "250 mcg",
                "pct": "25%"
            },
            {
                "value": "44 mcg",
                "pct": "12%"
            },
            {
                "value": "100 mcg",
                "pct": "10%"
            },
            {
                "value": "220 mcg",
                "pct": "10%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "43%"
            },
            {
                "value": "Twice daily",
                "pct": "40%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Sennosides, USP",
        "route": "Oral Pill",
        "fullName": "Sennosides, USP (Oral Pill)",
        "totalCount": 60,
        "searchTerms": [
            "Sennosides, USP",
            "Sennosides, USP (Oral Pill)",
            "sennosides, USP 15 MG Oral Tablet",
            "sennosides, usp",
            "sennosides, usp (oral pill)",
            "sennosides, usp 15 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "8.6 mg",
                "pct": "80%"
            },
            {
                "value": "17.2 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            },
            {
                "value": "At bedtime",
                "pct": "28%"
            },
            {
                "value": "Twice daily",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "65%"
            }
        ]
    },
    {
        "name": "Methadone",
        "route": "Oral Pill",
        "fullName": "Methadone (Oral Pill)",
        "totalCount": 60,
        "searchTerms": [
            "Methadone",
            "Methadone (Oral Pill)",
            "Methadone (Oral)",
            "methadone",
            "methadone (oral pill)",
            "methadone (oral)",
            "methadone hydrochloride 10 MG Oral Tablet",
            "methadone hydrochloride 10 mg oral tablet",
            "methadone hydrochloride 5 MG Oral Tablet",
            "methadone hydrochloride 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "37%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            },
            {
                "value": "Twice daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "40%"
            }
        ]
    },
    {
        "name": "Topiramate",
        "route": "Oral Pill",
        "fullName": "Topiramate (Oral Pill)",
        "totalCount": 60,
        "searchTerms": [
            "TOPAMAX",
            "TOPIRAMATE",
            "Topamax",
            "Topiramate",
            "Topiramate (Oral Pill)",
            "Topiramate (Oral)",
            "topamax",
            "topiramate",
            "topiramate (oral pill)",
            "topiramate (oral)",
            "topiramate 25 MG Oral Tablet",
            "topiramate 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "32%"
            },
            {
                "value": "100 mg",
                "pct": "30%"
            },
            {
                "value": "25 mg",
                "pct": "27%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "45%"
            },
            {
                "value": "Twice daily",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "60%"
            },
            {
                "code": "G43",
                "description": "Migraine",
                "pct": "11%"
            }
        ]
    },
    {
        "name": "BENADRYL",
        "route": "Oral Pill",
        "fullName": "BENADRYL (Oral Pill)",
        "totalCount": 59,
        "searchTerms": [
            "BENADRYL",
            "BENADRYL (Oral Pill)",
            "benadryl",
            "benadryl (oral pill)",
            "diphenhydramine hydrochloride 25 MG Oral Capsule",
            "diphenhydramine hydrochloride 25 MG Oral Tablet",
            "diphenhydramine hydrochloride 25 mg oral capsule",
            "diphenhydramine hydrochloride 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "80%"
            },
            {
                "value": "50 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "34%"
            },
            {
                "value": "At bedtime",
                "pct": "32%"
            },
            {
                "value": "Once daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "43%"
            }
        ]
    },
    {
        "name": "Nortriptyline",
        "route": "Oral Pill",
        "fullName": "Nortriptyline (Oral Pill)",
        "totalCount": 59,
        "searchTerms": [
            "NORTRIPTYLINE",
            "Nortriptyline",
            "Nortriptyline (Oral Pill)",
            "Nortriptyline (Oral)",
            "Pamelor",
            "nortriptyline",
            "nortriptyline (oral pill)",
            "nortriptyline (oral)",
            "nortriptyline 10 MG Oral Capsule",
            "nortriptyline 10 mg oral capsule",
            "nortriptyline 25 MG Oral Capsule",
            "nortriptyline 25 mg oral capsule",
            "nortriptyline 50 MG Oral Capsule",
            "nortriptyline 50 mg oral capsule",
            "nortriptyline 75 MG Oral Capsule",
            "nortriptyline 75 mg oral capsule",
            "pamelor"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "37%"
            },
            {
                "value": "10 mg",
                "pct": "34%"
            },
            {
                "value": "50 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "66%"
            },
            {
                "value": "At bedtime",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "59%"
            }
        ]
    },
    {
        "name": "COMBIVENT",
        "route": "Inhalant",
        "fullName": "COMBIVENT (Inhalant)",
        "totalCount": 59,
        "searchTerms": [
            "120 ACTUAT albuterol 0.1 MG/ACTUAT / ipratropium bromide 0.02 MG/ACTUAT Inhalation Spray",
            "120 actuat albuterol 0.1 mg/actuat / ipratropium bromide 0.02 mg/actuat inhalation spray",
            "COMBIVENT",
            "COMBIVENT (Inhalant)",
            "combivent",
            "combivent (inhalant)"
        ],
        "dosages": [
            {
                "value": "100-20 mcg",
                "pct": "92%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "24%"
            },
            {
                "value": "Four times daily",
                "pct": "20%"
            },
            {
                "value": "Once daily",
                "pct": "20%"
            },
            {
                "value": "Twice daily",
                "pct": "17%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ADVIL COLD AND SINUS",
        "route": "Oral Pill",
        "fullName": "ADVIL COLD AND SINUS (Oral Pill)",
        "totalCount": 59,
        "searchTerms": [
            "ADVIL COLD AND SINUS",
            "ADVIL COLD AND SINUS (Oral Pill)",
            "advil cold and sinus",
            "advil cold and sinus (oral pill)",
            "ibuprofen 200 MG / pseudoephedrine hydrochloride 30 MG Oral Capsule",
            "ibuprofen 200 MG / pseudoephedrine hydrochloride 30 MG Oral Tablet",
            "ibuprofen 200 mg / pseudoephedrine hydrochloride 30 mg oral capsule",
            "ibuprofen 200 mg / pseudoephedrine hydrochloride 30 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "200-30 mg",
                "pct": "88%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "14%"
            },
            {
                "value": "Twice daily",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "COMBIGAN",
        "route": "Ophthalmic",
        "fullName": "COMBIGAN (Ophthalmic)",
        "totalCount": 59,
        "searchTerms": [
            "COMBIGAN",
            "COMBIGAN (Ophthalmic)",
            "brimonidine tartrate 2 MG/ML / timolol 5 MG/ML Ophthalmic Solution",
            "brimonidine tartrate 2 mg/ml / timolol 5 mg/ml ophthalmic solution",
            "combigan",
            "combigan (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "75%"
            },
            {
                "value": "Once daily",
                "pct": "17%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "46%"
            },
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "27%"
            }
        ]
    },
    {
        "name": "DONEPEZIL HCL",
        "route": "Oral Pill",
        "fullName": "DONEPEZIL HCL (Oral Pill)",
        "totalCount": 59,
        "searchTerms": [
            "Aricept",
            "Aricept 5 mg",
            "DONEPEZIL HCL",
            "DONEPEZIL HCL (Oral)",
            "Donepezil HCL",
            "Donepezil HCL (Oral)",
            "Donepezil HCl",
            "Donepezil HCl (Oral)",
            "aricept",
            "aricept 5 mg",
            "donepezil hcl",
            "donepezil hcl (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "53%"
            },
            {
                "value": "5 mg",
                "pct": "46%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            },
            {
                "value": "At bedtime",
                "pct": "10%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G30.9",
                "description": "Alzheimer's disease, unspecified",
                "pct": "92%"
            }
        ]
    },
    {
        "name": "Diltiazem XR",
        "route": "Oral Pill",
        "fullName": "Diltiazem XR (Oral Pill)",
        "totalCount": 58,
        "searchTerms": [
            "24 HR diltiazem hydrochloride 240 MG Extended Release Oral Capsule",
            "24 HR diltiazem hydrochloride 300 MG Extended Release Oral Capsule",
            "24 HR diltiazem hydrochloride 360 MG Extended Release Oral Capsule",
            "24 hr diltiazem hydrochloride 240 mg extended release oral capsule",
            "24 hr diltiazem hydrochloride 300 mg extended release oral capsule",
            "24 hr diltiazem hydrochloride 360 mg extended release oral capsule",
            "Diltiazem XR",
            "Diltiazem XR (Oral Pill)",
            "dilTIAZem XR",
            "dilTIAZem XR (Oral Pill)",
            "diltiazem xr",
            "diltiazem xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "120 mg",
                "pct": "29%"
            },
            {
                "value": "240 mg",
                "pct": "28%"
            },
            {
                "value": "180 mg",
                "pct": "16%"
            },
            {
                "value": "300 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "Nystatin",
        "route": "Topical",
        "fullName": "Nystatin (Topical)",
        "totalCount": 57,
        "searchTerms": [
            "Nystatin",
            "Nystatin (Topical)",
            "nystatin",
            "nystatin (topical)",
            "nystatin 100 UNT/MG Topical Ointment",
            "nystatin 100 UNT/MG Topical Powder",
            "nystatin 100 unt/mg topical ointment",
            "nystatin 100 unt/mg topical powder",
            "nystatin 100000 UNT/ML Topical Cream",
            "nystatin 100000 unt/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "39%"
            },
            {
                "value": "Once daily",
                "pct": "37%"
            },
            {
                "value": "As needed",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B37.2",
                "description": "Candidiasis of skin and nail",
                "pct": "42%"
            },
            {
                "code": "B37.9",
                "description": "Candidiasis, unspecified",
                "pct": "21%"
            }
        ]
    },
    {
        "name": "metFORMIN/sitaGLIPtin XR",
        "route": "Oral Pill",
        "fullName": "metFORMIN/sitaGLIPtin XR (Oral Pill)",
        "totalCount": 57,
        "searchTerms": [
            "24 HR metformin hydrochloride 1000 MG / sitagliptin 100 MG Extended Release Oral Tablet",
            "24 HR metformin hydrochloride 1000 MG / sitagliptin 50 MG Extended Release Oral Tablet",
            "24 HR metformin hydrochloride 500 MG / sitagliptin 50 MG Extended Release Oral Tablet",
            "24 hr metformin hydrochloride 1000 mg / sitagliptin 100 mg extended release oral tablet",
            "24 hr metformin hydrochloride 1000 mg / sitagliptin 50 mg extended release oral tablet",
            "24 hr metformin hydrochloride 500 mg / sitagliptin 50 mg extended release oral tablet",
            "metFORMIN/sitaGLIPtin XR",
            "metFORMIN/sitaGLIPtin XR (Oral Pill)",
            "metformin/sitagliptin xr",
            "metformin/sitagliptin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "26%"
            },
            {
                "value": "500-50 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "40%"
            },
            {
                "value": "Once daily",
                "pct": "35%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Methimazole",
        "route": "Oral Pill",
        "fullName": "Methimazole (Oral Pill)",
        "totalCount": 57,
        "searchTerms": [
            "Methimazole",
            "Methimazole (Oral Pill)",
            "Methimazole (Oral)",
            "Tapazole",
            "Tapazole 5mg",
            "methIMAzole",
            "methIMAzole (Oral Pill)",
            "methIMAzole (Oral)",
            "methimazole",
            "methimazole (oral pill)",
            "methimazole (oral)",
            "methimazole 10 MG Oral Tablet",
            "methimazole 10 mg oral tablet",
            "methimazole 5 MG Oral Tablet",
            "methimazole 5 mg oral tablet",
            "tapazole",
            "tapazole 5mg"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "70%"
            },
            {
                "value": "10 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "77%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E05.90",
                "description": "Thyrotoxicosis, unsp without thyrotoxic crisis or storm",
                "pct": "64%"
            }
        ]
    },
    {
        "name": "OMEPRAZOLE DR",
        "route": "Oral Pill",
        "fullName": "OMEPRAZOLE DR (Oral Pill)",
        "totalCount": 57,
        "searchTerms": [
            "OMEPRAZOLE DR",
            "OMEPRAZOLE DR (Oral)",
            "OMEPRAZOLE dr",
            "Omeprazole DR",
            "Omeprazole DR (Oral)",
            "PRILOSEC",
            "Prilosec",
            "Prilosec DR",
            "omeprazole dr",
            "omeprazole dr (oral)",
            "prilosec",
            "prilosec dr"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "51%"
            },
            {
                "value": "20 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [
            {
                "value": "Delayed release",
                "pct": "35%"
            },
            {
                "value": "Delayed-release",
                "pct": "16%"
            },
            {
                "value": "Delayed Release",
                "pct": "11%"
            }
        ],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Sucralfate",
        "route": "Oral Pill",
        "fullName": "Sucralfate (Oral Pill)",
        "totalCount": 56,
        "searchTerms": [
            "CARAFATE",
            "Carafate",
            "Sucralfate",
            "Sucralfate (Oral Pill)",
            "Sucralfate (Oral)",
            "carafate",
            "sucralfate",
            "sucralfate (oral pill)",
            "sucralfate (oral)",
            "sucralfate 1000 MG Oral Tablet",
            "sucralfate 1000 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 g",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "30%"
            },
            {
                "value": "Twice daily",
                "pct": "18%"
            },
            {
                "value": "Four times daily",
                "pct": "18%"
            },
            {
                "value": "Three times daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [
            {
                "value": "Administer on an empty stomach",
                "pct": "23%"
            }
        ],
        "diagnoses": [
            {
                "code": "K25.9",
                "description": "Gastric ulcer, unsp as acute or chronic, w/o hemor or perf",
                "pct": "26%"
            },
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "19%"
            },
            {
                "code": "K27.9",
                "description": "Peptic ulc, site unsp, unsp as ac or chr, w/o hemor or perf",
                "pct": "16%"
            },
            {
                "code": "K21",
                "description": "Gastro-esophageal reflux disease",
                "pct": "16%"
            }
        ]
    },
    {
        "name": "Metoclopramide",
        "route": "Oral Pill",
        "fullName": "Metoclopramide (Oral Pill)",
        "totalCount": 56,
        "searchTerms": [
            "METOCLOPRAMIDE",
            "METOCLOPRAMIDE (Oral)",
            "Metoclopramide",
            "Metoclopramide (Oral Pill)",
            "Metoclopramide (Oral)",
            "Reglan",
            "metoclopramide",
            "metoclopramide (Oral)",
            "metoclopramide (oral pill)",
            "metoclopramide (oral)",
            "metoclopramide 10 MG Oral Tablet",
            "metoclopramide 10 mg oral tablet",
            "metoclopramide 5 MG Oral Tablet",
            "metoclopramide 5 mg oral tablet",
            "reglan"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "50%"
            },
            {
                "value": "10 mg",
                "pct": "48%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "23%"
            },
            {
                "value": "Once daily",
                "pct": "23%"
            },
            {
                "value": "As needed",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "41%"
            },
            {
                "code": "R11",
                "description": "Nausea and vomiting",
                "pct": "17%"
            }
        ]
    },
    {
        "name": "Potassium chloride XR",
        "route": "Oral Pill",
        "fullName": "Potassium chloride XR (Oral Pill)",
        "totalCount": 56,
        "searchTerms": [
            "Microencapsulated potassium chloride 10 MEQ Extended Release Oral Tablet",
            "Microencapsulated potassium chloride 20 MEQ Extended Release Oral Tablet",
            "Potassium chloride XR",
            "Potassium chloride XR (Oral Pill)",
            "microencapsulated potassium chloride 10 meq extended release oral tablet",
            "microencapsulated potassium chloride 20 meq extended release oral tablet",
            "potassium chloride 10 MEQ Extended Release Oral Tablet",
            "potassium chloride 10 meq extended release oral tablet",
            "potassium chloride 20 MEQ Extended Release Oral Tablet",
            "potassium chloride 20 meq extended release oral tablet",
            "potassium chloride xr",
            "potassium chloride xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 meq",
                "pct": "62%"
            },
            {
                "value": "20 meq",
                "pct": "34%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            },
            {
                "value": "Twice daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E87.6",
                "description": "Hypokalemia",
                "pct": "65%"
            },
            {
                "code": "E87",
                "description": "Other disorders of fluid, electrolyte and acid-base balance",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "Bisacodyl",
        "route": "Rectal",
        "fullName": "Bisacodyl (Rectal)",
        "totalCount": 56,
        "searchTerms": [
            "Bisacodyl",
            "Bisacodyl (Rectal)",
            "bisacodyl",
            "bisacodyl (rectal)",
            "bisacodyl 0.333 MG/ML Enema",
            "bisacodyl 0.333 mg/ml enema",
            "bisacodyl 10 MG Rectal Suppository",
            "bisacodyl 10 mg rectal suppository"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "82%"
            },
            {
                "value": "5 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "54%"
            },
            {
                "value": "As needed",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "73%"
            }
        ]
    },
    {
        "name": "Fluticasone/Salmeterol",
        "route": "Inhalant",
        "fullName": "Fluticasone/Salmeterol (Inhalant)",
        "totalCount": 56,
        "searchTerms": [
            "14 ACTUAT fluticasone propionate 0.1 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "14 ACTUAT fluticasone propionate 0.25 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "14 actuat fluticasone propionate 0.1 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "14 actuat fluticasone propionate 0.25 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "60 ACTUAT fluticasone propionate 0.055 MG/ACTUAT / salmeterol xinafoate 0.014 MG/ACTUAT Dry Powder Inhaler",
            "60 ACTUAT fluticasone propionate 0.113 MG/ACTUAT / salmeterol xinafoate 0.014 MG/ACTUAT Dry Powder Inhaler",
            "60 ACTUAT fluticasone propionate 0.232 MG/ACTUAT / salmeterol xinafoate 0.014 MG/ACTUAT Dry Powder Inhaler",
            "60 ACTUAT fluticasone propionate 0.5 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "60 actuat fluticasone propionate 0.055 mg/actuat / salmeterol xinafoate 0.014 mg/actuat dry powder inhaler",
            "60 actuat fluticasone propionate 0.113 mg/actuat / salmeterol xinafoate 0.014 mg/actuat dry powder inhaler",
            "60 actuat fluticasone propionate 0.232 mg/actuat / salmeterol xinafoate 0.014 mg/actuat dry powder inhaler",
            "60 actuat fluticasone propionate 0.5 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "Fluticasone/Salmeterol",
            "Fluticasone/Salmeterol (Inhalant)",
            "fluticasone/salmeterol",
            "fluticasone/salmeterol (inhalant)"
        ],
        "dosages": [
            {
                "value": "250-50 mcg",
                "pct": "46%"
            },
            {
                "value": "500-50 mcg",
                "pct": "20%"
            },
            {
                "value": "100-50 mcg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [
            {
                "value": "Not for acute relief",
                "pct": "10%"
            }
        ],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "44%"
            },
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "33%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "10%"
            }
        ]
    },
    {
        "name": "MOBIC",
        "route": "Oral Pill",
        "fullName": "MOBIC (Oral Pill)",
        "totalCount": 56,
        "searchTerms": [
            "MOBIC",
            "MOBIC (Oral Pill)",
            "meloxicam 15 MG Oral Tablet",
            "meloxicam 15 mg oral tablet",
            "meloxicam 7.5 MG Oral Tablet",
            "meloxicam 7.5 mg oral tablet",
            "mobic",
            "mobic (oral pill)"
        ],
        "dosages": [
            {
                "value": "7.5 mg",
                "pct": "70%"
            },
            {
                "value": "15 mg",
                "pct": "30%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "66%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ZOFRAN",
        "route": "Oral Pill",
        "fullName": "ZOFRAN (Oral Pill)",
        "totalCount": 55,
        "searchTerms": [
            "ZOFRAN",
            "ZOFRAN (Oral Pill)",
            "ondansetron 4 MG Oral Tablet",
            "ondansetron 4 mg oral tablet",
            "ondansetron 8 MG Oral Tablet",
            "ondansetron 8 mg oral tablet",
            "zofran",
            "zofran (oral pill)"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "76%"
            },
            {
                "value": "8 mg",
                "pct": "24%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "51%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ZyrTEC",
        "route": "Oral Pill",
        "fullName": "ZyrTEC (Oral Pill)",
        "totalCount": 55,
        "searchTerms": [
            "ZYRTEC",
            "ZyrTEC",
            "ZyrTEC (Oral Pill)",
            "Zyrtec",
            "Zyrtec (Oral)",
            "cetirizine hydrochloride 10 MG Oral Capsule",
            "cetirizine hydrochloride 10 MG Oral Tablet",
            "cetirizine hydrochloride 10 mg oral capsule",
            "cetirizine hydrochloride 10 mg oral tablet",
            "cetirizine hydrochloride 5 MG Oral Tablet",
            "cetirizine hydrochloride 5 mg oral tablet",
            "zyrtec",
            "zyrtec (oral pill)",
            "zyrtec (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Omega-3 acid ethyl esters (USP)",
        "route": "Oral Pill",
        "fullName": "Omega-3 acid ethyl esters (USP) (Oral Pill)",
        "totalCount": 55,
        "searchTerms": [
            "Omega-3 acid ethyl esters (USP)",
            "Omega-3 acid ethyl esters (USP) (Oral Pill)",
            "omega-3 acid ethyl esters (USP) 1000 MG Oral Capsule",
            "omega-3 acid ethyl esters (USP) 1200 MG Oral Capsule",
            "omega-3 acid ethyl esters (usp)",
            "omega-3 acid ethyl esters (usp) (oral pill)",
            "omega-3 acid ethyl esters (usp) 1000 mg oral capsule",
            "omega-3 acid ethyl esters (usp) 1200 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "1 g",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            },
            {
                "value": "Twice daily",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.1",
                "description": "Pure hyperglyceridemia",
                "pct": "29%"
            }
        ]
    },
    {
        "name": "Budesonide",
        "route": "Inhalant",
        "fullName": "Budesonide (Inhalant)",
        "totalCount": 55,
        "searchTerms": [
            "BUDESONIDE",
            "Budesonide",
            "Budesonide (Inhalant)",
            "budesonide",
            "budesonide (inhalant)",
            "budesonide 0.25 MG/ML Inhalation Suspension",
            "budesonide 0.25 mg/ml inhalation suspension",
            "budesonide 0.5 MG/ML Inhalation Suspension",
            "budesonide 0.5 mg/ml inhalation suspension"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "49%"
            },
            {
                "value": "90 mcg",
                "pct": "18%"
            },
            {
                "value": "0.25 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "64%"
            },
            {
                "value": "Once daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [
            {
                "value": "Not for acute relief",
                "pct": "16%"
            },
            {
                "value": "Rinse mouth after inhaled corticosteroid",
                "pct": "16%"
            }
        ],
        "diagnoses": [
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "30%"
            },
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "28%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "26%"
            }
        ]
    },
    {
        "name": "CeleBREX",
        "route": "Oral Pill",
        "fullName": "CeleBREX (Oral Pill)",
        "totalCount": 55,
        "searchTerms": [
            "CELEBREX",
            "CeleBREX",
            "CeleBREX (Oral Pill)",
            "Celebrex",
            "Celebrex (Oral)",
            "celebrex",
            "celebrex (oral pill)",
            "celebrex (oral)",
            "celecoxib 100 MG Oral Capsule",
            "celecoxib 100 mg oral capsule",
            "celecoxib 200 MG Oral Capsule",
            "celecoxib 200 mg oral capsule",
            "celecoxib 400 MG Oral Capsule",
            "celecoxib 400 mg oral capsule",
            "celecoxib 50 MG Oral Capsule",
            "celecoxib 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "65%"
            },
            {
                "value": "100 mg",
                "pct": "31%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "58%"
            },
            {
                "value": "Twice daily",
                "pct": "35%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "fluPHENAZine",
        "route": "Oral Pill",
        "fullName": "fluPHENAZine (Oral Pill)",
        "totalCount": 54,
        "searchTerms": [
            "FLUPHENAZINE",
            "Fluphenazine",
            "Fluphenazine (Oral)",
            "fluPHENAZine",
            "fluPHENAZine (Oral Pill)",
            "fluphenazine",
            "fluphenazine (oral pill)",
            "fluphenazine (oral)",
            "fluphenazine hydrochloride 1 MG Oral Tablet",
            "fluphenazine hydrochloride 1 mg oral tablet",
            "fluphenazine hydrochloride 10 MG Oral Tablet",
            "fluphenazine hydrochloride 10 mg oral tablet",
            "fluphenazine hydrochloride 2.5 MG Oral Tablet",
            "fluphenazine hydrochloride 2.5 mg oral tablet",
            "fluphenazine hydrochloride 5 MG Oral Tablet",
            "fluphenazine hydrochloride 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "43%"
            },
            {
                "value": "10 mg",
                "pct": "30%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "Twice daily",
                "pct": "28%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "Calcium carbonate/Cholecalciferol/Magnesium oxide",
        "route": "Oral Pill",
        "fullName": "Calcium carbonate/Cholecalciferol/Magnesium oxide (Oral Pill)",
        "totalCount": 54,
        "searchTerms": [
            "Calcium carbonate/Cholecalciferol/Magnesium oxide",
            "Calcium carbonate/Cholecalciferol/Magnesium oxide (Oral Pill)",
            "calcium carbonate 400 MG / cholecalciferol 133 UNT / magnesium oxide 167 MG Oral Tablet",
            "calcium carbonate 400 mg / cholecalciferol 133 unt / magnesium oxide 167 mg oral tablet",
            "calcium carbonate/cholecalciferol/magnesium oxide",
            "calcium carbonate/cholecalciferol/magnesium oxide (oral pill)"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "61%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DUONEB",
        "route": "Inhalant",
        "fullName": "DUONEB (Inhalant)",
        "totalCount": 54,
        "searchTerms": [
            "DUONEB",
            "DUONEB (Inhalant)",
            "albuterol 0.833 MG/ML / ipratropium bromide 0.167 MG/ML Inhalation Solution",
            "albuterol 0.833 mg/ml / ipratropium bromide 0.167 mg/ml inhalation solution",
            "duoneb",
            "duoneb (inhalant)"
        ],
        "dosages": [
            {
                "value": "0.833-0.167 mg",
                "pct": "78%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "31%"
            },
            {
                "value": "Twice daily",
                "pct": "13%"
            },
            {
                "value": "Once daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DIOVAN",
        "route": "Oral Pill",
        "fullName": "DIOVAN (Oral Pill)",
        "totalCount": 54,
        "searchTerms": [
            "DIOVAN",
            "DIOVAN (Oral Pill)",
            "Diovan",
            "Diovan (Oral)",
            "diovan",
            "diovan (oral pill)",
            "diovan (oral)",
            "valsartan 160 MG Oral Tablet",
            "valsartan 160 mg oral tablet",
            "valsartan 320 MG Oral Tablet",
            "valsartan 320 mg oral tablet",
            "valsartan 40 MG Oral Tablet",
            "valsartan 40 mg oral tablet",
            "valsartan 80 MG Oral Tablet",
            "valsartan 80 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "160 mg",
                "pct": "37%"
            },
            {
                "value": "80 mg",
                "pct": "22%"
            },
            {
                "value": "320 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RANEXA XR",
        "route": "Oral Pill",
        "fullName": "RANEXA XR (Oral Pill)",
        "totalCount": 54,
        "searchTerms": [
            "12 HR ranolazine 1000 MG Extended Release Oral Tablet",
            "12 HR ranolazine 500 MG Extended Release Oral Tablet",
            "12 hr ranolazine 1000 mg extended release oral tablet",
            "12 hr ranolazine 500 mg extended release oral tablet",
            "RANEXA",
            "RANEXA XR",
            "RANEXA XR (Oral Pill)",
            "ranexa",
            "ranexa xr",
            "ranexa xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "89%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "61%"
            },
            {
                "value": "Once daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "METOPROLOL TARTRATE",
        "route": "Oral Pill",
        "fullName": "METOPROLOL TARTRATE (Oral Pill)",
        "totalCount": 54,
        "searchTerms": [
            "Lopressor",
            "METOPROLOL TARTRATE",
            "METOPROLOL TARTRATE (Oral)",
            "Metoprolol Tartrate",
            "Metoprolol Tartrate (Oral)",
            "lopressor",
            "metoprolol tartrate",
            "metoprolol tartrate (Oral)",
            "metoprolol tartrate (oral)"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "69%"
            },
            {
                "value": "50 mg",
                "pct": "22%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "61%"
            },
            {
                "value": "Once daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [
            {
                "value": "Take with food",
                "pct": "22%"
            }
        ],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "98%"
            }
        ]
    },
    {
        "name": "Ciclopirox",
        "route": "Topical",
        "fullName": "Ciclopirox (Topical)",
        "totalCount": 53,
        "searchTerms": [
            "Ciclopirox",
            "Ciclopirox (Topical)",
            "ciclopirox",
            "ciclopirox (topical)",
            "ciclopirox 0.0077 MG/MG Topical Gel",
            "ciclopirox 0.0077 mg/mg topical gel",
            "ciclopirox 7.7 MG/ML Topical Cream",
            "ciclopirox 7.7 MG/ML Topical Lotion",
            "ciclopirox 7.7 mg/ml topical cream",
            "ciclopirox 7.7 mg/ml topical lotion",
            "ciclopirox 80 MG/ML Topical Solution",
            "ciclopirox 80 mg/ml topical solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "51%"
            },
            {
                "value": "Twice daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B35.9",
                "description": "Dermatophytosis, unspecified",
                "pct": "34%"
            },
            {
                "code": "B35.1",
                "description": "Tinea unguium",
                "pct": "21%"
            }
        ]
    },
    {
        "name": "Anastrozole",
        "route": "Oral Pill",
        "fullName": "Anastrozole (Oral Pill)",
        "totalCount": 53,
        "searchTerms": [
            "ANASTROZOLE",
            "Anastrozole",
            "Anastrozole (Oral Pill)",
            "Anastrozole (Oral)",
            "anastrozole",
            "anastrozole (oral pill)",
            "anastrozole (oral)",
            "anastrozole 1 MG Oral Tablet",
            "anastrozole 1 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "C80.1",
                "description": "Malignant (primary) neoplasm, unspecified",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "Alfuzosin XR",
        "route": "Oral Pill",
        "fullName": "Alfuzosin XR (Oral Pill)",
        "totalCount": 53,
        "searchTerms": [
            "24 HR alfuzosin hydrochloride 10 MG Extended Release Oral Tablet",
            "24 hr alfuzosin hydrochloride 10 mg extended release oral tablet",
            "Alfuzosin XR",
            "Alfuzosin XR (Oral Pill)",
            "alfuzosin xr",
            "alfuzosin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "98%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N40",
                "description": "Enlarged prostate",
                "pct": "38%"
            }
        ]
    },
    {
        "name": "N ICE WITH VITAMIN C",
        "route": "Chewable",
        "fullName": "N ICE WITH VITAMIN C (Chewable)",
        "totalCount": 53,
        "searchTerms": [
            "N ICE WITH VITAMIN C",
            "N ICE WITH VITAMIN C (Chewable)",
            "ascorbic acid 60 MG Chewable Tablet",
            "ascorbic acid 60 mg chewable tablet",
            "n ice with vitamin c",
            "n ice with vitamin c (chewable)"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "45%"
            },
            {
                "value": "500 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Thiamine",
        "route": "Oral Pill",
        "fullName": "Thiamine (Oral Pill)",
        "totalCount": 53,
        "searchTerms": [
            "THIAMINE",
            "Thiamine",
            "Thiamine (Oral Pill)",
            "thiamine",
            "thiamine (oral pill)",
            "thiamine 100 MG Oral Tablet",
            "thiamine 100 mg oral tablet",
            "thiamine 50 MG Oral Tablet",
            "thiamine 50 mg oral tablet",
            "thiamine 500 MG Oral Tablet",
            "thiamine 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "92%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E51.9",
                "description": "Thiamine deficiency, unspecified",
                "pct": "65%"
            },
            {
                "code": "E51",
                "description": "Thiamine deficiency",
                "pct": "15%"
            }
        ]
    },
    {
        "name": "FASPRIN",
        "route": "Oral Disintegrating",
        "fullName": "FASPRIN (Oral Disintegrating)",
        "totalCount": 52,
        "searchTerms": [
            "FASPRIN",
            "FASPRIN (Oral Disintegrating)",
            "aspirin 81 MG Disintegrating Oral Tablet",
            "aspirin 81 mg disintegrating oral tablet",
            "fasprin",
            "fasprin (oral disintegrating)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "94%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "52%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PERCOCET",
        "route": "Oral Pill",
        "fullName": "PERCOCET (Oral Pill)",
        "totalCount": 52,
        "searchTerms": [
            "PERCOCET",
            "PERCOCET (Oral Pill)",
            "acetaminophen 325 MG / oxycodone hydrochloride 10 MG Oral Tablet",
            "acetaminophen 325 MG / oxycodone hydrochloride 5 MG Oral Tablet",
            "acetaminophen 325 MG / oxycodone hydrochloride 7.5 MG Oral Tablet",
            "acetaminophen 325 mg / oxycodone hydrochloride 10 mg oral tablet",
            "acetaminophen 325 mg / oxycodone hydrochloride 5 mg oral tablet",
            "acetaminophen 325 mg / oxycodone hydrochloride 7.5 mg oral tablet",
            "percocet",
            "percocet (oral pill)"
        ],
        "dosages": [
            {
                "value": "325-10 mg",
                "pct": "48%"
            },
            {
                "value": "325-5 mg",
                "pct": "37%"
            },
            {
                "value": "325-7.5 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "60%"
            },
            {
                "value": "Once daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "36%"
            }
        ]
    },
    {
        "name": "LORADAMED",
        "route": "Oral Pill",
        "fullName": "LORADAMED (Oral Pill)",
        "totalCount": 52,
        "searchTerms": [
            "LORADAMED",
            "LORADAMED (Oral Pill)",
            "loradamed",
            "loradamed (oral pill)",
            "loratadine 10 MG Oral Tablet",
            "loratadine 10 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "98%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "77%"
            },
            {
                "value": "As needed",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Gemtesa",
        "route": "Oral Pill",
        "fullName": "Gemtesa (Oral Pill)",
        "totalCount": 52,
        "searchTerms": [
            "GEMTESA",
            "GEMTESA (Oral Pill)",
            "Gemtesa",
            "Gemtesa (Oral)",
            "gemtesa",
            "gemtesa (oral pill)",
            "gemtesa (oral)"
        ],
        "dosages": [
            {
                "value": "75 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "98%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "81%"
            }
        ]
    },
    {
        "name": "Fexofenadine",
        "route": "Oral Pill",
        "fullName": "Fexofenadine (Oral Pill)",
        "totalCount": 51,
        "searchTerms": [
            "Fexofenadine",
            "Fexofenadine (Oral Pill)",
            "Fexofenadine (Oral)",
            "fexofenadine",
            "fexofenadine (Oral)",
            "fexofenadine (oral pill)",
            "fexofenadine (oral)",
            "fexofenadine hydrochloride 180 MG Oral Tablet",
            "fexofenadine hydrochloride 180 mg oral tablet",
            "fexofenadine hydrochloride 30 MG Oral Tablet",
            "fexofenadine hydrochloride 30 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "180 mg",
                "pct": "84%"
            },
            {
                "value": "60 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "70%"
            }
        ]
    },
    {
        "name": "Hydrochlorothiazide/Olmesartan",
        "route": "Oral Pill",
        "fullName": "Hydrochlorothiazide/Olmesartan (Oral Pill)",
        "totalCount": 51,
        "searchTerms": [
            "Hydrochlorothiazide/Olmesartan",
            "Hydrochlorothiazide/Olmesartan (Oral Pill)",
            "hydroCHLOROthiazide/Olmesartan",
            "hydroCHLOROthiazide/Olmesartan (Oral Pill)",
            "hydrochlorothiazide 12.5 MG / olmesartan medoxomil 20 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / olmesartan medoxomil 40 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / olmesartan medoxomil 20 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / olmesartan medoxomil 40 mg oral tablet",
            "hydrochlorothiazide/olmesartan",
            "hydrochlorothiazide/olmesartan (oral pill)"
        ],
        "dosages": [
            {
                "value": "12.5-20 mg",
                "pct": "41%"
            },
            {
                "value": "12.5-40 mg",
                "pct": "35%"
            },
            {
                "value": "25-40 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "96%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "94%"
            }
        ]
    },
    {
        "name": "CARDIZEM XR",
        "route": "Oral Pill",
        "fullName": "CARDIZEM XR (Oral Pill)",
        "totalCount": 51,
        "searchTerms": [
            "24 HR diltiazem hydrochloride 120 MG Extended Release Oral Capsule",
            "24 HR diltiazem hydrochloride 120 MG Extended Release Oral Tablet",
            "24 HR diltiazem hydrochloride 180 MG Extended Release Oral Capsule",
            "24 HR diltiazem hydrochloride 240 MG Extended Release Oral Capsule",
            "24 HR diltiazem hydrochloride 240 MG Extended Release Oral Tablet",
            "24 HR diltiazem hydrochloride 300 MG Extended Release Oral Capsule",
            "24 HR diltiazem hydrochloride 300 MG Extended Release Oral Tablet",
            "24 HR diltiazem hydrochloride 360 MG Extended Release Oral Capsule",
            "24 HR diltiazem hydrochloride 360 MG Extended Release Oral Tablet",
            "24 hr diltiazem hydrochloride 120 mg extended release oral capsule",
            "24 hr diltiazem hydrochloride 120 mg extended release oral tablet",
            "24 hr diltiazem hydrochloride 180 mg extended release oral capsule",
            "24 hr diltiazem hydrochloride 240 mg extended release oral capsule",
            "24 hr diltiazem hydrochloride 240 mg extended release oral tablet",
            "24 hr diltiazem hydrochloride 300 mg extended release oral capsule",
            "24 hr diltiazem hydrochloride 300 mg extended release oral tablet",
            "24 hr diltiazem hydrochloride 360 mg extended release oral capsule",
            "24 hr diltiazem hydrochloride 360 mg extended release oral tablet",
            "CARDIZEM",
            "CARDIZEM XR",
            "CARDIZEM XR (Oral Pill)",
            "cardizem",
            "cardizem xr",
            "cardizem xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "120 mg",
                "pct": "39%"
            },
            {
                "value": "240 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROSCAR",
        "route": "Oral Pill",
        "fullName": "PROSCAR (Oral Pill)",
        "totalCount": 51,
        "searchTerms": [
            "PROSCAR",
            "PROSCAR (Oral Pill)",
            "finasteride 5 MG Oral Tablet",
            "finasteride 5 mg oral tablet",
            "proscar",
            "proscar (oral pill)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FLUTICASONE PROPIONATE",
        "route": "Nasal",
        "fullName": "FLUTICASONE PROPIONATE (Nasal)",
        "totalCount": 50,
        "searchTerms": [
            "FLUTICASONE PROPIONATE",
            "Flonase",
            "Flonase Allergy Relief",
            "Fluticasone Propionate",
            "Fluticasone Propionate (Nasal)",
            "Fluticasone propionate",
            "Fluticasone propionate (Nasal)",
            "flonase",
            "flonase allergy relief",
            "fluticasone propionate",
            "fluticasone propionate (Nasal)",
            "fluticasone propionate (nasal)"
        ],
        "dosages": [
            {
                "value": "50 mcg",
                "pct": "92%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "60%"
            },
            {
                "value": "Twice daily",
                "pct": "28%"
            }
        ],
        "adminNotes": [
            {
                "value": "120 metered sprays",
                "pct": "17%"
            },
            {
                "value": "For intranasal use only",
                "pct": "13%"
            }
        ],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "87%"
            },
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "21%"
            }
        ]
    },
    {
        "name": "ALENDRONATE SODIUM",
        "route": "Oral Pill",
        "fullName": "ALENDRONATE SODIUM (Oral Pill)",
        "totalCount": 50,
        "searchTerms": [
            "ALENDRONATE SODIUM",
            "ALENDRONATE SODIUM (Oral)",
            "Alendronate Sodium",
            "Alendronate Sodium (Oral)",
            "Fosamax",
            "alendronate sodium",
            "alendronate sodium (oral)",
            "fosamax"
        ],
        "dosages": [
            {
                "value": "70 mg",
                "pct": "88%"
            },
            {
                "value": "35 mg",
                "pct": "10%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "90%"
            }
        ],
        "adminNotes": [
            {
                "value": "Swallow whole",
                "pct": "12%"
            },
            {
                "value": "Do not chew or crush",
                "pct": "12%"
            }
        ],
        "diagnoses": [
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "ALBUTEROL SULFATE HFA",
        "route": "Inhaler",
        "fullName": "ALBUTEROL SULFATE HFA (Inhaler)",
        "totalCount": 50,
        "searchTerms": [
            "ALBUTEROL SULFATE HFA",
            "Albuterol Sulfate HFA",
            "Albuterol Sulfate HFA (Inhaler)",
            "PROVENTIL HFA",
            "ProAir HFA",
            "Ventolin HFA",
            "albuterol sulfate HFA",
            "albuterol sulfate HFA (Inhaler)",
            "albuterol sulfate hfa",
            "albuterol sulfate hfa (inhaler)",
            "proair hfa",
            "proventil hfa",
            "ventolin hfa"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "78%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "88%"
            }
        ],
        "adminNotes": [
            {
                "value": "200 metered inhalations",
                "pct": "24%"
            },
            {
                "value": "Shake well before each spray",
                "pct": "11%"
            }
        ],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "82%"
            },
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "24%"
            },
            {
                "code": "R06.02",
                "description": "Shortness of breath",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "Metolazone",
        "route": "Oral Pill",
        "fullName": "Metolazone (Oral Pill)",
        "totalCount": 49,
        "searchTerms": [
            "METOLAZONE",
            "Metolazone",
            "Metolazone (Oral Pill)",
            "Metolazone (Oral)",
            "Zaroxolyn",
            "metOLazone",
            "metOLazone (Oral Pill)",
            "metolazone",
            "metolazone (Oral)",
            "metolazone (oral pill)",
            "metolazone (oral)",
            "metolazone 10 MG Oral Tablet",
            "metolazone 10 mg oral tablet",
            "metolazone 2.5 MG Oral Tablet",
            "metolazone 2.5 mg oral tablet",
            "metolazone 5 MG Oral Tablet",
            "metolazone 5 mg oral tablet",
            "zaroxolyn"
        ],
        "dosages": [
            {
                "value": "2.5 mg",
                "pct": "55%"
            },
            {
                "value": "5 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "57%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "38%"
            }
        ]
    },
    {
        "name": "Doxycycline",
        "route": "Oral Pill",
        "fullName": "Doxycycline (Oral Pill)",
        "totalCount": 49,
        "searchTerms": [
            "Doxycycline",
            "Doxycycline (Oral Pill)",
            "Doxycycline (Oral)",
            "doxycycline",
            "doxycycline (Oral)",
            "doxycycline (oral pill)",
            "doxycycline (oral)",
            "doxycycline hyclate 100 MG Oral Capsule",
            "doxycycline hyclate 100 mg oral capsule",
            "doxycycline hyclate 200 MG Delayed Release Oral Tablet",
            "doxycycline hyclate 200 mg delayed release oral tablet",
            "doxycycline hyclate 50 MG Oral Capsule",
            "doxycycline hyclate 50 mg oral capsule",
            "doxycycline monohydrate 100 MG Oral Capsule",
            "doxycycline monohydrate 100 mg oral capsule",
            "doxycycline monohydrate 50 MG Oral Capsule",
            "doxycycline monohydrate 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "78%"
            },
            {
                "value": "50 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "49%"
            },
            {
                "value": "Once daily",
                "pct": "16%"
            },
            {
                "value": "Every 12 hours",
                "pct": "16%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NIFEDIPINE ER",
        "route": "Oral Pill",
        "fullName": "NIFEDIPINE ER (Oral Pill)",
        "totalCount": 49,
        "searchTerms": [
            "Adalat CC",
            "NIFEDIPINE ER",
            "NIFEDIPINE ER (Oral)",
            "NIFEdipine ER",
            "NIFEdipine ER (Oral)",
            "Nifedipine ER",
            "Nifedipine ER (Oral)",
            "Nifedipine Er",
            "Nifedipine Er (Oral)",
            "Procardia XL",
            "adalat cc",
            "nifedipine er",
            "nifedipine er (oral)",
            "procardia xl"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "49%"
            },
            {
                "value": "60 mg",
                "pct": "39%"
            },
            {
                "value": "90 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "96%"
            }
        ],
        "adminNotes": [
            {
                "value": "Extended release",
                "pct": "33%"
            },
            {
                "value": "Take on an empty stomach",
                "pct": "15%"
            },
            {
                "value": "Take on empty stomach",
                "pct": "12%"
            },
            {
                "value": "Extended Release",
                "pct": "12%"
            }
        ],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Folic Acid - Supplement",
        "route": "Oral Pill",
        "fullName": "Folic Acid - Supplement (Oral Pill)",
        "totalCount": 49,
        "searchTerms": [
            "FOLIC ACID - Supplement",
            "FOLIC ACID - Supplement (Oral)",
            "Folic Acid - Supplement",
            "Folic Acid - Supplement (Oral)",
            "Folicet",
            "Folvite",
            "folic acid - Supplement",
            "folic acid - Supplement (Oral)",
            "folic acid - supplement",
            "folic acid - supplement (oral)",
            "folicet",
            "folvite"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "96%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "98%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D52.9",
                "description": "Folate deficiency anemia, unspecified",
                "pct": "86%"
            },
            {
                "code": "E53.8",
                "description": "Deficiency of other specified B group vitamins",
                "pct": "10%"
            }
        ]
    },
    {
        "name": "ALDACTONE",
        "route": "Oral Pill",
        "fullName": "ALDACTONE (Oral Pill)",
        "totalCount": 48,
        "searchTerms": [
            "ALDACTONE",
            "ALDACTONE (Oral Pill)",
            "aldactone",
            "aldactone (oral pill)",
            "spironolactone 100 MG Oral Tablet",
            "spironolactone 100 mg oral tablet",
            "spironolactone 25 MG Oral Tablet",
            "spironolactone 25 mg oral tablet",
            "spironolactone 50 MG Oral Tablet",
            "spironolactone 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "83%"
            },
            {
                "value": "100 mg",
                "pct": "10%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Sulfamethoxazole/Trimethoprim",
        "route": "Oral Pill",
        "fullName": "Sulfamethoxazole/Trimethoprim (Oral Pill)",
        "totalCount": 48,
        "searchTerms": [
            "Sulfamethoxazole/Trimethoprim",
            "Sulfamethoxazole/Trimethoprim (Oral Pill)",
            "Sulfamethoxazole/Trimethoprim (Oral)",
            "sulfamethoxazole 400 MG / trimethoprim 80 MG Oral Tablet",
            "sulfamethoxazole 400 mg / trimethoprim 80 mg oral tablet",
            "sulfamethoxazole 800 MG / trimethoprim 160 MG Oral Tablet",
            "sulfamethoxazole 800 mg / trimethoprim 160 mg oral tablet",
            "sulfamethoxazole/trimethoprim",
            "sulfamethoxazole/trimethoprim (oral pill)",
            "sulfamethoxazole/trimethoprim (oral)"
        ],
        "dosages": [
            {
                "value": "800-160 mg",
                "pct": "69%"
            },
            {
                "value": "400-80 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "35%"
            },
            {
                "value": "Once daily",
                "pct": "31%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N39.0",
                "description": "Urinary tract infection, site not specified",
                "pct": "48%"
            }
        ]
    },
    {
        "name": "TRINTELLIX",
        "route": "Oral Pill",
        "fullName": "TRINTELLIX (Oral Pill)",
        "totalCount": 48,
        "searchTerms": [
            "TRINTELLIX",
            "TRINTELLIX (Oral Pill)",
            "trintellix",
            "trintellix (oral pill)",
            "vortioxetine 10 MG Oral Tablet",
            "vortioxetine 10 mg oral tablet",
            "vortioxetine 20 MG Oral Tablet",
            "vortioxetine 20 mg oral tablet",
            "vortioxetine 5 MG Oral Tablet",
            "vortioxetine 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "54%"
            },
            {
                "value": "20 mg",
                "pct": "27%"
            },
            {
                "value": "5 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "73%"
            }
        ]
    },
    {
        "name": "NORCO",
        "route": "Oral Pill",
        "fullName": "NORCO (Oral Pill)",
        "totalCount": 48,
        "searchTerms": [
            "NORCO",
            "NORCO (Oral Pill)",
            "acetaminophen 325 MG / hydrocodone bitartrate 10 MG Oral Tablet",
            "acetaminophen 325 MG / hydrocodone bitartrate 5 MG Oral Tablet",
            "acetaminophen 325 MG / hydrocodone bitartrate 7.5 MG Oral Tablet",
            "acetaminophen 325 mg / hydrocodone bitartrate 10 mg oral tablet",
            "acetaminophen 325 mg / hydrocodone bitartrate 5 mg oral tablet",
            "acetaminophen 325 mg / hydrocodone bitartrate 7.5 mg oral tablet",
            "norco",
            "norco (oral pill)"
        ],
        "dosages": [
            {
                "value": "325-7.5 mg",
                "pct": "40%"
            },
            {
                "value": "325-5 mg",
                "pct": "35%"
            },
            {
                "value": "325-10 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "52%"
            },
            {
                "value": "Twice daily",
                "pct": "12%"
            },
            {
                "value": "Once daily",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium carbonate/Folic acid/Vitamin B complex XR",
        "route": "Oral Pill",
        "fullName": "Calcium carbonate/Folic acid/Vitamin B complex XR (Oral Pill)",
        "totalCount": 48,
        "searchTerms": [
            "Calcium carbonate/Folic acid/Vitamin B complex XR",
            "Calcium carbonate/Folic acid/Vitamin B complex XR (Oral Pill)",
            "calcium carbonate 115 MG / folic acid 0.4 MG / vitamin B complex 50 MG Extended Release Oral Tablet",
            "calcium carbonate 115 mg / folic acid 0.4 mg / vitamin b complex 50 mg extended release oral tablet",
            "calcium carbonate/folic acid/vitamin b complex xr",
            "calcium carbonate/folic acid/vitamin b complex xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "115-0.4-50 mg",
                "pct": "69%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "QUETIAPINE FUMARATE",
        "route": "Oral Pill",
        "fullName": "QUETIAPINE FUMARATE (Oral Pill)",
        "totalCount": 48,
        "searchTerms": [
            "QUETIAPINE FUMARATE",
            "QUEtiapine Fumarate",
            "QUEtiapine Fumarate (Oral)",
            "Quetiapine Fumarate",
            "Quetiapine Fumarate (Oral)",
            "SEROQUEL",
            "SEROquel",
            "Seroquel",
            "quetiapine fumarate",
            "quetiapine fumarate (oral)",
            "seroquel"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "31%"
            },
            {
                "value": "25 mg",
                "pct": "29%"
            },
            {
                "value": "100 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "69%"
            },
            {
                "value": "At bedtime",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "49%"
            },
            {
                "code": "F31.9",
                "description": "Bipolar disorder, unspecified",
                "pct": "21%"
            },
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "14%"
            },
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "12%"
            }
        ]
    },
    {
        "name": "Bisoprolol",
        "route": "Oral Pill",
        "fullName": "Bisoprolol (Oral Pill)",
        "totalCount": 47,
        "searchTerms": [
            "BISOPROLOL",
            "Bisoprolol",
            "Bisoprolol (Oral Pill)",
            "bisoprolol",
            "bisoprolol (oral pill)",
            "bisoprolol fumarate 10 MG Oral Tablet",
            "bisoprolol fumarate 10 mg oral tablet",
            "bisoprolol fumarate 5 MG Oral Tablet",
            "bisoprolol fumarate 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "66%"
            },
            {
                "value": "10 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "46%"
            },
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "23%"
            }
        ]
    },
    {
        "name": "Tacrolimus",
        "route": "Oral Pill",
        "fullName": "Tacrolimus (Oral Pill)",
        "totalCount": 47,
        "searchTerms": [
            "Prograf",
            "TACROLIMUS",
            "Tacrolimus",
            "Tacrolimus (Oral Pill)",
            "Tacrolimus (Oral)",
            "prograf",
            "tacrolimus",
            "tacrolimus (Oral)",
            "tacrolimus (oral pill)",
            "tacrolimus (oral)",
            "tacrolimus 1 MG Oral Capsule",
            "tacrolimus 1 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "79%"
            },
            {
                "value": "0.5 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "49%"
            },
            {
                "value": "Once daily",
                "pct": "21%"
            },
            {
                "value": "Every 12 hours",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "Z94.9",
                "description": "Transplanted organ and tissue status, unspecified",
                "pct": "51%"
            }
        ]
    },
    {
        "name": "Sertraline HCl",
        "route": "Oral Pill",
        "fullName": "Sertraline HCl (Oral Pill)",
        "totalCount": 47,
        "searchTerms": [
            "SERTRALINE HCL",
            "SERTRALINE HCL (Oral)",
            "Sertraline HCL",
            "Sertraline HCL (Oral)",
            "Sertraline HCl",
            "Sertraline HCl (Oral)",
            "ZOLOFT",
            "Zoloft",
            "sertraline hcl",
            "sertraline hcl (oral)",
            "zoloft"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "47%"
            },
            {
                "value": "100 mg",
                "pct": "38%"
            },
            {
                "value": "25 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [
            {
                "value": "Take with water",
                "pct": "11%"
            }
        ],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "74%"
            },
            {
                "code": "F41.1",
                "description": "Generalized anxiety disorder",
                "pct": "49%"
            }
        ]
    },
    {
        "name": "Naltrexone",
        "route": "Oral Pill",
        "fullName": "Naltrexone (Oral Pill)",
        "totalCount": 46,
        "searchTerms": [
            "Naltrexone",
            "Naltrexone (Oral Pill)",
            "Naltrexone (Oral)",
            "naltrexone",
            "naltrexone (oral pill)",
            "naltrexone (oral)",
            "naltrexone hydrochloride 50 MG Oral Tablet",
            "naltrexone hydrochloride 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "87%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F10.20",
                "description": "Alcohol dependence, uncomplicated",
                "pct": "60%"
            }
        ]
    },
    {
        "name": "Diazepam",
        "route": "Oral Pill",
        "fullName": "Diazepam (Oral Pill)",
        "totalCount": 46,
        "searchTerms": [
            "Diazepam",
            "Diazepam (Oral Pill)",
            "Diazepam (Oral)",
            "diazePAM",
            "diazePAM (Oral Pill)",
            "diazepam",
            "diazepam (oral pill)",
            "diazepam (oral)",
            "diazepam 10 MG Oral Tablet",
            "diazepam 10 mg oral tablet",
            "diazepam 2 MG Oral Tablet",
            "diazepam 2 mg oral tablet",
            "diazepam 5 MG Oral Tablet",
            "diazepam 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "61%"
            },
            {
                "value": "2 mg",
                "pct": "20%"
            },
            {
                "value": "10 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "39%"
            },
            {
                "value": "As needed",
                "pct": "20%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "55%"
            }
        ]
    },
    {
        "name": "BENICAR",
        "route": "Oral Pill",
        "fullName": "BENICAR (Oral Pill)",
        "totalCount": 46,
        "searchTerms": [
            "BENICAR",
            "BENICAR (Oral Pill)",
            "benicar",
            "benicar (oral pill)",
            "olmesartan medoxomil 20 MG Oral Tablet",
            "olmesartan medoxomil 20 mg oral tablet",
            "olmesartan medoxomil 40 MG Oral Tablet",
            "olmesartan medoxomil 40 mg oral tablet",
            "olmesartan medoxomil 5 MG Oral Tablet",
            "olmesartan medoxomil 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "43%"
            },
            {
                "value": "20 mg",
                "pct": "39%"
            },
            {
                "value": "5 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Clobetasol",
        "route": "Topical",
        "fullName": "Clobetasol (Topical)",
        "totalCount": 46,
        "searchTerms": [
            "Clobetasol",
            "Clobetasol (Topical)",
            "Emollient clobetasol propionate 0.5 MG/ML Topical Cream",
            "Emollient clobetasol propionate 0.5 MG/ML Topical Foam",
            "clobetasol",
            "clobetasol (topical)",
            "clobetasol propionate 0.0005 MG/MG Topical Ointment",
            "clobetasol propionate 0.0005 mg/mg topical ointment",
            "clobetasol propionate 0.25 MG/ML Topical Cream",
            "clobetasol propionate 0.25 mg/ml topical cream",
            "clobetasol propionate 0.5 MG/ML Topical Foam",
            "clobetasol propionate 0.5 MG/ML Topical Solution",
            "clobetasol propionate 0.5 mg/ml topical foam",
            "clobetasol propionate 0.5 mg/ml topical solution",
            "emollient clobetasol propionate 0.5 mg/ml topical cream",
            "emollient clobetasol propionate 0.5 mg/ml topical foam"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "37%"
            },
            {
                "value": "Twice daily",
                "pct": "35%"
            },
            {
                "value": "As needed",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "L30.9",
                "description": "Dermatitis, unspecified",
                "pct": "40%"
            }
        ]
    },
    {
        "name": "Insulin analog, aspart",
        "route": "Injectable",
        "fullName": "Insulin analog, aspart (Injectable)",
        "totalCount": 46,
        "searchTerms": [
            "3 ML insulin aspart, human 100 UNT/ML Cartridge",
            "3 ML insulin aspart, human 100 UNT/ML Pen Injector",
            "3 ml insulin aspart, human 100 unt/ml cartridge",
            "3 ml insulin aspart, human 100 unt/ml pen injector",
            "Insulin analog, aspart",
            "Insulin analog, aspart (Injectable)",
            "insulin analog, aspart",
            "insulin analog, aspart (injectable)",
            "insulin aspart, human 100 UNT/ML Injectable Solution",
            "insulin aspart, human 100 unt/ml injectable solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "With meals",
                "pct": "37%"
            },
            {
                "value": "Three times daily",
                "pct": "28%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "55%"
            }
        ]
    },
    {
        "name": "Ferrous gluconate",
        "route": "Oral Pill",
        "fullName": "Ferrous gluconate (Oral Pill)",
        "totalCount": 46,
        "searchTerms": [
            "FERROUS GLUCONATE",
            "Ferrous Gluconate",
            "Ferrous Gluconate (Oral)",
            "Ferrous gluconate",
            "Ferrous gluconate (Oral Pill)",
            "ferrous gluconate",
            "ferrous gluconate (oral pill)",
            "ferrous gluconate (oral)",
            "ferrous gluconate 240 MG Oral Tablet",
            "ferrous gluconate 240 mg oral tablet",
            "ferrous gluconate 256 MG Oral Tablet",
            "ferrous gluconate 256 mg oral tablet",
            "ferrous gluconate 324 MG Oral Tablet",
            "ferrous gluconate 324 mg oral tablet",
            "ferrous gluconate 325 MG Oral Tablet",
            "ferrous gluconate 325 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "324 mg",
                "pct": "80%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "72%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D50.9",
                "description": "Iron deficiency anemia, unspecified",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "Metoprolol Succinate ER",
        "route": "Oral Pill",
        "fullName": "Metoprolol Succinate ER (Oral Pill)",
        "totalCount": 46,
        "searchTerms": [
            "METOPROLOL SUCCINATE ER",
            "METOPROLOL SUCCINATE ER (Oral)",
            "Metoprolol Succinate ER",
            "Metoprolol Succinate ER (Oral)",
            "TOPROL XL",
            "Toprol XL",
            "metoprolol succinate ER",
            "metoprolol succinate ER (Oral)",
            "metoprolol succinate er",
            "metoprolol succinate er (Oral)",
            "metoprolol succinate er (oral)",
            "toprol xl"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "43%"
            },
            {
                "value": "25 mg",
                "pct": "35%"
            },
            {
                "value": "200 mg",
                "pct": "11%"
            },
            {
                "value": "100 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [
            {
                "value": "Extended release",
                "pct": "35%"
            }
        ],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "BISAC-EVAC",
        "route": "Oral Pill",
        "fullName": "BISAC-EVAC (Oral Pill)",
        "totalCount": 46,
        "searchTerms": [
            "BISAC-EVAC",
            "BISAC-EVAC (Oral Pill)",
            "bisac-evac",
            "bisac-evac (oral pill)",
            "bisacodyl 5 MG Delayed Release Oral Tablet",
            "bisacodyl 5 mg delayed release oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "78%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            },
            {
                "value": "Twice daily",
                "pct": "11%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DULCOLAX",
        "route": "Oral Pill",
        "fullName": "DULCOLAX (Oral Pill)",
        "totalCount": 45,
        "searchTerms": [
            "DULCOLAX",
            "DULCOLAX (Oral Pill)",
            "Dulcolax",
            "bisacodyl 5 MG Delayed Release Oral Tablet",
            "bisacodyl 5 mg delayed release oral tablet",
            "dulcolax",
            "dulcolax (oral pill)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "87%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "49%"
            },
            {
                "value": "As needed",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "80%"
            }
        ]
    },
    {
        "name": "GLUMETZA XR",
        "route": "Oral Pill",
        "fullName": "GLUMETZA XR (Oral Pill)",
        "totalCount": 45,
        "searchTerms": [
            "GLUMETZA",
            "GLUMETZA XR",
            "GLUMETZA XR (Oral Pill)",
            "Modified 24 HR metformin hydrochloride 1000 MG Extended Release Oral Tablet",
            "Modified 24 HR metformin hydrochloride 500 MG Extended Release Oral Tablet",
            "glumetza",
            "glumetza xr",
            "glumetza xr (oral pill)",
            "modified 24 hr metformin hydrochloride 1000 mg extended release oral tablet",
            "modified 24 hr metformin hydrochloride 500 mg extended release oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "51%"
            },
            {
                "value": "Once daily",
                "pct": "36%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Primidone",
        "route": "Oral Pill",
        "fullName": "Primidone (Oral Pill)",
        "totalCount": 45,
        "searchTerms": [
            "Mysoline",
            "PRIMIDONE",
            "Primidone",
            "Primidone (Oral Pill)",
            "Primidone (Oral)",
            "mysoline",
            "primidone",
            "primidone (oral pill)",
            "primidone (oral)",
            "primidone 250 MG Oral Tablet",
            "primidone 250 mg oral tablet",
            "primidone 50 MG Oral Tablet",
            "primidone 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "84%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "51%"
            },
            {
                "value": "Twice daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "65%"
            }
        ]
    },
    {
        "name": "Raloxifene",
        "route": "Oral Pill",
        "fullName": "Raloxifene (Oral Pill)",
        "totalCount": 45,
        "searchTerms": [
            "Raloxifene",
            "Raloxifene (Oral Pill)",
            "Raloxifene (Oral)",
            "raloxifene",
            "raloxifene (oral pill)",
            "raloxifene (oral)",
            "raloxifene hydrochloride 60 MG Oral Tablet",
            "raloxifene hydrochloride 60 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DULCOLAX STOOL SOFTENER",
        "route": "Oral Pill",
        "fullName": "DULCOLAX STOOL SOFTENER (Oral Pill)",
        "totalCount": 44,
        "searchTerms": [
            "DULCOLAX STOOL SOFTENER",
            "DULCOLAX STOOL SOFTENER (Oral Pill)",
            "docusate sodium 100 MG Oral Capsule",
            "docusate sodium 100 mg oral capsule",
            "dulcolax stool softener",
            "dulcolax stool softener (oral pill)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "84%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "55%"
            },
            {
                "value": "Three times daily",
                "pct": "16%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Digoxin",
        "route": "Oral Pill",
        "fullName": "Digoxin (Oral Pill)",
        "totalCount": 44,
        "searchTerms": [
            "Digoxin",
            "Digoxin (Oral Pill)",
            "Digoxin (Oral)",
            "digoxin",
            "digoxin (Oral)",
            "digoxin (oral pill)",
            "digoxin (oral)",
            "digoxin 0.125 MG Oral Tablet",
            "digoxin 0.125 mg oral tablet",
            "digoxin 0.25 MG Oral Tablet",
            "digoxin 0.25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.125 mg",
                "pct": "77%"
            },
            {
                "value": "0.25 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "Empagliflozin",
        "route": "Oral Pill",
        "fullName": "Empagliflozin (Oral Pill)",
        "totalCount": 44,
        "searchTerms": [
            "Empagliflozin",
            "Empagliflozin (Oral Pill)",
            "Empagliflozin (Oral)",
            "empagliflozin",
            "empagliflozin (Oral)",
            "empagliflozin (oral pill)",
            "empagliflozin (oral)",
            "empagliflozin 10 MG Oral Tablet",
            "empagliflozin 10 mg oral tablet",
            "empagliflozin 25 MG Oral Tablet",
            "empagliflozin 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "66%"
            },
            {
                "value": "25 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "48%"
            },
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "Baclofen",
        "route": "Injectable",
        "fullName": "Baclofen (Injectable)",
        "totalCount": 44,
        "searchTerms": [
            "1 ML baclofen 0.05 MG/ML Prefilled Syringe",
            "1 ml baclofen 0.05 mg/ml prefilled syringe",
            "20 ML baclofen 0.5 MG/ML Prefilled Syringe",
            "20 ML baclofen 1 MG/ML Injection",
            "20 ML baclofen 1 MG/ML Prefilled Syringe",
            "20 ML baclofen 2 MG/ML Prefilled Syringe",
            "20 ml baclofen 0.5 mg/ml prefilled syringe",
            "20 ml baclofen 1 mg/ml injection",
            "20 ml baclofen 1 mg/ml prefilled syringe",
            "20 ml baclofen 2 mg/ml prefilled syringe",
            "5 ML baclofen 2 MG/ML Injection",
            "5 ml baclofen 2 mg/ml injection",
            "Baclofen",
            "Baclofen (Injectable)",
            "baclofen",
            "baclofen (injectable)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "30%"
            },
            {
                "value": "0.05 mg",
                "pct": "11%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "27%"
            },
            {
                "value": "Once daily",
                "pct": "16%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "AMITIZA",
        "route": "Oral Pill",
        "fullName": "AMITIZA (Oral Pill)",
        "totalCount": 44,
        "searchTerms": [
            "AMITIZA",
            "AMITIZA (Oral Pill)",
            "amitiza",
            "amitiza (oral pill)",
            "lubiprostone 0.008 MG Oral Capsule",
            "lubiprostone 0.008 mg oral capsule",
            "lubiprostone 0.024 MG Oral Capsule",
            "lubiprostone 0.024 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "24 mcg",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "55%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Metformin 500mg",
        "route": "Oral Pill",
        "fullName": "Metformin 500mg (Oral Pill)",
        "totalCount": 43,
        "searchTerms": ["METFORMIN 500mg", "Metformin 500mg", "metformin 500mg"],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "47%"
            },
            {
                "value": "Once daily",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Azelastine",
        "route": "Nasal",
        "fullName": "Azelastine (Nasal)",
        "totalCount": 43,
        "searchTerms": [
            "Azelastine",
            "Azelastine (Nasal)",
            "azelastine",
            "azelastine (nasal)",
            "azelastine hydrochloride 0.137 MG/ACTUAT Metered Dose Nasal Spray",
            "azelastine hydrochloride 0.137 mg/actuat metered dose nasal spray",
            "azelastine hydrochloride 0.206 MG/ACTUAT Metered Dose Nasal Spray",
            "azelastine hydrochloride 0.206 mg/actuat metered dose nasal spray"
        ],
        "dosages": [
            {
                "value": "137 mcg",
                "pct": "88%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "56%"
            },
            {
                "value": "Once daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "52%"
            }
        ]
    },
    {
        "name": "rOPINIRole",
        "route": "Oral Pill",
        "fullName": "rOPINIRole (Oral Pill)",
        "totalCount": 43,
        "searchTerms": [
            "Ropinirole",
            "Ropinirole (Oral)",
            "rOPINIRole",
            "rOPINIRole (Oral Pill)",
            "ropinirole",
            "ropinirole (oral pill)",
            "ropinirole (oral)",
            "ropinirole 0.25 MG Oral Tablet",
            "ropinirole 0.25 mg oral tablet",
            "ropinirole 0.5 MG Oral Tablet",
            "ropinirole 0.5 mg oral tablet",
            "ropinirole 2 MG Oral Tablet",
            "ropinirole 2 mg oral tablet",
            "ropinirole 3 MG Oral Tablet",
            "ropinirole 3 mg oral tablet",
            "ropinirole 4 MG Oral Tablet",
            "ropinirole 4 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.25 mg",
                "pct": "33%"
            },
            {
                "value": "0.5 mg",
                "pct": "23%"
            },
            {
                "value": "2 mg",
                "pct": "14%"
            },
            {
                "value": "1 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            },
            {
                "value": "At bedtime",
                "pct": "26%"
            },
            {
                "value": "Three times daily",
                "pct": "14%"
            },
            {
                "value": "Twice daily",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G20",
                "description": "Parkinson's disease",
                "pct": "39%"
            }
        ]
    },
    {
        "name": "ADMELOG",
        "route": "Injectable",
        "fullName": "ADMELOG (Injectable)",
        "totalCount": 43,
        "searchTerms": [
            "3 ML insulin lispro 100 UNT/ML Pen Injector",
            "3 ml insulin lispro 100 unt/ml pen injector",
            "ADMELOG",
            "ADMELOG (Injectable)",
            "admelog",
            "admelog (injectable)",
            "insulin lispro 100 UNT/ML Injectable Solution",
            "insulin lispro 100 unt/ml injectable solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "28%"
            },
            {
                "value": "With meals",
                "pct": "21%"
            },
            {
                "value": "Once daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rotate injection sites",
                "pct": "29%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "REXULTI",
        "route": "Oral Pill",
        "fullName": "REXULTI (Oral Pill)",
        "totalCount": 43,
        "searchTerms": [
            "REXULTI",
            "REXULTI (Oral Pill)",
            "REXULTI (Oral)",
            "Rexulti",
            "Rexulti (Oral)",
            "brexpiprazole 0.25 MG Oral Tablet",
            "brexpiprazole 0.25 mg oral tablet",
            "brexpiprazole 0.5 MG Oral Tablet",
            "brexpiprazole 0.5 mg oral tablet",
            "brexpiprazole 1 MG Oral Tablet",
            "brexpiprazole 1 mg oral tablet",
            "brexpiprazole 2 MG Oral Tablet",
            "brexpiprazole 2 mg oral tablet",
            "brexpiprazole 3 MG Oral Tablet",
            "brexpiprazole 3 mg oral tablet",
            "brexpiprazole 4 MG Oral Tablet",
            "brexpiprazole 4 mg oral tablet",
            "rexulti",
            "rexulti (oral pill)",
            "rexulti (oral)"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "35%"
            },
            {
                "value": "1 mg",
                "pct": "30%"
            },
            {
                "value": "2 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "30%"
            },
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "22%"
            }
        ]
    },
    {
        "name": "Sodium bicarbonate",
        "route": "Oral Pill",
        "fullName": "Sodium bicarbonate (Oral Pill)",
        "totalCount": 43,
        "searchTerms": [
            "SODIUM BICARBONATE",
            "SODIUM BICARBONATE (Oral)",
            "Sodium Bicarbonate",
            "Sodium Bicarbonate (Oral)",
            "Sodium bicarbonate",
            "Sodium bicarbonate (Oral Pill)",
            "sodium bicarbonate",
            "sodium bicarbonate (Oral)",
            "sodium bicarbonate (oral pill)",
            "sodium bicarbonate (oral)",
            "sodium bicarbonate 650 MG Oral Tablet",
            "sodium bicarbonate 650 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "650 mg",
                "pct": "93%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "37%"
            },
            {
                "value": "Once daily",
                "pct": "26%"
            },
            {
                "value": "Three times daily",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "79%"
            }
        ]
    },
    {
        "name": "ALEVE",
        "route": "Oral Pill",
        "fullName": "ALEVE (Oral Pill)",
        "totalCount": 43,
        "searchTerms": [
            "ALEVE",
            "ALEVE (Oral Pill)",
            "aleve",
            "aleve (oral pill)",
            "naproxen sodium 220 MG Oral Capsule",
            "naproxen sodium 220 MG Oral Tablet",
            "naproxen sodium 220 mg oral capsule",
            "naproxen sodium 220 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "220 mg",
                "pct": "84%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "47%"
            },
            {
                "value": "Once daily",
                "pct": "28%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "Albuterol Sulfate Inhalation Aerosol",
        "route": "Inhaler",
        "fullName": "Albuterol Sulfate Inhalation Aerosol (Inhaler)",
        "totalCount": 43,
        "searchTerms": [
            "Albuterol Sulfate Inhalation Aerosol",
            "Albuterol Sulfate Inhalation Aerosol (Inhaler)",
            "Proair HFA",
            "Proventil",
            "Ventolin",
            "Ventolin HFA",
            "albuterol sulfate inhalation aerosol",
            "albuterol sulfate inhalation aerosol (inhaler)",
            "proair hfa",
            "proventil",
            "ventolin",
            "ventolin hfa"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "98%"
            }
        ],
        "adminNotes": [
            {
                "value": "Shake well before use",
                "pct": "37%"
            },
            {
                "value": "200 metered inhalations",
                "pct": "19%"
            },
            {
                "value": "For oral inhalation with enclosed actuator only",
                "pct": "16%"
            },
            {
                "value": "Spacer used with MDI",
                "pct": "12%"
            },
            {
                "value": "For oral inhalation",
                "pct": "12%"
            }
        ],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "88%"
            },
            {
                "code": "R06.02",
                "description": "Shortness of breath",
                "pct": "21%"
            }
        ]
    },
    {
        "name": "Lacosamide",
        "route": "Oral Pill",
        "fullName": "Lacosamide (Oral Pill)",
        "totalCount": 42,
        "searchTerms": [
            "Lacosamide",
            "Lacosamide (Oral Pill)",
            "Lacosamide (Oral)",
            "Vimpat",
            "lacosamide",
            "lacosamide (oral pill)",
            "lacosamide (oral)",
            "lacosamide 100 MG Oral Tablet",
            "lacosamide 100 mg oral tablet",
            "lacosamide 150 MG Oral Tablet",
            "lacosamide 150 mg oral tablet",
            "lacosamide 200 MG Oral Tablet",
            "lacosamide 200 mg oral tablet",
            "lacosamide 50 MG Oral Tablet",
            "lacosamide 50 mg oral tablet",
            "vimpat"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "36%"
            },
            {
                "value": "200 mg",
                "pct": "24%"
            },
            {
                "value": "50 mg",
                "pct": "21%"
            },
            {
                "value": "150 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "67%"
            },
            {
                "value": "Once daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "SYSTANE",
        "route": "Ophthalmic",
        "fullName": "SYSTANE (Ophthalmic)",
        "totalCount": 42,
        "searchTerms": [
            "SYSTANE",
            "SYSTANE (Ophthalmic)",
            "polyethylene glycol 400 0.004 MG/MG / propylene glycol 0.003 MG/MG Ophthalmic Gel",
            "polyethylene glycol 400 0.004 mg/mg / propylene glycol 0.003 mg/mg ophthalmic gel",
            "polyethylene glycol 400 4 MG/ML / propylene glycol 3 MG/ML Ophthalmic Solution",
            "polyethylene glycol 400 4 mg/ml / propylene glycol 3 mg/ml ophthalmic solution",
            "systane",
            "systane (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "33%"
            },
            {
                "value": "As needed",
                "pct": "19%"
            },
            {
                "value": "Four times daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "prednisoLONE",
        "route": "Ophthalmic",
        "fullName": "prednisoLONE (Ophthalmic)",
        "totalCount": 42,
        "searchTerms": [
            "prednisoLONE",
            "prednisoLONE (Ophthalmic)",
            "prednisolone",
            "prednisolone (ophthalmic)",
            "prednisolone 10 MG/ML Ophthalmic Solution",
            "prednisolone 10 mg/ml ophthalmic solution",
            "prednisolone acetate 10 MG/ML Ophthalmic Suspension",
            "prednisolone acetate 10 mg/ml ophthalmic suspension"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Four times daily",
                "pct": "29%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            },
            {
                "value": "Twice daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H20.9",
                "description": "Unspecified iridocyclitis",
                "pct": "53%"
            }
        ]
    },
    {
        "name": "ZENPEP",
        "route": "Oral Pill",
        "fullName": "ZENPEP (Oral Pill)",
        "totalCount": 42,
        "searchTerms": [
            "ZENPEP",
            "ZENPEP (Oral Pill)",
            "Zenpep",
            "Zenpep (Oral)",
            "amylase 105000 UNT / lipase 25000 UNT / protease 79000 UNT Delayed Release Oral Capsule",
            "amylase 105000 unt / lipase 25000 unt / protease 79000 unt delayed release oral capsule",
            "amylase 136000 UNT / lipase 25000 UNT / protease 85000 UNT Delayed Release Oral Capsule",
            "amylase 136000 unt / lipase 25000 unt / protease 85000 unt delayed release oral capsule",
            "amylase 16000 UNT / lipase 3000 UNT / protease 10000 UNT Delayed Release Oral Capsule",
            "amylase 16000 unt / lipase 3000 unt / protease 10000 unt delayed release oral capsule",
            "amylase 168000 UNT / lipase 40000 UNT / protease 126000 UNT Delayed Release Oral Capsule",
            "amylase 168000 unt / lipase 40000 unt / protease 126000 unt delayed release oral capsule",
            "amylase 218000 UNT / lipase 40000 UNT / protease 136000 UNT Delayed Release Oral Capsule",
            "amylase 218000 unt / lipase 40000 unt / protease 136000 unt delayed release oral capsule",
            "amylase 24000 UNT / lipase 5000 UNT / protease 17000 UNT Delayed Release Oral Capsule",
            "amylase 24000 unt / lipase 5000 unt / protease 17000 unt delayed release oral capsule",
            "amylase 42000 UNT / lipase 10000 UNT / protease 32000 UNT Delayed Release Oral Capsule",
            "amylase 42000 unt / lipase 10000 unt / protease 32000 unt delayed release oral capsule",
            "amylase 84000 UNT / lipase 20000 UNT / protease 63000 UNT Delayed Release Oral Capsule",
            "amylase 84000 unt / lipase 20000 unt / protease 63000 unt delayed release oral capsule",
            "zenpep",
            "zenpep (oral pill)",
            "zenpep (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "45%"
            },
            {
                "value": "Once daily",
                "pct": "31%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K86.81",
                "description": "Exocrine pancreatic insufficiency",
                "pct": "88%"
            }
        ]
    },
    {
        "name": "MONTELUKAST SODIUM",
        "route": "Oral Pill",
        "fullName": "MONTELUKAST SODIUM (Oral Pill)",
        "totalCount": 42,
        "searchTerms": [
            "MONTELUKAST SODIUM",
            "MONTELUKAST SODIUM (Oral)",
            "Montelukast Sodium",
            "Montelukast Sodium (Oral)",
            "Singulair",
            "montelukast sodium",
            "montelukast sodium (oral)",
            "singulair"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            },
            {
                "value": "At bedtime",
                "pct": "17%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "89%"
            },
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "MECLIZINE HCL",
        "route": "Oral Pill",
        "fullName": "MECLIZINE HCL (Oral Pill)",
        "totalCount": 42,
        "searchTerms": [
            "ANTIVERT",
            "Antivert",
            "Dramamine",
            "MECLIZINE HCL",
            "Meclizine HCL",
            "Meclizine HCL (Oral)",
            "Meclizine HCl",
            "Meclizine HCl (Oral)",
            "antivert",
            "dramamine",
            "meclizine hcl",
            "meclizine hcl (oral)"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "60%"
            },
            {
                "value": "12.5 mg",
                "pct": "40%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "43%"
            },
            {
                "value": "Once daily",
                "pct": "29%"
            },
            {
                "value": "Twice daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R42",
                "description": "Dizziness and giddiness",
                "pct": "94%"
            }
        ]
    },
    {
        "name": "PANTOPRAZOLE SODIUM",
        "route": "Oral Pill",
        "fullName": "PANTOPRAZOLE SODIUM (Oral Pill)",
        "totalCount": 42,
        "searchTerms": [
            "PANTOPRAZOLE SODIUM",
            "PANTOPRAZOLE SODIUM (Oral)",
            "PROTONIX",
            "Pantoprazole Sodium",
            "Pantoprazole Sodium (Oral)",
            "Pantoprazole sodium",
            "Pantoprazole sodium (Oral)",
            "Protonix",
            "Protonix 40mg Tablet",
            "pantoprazole sodium",
            "pantoprazole sodium (oral)",
            "protonix",
            "protonix 40mg tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "83%"
            },
            {
                "value": "20 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ferrous Sulfate - Supplement",
        "route": "Oral Pill",
        "fullName": "Ferrous Sulfate - Supplement (Oral Pill)",
        "totalCount": 42,
        "searchTerms": [
            "FEOSOL",
            "FERROUS SULFATE - Supplement",
            "FERROUS SULFATE - Supplement (Oral)",
            "Feosol",
            "Feratab",
            "Ferosul",
            "Ferrous Sulfate - Supplement",
            "Ferrous Sulfate - Supplement (Oral)",
            "Ferrous sulfate - Supplement",
            "Ferrous sulfate - Supplement (Oral)",
            "feosol",
            "feratab",
            "ferosul",
            "ferrous sulfate - Supplement",
            "ferrous sulfate - Supplement (Oral)",
            "ferrous sulfate - supplement",
            "ferrous sulfate - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "325 mg",
                "pct": "90%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D50.9",
                "description": "Iron deficiency anemia, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "REFRESH TEARS",
        "route": "Ophthalmic",
        "fullName": "REFRESH TEARS (Ophthalmic)",
        "totalCount": 42,
        "searchTerms": [
            "REFRESH TEARS",
            "REFRESH TEARS (Ophthalmic)",
            "Refresh Plus",
            "Refresh Tears",
            "Refresh Tears (Ophthalmic)",
            "refresh plus",
            "refresh tears",
            "refresh tears (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "38%"
            },
            {
                "value": "Once daily",
                "pct": "19%"
            },
            {
                "value": "Three times daily",
                "pct": "12%"
            },
            {
                "value": "Four times daily",
                "pct": "12%"
            },
            {
                "value": "Twice daily",
                "pct": "12%"
            }
        ],
        "adminNotes": [
            {
                "value": "Lubricant Eye Drops",
                "pct": "45%"
            },
            {
                "value": "Lubricant eye drops",
                "pct": "23%"
            },
            {
                "value": "Sterile",
                "pct": "19%"
            }
        ],
        "diagnoses": [
            {
                "code": "H04.123",
                "description": "Dry eye syndrome of bilateral lacrimal glands",
                "pct": "94%"
            }
        ]
    },
    {
        "name": "Aspirin/DiphenhydrAMINE",
        "route": "Oral Pill",
        "fullName": "Aspirin/DiphenhydrAMINE (Oral Pill)",
        "totalCount": 41,
        "searchTerms": [
            "Aspirin/DiphenhydrAMINE",
            "Aspirin/DiphenhydrAMINE (Oral Pill)",
            "aspirin 500 MG / diphenhydramine hydrochloride 25 MG Oral Tablet",
            "aspirin 500 mg / diphenhydramine hydrochloride 25 mg oral tablet",
            "aspirin/diphenhydramine",
            "aspirin/diphenhydramine (oral pill)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "56%"
            },
            {
                "value": "500-25 mg",
                "pct": "29%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "61%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SYSTANE BALANCE",
        "route": "Ophthalmic",
        "fullName": "SYSTANE BALANCE (Ophthalmic)",
        "totalCount": 41,
        "searchTerms": [
            "SYSTANE BALANCE",
            "SYSTANE BALANCE (Ophthalmic)",
            "propylene glycol 6 MG/ML Ophthalmic Solution",
            "propylene glycol 6 mg/ml ophthalmic solution",
            "systane balance",
            "systane balance (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "32%"
            },
            {
                "value": "Four times daily",
                "pct": "22%"
            },
            {
                "value": "As needed",
                "pct": "12%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ATIVAN",
        "route": "Oral Pill",
        "fullName": "ATIVAN (Oral Pill)",
        "totalCount": 41,
        "searchTerms": [
            "ATIVAN",
            "ATIVAN (Oral Pill)",
            "ativan",
            "ativan (oral pill)",
            "lorazepam 0.5 MG Oral Tablet",
            "lorazepam 0.5 mg oral tablet",
            "lorazepam 1 MG Oral Tablet",
            "lorazepam 1 mg oral tablet",
            "lorazepam 2 MG Oral Tablet",
            "lorazepam 2 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "44%"
            },
            {
                "value": "0.5 mg",
                "pct": "37%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "29%"
            },
            {
                "value": "Once daily",
                "pct": "17%"
            },
            {
                "value": "Twice daily",
                "pct": "17%"
            },
            {
                "value": "Three times daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cephalexin",
        "route": "Oral Pill",
        "fullName": "Cephalexin (Oral Pill)",
        "totalCount": 40,
        "searchTerms": [
            "CEPHALEXIN",
            "Cephalexin",
            "Cephalexin (Oral Pill)",
            "Cephalexin (Oral)",
            "cephalexin",
            "cephalexin (oral pill)",
            "cephalexin (oral)",
            "cephalexin 250 MG Oral Capsule",
            "cephalexin 250 mg oral capsule",
            "cephalexin 500 MG Oral Capsule",
            "cephalexin 500 MG Oral Tablet",
            "cephalexin 500 mg oral capsule",
            "cephalexin 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "85%"
            },
            {
                "value": "250 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Every 6 hours",
                "pct": "18%"
            },
            {
                "value": "Twice daily",
                "pct": "18%"
            },
            {
                "value": "Once daily",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N39.0",
                "description": "Urinary tract infection, site not specified",
                "pct": "30%"
            }
        ]
    },
    {
        "name": "Mycophenolate mofetil",
        "route": "Oral Pill",
        "fullName": "Mycophenolate mofetil (Oral Pill)",
        "totalCount": 40,
        "searchTerms": [
            "CellCept",
            "Mycophenolate Mofetil",
            "Mycophenolate Mofetil (Oral)",
            "Mycophenolate mofetil",
            "Mycophenolate mofetil (Oral Pill)",
            "cellcept",
            "mycophenolate mofetil",
            "mycophenolate mofetil (oral pill)",
            "mycophenolate mofetil (oral)",
            "mycophenolate mofetil 250 MG Oral Capsule",
            "mycophenolate mofetil 250 mg oral capsule",
            "mycophenolate mofetil 500 MG Oral Tablet",
            "mycophenolate mofetil 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "78%"
            },
            {
                "value": "250 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "72%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "Z94.9",
                "description": "Transplanted organ and tissue status, unspecified",
                "pct": "26%"
            }
        ]
    },
    {
        "name": "Acarbose",
        "route": "Oral Pill",
        "fullName": "Acarbose (Oral Pill)",
        "totalCount": 40,
        "searchTerms": [
            "ACARBOSE",
            "Acarbose",
            "Acarbose (Oral Pill)",
            "Acarbose (Oral)",
            "Precose",
            "acarbose",
            "acarbose (Oral)",
            "acarbose (oral pill)",
            "acarbose (oral)",
            "acarbose 100 MG Oral Tablet",
            "acarbose 100 mg oral tablet",
            "acarbose 25 MG Oral Tablet",
            "acarbose 25 mg oral tablet",
            "acarbose 50 MG Oral Tablet",
            "acarbose 50 mg oral tablet",
            "precose"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "45%"
            },
            {
                "value": "25 mg",
                "pct": "28%"
            },
            {
                "value": "100 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "57%"
            },
            {
                "value": "Once daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "MAPAP",
        "route": "Oral Pill",
        "fullName": "MAPAP (Oral Pill)",
        "totalCount": 40,
        "searchTerms": [
            "MAPAP",
            "MAPAP (Oral Pill)",
            "MAPAP (Oral)",
            "TYLENOL",
            "acetaminophen 325 MG Oral Tablet",
            "acetaminophen 325 mg oral tablet",
            "acetaminophen 500 MG Oral Capsule",
            "acetaminophen 500 MG Oral Tablet",
            "acetaminophen 500 mg oral capsule",
            "acetaminophen 500 mg oral tablet",
            "mapap",
            "mapap (oral pill)",
            "mapap (oral)",
            "tylenol"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "68%"
            },
            {
                "value": "325 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "65%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "CeleXA",
        "route": "Oral Pill",
        "fullName": "CeleXA (Oral Pill)",
        "totalCount": 40,
        "searchTerms": [
            "CELEXA",
            "CeleXA",
            "CeleXA (Oral Pill)",
            "celexa",
            "celexa (oral pill)",
            "citalopram 10 MG Oral Tablet",
            "citalopram 10 mg oral tablet",
            "citalopram 20 MG Oral Tablet",
            "citalopram 20 mg oral tablet",
            "citalopram 40 MG Oral Tablet",
            "citalopram 40 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "55%"
            },
            {
                "value": "10 mg",
                "pct": "25%"
            },
            {
                "value": "40 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Amoxicillin",
        "route": "Oral Pill",
        "fullName": "Amoxicillin (Oral Pill)",
        "totalCount": 40,
        "searchTerms": [
            "Amoxicillin",
            "Amoxicillin (Oral Pill)",
            "Amoxicillin (Oral)",
            "amoxicillin",
            "amoxicillin (oral pill)",
            "amoxicillin (oral)",
            "amoxicillin 250 MG Oral Capsule",
            "amoxicillin 250 mg oral capsule",
            "amoxicillin 500 MG Oral Capsule",
            "amoxicillin 500 mg oral capsule",
            "amoxicillin 875 MG Oral Tablet",
            "amoxicillin 875 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "62%"
            },
            {
                "value": "875 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "25%"
            },
            {
                "value": "Once daily",
                "pct": "20%"
            },
            {
                "value": "Every 8 hours",
                "pct": "20%"
            },
            {
                "value": "Three times daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J18.9",
                "description": "Pneumonia, unspecified organism",
                "pct": "22%"
            }
        ]
    },
    {
        "name": "LATUDA",
        "route": "Oral Pill",
        "fullName": "LATUDA (Oral Pill)",
        "totalCount": 40,
        "searchTerms": [
            "LATUDA",
            "LATUDA (Oral Pill)",
            "latuda",
            "latuda (oral pill)",
            "lurasidone hydrochloride 120 MG Oral Tablet",
            "lurasidone hydrochloride 120 mg oral tablet",
            "lurasidone hydrochloride 20 MG Oral Tablet",
            "lurasidone hydrochloride 20 mg oral tablet",
            "lurasidone hydrochloride 40 MG Oral Tablet",
            "lurasidone hydrochloride 40 mg oral tablet",
            "lurasidone hydrochloride 60 MG Oral Tablet",
            "lurasidone hydrochloride 60 mg oral tablet",
            "lurasidone hydrochloride 80 MG Oral Tablet",
            "lurasidone hydrochloride 80 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "55%"
            },
            {
                "value": "20 mg",
                "pct": "15%"
            },
            {
                "value": "120 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SENOKOT",
        "route": "Oral Pill",
        "fullName": "SENOKOT (Oral Pill)",
        "totalCount": 40,
        "searchTerms": [
            "SENOKOT",
            "SENOKOT (Oral Pill)",
            "sennosides, USP 17.2 MG Oral Tablet",
            "sennosides, USP 8.6 MG Oral Tablet",
            "sennosides, usp 17.2 mg oral tablet",
            "sennosides, usp 8.6 mg oral tablet",
            "senokot",
            "senokot (oral pill)"
        ],
        "dosages": [
            {
                "value": "8.6 mg",
                "pct": "68%"
            },
            {
                "value": "17.2 mg",
                "pct": "30%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "At bedtime",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "LEVOTHYROXINE SODIUM",
        "route": "Oral Pill",
        "fullName": "LEVOTHYROXINE SODIUM (Oral Pill)",
        "totalCount": 40,
        "searchTerms": [
            "LEVOTHYROXINE SODIUM",
            "LEVOTHYROXINE SODIUM (Oral)",
            "LEVOTHYROXINE sodium",
            "Levo-T",
            "Levothyroxine Sodium",
            "Levothyroxine Sodium (Oral)",
            "Levothyroxine sodium",
            "Levothyroxine sodium (Oral)",
            "Levoxyl",
            "Synthroid",
            "levo-t",
            "levothyroxine sodium",
            "levothyroxine sodium (oral)",
            "levoxyl",
            "synthroid"
        ],
        "dosages": [
            {
                "value": "75 mcg",
                "pct": "22%"
            },
            {
                "value": "25 mcg",
                "pct": "18%"
            },
            {
                "value": "50 mcg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [
            {
                "value": "Take on an empty stomach",
                "pct": "29%"
            },
            {
                "value": "Best taken on an empty stomach 30–60 minutes before breakfast",
                "pct": "21%"
            }
        ],
        "diagnoses": [
            {
                "code": "E03.9",
                "description": "Hypothyroidism, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "MATZIM XR",
        "route": "Oral Pill",
        "fullName": "MATZIM XR (Oral Pill)",
        "totalCount": 40,
        "searchTerms": [
            "24 HR diltiazem hydrochloride 180 MG Extended Release Oral Tablet",
            "24 HR diltiazem hydrochloride 240 MG Extended Release Oral Tablet",
            "24 HR diltiazem hydrochloride 300 MG Extended Release Oral Tablet",
            "24 HR diltiazem hydrochloride 360 MG Extended Release Oral Tablet",
            "24 HR diltiazem hydrochloride 420 MG Extended Release Oral Tablet",
            "24 hr diltiazem hydrochloride 180 mg extended release oral tablet",
            "24 hr diltiazem hydrochloride 240 mg extended release oral tablet",
            "24 hr diltiazem hydrochloride 300 mg extended release oral tablet",
            "24 hr diltiazem hydrochloride 360 mg extended release oral tablet",
            "24 hr diltiazem hydrochloride 420 mg extended release oral tablet",
            "MATZIM",
            "MATZIM XR",
            "MATZIM XR (Oral Pill)",
            "matzim",
            "matzim xr",
            "matzim xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "240 mg",
                "pct": "30%"
            },
            {
                "value": "180 mg",
                "pct": "22%"
            },
            {
                "value": "120 mg",
                "pct": "12%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Levothyroxine",
        "route": "Oral Liquid",
        "fullName": "Levothyroxine (Oral Liquid)",
        "totalCount": 39,
        "searchTerms": [
            "Levothyroxine",
            "Levothyroxine (Oral Liquid)",
            "levothyroxine",
            "levothyroxine (oral liquid)",
            "levothyroxine sodium 0.025 MG/ML Oral Solution",
            "levothyroxine sodium 0.025 mg/ml oral solution",
            "levothyroxine sodium 0.05 MG/ML Oral Solution",
            "levothyroxine sodium 0.05 mg/ml oral solution",
            "levothyroxine sodium 0.075 MG/ML Oral Solution",
            "levothyroxine sodium 0.075 mg/ml oral solution",
            "levothyroxine sodium 0.088 MG/ML Oral Solution",
            "levothyroxine sodium 0.088 mg/ml oral solution",
            "levothyroxine sodium 0.112 MG/ML Oral Solution",
            "levothyroxine sodium 0.112 mg/ml oral solution",
            "levothyroxine sodium 0.125 MG/ML Oral Solution",
            "levothyroxine sodium 0.125 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "0.05 mg",
                "pct": "31%"
            },
            {
                "value": "0.075 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "59%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Meloxicam",
        "route": "Oral Disintegrating",
        "fullName": "Meloxicam (Oral Disintegrating)",
        "totalCount": 39,
        "searchTerms": [
            "Meloxicam",
            "Meloxicam (Oral Disintegrating)",
            "meloxicam",
            "meloxicam (oral disintegrating)",
            "meloxicam 15 MG Disintegrating Oral Tablet",
            "meloxicam 15 mg disintegrating oral tablet",
            "meloxicam 7.5 MG Disintegrating Oral Tablet",
            "meloxicam 7.5 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "7.5 mg",
                "pct": "62%"
            },
            {
                "value": "15 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TUMS",
        "route": "Chewable",
        "fullName": "TUMS (Chewable)",
        "totalCount": 39,
        "searchTerms": [
            "TUMS",
            "TUMS (Chewable)",
            "calcium carbonate 1000 MG Chewable Tablet",
            "calcium carbonate 1000 mg chewable tablet",
            "calcium carbonate 500 MG Chewable Tablet",
            "calcium carbonate 500 mg chewable tablet",
            "calcium carbonate 750 MG Chewable Tablet",
            "calcium carbonate 750 mg chewable tablet",
            "tums",
            "tums (chewable)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "36%"
            },
            {
                "value": "750 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "26%"
            },
            {
                "value": "Twice daily",
                "pct": "21%"
            },
            {
                "value": "Once daily",
                "pct": "18%"
            },
            {
                "value": "Three times daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Solifenacin",
        "route": "Oral Pill",
        "fullName": "Solifenacin (Oral Pill)",
        "totalCount": 39,
        "searchTerms": [
            "Solifenacin",
            "Solifenacin (Oral Pill)",
            "Solifenacin (Oral)",
            "solifenacin",
            "solifenacin (oral pill)",
            "solifenacin (oral)",
            "solifenacin succinate 10 MG Oral Tablet",
            "solifenacin succinate 10 mg oral tablet",
            "solifenacin succinate 5 MG Oral Tablet",
            "solifenacin succinate 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "49%"
            },
            {
                "value": "10 mg",
                "pct": "49%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "60%"
            }
        ]
    },
    {
        "name": "PHILLIPS MILK OF MAGNESIA",
        "route": "Oral Liquid",
        "fullName": "PHILLIPS MILK OF MAGNESIA (Oral Liquid)",
        "totalCount": 39,
        "searchTerms": [
            "PHILLIPS MILK OF MAGNESIA",
            "PHILLIPS MILK OF MAGNESIA (Oral Liquid)",
            "magnesium hydroxide 160 MG/ML Oral Suspension",
            "magnesium hydroxide 160 mg/ml oral suspension",
            "magnesium hydroxide 80 MG/ML Oral Suspension",
            "magnesium hydroxide 80 mg/ml oral suspension",
            "phillips milk of magnesia",
            "phillips milk of magnesia (oral liquid)"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lovastatin",
        "route": "Oral Pill",
        "fullName": "Lovastatin (Oral Pill)",
        "totalCount": 39,
        "searchTerms": [
            "LOVASTATIN",
            "Lovastatin",
            "Lovastatin (Oral Pill)",
            "Lovastatin (Oral)",
            "lovastatin",
            "lovastatin (oral pill)",
            "lovastatin (oral)",
            "lovastatin 10 MG Oral Tablet",
            "lovastatin 10 mg oral tablet",
            "lovastatin 20 MG Oral Tablet",
            "lovastatin 20 mg oral tablet",
            "lovastatin 40 MG Oral Tablet",
            "lovastatin 40 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "49%"
            },
            {
                "value": "40 mg",
                "pct": "44%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            },
            {
                "value": "At bedtime",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "65%"
            }
        ]
    },
    {
        "name": "Haloperidol",
        "route": "Injectable",
        "fullName": "Haloperidol (Injectable)",
        "totalCount": 39,
        "searchTerms": [
            "1 ML haloperidol 5 MG/ML Injection",
            "1 ML haloperidol 5 MG/ML Prefilled Syringe",
            "1 ML haloperidol decanoate 100 MG/ML Injection",
            "1 ML haloperidol decanoate 50 MG/ML Injection",
            "1 ml haloperidol 5 mg/ml injection",
            "1 ml haloperidol 5 mg/ml prefilled syringe",
            "1 ml haloperidol decanoate 100 mg/ml injection",
            "1 ml haloperidol decanoate 50 mg/ml injection",
            "Haloperidol",
            "Haloperidol (Injectable)",
            "haloperidol",
            "haloperidol (injectable)",
            "haloperidol 5 MG/ML Injectable Solution",
            "haloperidol 5 mg/ml injectable solution",
            "haloperidol decanoate 100 MG/ML Injectable Solution",
            "haloperidol decanoate 100 mg/ml injectable solution"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "38%"
            },
            {
                "value": "5 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Monthly",
                "pct": "44%"
            },
            {
                "value": "Qm",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CLOZARIL",
        "route": "Oral Pill",
        "fullName": "CLOZARIL (Oral Pill)",
        "totalCount": 39,
        "searchTerms": [
            "CLOZARIL",
            "CLOZARIL (Oral Pill)",
            "clozapine 100 MG Oral Tablet",
            "clozapine 100 mg oral tablet",
            "clozapine 200 MG Oral Tablet",
            "clozapine 200 mg oral tablet",
            "clozapine 25 MG Oral Tablet",
            "clozapine 25 mg oral tablet",
            "clozapine 50 MG Oral Tablet",
            "clozapine 50 mg oral tablet",
            "clozaril",
            "clozaril (oral pill)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "44%"
            },
            {
                "value": "200 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "38%"
            },
            {
                "value": "At bedtime",
                "pct": "31%"
            },
            {
                "value": "Twice daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Kerendia",
        "route": "Oral Pill",
        "fullName": "Kerendia (Oral Pill)",
        "totalCount": 39,
        "searchTerms": [
            "KERENDIA",
            "KERENDIA (Oral Pill)",
            "KERENDIA (Oral)",
            "Kerendia",
            "Kerendia (Oral)",
            "kerendia",
            "kerendia (oral pill)",
            "kerendia (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "85%"
            },
            {
                "value": "20 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N18.9",
                "description": "Chronic kidney disease, unspecified",
                "pct": "37%"
            },
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "32%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "13%"
            }
        ]
    },
    {
        "name": "Magnesium Oxide - Supplement",
        "route": "Oral Pill",
        "fullName": "Magnesium Oxide - Supplement (Oral Pill)",
        "totalCount": 39,
        "searchTerms": [
            "MAG-OX 400",
            "MAGNESIUM OXIDE - Supplement",
            "MAGNESIUM OXIDE - Supplement (Oral)",
            "Mag-Ox",
            "Mag-Oxide",
            "Magnesium Oxide - Supplement",
            "Magnesium Oxide - Supplement (Oral)",
            "mag-ox",
            "mag-ox 400",
            "mag-oxide",
            "magnesium oxide - Supplement",
            "magnesium oxide - Supplement (Oral)",
            "magnesium oxide - supplement",
            "magnesium oxide - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "87%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "72%"
            },
            {
                "value": "Twice daily",
                "pct": "13%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E61.2",
                "description": "Magnesium deficiency",
                "pct": "44%"
            },
            {
                "code": "E83.42",
                "description": "Hypomagnesemia",
                "pct": "44%"
            }
        ]
    },
    {
        "name": "Vitamin A/Vitamin D",
        "route": "Oral Pill",
        "fullName": "Vitamin A/Vitamin D (Oral Pill)",
        "totalCount": 38,
        "searchTerms": [
            "Vitamin A/Vitamin D",
            "Vitamin A/Vitamin D (Oral Pill)",
            "vitamin A 1250 UNT / vitamin D 135 UNT Oral Capsule",
            "vitamin A 2500 UNT / vitamin D 270 UNT Oral Capsule",
            "vitamin a 1250 unt / vitamin d 135 unt oral capsule",
            "vitamin a 2500 unt / vitamin d 270 unt oral capsule",
            "vitamin a/vitamin d",
            "vitamin a/vitamin d (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "26%"
            },
            {
                "value": "Once daily",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Gemfibrozil",
        "route": "Oral Pill",
        "fullName": "Gemfibrozil (Oral Pill)",
        "totalCount": 38,
        "searchTerms": [
            "Gemfibrozil",
            "Gemfibrozil (Oral Pill)",
            "Gemfibrozil (Oral)",
            "gemfibrozil",
            "gemfibrozil (Oral)",
            "gemfibrozil (oral pill)",
            "gemfibrozil (oral)",
            "gemfibrozil 600 MG Oral Tablet",
            "gemfibrozil 600 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "97%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "61%"
            },
            {
                "value": "Once daily",
                "pct": "34%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.1",
                "description": "Pure hyperglyceridemia",
                "pct": "46%"
            }
        ]
    },
    {
        "name": "Latanoprost/Netarsudil",
        "route": "Ophthalmic",
        "fullName": "Latanoprost/Netarsudil (Ophthalmic)",
        "totalCount": 38,
        "searchTerms": [
            "Latanoprost/Netarsudil",
            "Latanoprost/Netarsudil (Ophthalmic)",
            "latanoprost 0.05 MG/ML / netarsudil 0.2 MG/ML Ophthalmic Solution",
            "latanoprost 0.05 mg/ml / netarsudil 0.2 mg/ml ophthalmic solution",
            "latanoprost/netarsudil",
            "latanoprost/netarsudil (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "39%"
            },
            {
                "value": "At bedtime",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BANOPHEN",
        "route": "Oral Pill",
        "fullName": "BANOPHEN (Oral Pill)",
        "totalCount": 38,
        "searchTerms": [
            "BANOPHEN",
            "BANOPHEN (Oral Pill)",
            "Banophen",
            "Banophen (Oral)",
            "banophen",
            "banophen (oral pill)",
            "banophen (oral)",
            "diphenhydramine hydrochloride 25 MG Oral Capsule",
            "diphenhydramine hydrochloride 25 MG Oral Tablet",
            "diphenhydramine hydrochloride 25 mg oral capsule",
            "diphenhydramine hydrochloride 25 mg oral tablet",
            "diphenhydramine hydrochloride 50 MG Oral Capsule",
            "diphenhydramine hydrochloride 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "76%"
            },
            {
                "value": "50 mg",
                "pct": "24%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            },
            {
                "value": "As needed",
                "pct": "24%"
            },
            {
                "value": "At bedtime",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ABILIFY",
        "route": "Injectable",
        "fullName": "ABILIFY (Injectable)",
        "totalCount": 38,
        "searchTerms": [
            "1.5 ML aripiprazole 200 MG/ML Prefilled Syringe",
            "1.5 ml aripiprazole 200 mg/ml prefilled syringe",
            "ABILIFY",
            "ABILIFY (Injectable)",
            "abilify",
            "abilify (injectable)",
            "aripiprazole 300 MG Injection",
            "aripiprazole 300 mg injection",
            "aripiprazole 400 MG Injection",
            "aripiprazole 400 mg injection"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "74%"
            },
            {
                "value": "300 mg",
                "pct": "13%"
            }
        ],
        "frequencies": [
            {
                "value": "Monthly",
                "pct": "68%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Letrozole",
        "route": "Oral Pill",
        "fullName": "Letrozole (Oral Pill)",
        "totalCount": 38,
        "searchTerms": [
            "Femara",
            "Letrozole",
            "Letrozole (Oral Pill)",
            "Letrozole (Oral)",
            "femara",
            "letrozole",
            "letrozole (oral pill)",
            "letrozole (oral)",
            "letrozole 2.5 MG Oral Tablet",
            "letrozole 2.5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2.5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "C80.1",
                "description": "Malignant (primary) neoplasm, unspecified",
                "pct": "60%"
            },
            {
                "code": "C50",
                "description": "Malignant neoplasm of breast",
                "pct": "24%"
            }
        ]
    },
    {
        "name": "ALBUTEROL SULFATE",
        "route": "Inhaler",
        "fullName": "ALBUTEROL SULFATE (Inhaler)",
        "totalCount": 38,
        "searchTerms": [
            "ALBUTEROL SULFATE",
            "Albuterol Sulfate",
            "Albuterol Sulfate (Inhaler)",
            "Albuterol sulfate",
            "Albuterol sulfate (Inhaler)",
            "Proventil",
            "Proventil HFA",
            "Ventolin HFA",
            "albuterol sulfate",
            "albuterol sulfate (inhaler)",
            "proventil",
            "proventil hfa",
            "ventolin hfa"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "66%"
            },
            {
                "value": "2.5 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "84%"
            }
        ],
        "adminNotes": [
            {
                "value": "Shake well before use",
                "pct": "18%"
            }
        ],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "79%"
            },
            {
                "code": "R06.02",
                "description": "Shortness of breath",
                "pct": "33%"
            },
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "24%"
            }
        ]
    },
    {
        "name": "amLODIPine/Atorvastatin",
        "route": "Oral Pill",
        "fullName": "amLODIPine/Atorvastatin (Oral Pill)",
        "totalCount": 37,
        "searchTerms": [
            "amLODIPine/Atorvastatin",
            "amLODIPine/Atorvastatin (Oral Pill)",
            "amlodipine 10 MG / atorvastatin 20 MG Oral Tablet",
            "amlodipine 10 MG / atorvastatin 80 MG Oral Tablet",
            "amlodipine 10 mg / atorvastatin 20 mg oral tablet",
            "amlodipine 10 mg / atorvastatin 80 mg oral tablet",
            "amlodipine 2.5 MG / atorvastatin 10 MG Oral Tablet",
            "amlodipine 2.5 MG / atorvastatin 20 MG Oral Tablet",
            "amlodipine 2.5 mg / atorvastatin 10 mg oral tablet",
            "amlodipine 2.5 mg / atorvastatin 20 mg oral tablet",
            "amlodipine 5 MG / atorvastatin 10 MG Oral Tablet",
            "amlodipine 5 MG / atorvastatin 20 MG Oral Tablet",
            "amlodipine 5 MG / atorvastatin 40 MG Oral Tablet",
            "amlodipine 5 MG / atorvastatin 80 MG Oral Tablet",
            "amlodipine 5 mg / atorvastatin 10 mg oral tablet",
            "amlodipine 5 mg / atorvastatin 20 mg oral tablet",
            "amlodipine 5 mg / atorvastatin 40 mg oral tablet",
            "amlodipine 5 mg / atorvastatin 80 mg oral tablet",
            "amlodipine/atorvastatin",
            "amlodipine/atorvastatin (oral pill)"
        ],
        "dosages": [
            {
                "value": "10-80 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Nitrofurantoin",
        "route": "Oral Pill",
        "fullName": "Nitrofurantoin (Oral Pill)",
        "totalCount": 37,
        "searchTerms": [
            "Nitrofurantoin",
            "Nitrofurantoin (Oral Pill)",
            "Nitrofurantoin (Oral)",
            "nitrofurantoin",
            "nitrofurantoin (oral pill)",
            "nitrofurantoin (oral)",
            "nitrofurantoin, macrocrystals 100 MG Oral Capsule",
            "nitrofurantoin, macrocrystals 100 mg oral capsule",
            "nitrofurantoin, macrocrystals 25 MG / nitrofurantoin, monohydrate 75 MG Oral Capsule",
            "nitrofurantoin, macrocrystals 25 mg / nitrofurantoin, monohydrate 75 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "35%"
            },
            {
                "value": "Twice daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N39.0",
                "description": "Urinary tract infection, site not specified",
                "pct": "52%"
            }
        ]
    },
    {
        "name": "BAYER ASPIRIN",
        "route": "Oral Pill",
        "fullName": "BAYER ASPIRIN (Oral Pill)",
        "totalCount": 37,
        "searchTerms": [
            "BAYER ASPIRIN",
            "BAYER ASPIRIN (Oral Pill)",
            "Bayer Aspirin",
            "Bayer Aspirin (Oral)",
            "aspirin 325 MG Oral Tablet",
            "aspirin 325 mg oral tablet",
            "aspirin 500 MG Oral Tablet",
            "aspirin 500 mg oral tablet",
            "aspirin 81 MG Delayed Release Oral Tablet",
            "aspirin 81 mg delayed release oral tablet",
            "bayer aspirin",
            "bayer aspirin (oral pill)",
            "bayer aspirin (oral)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "86%"
            },
            {
                "value": "325 mg",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "65%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium acetate",
        "route": "Oral Pill",
        "fullName": "Calcium acetate (Oral Pill)",
        "totalCount": 37,
        "searchTerms": [
            "CALCIUM ACETATE",
            "CALCIUM ACETATE (Oral)",
            "Calcium Acetate",
            "Calcium Acetate (Oral)",
            "Calcium acetate",
            "Calcium acetate (Oral Pill)",
            "PhosLo",
            "Phoslo",
            "Phoslo Gel Caps",
            "calcium acetate",
            "calcium acetate (oral pill)",
            "calcium acetate (oral)",
            "calcium acetate 667 MG Oral Capsule",
            "calcium acetate 667 MG Oral Tablet",
            "calcium acetate 667 mg oral capsule",
            "calcium acetate 667 mg oral tablet",
            "phoslo",
            "phoslo gel caps"
        ],
        "dosages": [
            {
                "value": "667 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "41%"
            },
            {
                "value": "Once daily",
                "pct": "19%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E83.39",
                "description": "Other disorders of phosphorus metabolism",
                "pct": "30%"
            },
            {
                "code": "N18.9",
                "description": "Chronic kidney disease, unspecified",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "Icosapent ethyl",
        "route": "Oral Pill",
        "fullName": "Icosapent ethyl (Oral Pill)",
        "totalCount": 37,
        "searchTerms": [
            "ICOSAPENT ETHYL",
            "ICOSAPENT ETHYL (Oral)",
            "Icosapent Ethyl",
            "Icosapent Ethyl (Oral)",
            "Icosapent ethyl",
            "Icosapent ethyl (Oral Pill)",
            "VASCEPA",
            "Vascepa",
            "icosapent ethyl",
            "icosapent ethyl (oral pill)",
            "icosapent ethyl (oral)",
            "icosapent ethyl 1000 MG Oral Capsule",
            "icosapent ethyl 1000 mg oral capsule",
            "icosapent ethyl 500 MG Oral Capsule",
            "icosapent ethyl 500 mg oral capsule",
            "vascepa"
        ],
        "dosages": [
            {
                "value": "1 g",
                "pct": "22%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "70%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.1",
                "description": "Pure hyperglyceridemia",
                "pct": "48%"
            },
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "DIGOX",
        "route": "Oral Pill",
        "fullName": "DIGOX (Oral Pill)",
        "totalCount": 37,
        "searchTerms": [
            "DIGOX",
            "DIGOX (Oral Pill)",
            "digox",
            "digox (oral pill)",
            "digoxin 0.125 MG Oral Tablet",
            "digoxin 0.125 mg oral tablet",
            "digoxin 0.25 MG Oral Tablet",
            "digoxin 0.25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.125 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "65%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "JENTADUETO",
        "route": "Oral Pill",
        "fullName": "JENTADUETO (Oral Pill)",
        "totalCount": 37,
        "searchTerms": [
            "JENTADUETO",
            "JENTADUETO (Oral Pill)",
            "Jentadueto",
            "Jentadueto (Oral)",
            "jentadueto",
            "jentadueto (oral pill)",
            "jentadueto (oral)",
            "linagliptin 2.5 MG / metformin hydrochloride 1000 MG Oral Tablet",
            "linagliptin 2.5 MG / metformin hydrochloride 500 MG Oral Tablet",
            "linagliptin 2.5 MG / metformin hydrochloride 850 MG Oral Tablet",
            "linagliptin 2.5 mg / metformin hydrochloride 1000 mg oral tablet",
            "linagliptin 2.5 mg / metformin hydrochloride 500 mg oral tablet",
            "linagliptin 2.5 mg / metformin hydrochloride 850 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2.5-500 mg",
                "pct": "41%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "57%"
            },
            {
                "value": "Once daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "VITAMIN B COMPLEX",
        "route": "Oral Pill",
        "fullName": "VITAMIN B COMPLEX (Oral Pill)",
        "totalCount": 37,
        "searchTerms": ["VITAMIN B COMPLEX", "Vitamin B Complex", "vitamin b complex"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "97%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Pramipexole",
        "route": "Oral Pill",
        "fullName": "Pramipexole (Oral Pill)",
        "totalCount": 36,
        "searchTerms": [
            "Pramipexole",
            "Pramipexole (Oral Pill)",
            "Pramipexole (Oral)",
            "pramipexole",
            "pramipexole (oral pill)",
            "pramipexole (oral)",
            "pramipexole dihydrochloride 0.125 MG Oral Tablet",
            "pramipexole dihydrochloride 0.125 mg oral tablet",
            "pramipexole dihydrochloride 0.25 MG Oral Tablet",
            "pramipexole dihydrochloride 0.25 mg oral tablet",
            "pramipexole dihydrochloride 0.5 MG Oral Tablet",
            "pramipexole dihydrochloride 0.5 mg oral tablet",
            "pramipexole dihydrochloride 0.75 MG Oral Tablet",
            "pramipexole dihydrochloride 0.75 mg oral tablet",
            "pramipexole dihydrochloride 1 MG Oral Tablet",
            "pramipexole dihydrochloride 1 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.25 mg",
                "pct": "39%"
            },
            {
                "value": "1 mg",
                "pct": "19%"
            },
            {
                "value": "0.5 mg",
                "pct": "17%"
            },
            {
                "value": "0.125 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "31%"
            },
            {
                "value": "Three times daily",
                "pct": "25%"
            },
            {
                "value": "At bedtime",
                "pct": "22%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G20",
                "description": "Parkinson's disease",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "Potassium bicarbonate",
        "route": "Effervescent",
        "fullName": "Potassium bicarbonate (Effervescent)",
        "totalCount": 36,
        "searchTerms": [
            "Potassium bicarbonate",
            "Potassium bicarbonate (Effervescent)",
            "potassium bicarbonate",
            "potassium bicarbonate (effervescent)",
            "potassium bicarbonate 10 MEQ Effervescent Oral Tablet",
            "potassium bicarbonate 10 meq effervescent oral tablet",
            "potassium bicarbonate 20 MEQ Effervescent Oral Tablet",
            "potassium bicarbonate 20 meq effervescent oral tablet",
            "potassium bicarbonate 25 MEQ Effervescent Oral Tablet",
            "potassium bicarbonate 25 meq effervescent oral tablet"
        ],
        "dosages": [
            {
                "value": "10 meq",
                "pct": "47%"
            },
            {
                "value": "20 meq",
                "pct": "28%"
            },
            {
                "value": "25 meq",
                "pct": "14%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lansoprazole",
        "route": "Oral Pill",
        "fullName": "Lansoprazole (Oral Pill)",
        "totalCount": 36,
        "searchTerms": [
            "LANSOPRAZOLE",
            "Lansoprazole",
            "Lansoprazole (Oral Pill)",
            "Lansoprazole (Oral)",
            "Prevacid",
            "lansoprazole",
            "lansoprazole (oral pill)",
            "lansoprazole (oral)",
            "lansoprazole 15 MG Delayed Release Oral Capsule",
            "lansoprazole 15 mg delayed release oral capsule",
            "lansoprazole 30 MG Delayed Release Oral Capsule",
            "lansoprazole 30 mg delayed release oral capsule",
            "prevacid"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "75%"
            },
            {
                "value": "15 mg",
                "pct": "22%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "65%"
            }
        ]
    },
    {
        "name": "Aliskiren/Hydrochlorothiazide",
        "route": "Oral Pill",
        "fullName": "Aliskiren/Hydrochlorothiazide (Oral Pill)",
        "totalCount": 36,
        "searchTerms": [
            "Aliskiren/Hydrochlorothiazide",
            "Aliskiren/Hydrochlorothiazide (Oral Pill)",
            "aliskiren 150 MG / hydrochlorothiazide 12.5 MG Oral Tablet",
            "aliskiren 150 MG / hydrochlorothiazide 25 MG Oral Tablet",
            "aliskiren 150 mg / hydrochlorothiazide 12.5 mg oral tablet",
            "aliskiren 150 mg / hydrochlorothiazide 25 mg oral tablet",
            "aliskiren 300 MG / hydrochlorothiazide 12.5 MG Oral Tablet",
            "aliskiren 300 MG / hydrochlorothiazide 25 MG Oral Tablet",
            "aliskiren 300 mg / hydrochlorothiazide 12.5 mg oral tablet",
            "aliskiren 300 mg / hydrochlorothiazide 25 mg oral tablet",
            "aliskiren/hydrochlorothiazide",
            "aliskiren/hydrochlorothiazide (oral pill)"
        ],
        "dosages": [
            {
                "value": "150-12.5 mg",
                "pct": "28%"
            },
            {
                "value": "12.5 mg",
                "pct": "25%"
            },
            {
                "value": "25 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "69%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PRESERVISION",
        "route": "Oral Pill",
        "fullName": "PRESERVISION (Oral Pill)",
        "totalCount": 36,
        "searchTerms": [
            "PRESERVISION",
            "PRESERVISION (Oral Pill)",
            "ascorbic acid 113 MG / beta carotene 7160 MG / cuprous oxide 0.4 MG / dl-alpha tocopheryl acetate 100 UNT / zinc oxide 17.4 MG Oral Tablet",
            "ascorbic acid 113 mg / beta carotene 7160 mg / cuprous oxide 0.4 mg / dl-alpha tocopheryl acetate 100 unt / zinc oxide 17.4 mg oral tablet",
            "ascorbic acid 226 MG / beta carotene 14320 UNT / cuprous oxide 0.8 MG / dl-alpha tocopheryl acetate 200 UNT / zinc oxide 34.8 MG Oral Capsule",
            "ascorbic acid 226 mg / beta carotene 14320 unt / cuprous oxide 0.8 mg / dl-alpha tocopheryl acetate 200 unt / zinc oxide 34.8 mg oral capsule",
            "preservision",
            "preservision (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "61%"
            },
            {
                "value": "Twice daily",
                "pct": "31%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H35.30",
                "description": "Unspecified macular degeneration",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "Valproate",
        "route": "Oral Pill",
        "fullName": "Valproate (Oral Pill)",
        "totalCount": 36,
        "searchTerms": [
            "Valproate",
            "Valproate (Oral Pill)",
            "divalproex sodium 125 MG Delayed Release Oral Capsule",
            "divalproex sodium 125 MG Delayed Release Oral Tablet",
            "divalproex sodium 125 mg delayed release oral capsule",
            "divalproex sodium 125 mg delayed release oral tablet",
            "divalproex sodium 250 MG Delayed Release Oral Tablet",
            "divalproex sodium 250 mg delayed release oral tablet",
            "divalproex sodium 500 MG Delayed Release Oral Tablet",
            "divalproex sodium 500 mg delayed release oral tablet",
            "valproate",
            "valproate (oral pill)",
            "valproic acid 250 MG Oral Capsule",
            "valproic acid 250 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "250 mg",
                "pct": "33%"
            },
            {
                "value": "500 mg",
                "pct": "25%"
            },
            {
                "value": "125 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "36%"
            },
            {
                "value": "Once daily",
                "pct": "31%"
            },
            {
                "value": "At bedtime",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NAPROSYN",
        "route": "Oral Pill",
        "fullName": "NAPROSYN (Oral Pill)",
        "totalCount": 35,
        "searchTerms": [
            "NAPROSYN",
            "NAPROSYN (Oral Pill)",
            "naprosyn",
            "naprosyn (oral pill)",
            "naproxen 250 MG Oral Tablet",
            "naproxen 250 mg oral tablet",
            "naproxen 375 MG Delayed Release Oral Tablet",
            "naproxen 375 mg delayed release oral tablet",
            "naproxen 500 MG Oral Tablet",
            "naproxen 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "77%"
            },
            {
                "value": "250 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "43%"
            },
            {
                "value": "As needed",
                "pct": "29%"
            },
            {
                "value": "Once daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Betamethasone",
        "route": "Topical",
        "fullName": "Betamethasone (Topical)",
        "totalCount": 35,
        "searchTerms": [
            "BETAMETHASONE",
            "Betamethasone",
            "Betamethasone (Topical)",
            "betamethasone",
            "betamethasone (topical)",
            "betamethasone 0.0005 MG/MG Topical Ointment",
            "betamethasone 0.0005 mg/mg topical ointment",
            "betamethasone 0.5 MG/ML Topical Cream",
            "betamethasone 0.5 MG/ML Topical Spray",
            "betamethasone 0.5 mg/ml topical cream",
            "betamethasone 0.5 mg/ml topical spray",
            "betamethasone 1 MG/ML Topical Lotion",
            "betamethasone 1 mg/ml topical lotion",
            "betamethasone valerate 1.2 MG/ML Topical Foam",
            "betamethasone valerate 1.2 mg/ml topical foam"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "40%"
            },
            {
                "value": "Twice daily",
                "pct": "40%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Aspirin",
        "route": "Chewable",
        "fullName": "Aspirin (Chewable)",
        "totalCount": 35,
        "searchTerms": [
            "Aspirin",
            "Aspirin (Chewable)",
            "aspirin",
            "aspirin (chewable)",
            "aspirin 81 MG Chewable Tablet",
            "aspirin 81 mg chewable tablet"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "44%"
            }
        ]
    },
    {
        "name": "KLOR-CON XR",
        "route": "Oral Pill",
        "fullName": "KLOR-CON XR (Oral Pill)",
        "totalCount": 35,
        "searchTerms": [
            "KLOR-CON",
            "KLOR-CON XR",
            "KLOR-CON XR (Oral Pill)",
            "Microencapsulated potassium chloride 10 MEQ Extended Release Oral Tablet",
            "Microencapsulated potassium chloride 20 MEQ Extended Release Oral Tablet",
            "klor-con",
            "klor-con xr",
            "klor-con xr (oral pill)",
            "microencapsulated potassium chloride 10 meq extended release oral tablet",
            "microencapsulated potassium chloride 20 meq extended release oral tablet",
            "potassium chloride 10 MEQ Extended Release Oral Capsule",
            "potassium chloride 10 MEQ Extended Release Oral Tablet",
            "potassium chloride 10 meq extended release oral capsule",
            "potassium chloride 10 meq extended release oral tablet",
            "potassium chloride 8 MEQ Extended Release Oral Capsule",
            "potassium chloride 8 meq extended release oral capsule"
        ],
        "dosages": [
            {
                "value": "20 meq",
                "pct": "51%"
            },
            {
                "value": "10 meq",
                "pct": "43%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "63%"
            },
            {
                "value": "Twice daily",
                "pct": "14%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "REPATHA",
        "route": "Injectable",
        "fullName": "REPATHA (Injectable)",
        "totalCount": 35,
        "searchTerms": [
            "1 ML evolocumab 140 MG/ML Auto-Injector",
            "1 ML evolocumab 140 MG/ML Prefilled Syringe",
            "1 ml evolocumab 140 mg/ml auto-injector",
            "1 ml evolocumab 140 mg/ml prefilled syringe",
            "3.5 ML evolocumab 120 MG/ML Cartridge",
            "3.5 ml evolocumab 120 mg/ml cartridge",
            "REPATHA",
            "REPATHA (Injectable)",
            "repatha",
            "repatha (injectable)"
        ],
        "dosages": [
            {
                "value": "140 mg",
                "pct": "97%"
            }
        ],
        "frequencies": [
            {
                "value": "Every 2 weeks",
                "pct": "20%"
            },
            {
                "value": "140 mg subcutaneously every 2 weeks",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "27%"
            }
        ]
    },
    {
        "name": "Rivastigmine",
        "route": "Oral Pill",
        "fullName": "Rivastigmine (Oral Pill)",
        "totalCount": 35,
        "searchTerms": [
            "Rivastigmine",
            "Rivastigmine (Oral Pill)",
            "Rivastigmine (Oral)",
            "rivastigmine",
            "rivastigmine (oral pill)",
            "rivastigmine (oral)",
            "rivastigmine 1.5 MG Oral Capsule",
            "rivastigmine 1.5 mg oral capsule",
            "rivastigmine 3 MG Oral Capsule",
            "rivastigmine 3 mg oral capsule",
            "rivastigmine 4.5 MG Oral Capsule",
            "rivastigmine 4.5 mg oral capsule",
            "rivastigmine 6 MG Oral Capsule",
            "rivastigmine 6 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "1.5 mg",
                "pct": "26%"
            },
            {
                "value": "3 mg",
                "pct": "23%"
            },
            {
                "value": "6 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "46%"
            },
            {
                "value": "Once daily",
                "pct": "37%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Terazosin",
        "route": "Oral Pill",
        "fullName": "Terazosin (Oral Pill)",
        "totalCount": 35,
        "searchTerms": [
            "TERAZOSIN",
            "Terazosin",
            "Terazosin (Oral Pill)",
            "terazosin",
            "terazosin (oral pill)",
            "terazosin 1 MG Oral Capsule",
            "terazosin 1 mg oral capsule",
            "terazosin 10 MG Oral Capsule",
            "terazosin 10 mg oral capsule",
            "terazosin 2 MG Oral Capsule",
            "terazosin 2 mg oral capsule",
            "terazosin 5 MG Oral Capsule",
            "terazosin 5 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "54%"
            },
            {
                "value": "5 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N40.1",
                "description": "Enlarged prostate with lower urinary tract symptoms",
                "pct": "45%"
            }
        ]
    },
    {
        "name": "PENNSAID",
        "route": "Topical",
        "fullName": "PENNSAID (Topical)",
        "totalCount": 35,
        "searchTerms": [
            "PENNSAID",
            "PENNSAID (Topical)",
            "diclofenac sodium 15 MG/ML Topical Solution",
            "diclofenac sodium 15 mg/ml topical solution",
            "diclofenac sodium 20 MG/ML Topical Solution",
            "diclofenac sodium 20 mg/ml topical solution",
            "pennsaid",
            "pennsaid (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "51%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Bisacodyl/Polyethylene glycol 3350/Potassium chloride/Sodium bicarbonate/Sodium chloride",
        "route": "Pack",
        "fullName": "Bisacodyl/Polyethylene glycol 3350/Potassium chloride/Sodium bicarbonate/Sodium chloride (Pack)",
        "totalCount": 34,
        "searchTerms": [
            "Bisacodyl/Polyethylene glycol 3350/Potassium chloride/Sodium bicarbonate/Sodium chloride",
            "Bisacodyl/Polyethylene glycol 3350/Potassium chloride/Sodium bicarbonate/Sodium chloride (Pack)",
            "bisacodyl/polyethylene glycol 3350/potassium chloride/sodium bicarbonate/sodium chloride",
            "bisacodyl/polyethylene glycol 3350/potassium chloride/sodium bicarbonate/sodium chloride (pack)",
            "{1 (bisacodyl 5 MG Delayed Release Oral Tablet) / 1 (2000 ML) (polyethylene glycol 3350 210000 MG / potassium chloride 740 MG / sodium bicarbonate 2860 MG / sodium chloride 5600 MG Powder for Oral Solution) } Pack",
            "{1 (bisacodyl 5 mg delayed release oral tablet) / 1 (2000 ml) (polyethylene glycol 3350 210000 mg / potassium chloride 740 mg / sodium bicarbonate 2860 mg / sodium chloride 5600 mg powder for oral solution) } pack"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "26%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SYNJARDY",
        "route": "Oral Pill",
        "fullName": "SYNJARDY (Oral Pill)",
        "totalCount": 34,
        "searchTerms": [
            "SYNJARDY",
            "SYNJARDY (Oral Pill)",
            "Synjardy",
            "Synjardy (Oral)",
            "empagliflozin 12.5 MG / metformin hydrochloride 1000 MG Oral Tablet",
            "empagliflozin 12.5 MG / metformin hydrochloride 500 MG Oral Tablet",
            "empagliflozin 12.5 mg / metformin hydrochloride 1000 mg oral tablet",
            "empagliflozin 12.5 mg / metformin hydrochloride 500 mg oral tablet",
            "empagliflozin 5 MG / metformin hydrochloride 1000 MG Oral Tablet",
            "empagliflozin 5 MG / metformin hydrochloride 500 MG Oral Tablet",
            "empagliflozin 5 mg / metformin hydrochloride 1000 mg oral tablet",
            "empagliflozin 5 mg / metformin hydrochloride 500 mg oral tablet",
            "synjardy",
            "synjardy (oral pill)",
            "synjardy (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "62%"
            },
            {
                "value": "Once daily",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "61%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "22%"
            }
        ]
    },
    {
        "name": "ALPHAGAN",
        "route": "Ophthalmic",
        "fullName": "ALPHAGAN (Ophthalmic)",
        "totalCount": 34,
        "searchTerms": [
            "ALPHAGAN",
            "ALPHAGAN (Ophthalmic)",
            "alphagan",
            "alphagan (ophthalmic)",
            "brimonidine tartrate 1 MG/ML Ophthalmic Solution",
            "brimonidine tartrate 1 mg/ml ophthalmic solution",
            "brimonidine tartrate 1.5 MG/ML Ophthalmic Solution",
            "brimonidine tartrate 1.5 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "47%"
            },
            {
                "value": "Once daily",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OYSCO 500 WITH D",
        "route": "Oral Pill",
        "fullName": "OYSCO 500 WITH D (Oral Pill)",
        "totalCount": 34,
        "searchTerms": [
            "OYSCO 500 WITH D",
            "OYSCO 500 WITH D (Oral Pill)",
            "calcium carbonate 1250 MG / cholecalciferol 200 UNT Oral Tablet",
            "calcium carbonate 1250 mg / cholecalciferol 200 unt oral tablet",
            "oysco 500 with d",
            "oysco 500 with d (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "50%"
            },
            {
                "value": "Once daily",
                "pct": "41%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "35%"
            }
        ]
    },
    {
        "name": "Verapamil XR",
        "route": "Oral Pill",
        "fullName": "Verapamil XR (Oral Pill)",
        "totalCount": 34,
        "searchTerms": [
            "24 HR verapamil hydrochloride 100 MG Extended Release Oral Capsule",
            "24 HR verapamil hydrochloride 120 MG Extended Release Oral Capsule",
            "24 HR verapamil hydrochloride 180 MG Extended Release Oral Capsule",
            "24 HR verapamil hydrochloride 200 MG Extended Release Oral Capsule",
            "24 HR verapamil hydrochloride 240 MG Extended Release Oral Capsule",
            "24 hr verapamil hydrochloride 100 mg extended release oral capsule",
            "24 hr verapamil hydrochloride 120 mg extended release oral capsule",
            "24 hr verapamil hydrochloride 180 mg extended release oral capsule",
            "24 hr verapamil hydrochloride 200 mg extended release oral capsule",
            "24 hr verapamil hydrochloride 240 mg extended release oral capsule",
            "Verapamil XR",
            "Verapamil XR (Oral Pill)",
            "verapamil xr",
            "verapamil xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "120 mg",
                "pct": "41%"
            },
            {
                "value": "180 mg",
                "pct": "21%"
            },
            {
                "value": "240 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CARAFATE",
        "route": "Oral Pill",
        "fullName": "CARAFATE (Oral Pill)",
        "totalCount": 34,
        "searchTerms": [
            "CARAFATE",
            "CARAFATE (Oral Pill)",
            "carafate",
            "carafate (oral pill)",
            "sucralfate 1000 MG Oral Tablet",
            "sucralfate 1000 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 g",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "Four times daily",
                "pct": "29%"
            },
            {
                "value": "Once daily",
                "pct": "18%"
            },
            {
                "value": "Twice daily",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "COUMADIN",
        "route": "Oral Pill",
        "fullName": "COUMADIN (Oral Pill)",
        "totalCount": 34,
        "searchTerms": [
            "COUMADIN",
            "COUMADIN (Oral Pill)",
            "coumadin",
            "coumadin (oral pill)",
            "warfarin sodium 1 MG Oral Tablet",
            "warfarin sodium 1 mg oral tablet",
            "warfarin sodium 10 MG Oral Tablet",
            "warfarin sodium 10 mg oral tablet",
            "warfarin sodium 2 MG Oral Tablet",
            "warfarin sodium 2 mg oral tablet",
            "warfarin sodium 2.5 MG Oral Tablet",
            "warfarin sodium 2.5 mg oral tablet",
            "warfarin sodium 4 MG Oral Tablet",
            "warfarin sodium 4 mg oral tablet",
            "warfarin sodium 5 MG Oral Tablet",
            "warfarin sodium 5 mg oral tablet",
            "warfarin sodium 6 MG Oral Tablet",
            "warfarin sodium 6 mg oral tablet",
            "warfarin sodium 7.5 MG Oral Tablet",
            "warfarin sodium 7.5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "24%"
            },
            {
                "value": "2.5 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "68%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Levocetirizine",
        "route": "Oral Pill",
        "fullName": "Levocetirizine (Oral Pill)",
        "totalCount": 34,
        "searchTerms": [
            "Levocetirizine",
            "Levocetirizine (Oral Pill)",
            "Levocetirizine (Oral)",
            "XYZAL Allergy 24HR",
            "Xyzal",
            "levocetirizine",
            "levocetirizine (oral pill)",
            "levocetirizine (oral)",
            "levocetirizine dihydrochloride 5 MG Oral Tablet",
            "levocetirizine dihydrochloride 5 mg oral tablet",
            "xyzal",
            "xyzal allergy 24hr"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "62%"
            },
            {
                "code": "J30",
                "description": "Vasomotor and allergic rhinitis",
                "pct": "29%"
            }
        ]
    },
    {
        "name": "Melatonin - Supplement",
        "route": "Oral Pill",
        "fullName": "Melatonin - Supplement (Oral Pill)",
        "totalCount": 34,
        "searchTerms": [
            "MELATONIN - Supplement",
            "MELATONIN - Supplement (Oral)",
            "Melatonin - Supplement",
            "Melatonin - Supplement (Oral)",
            "melatonin - Supplement",
            "melatonin - Supplement (Oral)",
            "melatonin - supplement",
            "melatonin - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "32%"
            },
            {
                "value": "3 mg",
                "pct": "26%"
            },
            {
                "value": "10 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "59%"
            },
            {
                "value": "At bedtime",
                "pct": "38%"
            }
        ],
        "adminNotes": [
            {
                "value": "For insomnia",
                "pct": "15%"
            }
        ],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Eliquis (apixaban)",
        "route": "Oral Pill",
        "fullName": "Eliquis (apixaban) (Oral Pill)",
        "totalCount": 34,
        "searchTerms": [
            "Eliquis (Apixaban)",
            "Eliquis (Apixaban) (Oral)",
            "Eliquis (apixaban)",
            "Eliquis (apixaban) (Oral)",
            "eliquis (apixaban)",
            "eliquis (apixaban) (oral)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "76%"
            },
            {
                "value": "2.5 mg",
                "pct": "24%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "79%"
            },
            {
                "value": "Once daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [
            {
                "value": "Dispense with medication guide",
                "pct": "35%"
            },
            {
                "value": "Dispense with Medication Guide",
                "pct": "21%"
            }
        ],
        "diagnoses": [
            {
                "code": "I48.91",
                "description": "Unspecified atrial fibrillation",
                "pct": "50%"
            },
            {
                "code": "I82.40",
                "description": "Acute embolism and thombos unsp deep veins of low extrm",
                "pct": "41%"
            }
        ]
    },
    {
        "name": "Furosemide",
        "route": "Oral Liquid",
        "fullName": "Furosemide (Oral Liquid)",
        "totalCount": 33,
        "searchTerms": [
            "Furosemide",
            "Furosemide (Oral Liquid)",
            "furosemide",
            "furosemide (oral liquid)",
            "furosemide 10 MG/ML Oral Solution",
            "furosemide 10 mg/ml oral solution",
            "furosemide 8 MG/ML Oral Solution",
            "furosemide 8 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "85%"
            },
            {
                "value": "20 mg",
                "pct": "15%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "18%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dexlansoprazole",
        "route": "Oral Pill",
        "fullName": "Dexlansoprazole (Oral Pill)",
        "totalCount": 33,
        "searchTerms": [
            "Dexilant",
            "Dexlansoprazole",
            "Dexlansoprazole (Oral Pill)",
            "Dexlansoprazole (Oral)",
            "dexilant",
            "dexlansoprazole",
            "dexlansoprazole (oral pill)",
            "dexlansoprazole (oral)",
            "dexlansoprazole 30 MG Delayed Release Oral Capsule",
            "dexlansoprazole 30 mg delayed release oral capsule",
            "dexlansoprazole 60 MG Delayed Release Oral Capsule",
            "dexlansoprazole 60 mg delayed release oral capsule"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "82%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "60%"
            },
            {
                "code": "K21",
                "description": "Gastro-esophageal reflux disease",
                "pct": "20%"
            }
        ]
    },
    {
        "name": "LOPRESSOR",
        "route": "Oral Pill",
        "fullName": "LOPRESSOR (Oral Pill)",
        "totalCount": 33,
        "searchTerms": [
            "LOPRESSOR",
            "LOPRESSOR (Oral Pill)",
            "Lopressor",
            "Lopressor (Oral)",
            "lopressor",
            "lopressor (oral pill)",
            "lopressor (oral)",
            "metoprolol tartrate 100 MG Oral Tablet",
            "metoprolol tartrate 100 mg oral tablet",
            "metoprolol tartrate 50 MG Oral Tablet",
            "metoprolol tartrate 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "45%"
            },
            {
                "value": "25 mg",
                "pct": "24%"
            },
            {
                "value": "100 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "36%"
            },
            {
                "value": "Once daily",
                "pct": "36%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "metFORMIN XR",
        "route": "Oral Pill",
        "fullName": "metFORMIN XR (Oral Pill)",
        "totalCount": 33,
        "searchTerms": [
            "Metformin XR",
            "Metformin XR (Oral)",
            "Modified 24 HR metformin hydrochloride 500 MG Extended Release Oral Tablet",
            "Osmotic 24 HR metformin hydrochloride 500 MG Extended Release Oral Tablet",
            "metFORMIN XR",
            "metFORMIN XR (Oral Pill)",
            "metformin xr",
            "metformin xr (oral pill)",
            "metformin xr (oral)",
            "modified 24 hr metformin hydrochloride 500 mg extended release oral tablet",
            "osmotic 24 hr metformin hydrochloride 500 mg extended release oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "73%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "48%"
            },
            {
                "value": "Once daily",
                "pct": "48%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "57%"
            },
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "18%"
            }
        ]
    },
    {
        "name": "Cinacalcet",
        "route": "Oral Pill",
        "fullName": "Cinacalcet (Oral Pill)",
        "totalCount": 33,
        "searchTerms": [
            "CINACALCET",
            "CINACALCET (Oral)",
            "Cinacalcet",
            "Cinacalcet (Oral Pill)",
            "Cinacalcet (Oral)",
            "Sensipar",
            "cinacalcet",
            "cinacalcet (Oral)",
            "cinacalcet (oral pill)",
            "cinacalcet (oral)",
            "cinacalcet 30 MG Oral Tablet",
            "cinacalcet 30 mg oral tablet",
            "cinacalcet 60 MG Oral Tablet",
            "cinacalcet 60 mg oral tablet",
            "cinacalcet 90 MG Oral Tablet",
            "cinacalcet 90 mg oral tablet",
            "sensipar"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "67%"
            },
            {
                "value": "60 mg",
                "pct": "24%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E21.3",
                "description": "Hyperparathyroidism, unspecified",
                "pct": "74%"
            }
        ]
    },
    {
        "name": "LOKELMA",
        "route": "Oral Suspension Powder",
        "fullName": "LOKELMA (Oral Suspension Powder)",
        "totalCount": 33,
        "searchTerms": [
            "LOKELMA",
            "LOKELMA (Oral Suspension Powder)",
            "lokelma",
            "lokelma (oral suspension powder)",
            "sodium zirconium cyclosilicate 10000 MG Powder for Oral Suspension",
            "sodium zirconium cyclosilicate 10000 mg powder for oral suspension",
            "sodium zirconium cyclosilicate 5000 MG Powder for Oral Suspension",
            "sodium zirconium cyclosilicate 5000 mg powder for oral suspension"
        ],
        "dosages": [
            {
                "value": "10 g",
                "pct": "64%"
            },
            {
                "value": "5 g",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "61%"
            },
            {
                "value": "Twice daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E87.5",
                "description": "Hyperkalemia",
                "pct": "65%"
            }
        ]
    },
    {
        "name": "PROzac",
        "route": "Oral Pill",
        "fullName": "PROzac (Oral Pill)",
        "totalCount": 33,
        "searchTerms": [
            "PROZAC",
            "PROzac",
            "PROzac (Oral Pill)",
            "Prozac",
            "Prozac (Oral)",
            "fluoxetine 10 MG Oral Capsule",
            "fluoxetine 10 mg oral capsule",
            "fluoxetine 20 MG Oral Capsule",
            "fluoxetine 20 mg oral capsule",
            "fluoxetine 40 MG Oral Capsule",
            "fluoxetine 40 mg oral capsule",
            "prozac",
            "prozac (oral pill)",
            "prozac (oral)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "42%"
            },
            {
                "value": "40 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ANORO",
        "route": "Inhalant",
        "fullName": "ANORO (Inhalant)",
        "totalCount": 33,
        "searchTerms": [
            "30 ACTUAT umeclidinium 0.0625 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "30 actuat umeclidinium 0.0625 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "7 ACTUAT umeclidinium 0.0625 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "7 actuat umeclidinium 0.0625 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "ANORO",
            "ANORO (Inhalant)",
            "anoro",
            "anoro (inhalant)"
        ],
        "dosages": [
            {
                "value": "62.5-25 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OXcarbazepine",
        "route": "Oral Pill",
        "fullName": "OXcarbazepine (Oral Pill)",
        "totalCount": 33,
        "searchTerms": [
            "OXcarbazepine",
            "OXcarbazepine (Oral Pill)",
            "OXcarbazepine (Oral)",
            "Oxcarbazepine",
            "Oxcarbazepine (Oral)",
            "TRILEPTAL",
            "Trileptal",
            "oxcarbazepine",
            "oxcarbazepine (oral pill)",
            "oxcarbazepine (oral)",
            "oxcarbazepine 150 MG Oral Tablet",
            "oxcarbazepine 150 mg oral tablet",
            "oxcarbazepine 300 MG Oral Tablet",
            "oxcarbazepine 300 mg oral tablet",
            "oxcarbazepine 600 MG Oral Tablet",
            "oxcarbazepine 600 mg oral tablet",
            "trileptal"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "52%"
            },
            {
                "value": "600 mg",
                "pct": "27%"
            },
            {
                "value": "150 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "67%"
            },
            {
                "value": "Once daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "55%"
            }
        ]
    },
    {
        "name": "ENALAPRIL MALEATE",
        "route": "Oral Pill",
        "fullName": "ENALAPRIL MALEATE (Oral Pill)",
        "totalCount": 33,
        "searchTerms": [
            "ENALAPRIL MALEATE",
            "ENALAPRIL MALEATE (Oral)",
            "Enalapril Maleate",
            "Enalapril Maleate (Oral)",
            "VASOTEC",
            "Vaseretic",
            "Vasotec",
            "enalapril maleate",
            "enalapril maleate (oral)",
            "vaseretic",
            "vasotec"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "52%"
            },
            {
                "value": "10 mg",
                "pct": "24%"
            },
            {
                "value": "5 mg",
                "pct": "18%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            },
            {
                "value": "Twice daily",
                "pct": "15%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "80%"
            }
        ]
    },
    {
        "name": "Alpha tocopherol/Ascorbic acid/Cholecalciferol/Docosahexaenoate/Docusate/Ferrous fumarate/Folic acid/Pyridoxine/Tricalcium phosphate",
        "route": "Oral Pill",
        "fullName": "Alpha tocopherol/Ascorbic acid/Cholecalciferol/Docosahexaenoate/Docusate/Ferrous fumarate/Folic acid/Pyridoxine/Tricalcium phosphate (Oral Pill)",
        "totalCount": 32,
        "searchTerms": [
            "Alpha tocopherol/Ascorbic acid/Cholecalciferol/Docosahexaenoate/Docusate/Ferrous fumarate/Folic acid/Pyridoxine/Tricalcium phosphate",
            "Alpha tocopherol/Ascorbic acid/Cholecalciferol/Docosahexaenoate/Docusate/Ferrous fumarate/Folic acid/Pyridoxine/Tricalcium phosphate (Oral Pill)",
            "alpha tocopherol 30 UNT / ascorbic acid 28 MG / cholecalciferol 400 UNT / docosahexaenoic acid 300 MG / docusate sodium 55 MG / ferrous fumarate 27 MG / folic acid 1.25 MG / pyridoxine hydrochloride 25 MG / tricalcium phosphate 160 MG Oral Capsule",
            "alpha tocopherol 30 unt / ascorbic acid 28 mg / cholecalciferol 400 unt / docosahexaenoic acid 300 mg / docusate sodium 55 mg / ferrous fumarate 27 mg / folic acid 1.25 mg / pyridoxine hydrochloride 25 mg / tricalcium phosphate 160 mg oral capsule",
            "alpha tocopherol/ascorbic acid/cholecalciferol/docosahexaenoate/docusate/ferrous fumarate/folic acid/pyridoxine/tricalcium phosphate",
            "alpha tocopherol/ascorbic acid/cholecalciferol/docosahexaenoate/docusate/ferrous fumarate/folic acid/pyridoxine/tricalcium phosphate (oral pill)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "34%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "44%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HYZAAR",
        "route": "Oral Pill",
        "fullName": "HYZAAR (Oral Pill)",
        "totalCount": 32,
        "searchTerms": [
            "HYZAAR",
            "HYZAAR (Oral Pill)",
            "Hyzaar",
            "Hyzaar (Oral)",
            "hydrochlorothiazide 12.5 MG / losartan potassium 100 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / losartan potassium 50 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / losartan potassium 100 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / losartan potassium 50 mg oral tablet",
            "hydrochlorothiazide 25 MG / losartan potassium 100 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / losartan potassium 100 mg oral tablet",
            "hyzaar",
            "hyzaar (oral pill)",
            "hyzaar (oral)"
        ],
        "dosages": [
            {
                "value": "12.5-50 mg",
                "pct": "31%"
            },
            {
                "value": "25-100 mg",
                "pct": "31%"
            },
            {
                "value": "12.5-100 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Benazepril",
        "route": "Oral Pill",
        "fullName": "Benazepril (Oral Pill)",
        "totalCount": 32,
        "searchTerms": [
            "BENAZEPRIL",
            "Benazepril",
            "Benazepril (Oral Pill)",
            "Benazepril (Oral)",
            "Lotensin",
            "benazepril",
            "benazepril (oral pill)",
            "benazepril (oral)",
            "benazepril hydrochloride 10 MG Oral Tablet",
            "benazepril hydrochloride 10 mg oral tablet",
            "lotensin"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "50%"
            },
            {
                "value": "20 mg",
                "pct": "31%"
            },
            {
                "value": "10 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "78%"
            }
        ]
    },
    {
        "name": "VYTORIN",
        "route": "Oral Pill",
        "fullName": "VYTORIN (Oral Pill)",
        "totalCount": 32,
        "searchTerms": [
            "VYTORIN",
            "VYTORIN (Oral Pill)",
            "ezetimibe 10 MG / simvastatin 10 MG Oral Tablet",
            "ezetimibe 10 MG / simvastatin 20 MG Oral Tablet",
            "ezetimibe 10 MG / simvastatin 40 MG Oral Tablet",
            "ezetimibe 10 MG / simvastatin 80 MG Oral Tablet",
            "ezetimibe 10 mg / simvastatin 10 mg oral tablet",
            "ezetimibe 10 mg / simvastatin 20 mg oral tablet",
            "ezetimibe 10 mg / simvastatin 40 mg oral tablet",
            "ezetimibe 10 mg / simvastatin 80 mg oral tablet",
            "vytorin",
            "vytorin (oral pill)"
        ],
        "dosages": [
            {
                "value": "10-10 mg",
                "pct": "31%"
            },
            {
                "value": "10-40 mg",
                "pct": "28%"
            },
            {
                "value": "10-20 mg",
                "pct": "19%"
            },
            {
                "value": "10-80 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "47%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Mometasone",
        "route": "Topical",
        "fullName": "Mometasone (Topical)",
        "totalCount": 32,
        "searchTerms": [
            "Mometasone",
            "Mometasone (Topical)",
            "mometasone",
            "mometasone (topical)",
            "mometasone furoate 0.001 MG/MG Topical Ointment",
            "mometasone furoate 0.001 mg/mg topical ointment",
            "mometasone furoate 1 MG/ML Topical Lotion",
            "mometasone furoate 1 mg/ml topical lotion"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "47%"
            },
            {
                "value": "Twice daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "L30.9",
                "description": "Dermatitis, unspecified",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "Carboxymethylcellulose",
        "route": "Ophthalmic",
        "fullName": "Carboxymethylcellulose (Ophthalmic)",
        "totalCount": 32,
        "searchTerms": [
            "Carboxymethylcellulose",
            "Carboxymethylcellulose (Ophthalmic)",
            "carboxymethylcellulose",
            "carboxymethylcellulose (ophthalmic)",
            "carboxymethylcellulose sodium 2.5 MG/ML Ophthalmic Solution",
            "carboxymethylcellulose sodium 2.5 mg/ml ophthalmic solution",
            "carboxymethylcellulose sodium 5 MG/ML Ophthalmic Solution",
            "carboxymethylcellulose sodium 5 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "31%"
            },
            {
                "value": "Twice daily",
                "pct": "19%"
            },
            {
                "value": "Four times daily",
                "pct": "16%"
            }
        ],
        "adminNotes": [
            {
                "value": "Avoid touching dropper tip to eye or surfaces",
                "pct": "26%"
            }
        ],
        "diagnoses": [
            {
                "code": "H04.123",
                "description": "Dry eye syndrome of bilateral lacrimal glands",
                "pct": "70%"
            }
        ]
    },
    {
        "name": "BRILINTA",
        "route": "Oral Pill",
        "fullName": "BRILINTA (Oral Pill)",
        "totalCount": 32,
        "searchTerms": [
            "BRILINTA",
            "BRILINTA (Oral Pill)",
            "BRILINTA (Oral)",
            "Brilinta",
            "Brilinta (Oral)",
            "brilinta",
            "brilinta (oral pill)",
            "brilinta (oral)",
            "ticagrelor 60 MG Oral Tablet",
            "ticagrelor 60 mg oral tablet",
            "ticagrelor 90 MG Oral Tablet",
            "ticagrelor 90 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "90 mg",
                "pct": "66%"
            },
            {
                "value": "60 mg",
                "pct": "34%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "69%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "NexIUM",
        "route": "Injectable",
        "fullName": "NexIUM (Injectable)",
        "totalCount": 32,
        "searchTerms": [
            "NEXIUM",
            "NexIUM",
            "NexIUM (Injectable)",
            "esomeprazole 40 MG Injection",
            "esomeprazole 40 mg injection",
            "nexium",
            "nexium (injectable)"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Tadalafil",
        "route": "Oral Pill",
        "fullName": "Tadalafil (Oral Pill)",
        "totalCount": 31,
        "searchTerms": [
            "Cialis",
            "Pulmonary Hypertension tadalafil 20 MG Oral Tablet",
            "Tadalafil",
            "Tadalafil (Oral Pill)",
            "Tadalafil (Oral)",
            "cialis",
            "pulmonary hypertension tadalafil 20 mg oral tablet",
            "tadalafil",
            "tadalafil (oral pill)",
            "tadalafil (oral)",
            "tadalafil 10 MG Oral Tablet",
            "tadalafil 10 mg oral tablet",
            "tadalafil 5 MG Oral Tablet",
            "tadalafil 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "45%"
            },
            {
                "value": "20 mg",
                "pct": "39%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "55%"
            },
            {
                "value": "As needed",
                "pct": "23%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N52.9",
                "description": "Male erectile dysfunction, unspecified",
                "pct": "35%"
            }
        ]
    },
    {
        "name": "Omega-3 carboxylic acids",
        "route": "Oral Pill",
        "fullName": "Omega-3 carboxylic acids (Oral Pill)",
        "totalCount": 31,
        "searchTerms": [
            "Omega-3 carboxylic acids",
            "Omega-3 carboxylic acids (Oral Pill)",
            "omega-3 carboxylic acids",
            "omega-3 carboxylic acids (oral pill)",
            "omega-3 carboxylic acids 1000 MG Oral Capsule",
            "omega-3 carboxylic acids 1000 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "1 g",
                "pct": "87%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "52%"
            },
            {
                "value": "Twice daily",
                "pct": "39%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Nicotine",
        "route": "Transdermal",
        "fullName": "Nicotine (Transdermal)",
        "totalCount": 31,
        "searchTerms": [
            "24 HR nicotine 0.292 MG/HR Transdermal System",
            "24 HR nicotine 0.583 MG/HR Transdermal System",
            "24 HR nicotine 0.875 MG/HR Transdermal System",
            "24 hr nicotine 0.292 mg/hr transdermal system",
            "24 hr nicotine 0.583 mg/hr transdermal system",
            "24 hr nicotine 0.875 mg/hr transdermal system",
            "Nicotine",
            "Nicotine (Transdermal)",
            "nicotine",
            "nicotine (transdermal)"
        ],
        "dosages": [
            {
                "value": "21 mg",
                "pct": "39%"
            },
            {
                "value": "14 mg",
                "pct": "23%"
            },
            {
                "value": "7 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EFFEXOR XR",
        "route": "Oral Pill",
        "fullName": "EFFEXOR XR (Oral Pill)",
        "totalCount": 31,
        "searchTerms": [
            "24 HR venlafaxine 150 MG Extended Release Oral Capsule",
            "24 HR venlafaxine 37.5 MG Extended Release Oral Capsule",
            "24 HR venlafaxine 75 MG Extended Release Oral Capsule",
            "24 hr venlafaxine 150 mg extended release oral capsule",
            "24 hr venlafaxine 37.5 mg extended release oral capsule",
            "24 hr venlafaxine 75 mg extended release oral capsule",
            "EFFEXOR",
            "EFFEXOR XR",
            "EFFEXOR XR (Oral Pill)",
            "effexor",
            "effexor xr",
            "effexor xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "45%"
            },
            {
                "value": "75 mg",
                "pct": "39%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "65%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROLIA",
        "route": "Injectable",
        "fullName": "PROLIA (Injectable)",
        "totalCount": 31,
        "searchTerms": [
            "1 ML denosumab 60 MG/ML Prefilled Syringe",
            "1 ml denosumab 60 mg/ml prefilled syringe",
            "PROLIA",
            "PROLIA (Injectable)",
            "prolia",
            "prolia (injectable)"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "97%"
            }
        ],
        "frequencies": [
            {
                "value": "Once every 6 months",
                "pct": "19%"
            },
            {
                "value": "Every 6 months",
                "pct": "16%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "77%"
            }
        ]
    },
    {
        "name": "Hydrocortisone",
        "route": "Oral Pill",
        "fullName": "Hydrocortisone (Oral Pill)",
        "totalCount": 31,
        "searchTerms": [
            "Cortef",
            "Hydrocortisone",
            "Hydrocortisone (Oral Pill)",
            "Hydrocortisone (Oral)",
            "cortef",
            "hydrocortisone",
            "hydrocortisone (Oral)",
            "hydrocortisone (oral pill)",
            "hydrocortisone (oral)",
            "hydrocortisone 10 MG Oral Tablet",
            "hydrocortisone 10 mg oral tablet",
            "hydrocortisone 20 MG Oral Tablet",
            "hydrocortisone 20 mg oral tablet",
            "hydrocortisone 5 MG Oral Tablet",
            "hydrocortisone 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "55%"
            },
            {
                "value": "10 mg",
                "pct": "26%"
            },
            {
                "value": "20 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "52%"
            },
            {
                "value": "Twice daily",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E27.40",
                "description": "Unspecified adrenocortical insufficiency",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "Ipratropium",
        "route": "Inhalant",
        "fullName": "Ipratropium (Inhalant)",
        "totalCount": 31,
        "searchTerms": [
            "200 ACTUAT ipratropium bromide 0.017 MG/ACTUAT Metered Dose Inhaler",
            "200 actuat ipratropium bromide 0.017 mg/actuat metered dose inhaler",
            "IPRATROPIUM",
            "Ipratropium",
            "Ipratropium (Inhalant)",
            "ipratropium",
            "ipratropium (inhalant)",
            "ipratropium bromide 0.2 MG/ML Inhalation Solution",
            "ipratropium bromide 0.2 mg/ml inhalation solution"
        ],
        "dosages": [
            {
                "value": "0.2 mg",
                "pct": "45%"
            },
            {
                "value": "17 mcg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "29%"
            },
            {
                "value": "Four times daily",
                "pct": "16%"
            },
            {
                "value": "Three times daily",
                "pct": "16%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "37%"
            },
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "32%"
            }
        ]
    },
    {
        "name": "VESICARE",
        "route": "Oral Pill",
        "fullName": "VESICARE (Oral Pill)",
        "totalCount": 31,
        "searchTerms": [
            "VESICARE",
            "VESICARE (Oral Pill)",
            "solifenacin succinate 10 MG Oral Tablet",
            "solifenacin succinate 10 mg oral tablet",
            "solifenacin succinate 5 MG Oral Tablet",
            "solifenacin succinate 5 mg oral tablet",
            "vesicare",
            "vesicare (oral pill)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "52%"
            },
            {
                "value": "10 mg",
                "pct": "48%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "97%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VRAYLAR",
        "route": "Oral Pill",
        "fullName": "VRAYLAR (Oral Pill)",
        "totalCount": 31,
        "searchTerms": [
            "VRAYLAR",
            "VRAYLAR (Oral Pill)",
            "cariprazine 1.5 MG Oral Capsule",
            "cariprazine 1.5 mg oral capsule",
            "cariprazine 3 MG Oral Capsule",
            "cariprazine 3 mg oral capsule",
            "cariprazine 6 MG Oral Capsule",
            "cariprazine 6 mg oral capsule",
            "vraylar",
            "vraylar (oral pill)"
        ],
        "dosages": [
            {
                "value": "3 mg",
                "pct": "42%"
            },
            {
                "value": "1.5 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "97%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ferosul",
        "route": "Oral Pill",
        "fullName": "Ferosul (Oral Pill)",
        "totalCount": 31,
        "searchTerms": ["FEROSUL", "Ferosul", "Ferosul (Oral)", "ferosul", "ferosul (oral)"],
        "dosages": [
            {
                "value": "325 mg",
                "pct": "97%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "52%"
            },
            {
                "value": "Twice daily",
                "pct": "23%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Trelegy Ellipta",
        "route": "Inhaler",
        "fullName": "Trelegy Ellipta (Inhaler)",
        "totalCount": 31,
        "searchTerms": [
            "TRELEGY ELLIPTA",
            "TRELEGY ELLIPTA (Inhaler)",
            "Trelegy Ellipta",
            "Trelegy Ellipta (Inhaler)",
            "trelegy ellipta",
            "trelegy ellipta (inhaler)"
        ],
        "dosages": [
            {
                "value": "100 mcg",
                "pct": "52%"
            },
            {
                "value": "200 mcg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [
            {
                "value": "For oral inhalation only",
                "pct": "40%"
            }
        ],
        "diagnoses": [
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "DICLOFENAC SODIUM",
        "route": "Topical",
        "fullName": "DICLOFENAC SODIUM (Topical)",
        "totalCount": 31,
        "searchTerms": [
            "DICLOFENAC SODIUM",
            "Diclofenac Sodium",
            "Diclofenac Sodium (Topical)",
            "Voltaren Arthritis",
            "Voltaren Gel",
            "diclofenac sodium",
            "diclofenac sodium (topical)",
            "voltaren arthritis",
            "voltaren gel"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "35%"
            },
            {
                "value": "As needed",
                "pct": "23%"
            }
        ],
        "adminNotes": [
            {
                "value": "NSAID",
                "pct": "39%"
            },
            {
                "value": "For external use only",
                "pct": "22%"
            }
        ],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "96%"
            }
        ]
    },
    {
        "name": "Metoprolol Succ ER",
        "route": "Oral Pill",
        "fullName": "Metoprolol Succ ER (Oral Pill)",
        "totalCount": 31,
        "searchTerms": [
            "METOPROLOL SUCC ER",
            "METOPROLOL SUCC ER (Oral)",
            "Metoprolol Succ ER",
            "Metoprolol Succ ER (Oral)",
            "Toprol XL",
            "metoprolol succ er",
            "metoprolol succ er (oral)",
            "toprol xl"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "58%"
            },
            {
                "value": "100 mg",
                "pct": "23%"
            },
            {
                "value": "50 mg",
                "pct": "16%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "97%"
            }
        ],
        "adminNotes": [
            {
                "value": "Extended release",
                "pct": "39%"
            },
            {
                "value": "Do not crush or chew",
                "pct": "16%"
            }
        ],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "94%"
            }
        ]
    },
    {
        "name": "Ketoconazole",
        "route": "Shampoo",
        "fullName": "Ketoconazole (Shampoo)",
        "totalCount": 30,
        "searchTerms": [
            "Ketoconazole",
            "Ketoconazole (Shampoo)",
            "ketoconazole",
            "ketoconazole (shampoo)",
            "ketoconazole 10 MG/ML Medicated Shampoo",
            "ketoconazole 10 mg/ml medicated shampoo",
            "ketoconazole 20 MG/ML Medicated Shampoo",
            "ketoconazole 20 mg/ml medicated shampoo"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CLARITIN-D XR",
        "route": "Oral Pill",
        "fullName": "CLARITIN-D XR (Oral Pill)",
        "totalCount": 30,
        "searchTerms": [
            "12 HR loratadine 5 MG / pseudoephedrine sulfate 120 MG Extended Release Oral Tablet",
            "12 hr loratadine 5 mg / pseudoephedrine sulfate 120 mg extended release oral tablet",
            "24 HR loratadine 10 MG / pseudoephedrine sulfate 240 MG Extended Release Oral Tablet",
            "24 hr loratadine 10 mg / pseudoephedrine sulfate 240 mg extended release oral tablet",
            "CLARITIN-D",
            "CLARITIN-D XR",
            "CLARITIN-D XR (Oral Pill)",
            "claritin-d",
            "claritin-d xr",
            "claritin-d xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10-240 mg",
                "pct": "50%"
            },
            {
                "value": "10 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EPIPEN",
        "route": "Injectable",
        "fullName": "EPIPEN (Injectable)",
        "totalCount": 30,
        "searchTerms": [
            "EPIPEN",
            "EPIPEN (Injectable)",
            "NDA019430 0.3 ML epinephrine 0.5 MG/ML Auto-Injector",
            "NDA019430 0.3 ML epinephrine 1 MG/ML Auto-Injector",
            "epipen",
            "epipen (injectable)",
            "nda019430 0.3 ml epinephrine 0.5 mg/ml auto-injector",
            "nda019430 0.3 ml epinephrine 1 mg/ml auto-injector"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "40%"
            },
            {
                "value": "0.3 mg",
                "pct": "27%"
            },
            {
                "value": "1 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium carbonate",
        "route": "Oral Pill",
        "fullName": "Calcium carbonate (Oral Pill)",
        "totalCount": 30,
        "searchTerms": [
            "CALCIUM CARBONATE",
            "Calcium carbonate",
            "Calcium carbonate (Oral Pill)",
            "calcium carbonate",
            "calcium carbonate (oral pill)",
            "calcium carbonate 1625 MG Oral Tablet",
            "calcium carbonate 1625 mg oral tablet",
            "calcium carbonate 500 MG Oral Tablet",
            "calcium carbonate 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "648 mg",
                "pct": "33%"
            },
            {
                "value": "250 mg",
                "pct": "27%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "57%"
            },
            {
                "value": "Twice daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "24%"
            }
        ]
    },
    {
        "name": "acetaZOLAMIDE",
        "route": "Oral Pill",
        "fullName": "acetaZOLAMIDE (Oral Pill)",
        "totalCount": 30,
        "searchTerms": [
            "Acetazolamide",
            "Acetazolamide (Oral)",
            "acetaZOLAMIDE",
            "acetaZOLAMIDE (Oral Pill)",
            "acetazolamide",
            "acetazolamide (oral pill)",
            "acetazolamide (oral)",
            "acetazolamide 125 MG Oral Tablet",
            "acetazolamide 125 mg oral tablet",
            "acetazolamide 250 MG Oral Tablet",
            "acetazolamide 250 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "250 mg",
                "pct": "87%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "47%"
            },
            {
                "value": "Twice daily",
                "pct": "37%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TYLENOL EXTRA STRENGTH",
        "route": "Oral Pill",
        "fullName": "TYLENOL EXTRA STRENGTH (Oral Pill)",
        "totalCount": 30,
        "searchTerms": [
            "TYLENOL EXTRA STRENGTH",
            "Tylenol Extra Strength",
            "Tylenol Extra Strength (Oral)",
            "tylenol  extra strength",
            "tylenol extra strength",
            "tylenol extra strength (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "97%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "77%"
            }
        ],
        "adminNotes": [
            {
                "value": "Pain reliever/fever reducer",
                "pct": "65%"
            },
            {
                "value": "Acetaminophen",
                "pct": "50%"
            },
            {
                "value": "Do not use with other medicines containing acetaminophen",
                "pct": "23%"
            },
            {
                "value": "Rapid release gels",
                "pct": "19%"
            }
        ],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "96%"
            },
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "23%"
            }
        ]
    },
    {
        "name": "VITAMIN D2",
        "route": "Oral Pill",
        "fullName": "VITAMIN D2 (Oral Pill)",
        "totalCount": 30,
        "searchTerms": [
            "Drisdol",
            "VITAMIN D2",
            "Vitamin D2",
            "Vitamin D2 (Oral)",
            "drisdol",
            "vitamin d2",
            "vitamin d2 (oral)"
        ],
        "dosages": [
            {
                "value": "1.25 mg",
                "pct": "53%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "50%"
            },
            {
                "value": "Once daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "CLOPIDOGREL BISULFATE",
        "route": "Oral Pill",
        "fullName": "CLOPIDOGREL BISULFATE (Oral Pill)",
        "totalCount": 30,
        "searchTerms": [
            "CLOPIDOGREL BISULFATE",
            "CLOPIDOGREL BISULFATE (Oral)",
            "Clopidogrel Bisulfate",
            "Clopidogrel Bisulfate (Oral)",
            "PLAVIX",
            "Plavix",
            "Plavix 75",
            "clopidogrel bisulfate",
            "clopidogrel bisulfate (oral)",
            "plavix",
            "plavix 75"
        ],
        "dosages": [
            {
                "value": "75 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "81%"
            },
            {
                "code": "Z86.73",
                "description": "Prsnl hx of TIA (TIA, 10), and cereb infrc w/o resid deficits",
                "pct": "19%"
            }
        ]
    },
    {
        "name": "OCUVITE",
        "route": "Oral Pill",
        "fullName": "OCUVITE (Oral Pill)",
        "totalCount": 30,
        "searchTerms": [
            "OCUVITE",
            "OCUVITE (Oral Pill)",
            "ascorbic acid 200 MG / beta carotene 1000 UNT / cuprous oxide 2 MG / dl-alpha tocopheryl acetate 60 UNT / lutein 2 MG / sodium selenate 0.055 MG / zinc oxide 40 MG Oral Tablet",
            "ascorbic acid 200 mg / beta carotene 1000 unt / cuprous oxide 2 mg / dl-alpha tocopheryl acetate 60 unt / lutein 2 mg / sodium selenate 0.055 mg / zinc oxide 40 mg oral tablet",
            "ocuvite",
            "ocuvite (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            },
            {
                "value": "Twice daily",
                "pct": "20%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Pantoprazole",
        "route": "Oral Granules",
        "fullName": "Pantoprazole (Oral Granules)",
        "totalCount": 29,
        "searchTerms": [
            "Pantoprazole",
            "Pantoprazole (Oral Granules)",
            "pantoprazole",
            "pantoprazole (oral granules)",
            "pantoprazole 40 MG Oral Granules",
            "pantoprazole 40 mg oral granules"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "90%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "guanFACINE",
        "route": "Oral Pill",
        "fullName": "guanFACINE (Oral Pill)",
        "totalCount": 29,
        "searchTerms": [
            "Guanfacine",
            "Guanfacine (Oral)",
            "TENEX",
            "guanFACINE",
            "guanFACINE (Oral Pill)",
            "guanFACINE (Oral)",
            "guanfacine",
            "guanfacine (oral pill)",
            "guanfacine (oral)",
            "guanfacine 1 MG Oral Tablet",
            "guanfacine 1 mg oral tablet",
            "guanfacine 2 MG Oral Tablet",
            "guanfacine 2 mg oral tablet",
            "tenex"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "72%"
            },
            {
                "value": "2 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "59%"
            },
            {
                "value": "Twice daily",
                "pct": "28%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F90.9",
                "description": "Attention-deficit hyperactivity disorder, unspecified type",
                "pct": "41%"
            }
        ]
    },
    {
        "name": "Levalbuterol",
        "route": "Inhalant",
        "fullName": "Levalbuterol (Inhalant)",
        "totalCount": 29,
        "searchTerms": [
            "200 ACTUAT levalbuterol 0.045 MG/ACTUAT Metered Dose Inhaler",
            "200 actuat levalbuterol 0.045 mg/actuat metered dose inhaler",
            "Levalbuterol",
            "Levalbuterol (Inhalant)",
            "levalbuterol",
            "levalbuterol (inhalant)",
            "levalbuterol 0.21 MG/ML Inhalation Solution",
            "levalbuterol 0.21 mg/ml inhalation solution",
            "levalbuterol 0.417 MG/ML Inhalation Solution",
            "levalbuterol 0.417 mg/ml inhalation solution",
            "levalbuterol 2.5 MG/ML Inhalation Solution",
            "levalbuterol 2.5 mg/ml inhalation solution"
        ],
        "dosages": [
            {
                "value": "2.5 mg",
                "pct": "59%"
            },
            {
                "value": "45 mcg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "41%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lurasidone",
        "route": "Oral Pill",
        "fullName": "Lurasidone (Oral Pill)",
        "totalCount": 29,
        "searchTerms": [
            "Lurasidone",
            "Lurasidone (Oral Pill)",
            "lurasidone",
            "lurasidone (oral pill)",
            "lurasidone hydrochloride 120 MG Oral Tablet",
            "lurasidone hydrochloride 120 mg oral tablet",
            "lurasidone hydrochloride 20 MG Oral Tablet",
            "lurasidone hydrochloride 20 mg oral tablet",
            "lurasidone hydrochloride 40 MG Oral Tablet",
            "lurasidone hydrochloride 40 mg oral tablet",
            "lurasidone hydrochloride 60 MG Oral Tablet",
            "lurasidone hydrochloride 60 mg oral tablet",
            "lurasidone hydrochloride 80 MG Oral Tablet",
            "lurasidone hydrochloride 80 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "48%"
            },
            {
                "value": "80 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F31.9",
                "description": "Bipolar disorder, unspecified",
                "pct": "37%"
            },
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "26%"
            }
        ]
    },
    {
        "name": "Nebivolol",
        "route": "Oral Pill",
        "fullName": "Nebivolol (Oral Pill)",
        "totalCount": 29,
        "searchTerms": [
            "Bystolic",
            "NEBIVOLOL",
            "Nebivolol",
            "Nebivolol (Oral Pill)",
            "Nebivolol (Oral)",
            "bystolic",
            "nebivolol",
            "nebivolol (oral pill)",
            "nebivolol (oral)",
            "nebivolol 10 MG Oral Tablet",
            "nebivolol 10 mg oral tablet",
            "nebivolol 5 MG Oral Tablet",
            "nebivolol 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "41%"
            },
            {
                "value": "10 mg",
                "pct": "34%"
            },
            {
                "value": "20 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "91%"
            }
        ]
    },
    {
        "name": "Perphenazine",
        "route": "Oral Pill",
        "fullName": "Perphenazine (Oral Pill)",
        "totalCount": 29,
        "searchTerms": [
            "PERPHENAZINE",
            "PERPHENAZINE (Oral)",
            "Perphenazine",
            "Perphenazine (Oral Pill)",
            "Perphenazine (Oral)",
            "Trilafon",
            "perphenazine",
            "perphenazine (oral pill)",
            "perphenazine (oral)",
            "perphenazine 16 MG Oral Tablet",
            "perphenazine 16 mg oral tablet",
            "perphenazine 2 MG Oral Tablet",
            "perphenazine 2 mg oral tablet",
            "perphenazine 4 MG Oral Tablet",
            "perphenazine 4 mg oral tablet",
            "perphenazine 8 MG Oral Tablet",
            "perphenazine 8 mg oral tablet",
            "trilafon"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "38%"
            },
            {
                "value": "8 mg",
                "pct": "34%"
            },
            {
                "value": "2 mg",
                "pct": "17%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "34%"
            },
            {
                "value": "Twice daily",
                "pct": "21%"
            },
            {
                "value": "At bedtime",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F20.9",
                "description": "Schizophrenia, unspecified",
                "pct": "69%"
            }
        ]
    },
    {
        "name": "Metformin Hydrochloride",
        "route": "Oral Pill",
        "fullName": "Metformin Hydrochloride (Oral Pill)",
        "totalCount": 29,
        "searchTerms": [
            "GLUCOPHAGE",
            "GLUCOPHAGE TAB",
            "Glucophage",
            "Glucophage XR",
            "Metformin Hydrochloride",
            "Metformin Hydrochloride (Oral)",
            "glucophage",
            "glucophage tab",
            "glucophage xr",
            "metFORMIN HYDROCHLORIDE",
            "metFORMIN HYDROCHLORIDE (Oral)",
            "metformin hydrochloride",
            "metformin hydrochloride (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "52%"
            },
            {
                "value": "1000 mg",
                "pct": "34%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "69%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [
            {
                "value": "Take with food",
                "pct": "21%"
            },
            {
                "value": "Take with meals",
                "pct": "17%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "97%"
            }
        ]
    },
    {
        "name": "PAZEO",
        "route": "Ophthalmic",
        "fullName": "PAZEO (Ophthalmic)",
        "totalCount": 29,
        "searchTerms": [
            "PAZEO",
            "PAZEO (Ophthalmic)",
            "olopatadine 7 MG/ML Ophthalmic Solution",
            "olopatadine 7 mg/ml ophthalmic solution",
            "pazeo",
            "pazeo (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Aspirin low dose",
        "route": "Oral Pill",
        "fullName": "Aspirin low dose (Oral Pill)",
        "totalCount": 28,
        "searchTerms": [
            "ASPIRIN LOW DOSE",
            "ASPIRIN LOW DOSE (Oral)",
            "Aspir-Low",
            "Aspirin Low Dose",
            "Aspirin Low Dose (Oral)",
            "Aspirin low dose",
            "aspir-low",
            "aspirin",
            "aspirin low dose",
            "aspirin low dose (oral)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "TYLENOL PM",
        "route": "Oral Liquid",
        "fullName": "TYLENOL PM (Oral Liquid)",
        "totalCount": 28,
        "searchTerms": [
            "TYLENOL PM",
            "TYLENOL PM (Oral Liquid)",
            "acetaminophen 33.3 MG/ML / diphenhydramine hydrochloride 1.67 MG/ML Oral Solution",
            "acetaminophen 33.3 mg/ml / diphenhydramine hydrochloride 1.67 mg/ml oral solution",
            "tylenol pm",
            "tylenol pm (oral liquid)"
        ],
        "dosages": [
            {
                "value": "500-25 mg",
                "pct": "46%"
            },
            {
                "value": "500 mg",
                "pct": "39%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VICTOZA",
        "route": "Injectable",
        "fullName": "VICTOZA (Injectable)",
        "totalCount": 28,
        "searchTerms": [
            "3 ML liraglutide 6 MG/ML Pen Injector",
            "3 ml liraglutide 6 mg/ml pen injector",
            "VICTOZA",
            "VICTOZA (Injectable)",
            "victoza",
            "victoza (injectable)"
        ],
        "dosages": [
            {
                "value": "6 mg",
                "pct": "54%"
            },
            {
                "value": "1.8 mg",
                "pct": "21%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "61%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ezetimibe/Simvastatin",
        "route": "Oral Pill",
        "fullName": "Ezetimibe/Simvastatin (Oral Pill)",
        "totalCount": 28,
        "searchTerms": [
            "Ezetimibe/Simvastatin",
            "Ezetimibe/Simvastatin (Oral Pill)",
            "ezetimibe 10 MG / simvastatin 10 MG Oral Tablet",
            "ezetimibe 10 MG / simvastatin 20 MG Oral Tablet",
            "ezetimibe 10 MG / simvastatin 80 MG Oral Tablet",
            "ezetimibe 10 mg / simvastatin 10 mg oral tablet",
            "ezetimibe 10 mg / simvastatin 20 mg oral tablet",
            "ezetimibe 10 mg / simvastatin 80 mg oral tablet",
            "ezetimibe/simvastatin",
            "ezetimibe/simvastatin (oral pill)"
        ],
        "dosages": [
            {
                "value": "10-10 mg",
                "pct": "64%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "61%"
            }
        ]
    },
    {
        "name": "BUSPAR",
        "route": "Oral Pill",
        "fullName": "BUSPAR (Oral Pill)",
        "totalCount": 28,
        "searchTerms": [
            "BUSPAR",
            "BUSPAR (Oral Pill)",
            "buspar",
            "buspar (oral pill)",
            "buspirone hydrochloride 10 MG Oral Tablet",
            "buspirone hydrochloride 10 mg oral tablet",
            "buspirone hydrochloride 15 MG Oral Tablet",
            "buspirone hydrochloride 15 mg oral tablet",
            "buspirone hydrochloride 5 MG Oral Tablet",
            "buspirone hydrochloride 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "29%"
            },
            {
                "value": "5 mg",
                "pct": "29%"
            },
            {
                "value": "10 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "54%"
            },
            {
                "value": "Once daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DULERA",
        "route": "Inhalant",
        "fullName": "DULERA (Inhalant)",
        "totalCount": 28,
        "searchTerms": [
            "120 ACTUAT formoterol fumarate 0.005 MG/ACTUAT / mometasone furoate 0.05 MG/ACTUAT Metered Dose Inhaler",
            "120 ACTUAT formoterol fumarate 0.005 MG/ACTUAT / mometasone furoate 0.1 MG/ACTUAT Metered Dose Inhaler",
            "120 ACTUAT formoterol fumarate 0.005 MG/ACTUAT / mometasone furoate 0.2 MG/ACTUAT Metered Dose Inhaler",
            "120 actuat formoterol fumarate 0.005 mg/actuat / mometasone furoate 0.05 mg/actuat metered dose inhaler",
            "120 actuat formoterol fumarate 0.005 mg/actuat / mometasone furoate 0.1 mg/actuat metered dose inhaler",
            "120 actuat formoterol fumarate 0.005 mg/actuat / mometasone furoate 0.2 mg/actuat metered dose inhaler",
            "60 ACTUAT formoterol fumarate 0.005 MG/ACTUAT / mometasone furoate 0.1 MG/ACTUAT Metered Dose Inhaler",
            "60 ACTUAT formoterol fumarate 0.005 MG/ACTUAT / mometasone furoate 0.2 MG/ACTUAT Metered Dose Inhaler",
            "60 actuat formoterol fumarate 0.005 mg/actuat / mometasone furoate 0.1 mg/actuat metered dose inhaler",
            "60 actuat formoterol fumarate 0.005 mg/actuat / mometasone furoate 0.2 mg/actuat metered dose inhaler",
            "DULERA",
            "DULERA (Inhalant)",
            "dulera",
            "dulera (inhalant)"
        ],
        "dosages": [
            {
                "value": "5-100 mcg",
                "pct": "61%"
            },
            {
                "value": "5-200 mcg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "54%"
            },
            {
                "value": "Once daily",
                "pct": "21%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ramelteon",
        "route": "Oral Pill",
        "fullName": "Ramelteon (Oral Pill)",
        "totalCount": 28,
        "searchTerms": [
            "Ramelteon",
            "Ramelteon (Oral Pill)",
            "Ramelteon (Oral)",
            "Rozerem",
            "ramelteon",
            "ramelteon (oral pill)",
            "ramelteon (oral)",
            "ramelteon 8 MG Oral Tablet",
            "ramelteon 8 mg oral tablet",
            "rozerem"
        ],
        "dosages": [
            {
                "value": "8 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "57%"
            },
            {
                "value": "Once daily",
                "pct": "39%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "73%"
            }
        ]
    },
    {
        "name": "NITROSTAT",
        "route": "Sublingual",
        "fullName": "NITROSTAT (Sublingual)",
        "totalCount": 28,
        "searchTerms": [
            "NITROSTAT",
            "NITROSTAT (Sublingual)",
            "nitroglycerin 0.3 MG Sublingual Tablet",
            "nitroglycerin 0.3 mg sublingual tablet",
            "nitroglycerin 0.4 MG Sublingual Tablet",
            "nitroglycerin 0.4 mg sublingual tablet",
            "nitrostat",
            "nitrostat (sublingual)"
        ],
        "dosages": [
            {
                "value": "0.4 mg",
                "pct": "93%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "46%"
            },
            {
                "value": "As needed",
                "pct": "39%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Amantadine XR",
        "route": "Oral Pill",
        "fullName": "Amantadine XR (Oral Pill)",
        "totalCount": 28,
        "searchTerms": [
            "24 HR amantadine 129 MG Extended Release Oral Tablet",
            "24 HR amantadine 137 MG Extended Release Oral Capsule",
            "24 HR amantadine 258 MG Extended Release Oral Tablet",
            "24 HR amantadine 68.5 MG Extended Release Oral Capsule",
            "24 hr amantadine 129 mg extended release oral tablet",
            "24 hr amantadine 137 mg extended release oral capsule",
            "24 hr amantadine 258 mg extended release oral tablet",
            "24 hr amantadine 68.5 mg extended release oral capsule",
            "Amantadine XR",
            "Amantadine XR (Oral Pill)",
            "amantadine xr",
            "amantadine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "32%"
            },
            {
                "value": "Once daily",
                "pct": "32%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Hydrochlorothiazide/Triamterene",
        "route": "Oral Pill",
        "fullName": "Hydrochlorothiazide/Triamterene (Oral Pill)",
        "totalCount": 28,
        "searchTerms": [
            "Hydrochlorothiazide/Triamterene",
            "Hydrochlorothiazide/Triamterene (Oral Pill)",
            "hydroCHLOROthiazide/Triamterene",
            "hydroCHLOROthiazide/Triamterene (Oral Pill)",
            "hydrochlorothiazide 25 MG / triamterene 37.5 MG Oral Capsule",
            "hydrochlorothiazide 25 MG / triamterene 37.5 MG Oral Tablet",
            "hydrochlorothiazide 25 MG / triamterene 50 MG Oral Capsule",
            "hydrochlorothiazide 25 mg / triamterene 37.5 mg oral capsule",
            "hydrochlorothiazide 25 mg / triamterene 37.5 mg oral tablet",
            "hydrochlorothiazide 25 mg / triamterene 50 mg oral capsule",
            "hydrochlorothiazide 50 MG / triamterene 75 MG Oral Tablet",
            "hydrochlorothiazide 50 mg / triamterene 75 mg oral tablet",
            "hydrochlorothiazide/triamterene",
            "hydrochlorothiazide/triamterene (oral pill)"
        ],
        "dosages": [
            {
                "value": "25-37.5 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "80%"
            }
        ]
    },
    {
        "name": "Albuterol Sulfate Inhalation Solution",
        "route": "Inhaler",
        "fullName": "Albuterol Sulfate Inhalation Solution (Inhaler)",
        "totalCount": 28,
        "searchTerms": [
            "Albuterol Sulfate Inhalation Solution",
            "Albuterol Sulfate Inhalation Solution (Inhaler)",
            "Proventil",
            "Proventil Neb",
            "albuterol sulfate inhalation solution",
            "albuterol sulfate inhalation solution (inhaler)",
            "proventil",
            "proventil neb"
        ],
        "dosages": [
            {
                "value": "2.5 mg",
                "pct": "43%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "89%"
            }
        ],
        "adminNotes": [
            {
                "value": "For inhalation only",
                "pct": "25%"
            },
            {
                "value": "Sterile unit-dose vials",
                "pct": "21%"
            },
            {
                "value": "For oral inhalation only",
                "pct": "21%"
            },
            {
                "value": "For Inhalation Only",
                "pct": "21%"
            },
            {
                "value": "Not for injection",
                "pct": "18%"
            }
        ],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "86%"
            },
            {
                "code": "R06.02",
                "description": "Shortness of breath",
                "pct": "21%"
            },
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "21%"
            }
        ]
    },
    {
        "name": "Trazodone HCl",
        "route": "Oral Pill",
        "fullName": "Trazodone HCl (Oral Pill)",
        "totalCount": 28,
        "searchTerms": [
            "DESYREL",
            "Desyrel",
            "TRAZODONE HCL",
            "TRAZODONE HCL (Oral)",
            "Trazodone HCL",
            "Trazodone HCL (Oral)",
            "Trazodone HCl",
            "Trazodone HCl (Oral)",
            "desyrel",
            "traZODone HCl",
            "traZODone HCl (Oral)",
            "trazodone hcl",
            "trazodone hcl (oral)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "50%"
            },
            {
                "value": "100 mg",
                "pct": "39%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            },
            {
                "value": "At bedtime",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "96%"
            },
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "25%"
            }
        ]
    },
    {
        "name": "Esomeprazole",
        "route": "Injectable",
        "fullName": "Esomeprazole (Injectable)",
        "totalCount": 28,
        "searchTerms": [
            "Esomeprazole",
            "Esomeprazole (Injectable)",
            "esomeprazole",
            "esomeprazole (injectable)",
            "esomeprazole 20 MG Injection",
            "esomeprazole 20 mg injection",
            "esomeprazole 40 MG Injection",
            "esomeprazole 40 mg injection"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "82%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "traZODone XR",
        "route": "Oral Pill",
        "fullName": "traZODone XR (Oral Pill)",
        "totalCount": 27,
        "searchTerms": [
            "24 HR trazodone hydrochloride 150 MG Extended Release Oral Tablet",
            "24 HR trazodone hydrochloride 300 MG Extended Release Oral Tablet",
            "24 hr trazodone hydrochloride 150 mg extended release oral tablet",
            "24 hr trazodone hydrochloride 300 mg extended release oral tablet",
            "traZODone XR",
            "traZODone XR (Oral Pill)",
            "trazodone xr",
            "trazodone xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "41%"
            },
            {
                "value": "300 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "56%"
            },
            {
                "value": "Once daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Acyclovir",
        "route": "Oral Pill",
        "fullName": "Acyclovir (Oral Pill)",
        "totalCount": 27,
        "searchTerms": [
            "Acyclovir",
            "Acyclovir (Oral Pill)",
            "Acyclovir (Oral)",
            "acyclovir",
            "acyclovir (oral pill)",
            "acyclovir (oral)",
            "acyclovir 200 MG Oral Capsule",
            "acyclovir 200 mg oral capsule",
            "acyclovir 400 MG Oral Tablet",
            "acyclovir 400 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "81%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "41%"
            },
            {
                "value": "Once daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B00.9",
                "description": "Herpesviral infection, unspecified",
                "pct": "47%"
            }
        ]
    },
    {
        "name": "Ondansetron",
        "route": "Oral Disintegrating",
        "fullName": "Ondansetron (Oral Disintegrating)",
        "totalCount": 27,
        "searchTerms": [
            "Ondansetron",
            "Ondansetron (Oral Disintegrating)",
            "ondansetron",
            "ondansetron (oral disintegrating)",
            "ondansetron 4 MG Disintegrating Oral Tablet",
            "ondansetron 4 mg disintegrating oral tablet",
            "ondansetron 8 MG Disintegrating Oral Tablet",
            "ondansetron 8 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "81%"
            },
            {
                "value": "8 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "48%"
            },
            {
                "value": "Once daily",
                "pct": "26%"
            },
            {
                "value": "Every 8 hours",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PRADAXA",
        "route": "Oral Pill",
        "fullName": "PRADAXA (Oral Pill)",
        "totalCount": 27,
        "searchTerms": [
            "PRADAXA",
            "PRADAXA (Oral Pill)",
            "dabigatran etexilate 150 MG Oral Capsule",
            "dabigatran etexilate 150 mg oral capsule",
            "dabigatran etexilate 75 MG Oral Capsule",
            "dabigatran etexilate 75 mg oral capsule",
            "pradaxa",
            "pradaxa (oral pill)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "67%"
            },
            {
                "value": "75 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "63%"
            },
            {
                "value": "Once daily",
                "pct": "22%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Trospium",
        "route": "Oral Pill",
        "fullName": "Trospium (Oral Pill)",
        "totalCount": 27,
        "searchTerms": [
            "Trospium",
            "Trospium (Oral Pill)",
            "Trospium (Oral)",
            "trospium",
            "trospium (Oral)",
            "trospium (oral pill)",
            "trospium (oral)",
            "trospium chloride 20 MG Oral Tablet",
            "trospium chloride 20 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "48%"
            },
            {
                "value": "Once daily",
                "pct": "37%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "54%"
            }
        ]
    },
    {
        "name": "DESCOVY",
        "route": "Oral Pill",
        "fullName": "DESCOVY (Oral Pill)",
        "totalCount": 27,
        "searchTerms": [
            "DESCOVY",
            "DESCOVY (Oral Pill)",
            "Descovy",
            "Descovy (Oral)",
            "descovy",
            "descovy (oral pill)",
            "descovy (oral)",
            "emtricitabine 200 MG / tenofovir alafenamide 25 MG Oral Tablet",
            "emtricitabine 200 mg / tenofovir alafenamide 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "200-25 mg",
                "pct": "96%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "96%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B20",
                "description": "Human immunodeficiency virus [HIV] disease",
                "pct": "46%"
            }
        ]
    },
    {
        "name": "Azelastine/Fluticasone",
        "route": "Nasal",
        "fullName": "Azelastine/Fluticasone (Nasal)",
        "totalCount": 27,
        "searchTerms": [
            "Azelastine/Fluticasone",
            "Azelastine/Fluticasone (Nasal)",
            "azelastine hydrochloride 0.137 MG/ACTUAT / fluticasone propionate 0.05 MG/ACTUAT Metered Dose Nasal Spray",
            "azelastine hydrochloride 0.137 mg/actuat / fluticasone propionate 0.05 mg/actuat metered dose nasal spray",
            "azelastine/fluticasone",
            "azelastine/fluticasone (nasal)"
        ],
        "dosages": [
            {
                "value": "137-50 mcg",
                "pct": "85%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "37%"
            },
            {
                "value": "Once daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "44%"
            }
        ]
    },
    {
        "name": "Esomeprazole",
        "route": "Oral Suspension Granules",
        "fullName": "Esomeprazole (Oral Suspension Granules)",
        "totalCount": 27,
        "searchTerms": [
            "Esomeprazole",
            "Esomeprazole (Oral Suspension Granules)",
            "esomeprazole",
            "esomeprazole (oral suspension granules)",
            "esomeprazole 10 MG Granules for Oral Suspension",
            "esomeprazole 10 mg granules for oral suspension",
            "esomeprazole 2.5 MG Granules for Oral Suspension",
            "esomeprazole 2.5 mg granules for oral suspension",
            "esomeprazole 5 MG Granules for Oral Suspension",
            "esomeprazole 5 mg granules for oral suspension"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "22%"
            },
            {
                "value": "5 mg",
                "pct": "19%"
            },
            {
                "value": "20 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "63%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "INVOKANA",
        "route": "Oral Pill",
        "fullName": "INVOKANA (Oral Pill)",
        "totalCount": 27,
        "searchTerms": [
            "INVOKANA",
            "INVOKANA (Oral Pill)",
            "Invokana",
            "Invokana (Oral)",
            "canagliflozin 100 MG Oral Tablet",
            "canagliflozin 100 mg oral tablet",
            "canagliflozin 300 MG Oral Tablet",
            "canagliflozin 300 mg oral tablet",
            "invokana",
            "invokana (oral pill)",
            "invokana (oral)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "52%"
            },
            {
                "value": "300 mg",
                "pct": "48%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Diclofenac Sodium Topical Gel",
        "route": "Topical",
        "fullName": "Diclofenac Sodium Topical Gel (Topical)",
        "totalCount": 27,
        "searchTerms": [
            "DICLOFENAC SODIUM TOPICAL GEL",
            "Diclofenac Sodium Topical Gel",
            "Diclofenac Sodium Topical Gel (Topical)",
            "Voltaren 1% Gel",
            "Voltaren Gel",
            "diclofenac sodium topical gel",
            "diclofenac sodium topical gel (topical)",
            "voltaren 1% gel",
            "voltaren gel"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "37%"
            },
            {
                "value": "As needed",
                "pct": "33%"
            }
        ],
        "adminNotes": [
            {
                "value": "NSAID",
                "pct": "89%"
            },
            {
                "value": "Arthritis pain reliever",
                "pct": "70%"
            },
            {
                "value": "For external use only",
                "pct": "22%"
            }
        ],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "96%"
            }
        ]
    },
    {
        "name": "SYMBICORT",
        "route": "Inhaler",
        "fullName": "SYMBICORT (Inhaler)",
        "totalCount": 27,
        "searchTerms": ["Symbicort", "Symbicort (Inhaler)", "symbicort", "symbicort (inhaler)"],
        "dosages": [
            {
                "value": "160 mcg",
                "pct": "33%"
            },
            {
                "value": "160/4.5 mcg",
                "pct": "22%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [
            {
                "value": "120 inhalations",
                "pct": "30%"
            }
        ],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "78%"
            },
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "37%"
            }
        ]
    },
    {
        "name": "LIVALO",
        "route": "Oral Pill",
        "fullName": "LIVALO (Oral Pill)",
        "totalCount": 27,
        "searchTerms": [
            "LIVALO",
            "LIVALO (Oral Pill)",
            "Livalo",
            "Livalo (Oral)",
            "livalo",
            "livalo (oral pill)",
            "livalo (oral)",
            "pitavastatin calcium 1 MG Oral Tablet",
            "pitavastatin calcium 1 mg oral tablet",
            "pitavastatin calcium 2 MG Oral Tablet",
            "pitavastatin calcium 2 mg oral tablet",
            "pitavastatin calcium 4 MG Oral Tablet",
            "pitavastatin calcium 4 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "48%"
            },
            {
                "value": "4 mg",
                "pct": "44%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TRAZADONE",
        "route": "Oral Pill",
        "fullName": "TRAZADONE (Oral Pill)",
        "totalCount": 27,
        "searchTerms": ["TRAZADONE", "Trazadone", "trazadone"],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "41%"
            },
            {
                "value": "100 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "56%"
            },
            {
                "value": "Once daily",
                "pct": "26%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Refresh Tears 0.5% Sol",
        "route": "Oral Pill",
        "fullName": "Refresh Tears 0.5% Sol (Oral Pill)",
        "totalCount": 26,
        "searchTerms": ["Refresh Tears 0.5% Sol", "refresh tears 0.5% sol"],
        "dosages": [
            {
                "value": "1 drop",
                "pct": "73%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "46%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Donepezil",
        "route": "Oral Disintegrating",
        "fullName": "Donepezil (Oral Disintegrating)",
        "totalCount": 26,
        "searchTerms": [
            "Donepezil",
            "Donepezil (Oral Disintegrating)",
            "donepezil",
            "donepezil (oral disintegrating)",
            "donepezil hydrochloride 10 MG Disintegrating Oral Tablet",
            "donepezil hydrochloride 10 mg disintegrating oral tablet",
            "donepezil hydrochloride 5 MG Disintegrating Oral Tablet",
            "donepezil hydrochloride 5 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "62%"
            },
            {
                "value": "5 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "54%"
            },
            {
                "value": "At bedtime",
                "pct": "23%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Pregabalin XR",
        "route": "Oral Pill",
        "fullName": "Pregabalin XR (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "24 HR pregabalin 165 MG Extended Release Oral Tablet",
            "24 HR pregabalin 330 MG Extended Release Oral Tablet",
            "24 HR pregabalin 82.5 MG Extended Release Oral Tablet",
            "24 hr pregabalin 165 mg extended release oral tablet",
            "24 hr pregabalin 330 mg extended release oral tablet",
            "24 hr pregabalin 82.5 mg extended release oral tablet",
            "Pregabalin XR",
            "Pregabalin XR (Oral Pill)",
            "pregabalin xr",
            "pregabalin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "27%"
            },
            {
                "value": "100 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "42%"
            },
            {
                "value": "Once daily",
                "pct": "35%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lactulose",
        "route": "Oral Solution Powder",
        "fullName": "Lactulose (Oral Solution Powder)",
        "totalCount": 26,
        "searchTerms": [
            "Lactulose",
            "Lactulose (Oral Solution Powder)",
            "lactulose",
            "lactulose (oral solution powder)",
            "lactulose 10000 MG Powder for Oral Solution",
            "lactulose 10000 mg powder for oral solution",
            "lactulose 20000 MG Powder for Oral Solution",
            "lactulose 20000 mg powder for oral solution"
        ],
        "dosages": [
            {
                "value": "10 g",
                "pct": "50%"
            },
            {
                "value": "20 g",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "46%"
            },
            {
                "value": "Twice daily",
                "pct": "23%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Candesartan",
        "route": "Oral Pill",
        "fullName": "Candesartan (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "Candesartan",
            "Candesartan (Oral Pill)",
            "candesartan",
            "candesartan (oral pill)",
            "candesartan cilexetil 16 MG Oral Tablet",
            "candesartan cilexetil 16 mg oral tablet",
            "candesartan cilexetil 32 MG Oral Tablet",
            "candesartan cilexetil 32 mg oral tablet",
            "candesartan cilexetil 4 MG Oral Tablet",
            "candesartan cilexetil 4 mg oral tablet",
            "candesartan cilexetil 8 MG Oral Tablet",
            "candesartan cilexetil 8 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "32 mg",
                "pct": "35%"
            },
            {
                "value": "4 mg",
                "pct": "27%"
            },
            {
                "value": "8 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Simethicone",
        "route": "Oral Pill",
        "fullName": "Simethicone (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "SIMETHICONE",
            "Simethicone",
            "Simethicone (Oral Pill)",
            "Simethicone (Oral)",
            "simethicone",
            "simethicone (Oral)",
            "simethicone (oral pill)",
            "simethicone (oral)",
            "simethicone 125 MG Oral Capsule",
            "simethicone 125 MG Oral Tablet",
            "simethicone 125 mg oral capsule",
            "simethicone 125 mg oral tablet",
            "simethicone 166 MG Oral Capsule",
            "simethicone 166 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "125 mg",
                "pct": "42%"
            },
            {
                "value": "80 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Four times daily",
                "pct": "23%"
            },
            {
                "value": "At bedtime",
                "pct": "19%"
            },
            {
                "value": "As needed",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NYSTOP",
        "route": "Topical",
        "fullName": "NYSTOP (Topical)",
        "totalCount": 26,
        "searchTerms": [
            "NYSTOP",
            "NYSTOP (Topical)",
            "nystatin 100 UNT/MG Topical Powder",
            "nystatin 100 unt/mg topical powder",
            "nystop",
            "nystop (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "46%"
            },
            {
                "value": "Once daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lithium carbonate XR",
        "route": "Oral Pill",
        "fullName": "Lithium carbonate XR (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "Lithium carbonate XR",
            "Lithium carbonate XR (Oral Pill)",
            "lithium carbonate 300 MG Extended Release Oral Tablet",
            "lithium carbonate 300 mg extended release oral tablet",
            "lithium carbonate 450 MG Extended Release Oral Tablet",
            "lithium carbonate 450 mg extended release oral tablet",
            "lithium carbonate xr",
            "lithium carbonate xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "54%"
            },
            {
                "value": "450 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "54%"
            },
            {
                "value": "Twice daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LaMICtal",
        "route": "Oral Pill",
        "fullName": "LaMICtal (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "LAMICTAL",
            "LaMICtal",
            "LaMICtal (Oral Pill)",
            "lamictal",
            "lamictal (oral pill)",
            "lamotrigine 100 MG Oral Tablet",
            "lamotrigine 100 mg oral tablet",
            "lamotrigine 150 MG Oral Tablet",
            "lamotrigine 150 mg oral tablet",
            "lamotrigine 200 MG Oral Tablet",
            "lamotrigine 200 mg oral tablet",
            "lamotrigine 25 MG Oral Tablet",
            "lamotrigine 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "38%"
            },
            {
                "value": "200 mg",
                "pct": "23%"
            },
            {
                "value": "150 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "35%"
            },
            {
                "value": "Twice daily",
                "pct": "31%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ACTOS",
        "route": "Oral Pill",
        "fullName": "ACTOS (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "ACTOS",
            "ACTOS (Oral Pill)",
            "actos",
            "actos (oral pill)",
            "pioglitazone 15 MG Oral Tablet",
            "pioglitazone 15 mg oral tablet",
            "pioglitazone 30 MG Oral Tablet",
            "pioglitazone 30 mg oral tablet",
            "pioglitazone 45 MG Oral Tablet",
            "pioglitazone 45 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "46%"
            },
            {
                "value": "15 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Temazepam",
        "route": "Oral Pill",
        "fullName": "Temazepam (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "Temazepam",
            "Temazepam (Oral Pill)",
            "Temazepam (Oral)",
            "temazepam",
            "temazepam (oral pill)",
            "temazepam (oral)",
            "temazepam 15 MG Oral Capsule",
            "temazepam 15 mg oral capsule",
            "temazepam 22.5 MG Oral Capsule",
            "temazepam 22.5 mg oral capsule",
            "temazepam 30 MG Oral Capsule",
            "temazepam 30 mg oral capsule",
            "temazepam 7.5 MG Oral Capsule",
            "temazepam 7.5 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "58%"
            },
            {
                "value": "30 mg",
                "pct": "31%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "38%"
            },
            {
                "value": "At bedtime",
                "pct": "31%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TIVICAY",
        "route": "Oral Pill",
        "fullName": "TIVICAY (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "TIVICAY",
            "TIVICAY (Oral Pill)",
            "Tivicay",
            "Tivicay (Oral)",
            "dolutegravir 50 MG Oral Tablet",
            "dolutegravir 50 mg oral tablet",
            "tivicay",
            "tivicay (oral pill)",
            "tivicay (oral)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "69%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B20",
                "description": "Human immunodeficiency virus [HIV] disease",
                "pct": "60%"
            }
        ]
    },
    {
        "name": "Zonisamide",
        "route": "Oral Pill",
        "fullName": "Zonisamide (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "ZONISAMIDE",
            "Zonisamide",
            "Zonisamide (Oral Pill)",
            "Zonisamide (Oral)",
            "zonisamide",
            "zonisamide (oral pill)",
            "zonisamide (oral)",
            "zonisamide 100 MG Oral Capsule",
            "zonisamide 100 mg oral capsule",
            "zonisamide 50 MG Oral Capsule",
            "zonisamide 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "50%"
            },
            {
                "value": "25 mg",
                "pct": "19%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "38%"
            },
            {
                "value": "At bedtime",
                "pct": "19%"
            },
            {
                "value": "Once daily",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "41%"
            }
        ]
    },
    {
        "name": "Mirabegron XR",
        "route": "Oral Pill",
        "fullName": "Mirabegron XR (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "24 HR mirabegron 25 MG Extended Release Oral Tablet",
            "24 HR mirabegron 50 MG Extended Release Oral Tablet",
            "24 hr mirabegron 25 mg extended release oral tablet",
            "24 hr mirabegron 50 mg extended release oral tablet",
            "Mirabegron XR",
            "Mirabegron XR (Oral Pill)",
            "mirabegron xr",
            "mirabegron xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "54%"
            },
            {
                "value": "50 mg",
                "pct": "46%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "42%"
            },
            {
                "code": "N32.81",
                "description": "Overactive bladder",
                "pct": "32%"
            }
        ]
    },
    {
        "name": "FLEXERIL",
        "route": "Oral Pill",
        "fullName": "FLEXERIL (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "FLEXERIL",
            "FLEXERIL (Oral Pill)",
            "Flexeril",
            "Flexeril (Oral)",
            "cyclobenzaprine hydrochloride 10 MG Oral Tablet",
            "cyclobenzaprine hydrochloride 10 mg oral tablet",
            "cyclobenzaprine hydrochloride 5 MG Oral Tablet",
            "cyclobenzaprine hydrochloride 5 mg oral tablet",
            "flexeril",
            "flexeril (oral pill)",
            "flexeril (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "62%"
            },
            {
                "value": "5 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "35%"
            },
            {
                "value": "As needed",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RHOPRESSA",
        "route": "Ophthalmic",
        "fullName": "RHOPRESSA (Ophthalmic)",
        "totalCount": 26,
        "searchTerms": [
            "RHOPRESSA",
            "RHOPRESSA (Ophthalmic)",
            "netarsudil 0.2 MG/ML Ophthalmic Solution",
            "netarsudil 0.2 mg/ml ophthalmic solution",
            "rhopressa",
            "rhopressa (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "44%"
            },
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "28%"
            }
        ]
    },
    {
        "name": "Halobetasol",
        "route": "Topical",
        "fullName": "Halobetasol (Topical)",
        "totalCount": 26,
        "searchTerms": [
            "Halobetasol",
            "Halobetasol (Topical)",
            "halobetasol",
            "halobetasol (topical)",
            "halobetasol propionate 0.5 MG/ML Topical Cream",
            "halobetasol propionate 0.5 MG/ML Topical Foam",
            "halobetasol propionate 0.5 MG/ML Topical Lotion",
            "halobetasol propionate 0.5 mg/ml topical cream",
            "halobetasol propionate 0.5 mg/ml topical foam",
            "halobetasol propionate 0.5 mg/ml topical lotion"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "46%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            },
            {
                "value": "As needed",
                "pct": "19%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Betamethasone/Clotrimazole",
        "route": "Topical",
        "fullName": "Betamethasone/Clotrimazole (Topical)",
        "totalCount": 26,
        "searchTerms": [
            "Betamethasone/Clotrimazole",
            "Betamethasone/Clotrimazole (Topical)",
            "betamethasone 0.5 MG/ML / clotrimazole 10 MG/ML Topical Cream",
            "betamethasone 0.5 MG/ML / clotrimazole 10 MG/ML Topical Lotion",
            "betamethasone 0.5 mg/ml / clotrimazole 10 mg/ml topical cream",
            "betamethasone 0.5 mg/ml / clotrimazole 10 mg/ml topical lotion",
            "betamethasone/clotrimazole",
            "betamethasone/clotrimazole (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "58%"
            },
            {
                "value": "Once daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Diltiazem",
        "route": "Oral Pill",
        "fullName": "Diltiazem (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "Diltiazem",
            "Diltiazem (Oral Pill)",
            "Diltiazem (Oral)",
            "dilTIAZem",
            "dilTIAZem (Oral Pill)",
            "diltiaZEM",
            "diltiaZEM (Oral)",
            "diltiazem",
            "diltiazem (oral pill)",
            "diltiazem (oral)",
            "diltiazem hydrochloride 120 MG Oral Tablet",
            "diltiazem hydrochloride 120 mg oral tablet",
            "diltiazem hydrochloride 30 MG Oral Tablet",
            "diltiazem hydrochloride 30 mg oral tablet",
            "diltiazem hydrochloride 60 MG Oral Tablet",
            "diltiazem hydrochloride 60 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "120 mg",
                "pct": "65%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "74%"
            }
        ]
    },
    {
        "name": "Vitamin C - Supplement",
        "route": "Oral Pill",
        "fullName": "Vitamin C - Supplement (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "Acerola C",
            "Ascorbic Acid",
            "VITAMIN C - Supplement",
            "VITAMIN C - Supplement (Oral)",
            "Vitamin C - Supplement",
            "Vitamin C - Supplement (Oral)",
            "acerola c",
            "ascorbic acid",
            "vitamin C - Supplement",
            "vitamin C - Supplement (Oral)",
            "vitamin c - supplement",
            "vitamin c - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "85%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "HYDROXYZINE HCL",
        "route": "Oral Pill",
        "fullName": "HYDROXYZINE HCL (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "Atarax",
            "HYDROXYZINE HCL",
            "HYDROXYZINE HCL (Oral)",
            "HydrOXYzine hcl",
            "HydrOXYzine hcl (Oral)",
            "Hydroxyzine HCL",
            "Hydroxyzine HCL (Oral)",
            "Hydroxyzine HCl",
            "Hydroxyzine HCl (Oral)",
            "Hydroxyzine Hcl",
            "Hydroxyzine Hcl (Oral)",
            "atarax",
            "hydrOXYzine HCL",
            "hydrOXYzine HCL (Oral)",
            "hydrOXYzine HCl",
            "hydrOXYzine HCl (Oral)",
            "hydroXYZine HCl",
            "hydroXYZine HCl (Oral)",
            "hydroxyzine hcl",
            "hydroxyzine hcl (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "42%"
            },
            {
                "value": "25 mg",
                "pct": "31%"
            },
            {
                "value": "50 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "31%"
            },
            {
                "value": "Once daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "92%"
            }
        ]
    },
    {
        "name": "LANTUS SOLOSTAR",
        "route": "Injectable",
        "fullName": "LANTUS SOLOSTAR (Injectable)",
        "totalCount": 26,
        "searchTerms": [
            "LANTUS SOLOSTAR",
            "LANTUS SOLOSTAR (Injectable)",
            "LANTUS SoloStar",
            "LANTUS SoloStar (Injectable)",
            "Lantus SOLOSTAR",
            "Lantus SOLOSTAR (Injectable)",
            "Lantus SoloStar",
            "Lantus SoloStar (Injectable)",
            "Lantus Solostar",
            "Lantus Solostar (Injectable)",
            "lantus solostar",
            "lantus solostar (injectable)"
        ],
        "dosages": [
            {
                "value": "100 units",
                "pct": "92%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "54%"
            },
            {
                "value": "At bedtime",
                "pct": "31%"
            }
        ],
        "adminNotes": [
            {
                "value": "Do not mix with other insulins",
                "pct": "21%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Vitamin D2 - Supplement",
        "route": "Oral Pill",
        "fullName": "Vitamin D2 - Supplement (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "Drisdol",
            "VITAMIN D2 - Supplement",
            "VITAMIN D2 - Supplement (Oral)",
            "Vitamin D2 - Supplement",
            "Vitamin D2 - Supplement (Oral)",
            "drisdol",
            "vitamin d2 - supplement",
            "vitamin d2 - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "1.25 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "96%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "BENICAR HCT",
        "route": "Oral Pill",
        "fullName": "BENICAR HCT (Oral Pill)",
        "totalCount": 26,
        "searchTerms": [
            "BENICAR HCT",
            "BENICAR HCT (Oral Pill)",
            "benicar hct",
            "benicar hct (oral pill)",
            "hydrochlorothiazide 12.5 MG / olmesartan medoxomil 20 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / olmesartan medoxomil 40 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / olmesartan medoxomil 20 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / olmesartan medoxomil 40 mg oral tablet",
            "hydrochlorothiazide 25 MG / olmesartan medoxomil 40 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / olmesartan medoxomil 40 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "25-40 mg",
                "pct": "46%"
            },
            {
                "value": "12.5-40 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RENA-VITE",
        "route": "Oral Pill",
        "fullName": "RENA-VITE (Oral Pill)",
        "totalCount": 25,
        "searchTerms": [
            "RENA-VITE",
            "RENA-VITE (Oral Pill)",
            "ascorbic acid 60 MG / calcium pantothenate 10 MG / D-biotin 0.3 MG / folic acid 0.8 MG / niacinamide 20 MG / pyridoxine 10 MG / riboflavin 1.7 MG / thiamine 1.5 MG / vitamin B12 0.006 MG Oral Tablet",
            "ascorbic acid 60 mg / calcium pantothenate 10 mg / d-biotin 0.3 mg / folic acid 0.8 mg / niacinamide 20 mg / pyridoxine 10 mg / riboflavin 1.7 mg / thiamine 1.5 mg / vitamin b12 0.006 mg oral tablet",
            "rena-vite",
            "rena-vite (oral pill)"
        ],
        "dosages": [
            {
                "value": "60-10-0.3-0.8-20-10-1.7-1.5-0.006 mg",
                "pct": "88%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "Vitamin B6",
        "route": "Oral Pill",
        "fullName": "Vitamin B6 (Oral Pill)",
        "totalCount": 25,
        "searchTerms": [
            "Vitamin B6",
            "Vitamin B6 (Oral Pill)",
            "vitamin B6 100 MG Oral Tablet",
            "vitamin B6 25 MG Oral Tablet",
            "vitamin b6",
            "vitamin b6 (oral pill)",
            "vitamin b6 100 mg oral tablet",
            "vitamin b6 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "48%"
            },
            {
                "value": "10 mg",
                "pct": "20%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "76%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Buprenorphine/Naloxone",
        "route": "Sublingual",
        "fullName": "Buprenorphine/Naloxone (Sublingual)",
        "totalCount": 25,
        "searchTerms": [
            "Buprenorphine/Naloxone",
            "Buprenorphine/Naloxone (Sublingual)",
            "buprenorphine 1.4 MG / naloxone 0.36 MG Sublingual Tablet",
            "buprenorphine 1.4 mg / naloxone 0.36 mg sublingual tablet",
            "buprenorphine 12 MG / naloxone 3 MG Sublingual Film",
            "buprenorphine 12 mg / naloxone 3 mg sublingual film",
            "buprenorphine 2 MG / naloxone 0.5 MG Sublingual Film",
            "buprenorphine 2 mg / naloxone 0.5 mg sublingual film",
            "buprenorphine 8 MG / naloxone 2 MG Sublingual Film",
            "buprenorphine 8 mg / naloxone 2 mg sublingual film",
            "buprenorphine/naloxone",
            "buprenorphine/naloxone (sublingual)"
        ],
        "dosages": [
            {
                "value": "2-0.5 mg",
                "pct": "32%"
            },
            {
                "value": "8-2 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "32%"
            },
            {
                "value": "Twice daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Nystatin/Triamcinolone",
        "route": "Topical",
        "fullName": "Nystatin/Triamcinolone (Topical)",
        "totalCount": 24,
        "searchTerms": [
            "Nystatin/Triamcinolone",
            "Nystatin/Triamcinolone (Topical)",
            "nystatin 100 UNT/MG / triamcinolone acetonide 0.001 MG/MG Topical Ointment",
            "nystatin 100 unt/mg / triamcinolone acetonide 0.001 mg/mg topical ointment",
            "nystatin 100000 UNT/ML / triamcinolone acetonide 1 MG/ML Topical Cream",
            "nystatin 100000 unt/ml / triamcinolone acetonide 1 mg/ml topical cream",
            "nystatin/triamcinolone",
            "nystatin/triamcinolone (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "46%"
            },
            {
                "value": "Once daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ARNUITY",
        "route": "Inhalant",
        "fullName": "ARNUITY (Inhalant)",
        "totalCount": 24,
        "searchTerms": [
            "14 ACTUAT fluticasone furoate 0.1 MG/ACTUAT Dry Powder Inhaler",
            "14 ACTUAT fluticasone furoate 0.2 MG/ACTUAT Dry Powder Inhaler",
            "14 actuat fluticasone furoate 0.1 mg/actuat dry powder inhaler",
            "14 actuat fluticasone furoate 0.2 mg/actuat dry powder inhaler",
            "30 ACTUAT fluticasone furoate 0.1 MG/ACTUAT Dry Powder Inhaler",
            "30 ACTUAT fluticasone furoate 0.2 MG/ACTUAT Dry Powder Inhaler",
            "30 actuat fluticasone furoate 0.1 mg/actuat dry powder inhaler",
            "30 actuat fluticasone furoate 0.2 mg/actuat dry powder inhaler",
            "ARNUITY",
            "ARNUITY (Inhalant)",
            "arnuity",
            "arnuity (inhalant)"
        ],
        "dosages": [
            {
                "value": "100 mcg",
                "pct": "50%"
            },
            {
                "value": "200 mcg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Botulinum toxin type A",
        "route": "Injectable",
        "fullName": "Botulinum toxin type A (Injectable)",
        "totalCount": 24,
        "searchTerms": [
            "Botulinum toxin type A",
            "Botulinum toxin type A (Injectable)",
            "abobotulinumtoxinA 500 UNT Injection",
            "abobotulinumtoxina 500 unt injection",
            "botulinum toxin type a",
            "botulinum toxin type a (injectable)",
            "incobotulinumtoxinA 100 UNT Injection",
            "incobotulinumtoxinA 200 UNT Injection",
            "incobotulinumtoxinA 50 UNT Injection",
            "incobotulinumtoxina 100 unt injection",
            "incobotulinumtoxina 200 unt injection",
            "incobotulinumtoxina 50 unt injection"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "sitaGLIPtin",
        "route": "Oral Pill",
        "fullName": "sitaGLIPtin (Oral Pill)",
        "totalCount": 24,
        "searchTerms": [
            "SITagliptin",
            "SITagliptin (Oral Pill)",
            "Sitagliptin",
            "Sitagliptin (Oral)",
            "sitaGLIPtin",
            "sitaGLIPtin (Oral Pill)",
            "sitagliptin",
            "sitagliptin (oral pill)",
            "sitagliptin (oral)",
            "sitagliptin 100 MG Oral Tablet",
            "sitagliptin 100 mg oral tablet",
            "sitagliptin 25 MG Oral Tablet",
            "sitagliptin 25 mg oral tablet",
            "sitagliptin 50 MG Oral Tablet",
            "sitagliptin 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "46%"
            },
            {
                "value": "50 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "59%"
            }
        ]
    },
    {
        "name": "cycloSPORINE",
        "route": "Ophthalmic",
        "fullName": "cycloSPORINE (Ophthalmic)",
        "totalCount": 24,
        "searchTerms": [
            "Restasis",
            "cycloSPORINE",
            "cycloSPORINE (Ophthalmic)",
            "cyclosporine",
            "cyclosporine (ophthalmic)",
            "cyclosporine 0.9 MG/ML Ophthalmic Solution",
            "cyclosporine 0.9 mg/ml ophthalmic solution",
            "restasis"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "71%"
            },
            {
                "value": "Once daily",
                "pct": "21%"
            }
        ],
        "adminNotes": [
            {
                "value": "Avoid touching dropper tip to eye or surfaces",
                "pct": "29%"
            }
        ],
        "diagnoses": [
            {
                "code": "H04.123",
                "description": "Dry eye syndrome of bilateral lacrimal glands",
                "pct": "76%"
            }
        ]
    },
    {
        "name": "BUPROPION",
        "route": "Oral Pill",
        "fullName": "BUPROPION (Oral Pill)",
        "totalCount": 24,
        "searchTerms": [
            "BUPROPION",
            "Bupropion",
            "Bupropion (Oral)",
            "buPROPion",
            "buPROPion (Oral Pill)",
            "bupropion",
            "bupropion (oral pill)",
            "bupropion (oral)",
            "bupropion hydrochloride 100 MG Oral Tablet",
            "bupropion hydrochloride 100 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "54%"
            },
            {
                "value": "75 mg",
                "pct": "29%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "59%"
            }
        ]
    },
    {
        "name": "SUMAtriptan",
        "route": "Oral Pill",
        "fullName": "SUMAtriptan (Oral Pill)",
        "totalCount": 24,
        "searchTerms": [
            "SUMAtriptan",
            "SUMAtriptan (Oral Pill)",
            "Sumatriptan",
            "Sumatriptan (Oral)",
            "sumatriptan",
            "sumatriptan (oral pill)",
            "sumatriptan (oral)",
            "sumatriptan 100 MG Oral Tablet",
            "sumatriptan 100 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "50%"
            },
            {
                "value": "100 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "54%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G43.909",
                "description": "Migraine, unsp, not intractable, without status migrainosus",
                "pct": "70%"
            }
        ]
    },
    {
        "name": "Ticagrelor",
        "route": "Oral Pill",
        "fullName": "Ticagrelor (Oral Pill)",
        "totalCount": 24,
        "searchTerms": [
            "Brilinta",
            "Ticagrelor",
            "Ticagrelor (Oral Pill)",
            "Ticagrelor (Oral)",
            "brilinta",
            "ticagrelor",
            "ticagrelor (oral pill)",
            "ticagrelor (oral)",
            "ticagrelor 60 MG Oral Tablet",
            "ticagrelor 60 mg oral tablet",
            "ticagrelor 90 MG Oral Tablet",
            "ticagrelor 90 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "90 mg",
                "pct": "96%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "PAXIL",
        "route": "Oral Pill",
        "fullName": "PAXIL (Oral Pill)",
        "totalCount": 24,
        "searchTerms": [
            "PAXIL",
            "PAXIL (Oral Pill)",
            "paroxetine hydrochloride 10 MG Oral Tablet",
            "paroxetine hydrochloride 10 mg oral tablet",
            "paroxetine hydrochloride 20 MG Oral Tablet",
            "paroxetine hydrochloride 20 mg oral tablet",
            "paroxetine hydrochloride 30 MG Oral Tablet",
            "paroxetine hydrochloride 30 mg oral tablet",
            "paroxetine hydrochloride 40 MG Oral Tablet",
            "paroxetine hydrochloride 40 mg oral tablet",
            "paxil",
            "paxil (oral pill)"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "38%"
            },
            {
                "value": "20 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Multivitamin - Supplement",
        "route": "Oral Pill",
        "fullName": "Multivitamin - Supplement (Oral Pill)",
        "totalCount": 24,
        "searchTerms": [
            "MULTIVITAMIN - Supplement",
            "MULTIVITAMIN - Supplement (Oral)",
            "Multivitamin",
            "Multivitamin - Supplement",
            "Multivitamin - Supplement (Oral)",
            "multivitamin",
            "multivitamin - Supplement",
            "multivitamin - Supplement (Oral)",
            "multivitamin - supplement",
            "multivitamin - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "96%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "83%"
            },
            {
                "code": "Z71.3",
                "description": "Dietary counseling and surveillance",
                "pct": "29%"
            }
        ]
    },
    {
        "name": "Nature Made D3 - Supplement",
        "route": "Oral Pill",
        "fullName": "Nature Made D3 - Supplement (Oral Pill)",
        "totalCount": 24,
        "searchTerms": [
            "Nature Made D3 - Supplement",
            "Nature Made D3 - Supplement (Oral)",
            "nature made d3 - supplement",
            "nature made d3 - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "Supports bone",
                "pct": "62%"
            },
            {
                "value": "Supports immune health",
                "pct": "58%"
            },
            {
                "value": "Softgels",
                "pct": "38%"
            },
            {
                "value": "teeth & muscle health",
                "pct": "33%"
            },
            {
                "value": "teeth and muscle health",
                "pct": "25%"
            }
        ],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Albuterol",
        "route": "Inhaler",
        "fullName": "Albuterol (Inhaler)",
        "totalCount": 24,
        "searchTerms": [
            "ALBUTEROL",
            "ALBUTEROL (Inhaler)",
            "Albuterol",
            "Albuterol (Inhaler)",
            "PROAIR HFA",
            "albuterol",
            "albuterol (Inhaler)",
            "albuterol (inhaler)",
            "proair hfa"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "58%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "88%"
            }
        ],
        "adminNotes": [
            {
                "value": "For wheezing",
                "pct": "25%"
            }
        ],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "92%"
            }
        ]
    },
    {
        "name": "XALATAN",
        "route": "Ophthalmic",
        "fullName": "XALATAN (Ophthalmic)",
        "totalCount": 24,
        "searchTerms": [
            "XALATAN",
            "XALATAN (Ophthalmic)",
            "latanoprost 0.05 MG/ML Ophthalmic Solution",
            "latanoprost 0.05 mg/ml ophthalmic solution",
            "xalatan",
            "xalatan (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "50%"
            },
            {
                "value": "Once daily",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "XIIDRA",
        "route": "Ophthalmic",
        "fullName": "XIIDRA (Ophthalmic)",
        "totalCount": 23,
        "searchTerms": [
            "XIIDRA",
            "XIIDRA (Ophthalmic)",
            "lifitegrast 50 MG/ML Ophthalmic Solution",
            "lifitegrast 50 mg/ml ophthalmic solution",
            "xiidra",
            "xiidra (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H04.123",
                "description": "Dry eye syndrome of bilateral lacrimal glands",
                "pct": "78%"
            }
        ]
    },
    {
        "name": "FOSAMAX",
        "route": "Oral Pill",
        "fullName": "FOSAMAX (Oral Pill)",
        "totalCount": 23,
        "searchTerms": [
            "FOSAMAX",
            "FOSAMAX (Oral Pill)",
            "alendronic acid 70 MG Oral Tablet",
            "alendronic acid 70 mg oral tablet",
            "fosamax",
            "fosamax (oral pill)"
        ],
        "dosages": [
            {
                "value": "70 mg",
                "pct": "96%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "65%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Tolterodine XR",
        "route": "Oral Pill",
        "fullName": "Tolterodine XR (Oral Pill)",
        "totalCount": 23,
        "searchTerms": [
            "24 HR tolterodine tartrate 2 MG Extended Release Oral Capsule",
            "24 HR tolterodine tartrate 4 MG Extended Release Oral Capsule",
            "24 hr tolterodine tartrate 2 mg extended release oral capsule",
            "24 hr tolterodine tartrate 4 mg extended release oral capsule",
            "Tolterodine XR",
            "Tolterodine XR (Oral Pill)",
            "tolterodine xr",
            "tolterodine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "57%"
            },
            {
                "value": "2 mg",
                "pct": "43%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Levofloxacin",
        "route": "Oral Pill",
        "fullName": "Levofloxacin (Oral Pill)",
        "totalCount": 23,
        "searchTerms": [
            "LEVAQUIN",
            "LEVOFLOXACIN",
            "Levaquin",
            "Levofloxacin",
            "Levofloxacin (Oral Pill)",
            "Levofloxacin (Oral)",
            "levaquin",
            "levoFLOXacin",
            "levoFLOXacin (Oral Pill)",
            "levoFLOXacin (Oral)",
            "levofloxacin",
            "levofloxacin (oral pill)",
            "levofloxacin (oral)",
            "levofloxacin 250 MG Oral Tablet",
            "levofloxacin 250 mg oral tablet",
            "levofloxacin 500 MG Oral Tablet",
            "levofloxacin 500 mg oral tablet",
            "levofloxacin 750 MG Oral Tablet",
            "levofloxacin 750 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "48%"
            },
            {
                "value": "750 mg",
                "pct": "39%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FEOSOL",
        "route": "Oral Pill",
        "fullName": "FEOSOL (Oral Pill)",
        "totalCount": 23,
        "searchTerms": [
            "FEOSOL",
            "FEOSOL (Oral Pill)",
            "feosol",
            "feosol (oral pill)",
            "ferrous sulfate 325 MG Oral Tablet",
            "ferrous sulfate 325 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "325 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "AYR SALINE NASAL",
        "route": "Nasal",
        "fullName": "AYR SALINE NASAL (Nasal)",
        "totalCount": 23,
        "searchTerms": [
            "AYR SALINE NASAL",
            "AYR SALINE NASAL (Nasal)",
            "Altamist",
            "altamist",
            "ayr saline nasal",
            "ayr saline nasal (nasal)",
            "sodium chloride 0.111 MEQ/ML Nasal Solution",
            "sodium chloride 0.111 MEQ/ML Nasal Spray",
            "sodium chloride 0.111 meq/ml nasal solution",
            "sodium chloride 0.111 meq/ml nasal spray"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "52%"
            },
            {
                "value": "Three times daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Rivaroxaban",
        "route": "Oral Pill",
        "fullName": "Rivaroxaban (Oral Pill)",
        "totalCount": 23,
        "searchTerms": [
            "RIVAROXABAN",
            "RIVAROXABAN (Oral)",
            "Rivaroxaban",
            "Rivaroxaban (Oral Pill)",
            "Rivaroxaban (Oral)",
            "Xarelto",
            "rivaroxaban",
            "rivaroxaban (oral pill)",
            "rivaroxaban (oral)",
            "rivaroxaban 10 MG Oral Tablet",
            "rivaroxaban 10 mg oral tablet",
            "rivaroxaban 15 MG Oral Tablet",
            "rivaroxaban 15 mg oral tablet",
            "rivaroxaban 20 MG Oral Tablet",
            "rivaroxaban 20 mg oral tablet",
            "xarelto"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "39%"
            },
            {
                "value": "2.5 mg",
                "pct": "39%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "52%"
            },
            {
                "value": "Twice daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I48.91",
                "description": "Unspecified atrial fibrillation",
                "pct": "60%"
            }
        ]
    },
    {
        "name": "Fluocinonide",
        "route": "Topical",
        "fullName": "Fluocinonide (Topical)",
        "totalCount": 23,
        "searchTerms": [
            "Fluocinonide",
            "Fluocinonide (Topical)",
            "fluocinonide",
            "fluocinonide (topical)",
            "fluocinonide 0.0005 MG/MG Topical Ointment",
            "fluocinonide 0.0005 mg/mg topical ointment",
            "fluocinonide 0.5 MG/ML Topical Cream",
            "fluocinonide 0.5 MG/ML Topical Solution",
            "fluocinonide 0.5 mg/ml topical cream",
            "fluocinonide 0.5 mg/ml topical solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "43%"
            },
            {
                "value": "Twice daily",
                "pct": "39%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "GLUCOTROL",
        "route": "Oral Pill",
        "fullName": "GLUCOTROL (Oral Pill)",
        "totalCount": 23,
        "searchTerms": [
            "GLUCOTROL",
            "GLUCOTROL (Oral Pill)",
            "glipizide 10 MG Oral Tablet",
            "glipizide 10 mg oral tablet",
            "glipizide 5 MG Oral Tablet",
            "glipizide 5 mg oral tablet",
            "glucotrol",
            "glucotrol (oral pill)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "48%"
            },
            {
                "value": "10 mg",
                "pct": "43%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "30%"
            },
            {
                "value": "Twice daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Fludrocortisone",
        "route": "Oral Pill",
        "fullName": "Fludrocortisone (Oral Pill)",
        "totalCount": 23,
        "searchTerms": [
            "FLUDROCORTISONE",
            "Fludrocortisone",
            "Fludrocortisone (Oral Pill)",
            "Fludrocortisone (Oral)",
            "fludrocortisone",
            "fludrocortisone (oral pill)",
            "fludrocortisone (oral)",
            "fludrocortisone 0.1 MG Oral Tablet",
            "fludrocortisone 0.1 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.1 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "74%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Losartan/HCTZ",
        "route": "Oral Pill",
        "fullName": "Losartan/HCTZ (Oral Pill)",
        "totalCount": 23,
        "searchTerms": [
            "HYZAAR",
            "Hyzaar",
            "LOSARTAN/HCTZ",
            "LOSARTAN/HCTZ (Oral)",
            "Losartan/HCTZ",
            "Losartan/HCTZ (Oral)",
            "hyzaar",
            "losartan/hctz",
            "losartan/hctz (oral)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "43%"
            },
            {
                "value": "100-25 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "MEMANTINE HCL",
        "route": "Oral Pill",
        "fullName": "MEMANTINE HCL (Oral Pill)",
        "totalCount": 23,
        "searchTerms": [
            "MEMANTINE HCL",
            "MEMANTINE HCL (Oral)",
            "Memantine HCL",
            "Memantine HCL (Oral)",
            "Memantine HCl",
            "Memantine HCl (Oral)",
            "Namenda",
            "Namenda 5 mg Tab",
            "memantine HCL",
            "memantine hcl",
            "memantine hcl (oral)",
            "namenda",
            "namenda 5 mg tab"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "70%"
            },
            {
                "value": "5 mg",
                "pct": "30%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "65%"
            },
            {
                "value": "Twice daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G30.9",
                "description": "Alzheimer's disease, unspecified",
                "pct": "89%"
            }
        ]
    },
    {
        "name": "AZOPT",
        "route": "Ophthalmic",
        "fullName": "AZOPT (Ophthalmic)",
        "totalCount": 23,
        "searchTerms": [
            "AZOPT",
            "AZOPT (Ophthalmic)",
            "azopt",
            "azopt (ophthalmic)",
            "brinzolamide 10 MG/ML Ophthalmic Suspension",
            "brinzolamide 10 mg/ml ophthalmic suspension"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "35%"
            },
            {
                "value": "Twice daily",
                "pct": "30%"
            },
            {
                "value": "Three times daily",
                "pct": "30%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TYLENOL SEVERE ALLERGY",
        "route": "Oral Pill",
        "fullName": "TYLENOL SEVERE ALLERGY (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "TYLENOL SEVERE ALLERGY",
            "TYLENOL SEVERE ALLERGY (Oral Pill)",
            "acetaminophen 500 MG / diphenhydramine hydrochloride 12.5 MG Oral Tablet",
            "acetaminophen 500 mg / diphenhydramine hydrochloride 12.5 mg oral tablet",
            "tylenol severe allergy",
            "tylenol severe allergy (oral pill)"
        ],
        "dosages": [
            {
                "value": "500-12.5 mg",
                "pct": "55%"
            },
            {
                "value": "500 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cyproheptadine",
        "route": "Oral Pill",
        "fullName": "Cyproheptadine (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "CYPROHEPTADINE",
            "CYPROHEPTADINE (Oral)",
            "Cyproheptadine",
            "Cyproheptadine (Oral Pill)",
            "Cyproheptadine (Oral)",
            "Periactin",
            "cyproheptadine",
            "cyproheptadine (oral pill)",
            "cyproheptadine (oral)",
            "cyproheptadine hydrochloride 4 MG Oral Tablet",
            "cyproheptadine hydrochloride 4 mg oral tablet",
            "periactin"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "Twice daily",
                "pct": "23%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "69%"
            }
        ]
    },
    {
        "name": "Ketorolac",
        "route": "Ophthalmic",
        "fullName": "Ketorolac (Ophthalmic)",
        "totalCount": 22,
        "searchTerms": [
            "Ketorolac",
            "Ketorolac (Ophthalmic)",
            "ketorolac",
            "ketorolac (ophthalmic)",
            "ketorolac tromethamine 4 MG/ML Ophthalmic Solution",
            "ketorolac tromethamine 4 mg/ml ophthalmic solution",
            "ketorolac tromethamine 4.5 MG/ML Ophthalmic Solution",
            "ketorolac tromethamine 4.5 mg/ml ophthalmic solution",
            "ketorolac tromethamine 5 MG/ML Ophthalmic Solution",
            "ketorolac tromethamine 5 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Four times daily",
                "pct": "32%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H57.89",
                "description": "Other specified disorders of eye and adnexa",
                "pct": "33%"
            }
        ]
    },
    {
        "name": "Nabumetone",
        "route": "Oral Pill",
        "fullName": "Nabumetone (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "Nabumetone",
            "Nabumetone (Oral Pill)",
            "Nabumetone (Oral)",
            "nabumetone",
            "nabumetone (oral pill)",
            "nabumetone (oral)",
            "nabumetone 500 MG Oral Tablet",
            "nabumetone 500 mg oral tablet",
            "nabumetone 750 MG Oral Tablet",
            "nabumetone 750 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "68%"
            },
            {
                "value": "750 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "Twice daily",
                "pct": "32%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "Rivastigmine",
        "route": "Transdermal",
        "fullName": "Rivastigmine (Transdermal)",
        "totalCount": 22,
        "searchTerms": [
            "24 HR rivastigmine 0.192 MG/HR Transdermal System",
            "24 HR rivastigmine 0.554 MG/HR Transdermal System",
            "24 hr rivastigmine 0.192 mg/hr transdermal system",
            "24 hr rivastigmine 0.554 mg/hr transdermal system",
            "Rivastigmine",
            "Rivastigmine (Transdermal)",
            "rivastigmine",
            "rivastigmine (transdermal)"
        ],
        "dosages": [
            {
                "value": "0.554 mg",
                "pct": "36%"
            },
            {
                "value": "9.5 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Fluticasone/Vilanterol",
        "route": "Inhalant",
        "fullName": "Fluticasone/Vilanterol (Inhalant)",
        "totalCount": 22,
        "searchTerms": [
            "14 ACTUAT fluticasone furoate 0.1 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "14 ACTUAT fluticasone furoate 0.2 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "14 actuat fluticasone furoate 0.1 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "14 actuat fluticasone furoate 0.2 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "30 ACTUAT fluticasone furoate 0.1 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "30 ACTUAT fluticasone furoate 0.2 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "30 actuat fluticasone furoate 0.1 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "30 actuat fluticasone furoate 0.2 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "Fluticasone/Vilanterol",
            "Fluticasone/Vilanterol (Inhalant)",
            "fluticasone/vilanterol",
            "fluticasone/vilanterol (inhalant)"
        ],
        "dosages": [
            {
                "value": "100-25 mcg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BUMEX",
        "route": "Oral Pill",
        "fullName": "BUMEX (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "BUMEX",
            "BUMEX (Oral Pill)",
            "Bumex",
            "Bumex (Oral)",
            "bumetanide 0.5 MG Oral Tablet",
            "bumetanide 0.5 mg oral tablet",
            "bumetanide 1 MG Oral Tablet",
            "bumetanide 1 mg oral tablet",
            "bumetanide 2 MG Oral Tablet",
            "bumetanide 2 mg oral tablet",
            "bumex",
            "bumex (oral pill)",
            "bumex (oral)"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "45%"
            },
            {
                "value": "1 mg",
                "pct": "32%"
            },
            {
                "value": "0.5 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "41%"
            },
            {
                "value": "Twice daily",
                "pct": "36%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "56%"
            }
        ]
    },
    {
        "name": "ZyrTEC",
        "route": "Oral Disintegrating",
        "fullName": "ZyrTEC (Oral Disintegrating)",
        "totalCount": 22,
        "searchTerms": [
            "ZYRTEC",
            "ZyrTEC",
            "ZyrTEC (Oral Disintegrating)",
            "cetirizine hydrochloride 10 MG Disintegrating Oral Tablet",
            "cetirizine hydrochloride 10 mg disintegrating oral tablet",
            "zyrtec",
            "zyrtec (oral disintegrating)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TOPROL XR",
        "route": "Oral Pill",
        "fullName": "TOPROL XR (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "24 HR metoprolol succinate 100 MG Extended Release Oral Tablet",
            "24 HR metoprolol succinate 25 MG Extended Release Oral Tablet",
            "24 HR metoprolol succinate 50 MG Extended Release Oral Tablet",
            "24 hr metoprolol succinate 100 mg extended release oral tablet",
            "24 hr metoprolol succinate 25 mg extended release oral tablet",
            "24 hr metoprolol succinate 50 mg extended release oral tablet",
            "TOPROL",
            "TOPROL XR",
            "TOPROL XR (Oral Pill)",
            "toprol",
            "toprol xr",
            "toprol xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "41%"
            },
            {
                "value": "25 mg",
                "pct": "27%"
            },
            {
                "value": "100 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "PROVENTIL",
        "route": "Inhalant",
        "fullName": "PROVENTIL (Inhalant)",
        "totalCount": 22,
        "searchTerms": [
            "NDA020503 200 ACTUAT albuterol 0.09 MG/ACTUAT Metered Dose Inhaler",
            "PROVENTIL",
            "PROVENTIL (Inhalant)",
            "nda020503 200 actuat albuterol 0.09 mg/actuat metered dose inhaler",
            "proventil",
            "proventil (inhalant)"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "45%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Azithromycin",
        "route": "Oral Pill",
        "fullName": "Azithromycin (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "Azithromycin",
            "Azithromycin (Oral Pill)",
            "Azithromycin (Oral)",
            "azithromycin",
            "azithromycin (oral pill)",
            "azithromycin (oral)",
            "azithromycin 500 MG Oral Tablet",
            "azithromycin 500 mg oral tablet",
            "azithromycin 600 MG Oral Tablet",
            "azithromycin 600 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "250 mg",
                "pct": "59%"
            },
            {
                "value": "500 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TOUJEO",
        "route": "Injectable",
        "fullName": "TOUJEO (Injectable)",
        "totalCount": 22,
        "searchTerms": [
            "1.5 ML insulin glargine 300 UNT/ML Pen Injector",
            "1.5 ml insulin glargine 300 unt/ml pen injector",
            "3 ML insulin glargine 300 UNT/ML Pen Injector",
            "3 ml insulin glargine 300 unt/ml pen injector",
            "TOUJEO",
            "TOUJEO (Injectable)",
            "toujeo",
            "toujeo (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "41%"
            },
            {
                "value": "At bedtime",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "Vitamin E",
        "route": "Oral Pill",
        "fullName": "Vitamin E (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "VITAMIN E",
            "Vitamin E",
            "Vitamin E (Oral Pill)",
            "dl-alpha tocopheryl acetate 200 UNT Oral Capsule",
            "dl-alpha tocopheryl acetate 200 unt oral capsule",
            "vitamin E 100 UNT Oral Tablet",
            "vitamin e",
            "vitamin e (oral pill)",
            "vitamin e 100 unt oral tablet"
        ],
        "dosages": [
            {
                "value": "180 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "95%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Melatonin/Tryptophan",
        "route": "Oral Pill",
        "fullName": "Melatonin/Tryptophan (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "Melatonin/Tryptophan",
            "Melatonin/Tryptophan (Oral Pill)",
            "melatonin 3 MG / tryptophan 100 MG Oral Capsule",
            "melatonin 3 mg / tryptophan 100 mg oral capsule",
            "melatonin/tryptophan",
            "melatonin/tryptophan (oral pill)"
        ],
        "dosages": [
            {
                "value": "3-100 mg",
                "pct": "36%"
            },
            {
                "value": "3 mg",
                "pct": "27%"
            }
        ],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "68%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Zolpidem Tartrate",
        "route": "Oral Pill",
        "fullName": "Zolpidem Tartrate (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "Ambien",
            "Ambien CR",
            "ZOLPIDEM TARTRATE",
            "ZOLPIDEM TARTRATE (Oral)",
            "Zolpidem Tartrate",
            "Zolpidem Tartrate (Oral)",
            "ambien",
            "ambien cr",
            "zolpidem tartrate",
            "zolpidem tartrate (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "68%"
            },
            {
                "value": "5 mg",
                "pct": "27%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "59%"
            },
            {
                "value": "At bedtime",
                "pct": "41%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "PRAVASTATIN SODIUM",
        "route": "Oral Pill",
        "fullName": "PRAVASTATIN SODIUM (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "PRAVASTATIN SODIUM",
            "PRAVASTATIN SODIUM (Oral)",
            "Pravachol",
            "Pravastatin Sodium",
            "Pravastatin Sodium (Oral)",
            "pravachol",
            "pravastatin sodium",
            "pravastatin sodium (oral)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "50%"
            },
            {
                "value": "40 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "80%"
            }
        ]
    },
    {
        "name": "Fluticasone Propionate Nasal Spray USP",
        "route": "Nasal",
        "fullName": "Fluticasone Propionate Nasal Spray USP (Nasal)",
        "totalCount": 22,
        "searchTerms": [
            "Flonase",
            "Fluticasone Propionate Nasal Spray USP",
            "Fluticasone Propionate Nasal Spray USP (Nasal)",
            "flonase",
            "fluticasone propionate nasal spray usp",
            "fluticasone propionate nasal spray usp (nasal)"
        ],
        "dosages": [
            {
                "value": "50 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "64%"
            },
            {
                "value": "Twice daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [
            {
                "value": "For intranasal use only",
                "pct": "36%"
            }
        ],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "68%"
            },
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "45%"
            }
        ]
    },
    {
        "name": "LOVAZA",
        "route": "Oral Pill",
        "fullName": "LOVAZA (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "LOVAZA",
            "LOVAZA (Oral Pill)",
            "lovaza",
            "lovaza (oral pill)",
            "omega-3 acid ethyl esters (USP) 1000 MG Oral Capsule",
            "omega-3 acid ethyl esters (usp) 1000 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "1 g",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "68%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Metformin HCl ER",
        "route": "Oral Pill",
        "fullName": "Metformin HCl ER (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "GLUCOPHAGE XR",
            "Glucophage",
            "Glucophage XR",
            "METFORMIN HCL ER",
            "METFORMIN HCL ER (Oral)",
            "Metformin HCL ER",
            "Metformin HCL ER (Oral)",
            "Metformin HCl ER",
            "Metformin HCl ER (Oral)",
            "glucophage",
            "glucophage xr",
            "metFORMIN HCL ER",
            "metFORMIN HCL ER (Oral)",
            "metFORMIN HCl ER",
            "metFORMIN HCl ER (Oral)",
            "metformin hcl er",
            "metformin hcl er (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "73%"
            },
            {
                "value": "750 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "59%"
            },
            {
                "value": "Twice daily",
                "pct": "36%"
            }
        ],
        "adminNotes": [
            {
                "value": "Extended release",
                "pct": "36%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "TOPAMAX",
        "route": "Oral Pill",
        "fullName": "TOPAMAX (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "TOPAMAX",
            "TOPAMAX (Oral Pill)",
            "topamax",
            "topamax (oral pill)",
            "topiramate 100 MG Oral Tablet",
            "topiramate 100 mg oral tablet",
            "topiramate 25 MG Oral Capsule",
            "topiramate 25 MG Oral Tablet",
            "topiramate 25 mg oral capsule",
            "topiramate 25 mg oral tablet",
            "topiramate 50 MG Oral Tablet",
            "topiramate 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "32%"
            },
            {
                "value": "100 mg",
                "pct": "27%"
            },
            {
                "value": "25 mg",
                "pct": "27%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "41%"
            },
            {
                "value": "Once daily",
                "pct": "27%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ibuprofen/oxyCODONE",
        "route": "Oral Pill",
        "fullName": "Ibuprofen/oxyCODONE (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "Ibuprofen/oxyCODONE",
            "Ibuprofen/oxyCODONE (Oral Pill)",
            "ibuprofen 400 MG / oxycodone hydrochloride 5 MG Oral Tablet",
            "ibuprofen 400 mg / oxycodone hydrochloride 5 mg oral tablet",
            "ibuprofen/oxycodone",
            "ibuprofen/oxycodone (oral pill)"
        ],
        "dosages": [
            {
                "value": "400-5 mg",
                "pct": "41%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "32%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FERRAPLUS",
        "route": "Oral Pill",
        "fullName": "FERRAPLUS (Oral Pill)",
        "totalCount": 22,
        "searchTerms": [
            "FERRAPLUS",
            "FERRAPLUS (Oral Pill)",
            "ascorbic acid 120 MG / docusate sodium 50 MG / folic acid 1 MG / iron carbonyl 90 MG / vitamin B12 0.012 MG Oral Tablet",
            "ascorbic acid 120 mg / docusate sodium 50 mg / folic acid 1 mg / iron carbonyl 90 mg / vitamin b12 0.012 mg oral tablet",
            "ferraplus",
            "ferraplus (oral pill)"
        ],
        "dosages": [
            {
                "value": "120-50-1-90-0.012 mg",
                "pct": "41%"
            },
            {
                "value": "1 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "59%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Fish oil (containing omega-3 acids)",
        "route": "Injectable",
        "fullName": "Fish oil (containing omega-3 acids) (Injectable)",
        "totalCount": 22,
        "searchTerms": [
            "100 ML fish oil (containing omega-3 acids) 100 MG/ML Injection",
            "100 ml fish oil (containing omega-3 acids) 100 mg/ml injection",
            "50 ML fish oil (containing omega-3 acids) 100 MG/ML Injection",
            "50 ml fish oil (containing omega-3 acids) 100 mg/ml injection",
            "Fish oil (containing omega-3 acids)",
            "Fish oil (containing omega-3 acids) (Injectable)",
            "fish oil (containing omega-3 acids)",
            "fish oil (containing omega-3 acids) (injectable)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "45%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "45%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "COGENTIN",
        "route": "Injectable",
        "fullName": "COGENTIN (Injectable)",
        "totalCount": 22,
        "searchTerms": [
            "2 ML benztropine mesylate 1 MG/ML Injection",
            "2 ml benztropine mesylate 1 mg/ml injection",
            "COGENTIN",
            "COGENTIN (Injectable)",
            "Cogentin",
            "cogentin",
            "cogentin (injectable)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "64%"
            },
            {
                "value": "2 mg",
                "pct": "23%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "Twice daily",
                "pct": "23%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Linagliptin/metFORMIN",
        "route": "Oral Pill",
        "fullName": "Linagliptin/metFORMIN (Oral Pill)",
        "totalCount": 21,
        "searchTerms": [
            "Linagliptin/metFORMIN",
            "Linagliptin/metFORMIN (Oral Pill)",
            "linagliptin 2.5 MG / metformin hydrochloride 1000 MG Oral Tablet",
            "linagliptin 2.5 MG / metformin hydrochloride 500 MG Oral Tablet",
            "linagliptin 2.5 MG / metformin hydrochloride 850 MG Oral Tablet",
            "linagliptin 2.5 mg / metformin hydrochloride 1000 mg oral tablet",
            "linagliptin 2.5 mg / metformin hydrochloride 500 mg oral tablet",
            "linagliptin 2.5 mg / metformin hydrochloride 850 mg oral tablet",
            "linagliptin/metformin",
            "linagliptin/metformin (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "24%"
            },
            {
                "value": "2.5-500 mg",
                "pct": "24%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "48%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "metroNIDAZOLE",
        "route": "Oral Pill",
        "fullName": "metroNIDAZOLE (Oral Pill)",
        "totalCount": 21,
        "searchTerms": [
            "Flagyl",
            "Metronidazole",
            "Metronidazole (Oral)",
            "flagyl",
            "metroNIDAZOLE",
            "metroNIDAZOLE (Oral Pill)",
            "metroNIDAZOLE (Oral)",
            "metronidazole",
            "metronidazole (oral pill)",
            "metronidazole (oral)",
            "metronidazole 250 MG Oral Tablet",
            "metronidazole 250 mg oral tablet",
            "metronidazole 375 MG Oral Capsule",
            "metronidazole 375 mg oral capsule",
            "metronidazole 500 MG Oral Tablet",
            "metronidazole 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "90%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "A49.9",
                "description": "Bacterial infection, unspecified",
                "pct": "72%"
            }
        ]
    },
    {
        "name": "VIMPAT",
        "route": "Oral Pill",
        "fullName": "VIMPAT (Oral Pill)",
        "totalCount": 21,
        "searchTerms": [
            "VIMPAT",
            "VIMPAT (Oral Pill)",
            "lacosamide 100 MG Oral Tablet",
            "lacosamide 100 mg oral tablet",
            "lacosamide 150 MG Oral Tablet",
            "lacosamide 150 mg oral tablet",
            "lacosamide 200 MG Oral Tablet",
            "lacosamide 200 mg oral tablet",
            "lacosamide 50 MG Oral Tablet",
            "lacosamide 50 mg oral tablet",
            "vimpat",
            "vimpat (oral pill)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "38%"
            },
            {
                "value": "100 mg",
                "pct": "33%"
            },
            {
                "value": "200 mg",
                "pct": "24%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "48%"
            },
            {
                "value": "Once daily",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Latanoprostene bunod",
        "route": "Ophthalmic",
        "fullName": "Latanoprostene bunod (Ophthalmic)",
        "totalCount": 21,
        "searchTerms": [
            "Latanoprostene bunod",
            "Latanoprostene bunod (Ophthalmic)",
            "latanoprostene bunod",
            "latanoprostene bunod (ophthalmic)",
            "latanoprostene bunod 0.24 MG/ML Ophthalmic Solution",
            "latanoprostene bunod 0.24 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "38%"
            },
            {
                "value": "Once daily",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TYLENOL",
        "route": "Oral Liquid",
        "fullName": "TYLENOL (Oral Liquid)",
        "totalCount": 21,
        "searchTerms": [
            "TYLENOL",
            "TYLENOL (Oral Liquid)",
            "acetaminophen 32 MG/ML Oral Suspension",
            "acetaminophen 32 mg/ml oral suspension",
            "acetaminophen 33.3 MG/ML Oral Solution",
            "acetaminophen 33.3 mg/ml oral solution",
            "tylenol",
            "tylenol (oral liquid)"
        ],
        "dosages": [
            {
                "value": "160 mg",
                "pct": "76%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "50%"
            },
            {
                "code": "R50.9",
                "description": "Fever, unspecified",
                "pct": "31%"
            }
        ]
    },
    {
        "name": "amLODIPine/Valsartan",
        "route": "Oral Pill",
        "fullName": "amLODIPine/Valsartan (Oral Pill)",
        "totalCount": 21,
        "searchTerms": [
            "amLODIPine/Valsartan",
            "amLODIPine/Valsartan (Oral Pill)",
            "amlodipine 10 MG / valsartan 160 MG Oral Tablet",
            "amlodipine 10 MG / valsartan 320 MG Oral Tablet",
            "amlodipine 10 mg / valsartan 160 mg oral tablet",
            "amlodipine 10 mg / valsartan 320 mg oral tablet",
            "amlodipine 5 MG / valsartan 160 MG Oral Tablet",
            "amlodipine 5 MG / valsartan 320 MG Oral Tablet",
            "amlodipine 5 mg / valsartan 160 mg oral tablet",
            "amlodipine 5 mg / valsartan 320 mg oral tablet",
            "amlodipine/valsartan",
            "amlodipine/valsartan (oral pill)"
        ],
        "dosages": [
            {
                "value": "5-160 mg",
                "pct": "29%"
            },
            {
                "value": "10-160 mg",
                "pct": "29%"
            },
            {
                "value": "10-320 mg",
                "pct": "29%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "95%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "80%"
            }
        ]
    },
    {
        "name": "NovoLOG MIX",
        "route": "Injectable",
        "fullName": "NovoLOG MIX (Injectable)",
        "totalCount": 21,
        "searchTerms": [
            "3 ML insulin aspart protamine, human 70 UNT/ML / insulin aspart, human 30 UNT/ML Pen Injector",
            "3 ml insulin aspart protamine, human 70 unt/ml / insulin aspart, human 30 unt/ml pen injector",
            "NOVOLOG MIX",
            "NovoLOG MIX",
            "NovoLOG MIX (Injectable)",
            "insulin aspart protamine, human 70 UNT/ML / insulin aspart, human 30 UNT/ML Injectable Suspension",
            "insulin aspart protamine, human 70 unt/ml / insulin aspart, human 30 unt/ml injectable suspension",
            "novolog mix",
            "novolog mix (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "80%"
            }
        ]
    },
    {
        "name": "OXcarbazepine XR",
        "route": "Oral Pill",
        "fullName": "OXcarbazepine XR (Oral Pill)",
        "totalCount": 21,
        "searchTerms": [
            "24 HR oxcarbazepine 150 MG Extended Release Oral Tablet",
            "24 HR oxcarbazepine 300 MG Extended Release Oral Tablet",
            "24 HR oxcarbazepine 600 MG Extended Release Oral Tablet",
            "24 hr oxcarbazepine 150 mg extended release oral tablet",
            "24 hr oxcarbazepine 300 mg extended release oral tablet",
            "24 hr oxcarbazepine 600 mg extended release oral tablet",
            "OXcarbazepine XR",
            "OXcarbazepine XR (Oral Pill)",
            "oxcarbazepine xr",
            "oxcarbazepine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "43%"
            },
            {
                "value": "300 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "52%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Sildenafil",
        "route": "Oral Pill",
        "fullName": "Sildenafil (Oral Pill)",
        "totalCount": 21,
        "searchTerms": [
            "Sildenafil",
            "Sildenafil (Oral Pill)",
            "sildenafil",
            "sildenafil (oral pill)",
            "sildenafil 100 MG Oral Tablet",
            "sildenafil 100 mg oral tablet",
            "sildenafil 20 MG Oral Tablet",
            "sildenafil 20 mg oral tablet",
            "sildenafil 25 MG Oral Tablet",
            "sildenafil 25 mg oral tablet",
            "sildenafil 50 MG Oral Tablet",
            "sildenafil 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "29%"
            },
            {
                "value": "100 mg",
                "pct": "29%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "57%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ROCKLATAN",
        "route": "Ophthalmic",
        "fullName": "ROCKLATAN (Ophthalmic)",
        "totalCount": 21,
        "searchTerms": [
            "ROCKLATAN",
            "ROCKLATAN (Ophthalmic)",
            "latanoprost 0.05 MG/ML / netarsudil 0.2 MG/ML Ophthalmic Solution",
            "latanoprost 0.05 mg/ml / netarsudil 0.2 mg/ml ophthalmic solution",
            "rocklatan",
            "rocklatan (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "Febuxostat",
        "route": "Oral Pill",
        "fullName": "Febuxostat (Oral Pill)",
        "totalCount": 21,
        "searchTerms": [
            "Febuxostat",
            "Febuxostat (Oral Pill)",
            "febuxostat",
            "febuxostat (oral pill)",
            "febuxostat 40 MG Oral Tablet",
            "febuxostat 40 mg oral tablet",
            "febuxostat 80 MG Oral Tablet",
            "febuxostat 80 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "METAMUCIL",
        "route": "Oral Suspension Powder",
        "fullName": "METAMUCIL (Oral Suspension Powder)",
        "totalCount": 21,
        "searchTerms": [
            "METAMUCIL",
            "METAMUCIL (Oral Suspension Powder)",
            "metamucil",
            "metamucil (oral suspension powder)",
            "psyllium 3400 MG Powder for Oral Suspension",
            "psyllium 3400 mg powder for oral suspension"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            },
            {
                "value": "As needed",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "SIMBRINZA",
        "route": "Ophthalmic",
        "fullName": "SIMBRINZA (Ophthalmic)",
        "totalCount": 21,
        "searchTerms": [
            "SIMBRINZA",
            "SIMBRINZA (Ophthalmic)",
            "brimonidine tartrate 2 MG/ML / brinzolamide 10 MG/ML Ophthalmic Suspension",
            "brimonidine tartrate 2 mg/ml / brinzolamide 10 mg/ml ophthalmic suspension",
            "simbrinza",
            "simbrinza (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "48%"
            },
            {
                "value": "Three times daily",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "Lactobacillus acidophilus",
        "route": "Oral Pill",
        "fullName": "Lactobacillus acidophilus (Oral Pill)",
        "totalCount": 21,
        "searchTerms": [
            "Lactobacillus acidophilus",
            "Lactobacillus acidophilus (Oral Pill)",
            "Lactobacillus acidophilus 1 MG Oral Tablet",
            "Lactobacillus acidophilus 16 MG Oral Capsule",
            "Lactobacillus acidophilus 20000000000 UNT Oral Capsule",
            "Lactobacillus acidophilus 460 MG Oral Capsule",
            "lactobacillus acidophilus",
            "lactobacillus acidophilus (oral pill)",
            "lactobacillus acidophilus 1 mg oral tablet",
            "lactobacillus acidophilus 16 mg oral capsule",
            "lactobacillus acidophilus 20000000000 unt oral capsule",
            "lactobacillus acidophilus 460 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "460 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "48%"
            },
            {
                "value": "Twice daily",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TRAVATAN",
        "route": "Ophthalmic",
        "fullName": "TRAVATAN (Ophthalmic)",
        "totalCount": 21,
        "searchTerms": [
            "TRAVATAN",
            "TRAVATAN (Ophthalmic)",
            "travatan",
            "travatan (ophthalmic)",
            "travoprost 0.04 MG/ML Ophthalmic Solution",
            "travoprost 0.04 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Bayer Low Dose Aspirin",
        "route": "Oral Pill",
        "fullName": "Bayer Low Dose Aspirin (Oral Pill)",
        "totalCount": 21,
        "searchTerms": [
            "Bayer Low Dose Aspirin",
            "Bayer Low Dose Aspirin (Oral)",
            "bayer low dose aspirin",
            "bayer low dose aspirin (oral)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "NSAID",
                "pct": "62%"
            },
            {
                "value": "Safety coated",
                "pct": "57%"
            },
            {
                "value": "Pain reliever",
                "pct": "52%"
            },
            {
                "value": "Enteric coated tablets",
                "pct": "29%"
            }
        ],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "76%"
            },
            {
                "code": "Z86.73",
                "description": "Prsnl hx of TIA (TIA, 10), and cereb infrc w/o resid deficits",
                "pct": "24%"
            }
        ]
    },
    {
        "name": "Vitamin B12 - Supplement",
        "route": "Oral Pill",
        "fullName": "Vitamin B12 - Supplement (Oral Pill)",
        "totalCount": 21,
        "searchTerms": [
            "Vit B-12",
            "Vitamin B12 - Supplement",
            "Vitamin B12 - Supplement (Oral)",
            "vit b-12",
            "vitamin b12 - supplement",
            "vitamin b12 - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "1000 mcg",
                "pct": "76%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "95%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D51.9",
                "description": "Vitamin B12 deficiency anemia, unspecified",
                "pct": "81%"
            },
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "38%"
            }
        ]
    },
    {
        "name": "Ammonium Lactate",
        "route": "Topical",
        "fullName": "Ammonium Lactate (Topical)",
        "totalCount": 21,
        "searchTerms": [
            "AMMONIUM LACTATE",
            "Ammonium Lactate",
            "Ammonium Lactate (Topical)",
            "Ammonium lactate",
            "Ammonium lactate (Topical)",
            "ammonium lactate",
            "ammonium lactate (Topical)",
            "ammonium lactate (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "62%"
            },
            {
                "value": "Once daily",
                "pct": "24%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "L85.3",
                "description": "Xerosis cutis",
                "pct": "89%"
            }
        ]
    },
    {
        "name": "ROXICODONE",
        "route": "Oral Pill",
        "fullName": "ROXICODONE (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "ROXICODONE",
            "ROXICODONE (Oral Pill)",
            "oxycodone hydrochloride 15 MG Oral Tablet",
            "oxycodone hydrochloride 15 mg oral tablet",
            "oxycodone hydrochloride 30 MG Oral Tablet",
            "oxycodone hydrochloride 30 mg oral tablet",
            "oxycodone hydrochloride 5 MG Oral Tablet",
            "oxycodone hydrochloride 5 mg oral tablet",
            "roxicodone",
            "roxicodone (oral pill)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DOVATO",
        "route": "Oral Pill",
        "fullName": "DOVATO (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "DOVATO",
            "DOVATO (Oral Pill)",
            "Dovato",
            "Dovato (Oral)",
            "dolutegravir 50 MG / lamivudine 300 MG Oral Tablet",
            "dolutegravir 50 mg / lamivudine 300 mg oral tablet",
            "dovato",
            "dovato (oral pill)",
            "dovato (oral)"
        ],
        "dosages": [
            {
                "value": "50-300 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "95%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B20",
                "description": "Human immunodeficiency virus [HIV] disease",
                "pct": "81%"
            }
        ]
    },
    {
        "name": "morphine XR",
        "route": "Oral Pill",
        "fullName": "morphine XR (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Morphine XR",
            "Morphine XR (Oral Pill)",
            "morphine XR",
            "morphine XR (Oral Pill)",
            "morphine sulfate 40 MG Extended Release Oral Capsule",
            "morphine sulfate 40 mg extended release oral capsule",
            "morphine xr",
            "morphine xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "40%"
            },
            {
                "value": "As needed",
                "pct": "35%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Terbinafine",
        "route": "Oral Pill",
        "fullName": "Terbinafine (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Terbinafine",
            "Terbinafine (Oral Pill)",
            "terbinafine",
            "terbinafine (oral pill)",
            "terbinafine 250 MG Oral Tablet",
            "terbinafine 250 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "250 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Amoxicillin/Clavulanate",
        "route": "Oral Pill",
        "fullName": "Amoxicillin/Clavulanate (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Amoxicillin/Clavulanate",
            "Amoxicillin/Clavulanate (Oral Pill)",
            "Amoxicillin/Clavulanate (Oral)",
            "Augmentin",
            "amoxicillin 500 MG / clavulanate 125 MG Oral Tablet",
            "amoxicillin 500 mg / clavulanate 125 mg oral tablet",
            "amoxicillin 875 MG / clavulanate 125 MG Oral Tablet",
            "amoxicillin 875 mg / clavulanate 125 mg oral tablet",
            "amoxicillin/clavulanate",
            "amoxicillin/clavulanate (oral pill)",
            "amoxicillin/clavulanate (oral)",
            "augmentin"
        ],
        "dosages": [
            {
                "value": "875-125 mg",
                "pct": "65%"
            },
            {
                "value": "500-125 mg",
                "pct": "30%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "risperiDONE",
        "route": "Oral Liquid",
        "fullName": "risperiDONE (Oral Liquid)",
        "totalCount": 20,
        "searchTerms": [
            "risperiDONE",
            "risperiDONE (Oral Liquid)",
            "risperidone",
            "risperidone (oral liquid)",
            "risperidone 1 MG/ML Oral Solution",
            "risperidone 1 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "65%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "35%"
            },
            {
                "value": "Twice daily",
                "pct": "35%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Alogliptin/Pioglitazone",
        "route": "Oral Pill",
        "fullName": "Alogliptin/Pioglitazone (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Alogliptin/Pioglitazone",
            "Alogliptin/Pioglitazone (Oral Pill)",
            "alogliptin 12.5 MG / pioglitazone 15 MG Oral Tablet",
            "alogliptin 12.5 MG / pioglitazone 30 MG Oral Tablet",
            "alogliptin 12.5 MG / pioglitazone 45 MG Oral Tablet",
            "alogliptin 12.5 mg / pioglitazone 15 mg oral tablet",
            "alogliptin 12.5 mg / pioglitazone 30 mg oral tablet",
            "alogliptin 12.5 mg / pioglitazone 45 mg oral tablet",
            "alogliptin 25 MG / pioglitazone 30 MG Oral Tablet",
            "alogliptin 25 mg / pioglitazone 30 mg oral tablet",
            "alogliptin/pioglitazone",
            "alogliptin/pioglitazone (oral pill)"
        ],
        "dosages": [
            {
                "value": "12.5-15 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "60%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BACTRIM",
        "route": "Oral Pill",
        "fullName": "BACTRIM (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "BACTRIM",
            "BACTRIM (Oral Pill)",
            "bactrim",
            "bactrim (oral pill)",
            "sulfamethoxazole 400 MG / trimethoprim 80 MG Oral Tablet",
            "sulfamethoxazole 400 mg / trimethoprim 80 mg oral tablet",
            "sulfamethoxazole 800 MG / trimethoprim 160 MG Oral Tablet",
            "sulfamethoxazole 800 mg / trimethoprim 160 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "800-160 mg",
                "pct": "40%"
            },
            {
                "value": "400-80 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "40%"
            },
            {
                "value": "Once daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ENDOCET",
        "route": "Oral Pill",
        "fullName": "ENDOCET (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "ENDOCET",
            "ENDOCET (Oral Pill)",
            "acetaminophen 325 MG / oxycodone hydrochloride 10 MG Oral Tablet",
            "acetaminophen 325 MG / oxycodone hydrochloride 5 MG Oral Tablet",
            "acetaminophen 325 MG / oxycodone hydrochloride 7.5 MG Oral Tablet",
            "acetaminophen 325 mg / oxycodone hydrochloride 10 mg oral tablet",
            "acetaminophen 325 mg / oxycodone hydrochloride 5 mg oral tablet",
            "acetaminophen 325 mg / oxycodone hydrochloride 7.5 mg oral tablet",
            "endocet",
            "endocet (oral pill)"
        ],
        "dosages": [
            {
                "value": "325-10 mg",
                "pct": "65%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "40%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dexamethasone",
        "route": "Oral Pill",
        "fullName": "Dexamethasone (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Decadron",
            "Dexamethasone",
            "Dexamethasone (Oral Pill)",
            "Dexamethasone (Oral)",
            "decadron",
            "dexAMETHasone",
            "dexAMETHasone (Oral Pill)",
            "dexAMETHasone (Oral)",
            "dexamethasone",
            "dexamethasone (oral pill)",
            "dexamethasone (oral)",
            "dexamethasone 0.5 MG Oral Tablet",
            "dexamethasone 0.5 mg oral tablet",
            "dexamethasone 1.5 MG Oral Tablet",
            "dexamethasone 1.5 mg oral tablet",
            "dexamethasone 2 MG Oral Tablet",
            "dexamethasone 2 mg oral tablet",
            "dexamethasone 4 MG Oral Tablet",
            "dexamethasone 4 mg oral tablet",
            "dexamethasone 6 MG Oral Tablet",
            "dexamethasone 6 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M06.9",
                "description": "Rheumatoid arthritis, unspecified",
                "pct": "64%"
            }
        ]
    },
    {
        "name": "ATROVENT",
        "route": "Inhalant",
        "fullName": "ATROVENT (Inhalant)",
        "totalCount": 20,
        "searchTerms": [
            "200 ACTUAT ipratropium bromide 0.017 MG/ACTUAT Metered Dose Inhaler",
            "200 actuat ipratropium bromide 0.017 mg/actuat metered dose inhaler",
            "ATROVENT",
            "ATROVENT (Inhalant)",
            "atrovent",
            "atrovent (inhalant)"
        ],
        "dosages": [
            {
                "value": "17 mcg",
                "pct": "80%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Megestrol",
        "route": "Oral Pill",
        "fullName": "Megestrol (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "MEGESTROL",
            "MEGESTROL (Oral)",
            "Megestrol",
            "Megestrol (Oral Pill)",
            "Megestrol (Oral)",
            "megestrol",
            "megestrol (oral pill)",
            "megestrol (oral)",
            "megestrol acetate 20 MG Oral Tablet",
            "megestrol acetate 20 mg oral tablet",
            "megestrol acetate 40 MG Oral Tablet",
            "megestrol acetate 40 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "Twice daily",
                "pct": "45%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Aspirin/Caffeine/Dihydrocodeine",
        "route": "Oral Pill",
        "fullName": "Aspirin/Caffeine/Dihydrocodeine (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Aspirin/Caffeine/Dihydrocodeine",
            "Aspirin/Caffeine/Dihydrocodeine (Oral Pill)",
            "aspirin 356.4 MG / caffeine 30 MG / dihydrocodeine bitartrate 16 MG Oral Capsule",
            "aspirin 356.4 mg / caffeine 30 mg / dihydrocodeine bitartrate 16 mg oral capsule",
            "aspirin/caffeine/dihydrocodeine",
            "aspirin/caffeine/dihydrocodeine (oral pill)"
        ],
        "dosages": [
            {
                "value": "356.4-30-16 mg",
                "pct": "50%"
            },
            {
                "value": "81 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NURTEC",
        "route": "Oral Disintegrating",
        "fullName": "NURTEC (Oral Disintegrating)",
        "totalCount": 20,
        "searchTerms": [
            "NURTEC",
            "NURTEC (Oral Disintegrating)",
            "Rimegepant 75 MG Disintegrating Oral Tablet",
            "nurtec",
            "nurtec (oral disintegrating)",
            "rimegepant 75 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "75 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "50%"
            },
            {
                "value": "Once daily",
                "pct": "35%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G43.909",
                "description": "Migraine, unsp, not intractable, without status migrainosus",
                "pct": "53%"
            }
        ]
    },
    {
        "name": "Minoxidil",
        "route": "Oral Pill",
        "fullName": "Minoxidil (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "LONITEN",
            "Loniten",
            "MINOXIDIL",
            "MINOXIDIL (Oral)",
            "Minoxidil",
            "Minoxidil (Oral Pill)",
            "Minoxidil (Oral)",
            "loniten",
            "minoxidil",
            "minoxidil (oral pill)",
            "minoxidil (oral)",
            "minoxidil 2.5 MG Oral Tablet",
            "minoxidil 2.5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2.5 mg",
                "pct": "80%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            },
            {
                "value": "Twice daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "57%"
            }
        ]
    },
    {
        "name": "ALLEGRA",
        "route": "Oral Pill",
        "fullName": "ALLEGRA (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "ALLEGRA",
            "ALLEGRA (Oral Pill)",
            "allegra",
            "allegra (oral pill)",
            "fexofenadine hydrochloride 180 MG Oral Tablet",
            "fexofenadine hydrochloride 180 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "180 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Brimonidine/Brinzolamide",
        "route": "Ophthalmic",
        "fullName": "Brimonidine/Brinzolamide (Ophthalmic)",
        "totalCount": 20,
        "searchTerms": [
            "Brimonidine/Brinzolamide",
            "Brimonidine/Brinzolamide (Ophthalmic)",
            "brimonidine tartrate 2 MG/ML / brinzolamide 10 MG/ML Ophthalmic Suspension",
            "brimonidine tartrate 2 mg/ml / brinzolamide 10 mg/ml ophthalmic suspension",
            "brimonidine/brinzolamide",
            "brimonidine/brinzolamide (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "25%"
            },
            {
                "value": "Twice daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Loratadine/Pseudoephedrine XR",
        "route": "Oral Pill",
        "fullName": "Loratadine/Pseudoephedrine XR (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "12 HR loratadine 5 MG / pseudoephedrine sulfate 120 MG Extended Release Oral Tablet",
            "12 hr loratadine 5 mg / pseudoephedrine sulfate 120 mg extended release oral tablet",
            "24 HR loratadine 10 MG / pseudoephedrine sulfate 240 MG Extended Release Oral Tablet",
            "24 hr loratadine 10 mg / pseudoephedrine sulfate 240 mg extended release oral tablet",
            "Loratadine/Pseudoephedrine XR",
            "Loratadine/Pseudoephedrine XR (Oral Pill)",
            "loratadine/pseudoephedrine xr",
            "loratadine/pseudoephedrine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "35%"
            },
            {
                "value": "10-240 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ziprasidone",
        "route": "Oral Pill",
        "fullName": "Ziprasidone (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Ziprasidone",
            "Ziprasidone (Oral Pill)",
            "ziprasidone",
            "ziprasidone (oral pill)",
            "ziprasidone 20 MG Oral Capsule",
            "ziprasidone 20 mg oral capsule",
            "ziprasidone 40 MG Oral Capsule",
            "ziprasidone 40 mg oral capsule",
            "ziprasidone 60 MG Oral Capsule",
            "ziprasidone 60 mg oral capsule",
            "ziprasidone 80 MG Oral Capsule",
            "ziprasidone 80 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "80 mg",
                "pct": "35%"
            },
            {
                "value": "60 mg",
                "pct": "25%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "45%"
            },
            {
                "value": "Once daily",
                "pct": "35%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Fluconazole",
        "route": "Oral Pill",
        "fullName": "Fluconazole (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Diflucan",
            "Fluconazole",
            "Fluconazole (Oral Pill)",
            "Fluconazole (Oral)",
            "diflucan",
            "fluconazole",
            "fluconazole (Oral)",
            "fluconazole (oral pill)",
            "fluconazole (oral)",
            "fluconazole 100 MG Oral Tablet",
            "fluconazole 100 mg oral tablet",
            "fluconazole 150 MG Oral Tablet",
            "fluconazole 150 mg oral tablet",
            "fluconazole 200 MG Oral Tablet",
            "fluconazole 200 mg oral tablet",
            "fluconazole 50 MG Oral Tablet",
            "fluconazole 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "40%"
            },
            {
                "value": "200 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "95%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B37.9",
                "description": "Candidiasis, unspecified",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "levETIRAcetam",
        "route": "Oral Liquid",
        "fullName": "levETIRAcetam (Oral Liquid)",
        "totalCount": 20,
        "searchTerms": [
            "levETIRAcetam",
            "levETIRAcetam (Oral Liquid)",
            "levetiracetam",
            "levetiracetam (oral liquid)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "55%"
            }
        ]
    },
    {
        "name": "Amantadine",
        "route": "Oral Pill",
        "fullName": "Amantadine (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Amantadine",
            "Amantadine (Oral Pill)",
            "Amantadine (Oral)",
            "amantadine",
            "amantadine (oral pill)",
            "amantadine (oral)",
            "amantadine hydrochloride 100 MG Oral Capsule",
            "amantadine hydrochloride 100 MG Oral Tablet",
            "amantadine hydrochloride 100 mg oral capsule",
            "amantadine hydrochloride 100 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "70%"
            },
            {
                "value": "Once daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G20",
                "description": "Parkinson's disease",
                "pct": "79%"
            }
        ]
    },
    {
        "name": "Sotalol",
        "route": "Oral Pill",
        "fullName": "Sotalol (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Atrial Fibrillation sotalol hydrochloride 120 MG Oral Tablet",
            "Atrial Fibrillation sotalol hydrochloride 80 MG Oral Tablet",
            "Sotalol",
            "Sotalol (Oral Pill)",
            "Sotalol (Oral)",
            "atrial fibrillation sotalol hydrochloride 120 mg oral tablet",
            "atrial fibrillation sotalol hydrochloride 80 mg oral tablet",
            "sotalol",
            "sotalol (oral pill)",
            "sotalol (oral)"
        ],
        "dosages": [
            {
                "value": "80 mg",
                "pct": "65%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "70%"
            },
            {
                "value": "Once daily",
                "pct": "25%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "XIGDUO XR",
        "route": "Oral Pill",
        "fullName": "XIGDUO XR (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "24 HR dapagliflozin 10 MG / metformin hydrochloride 1000 MG Extended Release Oral Tablet",
            "24 HR dapagliflozin 5 MG / metformin hydrochloride 500 MG Extended Release Oral Tablet",
            "24 hr dapagliflozin 10 mg / metformin hydrochloride 1000 mg extended release oral tablet",
            "24 hr dapagliflozin 5 mg / metformin hydrochloride 500 mg extended release oral tablet",
            "XIGDUO",
            "XIGDUO XR",
            "XIGDUO XR (Oral Pill)",
            "XIGDUO XR (Oral)",
            "Xigduo XR",
            "Xigduo XR (Oral)",
            "xigduo",
            "xigduo xr",
            "xigduo xr (oral pill)",
            "xigduo xr (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "82%"
            }
        ]
    },
    {
        "name": "MYRBETRIQ",
        "route": "Oral Pill",
        "fullName": "MYRBETRIQ (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "MYRBETRIQ",
            "Myrbetriq",
            "Myrbetriq (Oral)",
            "myrbetriq",
            "myrbetriq (oral)"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "65%"
            },
            {
                "value": "50 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "88%"
            }
        ]
    },
    {
        "name": "Linagliptin",
        "route": "Oral Pill",
        "fullName": "Linagliptin (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "Linagliptin",
            "Linagliptin (Oral Pill)",
            "linagliptin",
            "linagliptin (oral pill)",
            "linagliptin 5 MG Oral Tablet",
            "linagliptin 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "carBAMazepine XR",
        "route": "Oral Pill",
        "fullName": "carBAMazepine XR (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "12 HR carbamazepine 100 MG Extended Release Oral Tablet",
            "12 HR carbamazepine 200 MG Extended Release Oral Capsule",
            "12 HR carbamazepine 300 MG Extended Release Oral Capsule",
            "12 hr carbamazepine 100 mg extended release oral tablet",
            "12 hr carbamazepine 200 mg extended release oral capsule",
            "12 hr carbamazepine 300 mg extended release oral capsule",
            "carBAMazepine XR",
            "carBAMazepine XR (Oral Pill)",
            "carbamazepine xr",
            "carbamazepine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "55%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DITROPAN XR",
        "route": "Oral Pill",
        "fullName": "DITROPAN XR (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "24 HR oxybutynin chloride 10 MG Extended Release Oral Tablet",
            "24 HR oxybutynin chloride 5 MG Extended Release Oral Tablet",
            "24 hr oxybutynin chloride 10 mg extended release oral tablet",
            "24 hr oxybutynin chloride 5 mg extended release oral tablet",
            "DITROPAN",
            "DITROPAN XR",
            "DITROPAN XR (Oral Pill)",
            "ditropan",
            "ditropan xr",
            "ditropan xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "65%"
            },
            {
                "value": "10 mg",
                "pct": "30%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CETIRIZINE HCL",
        "route": "Oral Pill",
        "fullName": "CETIRIZINE HCL (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "CETIRIZINE HCL",
            "CETIRIZINE HCL (Oral)",
            "Cetirizine HCL",
            "Cetirizine HCL (Oral)",
            "Cetirizine HCl",
            "Cetirizine HCl (Oral)",
            "KLS Aller-Tec",
            "Zyrtec",
            "Zyrtec Allergy",
            "cetirizine HCl",
            "cetirizine HCl (Oral)",
            "cetirizine hcl",
            "cetirizine hcl (oral)",
            "kls aller-tec",
            "zyrtec",
            "zyrtec allergy"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "glipizide er",
        "route": "Oral Pill",
        "fullName": "glipizide er (Oral Pill)",
        "totalCount": 20,
        "searchTerms": [
            "GLIPIZIDE ER",
            "GLIPIZIDE ER (Oral)",
            "Glipizide ER",
            "Glipizide ER (Oral)",
            "Glucotrol",
            "Glucotrol XL",
            "glipiZIDE ER",
            "glipiZIDE ER (Oral)",
            "glipizide er",
            "glipizide er (oral)",
            "glucotrol",
            "glucotrol xl"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "45%"
            },
            {
                "value": "5 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "65%"
            }
        ],
        "adminNotes": [
            {
                "value": "Extended release",
                "pct": "42%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Vitamin D3 2000u",
        "route": "Oral Pill",
        "fullName": "Vitamin D3 2000u (Oral Pill)",
        "totalCount": 20,
        "searchTerms": ["Vitamin D3 2000u", "vitamin d3 2000u"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Famotidine/Ibuprofen",
        "route": "Oral Pill",
        "fullName": "Famotidine/Ibuprofen (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "Famotidine/Ibuprofen",
            "Famotidine/Ibuprofen (Oral Pill)",
            "famotidine 26.6 MG / ibuprofen 800 MG Oral Tablet",
            "famotidine 26.6 mg / ibuprofen 800 mg oral tablet",
            "famotidine/ibuprofen",
            "famotidine/ibuprofen (oral pill)"
        ],
        "dosages": [
            {
                "value": "26.6-800 mg",
                "pct": "53%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Aspirin/Omeprazole",
        "route": "Oral Pill",
        "fullName": "Aspirin/Omeprazole (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "Aspirin/Omeprazole",
            "Aspirin/Omeprazole (Oral Pill)",
            "aspirin 81 MG / omeprazole 40 MG Delayed Release Oral Tablet",
            "aspirin 81 mg / omeprazole 40 mg delayed release oral tablet",
            "aspirin/omeprazole",
            "aspirin/omeprazole (oral pill)"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "32%"
            },
            {
                "value": "81-40 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "68%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RENVELA",
        "route": "Oral Pill",
        "fullName": "RENVELA (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "RENVELA",
            "RENVELA (Oral Pill)",
            "renvela",
            "renvela (oral pill)",
            "sevelamer carbonate 800 MG Oral Tablet",
            "sevelamer carbonate 800 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "800 mg",
                "pct": "95%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "58%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Carvedilol XR",
        "route": "Oral Pill",
        "fullName": "Carvedilol XR (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "24 HR carvedilol phosphate 10 MG Extended Release Oral Capsule",
            "24 HR carvedilol phosphate 20 MG Extended Release Oral Capsule",
            "24 HR carvedilol phosphate 80 MG Extended Release Oral Capsule",
            "24 hr carvedilol phosphate 10 mg extended release oral capsule",
            "24 hr carvedilol phosphate 20 mg extended release oral capsule",
            "24 hr carvedilol phosphate 80 mg extended release oral capsule",
            "Carvedilol XR",
            "Carvedilol XR (Oral Pill)",
            "carvedilol xr",
            "carvedilol xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "12.5 mg",
                "pct": "26%"
            },
            {
                "value": "10 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "53%"
            },
            {
                "value": "Once daily",
                "pct": "37%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Methadone",
        "route": "Oral Liquid",
        "fullName": "Methadone (Oral Liquid)",
        "totalCount": 19,
        "searchTerms": [
            "Methadone",
            "Methadone (Oral Liquid)",
            "methadone",
            "methadone (oral liquid)",
            "methadone hydrochloride 1 MG/ML Oral Solution",
            "methadone hydrochloride 1 mg/ml oral solution",
            "methadone hydrochloride 10 MG/ML Oral Solution",
            "methadone hydrochloride 10 mg/ml oral solution",
            "methadone hydrochloride 2 MG/ML Oral Solution",
            "methadone hydrochloride 2 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "58%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "68%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VALIUM",
        "route": "Oral Pill",
        "fullName": "VALIUM (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "VALIUM",
            "VALIUM (Oral Pill)",
            "diazepam 10 MG Oral Tablet",
            "diazepam 10 mg oral tablet",
            "diazepam 2 MG Oral Tablet",
            "diazepam 2 mg oral tablet",
            "diazepam 5 MG Oral Tablet",
            "diazepam 5 mg oral tablet",
            "valium",
            "valium (oral pill)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "47%"
            },
            {
                "value": "2 mg",
                "pct": "37%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PrednisoLONE/Sulfacetamide",
        "route": "Ophthalmic",
        "fullName": "PrednisoLONE/Sulfacetamide (Ophthalmic)",
        "totalCount": 19,
        "searchTerms": [
            "PrednisoLONE/Sulfacetamide",
            "PrednisoLONE/Sulfacetamide (Ophthalmic)",
            "prednisolone acetate 0.002 MG/MG / sulfacetamide sodium 0.1 MG/MG Ophthalmic Ointment",
            "prednisolone acetate 0.002 mg/mg / sulfacetamide sodium 0.1 mg/mg ophthalmic ointment",
            "prednisolone acetate 2 MG/ML / sulfacetamide sodium 100 MG/ML Ophthalmic Suspension",
            "prednisolone acetate 2 mg/ml / sulfacetamide sodium 100 mg/ml ophthalmic suspension",
            "prednisolone sodium phosphate 2.5 MG/ML / sulfacetamide sodium 100 MG/ML Ophthalmic Solution",
            "prednisolone sodium phosphate 2.5 mg/ml / sulfacetamide sodium 100 mg/ml ophthalmic solution",
            "prednisolone/sulfacetamide",
            "prednisolone/sulfacetamide (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ADDERALL",
        "route": "Oral Pill",
        "fullName": "ADDERALL (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "ADDERALL",
            "ADDERALL (Oral Pill)",
            "adderall",
            "adderall (oral pill)",
            "amphetamine aspartate 1.25 MG / amphetamine sulfate 1.25 MG / dextroamphetamine saccharate 1.25 MG / dextroamphetamine sulfate 1.25 MG Oral Tablet",
            "amphetamine aspartate 1.25 mg / amphetamine sulfate 1.25 mg / dextroamphetamine saccharate 1.25 mg / dextroamphetamine sulfate 1.25 mg oral tablet",
            "amphetamine aspartate 1.875 MG / amphetamine sulfate 1.875 MG / dextroamphetamine saccharate 1.875 MG / dextroamphetamine sulfate 1.875 MG Oral Tablet",
            "amphetamine aspartate 1.875 mg / amphetamine sulfate 1.875 mg / dextroamphetamine saccharate 1.875 mg / dextroamphetamine sulfate 1.875 mg oral tablet",
            "amphetamine aspartate 2.5 MG / amphetamine sulfate 2.5 MG / dextroamphetamine saccharate 2.5 MG / dextroamphetamine sulfate 2.5 MG Oral Tablet",
            "amphetamine aspartate 2.5 mg / amphetamine sulfate 2.5 mg / dextroamphetamine saccharate 2.5 mg / dextroamphetamine sulfate 2.5 mg oral tablet",
            "amphetamine aspartate 3.75 MG / amphetamine sulfate 3.75 MG / dextroamphetamine saccharate 3.75 MG / dextroamphetamine sulfate 3.75 MG Oral Tablet",
            "amphetamine aspartate 3.75 mg / amphetamine sulfate 3.75 mg / dextroamphetamine saccharate 3.75 mg / dextroamphetamine sulfate 3.75 mg oral tablet",
            "amphetamine aspartate 5 MG / amphetamine sulfate 5 MG / dextroamphetamine saccharate 5 MG / dextroamphetamine sulfate 5 MG Oral Tablet",
            "amphetamine aspartate 5 mg / amphetamine sulfate 5 mg / dextroamphetamine saccharate 5 mg / dextroamphetamine sulfate 5 mg oral tablet",
            "amphetamine aspartate 7.5 MG / amphetamine sulfate 7.5 MG / dextroamphetamine saccharate 7.5 MG / dextroamphetamine sulfate 7.5 MG Oral Tablet",
            "amphetamine aspartate 7.5 mg / amphetamine sulfate 7.5 mg / dextroamphetamine saccharate 7.5 mg / dextroamphetamine sulfate 7.5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "42%"
            },
            {
                "value": "Once daily",
                "pct": "32%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "UBRELVY",
        "route": "Oral Pill",
        "fullName": "UBRELVY (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "UBRELVY",
            "UBRELVY (Oral Pill)",
            "Ubrelvy",
            "Ubrelvy (Oral)",
            "ubrelvy",
            "ubrelvy (oral pill)",
            "ubrelvy (oral)",
            "ubrogepant 100 MG Oral Tablet",
            "ubrogepant 100 mg oral tablet",
            "ubrogepant 50 MG Oral Tablet",
            "ubrogepant 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "74%"
            },
            {
                "value": "50 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G43.909",
                "description": "Migraine, unsp, not intractable, without status migrainosus",
                "pct": "79%"
            }
        ]
    },
    {
        "name": "Ketotifen",
        "route": "Ophthalmic",
        "fullName": "Ketotifen (Ophthalmic)",
        "totalCount": 19,
        "searchTerms": [
            "Alaway",
            "Ketotifen",
            "Ketotifen (Ophthalmic)",
            "alaway",
            "ketotifen",
            "ketotifen (ophthalmic)",
            "ketotifen 0.25 MG/ML Ophthalmic Solution",
            "ketotifen 0.25 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H10.10",
                "description": "Acute atopic conjunctivitis, unspecified eye",
                "pct": "47%"
            }
        ]
    },
    {
        "name": "Spironolactone",
        "route": "Oral Liquid",
        "fullName": "Spironolactone (Oral Liquid)",
        "totalCount": 19,
        "searchTerms": [
            "Spironolactone",
            "Spironolactone (Oral Liquid)",
            "spironolactone",
            "spironolactone (oral liquid)",
            "spironolactone 5 MG/ML Oral Suspension",
            "spironolactone 5 mg/ml oral suspension"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SOOTHE LUBRICANT EYE DROPS",
        "route": "Ophthalmic",
        "fullName": "SOOTHE LUBRICANT EYE DROPS (Ophthalmic)",
        "totalCount": 19,
        "searchTerms": [
            "SOOTHE LUBRICANT EYE DROPS",
            "SOOTHE LUBRICANT EYE DROPS (Ophthalmic)",
            "glycerin 6 MG/ML / propylene glycol 6 MG/ML Ophthalmic Solution",
            "glycerin 6 mg/ml / propylene glycol 6 mg/ml ophthalmic solution",
            "soothe lubricant eye drops",
            "soothe lubricant eye drops (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "58%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H04.123",
                "description": "Dry eye syndrome of bilateral lacrimal glands",
                "pct": "73%"
            }
        ]
    },
    {
        "name": "Eszopiclone",
        "route": "Oral Pill",
        "fullName": "Eszopiclone (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "Eszopiclone",
            "Eszopiclone (Oral Pill)",
            "Eszopiclone (Oral)",
            "eszopiclone",
            "eszopiclone (oral pill)",
            "eszopiclone (oral)",
            "eszopiclone 1 MG Oral Tablet",
            "eszopiclone 1 mg oral tablet",
            "eszopiclone 2 MG Oral Tablet",
            "eszopiclone 2 mg oral tablet",
            "eszopiclone 3 MG Oral Tablet",
            "eszopiclone 3 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "3 mg",
                "pct": "47%"
            },
            {
                "value": "2 mg",
                "pct": "37%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "53%"
            },
            {
                "value": "At bedtime",
                "pct": "32%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "Breztri",
        "route": "Inhalant",
        "fullName": "Breztri (Inhalant)",
        "totalCount": 19,
        "searchTerms": [
            "BREZTRI",
            "BREZTRI (Inhalant)",
            "Breztri",
            "breztri",
            "breztri (inhalant)"
        ],
        "dosages": [
            {
                "value": "160-4.8-9 mcg",
                "pct": "79%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "47%"
            },
            {
                "code": "J45",
                "description": "Asthma",
                "pct": "33%"
            }
        ]
    },
    {
        "name": "ASPERCREME",
        "route": "Topical",
        "fullName": "ASPERCREME (Topical)",
        "totalCount": 19,
        "searchTerms": [
            "ASPERCREME",
            "ASPERCREME (Topical)",
            "aspercreme",
            "aspercreme (topical)",
            "trolamine salicylate 100 MG/ML Topical Cream",
            "trolamine salicylate 100 MG/ML Topical Lotion",
            "trolamine salicylate 100 mg/ml topical cream",
            "trolamine salicylate 100 mg/ml topical lotion"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Four times daily",
                "pct": "32%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Biotin",
        "route": "Oral Pill",
        "fullName": "Biotin (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "BIOTIN",
            "Biotin",
            "Biotin (Oral Pill)",
            "biotin",
            "biotin (oral pill)",
            "biotin 1 MG Oral Tablet",
            "biotin 1 mg oral tablet",
            "biotin 10 MG Oral Tablet",
            "biotin 10 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "epinephrine",
        "route": "Injectable",
        "fullName": "epinephrine (Injectable)",
        "totalCount": 19,
        "searchTerms": [
            "EPINEPHrine",
            "EPINEPHrine (Injectable)",
            "epinephrine",
            "epinephrine (injectable)"
        ],
        "dosages": [
            {
                "value": "0.3 mg",
                "pct": "37%"
            },
            {
                "value": "0.032 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "T78.2",
                "description": "Anaphylactic shock, unspecified",
                "pct": "33%"
            },
            {
                "code": "T78.2XXA",
                "description": "Anaphylactic shock, unspecified, initial encounter",
                "pct": "28%"
            }
        ]
    },
    {
        "name": "Methylphenidate",
        "route": "Oral Pill",
        "fullName": "Methylphenidate (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "Methylphenidate",
            "Methylphenidate (Oral Pill)",
            "Methylphenidate (Oral)",
            "methylphenidate",
            "methylphenidate (oral pill)",
            "methylphenidate (oral)",
            "methylphenidate hydrochloride 10 MG Oral Tablet",
            "methylphenidate hydrochloride 10 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "37%"
            },
            {
                "value": "20 mg",
                "pct": "26%"
            },
            {
                "value": "10 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "47%"
            },
            {
                "value": "Twice daily",
                "pct": "32%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F90.9",
                "description": "Attention-deficit hyperactivity disorder, unspecified type",
                "pct": "86%"
            }
        ]
    },
    {
        "name": "INGREZZA",
        "route": "Oral Pill",
        "fullName": "INGREZZA (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "INGREZZA",
            "INGREZZA (Oral Pill)",
            "ingrezza",
            "ingrezza (oral pill)",
            "valbenazine 40 MG Oral Capsule",
            "valbenazine 40 mg oral capsule",
            "valbenazine 80 MG Oral Capsule",
            "valbenazine 80 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "80 mg",
                "pct": "47%"
            },
            {
                "value": "40 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Vitamin B-12 - Supplement",
        "route": "Oral Pill",
        "fullName": "Vitamin B-12 - Supplement (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "VITAMIN B-12 - Supplement",
            "VITAMIN B-12 - Supplement (Oral)",
            "Vitamin B-12 - Supplement",
            "Vitamin B-12 - Supplement (Oral)",
            "vitamin B-12 - Supplement",
            "vitamin B-12 - Supplement (Oral)",
            "vitamin b-12 - supplement",
            "vitamin b-12 - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "1000 mcg",
                "pct": "58%"
            },
            {
                "value": "500 mcg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "95%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D51.9",
                "description": "Vitamin B12 deficiency anemia, unspecified",
                "pct": "84%"
            },
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "47%"
            }
        ]
    },
    {
        "name": "BUSPIRONE HCL",
        "route": "Oral Pill",
        "fullName": "BUSPIRONE HCL (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "BUSPIRONE HCL",
            "BUSPIRONE HCL (Oral)",
            "Buspar",
            "Buspirone HCL",
            "Buspirone HCL (Oral)",
            "Buspirone HCl",
            "Buspirone HCl (Oral)",
            "busPIRone HCl",
            "busPIRone HCl (Oral)",
            "buspar",
            "buspirone HCL",
            "buspirone hcl",
            "buspirone hcl (oral)"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "53%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.9",
                "description": "Anxiety disorder, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Paliperidone XR",
        "route": "Oral Pill",
        "fullName": "Paliperidone XR (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "24 HR paliperidone 3 MG Extended Release Oral Tablet",
            "24 HR paliperidone 6 MG Extended Release Oral Tablet",
            "24 HR paliperidone 9 MG Extended Release Oral Tablet",
            "24 hr paliperidone 3 mg extended release oral tablet",
            "24 hr paliperidone 6 mg extended release oral tablet",
            "24 hr paliperidone 9 mg extended release oral tablet",
            "Paliperidone XR",
            "Paliperidone XR (Oral Pill)",
            "paliperidone xr",
            "paliperidone xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "9 mg",
                "pct": "37%"
            },
            {
                "value": "6 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "84%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Metformin ER",
        "route": "Oral Pill",
        "fullName": "Metformin ER (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "Fortamet",
            "GLUCOPHAGE XR",
            "Glucophage XR",
            "Metformin ER",
            "Metformin ER (Oral)",
            "fortamet",
            "glucophage xr",
            "metFORMIN ER",
            "metFORMIN ER (Oral)",
            "metformin er",
            "metformin er (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "58%"
            },
            {
                "value": "750 mg",
                "pct": "37%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "68%"
            },
            {
                "value": "Twice daily",
                "pct": "26%"
            }
        ],
        "adminNotes": [
            {
                "value": "Extended release",
                "pct": "37%"
            },
            {
                "value": "Take with breakfast",
                "pct": "32%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "95%"
            }
        ]
    },
    {
        "name": "MULTAQ",
        "route": "Oral Pill",
        "fullName": "MULTAQ (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "MULTAQ",
            "MULTAQ (Oral Pill)",
            "Multaq",
            "Multaq (Oral)",
            "dronedarone 400 MG Oral Tablet",
            "dronedarone 400 mg oral tablet",
            "multaq",
            "multaq (oral pill)",
            "multaq (oral)"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "63%"
            },
            {
                "value": "Once daily",
                "pct": "37%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ibuprofen/Pseudoephedrine",
        "route": "Oral Pill",
        "fullName": "Ibuprofen/Pseudoephedrine (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "Ibuprofen/Pseudoephedrine",
            "Ibuprofen/Pseudoephedrine (Oral Pill)",
            "ibuprofen 200 MG / pseudoephedrine hydrochloride 30 MG Oral Capsule",
            "ibuprofen 200 MG / pseudoephedrine hydrochloride 30 MG Oral Tablet",
            "ibuprofen 200 mg / pseudoephedrine hydrochloride 30 mg oral capsule",
            "ibuprofen 200 mg / pseudoephedrine hydrochloride 30 mg oral tablet",
            "ibuprofen/pseudoephedrine",
            "ibuprofen/pseudoephedrine (oral pill)"
        ],
        "dosages": [
            {
                "value": "200-30 mg",
                "pct": "53%"
            },
            {
                "value": "600 mg",
                "pct": "32%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ULORIC",
        "route": "Oral Pill",
        "fullName": "ULORIC (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "ULORIC",
            "ULORIC (Oral Pill)",
            "febuxostat 40 MG Oral Tablet",
            "febuxostat 40 mg oral tablet",
            "febuxostat 80 MG Oral Tablet",
            "febuxostat 80 mg oral tablet",
            "uloric",
            "uloric (oral pill)"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "74%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TIROSINT",
        "route": "Oral Pill",
        "fullName": "TIROSINT (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "TIROSINT",
            "TIROSINT (Oral Pill)",
            "levothyroxine sodium 0.175 MG Oral Capsule",
            "levothyroxine sodium 0.175 mg oral capsule",
            "levothyroxine sodium 0.2 MG Oral Capsule",
            "levothyroxine sodium 0.2 mg oral capsule",
            "tirosint",
            "tirosint (oral pill)"
        ],
        "dosages": [
            {
                "value": "0.2 mg",
                "pct": "26%"
            },
            {
                "value": "0.175 mg",
                "pct": "26%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "58%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MUCINEX D XR",
        "route": "Oral Pill",
        "fullName": "MUCINEX D XR (Oral Pill)",
        "totalCount": 19,
        "searchTerms": [
            "12 HR guaifenesin 1200 MG / pseudoephedrine hydrochloride 120 MG Extended Release Oral Tablet",
            "12 HR guaifenesin 600 MG / pseudoephedrine hydrochloride 60 MG Extended Release Oral Tablet",
            "12 hr guaifenesin 1200 mg / pseudoephedrine hydrochloride 120 mg extended release oral tablet",
            "12 hr guaifenesin 600 mg / pseudoephedrine hydrochloride 60 mg extended release oral tablet",
            "MUCINEX D",
            "MUCINEX D XR",
            "MUCINEX D XR (Oral Pill)",
            "mucinex d",
            "mucinex d xr",
            "mucinex d xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "600-60 mg",
                "pct": "53%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "32%"
            },
            {
                "value": "Twice daily",
                "pct": "26%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Metformin 500",
        "route": "Oral Pill",
        "fullName": "Metformin 500 (Oral Pill)",
        "totalCount": 19,
        "searchTerms": ["Metformin 500", "metformin 500"],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "68%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "68%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "REGLAN",
        "route": "Oral Pill",
        "fullName": "REGLAN (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "REGLAN",
            "REGLAN (Oral Pill)",
            "metoclopramide 10 MG Oral Tablet",
            "metoclopramide 10 mg oral tablet",
            "metoclopramide 5 MG Oral Tablet",
            "metoclopramide 5 mg oral tablet",
            "reglan",
            "reglan (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "56%"
            },
            {
                "value": "5 mg",
                "pct": "39%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "39%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "GEODON",
        "route": "Oral Pill",
        "fullName": "GEODON (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "GEODON",
            "GEODON (Oral Pill)",
            "geodon",
            "geodon (oral pill)",
            "ziprasidone 20 MG Oral Capsule",
            "ziprasidone 20 mg oral capsule",
            "ziprasidone 40 MG Oral Capsule",
            "ziprasidone 40 mg oral capsule",
            "ziprasidone 60 MG Oral Capsule",
            "ziprasidone 60 mg oral capsule",
            "ziprasidone 80 MG Oral Capsule",
            "ziprasidone 80 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "Twice daily",
                "pct": "28%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NARCAN",
        "route": "Nasal",
        "fullName": "NARCAN (Nasal)",
        "totalCount": 18,
        "searchTerms": [
            "NARCAN",
            "NARCAN (Nasal)",
            "Narcan",
            "naloxone hydrochloride 20 MG/ML Nasal Spray",
            "naloxone hydrochloride 20 mg/ml nasal spray",
            "naloxone hydrochloride 40 MG/ML Nasal Spray",
            "naloxone hydrochloride 40 mg/ml nasal spray",
            "narcan",
            "narcan (nasal)"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "56%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "lamoTRIgine XR",
        "route": "Oral Pill",
        "fullName": "lamoTRIgine XR (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "24 HR lamotrigine 250 MG Extended Release Oral Tablet",
            "24 HR lamotrigine 300 MG Extended Release Oral Tablet",
            "24 hr lamotrigine 250 mg extended release oral tablet",
            "24 hr lamotrigine 300 mg extended release oral tablet",
            "lamoTRIgine XR",
            "lamoTRIgine XR (Oral Pill)",
            "lamotrigine xr",
            "lamotrigine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "56%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Atenolol/Chlorthalidone",
        "route": "Oral Pill",
        "fullName": "Atenolol/Chlorthalidone (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "Atenolol/Chlorthalidone",
            "Atenolol/Chlorthalidone (Oral Pill)",
            "atenolol 100 MG / chlorthalidone 25 MG Oral Tablet",
            "atenolol 100 mg / chlorthalidone 25 mg oral tablet",
            "atenolol 50 MG / chlorthalidone 25 MG Oral Tablet",
            "atenolol 50 mg / chlorthalidone 25 mg oral tablet",
            "atenolol/chlorthalidone",
            "atenolol/chlorthalidone (oral pill)"
        ],
        "dosages": [
            {
                "value": "100-25 mg",
                "pct": "67%"
            },
            {
                "value": "50-25 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Sennosides, USP",
        "route": "Chewable",
        "fullName": "Sennosides, USP (Chewable)",
        "totalCount": 18,
        "searchTerms": [
            "Sennosides, USP",
            "Sennosides, USP (Chewable)",
            "sennosides, USP 8.6 MG Chewable Tablet",
            "sennosides, usp",
            "sennosides, usp (chewable)",
            "sennosides, usp 8.6 mg chewable tablet"
        ],
        "dosages": [
            {
                "value": "8.6 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "44%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Trihexyphenidyl",
        "route": "Oral Pill",
        "fullName": "Trihexyphenidyl (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "Trihexyphenidyl",
            "Trihexyphenidyl (Oral Pill)",
            "Trihexyphenidyl (Oral)",
            "trihexyphenidyl",
            "trihexyphenidyl (oral pill)",
            "trihexyphenidyl (oral)",
            "trihexyphenidyl hydrochloride 2 MG Oral Tablet",
            "trihexyphenidyl hydrochloride 2 mg oral tablet",
            "trihexyphenidyl hydrochloride 5 MG Oral Tablet",
            "trihexyphenidyl hydrochloride 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "50%"
            },
            {
                "value": "5 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "44%"
            },
            {
                "value": "Twice daily",
                "pct": "28%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cholecalciferol",
        "route": "Oral Liquid",
        "fullName": "Cholecalciferol (Oral Liquid)",
        "totalCount": 18,
        "searchTerms": [
            "Cholecalciferol",
            "Cholecalciferol (Oral Liquid)",
            "cholecalciferol",
            "cholecalciferol (oral liquid)",
            "cholecalciferol 10000 UNT/ML Oral Solution",
            "cholecalciferol 10000 unt/ml oral solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PURELAX",
        "route": "Oral Solution Powder",
        "fullName": "PURELAX (Oral Solution Powder)",
        "totalCount": 18,
        "searchTerms": [
            "PURELAX",
            "PURELAX (Oral Solution Powder)",
            "polyethylene glycol 3350 17000 MG Powder for Oral Solution",
            "polyethylene glycol 3350 17000 mg powder for oral solution",
            "purelax",
            "purelax (oral solution powder)"
        ],
        "dosages": [
            {
                "value": "17 g",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OxyCONTIN XR",
        "route": "Oral Pill",
        "fullName": "OxyCONTIN XR (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "Abuse-Deterrent 12 HR oxycodone hydrochloride 10 MG Extended Release Oral Tablet",
            "Abuse-Deterrent 12 HR oxycodone hydrochloride 15 MG Extended Release Oral Tablet",
            "Abuse-Deterrent 12 HR oxycodone hydrochloride 20 MG Extended Release Oral Tablet",
            "Abuse-Deterrent 12 HR oxycodone hydrochloride 30 MG Extended Release Oral Tablet",
            "Abuse-Deterrent 12 HR oxycodone hydrochloride 60 MG Extended Release Oral Tablet",
            "OXYCONTIN",
            "OxyCONTIN XR",
            "OxyCONTIN XR (Oral Pill)",
            "abuse-deterrent 12 hr oxycodone hydrochloride 10 mg extended release oral tablet",
            "abuse-deterrent 12 hr oxycodone hydrochloride 15 mg extended release oral tablet",
            "abuse-deterrent 12 hr oxycodone hydrochloride 20 mg extended release oral tablet",
            "abuse-deterrent 12 hr oxycodone hydrochloride 30 mg extended release oral tablet",
            "abuse-deterrent 12 hr oxycodone hydrochloride 60 mg extended release oral tablet",
            "oxycontin",
            "oxycontin xr",
            "oxycontin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "44%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Eplerenone",
        "route": "Oral Pill",
        "fullName": "Eplerenone (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "EPLERENONE",
            "EPLERENONE (Oral)",
            "Eplerenone",
            "Eplerenone (Oral Pill)",
            "Eplerenone (Oral)",
            "Inspra",
            "eplerenone",
            "eplerenone (oral pill)",
            "eplerenone (oral)",
            "eplerenone 25 MG Oral Tablet",
            "eplerenone 25 mg oral tablet",
            "eplerenone 50 MG Oral Tablet",
            "eplerenone 50 mg oral tablet",
            "inspra"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "67%"
            },
            {
                "value": "50 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "69%"
            }
        ]
    },
    {
        "name": "LOTREL",
        "route": "Oral Pill",
        "fullName": "LOTREL (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "LOTREL",
            "LOTREL (Oral Pill)",
            "amlodipine 10 MG / benazepril hydrochloride 20 MG Oral Capsule",
            "amlodipine 10 MG / benazepril hydrochloride 40 MG Oral Capsule",
            "amlodipine 10 mg / benazepril hydrochloride 20 mg oral capsule",
            "amlodipine 10 mg / benazepril hydrochloride 40 mg oral capsule",
            "amlodipine 5 MG / benazepril hydrochloride 10 MG Oral Capsule",
            "amlodipine 5 MG / benazepril hydrochloride 20 MG Oral Capsule",
            "amlodipine 5 MG / benazepril hydrochloride 40 MG Oral Capsule",
            "amlodipine 5 mg / benazepril hydrochloride 10 mg oral capsule",
            "amlodipine 5 mg / benazepril hydrochloride 20 mg oral capsule",
            "amlodipine 5 mg / benazepril hydrochloride 40 mg oral capsule",
            "lotrel",
            "lotrel (oral pill)"
        ],
        "dosages": [
            {
                "value": "10-40 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MIEBO",
        "route": "Ophthalmic",
        "fullName": "MIEBO (Ophthalmic)",
        "totalCount": 18,
        "searchTerms": [
            "MIEBO",
            "MIEBO (Ophthalmic)",
            "Miebo",
            "Miebo (Ophthalmic)",
            "miebo",
            "miebo (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Four times daily",
                "pct": "44%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H04.123",
                "description": "Dry eye syndrome of bilateral lacrimal glands",
                "pct": "78%"
            }
        ]
    },
    {
        "name": "FEROCON",
        "route": "Oral Pill",
        "fullName": "FEROCON (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "FEROCON",
            "FEROCON (Oral Pill)",
            "ascorbic acid 75 MG / ferrous fumarate 333 MG / folic acid 0.5 MG / liver stomach concentrate 240 MG / vitamin B12 0.015 MG Oral Capsule",
            "ascorbic acid 75 mg / ferrous fumarate 333 mg / folic acid 0.5 mg / liver stomach concentrate 240 mg / vitamin b12 0.015 mg oral capsule",
            "ferocon",
            "ferocon (oral pill)"
        ],
        "dosages": [
            {
                "value": "75-333-0.5-240-0.015 mg",
                "pct": "39%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "61%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "GlipiZIDE/metFORMIN",
        "route": "Oral Pill",
        "fullName": "GlipiZIDE/metFORMIN (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "GlipiZIDE/metFORMIN",
            "GlipiZIDE/metFORMIN (Oral Pill)",
            "Glipizide/Metformin",
            "Glipizide/Metformin (Oral)",
            "glipiZIDE/metFORMIN",
            "glipiZIDE/metFORMIN (Oral Pill)",
            "glipizide 2.5 MG / metformin hydrochloride 250 MG Oral Tablet",
            "glipizide 2.5 MG / metformin hydrochloride 500 MG Oral Tablet",
            "glipizide 2.5 mg / metformin hydrochloride 250 mg oral tablet",
            "glipizide 2.5 mg / metformin hydrochloride 500 mg oral tablet",
            "glipizide/metformin",
            "glipizide/metformin (oral pill)",
            "glipizide/metformin (oral)"
        ],
        "dosages": [
            {
                "value": "5-500 mg",
                "pct": "44%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "61%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SENNOSIDES",
        "route": "Oral Pill",
        "fullName": "SENNOSIDES (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "SENNOSIDES",
            "Senna",
            "Sennosides",
            "Sennosides (Oral)",
            "Senokot",
            "senna",
            "sennosides",
            "sennosides (Oral)",
            "sennosides (oral)",
            "senokot"
        ],
        "dosages": [
            {
                "value": "8.6 mg",
                "pct": "94%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Bayer Low Dose Aspirin Regimen",
        "route": "Oral Pill",
        "fullName": "Bayer Low Dose Aspirin Regimen (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "Bayer Low Dose Aspirin Regimen",
            "Bayer Low Dose Aspirin Regimen (Oral)",
            "bayer low dose aspirin regimen",
            "bayer low dose aspirin regimen (oral)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [
            {
                "value": "Pain reliever",
                "pct": "78%"
            },
            {
                "value": "NSAID",
                "pct": "72%"
            },
            {
                "value": "Enteric coated tablets",
                "pct": "72%"
            },
            {
                "value": "Safety coated",
                "pct": "39%"
            }
        ],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "56%"
            }
        ]
    },
    {
        "name": "HumuLIN",
        "route": "Injectable",
        "fullName": "HumuLIN (Injectable)",
        "totalCount": 18,
        "searchTerms": [
            "3 ML insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Pen Injector",
            "3 ml insulin isophane, human 70 unt/ml / insulin, regular, human 30 unt/ml pen injector",
            "HUMULIN",
            "HumuLIN",
            "HumuLIN (Injectable)",
            "humulin",
            "humulin (injectable)",
            "insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Injectable Suspension",
            "insulin isophane, human 70 unt/ml / insulin, regular, human 30 unt/ml injectable suspension"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "39%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MAG-OX",
        "route": "Oral Pill",
        "fullName": "MAG-OX (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "MAG-OX",
            "MAG-OX (Oral Pill)",
            "MAG-OX 400",
            "Mag-Ox",
            "mag-ox",
            "mag-ox (oral pill)",
            "mag-ox 400",
            "magnesium oxide 400 MG Oral Tablet",
            "magnesium oxide 400 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "61%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "GRALISE",
        "route": "Oral Pill",
        "fullName": "GRALISE (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "GRALISE",
            "GRALISE (Oral Pill)",
            "Once-Daily gabapentin 300 MG Oral Tablet",
            "Once-Daily gabapentin 600 MG Oral Tablet",
            "gralise",
            "gralise (oral pill)",
            "once-daily gabapentin 300 mg oral tablet",
            "once-daily gabapentin 600 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "61%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "39%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PRESTALIA",
        "route": "Oral Pill",
        "fullName": "PRESTALIA (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "PRESTALIA",
            "PRESTALIA (Oral Pill)",
            "amlodipine 10 MG / perindopril arginine 14 MG Oral Tablet",
            "amlodipine 10 mg / perindopril arginine 14 mg oral tablet",
            "amlodipine 2.5 MG / perindopril arginine 3.5 MG Oral Tablet",
            "amlodipine 2.5 mg / perindopril arginine 3.5 mg oral tablet",
            "amlodipine 5 MG / perindopril arginine 7 MG Oral Tablet",
            "amlodipine 5 mg / perindopril arginine 7 mg oral tablet",
            "prestalia",
            "prestalia (oral pill)"
        ],
        "dosages": [
            {
                "value": "2.5-3.5 mg",
                "pct": "33%"
            },
            {
                "value": "10-14 mg",
                "pct": "28%"
            },
            {
                "value": "5-7 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "28%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "K-TAB XR",
        "route": "Oral Pill",
        "fullName": "K-TAB XR (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "K-TAB",
            "K-TAB XR",
            "K-TAB XR (Oral Pill)",
            "k-tab",
            "k-tab xr",
            "k-tab xr (oral pill)",
            "potassium chloride 20 MEQ Extended Release Oral Tablet",
            "potassium chloride 20 meq extended release oral tablet"
        ],
        "dosages": [
            {
                "value": "20 meq",
                "pct": "72%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "morphine",
        "route": "Injectable",
        "fullName": "morphine (Injectable)",
        "totalCount": 18,
        "searchTerms": [
            "1 ML morphine sulfate 15 MG/ML Prefilled Syringe",
            "1 ML morphine sulfate 5 MG/ML Prefilled Syringe",
            "1 ml morphine sulfate 15 mg/ml prefilled syringe",
            "1 ml morphine sulfate 5 mg/ml prefilled syringe",
            "1.5 ML morphine sulfate liposomal 10 MG/ML Injection",
            "1.5 ml morphine sulfate liposomal 10 mg/ml injection",
            "10 ML morphine sulfate 0.5 MG/ML Injection",
            "10 ML morphine sulfate 1 MG/ML Injection",
            "10 ml morphine sulfate 0.5 mg/ml injection",
            "10 ml morphine sulfate 1 mg/ml injection",
            "2 ML morphine sulfate 0.5 MG/ML Injection",
            "2 ml morphine sulfate 0.5 mg/ml injection",
            "MORPHINE",
            "Morphine",
            "morphine",
            "morphine (Injectable)",
            "morphine (injectable)"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "33%"
            },
            {
                "value": "15 mg",
                "pct": "28%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "39%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PERI-COLACE REFORMULATED FEB 2008",
        "route": "Oral Pill",
        "fullName": "PERI-COLACE REFORMULATED FEB 2008 (Oral Pill)",
        "totalCount": 18,
        "searchTerms": [
            "PERI-COLACE REFORMULATED FEB 2008",
            "PERI-COLACE REFORMULATED FEB 2008 (Oral Pill)",
            "docusate sodium 50 MG / sennosides, USP 8.6 MG Oral Tablet",
            "docusate sodium 50 mg / sennosides, usp 8.6 mg oral tablet",
            "peri-colace reformulated feb 2008",
            "peri-colace reformulated feb 2008 (oral pill)"
        ],
        "dosages": [
            {
                "value": "50-8.6 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Centrum Silver Multivitamin",
        "route": "Oral Pill",
        "fullName": "Centrum Silver Multivitamin (Oral Pill)",
        "totalCount": 18,
        "searchTerms": ["Centrum Silver Multivitamin", "centrum silver multivitamin"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SUBOXONE",
        "route": "Sublingual",
        "fullName": "SUBOXONE (Sublingual)",
        "totalCount": 17,
        "searchTerms": [
            "SUBOXONE",
            "SUBOXONE (Sublingual)",
            "buprenorphine 2 MG / naloxone 0.5 MG Sublingual Film",
            "buprenorphine 2 mg / naloxone 0.5 mg sublingual film",
            "buprenorphine 4 MG / naloxone 1 MG Sublingual Film",
            "buprenorphine 4 mg / naloxone 1 mg sublingual film",
            "buprenorphine 8 MG / naloxone 2 MG Sublingual Film",
            "buprenorphine 8 mg / naloxone 2 mg sublingual film",
            "suboxone",
            "suboxone (sublingual)"
        ],
        "dosages": [
            {
                "value": "8-2 mg",
                "pct": "65%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "35%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "COSOPT",
        "route": "Ophthalmic",
        "fullName": "COSOPT (Ophthalmic)",
        "totalCount": 17,
        "searchTerms": [
            "COSOPT",
            "COSOPT (Ophthalmic)",
            "Preservative-Free dorzolamide 20 MG/ML / timolol 5 MG/ML Ophthalmic Solution",
            "cosopt",
            "cosopt (ophthalmic)",
            "dorzolamide 20 MG/ML / timolol 5 MG/ML Ophthalmic Solution",
            "dorzolamide 20 mg/ml / timolol 5 mg/ml ophthalmic solution",
            "preservative-free dorzolamide 20 mg/ml / timolol 5 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "53%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Travoprost",
        "route": "Ophthalmic",
        "fullName": "Travoprost (Ophthalmic)",
        "totalCount": 17,
        "searchTerms": [
            "Travoprost",
            "Travoprost (Ophthalmic)",
            "travoprost",
            "travoprost (ophthalmic)",
            "travoprost 0.04 MG/ML Ophthalmic Solution",
            "travoprost 0.04 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "41%"
            },
            {
                "value": "At bedtime",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Diltiazem",
        "route": "Injectable",
        "fullName": "Diltiazem (Injectable)",
        "totalCount": 17,
        "searchTerms": [
            "25 ML diltiazem hydrochloride 5 MG/ML Injection",
            "25 ml diltiazem hydrochloride 5 mg/ml injection",
            "5 ML diltiazem hydrochloride 5 MG/ML Injection",
            "5 ml diltiazem hydrochloride 5 mg/ml injection",
            "Diltiazem",
            "Diltiazem (Injectable)",
            "diltiazem",
            "diltiazem (injectable)",
            "diltiazem hydrochloride 100 MG Injection",
            "diltiazem hydrochloride 100 mg injection"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium citrate",
        "route": "Oral Pill",
        "fullName": "Calcium citrate (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "Calcium Citrate",
            "Calcium citrate",
            "Calcium citrate (Oral Pill)",
            "calcium citrate",
            "calcium citrate (oral pill)",
            "calcium citrate 800 MG Oral Capsule",
            "calcium citrate 800 mg oral capsule",
            "calcium citrate 950 MG Oral Capsule",
            "calcium citrate 950 MG Oral Tablet",
            "calcium citrate 950 mg oral capsule",
            "calcium citrate 950 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "29%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ZANAFLEX",
        "route": "Oral Pill",
        "fullName": "ZANAFLEX (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "ZANAFLEX",
            "ZANAFLEX (Oral Pill)",
            "tizanidine 2 MG Oral Tablet",
            "tizanidine 2 mg oral tablet",
            "tizanidine 4 MG Oral Tablet",
            "tizanidine 4 mg oral tablet",
            "tizanidine 6 MG Oral Capsule",
            "tizanidine 6 mg oral capsule",
            "zanaflex",
            "zanaflex (oral pill)"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "53%"
            },
            {
                "value": "2 mg",
                "pct": "41%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PRAVACHOL",
        "route": "Oral Pill",
        "fullName": "PRAVACHOL (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "PRAVACHOL",
            "PRAVACHOL (Oral Pill)",
            "pravachol",
            "pravachol (oral pill)",
            "pravastatin sodium 10 MG Oral Tablet",
            "pravastatin sodium 10 mg oral tablet",
            "pravastatin sodium 20 MG Oral Tablet",
            "pravastatin sodium 20 mg oral tablet",
            "pravastatin sodium 40 MG Oral Tablet",
            "pravastatin sodium 40 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "47%"
            },
            {
                "value": "20 mg",
                "pct": "29%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "53%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Nateglinide",
        "route": "Oral Pill",
        "fullName": "Nateglinide (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "Nateglinide",
            "Nateglinide (Oral Pill)",
            "Nateglinide (Oral)",
            "nateglinide",
            "nateglinide (oral pill)",
            "nateglinide (oral)",
            "nateglinide 120 MG Oral Tablet",
            "nateglinide 120 mg oral tablet",
            "nateglinide 60 MG Oral Tablet",
            "nateglinide 60 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "53%"
            },
            {
                "value": "120 mg",
                "pct": "41%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "59%"
            },
            {
                "value": "Once daily",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "Mesalamine",
        "route": "Oral Pill",
        "fullName": "Mesalamine (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "MESALAMINE",
            "Mesalamine",
            "Mesalamine (Oral Pill)",
            "Mesalamine (Oral)",
            "mesalamine",
            "mesalamine (oral pill)",
            "mesalamine (oral)",
            "mesalamine 400 MG Delayed Release Oral Capsule",
            "mesalamine 400 MG Delayed Release Oral Tablet",
            "mesalamine 400 mg delayed release oral capsule",
            "mesalamine 400 mg delayed release oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "41%"
            },
            {
                "value": "Twice daily",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K51.90",
                "description": "Ulcerative colitis, unspecified, without complications",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "Sodium chloride",
        "route": "Oral Pill",
        "fullName": "Sodium chloride (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "SODIUM CHLORIDE",
            "Sodium Chloride",
            "Sodium Chloride (Oral)",
            "Sodium chloride",
            "Sodium chloride (Oral Pill)",
            "sodium chloride",
            "sodium chloride (oral pill)",
            "sodium chloride (oral)",
            "sodium chloride 1000 MG Oral Tablet",
            "sodium chloride 1000 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 g",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "41%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E87.1",
                "description": "Hypo-osmolality and hyponatremia",
                "pct": "82%"
            }
        ]
    },
    {
        "name": "Semaglutide",
        "route": "Oral Pill",
        "fullName": "Semaglutide (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "Semaglutide",
            "Semaglutide (Oral Pill)",
            "semaglutide",
            "semaglutide (oral pill)",
            "semaglutide 14 MG Oral Tablet",
            "semaglutide 14 mg oral tablet",
            "semaglutide 3 MG Oral Tablet",
            "semaglutide 3 mg oral tablet",
            "semaglutide 7 MG Oral Tablet",
            "semaglutide 7 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "7 mg",
                "pct": "47%"
            },
            {
                "value": "14 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11",
                "description": "Type 2 diabetes mellitus",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "Methenamine",
        "route": "Oral Pill",
        "fullName": "Methenamine (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "Methenamine",
            "Methenamine (Oral Pill)",
            "Methenamine (Oral)",
            "methenamine",
            "methenamine (oral pill)",
            "methenamine (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "59%"
            },
            {
                "value": "Once daily",
                "pct": "41%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N39.0",
                "description": "Urinary tract infection, site not specified",
                "pct": "81%"
            }
        ]
    },
    {
        "name": "Silver sulfadiazine",
        "route": "Topical",
        "fullName": "Silver sulfadiazine (Topical)",
        "totalCount": 17,
        "searchTerms": [
            "Silver Sulfadiazine",
            "Silver sulfadiazine",
            "Silver sulfadiazine (Topical)",
            "silver sulfADIAZINE",
            "silver sulfADIAZINE (Topical)",
            "silver sulfadiazine",
            "silver sulfadiazine (topical)",
            "silver sulfadiazine 10 MG/ML Topical Cream",
            "silver sulfadiazine 10 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "29%"
            },
            {
                "value": "Twice daily",
                "pct": "29%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ibandronate",
        "route": "Oral Pill",
        "fullName": "Ibandronate (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "IBANDRONATE",
            "Ibandronate",
            "Ibandronate (Oral Pill)",
            "ibandronate",
            "ibandronate (oral pill)",
            "ibandronic acid 150 MG Oral Tablet",
            "ibandronic acid 150 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once monthly",
                "pct": "47%"
            },
            {
                "value": "Once daily",
                "pct": "35%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "90%"
            }
        ]
    },
    {
        "name": "HYDRALAZINE HCL",
        "route": "Oral Pill",
        "fullName": "HYDRALAZINE HCL (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "Apresoline",
            "HYDRALAZINE HCL",
            "HYDRALAZINE HCL (Oral)",
            "Hydralazine HCL",
            "Hydralazine HCL (Oral)",
            "Hydralazine HCl",
            "Hydralazine HCl (Oral)",
            "apresoline",
            "hydralazine HCL",
            "hydralazine hcl",
            "hydralazine hcl (oral)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "53%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "53%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Leflunomide",
        "route": "Oral Pill",
        "fullName": "Leflunomide (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "Leflunomide",
            "Leflunomide (Oral Pill)",
            "Leflunomide (Oral)",
            "leflunomide",
            "leflunomide (Oral)",
            "leflunomide (oral pill)",
            "leflunomide (oral)",
            "leflunomide 10 MG Oral Tablet",
            "leflunomide 10 mg oral tablet",
            "leflunomide 20 MG Oral Tablet",
            "leflunomide 20 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "53%"
            },
            {
                "value": "10 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M06.9",
                "description": "Rheumatoid arthritis, unspecified",
                "pct": "92%"
            }
        ]
    },
    {
        "name": "VENTOLIN HFA",
        "route": "Inhaler",
        "fullName": "VENTOLIN HFA (Inhaler)",
        "totalCount": 17,
        "searchTerms": [
            "VENTOLIN HFA",
            "VENTOLIN hfa",
            "Ventolin HFA",
            "Ventolin HFA (Inhaler)",
            "ventolin hfa",
            "ventolin hfa (inhaler)"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "71%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "59%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ozempic (semaglutide)",
        "route": "Injectable",
        "fullName": "Ozempic (semaglutide) (Injectable)",
        "totalCount": 17,
        "searchTerms": [
            "Ozempic (Semaglutide)",
            "Ozempic (Semaglutide) (Injectable)",
            "Ozempic (semaglutide)",
            "Ozempic (semaglutide) (Injectable)",
            "ozempic (semaglutide)",
            "ozempic (semaglutide) (injectable)"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "35%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "94%"
            }
        ],
        "adminNotes": [
            {
                "value": "Prefilled pen",
                "pct": "29%"
            },
            {
                "value": "For single patient use only",
                "pct": "29%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "76%"
            },
            {
                "code": "E66.3",
                "description": "Overweight",
                "pct": "47%"
            }
        ]
    },
    {
        "name": "Jardiance (empagliflozin)",
        "route": "Oral Pill",
        "fullName": "Jardiance (empagliflozin) (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "Jardiance (empagliflozin)",
            "Jardiance (empagliflozin) (Oral)",
            "jardiance (empagliflozin)",
            "jardiance (empagliflozin) (oral)"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "59%"
            },
            {
                "value": "10 mg",
                "pct": "41%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "Dispense with accompanying medication guide",
                "pct": "41%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "EDARBYCLOR",
        "route": "Oral Pill",
        "fullName": "EDARBYCLOR (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "EDARBYCLOR",
            "EDARBYCLOR (Oral Pill)",
            "azilsartan medoxomil 40 MG / chlorthalidone 12.5 MG Oral Tablet",
            "azilsartan medoxomil 40 MG / chlorthalidone 25 MG Oral Tablet",
            "azilsartan medoxomil 40 mg / chlorthalidone 12.5 mg oral tablet",
            "azilsartan medoxomil 40 mg / chlorthalidone 25 mg oral tablet",
            "edarbyclor",
            "edarbyclor (oral pill)"
        ],
        "dosages": [
            {
                "value": "40-12.5 mg",
                "pct": "53%"
            },
            {
                "value": "40-25 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "76%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium carbonate/Vitamin D",
        "route": "Oral Pill",
        "fullName": "Calcium carbonate/Vitamin D (Oral Pill)",
        "totalCount": 17,
        "searchTerms": [
            "Calcium carbonate/Vitamin D",
            "Calcium carbonate/Vitamin D (Oral Pill)",
            "calcium carbonate 600 MG / vitamin D 125 UNT Oral Tablet",
            "calcium carbonate 600 mg / vitamin d 125 unt oral tablet",
            "calcium carbonate/vitamin d",
            "calcium carbonate/vitamin d (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ARIPiprazole",
        "route": "Injectable",
        "fullName": "ARIPiprazole (Injectable)",
        "totalCount": 17,
        "searchTerms": [
            "1.5 ML aripiprazole 200 MG/ML Prefilled Syringe",
            "1.5 ml aripiprazole 200 mg/ml prefilled syringe",
            "2 ML aripiprazole 200 MG/ML Prefilled Syringe",
            "2 ml aripiprazole 200 mg/ml prefilled syringe",
            "ARIPiprazole",
            "ARIPiprazole (Injectable)",
            "aripiprazole",
            "aripiprazole (injectable)",
            "aripiprazole 300 MG Injection",
            "aripiprazole 300 mg injection",
            "aripiprazole 400 MG Injection",
            "aripiprazole 400 mg injection"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "47%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Vitamin D Unspecified",
        "route": "Oral Pill",
        "fullName": "Vitamin D Unspecified (Oral Pill)",
        "totalCount": 16,
        "searchTerms": ["Vitamin D Unspecified", "vitamin d unspecified"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Clobazam",
        "route": "Oral Pill",
        "fullName": "Clobazam (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "CLOBAZAM",
            "Clobazam",
            "Clobazam (Oral Pill)",
            "Clobazam (Oral)",
            "Onfi",
            "cloBAZam",
            "cloBAZam (Oral Pill)",
            "clobazam",
            "clobazam (oral pill)",
            "clobazam (oral)",
            "clobazam 10 MG Oral Tablet",
            "clobazam 10 mg oral tablet",
            "onfi"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "56%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "Silodosin",
        "route": "Oral Pill",
        "fullName": "Silodosin (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "Silodosin",
            "Silodosin (Oral Pill)",
            "Silodosin (Oral)",
            "silodosin",
            "silodosin (oral pill)",
            "silodosin (oral)",
            "silodosin 4 MG Oral Capsule",
            "silodosin 4 mg oral capsule",
            "silodosin 8 MG Oral Capsule",
            "silodosin 8 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "8 mg",
                "pct": "88%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "amLODIPine/Celecoxib",
        "route": "Oral Pill",
        "fullName": "amLODIPine/Celecoxib (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "amLODIPine/Celecoxib",
            "amLODIPine/Celecoxib (Oral Pill)",
            "amlodipine 10 MG / celecoxib 200 MG Oral Tablet",
            "amlodipine 10 mg / celecoxib 200 mg oral tablet",
            "amlodipine 2.5 MG / celecoxib 200 MG Oral Tablet",
            "amlodipine 2.5 mg / celecoxib 200 mg oral tablet",
            "amlodipine 5 MG / celecoxib 200 MG Oral Tablet",
            "amlodipine 5 mg / celecoxib 200 mg oral tablet",
            "amlodipine/celecoxib",
            "amlodipine/celecoxib (oral pill)"
        ],
        "dosages": [
            {
                "value": "10-200 mg",
                "pct": "31%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LOTENSIN",
        "route": "Oral Pill",
        "fullName": "LOTENSIN (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "LOTENSIN",
            "LOTENSIN (Oral Pill)",
            "benazepril hydrochloride 10 MG Oral Tablet",
            "benazepril hydrochloride 10 mg oral tablet",
            "benazepril hydrochloride 20 MG Oral Tablet",
            "benazepril hydrochloride 20 mg oral tablet",
            "benazepril hydrochloride 40 MG Oral Tablet",
            "benazepril hydrochloride 40 mg oral tablet",
            "lotensin",
            "lotensin (oral pill)"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "KOMBIGLYZE XR",
        "route": "Oral Pill",
        "fullName": "KOMBIGLYZE XR (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "24 HR metformin hydrochloride 1000 MG / saxagliptin 2.5 MG Extended Release Oral Tablet",
            "24 HR metformin hydrochloride 1000 MG / saxagliptin 5 MG Extended Release Oral Tablet",
            "24 HR metformin hydrochloride 500 MG / saxagliptin 5 MG Extended Release Oral Tablet",
            "24 hr metformin hydrochloride 1000 mg / saxagliptin 2.5 mg extended release oral tablet",
            "24 hr metformin hydrochloride 1000 mg / saxagliptin 5 mg extended release oral tablet",
            "24 hr metformin hydrochloride 500 mg / saxagliptin 5 mg extended release oral tablet",
            "KOMBIGLYZE",
            "KOMBIGLYZE XR",
            "KOMBIGLYZE XR (Oral Pill)",
            "kombiglyze",
            "kombiglyze xr",
            "kombiglyze xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cetirizine",
        "route": "Oral Liquid",
        "fullName": "Cetirizine (Oral Liquid)",
        "totalCount": 16,
        "searchTerms": [
            "Cetirizine",
            "Cetirizine (Oral Liquid)",
            "cetirizine",
            "cetirizine (oral liquid)",
            "cetirizine hydrochloride 1 MG/ML Oral Solution",
            "cetirizine hydrochloride 1 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "81%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "55%"
            }
        ]
    },
    {
        "name": "THERA-D",
        "route": "Oral Pill",
        "fullName": "THERA-D (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "THERA-D",
            "THERA-D (Oral Pill)",
            "cholecalciferol 0.05 MG Oral Tablet",
            "cholecalciferol 0.05 mg oral tablet",
            "cholecalciferol 0.1 MG Oral Tablet",
            "cholecalciferol 0.1 mg oral tablet",
            "thera-d",
            "thera-d (oral pill)"
        ],
        "dosages": [
            {
                "value": "0.1 mg",
                "pct": "69%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Felodipine XR",
        "route": "Oral Pill",
        "fullName": "Felodipine XR (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "24 HR felodipine 10 MG Extended Release Oral Tablet",
            "24 HR felodipine 2.5 MG Extended Release Oral Tablet",
            "24 HR felodipine 5 MG Extended Release Oral Tablet",
            "24 hr felodipine 10 mg extended release oral tablet",
            "24 hr felodipine 2.5 mg extended release oral tablet",
            "24 hr felodipine 5 mg extended release oral tablet",
            "Felodipine XR",
            "Felodipine XR (Oral Pill)",
            "felodipine xr",
            "felodipine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "50%"
            },
            {
                "value": "5 mg",
                "pct": "31%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Meclizine",
        "route": "Chewable",
        "fullName": "Meclizine (Chewable)",
        "totalCount": 16,
        "searchTerms": [
            "Meclizine",
            "Meclizine (Chewable)",
            "meclizine",
            "meclizine (chewable)",
            "meclizine hydrochloride 25 MG Chewable Tablet",
            "meclizine hydrochloride 25 mg chewable tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "94%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "31%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TIADYLT XR",
        "route": "Oral Pill",
        "fullName": "TIADYLT XR (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "24 HR diltiazem hydrochloride 120 MG Extended Release Oral Capsule",
            "24 HR diltiazem hydrochloride 180 MG Extended Release Oral Capsule",
            "24 HR diltiazem hydrochloride 240 MG Extended Release Oral Capsule",
            "24 hr diltiazem hydrochloride 120 mg extended release oral capsule",
            "24 hr diltiazem hydrochloride 180 mg extended release oral capsule",
            "24 hr diltiazem hydrochloride 240 mg extended release oral capsule",
            "TIADYLT",
            "TIADYLT XR",
            "TIADYLT XR (Oral Pill)",
            "tiadylt",
            "tiadylt xr",
            "tiadylt xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "120 mg",
                "pct": "56%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Moxifloxacin",
        "route": "Ophthalmic",
        "fullName": "Moxifloxacin (Ophthalmic)",
        "totalCount": 16,
        "searchTerms": [
            "Moxifloxacin",
            "Moxifloxacin (Ophthalmic)",
            "moxifloxacin",
            "moxifloxacin (ophthalmic)",
            "moxifloxacin 5 MG/ML Ophthalmic Solution",
            "moxifloxacin 5 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H10.9",
                "description": "Unspecified conjunctivitis",
                "pct": "58%"
            }
        ]
    },
    {
        "name": "Simethicone",
        "route": "Chewable",
        "fullName": "Simethicone (Chewable)",
        "totalCount": 16,
        "searchTerms": [
            "Simethicone",
            "Simethicone (Chewable)",
            "simethicone",
            "simethicone (chewable)",
            "simethicone 80 MG Chewable Tablet",
            "simethicone 80 mg chewable tablet"
        ],
        "dosages": [
            {
                "value": "80 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "50%"
            },
            {
                "value": "At bedtime",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R14.0",
                "description": "Abdominal distension (gaseous)",
                "pct": "33%"
            }
        ]
    },
    {
        "name": "Prochlorperazine",
        "route": "Oral Pill",
        "fullName": "Prochlorperazine (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "Compazine",
            "Prochlorperazine",
            "Prochlorperazine (Oral Pill)",
            "Prochlorperazine (Oral)",
            "compazine",
            "prochlorperazine",
            "prochlorperazine (oral pill)",
            "prochlorperazine (oral)",
            "prochlorperazine 10 MG Oral Tablet",
            "prochlorperazine 10 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "69%"
            },
            {
                "value": "5 mg",
                "pct": "31%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "56%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OLMESARTAN MEDOXOMIL",
        "route": "Oral Pill",
        "fullName": "OLMESARTAN MEDOXOMIL (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "Benicar",
            "Benicar Tabs",
            "OLMESARTAN MEDOXOMIL",
            "Olmesartan Medoxomil",
            "Olmesartan Medoxomil (Oral)",
            "benicar",
            "benicar tabs",
            "olmesartan medoxomil",
            "olmesartan medoxomil (oral)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "38%"
            },
            {
                "value": "40 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "FLUOXETINE HCL",
        "route": "Oral Pill",
        "fullName": "FLUOXETINE HCL (Oral Pill)",
        "totalCount": 16,
        "searchTerms": [
            "FLUOXETINE HCL",
            "FLUoxetine",
            "FLUoxetine HCL",
            "FLUoxetine HCL (Oral)",
            "Fluoxetine",
            "Fluoxetine HCL",
            "Fluoxetine HCL (Oral)",
            "Fluoxetine HCl",
            "Fluoxetine HCl (Oral)",
            "Prozac",
            "Prozac 40 MG Caps",
            "fluoxetine",
            "fluoxetine hcl",
            "fluoxetine hcl (oral)",
            "prozac",
            "prozac 40 mg caps"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "38%"
            },
            {
                "value": "20 mg",
                "pct": "31%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "94%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "93%"
            }
        ]
    },
    {
        "name": "NexIUM",
        "route": "Oral Suspension Granules",
        "fullName": "NexIUM (Oral Suspension Granules)",
        "totalCount": 16,
        "searchTerms": [
            "NEXIUM",
            "NexIUM",
            "NexIUM (Oral Suspension Granules)",
            "esomeprazole 10 MG Granules for Oral Suspension",
            "esomeprazole 10 mg granules for oral suspension",
            "esomeprazole 2.5 MG Granules for Oral Suspension",
            "esomeprazole 2.5 mg granules for oral suspension",
            "esomeprazole 20 MG Granules for Oral Suspension",
            "esomeprazole 20 mg granules for oral suspension",
            "esomeprazole 40 MG Granules for Oral Suspension",
            "esomeprazole 40 mg granules for oral suspension",
            "esomeprazole 5 MG Granules for Oral Suspension",
            "esomeprazole 5 mg granules for oral suspension",
            "nexium",
            "nexium (oral suspension granules)"
        ],
        "dosages": [
            {
                "value": "2.5 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "44%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Fish Oil",
        "route": "Oral Pill",
        "fullName": "Fish Oil (Oral Pill)",
        "totalCount": 16,
        "searchTerms": ["FISH OIL", "Fish Oil", "Fish oil", "fish oil"],
        "dosages": [
            {
                "value": "1000 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "81%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "prednisoLONE",
        "route": "Pack",
        "fullName": "prednisoLONE (Pack)",
        "totalCount": 15,
        "searchTerms": [
            "prednisoLONE",
            "prednisoLONE (Pack)",
            "prednisolone",
            "prednisolone (pack)",
            "{21 (prednisolone 5 MG Oral Tablet) } Pack",
            "{21 (prednisolone 5 mg oral tablet) } pack",
            "{48 (prednisolone 5 MG Oral Tablet) } Pack",
            "{48 (prednisolone 5 mg oral tablet) } pack"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NovoLIN",
        "route": "Injectable",
        "fullName": "NovoLIN (Injectable)",
        "totalCount": 15,
        "searchTerms": [
            "3 ML insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Pen Injector",
            "3 ml insulin isophane, human 70 unt/ml / insulin, regular, human 30 unt/ml pen injector",
            "NOVOLIN",
            "NovoLIN",
            "NovoLIN (Injectable)",
            "insulin isophane, human 70 UNT/ML / insulin, regular, human 30 UNT/ML Injectable Suspension",
            "insulin isophane, human 70 unt/ml / insulin, regular, human 30 unt/ml injectable suspension",
            "novolin",
            "novolin (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium ascorbate/Calcium threonate/Ferrous asparto glycinate/Folic acid/Polysaccharide iron complex/Succinic acid/Vitamin B12",
        "route": "Oral Pill",
        "fullName": "Calcium ascorbate/Calcium threonate/Ferrous asparto glycinate/Folic acid/Polysaccharide iron complex/Succinic acid/Vitamin B12 (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "Calcium ascorbate/Calcium threonate/Ferrous asparto glycinate/Folic acid/Polysaccharide iron complex/Succinic acid/Vitamin B12",
            "Calcium ascorbate/Calcium threonate/Ferrous asparto glycinate/Folic acid/Polysaccharide iron complex/Succinic acid/Vitamin B12 (Oral Pill)",
            "calcium ascorbate 60 MG / calcium threonate 0.8 MG / ferrous asparto glycinate 50 MG / folic acid 1 MG / polysaccharide iron complex 100 MG / succinic acid 50 MG / vitamin B12 0.025 MG Oral Capsule",
            "calcium ascorbate 60 mg / calcium threonate 0.8 mg / ferrous asparto glycinate 50 mg / folic acid 1 mg / polysaccharide iron complex 100 mg / succinic acid 50 mg / vitamin b12 0.025 mg oral capsule",
            "calcium ascorbate/calcium threonate/ferrous asparto glycinate/folic acid/polysaccharide iron complex/succinic acid/vitamin b12",
            "calcium ascorbate/calcium threonate/ferrous asparto glycinate/folic acid/polysaccharide iron complex/succinic acid/vitamin b12 (oral pill)"
        ],
        "dosages": [
            {
                "value": "60-0.8-50-1-100-50-0.025 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "40%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ciprofloxacin",
        "route": "Oral Pill",
        "fullName": "Ciprofloxacin (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "CIPROFLOXACIN",
            "Cipro",
            "Ciprofloxacin",
            "Ciprofloxacin (Oral Pill)",
            "Ciprofloxacin (Oral)",
            "cipro",
            "ciprofloxacin",
            "ciprofloxacin (oral pill)",
            "ciprofloxacin (oral)",
            "ciprofloxacin 250 MG Oral Tablet",
            "ciprofloxacin 250 mg oral tablet",
            "ciprofloxacin 500 MG Oral Tablet",
            "ciprofloxacin 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "73%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "60%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N39.0",
                "description": "Urinary tract infection, site not specified",
                "pct": "56%"
            }
        ]
    },
    {
        "name": "Brinzolamide",
        "route": "Ophthalmic",
        "fullName": "Brinzolamide (Ophthalmic)",
        "totalCount": 15,
        "searchTerms": [
            "Brinzolamide",
            "Brinzolamide (Ophthalmic)",
            "brinzolamide",
            "brinzolamide (ophthalmic)",
            "brinzolamide 10 MG/ML Ophthalmic Suspension",
            "brinzolamide 10 mg/ml ophthalmic suspension"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "53%"
            },
            {
                "value": "Once daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "42%"
            }
        ]
    },
    {
        "name": "Varenicline",
        "route": "Oral Pill",
        "fullName": "Varenicline (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "VARENICLINE",
            "Varenicline",
            "Varenicline (Oral Pill)",
            "Varenicline (Oral)",
            "varenicline",
            "varenicline (oral pill)",
            "varenicline (oral)",
            "varenicline 0.5 MG Oral Tablet",
            "varenicline 0.5 mg oral tablet",
            "varenicline 1 MG Oral Tablet",
            "varenicline 1 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "73%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "60%"
            },
            {
                "value": "Once daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F17.200",
                "description": "Nicotine dependence, unspecified, uncomplicated",
                "pct": "70%"
            }
        ]
    },
    {
        "name": "Entecavir",
        "route": "Oral Pill",
        "fullName": "Entecavir (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "Entecavir",
            "Entecavir (Oral Pill)",
            "Entecavir (Oral)",
            "entecavir",
            "entecavir (oral pill)",
            "entecavir (oral)",
            "entecavir 0.5 MG Oral Tablet",
            "entecavir 0.5 mg oral tablet",
            "entecavir 1 MG Oral Tablet",
            "entecavir 1 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "93%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B18.1",
                "description": "Chronic viral hepatitis B without delta-agent",
                "pct": "64%"
            }
        ]
    },
    {
        "name": "cloZAPine",
        "route": "Oral Disintegrating",
        "fullName": "cloZAPine (Oral Disintegrating)",
        "totalCount": 15,
        "searchTerms": [
            "cloZAPine",
            "cloZAPine (Oral Disintegrating)",
            "clozapine",
            "clozapine (oral disintegrating)",
            "clozapine 100 MG Disintegrating Oral Tablet",
            "clozapine 100 mg disintegrating oral tablet",
            "clozapine 150 MG Disintegrating Oral Tablet",
            "clozapine 150 mg disintegrating oral tablet",
            "clozapine 200 MG Disintegrating Oral Tablet",
            "clozapine 200 mg disintegrating oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "33%"
            },
            {
                "value": "Once daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Alogliptin",
        "route": "Oral Pill",
        "fullName": "Alogliptin (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "Alogliptin",
            "Alogliptin (Oral Pill)",
            "Alogliptin (Oral)",
            "alogliptin",
            "alogliptin (oral pill)",
            "alogliptin (oral)",
            "alogliptin 12.5 MG Oral Tablet",
            "alogliptin 12.5 mg oral tablet",
            "alogliptin 25 MG Oral Tablet",
            "alogliptin 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "53%"
            },
            {
                "value": "12.5 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Docusate",
        "route": "Oral Liquid",
        "fullName": "Docusate (Oral Liquid)",
        "totalCount": 15,
        "searchTerms": [
            "Docusate",
            "Docusate (Oral Liquid)",
            "docusate",
            "docusate (oral liquid)",
            "docusate sodium 3.33 MG/ML Oral Solution",
            "docusate sodium 3.33 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "40%"
            },
            {
                "value": "100 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Erythromycin",
        "route": "Ophthalmic",
        "fullName": "Erythromycin (Ophthalmic)",
        "totalCount": 15,
        "searchTerms": [
            "Erythromycin",
            "Erythromycin (Ophthalmic)",
            "Ilotycin",
            "erythromycin",
            "erythromycin (ophthalmic)",
            "erythromycin 0.005 MG/MG Ophthalmic Ointment",
            "erythromycin 0.005 mg/mg ophthalmic ointment",
            "ilotycin"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "60%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H10.9",
                "description": "Unspecified conjunctivitis",
                "pct": "69%"
            }
        ]
    },
    {
        "name": "CARDURA",
        "route": "Oral Pill",
        "fullName": "CARDURA (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "CARDURA",
            "CARDURA (Oral Pill)",
            "cardura",
            "cardura (oral pill)",
            "doxazosin 1 MG Oral Tablet",
            "doxazosin 1 mg oral tablet",
            "doxazosin 2 MG Oral Tablet",
            "doxazosin 2 mg oral tablet",
            "doxazosin 4 MG Oral Tablet",
            "doxazosin 4 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "47%"
            },
            {
                "value": "2 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ursodeoxycholate",
        "route": "Oral Pill",
        "fullName": "Ursodeoxycholate (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "Ursodeoxycholate",
            "Ursodeoxycholate (Oral Pill)",
            "ursodeoxycholate",
            "ursodeoxycholate (oral pill)",
            "ursodiol 300 MG Oral Capsule",
            "ursodiol 300 mg oral capsule",
            "ursodiol 500 MG Oral Tablet",
            "ursodiol 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "47%"
            },
            {
                "value": "300 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "60%"
            },
            {
                "value": "Once daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Tiotropium",
        "route": "Inhalant",
        "fullName": "Tiotropium (Inhalant)",
        "totalCount": 15,
        "searchTerms": [
            "60 ACTUAT tiotropium 0.00125 MG/ACTUAT Inhalation Spray",
            "60 ACTUAT tiotropium 0.0025 MG/ACTUAT Inhalation Spray",
            "60 actuat tiotropium 0.00125 mg/actuat inhalation spray",
            "60 actuat tiotropium 0.0025 mg/actuat inhalation spray",
            "Tiotropium",
            "Tiotropium (Inhalant)",
            "tiotropium",
            "tiotropium (inhalant)",
            "tiotropium 0.018 MG Inhalation Powder",
            "tiotropium 0.018 mg inhalation powder"
        ],
        "dosages": [
            {
                "value": "2.5 mcg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Vitamin B12",
        "route": "Injectable",
        "fullName": "Vitamin B12 (Injectable)",
        "totalCount": 15,
        "searchTerms": [
            "Vitamin B12",
            "Vitamin B12 (Injectable)",
            "vitamin b12",
            "vitamin b12 (injectable)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "1 mg intramuscular once monthly",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D51.9",
                "description": "Vitamin B12 deficiency anemia, unspecified",
                "pct": "67%"
            },
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "33%"
            }
        ]
    },
    {
        "name": "Nadolol",
        "route": "Oral Pill",
        "fullName": "Nadolol (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "Nadolol",
            "Nadolol (Oral Pill)",
            "Nadolol (Oral)",
            "nadolol",
            "nadolol (oral pill)",
            "nadolol (oral)",
            "nadolol 20 MG Oral Tablet",
            "nadolol 20 mg oral tablet",
            "nadolol 40 MG Oral Tablet",
            "nadolol 40 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "73%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "carBAMazepine",
        "route": "Oral Pill",
        "fullName": "carBAMazepine (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "CARBAMAZEPINE",
            "Carbamazepine",
            "Carbamazepine (Oral)",
            "Tegretol",
            "carBAMazepine",
            "carBAMazepine (Oral Pill)",
            "carbamazepine",
            "carbamazepine (oral pill)",
            "carbamazepine (oral)",
            "carbamazepine 100 MG Oral Tablet",
            "carbamazepine 100 mg oral tablet",
            "carbamazepine 200 MG Oral Tablet",
            "carbamazepine 200 mg oral tablet",
            "tegretol"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "67%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "XIFAXAN",
        "route": "Oral Pill",
        "fullName": "XIFAXAN (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "XIFAXAN",
            "XIFAXAN (Oral Pill)",
            "Xifaxan",
            "Xifaxan (Oral)",
            "rifaximin 200 MG Oral Tablet",
            "rifaximin 200 mg oral tablet",
            "rifaximin 550 MG Oral Tablet",
            "rifaximin 550 mg oral tablet",
            "xifaxan",
            "xifaxan (oral pill)",
            "xifaxan (oral)"
        ],
        "dosages": [
            {
                "value": "550 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "53%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Hydroxyurea",
        "route": "Oral Pill",
        "fullName": "Hydroxyurea (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "Hydroxyurea",
            "Hydroxyurea (Oral Pill)",
            "Hydroxyurea (Oral)",
            "hydroxyurea",
            "hydroxyurea (Oral)",
            "hydroxyurea (oral pill)",
            "hydroxyurea (oral)",
            "hydroxyurea 100 MG Oral Tablet",
            "hydroxyurea 100 mg oral tablet",
            "hydroxyurea 300 MG Oral Capsule",
            "hydroxyurea 300 mg oral capsule",
            "hydroxyurea 500 MG Oral Capsule",
            "hydroxyurea 500 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "93%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "60%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D57.1",
                "description": "Sickle-cell disease without crisis",
                "pct": "56%"
            }
        ]
    },
    {
        "name": "Polyethylene glycol 3350",
        "route": "Oral Pill",
        "fullName": "Polyethylene glycol 3350 (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "Miralax",
            "Polyethylene Glycol 3350",
            "Polyethylene Glycol 3350 (Oral)",
            "miralax",
            "polyethylene glycol 3350",
            "polyethylene glycol 3350 (Oral)",
            "polyethylene glycol 3350 (oral)"
        ],
        "dosages": [
            {
                "value": "17 g",
                "pct": "53%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Meclizine Hydrochloride",
        "route": "Oral Pill",
        "fullName": "Meclizine Hydrochloride (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "ANTIVERT",
            "Antivert",
            "Dramamine II",
            "MECLIZINE HYDROCHLORIDE",
            "MECLIZINE HYDROCHLORIDE (Oral)",
            "Meclizine Hydrochloride",
            "Meclizine Hydrochloride (Oral)",
            "antivert",
            "dramamine ii",
            "meclizine hydrochloride",
            "meclizine hydrochloride (oral)"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "60%"
            },
            {
                "value": "12.5 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "40%"
            },
            {
                "value": "Once daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R42",
                "description": "Dizziness and giddiness",
                "pct": "93%"
            }
        ]
    },
    {
        "name": "TRAMADOL HCL",
        "route": "Oral Pill",
        "fullName": "TRAMADOL HCL (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "TRAMADOL HCL",
            "TRAMADOL HCL (Oral)",
            "Tramadol HCL",
            "Tramadol HCL (Oral)",
            "Tramadol HCl",
            "Tramadol HCl (Oral)",
            "Ultram",
            "tramadol hcl",
            "tramadol hcl (oral)",
            "ultram"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "93%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "53%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "92%"
            },
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "46%"
            }
        ]
    },
    {
        "name": "Diclofenac Sodium Gel",
        "route": "Topical",
        "fullName": "Diclofenac Sodium Gel (Topical)",
        "totalCount": 15,
        "searchTerms": [
            "DICLOFENAC SODIUM GEL",
            "DICLOFENAC SODIUM GEL (Topical)",
            "Diclofenac Sodium Gel",
            "Diclofenac Sodium Gel (Topical)",
            "VOLTAREN ARTHRITIS",
            "Voltaren",
            "Voltaren Arthritis",
            "Voltaren Gel",
            "diclofenac sodium gel",
            "diclofenac sodium gel (topical)",
            "voltaren",
            "voltaren arthritis",
            "voltaren gel"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "33%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Cholecalciferol - Supplement",
        "route": "Oral Pill",
        "fullName": "Cholecalciferol - Supplement (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "Cholecalciferol - Supplement",
            "Cholecalciferol - Supplement (Oral)",
            "Thera-D 2000",
            "cholecalciferol - Supplement",
            "cholecalciferol - Supplement (Oral)",
            "cholecalciferol - supplement",
            "cholecalciferol - supplement (oral)",
            "thera-d 2000"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Brimonidine Tartrate",
        "route": "Ophthalmic",
        "fullName": "Brimonidine Tartrate (Ophthalmic)",
        "totalCount": 15,
        "searchTerms": [
            "Alphagan P",
            "BRIMONIDINE TARTRATE",
            "BRIMONIDINE TARTRATE (Ophthalmic)",
            "Brimonidine Tartrate",
            "Brimonidine Tartrate (Ophthalmic)",
            "alphagan p",
            "brimonidine tartrate",
            "brimonidine tartrate (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [
            {
                "value": "Avoid touching dropper tip to eye or surfaces",
                "pct": "33%"
            }
        ],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "60%"
            },
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "33%"
            }
        ]
    },
    {
        "name": "LIDODERM",
        "route": "Topical",
        "fullName": "LIDODERM (Topical)",
        "totalCount": 15,
        "searchTerms": [
            "LIDODERM",
            "LIDODERM (Topical)",
            "lidocaine 0.05 MG/MG Medicated Patch",
            "lidocaine 0.05 mg/mg medicated patch",
            "lidoderm",
            "lidoderm (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium carbonate/Magnesium oxide",
        "route": "Oral Pill",
        "fullName": "Calcium carbonate/Magnesium oxide (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "Calcium carbonate/Magnesium oxide",
            "Calcium carbonate/Magnesium oxide (Oral Pill)",
            "calcium carbonate 250 MG / magnesium oxide 155 MG Oral Tablet",
            "calcium carbonate 250 mg / magnesium oxide 155 mg oral tablet",
            "calcium carbonate/magnesium oxide",
            "calcium carbonate/magnesium oxide (oral pill)"
        ],
        "dosages": [
            {
                "value": "250-155 mg",
                "pct": "33%"
            },
            {
                "value": "400 mg",
                "pct": "33%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "53%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "AVODART",
        "route": "Oral Pill",
        "fullName": "AVODART (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "AVODART",
            "AVODART (Oral Pill)",
            "avodart",
            "avodart (oral pill)",
            "dutasteride 0.5 MG Oral Capsule",
            "dutasteride 0.5 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "93%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "87%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SILENOR",
        "route": "Oral Pill",
        "fullName": "SILENOR (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "SILENOR",
            "SILENOR (Oral Pill)",
            "doxepin 3 MG Oral Tablet",
            "doxepin 3 mg oral tablet",
            "doxepin 6 MG Oral Tablet",
            "doxepin 6 mg oral tablet",
            "silenor",
            "silenor (oral pill)"
        ],
        "dosages": [
            {
                "value": "3 mg",
                "pct": "53%"
            },
            {
                "value": "6 mg",
                "pct": "47%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Q-GEL",
        "route": "Oral Pill",
        "fullName": "Q-GEL (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "Q-GEL",
            "Q-GEL (Oral Pill)",
            "q-gel",
            "q-gel (oral pill)",
            "ubidecarenone 100 MG / vitamin E 150 UNT Oral Capsule",
            "ubidecarenone 100 mg / vitamin e 150 unt oral capsule",
            "ubidecarenone 15 MG / vitamin E 3 UNT Oral Capsule",
            "ubidecarenone 15 mg / vitamin e 3 unt oral capsule",
            "ubidecarenone 60 MG / vitamin E 150 UNT Oral Capsule",
            "ubidecarenone 60 mg / vitamin e 150 unt oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MUCINEX DM XR",
        "route": "Oral Pill",
        "fullName": "MUCINEX DM XR (Oral Pill)",
        "totalCount": 15,
        "searchTerms": [
            "12 HR dextromethorphan hydrobromide 30 MG / guaifenesin 600 MG Extended Release Oral Tablet",
            "12 HR dextromethorphan hydrobromide 60 MG / guaifenesin 1200 MG Extended Release Oral Tablet",
            "12 hr dextromethorphan hydrobromide 30 mg / guaifenesin 600 mg extended release oral tablet",
            "12 hr dextromethorphan hydrobromide 60 mg / guaifenesin 1200 mg extended release oral tablet",
            "MUCINEX DM",
            "MUCINEX DM XR",
            "MUCINEX DM XR (Oral Pill)",
            "mucinex dm",
            "mucinex dm xr",
            "mucinex dm xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "47%"
            },
            {
                "value": "30-600 mg",
                "pct": "40%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "47%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TYLENOL WITH CODEINE",
        "route": "Oral Pill",
        "fullName": "TYLENOL WITH CODEINE (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "TYLENOL WITH CODEINE",
            "TYLENOL WITH CODEINE (Oral Pill)",
            "acetaminophen 300 MG / codeine phosphate 30 MG Oral Tablet",
            "acetaminophen 300 MG / codeine phosphate 60 MG Oral Tablet",
            "acetaminophen 300 mg / codeine phosphate 30 mg oral tablet",
            "acetaminophen 300 mg / codeine phosphate 60 mg oral tablet",
            "tylenol with codeine",
            "tylenol with codeine (oral pill)"
        ],
        "dosages": [
            {
                "value": "300-30 mg",
                "pct": "64%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ULTRAM",
        "route": "Oral Pill",
        "fullName": "ULTRAM (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "ULTRAM",
            "ULTRAM (Oral Pill)",
            "tramadol hydrochloride 50 MG Oral Tablet",
            "tramadol hydrochloride 50 mg oral tablet",
            "ultram",
            "ultram (oral pill)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Memantine XR",
        "route": "Oral Pill",
        "fullName": "Memantine XR (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "24 HR memantine hydrochloride 14 MG Extended Release Oral Capsule",
            "24 HR memantine hydrochloride 21 MG Extended Release Oral Capsule",
            "24 HR memantine hydrochloride 28 MG Extended Release Oral Capsule",
            "24 HR memantine hydrochloride 7 MG Extended Release Oral Capsule",
            "24 hr memantine hydrochloride 14 mg extended release oral capsule",
            "24 hr memantine hydrochloride 21 mg extended release oral capsule",
            "24 hr memantine hydrochloride 28 mg extended release oral capsule",
            "24 hr memantine hydrochloride 7 mg extended release oral capsule",
            "Memantine XR",
            "Memantine XR (Oral Pill)",
            "Memantine XR (Oral)",
            "memantine xr",
            "memantine xr (oral pill)",
            "memantine xr (oral)"
        ],
        "dosages": [
            {
                "value": "14 mg",
                "pct": "43%"
            },
            {
                "value": "28 mg",
                "pct": "43%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "clonazePAM",
        "route": "Oral Disintegrating",
        "fullName": "clonazePAM (Oral Disintegrating)",
        "totalCount": 14,
        "searchTerms": [
            "clonazePAM",
            "clonazePAM (Oral Disintegrating)",
            "clonazepam",
            "clonazepam (oral disintegrating)",
            "clonazepam 0.125 MG Disintegrating Oral Tablet",
            "clonazepam 0.125 mg disintegrating oral tablet",
            "clonazepam 0.25 MG Disintegrating Oral Tablet",
            "clonazepam 0.25 mg disintegrating oral tablet",
            "clonazepam 0.5 MG Disintegrating Oral Tablet",
            "clonazepam 0.5 mg disintegrating oral tablet",
            "clonazepam 1 MG Disintegrating Oral Tablet",
            "clonazepam 1 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "57%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Prasugrel",
        "route": "Oral Pill",
        "fullName": "Prasugrel (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "PRASUGREL",
            "Prasugrel",
            "Prasugrel (Oral Pill)",
            "prasugrel",
            "prasugrel (oral pill)",
            "prasugrel 10 MG Oral Tablet",
            "prasugrel 10 mg oral tablet",
            "prasugrel 5 MG Oral Tablet",
            "prasugrel 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "64%"
            },
            {
                "value": "5 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "93%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Phenytoin XR",
        "route": "Oral Pill",
        "fullName": "Phenytoin XR (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "Phenytoin XR",
            "Phenytoin XR (Oral Pill)",
            "phenytoin sodium 100 MG Extended Release Oral Capsule",
            "phenytoin sodium 100 mg extended release oral capsule",
            "phenytoin sodium 30 MG Extended Release Oral Capsule",
            "phenytoin sodium 30 mg extended release oral capsule",
            "phenytoin xr",
            "phenytoin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "93%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Modafinil",
        "route": "Oral Pill",
        "fullName": "Modafinil (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "Modafinil",
            "Modafinil (Oral Pill)",
            "modafinil",
            "modafinil (oral pill)",
            "modafinil 100 MG Oral Tablet",
            "modafinil 100 mg oral tablet",
            "modafinil 200 MG Oral Tablet",
            "modafinil 200 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "50%"
            },
            {
                "value": "100 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VASOTEC",
        "route": "Oral Pill",
        "fullName": "VASOTEC (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "VASOTEC",
            "VASOTEC (Oral Pill)",
            "enalapril maleate 10 MG Oral Tablet",
            "enalapril maleate 10 mg oral tablet",
            "enalapril maleate 2.5 MG Oral Tablet",
            "enalapril maleate 2.5 mg oral tablet",
            "enalapril maleate 20 MG Oral Tablet",
            "enalapril maleate 20 mg oral tablet",
            "enalapril maleate 5 MG Oral Tablet",
            "enalapril maleate 5 mg oral tablet",
            "vasotec",
            "vasotec (oral pill)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "36%"
            },
            {
                "value": "10 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Hydrochlorothiazide/Moexipril",
        "route": "Oral Pill",
        "fullName": "Hydrochlorothiazide/Moexipril (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "Hydrochlorothiazide/Moexipril",
            "Hydrochlorothiazide/Moexipril (Oral Pill)",
            "hydrochlorothiazide 12.5 MG / moexipril hydrochloride 15 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / moexipril hydrochloride 7.5 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / moexipril hydrochloride 15 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / moexipril hydrochloride 7.5 mg oral tablet",
            "hydrochlorothiazide 25 MG / moexipril hydrochloride 15 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / moexipril hydrochloride 15 mg oral tablet",
            "hydrochlorothiazide/moexipril",
            "hydrochlorothiazide/moexipril (oral pill)"
        ],
        "dosages": [
            {
                "value": "12.5 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OYSCO 500",
        "route": "Oral Pill",
        "fullName": "OYSCO 500 (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "OYSCO 500",
            "OYSCO 500 (Oral Pill)",
            "calcium carbonate 1250 MG Oral Tablet",
            "calcium carbonate 1250 mg oral tablet",
            "oysco 500",
            "oysco 500 (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Semaglutide",
        "route": "Injectable",
        "fullName": "Semaglutide (Injectable)",
        "totalCount": 14,
        "searchTerms": [
            "0.25 MG, 0.5 MG Dose 1.5 ML semaglutide 1.34 MG/ML Pen Injector",
            "0.25 mg, 0.5 mg dose 1.5 ml semaglutide 1.34 mg/ml pen injector",
            "1 MG Dose 1.5 ML semaglutide 1.34 MG/ML Pen Injector",
            "1 mg dose 1.5 ml semaglutide 1.34 mg/ml pen injector",
            "Semaglutide",
            "Semaglutide (Injectable)",
            "semaglutide",
            "semaglutide (injectable)"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "60%"
            }
        ]
    },
    {
        "name": "amLODIPine/Olmesartan",
        "route": "Oral Pill",
        "fullName": "amLODIPine/Olmesartan (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "amLODIPine/Olmesartan",
            "amLODIPine/Olmesartan (Oral Pill)",
            "amlodipine 10 MG / olmesartan medoxomil 20 MG Oral Tablet",
            "amlodipine 10 mg / olmesartan medoxomil 20 mg oral tablet",
            "amlodipine 5 MG / olmesartan medoxomil 40 MG Oral Tablet",
            "amlodipine 5 mg / olmesartan medoxomil 40 mg oral tablet",
            "amlodipine/olmesartan",
            "amlodipine/olmesartan (oral pill)"
        ],
        "dosages": [
            {
                "value": "10-40 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "82%"
            }
        ]
    },
    {
        "name": "Indomethacin",
        "route": "Oral Pill",
        "fullName": "Indomethacin (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "Indocin",
            "Indomethacin",
            "Indomethacin (Oral Pill)",
            "Indomethacin (Oral)",
            "indocin",
            "indomethacin",
            "indomethacin (oral pill)",
            "indomethacin (oral)",
            "indomethacin 20 MG Oral Capsule",
            "indomethacin 20 mg oral capsule",
            "indomethacin 25 MG Oral Capsule",
            "indomethacin 25 mg oral capsule",
            "indomethacin 50 MG Oral Capsule",
            "indomethacin 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "50%"
            },
            {
                "value": "25 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cefdinir",
        "route": "Oral Pill",
        "fullName": "Cefdinir (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "Cefdinir",
            "Cefdinir (Oral Pill)",
            "Cefdinir (Oral)",
            "Omnicef",
            "cefdinir",
            "cefdinir (oral pill)",
            "cefdinir (oral)",
            "cefdinir 300 MG Oral Capsule",
            "cefdinir 300 mg oral capsule",
            "omnicef"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "43%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CYANOKIT",
        "route": "Injectable",
        "fullName": "CYANOKIT (Injectable)",
        "totalCount": 14,
        "searchTerms": [
            "CYANOKIT",
            "CYANOKIT (Injectable)",
            "cyanokit",
            "cyanokit (injectable)",
            "hydroxocobalamin 5000 MG Injection",
            "hydroxocobalamin 5000 mg injection"
        ],
        "dosages": [
            {
                "value": "5 g",
                "pct": "57%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Nicotine",
        "route": "Chewable",
        "fullName": "Nicotine (Chewable)",
        "totalCount": 14,
        "searchTerms": [
            "Nicotine",
            "Nicotine (Chewable)",
            "nicotine",
            "nicotine (chewable)",
            "nicotine 2 MG Chewing Gum",
            "nicotine 2 mg chewing gum",
            "nicotine 4 MG Chewing Gum",
            "nicotine 4 mg chewing gum"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "57%"
            },
            {
                "value": "4 mg",
                "pct": "43%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "57%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Acetaminophen/HYDROcodone",
        "route": "Oral Pill",
        "fullName": "Acetaminophen/HYDROcodone (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "Acetaminophen/HYDROcodone",
            "Acetaminophen/HYDROcodone (Oral Pill)",
            "acetaminophen 300 MG / hydrocodone bitartrate 10 MG Oral Tablet",
            "acetaminophen 300 mg / hydrocodone bitartrate 10 mg oral tablet",
            "acetaminophen 325 MG / hydrocodone bitartrate 10 MG Oral Tablet",
            "acetaminophen 325 MG / hydrocodone bitartrate 5 MG Oral Tablet",
            "acetaminophen 325 mg / hydrocodone bitartrate 10 mg oral tablet",
            "acetaminophen 325 mg / hydrocodone bitartrate 5 mg oral tablet",
            "acetaminophen/hydrocodone",
            "acetaminophen/hydrocodone (oral pill)"
        ],
        "dosages": [
            {
                "value": "325-10 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "82%"
            }
        ]
    },
    {
        "name": "MAG-OX 400",
        "route": "Oral Pill",
        "fullName": "MAG-OX 400 (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "MAG-OX 400",
            "MAG-OX 400 (Oral Pill)",
            "mag-ox 400",
            "mag-ox 400 (oral pill)"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E83.42",
                "description": "Hypomagnesemia",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "INVEGA XR",
        "route": "Oral Pill",
        "fullName": "INVEGA XR (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "24 HR paliperidone 1.5 MG Extended Release Oral Tablet",
            "24 HR paliperidone 3 MG Extended Release Oral Tablet",
            "24 HR paliperidone 6 MG Extended Release Oral Tablet",
            "24 HR paliperidone 9 MG Extended Release Oral Tablet",
            "24 hr paliperidone 1.5 mg extended release oral tablet",
            "24 hr paliperidone 3 mg extended release oral tablet",
            "24 hr paliperidone 6 mg extended release oral tablet",
            "24 hr paliperidone 9 mg extended release oral tablet",
            "INVEGA",
            "INVEGA XR",
            "INVEGA XR (Oral Pill)",
            "invega",
            "invega xr",
            "invega xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Folic acid/Vitamin B12/Vitamin B6",
        "route": "Oral Pill",
        "fullName": "Folic acid/Vitamin B12/Vitamin B6 (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "Folic acid/Vitamin B12/Vitamin B6",
            "Folic acid/Vitamin B12/Vitamin B6 (Oral Pill)",
            "folic acid/vitamin b12/vitamin b6",
            "folic acid/vitamin b12/vitamin b6 (oral pill)"
        ],
        "dosages": [
            {
                "value": "0.4-0.1-50 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "64%"
            }
        ]
    },
    {
        "name": "Melatonin",
        "route": "Chewable",
        "fullName": "Melatonin (Chewable)",
        "totalCount": 14,
        "searchTerms": [
            "Melatonin",
            "Melatonin (Chewable)",
            "melatonin",
            "melatonin (chewable)",
            "melatonin 2.5 MG Chewable Tablet",
            "melatonin 2.5 mg chewable tablet",
            "melatonin 5 MG Chewable Tablet",
            "melatonin 5 mg chewable tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "DICLOFENAC SODIUM",
        "route": "Oral Pill",
        "fullName": "DICLOFENAC SODIUM (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "Diclofenac Sodium",
            "Diclofenac Sodium (Oral)",
            "VOLTAREN",
            "Voltaren",
            "diclofenac sodium",
            "diclofenac sodium (oral)",
            "voltaren"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "43%"
            },
            {
                "value": "75 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "93%"
            }
        ]
    },
    {
        "name": "RYTARY XR",
        "route": "Oral Pill",
        "fullName": "RYTARY XR (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "8 HR carbidopa 23.75 MG / levodopa 95 MG Extended Release Oral Capsule",
            "8 HR carbidopa 36.25 MG / levodopa 145 MG Extended Release Oral Capsule",
            "8 HR carbidopa 48.75 MG / levodopa 195 MG Extended Release Oral Capsule",
            "8 HR carbidopa 61.25 MG / levodopa 245 MG Extended Release Oral Capsule",
            "8 hr carbidopa 23.75 mg / levodopa 95 mg extended release oral capsule",
            "8 hr carbidopa 36.25 mg / levodopa 145 mg extended release oral capsule",
            "8 hr carbidopa 48.75 mg / levodopa 195 mg extended release oral capsule",
            "8 hr carbidopa 61.25 mg / levodopa 245 mg extended release oral capsule",
            "RYTARY",
            "RYTARY XR",
            "RYTARY XR (Oral Pill)",
            "rytary",
            "rytary xr",
            "rytary xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "23.75-95 mg",
                "pct": "36%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LIDOCAINE PATCH",
        "route": "Topical",
        "fullName": "LIDOCAINE PATCH (Topical)",
        "totalCount": 14,
        "searchTerms": [
            "Blue-Emu",
            "LIDOCAINE PATCH",
            "Lidocaine Patch",
            "Lidocaine Patch (Topical)",
            "Lidoderm",
            "blue-emu",
            "lidocaine patch",
            "lidocaine patch (topical)",
            "lidoderm"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "43%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "92%"
            }
        ]
    },
    {
        "name": "Latanoprost Ophthalmic Solution",
        "route": "Ophthalmic",
        "fullName": "Latanoprost Ophthalmic Solution (Ophthalmic)",
        "totalCount": 14,
        "searchTerms": [
            "Latanoprost Ophthalmic Solution",
            "Latanoprost Ophthalmic Solution (Ophthalmic)",
            "Xalatan",
            "latanoprost ophthalmic solution",
            "latanoprost ophthalmic solution (ophthalmic)",
            "xalatan"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [
            {
                "value": "Sterile",
                "pct": "43%"
            },
            {
                "value": "For use in the eyes only",
                "pct": "43%"
            }
        ],
        "diagnoses": [
            {
                "code": "H40.10",
                "description": "Unspecified open-angle glaucoma",
                "pct": "86%"
            }
        ]
    },
    {
        "name": "TRAZODONE HYDROCHLORIDE",
        "route": "Oral Pill",
        "fullName": "TRAZODONE HYDROCHLORIDE (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "Desyrel",
            "TRAZODONE HYDROCHLORIDE",
            "Trazodone Hydrochloride",
            "Trazodone Hydrochloride (Oral)",
            "desyrel",
            "trazodone hydrochloride",
            "trazodone hydrochloride (oral)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "79%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "At bedtime",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G47.00",
                "description": "Insomnia, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "CLONIDINE HCL",
        "route": "Oral Pill",
        "fullName": "CLONIDINE HCL (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "CATAPRES",
            "CLONIDINE HCL",
            "CLONIDINE HCL (Oral)",
            "Catapres",
            "Clonidine HCL",
            "Clonidine HCL (Oral)",
            "Clonidine HCl",
            "Clonidine HCl (Oral)",
            "catapres",
            "cloNIDine HCL",
            "cloNIDine HCL (Oral)",
            "cloNIDine HCl",
            "cloNIDine HCl (Oral)",
            "clonidine HCL",
            "clonidine HCL (Oral)",
            "clonidine hcl",
            "clonidine hcl (oral)"
        ],
        "dosages": [
            {
                "value": "0.1 mg",
                "pct": "64%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "69%"
            }
        ]
    },
    {
        "name": "glyBURIDE",
        "route": "Oral Pill",
        "fullName": "glyBURIDE (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "glyBURIDE",
            "glyBURIDE (Oral Pill)",
            "glyburide",
            "glyburide (oral pill)",
            "glyburide 1.25 MG Oral Tablet",
            "glyburide 1.25 mg oral tablet",
            "glyburide 2.5 MG Oral Tablet",
            "glyburide 2.5 mg oral tablet",
            "glyburide 5 MG Oral Tablet",
            "glyburide 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "50%"
            },
            {
                "value": "2.5 mg",
                "pct": "43%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "36%"
            },
            {
                "value": "Twice daily",
                "pct": "36%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Prednisolone Acetate",
        "route": "Ophthalmic",
        "fullName": "Prednisolone Acetate (Ophthalmic)",
        "totalCount": 14,
        "searchTerms": [
            "Pred Forte",
            "Pred-Forte",
            "Prednisolone Acetate",
            "Prednisolone Acetate (Ophthalmic)",
            "pred forte",
            "pred-forte",
            "prednisoLONE Acetate",
            "prednisoLONE Acetate (Ophthalmic)",
            "prednisolone Acetate",
            "prednisolone Acetate (Ophthalmic)",
            "prednisolone acetate",
            "prednisolone acetate (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H20.9",
                "description": "Unspecified iridocyclitis",
                "pct": "85%"
            }
        ]
    },
    {
        "name": "Januvia (sitagliptin)",
        "route": "Oral Pill",
        "fullName": "Januvia (sitagliptin) (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "Januvia (sitagliptin)",
            "Januvia (sitagliptin) (Oral)",
            "januvia (sitagliptin)",
            "januvia (sitagliptin) (oral)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Lantus SoloStar (insulin glargine)",
        "route": "Injectable",
        "fullName": "Lantus SoloStar (insulin glargine) (Injectable)",
        "totalCount": 14,
        "searchTerms": [
            "Lantus SoloStar (Insulin Glargine)",
            "Lantus SoloStar (Insulin Glargine) (Injectable)",
            "Lantus SoloStar (insulin glargine)",
            "Lantus SoloStar (insulin glargine) (Injectable)",
            "Lantus Solostar (insulin glargine)",
            "Lantus Solostar (insulin glargine) (Injectable)",
            "lantus solostar (insulin glargine)",
            "lantus solostar (insulin glargine) (injectable)"
        ],
        "dosages": [
            {
                "value": "100 units",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [
            {
                "value": "For subcutaneous use only",
                "pct": "71%"
            },
            {
                "value": "For single patient use only",
                "pct": "43%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "93%"
            }
        ]
    },
    {
        "name": "Senna S",
        "route": "Oral Pill",
        "fullName": "Senna S (Oral Pill)",
        "totalCount": 14,
        "searchTerms": ["SENNA S", "Senna S", "Senna S (Oral)", "senna s", "senna s (oral)"],
        "dosages": [
            {
                "value": "8.6 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "36%"
            },
            {
                "value": "At bedtime",
                "pct": "36%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROCTOZONE HC",
        "route": "Topical",
        "fullName": "PROCTOZONE HC (Topical)",
        "totalCount": 14,
        "searchTerms": [
            "PROCTOZONE HC",
            "PROCTOZONE HC (Topical)",
            "hydrocortisone 25 MG/ML Topical Cream",
            "hydrocortisone 25 mg/ml topical cream",
            "proctozone hc",
            "proctozone hc (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "36%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FOLBALIN",
        "route": "Oral Pill",
        "fullName": "FOLBALIN (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "FOLBALIN",
            "FOLBALIN (Oral Pill)",
            "folbalin",
            "folbalin (oral pill)",
            "folic acid 2.5 MG / vitamin B12 2 MG / vitamin B6 25 MG Oral Tablet",
            "folic acid 2.5 mg / vitamin b12 2 mg / vitamin b6 25 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "79%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "COLCRYS",
        "route": "Oral Pill",
        "fullName": "COLCRYS (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "COLCRYS",
            "COLCRYS (Oral Pill)",
            "colchicine 0.6 MG Oral Tablet",
            "colchicine 0.6 mg oral tablet",
            "colcrys",
            "colcrys (oral pill)"
        ],
        "dosages": [
            {
                "value": "0.6 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NASCOBAL",
        "route": "Nasal",
        "fullName": "NASCOBAL (Nasal)",
        "totalCount": 14,
        "searchTerms": [
            "NASCOBAL",
            "NASCOBAL (Nasal)",
            "nascobal",
            "nascobal (nasal)",
            "vitamin B12 0.5 MG/ACTUAT Nasal Spray",
            "vitamin b12 0.5 mg/actuat nasal spray"
        ],
        "dosages": [
            {
                "value": "500 mcg",
                "pct": "71%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Acetaminophen/HYDROcodone",
        "route": "Oral Liquid",
        "fullName": "Acetaminophen/HYDROcodone (Oral Liquid)",
        "totalCount": 14,
        "searchTerms": [
            "Acetaminophen/HYDROcodone",
            "Acetaminophen/HYDROcodone (Oral Liquid)",
            "acetaminophen 20 MG/ML / hydrocodone bitartrate 0.667 MG/ML Oral Solution",
            "acetaminophen 20 mg/ml / hydrocodone bitartrate 0.667 mg/ml oral solution",
            "acetaminophen/hydrocodone",
            "acetaminophen/hydrocodone (oral liquid)"
        ],
        "dosages": [
            {
                "value": "300-10 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "36%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DIOVAN HCT",
        "route": "Oral Pill",
        "fullName": "DIOVAN HCT (Oral Pill)",
        "totalCount": 14,
        "searchTerms": [
            "DIOVAN HCT",
            "DIOVAN HCT (Oral Pill)",
            "diovan hct",
            "diovan hct (oral pill)",
            "hydrochlorothiazide 12.5 MG / valsartan 160 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / valsartan 320 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / valsartan 80 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / valsartan 160 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / valsartan 320 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / valsartan 80 mg oral tablet",
            "hydrochlorothiazide 25 MG / valsartan 160 MG Oral Tablet",
            "hydrochlorothiazide 25 MG / valsartan 320 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / valsartan 160 mg oral tablet",
            "hydrochlorothiazide 25 mg / valsartan 320 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Centrum Multivitamin",
        "route": "Oral Pill",
        "fullName": "Centrum Multivitamin (Oral Pill)",
        "totalCount": 14,
        "searchTerms": ["Centrum Multivitamin", "centrum multivitamin"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Desvenlafaxine XR",
        "route": "Oral Pill",
        "fullName": "Desvenlafaxine XR (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "24 HR desvenlafaxine succinate 100 MG Extended Release Oral Tablet",
            "24 HR desvenlafaxine succinate 25 MG Extended Release Oral Tablet",
            "24 HR desvenlafaxine succinate 50 MG Extended Release Oral Tablet",
            "24 hr desvenlafaxine succinate 100 mg extended release oral tablet",
            "24 hr desvenlafaxine succinate 25 mg extended release oral tablet",
            "24 hr desvenlafaxine succinate 50 mg extended release oral tablet",
            "Desvenlafaxine XR",
            "Desvenlafaxine XR (Oral Pill)",
            "desvenlafaxine xr",
            "desvenlafaxine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "54%"
            },
            {
                "value": "100 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VYZULTA",
        "route": "Ophthalmic",
        "fullName": "VYZULTA (Ophthalmic)",
        "totalCount": 13,
        "searchTerms": [
            "VYZULTA",
            "VYZULTA (Ophthalmic)",
            "latanoprostene bunod 0.24 MG/ML Ophthalmic Solution",
            "latanoprostene bunod 0.24 mg/ml ophthalmic solution",
            "vyzulta",
            "vyzulta (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "77%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "Amoxicillin/Clarithromycin/Omeprazole",
        "route": "Pack",
        "fullName": "Amoxicillin/Clarithromycin/Omeprazole (Pack)",
        "totalCount": 13,
        "searchTerms": [
            "Amoxicillin/Clarithromycin/Omeprazole",
            "Amoxicillin/Clarithromycin/Omeprazole (Pack)",
            "amoxicillin/clarithromycin/omeprazole",
            "amoxicillin/clarithromycin/omeprazole (pack)",
            "{4 (amoxicillin 500 MG Oral Capsule) / 2 (clarithromycin 500 MG Oral Tablet) / 2 (omeprazole 20 MG Delayed Release Oral Capsule) } Pack",
            "{4 (amoxicillin 500 mg oral capsule) / 2 (clarithromycin 500 mg oral tablet) / 2 (omeprazole 20 mg delayed release oral capsule) } pack"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "INDERAL XR",
        "route": "Oral Pill",
        "fullName": "INDERAL XR (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "24 HR propranolol hydrochloride 120 MG Extended Release Oral Capsule",
            "24 HR propranolol hydrochloride 60 MG Extended Release Oral Capsule",
            "24 HR propranolol hydrochloride 80 MG Extended Release Oral Capsule",
            "24 hr propranolol hydrochloride 120 mg extended release oral capsule",
            "24 hr propranolol hydrochloride 60 mg extended release oral capsule",
            "24 hr propranolol hydrochloride 80 mg extended release oral capsule",
            "INDERAL",
            "INDERAL XR",
            "INDERAL XR (Oral Pill)",
            "inderal",
            "inderal xr",
            "inderal xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "46%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "lamoTRIgine",
        "route": "Oral Disintegrating",
        "fullName": "lamoTRIgine (Oral Disintegrating)",
        "totalCount": 13,
        "searchTerms": [
            "lamoTRIgine",
            "lamoTRIgine (Oral Disintegrating)",
            "lamotrigine",
            "lamotrigine (oral disintegrating)",
            "lamotrigine 100 MG Disintegrating Oral Tablet",
            "lamotrigine 100 mg disintegrating oral tablet",
            "lamotrigine 25 MG Disintegrating Oral Tablet",
            "lamotrigine 25 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "69%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Nystatin",
        "route": "Oral Pill",
        "fullName": "Nystatin (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "Nystatin",
            "Nystatin (Oral Pill)",
            "nystatin",
            "nystatin (Oral)",
            "nystatin (oral pill)",
            "nystatin (oral)",
            "nystatin 1000000 UNT Oral Capsule",
            "nystatin 1000000 unt oral capsule",
            "nystatin 500000 UNT Oral Capsule",
            "nystatin 500000 unt oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VALTREX",
        "route": "Oral Pill",
        "fullName": "VALTREX (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "VALTREX",
            "VALTREX (Oral Pill)",
            "Valtrex",
            "Valtrex (Oral)",
            "valacyclovir 1000 MG Oral Tablet",
            "valacyclovir 1000 mg oral tablet",
            "valacyclovir 500 MG Oral Tablet",
            "valacyclovir 500 mg oral tablet",
            "valtrex",
            "valtrex (oral pill)",
            "valtrex (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Rizatriptan",
        "route": "Oral Pill",
        "fullName": "Rizatriptan (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "Rizatriptan",
            "Rizatriptan (Oral Pill)",
            "Rizatriptan (Oral)",
            "rizatriptan",
            "rizatriptan (Oral)",
            "rizatriptan (oral pill)",
            "rizatriptan (oral)",
            "rizatriptan 10 MG Oral Tablet",
            "rizatriptan 10 mg oral tablet",
            "rizatriptan 5 MG Oral Tablet",
            "rizatriptan 5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "77%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "46%"
            },
            {
                "value": "Once daily",
                "pct": "46%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Tacrolimus XR",
        "route": "Oral Pill",
        "fullName": "Tacrolimus XR (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "24 HR tacrolimus 0.5 MG Extended Release Oral Capsule",
            "24 HR tacrolimus 1 MG Extended Release Oral Capsule",
            "24 HR tacrolimus 1 MG Extended Release Oral Tablet",
            "24 HR tacrolimus 4 MG Extended Release Oral Tablet",
            "24 hr tacrolimus 0.5 mg extended release oral capsule",
            "24 hr tacrolimus 1 mg extended release oral capsule",
            "24 hr tacrolimus 1 mg extended release oral tablet",
            "24 hr tacrolimus 4 mg extended release oral tablet",
            "Tacrolimus XR",
            "Tacrolimus XR (Oral Pill)",
            "tacrolimus xr",
            "tacrolimus xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "38%"
            },
            {
                "value": "Twice daily",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Montelukast",
        "route": "Chewable",
        "fullName": "Montelukast (Chewable)",
        "totalCount": 13,
        "searchTerms": [
            "Montelukast",
            "Montelukast (Chewable)",
            "montelukast",
            "montelukast (chewable)",
            "montelukast 4 MG Chewable Tablet",
            "montelukast 4 mg chewable tablet",
            "montelukast 5 MG Chewable Tablet",
            "montelukast 5 mg chewable tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "46%"
            },
            {
                "value": "5 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Atropine",
        "route": "Ophthalmic",
        "fullName": "Atropine (Ophthalmic)",
        "totalCount": 13,
        "searchTerms": [
            "Atropine",
            "Atropine (Ophthalmic)",
            "atropine",
            "atropine (ophthalmic)",
            "atropine sulfate 0.01 MG/MG Ophthalmic Ointment",
            "atropine sulfate 0.01 mg/mg ophthalmic ointment"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "IMITREX",
        "route": "Oral Pill",
        "fullName": "IMITREX (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "IMITREX",
            "IMITREX (Oral Pill)",
            "imitrex",
            "imitrex (oral pill)",
            "sumatriptan 100 MG Oral Tablet",
            "sumatriptan 100 mg oral tablet",
            "sumatriptan 25 MG Oral Tablet",
            "sumatriptan 25 mg oral tablet",
            "sumatriptan 50 MG Oral Tablet",
            "sumatriptan 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "54%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "46%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ODEFSEY",
        "route": "Oral Pill",
        "fullName": "ODEFSEY (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "ODEFSEY",
            "ODEFSEY (Oral Pill)",
            "emtricitabine 200 MG / rilpivirine 25 MG / tenofovir alafenamide 25 MG Oral Tablet",
            "emtricitabine 200 mg / rilpivirine 25 mg / tenofovir alafenamide 25 mg oral tablet",
            "odefsey",
            "odefsey (oral pill)"
        ],
        "dosages": [
            {
                "value": "200-25-25 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B20",
                "description": "Human immunodeficiency virus [HIV] disease",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "SYMTUZA",
        "route": "Oral Pill",
        "fullName": "SYMTUZA (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "SYMTUZA",
            "SYMTUZA (Oral Pill)",
            "Symtuza",
            "Symtuza (Oral)",
            "cobicistat 150 MG / darunavir 800 MG / emtricitabine 200 MG / tenofovir alafenamide 10 MG Oral Tablet",
            "cobicistat 150 mg / darunavir 800 mg / emtricitabine 200 mg / tenofovir alafenamide 10 mg oral tablet",
            "symtuza",
            "symtuza (oral pill)",
            "symtuza (oral)"
        ],
        "dosages": [
            {
                "value": "150-800-200-10 mg",
                "pct": "85%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B20",
                "description": "Human immunodeficiency virus [HIV] disease",
                "pct": "88%"
            }
        ]
    },
    {
        "name": "Fosinopril",
        "route": "Oral Pill",
        "fullName": "Fosinopril (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "Fosinopril",
            "Fosinopril (Oral Pill)",
            "Fosinopril (Oral)",
            "fosinopril",
            "fosinopril (oral pill)",
            "fosinopril (oral)",
            "fosinopril sodium 10 MG Oral Tablet",
            "fosinopril sodium 10 mg oral tablet",
            "fosinopril sodium 20 MG Oral Tablet",
            "fosinopril sodium 20 mg oral tablet",
            "fosinopril sodium 40 MG Oral Tablet",
            "fosinopril sodium 40 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "Calcium carbonate/Folic acid/Pyridoxine/Vitamin B12 XR",
        "route": "Oral Pill",
        "fullName": "Calcium carbonate/Folic acid/Pyridoxine/Vitamin B12 XR (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "24 HR calcium carbonate 200 MG / folic acid 1 MG / pyridoxine 75 MG / vitamin B12 0.012 MG Extended Release Oral Tablet",
            "24 hr calcium carbonate 200 mg / folic acid 1 mg / pyridoxine 75 mg / vitamin b12 0.012 mg extended release oral tablet",
            "Calcium carbonate/Folic acid/Pyridoxine/Vitamin B12 XR",
            "Calcium carbonate/Folic acid/Pyridoxine/Vitamin B12 XR (Oral Pill)",
            "calcium carbonate/folic acid/pyridoxine/vitamin b12 xr",
            "calcium carbonate/folic acid/pyridoxine/vitamin b12 xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "200-1-75-0.012 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TRULANCE",
        "route": "Oral Pill",
        "fullName": "TRULANCE (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "TRULANCE",
            "TRULANCE (Oral Pill)",
            "Trulance",
            "Trulance (Oral)",
            "plecanatide 3 MG Oral Tablet",
            "plecanatide 3 mg oral tablet",
            "trulance",
            "trulance (oral pill)",
            "trulance (oral)"
        ],
        "dosages": [
            {
                "value": "3 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "77%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "morphine",
        "route": "Oral Pill",
        "fullName": "morphine (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "Morphine",
            "Morphine (Oral Pill)",
            "Morphine (Oral)",
            "morphine",
            "morphine (oral pill)",
            "morphine (oral)"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "69%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "Tolterodine",
        "route": "Oral Pill",
        "fullName": "Tolterodine (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "Tolterodine",
            "Tolterodine (Oral Pill)",
            "Tolterodine (Oral)",
            "tolterodine",
            "tolterodine (oral pill)",
            "tolterodine (oral)",
            "tolterodine tartrate 1 MG Oral Tablet",
            "tolterodine tartrate 1 mg oral tablet",
            "tolterodine tartrate 2 MG Oral Tablet",
            "tolterodine tartrate 2 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "92%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "46%"
            },
            {
                "value": "Once daily",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EDARBI",
        "route": "Oral Pill",
        "fullName": "EDARBI (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "EDARBI",
            "EDARBI (Oral Pill)",
            "azilsartan medoxomil 40 MG Oral Tablet",
            "azilsartan medoxomil 40 mg oral tablet",
            "azilsartan medoxomil 80 MG Oral Tablet",
            "azilsartan medoxomil 80 mg oral tablet",
            "edarbi",
            "edarbi (oral pill)"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "69%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "77%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cholestyramine resin",
        "route": "Oral Suspension Powder",
        "fullName": "Cholestyramine resin (Oral Suspension Powder)",
        "totalCount": 13,
        "searchTerms": [
            "Cholestyramine resin",
            "Cholestyramine resin (Oral Suspension Powder)",
            "Sugar-Free cholestyramine resin 4000 MG Powder for Oral Suspension",
            "cholestyramine resin",
            "cholestyramine resin (oral suspension powder)",
            "cholestyramine resin 4000 MG Powder for Oral Suspension",
            "cholestyramine resin 4000 mg powder for oral suspension",
            "sugar-free cholestyramine resin 4000 mg powder for oral suspension"
        ],
        "dosages": [
            {
                "value": "4 g",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "69%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Sodium chloride",
        "route": "Nasal",
        "fullName": "Sodium chloride (Nasal)",
        "totalCount": 13,
        "searchTerms": [
            "Sodium chloride",
            "Sodium chloride (Nasal)",
            "sodium chloride",
            "sodium chloride (nasal)",
            "sodium chloride 0.0342 MEQ/ML Nasal Spray",
            "sodium chloride 0.0342 meq/ml nasal spray",
            "sodium chloride 0.359 MEQ/ML Nasal Solution",
            "sodium chloride 0.359 meq/ml nasal solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "38%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Propranolol XR",
        "route": "Oral Pill",
        "fullName": "Propranolol XR (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "24 HR propranolol hydrochloride 120 MG Extended Release Oral Capsule",
            "24 HR propranolol hydrochloride 60 MG Extended Release Oral Capsule",
            "24 HR propranolol hydrochloride 80 MG Extended Release Oral Capsule",
            "24 hr propranolol hydrochloride 120 mg extended release oral capsule",
            "24 hr propranolol hydrochloride 60 mg extended release oral capsule",
            "24 hr propranolol hydrochloride 80 mg extended release oral capsule",
            "Propranolol XR",
            "Propranolol XR (Oral Pill)",
            "propranolol xr",
            "propranolol xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "80 mg",
                "pct": "46%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Magnesium",
        "route": "Supplement",
        "fullName": "Magnesium (Supplement)",
        "totalCount": 13,
        "searchTerms": [
            "MAGNESIUM",
            "Magnesium",
            "Magnesium (Supplement)",
            "magnesium",
            "magnesium (supplement)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "85%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Carbidopa-Levodopa",
        "route": "Oral Pill",
        "fullName": "Carbidopa-Levodopa (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "Carbidopa-Levodopa",
            "Carbidopa-Levodopa (Oral)",
            "Carbidopa-levodopa",
            "Carbidopa-levodopa (Oral)",
            "carbidopa-levodopa",
            "carbidopa-levodopa (Oral)",
            "carbidopa-levodopa (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G20",
                "description": "Parkinson's disease",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Haloperidol",
        "route": "Oral Liquid",
        "fullName": "Haloperidol (Oral Liquid)",
        "totalCount": 13,
        "searchTerms": [
            "Haloperidol",
            "Haloperidol (Oral Liquid)",
            "haloperidol",
            "haloperidol (oral liquid)",
            "haloperidol 2 MG/ML Oral Solution",
            "haloperidol 2 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "54%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Tizanidine HCl",
        "route": "Oral Pill",
        "fullName": "Tizanidine HCl (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "TIZANIDINE HCL",
            "TIZANIDINE HCL (Oral)",
            "Tizanidine HCL",
            "Tizanidine HCL (Oral)",
            "Tizanidine HCl",
            "Tizanidine HCl (Oral)",
            "Zanaflex",
            "tIZANidine HCL",
            "tIZANidine HCL (Oral)",
            "tiZANidine HCL",
            "tiZANidine HCL (Oral)",
            "tiZANidine HCl",
            "tiZANidine HCl (Oral)",
            "tizanidine hcl",
            "tizanidine hcl (oral)",
            "zanaflex"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "54%"
            },
            {
                "value": "2 mg",
                "pct": "46%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M62.838",
                "description": "Other muscle spasm",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Nature's Bounty D3 - Supplement",
        "route": "Oral Pill",
        "fullName": "Nature's Bounty D3 - Supplement (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "Nature's Bounty D3 - Supplement",
            "Nature's Bounty D3 - Supplement (Oral)",
            "nature's bounty d3 - supplement",
            "nature's bounty d3 - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "25 mcg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "Rapid release softgels",
                "pct": "62%"
            }
        ],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "77%"
            }
        ]
    },
    {
        "name": "Artificial Tears",
        "route": "Ophthalmic",
        "fullName": "Artificial Tears (Ophthalmic)",
        "totalCount": 13,
        "searchTerms": [
            "ARTIFICIAL TEARS",
            "Artificial Tears",
            "Artificial Tears (Ophthalmic)",
            "Refresh Tears",
            "artificial tears",
            "artificial tears (ophthalmic)",
            "refresh tears"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "WIXELA",
        "route": "Inhalant",
        "fullName": "WIXELA (Inhalant)",
        "totalCount": 13,
        "searchTerms": [
            "60 ACTUAT fluticasone propionate 0.1 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "60 ACTUAT fluticasone propionate 0.25 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "60 ACTUAT fluticasone propionate 0.5 MG/ACTUAT / salmeterol 0.05 MG/ACTUAT Dry Powder Inhaler",
            "60 actuat fluticasone propionate 0.1 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "60 actuat fluticasone propionate 0.25 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "60 actuat fluticasone propionate 0.5 mg/actuat / salmeterol 0.05 mg/actuat dry powder inhaler",
            "WIXELA",
            "WIXELA (Inhalant)",
            "wixela",
            "wixela (inhalant)"
        ],
        "dosages": [
            {
                "value": "100-50 mcg",
                "pct": "38%"
            },
            {
                "value": "250-50 mcg",
                "pct": "38%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "46%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "metoprolol succ",
        "route": "Oral Pill",
        "fullName": "metoprolol succ (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "METOPROLOL SUCC",
            "METOPROLOL SUCC (Oral)",
            "Metoprolol Succ",
            "Metoprolol Succ (Oral)",
            "Metoprolol Succ.",
            "Metoprolol Succ. (Oral)",
            "Toprol XL",
            "metoprolol succ",
            "metoprolol succ (oral)",
            "metoprolol succ.",
            "metoprolol succ. (oral)",
            "toprol xl"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "46%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "69%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "90%"
            }
        ]
    },
    {
        "name": "Fluticasone Propionate Nasal Spray",
        "route": "Nasal",
        "fullName": "Fluticasone Propionate Nasal Spray (Nasal)",
        "totalCount": 13,
        "searchTerms": [
            "Flonase",
            "Flonase 50 mcg/inh aerosol",
            "Fluticasone Propionate Nasal Spray",
            "Fluticasone Propionate Nasal Spray (Nasal)",
            "flonase",
            "flonase 50 mcg/inh aerosol",
            "fluticasone propionate nasal spray",
            "fluticasone propionate nasal spray (Nasal)",
            "fluticasone propionate nasal spray (nasal)"
        ],
        "dosages": [
            {
                "value": "50 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "ISOSORBIDE MONONITRATE",
        "route": "Oral Pill",
        "fullName": "ISOSORBIDE MONONITRATE (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "IMDUR",
            "ISOSORBIDE MONONITRATE",
            "ISOSORBIDE MONONITRATE (Oral)",
            "Imdur",
            "Isosorbide Mononitrate",
            "Isosorbide Mononitrate (Oral)",
            "Isosorbide mononitrate",
            "Isosorbide mononitrate (Oral)",
            "imdur",
            "isosorbide mononitrate",
            "isosorbide mononitrate (Oral)",
            "isosorbide mononitrate (oral)"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "54%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "RAPAFLO",
        "route": "Oral Pill",
        "fullName": "RAPAFLO (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "RAPAFLO",
            "RAPAFLO (Oral Pill)",
            "rapaflo",
            "rapaflo (oral pill)",
            "silodosin 4 MG Oral Capsule",
            "silodosin 4 mg oral capsule",
            "silodosin 8 MG Oral Capsule",
            "silodosin 8 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "8 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FIORICET",
        "route": "Oral Pill",
        "fullName": "FIORICET (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "FIORICET",
            "FIORICET (Oral Pill)",
            "acetaminophen 300 MG / butalbital 50 MG / caffeine 40 MG Oral Capsule",
            "acetaminophen 300 mg / butalbital 50 mg / caffeine 40 mg oral capsule",
            "acetaminophen 325 MG / butalbital 50 MG / caffeine 40 MG Oral Tablet",
            "acetaminophen 325 mg / butalbital 50 mg / caffeine 40 mg oral tablet",
            "fioricet",
            "fioricet (oral pill)"
        ],
        "dosages": [
            {
                "value": "300-50-40 mg",
                "pct": "38%"
            },
            {
                "value": "325-50-40 mg",
                "pct": "38%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "REQUIP",
        "route": "Oral Pill",
        "fullName": "REQUIP (Oral Pill)",
        "totalCount": 13,
        "searchTerms": [
            "REQUIP",
            "REQUIP (Oral Pill)",
            "requip",
            "requip (oral pill)",
            "ropinirole 0.25 MG Oral Tablet",
            "ropinirole 0.25 mg oral tablet",
            "ropinirole 0.5 MG Oral Tablet",
            "ropinirole 0.5 mg oral tablet",
            "ropinirole 1 MG Oral Tablet",
            "ropinirole 1 mg oral tablet",
            "ropinirole 4 MG Oral Tablet",
            "ropinirole 4 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.25 mg",
                "pct": "46%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "54%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HALDOL",
        "route": "Oral Pill",
        "fullName": "HALDOL (Oral Pill)",
        "totalCount": 13,
        "searchTerms": ["Haldol", "Haldol (Oral)", "haldol", "haldol (oral)"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NUPLAZID",
        "route": "Oral Pill",
        "fullName": "NUPLAZID (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "NUPLAZID",
            "NUPLAZID (Oral Pill)",
            "Nuplazid",
            "Nuplazid (Oral)",
            "nuplazid",
            "nuplazid (oral pill)",
            "nuplazid (oral)",
            "pimavanserin 34 MG Oral Capsule",
            "pimavanserin 34 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "34 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Vitamin B1",
        "route": "Oral Pill",
        "fullName": "Vitamin B1 (Oral Pill)",
        "totalCount": 12,
        "searchTerms": ["VITAMIN B1", "Vitamin B1", "vitamin b1"],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "GENVOYA",
        "route": "Oral Pill",
        "fullName": "GENVOYA (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "GENVOYA",
            "GENVOYA (Oral Pill)",
            "Genvoya",
            "Genvoya (Oral)",
            "cobicistat 150 MG / elvitegravir 150 MG / emtricitabine 200 MG / tenofovir alafenamide 10 MG Oral Tablet",
            "cobicistat 150 mg / elvitegravir 150 mg / emtricitabine 200 mg / tenofovir alafenamide 10 mg oral tablet",
            "genvoya",
            "genvoya (oral pill)",
            "genvoya (oral)"
        ],
        "dosages": [
            {
                "value": "150-150-200-10 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DEPO-PROVERA",
        "route": "Injectable",
        "fullName": "DEPO-PROVERA (Injectable)",
        "totalCount": 12,
        "searchTerms": [
            "1 ML medroxyprogesterone acetate 150 MG/ML Injection",
            "1 ML medroxyprogesterone acetate 150 MG/ML Prefilled Syringe",
            "1 ml medroxyprogesterone acetate 150 mg/ml injection",
            "1 ml medroxyprogesterone acetate 150 mg/ml prefilled syringe",
            "DEPO-PROVERA",
            "DEPO-PROVERA (Injectable)",
            "depo-provera",
            "depo-provera (injectable)",
            "medroxyprogesterone acetate 400 MG/ML Injectable Suspension",
            "medroxyprogesterone acetate 400 mg/ml injectable suspension"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ammonia",
        "route": "Topical",
        "fullName": "Ammonia (Topical)",
        "totalCount": 12,
        "searchTerms": [
            "Ammonia",
            "Ammonia (Topical)",
            "ammonia",
            "ammonia (topical)",
            "ammonia 15 MG/ML Topical Lotion",
            "ammonia 15 mg/ml topical lotion"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DUPIXENT",
        "route": "Injectable",
        "fullName": "DUPIXENT (Injectable)",
        "totalCount": 12,
        "searchTerms": [
            "2 ML dupilumab 150 MG/ML Prefilled Syringe",
            "2 ml dupilumab 150 mg/ml prefilled syringe",
            "DUPIXENT",
            "DUPIXENT (Injectable)",
            "dupixent",
            "dupixent (injectable)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "92%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "AMLACTIN",
        "route": "Topical",
        "fullName": "AMLACTIN (Topical)",
        "totalCount": 12,
        "searchTerms": [
            "AMLACTIN",
            "AMLACTIN (Topical)",
            "amlactin",
            "amlactin (topical)",
            "ammonium lactate 120 MG/ML Topical Lotion",
            "ammonium lactate 120 mg/ml topical lotion"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "IFEREX",
        "route": "Oral Pill",
        "fullName": "IFEREX (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "IFEREX",
            "IFEREX (Oral Pill)",
            "iferex",
            "iferex (oral pill)",
            "polysaccharide iron complex 150 MG Oral Capsule",
            "polysaccharide iron complex 150 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "58%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROCARDIA XR",
        "route": "Oral Pill",
        "fullName": "PROCARDIA XR (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "Osmotic 24 HR nifedipine 30 MG Extended Release Oral Tablet",
            "Osmotic 24 HR nifedipine 60 MG Extended Release Oral Tablet",
            "Osmotic 24 HR nifedipine 90 MG Extended Release Oral Tablet",
            "PROCARDIA",
            "PROCARDIA XR",
            "PROCARDIA XR (Oral Pill)",
            "osmotic 24 hr nifedipine 30 mg extended release oral tablet",
            "osmotic 24 hr nifedipine 60 mg extended release oral tablet",
            "osmotic 24 hr nifedipine 90 mg extended release oral tablet",
            "procardia",
            "procardia xr",
            "procardia xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "sulfaSALAzine",
        "route": "Oral Pill",
        "fullName": "sulfaSALAzine (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "Sulfasalazine",
            "Sulfasalazine (Oral)",
            "sulfaSALAzine",
            "sulfaSALAzine (Oral Pill)",
            "sulfasalazine",
            "sulfasalazine (oral pill)",
            "sulfasalazine (oral)",
            "sulfasalazine 500 MG Oral Tablet",
            "sulfasalazine 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "92%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "58%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LOPRESSOR HCT",
        "route": "Oral Pill",
        "fullName": "LOPRESSOR HCT (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "LOPRESSOR HCT",
            "LOPRESSOR HCT (Oral Pill)",
            "hydrochlorothiazide 25 MG / metoprolol tartrate 100 MG Oral Tablet",
            "hydrochlorothiazide 25 MG / metoprolol tartrate 50 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / metoprolol tartrate 100 mg oral tablet",
            "hydrochlorothiazide 25 mg / metoprolol tartrate 50 mg oral tablet",
            "hydrochlorothiazide 50 MG / metoprolol tartrate 100 MG Oral Tablet",
            "hydrochlorothiazide 50 mg / metoprolol tartrate 100 mg oral tablet",
            "lopressor hct",
            "lopressor hct (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Omeprazole/Sodium bicarbonate",
        "route": "Oral Pill",
        "fullName": "Omeprazole/Sodium bicarbonate (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "Omeprazole/Sodium bicarbonate",
            "Omeprazole/Sodium bicarbonate (Oral Pill)",
            "omeprazole 20 MG / sodium bicarbonate 1100 MG Oral Capsule",
            "omeprazole 20 mg / sodium bicarbonate 1100 mg oral capsule",
            "omeprazole/sodium bicarbonate",
            "omeprazole/sodium bicarbonate (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "58%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "55%"
            }
        ]
    },
    {
        "name": "SINEMET",
        "route": "Oral Pill",
        "fullName": "SINEMET (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "SINEMET",
            "SINEMET (Oral Pill)",
            "Sinemet",
            "Sinemet (Oral)",
            "carbidopa 10 MG / levodopa 100 MG Oral Tablet",
            "carbidopa 10 mg / levodopa 100 mg oral tablet",
            "carbidopa 25 MG / levodopa 100 MG Oral Tablet",
            "carbidopa 25 mg / levodopa 100 mg oral tablet",
            "sinemet",
            "sinemet (oral pill)",
            "sinemet (oral)"
        ],
        "dosages": [
            {
                "value": "25-100 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lutein",
        "route": "Oral Pill",
        "fullName": "Lutein (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "LUTEIN",
            "Lutein",
            "Lutein (Oral Pill)",
            "lutein",
            "lutein (oral pill)",
            "lutein 10 MG Oral Tablet",
            "lutein 10 mg oral tablet",
            "lutein 20 MG Oral Capsule",
            "lutein 20 mg oral capsule",
            "lutein 6 MG Oral Tablet",
            "lutein 6 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NEXLIZET",
        "route": "Oral Pill",
        "fullName": "NEXLIZET (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "NEXLIZET",
            "NEXLIZET (Oral Pill)",
            "Nexlizet",
            "Nexlizet (Oral)",
            "nexlizet",
            "nexlizet (oral pill)",
            "nexlizet (oral)"
        ],
        "dosages": [
            {
                "value": "180-10 mg",
                "pct": "92%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "Zinc oxide",
        "route": "Topical",
        "fullName": "Zinc oxide (Topical)",
        "totalCount": 12,
        "searchTerms": [
            "ZINC OXIDE",
            "Zinc oxide",
            "Zinc oxide (Topical)",
            "zinc oxide",
            "zinc oxide (topical)",
            "zinc oxide 0.018 MG/MG Topical Ointment",
            "zinc oxide 0.018 mg/mg topical ointment"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MOVANTIK",
        "route": "Oral Pill",
        "fullName": "MOVANTIK (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "MOVANTIK",
            "MOVANTIK (Oral Pill)",
            "movantik",
            "movantik (oral pill)",
            "naloxegol 12.5 MG Oral Tablet",
            "naloxegol 12.5 mg oral tablet",
            "naloxegol 25 MG Oral Tablet",
            "naloxegol 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "92%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "Acetaminophen/Codeine",
        "route": "Oral Pill",
        "fullName": "Acetaminophen/Codeine (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "ACETAMINOPHEN/CODEINE",
            "Acetaminophen/Codeine",
            "Acetaminophen/Codeine (Oral Pill)",
            "Acetaminophen/Codeine (Oral)",
            "acetaminophen 300 MG / codeine phosphate 30 MG Oral Tablet",
            "acetaminophen 300 mg / codeine phosphate 30 mg oral tablet",
            "acetaminophen/codeine",
            "acetaminophen/codeine (oral pill)",
            "acetaminophen/codeine (oral)"
        ],
        "dosages": [
            {
                "value": "300-30 mg",
                "pct": "58%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "medroxyPROGESTERone",
        "route": "Oral Pill",
        "fullName": "medroxyPROGESTERone (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "Medroxyprogesterone",
            "Medroxyprogesterone (Oral)",
            "Provera",
            "medroxyPROGESTERone",
            "medroxyPROGESTERone (Oral Pill)",
            "medroxyprogesterone",
            "medroxyprogesterone (oral pill)",
            "medroxyprogesterone (oral)",
            "medroxyprogesterone acetate 10 MG Oral Tablet",
            "medroxyprogesterone acetate 10 mg oral tablet",
            "medroxyprogesterone acetate 2.5 MG Oral Tablet",
            "medroxyprogesterone acetate 2.5 mg oral tablet",
            "medroxyprogesterone acetate 5 MG Oral Tablet",
            "medroxyprogesterone acetate 5 mg oral tablet",
            "provera"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "67%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OCUVITE LUTEIN",
        "route": "Oral Pill",
        "fullName": "OCUVITE LUTEIN (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "OCUVITE LUTEIN",
            "OCUVITE LUTEIN (Oral Pill)",
            "ascorbic acid 60 MG / cuprous oxide 2 MG / dl-alpha tocopheryl acetate 30 MG / lutein 6 MG / zinc oxide 15 MG Oral Capsule",
            "ascorbic acid 60 mg / cuprous oxide 2 mg / dl-alpha tocopheryl acetate 30 mg / lutein 6 mg / zinc oxide 15 mg oral capsule",
            "ocuvite lutein",
            "ocuvite lutein (oral pill)"
        ],
        "dosages": [
            {
                "value": "60-2-30-6-15 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "GAVILAX",
        "route": "Oral Solution Powder",
        "fullName": "GAVILAX (Oral Solution Powder)",
        "totalCount": 12,
        "searchTerms": [
            "GAVILAX",
            "GAVILAX (Oral Solution Powder)",
            "GaviLax",
            "gavilax",
            "gavilax (oral solution powder)",
            "polyethylene glycol 3350 17000 MG Powder for Oral Solution",
            "polyethylene glycol 3350 17000 mg powder for oral solution"
        ],
        "dosages": [
            {
                "value": "17 g",
                "pct": "92%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Farxiga (dapagliflozin)",
        "route": "Oral Pill",
        "fullName": "Farxiga (dapagliflozin) (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "Farxiga (Dapagliflozin)",
            "Farxiga (Dapagliflozin) (Oral)",
            "Farxiga (dapagliflozin)",
            "Farxiga (dapagliflozin) (Oral)",
            "farxiga (dapagliflozin)",
            "farxiga (dapagliflozin) (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "Dispense with Medication Guide",
                "pct": "58%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "NovoLog FlexPen (insulin aspart)",
        "route": "Injectable",
        "fullName": "NovoLog FlexPen (insulin aspart) (Injectable)",
        "totalCount": 12,
        "searchTerms": [
            "NovoLog FlexPen (insulin aspart)",
            "NovoLog FlexPen (insulin aspart) (Injectable)",
            "novolog flexpen (insulin aspart)",
            "novolog flexpen (insulin aspart) (injectable)"
        ],
        "dosages": [
            {
                "value": "100 units",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "Mounjaro (tirzepatide)",
        "route": "Injectable",
        "fullName": "Mounjaro (tirzepatide) (Injectable)",
        "totalCount": 12,
        "searchTerms": [
            "Mounjaro (Tirzepatide)",
            "Mounjaro (Tirzepatide) (Injectable)",
            "Mounjaro (tirzepatide)",
            "Mounjaro (tirzepatide) (Injectable)",
            "mounjaro (tirzepatide)",
            "mounjaro (tirzepatide) (injectable)"
        ],
        "dosages": [
            {
                "value": "2.5 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "92%"
            }
        ]
    },
    {
        "name": "METOPROLOL ER",
        "route": "Oral Pill",
        "fullName": "METOPROLOL ER (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "METOPROLOL ER",
            "METOPROLOL ER (Oral)",
            "Metoprolol ER",
            "Metoprolol ER (Oral)",
            "TOPROL XL",
            "Toprol XL",
            "metoprolol er",
            "metoprolol er (oral)",
            "toprol xl"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "82%"
            }
        ]
    },
    {
        "name": "OXYCODONE HCL",
        "route": "Oral Pill",
        "fullName": "OXYCODONE HCL (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "OXYCODONE HCL",
            "OXYCODONE HCL (Oral)",
            "Oxaydo",
            "Oxycodone HCL",
            "Oxycodone HCL (Oral)",
            "Oxycodone HCl",
            "Oxycodone HCl (Oral)",
            "ROXICODONE",
            "Roxicodone",
            "oxaydo",
            "oxyCODONE HCL",
            "oxyCODONE HCL (Oral)",
            "oxyCODONE HCl",
            "oxyCODONE HCl (Oral)",
            "oxycodone hcl",
            "oxycodone hcl (oral)",
            "roxicodone"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "89%"
            }
        ]
    },
    {
        "name": "NovoLog FlexPen",
        "route": "Injectable",
        "fullName": "NovoLog FlexPen (Injectable)",
        "totalCount": 12,
        "searchTerms": [
            "NovoLOG FlexPen",
            "NovoLOG FlexPen (Injectable)",
            "NovoLog FlexPen",
            "NovoLog FlexPen (Injectable)",
            "Novolog FlexPen",
            "Novolog FlexPen (Injectable)",
            "Novolog Flexpen",
            "Novolog Flexpen (Injectable)",
            "novolog flexpen",
            "novolog flexpen (injectable)"
        ],
        "dosages": [
            {
                "value": "100 units",
                "pct": "92%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Basaglar KwikPen",
        "route": "Injectable",
        "fullName": "Basaglar KwikPen (Injectable)",
        "totalCount": 12,
        "searchTerms": [
            "Basaglar KwikPen",
            "Basaglar KwikPen (Injectable)",
            "Basaglar Kwikpen",
            "Basaglar Kwikpen (Injectable)",
            "basaglar kwikpen",
            "basaglar kwikpen (injectable)"
        ],
        "dosages": [
            {
                "value": "100 units",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "DULOXETINE HCL",
        "route": "Oral Pill",
        "fullName": "DULOXETINE HCL (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "CYMBALTA",
            "Cymbalta",
            "DULOXETINE HCL",
            "DULOXETINE HCL (Oral)",
            "Duloxetine HCL",
            "Duloxetine HCL (Oral)",
            "Duloxetine HCl",
            "Duloxetine HCl (Oral)",
            "cymbalta",
            "duloxetine hcl",
            "duloxetine hcl (oral)"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "88%"
            }
        ]
    },
    {
        "name": "ALBUTEROL HFA",
        "route": "Inhaler",
        "fullName": "ALBUTEROL HFA (Inhaler)",
        "totalCount": 12,
        "searchTerms": [
            "ALBUTEROL HFA",
            "Albuterol HFA",
            "Albuterol HFA (Inhaler)",
            "albuterol HFA",
            "albuterol HFA (Inhaler)",
            "albuterol hfa",
            "albuterol hfa (inhaler)"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "91%"
            }
        ]
    },
    {
        "name": "chlorproMAZINE",
        "route": "Oral Pill",
        "fullName": "chlorproMAZINE (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "Chlorpromazine",
            "Chlorpromazine (Oral)",
            "chlorproMAZINE",
            "chlorproMAZINE (Oral Pill)",
            "chlorpromazine",
            "chlorpromazine (oral pill)",
            "chlorpromazine (oral)",
            "chlorpromazine hydrochloride 10 MG Oral Tablet",
            "chlorpromazine hydrochloride 10 mg oral tablet",
            "chlorpromazine hydrochloride 200 MG Oral Tablet",
            "chlorpromazine hydrochloride 200 mg oral tablet",
            "chlorpromazine hydrochloride 25 MG Oral Tablet",
            "chlorpromazine hydrochloride 25 mg oral tablet",
            "chlorpromazine hydrochloride 50 MG Oral Tablet",
            "chlorpromazine hydrochloride 50 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "58%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PRALUENT",
        "route": "Injectable",
        "fullName": "PRALUENT (Injectable)",
        "totalCount": 12,
        "searchTerms": [
            "1 ML alirocumab 150 MG/ML Prefilled Syringe",
            "1 ML alirocumab 75 MG/ML Prefilled Syringe",
            "1 ml alirocumab 150 mg/ml prefilled syringe",
            "1 ml alirocumab 75 mg/ml prefilled syringe",
            "PRALUENT",
            "PRALUENT (Injectable)",
            "praluent",
            "praluent (injectable)"
        ],
        "dosages": [
            {
                "value": "75 mg",
                "pct": "58%"
            },
            {
                "value": "150 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "ACETAMINOPHEN EXTRA STRENGTH",
        "route": "Oral Pill",
        "fullName": "ACETAMINOPHEN EXTRA STRENGTH (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "ACETAMINOPHEN EXTRA STRENGTH",
            "Acetaminophen Extra Strength",
            "Acetaminophen Extra Strength (Oral)",
            "Tylenol Extra Strength",
            "acetaminophen extra strength",
            "acetaminophen extra strength (oral)",
            "tylenol extra strength"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "92%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "91%"
            }
        ]
    },
    {
        "name": "Ipratropium",
        "route": "Nasal",
        "fullName": "Ipratropium (Nasal)",
        "totalCount": 12,
        "searchTerms": [
            "Ipratropium",
            "Ipratropium (Nasal)",
            "ipratropium",
            "ipratropium (nasal)",
            "ipratropium bromide 0.021 MG/ACTUAT Metered Dose Nasal Spray",
            "ipratropium bromide 0.021 mg/actuat metered dose nasal spray",
            "ipratropium bromide 0.042 MG/ACTUAT Metered Dose Nasal Spray",
            "ipratropium bromide 0.042 mg/actuat metered dose nasal spray"
        ],
        "dosages": [
            {
                "value": "21 mcg",
                "pct": "42%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EXELON",
        "route": "Transdermal",
        "fullName": "EXELON (Transdermal)",
        "totalCount": 12,
        "searchTerms": [
            "24 HR rivastigmine 0.192 MG/HR Transdermal System",
            "24 HR rivastigmine 0.396 MG/HR Transdermal System",
            "24 HR rivastigmine 0.554 MG/HR Transdermal System",
            "24 hr rivastigmine 0.192 mg/hr transdermal system",
            "24 hr rivastigmine 0.396 mg/hr transdermal system",
            "24 hr rivastigmine 0.554 mg/hr transdermal system",
            "EXELON",
            "EXELON (Transdermal)",
            "exelon",
            "exelon (transdermal)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "acetaminophen (TYLENOL)",
        "route": "Oral Pill",
        "fullName": "acetaminophen (TYLENOL) (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "Acetaminophen (Tylenol)",
            "Acetaminophen (Tylenol) (Oral)",
            "acetaminophen (TYLENOL)",
            "acetaminophen (TYLENOL) (Oral)",
            "acetaminophen (Tylenol)",
            "acetaminophen (Tylenol) (Oral)",
            "acetaminophen (tylenol)",
            "acetaminophen (tylenol) (oral)"
        ],
        "dosages": [
            {
                "value": "325 mg",
                "pct": "58%"
            },
            {
                "value": "500 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "92%"
            }
        ]
    },
    {
        "name": "BREO ELLIPTA",
        "route": "Inhaler",
        "fullName": "BREO ELLIPTA (Inhaler)",
        "totalCount": 12,
        "searchTerms": [
            "BREO ELLIPTA",
            "Breo Ellipta",
            "Breo Ellipta (Inhaler)",
            "breo ellipta",
            "breo ellipta (inhaler)"
        ],
        "dosages": [
            {
                "value": "100 mcg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TIMOLOL MALEATE",
        "route": "Ophthalmic",
        "fullName": "TIMOLOL MALEATE (Ophthalmic)",
        "totalCount": 12,
        "searchTerms": [
            "TIMOLOL MALEATE",
            "TIMOLOL MALEATE (Ophthalmic)",
            "Timolol Maleate",
            "Timolol Maleate (Ophthalmic)",
            "Timolol maleate",
            "Timoptic",
            "timolol maleate",
            "timolol maleate (ophthalmic)",
            "timoptic"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "42%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "ASPIRIN ADULT LOW DOSE",
        "route": "Oral Pill",
        "fullName": "ASPIRIN ADULT LOW DOSE (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "ASPIRIN ADULT LOW DOSE",
            "Aspirin Adult Low Dose",
            "Aspirin Adult Low Dose (Oral)",
            "aspirin adult low dose",
            "aspirin adult low dose (oral)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Triamterene",
        "route": "Oral Pill",
        "fullName": "Triamterene (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "TRIAMTERENE",
            "Triamterene",
            "Triamterene (Oral Pill)",
            "triamterene",
            "triamterene (oral pill)",
            "triamterene 100 MG Oral Capsule",
            "triamterene 100 mg oral capsule",
            "triamterene 50 MG Oral Capsule",
            "triamterene 50 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BIOFREEZE",
        "route": "Topical",
        "fullName": "BIOFREEZE (Topical)",
        "totalCount": 12,
        "searchTerms": [
            "BIOFREEZE",
            "BIOFREEZE (Topical)",
            "biofreeze",
            "biofreeze (topical)",
            "menthol 0.04 MG/MG Topical Gel",
            "menthol 0.04 mg/mg topical gel",
            "menthol 100 MG/ML Topical Cream",
            "menthol 100 MG/ML Topical Spray",
            "menthol 100 mg/ml topical cream",
            "menthol 100 mg/ml topical spray",
            "menthol 105 MG/ML Topical Spray",
            "menthol 105 mg/ml topical spray"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FERREX 150 FORTE PLUS",
        "route": "Oral Pill",
        "fullName": "FERREX 150 FORTE PLUS (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "FERREX 150 FORTE PLUS",
            "FERREX 150 FORTE PLUS (Oral Pill)",
            "calcium ascorbate 60 MG / calcium threonate 0.8 MG / ferrous asparto glycinate 50 MG / folic acid 1 MG / polysaccharide iron complex 100 MG / succinic acid 50 MG / vitamin B12 0.025 MG Oral Capsule",
            "calcium ascorbate 60 mg / calcium threonate 0.8 mg / ferrous asparto glycinate 50 mg / folic acid 1 mg / polysaccharide iron complex 100 mg / succinic acid 50 mg / vitamin b12 0.025 mg oral capsule",
            "ferrex 150 forte plus",
            "ferrex 150 forte plus (oral pill)"
        ],
        "dosages": [
            {
                "value": "60-0.8-50-1-100-50-0.025 mg",
                "pct": "67%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TENORMIN",
        "route": "Oral Pill",
        "fullName": "TENORMIN (Oral Pill)",
        "totalCount": 12,
        "searchTerms": [
            "TENORMIN",
            "TENORMIN (Oral Pill)",
            "atenolol 25 MG Oral Tablet",
            "atenolol 25 mg oral tablet",
            "atenolol 50 MG Oral Tablet",
            "atenolol 50 mg oral tablet",
            "tenormin",
            "tenormin (oral pill)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "58%"
            },
            {
                "value": "25 mg",
                "pct": "42%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ROBITUSSIN DM",
        "route": "Oral Liquid",
        "fullName": "ROBITUSSIN DM (Oral Liquid)",
        "totalCount": 12,
        "searchTerms": [
            "ROBITUSSIN DM",
            "ROBITUSSIN DM (Oral Liquid)",
            "dextromethorphan hydrobromide 2 MG/ML / guaifenesin 20 MG/ML Oral Solution",
            "dextromethorphan hydrobromide 2 mg/ml / guaifenesin 20 mg/ml oral solution",
            "robitussin dm",
            "robitussin dm (oral liquid)"
        ],
        "dosages": [
            {
                "value": "10-100 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "58%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "fluPHENAZine",
        "route": "Injectable",
        "fullName": "fluPHENAZine (Injectable)",
        "totalCount": 12,
        "searchTerms": [
            "fluPHENAZine",
            "fluPHENAZine (Injectable)",
            "fluphenazine",
            "fluphenazine (injectable)",
            "fluphenazine decanoate 25 MG/ML Injectable Solution",
            "fluphenazine decanoate 25 mg/ml injectable solution",
            "fluphenazine hydrochloride 2.5 MG/ML Injectable Solution",
            "fluphenazine hydrochloride 2.5 mg/ml injectable solution"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "67%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Antacid Liquid",
        "route": "Oral Pill",
        "fullName": "Antacid Liquid (Oral Pill)",
        "totalCount": 12,
        "searchTerms": ["Antacid Liquid", "antacid liquid"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Roflumilast",
        "route": "Oral Pill",
        "fullName": "Roflumilast (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Roflumilast",
            "Roflumilast (Oral Pill)",
            "Roflumilast (Oral)",
            "roflumilast",
            "roflumilast (oral pill)",
            "roflumilast (oral)",
            "roflumilast 0.5 MG Oral Tablet",
            "roflumilast 0.5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mcg",
                "pct": "55%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Desmopressin",
        "route": "Oral Pill",
        "fullName": "Desmopressin (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Desmopressin",
            "Desmopressin (Oral Pill)",
            "desmopressin",
            "desmopressin (oral pill)",
            "desmopressin acetate 0.2 MG Oral Tablet",
            "desmopressin acetate 0.2 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.1 mg",
                "pct": "82%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "45%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Carbidopa/Levodopa",
        "route": "Oral Liquid",
        "fullName": "Carbidopa/Levodopa (Oral Liquid)",
        "totalCount": 11,
        "searchTerms": [
            "Carbidopa/Levodopa",
            "Carbidopa/Levodopa (Oral Liquid)",
            "carbidopa 4.63 MG/ML / levodopa 20 MG/ML Oral Suspension",
            "carbidopa 4.63 mg/ml / levodopa 20 mg/ml oral suspension",
            "carbidopa/levodopa",
            "carbidopa/levodopa (oral liquid)"
        ],
        "dosages": [
            {
                "value": "4.63-20 mg",
                "pct": "45%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HYDROmorphone",
        "route": "Oral Pill",
        "fullName": "HYDROmorphone (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "HYDROmorphone",
            "HYDROmorphone (Oral Pill)",
            "hydromorphone",
            "hydromorphone (oral pill)",
            "hydromorphone hydrochloride 2 MG Oral Tablet",
            "hydromorphone hydrochloride 2 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "55%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Mycophenolic acid",
        "route": "Oral Pill",
        "fullName": "Mycophenolic acid (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Mycophenolic acid",
            "Mycophenolic acid (Oral Pill)",
            "mycophenolic acid",
            "mycophenolic acid (oral pill)",
            "mycophenolic acid 180 MG Delayed Release Oral Tablet",
            "mycophenolic acid 180 mg delayed release oral tablet",
            "mycophenolic acid 360 MG Delayed Release Oral Tablet",
            "mycophenolic acid 360 mg delayed release oral tablet"
        ],
        "dosages": [
            {
                "value": "360 mg",
                "pct": "64%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PULMICORT",
        "route": "Inhalant",
        "fullName": "PULMICORT (Inhalant)",
        "totalCount": 11,
        "searchTerms": [
            "120 ACTUAT budesonide 0.18 MG/ACTUAT Dry Powder Inhaler",
            "120 actuat budesonide 0.18 mg/actuat dry powder inhaler",
            "60 ACTUAT budesonide 0.09 MG/ACTUAT Dry Powder Inhaler",
            "60 actuat budesonide 0.09 mg/actuat dry powder inhaler",
            "PULMICORT",
            "PULMICORT (Inhalant)",
            "budesonide 0.25 MG/ML Inhalation Suspension",
            "budesonide 0.25 mg/ml inhalation suspension",
            "budesonide 0.5 MG/ML Inhalation Suspension",
            "budesonide 0.5 mg/ml inhalation suspension",
            "pulmicort",
            "pulmicort (inhalant)"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "55%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VEMLIDY",
        "route": "Oral Pill",
        "fullName": "VEMLIDY (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "VEMLIDY",
            "VEMLIDY (Oral Pill)",
            "tenofovir alafenamide 25 MG Oral Tablet",
            "tenofovir alafenamide 25 mg oral tablet",
            "vemlidy",
            "vemlidy (oral pill)"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MAPAP XR",
        "route": "Oral Pill",
        "fullName": "MAPAP XR (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "8 HR acetaminophen 650 MG Extended Release Oral Tablet",
            "8 hr acetaminophen 650 mg extended release oral tablet",
            "MAPAP",
            "MAPAP XR",
            "MAPAP XR (Oral Pill)",
            "mapap",
            "mapap xr",
            "mapap xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "650 mg",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ARMOUR THYROID",
        "route": "Oral Pill",
        "fullName": "ARMOUR THYROID (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "ARMOUR THYROID",
            "ARMOUR THYROID (Oral Pill)",
            "armour thyroid",
            "armour thyroid (oral pill)",
            "thyroid (USP) 15 MG Oral Tablet",
            "thyroid (USP) 30 MG Oral Tablet",
            "thyroid (USP) 60 MG Oral Tablet",
            "thyroid (USP) 90 MG Oral Tablet",
            "thyroid (usp) 15 mg oral tablet",
            "thyroid (usp) 30 mg oral tablet",
            "thyroid (usp) 60 mg oral tablet",
            "thyroid (usp) 90 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "45%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PEPTO-BISMOL",
        "route": "Oral Liquid",
        "fullName": "PEPTO-BISMOL (Oral Liquid)",
        "totalCount": 11,
        "searchTerms": [
            "PEPTO-BISMOL",
            "PEPTO-BISMOL (Oral Liquid)",
            "bismuth subsalicylate 17.5 MG/ML Oral Suspension",
            "bismuth subsalicylate 17.5 mg/ml oral suspension",
            "bismuth subsalicylate 35 MG/ML Oral Suspension",
            "bismuth subsalicylate 35 mg/ml oral suspension",
            "pepto-bismol",
            "pepto-bismol (oral liquid)"
        ],
        "dosages": [
            {
                "value": "262 mg",
                "pct": "64%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Zolpidem",
        "route": "Oral Spray",
        "fullName": "Zolpidem (Oral Spray)",
        "totalCount": 11,
        "searchTerms": [
            "Zolpidem",
            "Zolpidem (Oral Spray)",
            "zolpidem",
            "zolpidem (oral spray)",
            "zolpidem tartrate 5 MG/ACTUAT Oral Spray",
            "zolpidem tartrate 5 mg/actuat oral spray"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "91%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PATADAY",
        "route": "Ophthalmic",
        "fullName": "PATADAY (Ophthalmic)",
        "totalCount": 11,
        "searchTerms": [
            "PATADAY",
            "PATADAY (Ophthalmic)",
            "olopatadine 1 MG/ML Ophthalmic Solution",
            "olopatadine 1 mg/ml ophthalmic solution",
            "olopatadine 2 MG/ML Ophthalmic Solution",
            "olopatadine 2 mg/ml ophthalmic solution",
            "pataday",
            "pataday (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cyclobenzaprine XR",
        "route": "Oral Pill",
        "fullName": "Cyclobenzaprine XR (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "24 HR cyclobenzaprine hydrochloride 15 MG Extended Release Oral Capsule",
            "24 HR cyclobenzaprine hydrochloride 30 MG Extended Release Oral Capsule",
            "24 hr cyclobenzaprine hydrochloride 15 mg extended release oral capsule",
            "24 hr cyclobenzaprine hydrochloride 30 mg extended release oral capsule",
            "Cyclobenzaprine XR",
            "Cyclobenzaprine XR (Oral Pill)",
            "cyclobenzaprine xr",
            "cyclobenzaprine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "45%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ascorbic acid/Ferrous fumarate/Folic acid/Niacin/Polysaccharide iron complex",
        "route": "Oral Pill",
        "fullName": "Ascorbic acid/Ferrous fumarate/Folic acid/Niacin/Polysaccharide iron complex (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Ascorbic acid/Ferrous fumarate/Folic acid/Niacin/Polysaccharide iron complex",
            "Ascorbic acid/Ferrous fumarate/Folic acid/Niacin/Polysaccharide iron complex (Oral Pill)",
            "ascorbic acid 40 MG / ferrous fumarate 62.5 MG / folic acid 1 MG / niacin 3 MG / polysaccharide iron complex 62.5 MG Oral Capsule",
            "ascorbic acid 40 mg / ferrous fumarate 62.5 mg / folic acid 1 mg / niacin 3 mg / polysaccharide iron complex 62.5 mg oral capsule",
            "ascorbic acid/ferrous fumarate/folic acid/niacin/polysaccharide iron complex",
            "ascorbic acid/ferrous fumarate/folic acid/niacin/polysaccharide iron complex (oral pill)"
        ],
        "dosages": [
            {
                "value": "40-62.5-1-3-62.5 mg",
                "pct": "64%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SANTYL",
        "route": "Topical",
        "fullName": "SANTYL (Topical)",
        "totalCount": 11,
        "searchTerms": [
            "SANTYL",
            "SANTYL (Topical)",
            "collagenase 0.25 UNT/MG Topical Ointment",
            "collagenase 0.25 unt/mg topical ointment",
            "santyl",
            "santyl (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "55%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Exemestane",
        "route": "Oral Pill",
        "fullName": "Exemestane (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Exemestane",
            "Exemestane (Oral Pill)",
            "exemestane",
            "exemestane (oral pill)",
            "exemestane 25 MG Oral Tablet",
            "exemestane 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CLEARLAX",
        "route": "Oral Solution Powder",
        "fullName": "CLEARLAX (Oral Solution Powder)",
        "totalCount": 11,
        "searchTerms": [
            "CLEARLAX",
            "CLEARLAX (Oral Solution Powder)",
            "clearlax",
            "clearlax (oral solution powder)",
            "polyethylene glycol 3350 17000 MG Powder for Oral Solution",
            "polyethylene glycol 3350 17000 mg powder for oral solution"
        ],
        "dosages": [
            {
                "value": "17 g",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lactate/Pramoxine",
        "route": "Topical",
        "fullName": "Lactate/Pramoxine (Topical)",
        "totalCount": 11,
        "searchTerms": [
            "Lactate/Pramoxine",
            "Lactate/Pramoxine (Topical)",
            "ammonium lactate 120 MG/ML / pramoxine hydrochloride 10 MG/ML Topical Cream",
            "ammonium lactate 120 mg/ml / pramoxine hydrochloride 10 mg/ml topical cream",
            "lactate/pramoxine",
            "lactate/pramoxine (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "55%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Folic acid/Polysaccharide iron complex/Vitamin B12",
        "route": "Oral Pill",
        "fullName": "Folic acid/Polysaccharide iron complex/Vitamin B12 (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Folic acid/Polysaccharide iron complex/Vitamin B12",
            "Folic acid/Polysaccharide iron complex/Vitamin B12 (Oral Pill)",
            "folic acid/polysaccharide iron complex/vitamin b12",
            "folic acid/polysaccharide iron complex/vitamin b12 (oral pill)"
        ],
        "dosages": [
            {
                "value": "1-150-0.025 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D50.9",
                "description": "Iron deficiency anemia, unspecified",
                "pct": "45%"
            }
        ]
    },
    {
        "name": "AIRSUPRA",
        "route": "Inhalant",
        "fullName": "AIRSUPRA (Inhalant)",
        "totalCount": 11,
        "searchTerms": ["AIRSUPRA", "AIRSUPRA (Inhalant)", "airsupra", "airsupra (inhalant)"],
        "dosages": [
            {
                "value": "90-80 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "91%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "73%"
            }
        ]
    },
    {
        "name": "SYNJARDY XR",
        "route": "Oral Pill",
        "fullName": "SYNJARDY XR (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "24 HR empagliflozin 12.5 MG / metformin hydrochloride 1000 MG Extended Release Oral Tablet",
            "24 HR empagliflozin 25 MG / metformin hydrochloride 1000 MG Extended Release Oral Tablet",
            "24 HR empagliflozin 5 MG / metformin hydrochloride 1000 MG Extended Release Oral Tablet",
            "24 hr empagliflozin 12.5 mg / metformin hydrochloride 1000 mg extended release oral tablet",
            "24 hr empagliflozin 25 mg / metformin hydrochloride 1000 mg extended release oral tablet",
            "24 hr empagliflozin 5 mg / metformin hydrochloride 1000 mg extended release oral tablet",
            "SYNJARDY",
            "SYNJARDY XR",
            "SYNJARDY XR (Oral Pill)",
            "SYNJARDY XR (Oral)",
            "Synjardy XR",
            "Synjardy XR (Oral)",
            "synjardy",
            "synjardy xr",
            "synjardy xr (oral pill)",
            "synjardy xr (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "Budesonide",
        "route": "Oral Pill",
        "fullName": "Budesonide (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Budesonide",
            "Budesonide (Oral Pill)",
            "budesonide",
            "budesonide (oral pill)",
            "budesonide 3 MG Delayed Release Oral Capsule",
            "budesonide 3 mg delayed release oral capsule"
        ],
        "dosages": [
            {
                "value": "3 mg",
                "pct": "45%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "45%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Estradiol",
        "route": "Oral Pill",
        "fullName": "Estradiol (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Estradiol",
            "Estradiol (Oral Pill)",
            "Estradiol (Oral)",
            "estradiol",
            "estradiol (oral pill)",
            "estradiol (oral)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "45%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "IMODIUM",
        "route": "Oral Pill",
        "fullName": "IMODIUM (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "IMODIUM",
            "IMODIUM (Oral Pill)",
            "imodium",
            "imodium (oral pill)",
            "loperamide hydrochloride 2 MG Oral Capsule",
            "loperamide hydrochloride 2 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "45%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VIVA-DROPS LUBRICATING EYE DROPS",
        "route": "Ophthalmic",
        "fullName": "VIVA-DROPS LUBRICATING EYE DROPS (Ophthalmic)",
        "totalCount": 11,
        "searchTerms": [
            "VIVA-DROPS LUBRICATING EYE DROPS",
            "VIVA-DROPS LUBRICATING EYE DROPS (Ophthalmic)",
            "polysorbate 80 10 MG/ML Ophthalmic Solution",
            "polysorbate 80 10 mg/ml ophthalmic solution",
            "viva-drops lubricating eye drops",
            "viva-drops lubricating eye drops (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Sevelamer Carbonate",
        "route": "Oral Pill",
        "fullName": "Sevelamer Carbonate (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Renvela",
            "SEVELAMER CARBONATE",
            "SEVELAMER CARBONATE (Oral)",
            "Sevelamer Carbonate",
            "Sevelamer Carbonate (Oral)",
            "renvela",
            "sevelamer carbonate",
            "sevelamer carbonate (Oral)",
            "sevelamer carbonate (oral)"
        ],
        "dosages": [
            {
                "value": "800 mg",
                "pct": "82%"
            }
        ],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "73%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N18.9",
                "description": "Chronic kidney disease, unspecified",
                "pct": "73%"
            }
        ]
    },
    {
        "name": "Pentoxifylline XR",
        "route": "Oral Pill",
        "fullName": "Pentoxifylline XR (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Pentoxifylline XR",
            "Pentoxifylline XR (Oral Pill)",
            "pentoxifylline 400 MG Extended Release Oral Tablet",
            "pentoxifylline 400 mg extended release oral tablet",
            "pentoxifylline xr",
            "pentoxifylline xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "91%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "45%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium - Supplement",
        "route": "Oral Pill",
        "fullName": "Calcium - Supplement (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Calcium - Supplement",
            "Calcium - Supplement (Oral)",
            "OYSCO 500",
            "Os-Cal 500 + D",
            "calcium - supplement",
            "calcium - supplement (oral)",
            "os-cal 500 + d",
            "oysco 500"
        ],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "45%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "NUEDEXTA",
        "route": "Oral Pill",
        "fullName": "NUEDEXTA (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "NUEDEXTA",
            "NUEDEXTA (Oral Pill)",
            "dextromethorphan hydrobromide 20 MG / quinidine sulfate 10 MG Oral Capsule",
            "dextromethorphan hydrobromide 20 mg / quinidine sulfate 10 mg oral capsule",
            "nuedexta",
            "nuedexta (oral pill)"
        ],
        "dosages": [
            {
                "value": "20-10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "45%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Montelukast Sod",
        "route": "Oral Pill",
        "fullName": "Montelukast Sod (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "MONTELUKAST SOD",
            "MONTELUKAST SOD (Oral)",
            "Montelukast SOD",
            "Montelukast SOD (Oral)",
            "Montelukast Sod",
            "Montelukast Sod (Oral)",
            "Singulair",
            "montelukast sod",
            "montelukast sod (oral)",
            "singulair"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "91%"
            }
        ]
    },
    {
        "name": "Pantoprazole Sod DR",
        "route": "Oral Pill",
        "fullName": "Pantoprazole Sod DR (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "PANTOPRAZOLE SOD DR",
            "PANTOPRAZOLE SOD DR (Oral)",
            "Pantoprazole SOD DR",
            "Pantoprazole SOD DR (Oral)",
            "Pantoprazole Sod DR",
            "Pantoprazole Sod DR (Oral)",
            "Protonix",
            "pantoprazole sod dr",
            "pantoprazole sod dr (oral)",
            "protonix"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "82%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [
            {
                "value": "Delayed release",
                "pct": "45%"
            }
        ],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "atorvastatin (LIPITOR)",
        "route": "Oral Pill",
        "fullName": "atorvastatin (LIPITOR) (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Atorvastatin (Lipitor)",
            "Atorvastatin (Lipitor) (Oral)",
            "atorvastatin (LIPITOR)",
            "atorvastatin (LIPITOR) (Oral)",
            "atorvastatin (lipitor)",
            "atorvastatin (lipitor) (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Polyethylene Glycol",
        "route": "Oral Pill",
        "fullName": "Polyethylene Glycol (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "POLYETHYLENE GLYCOL",
            "Polyethylene Glycol",
            "Polyethylene Glycol (Oral)",
            "Polyethylene glycol",
            "Polyethylene glycol (Oral)",
            "polyethylene glycol",
            "polyethylene glycol (Oral)",
            "polyethylene glycol (oral)"
        ],
        "dosages": [
            {
                "value": "17 g",
                "pct": "64%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "64%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Centrum Silver Women 50+ - Supplement",
        "route": "Oral Pill",
        "fullName": "Centrum Silver Women 50+ - Supplement (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "Centrum Silver Women 50+ - Supplement",
            "Centrum Silver Women 50+ - Supplement (Oral)",
            "centrum silver women 50+ - supplement",
            "centrum silver women 50+ - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "100%"
            },
            {
                "code": "Z71.3",
                "description": "Dietary counseling and surveillance",
                "pct": "45%"
            }
        ]
    },
    {
        "name": "Doxepin",
        "route": "Oral Liquid",
        "fullName": "Doxepin (Oral Liquid)",
        "totalCount": 11,
        "searchTerms": [
            "Doxepin",
            "Doxepin (Oral Liquid)",
            "doxepin",
            "doxepin (oral liquid)",
            "doxepin hydrochloride 10 MG/ML Oral Solution",
            "doxepin hydrochloride 10 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TOVIAZ XR",
        "route": "Oral Pill",
        "fullName": "TOVIAZ XR (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "24 HR fesoterodine fumarate 4 MG Extended Release Oral Tablet",
            "24 HR fesoterodine fumarate 8 MG Extended Release Oral Tablet",
            "24 hr fesoterodine fumarate 4 mg extended release oral tablet",
            "24 hr fesoterodine fumarate 8 mg extended release oral tablet",
            "TOVIAZ",
            "TOVIAZ XR",
            "TOVIAZ XR (Oral Pill)",
            "toviaz",
            "toviaz xr",
            "toviaz xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "73%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "82%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROTONIX",
        "route": "Oral Granules",
        "fullName": "PROTONIX (Oral Granules)",
        "totalCount": 11,
        "searchTerms": [
            "PROTONIX",
            "PROTONIX (Oral Granules)",
            "pantoprazole 40 MG Oral Granules",
            "pantoprazole 40 mg oral granules",
            "protonix",
            "protonix (oral granules)"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "55%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "WAL-ITIN",
        "route": "Oral Pill",
        "fullName": "WAL-ITIN (Oral Pill)",
        "totalCount": 11,
        "searchTerms": [
            "WAL-ITIN",
            "WAL-ITIN (Oral Pill)",
            "loratadine 10 MG Oral Tablet",
            "loratadine 10 mg oral tablet",
            "wal-itin",
            "wal-itin (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "91%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MINIPRESS",
        "route": "Oral Pill",
        "fullName": "MINIPRESS (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "MINIPRESS",
            "MINIPRESS (Oral Pill)",
            "minipress",
            "minipress (oral pill)",
            "prazosin 1 MG Oral Capsule",
            "prazosin 1 mg oral capsule",
            "prazosin 2 MG Oral Capsule",
            "prazosin 2 mg oral capsule",
            "prazosin 5 MG Oral Capsule",
            "prazosin 5 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DEMADEX",
        "route": "Oral Pill",
        "fullName": "DEMADEX (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "DEMADEX",
            "DEMADEX (Oral Pill)",
            "demadex",
            "demadex (oral pill)",
            "torsemide 10 MG Oral Tablet",
            "torsemide 10 mg oral tablet",
            "torsemide 20 MG Oral Tablet",
            "torsemide 20 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HUMIRA",
        "route": "Injectable",
        "fullName": "HUMIRA (Injectable)",
        "totalCount": 10,
        "searchTerms": [
            "0.2 ML adalimumab 50 MG/ML Prefilled Syringe",
            "0.2 ml adalimumab 50 mg/ml prefilled syringe",
            "0.8 ML adalimumab 100 MG/ML Prefilled Syringe",
            "0.8 ML adalimumab 50 MG/ML Auto-Injector",
            "0.8 ml adalimumab 100 mg/ml prefilled syringe",
            "0.8 ml adalimumab 50 mg/ml auto-injector",
            "HUMIRA",
            "HUMIRA (Injectable)",
            "humira",
            "humira (injectable)"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CALCIUM",
        "route": "Oral Pill",
        "fullName": "CALCIUM (Oral Pill)",
        "totalCount": 10,
        "searchTerms": ["CALCIUM", "Calcium", "calcium"],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "80%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OCREVUS",
        "route": "Injectable",
        "fullName": "OCREVUS (Injectable)",
        "totalCount": 10,
        "searchTerms": [
            "10 ML ocrelizumab 30 MG/ML Injection",
            "10 ml ocrelizumab 30 mg/ml injection",
            "OCREVUS",
            "OCREVUS (Injectable)",
            "ocrevus",
            "ocrevus (injectable)"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "80%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PHENobarbital",
        "route": "Oral Pill",
        "fullName": "PHENobarbital (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "PHENobarbital",
            "PHENobarbital (Oral Pill)",
            "Phenobarbital",
            "Phenobarbital (Oral)",
            "phenobarbital",
            "phenobarbital (oral pill)",
            "phenobarbital (oral)",
            "phenobarbital 100 MG Oral Tablet",
            "phenobarbital 100 mg oral tablet",
            "phenobarbital 15 MG Oral Tablet",
            "phenobarbital 15 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Chondroitin sulfates/Glucosamine",
        "route": "Oral Pill",
        "fullName": "Chondroitin sulfates/Glucosamine (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Chondroitin sulfates/Glucosamine",
            "Chondroitin sulfates/Glucosamine (Oral Pill)",
            "chondroitin sulfates 133 MG / glucosamine hydrochloride 167 MG Oral Capsule",
            "chondroitin sulfates 133 mg / glucosamine hydrochloride 167 mg oral capsule",
            "chondroitin sulfates 400 MG / glucosamine sulfate 500 MG Oral Tablet",
            "chondroitin sulfates 400 mg / glucosamine sulfate 500 mg oral tablet",
            "chondroitin sulfates/glucosamine",
            "chondroitin sulfates/glucosamine (oral pill)"
        ],
        "dosages": [
            {
                "value": "400-500 mg",
                "pct": "70%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Enoxaparin",
        "route": "Injectable",
        "fullName": "Enoxaparin (Injectable)",
        "totalCount": 10,
        "searchTerms": [
            "0.3 ML enoxaparin sodium 100 MG/ML Prefilled Syringe",
            "0.3 ml enoxaparin sodium 100 mg/ml prefilled syringe",
            "0.4 ML enoxaparin sodium 100 MG/ML Prefilled Syringe",
            "0.4 ml enoxaparin sodium 100 mg/ml prefilled syringe",
            "0.8 ML enoxaparin sodium 150 MG/ML Prefilled Syringe",
            "0.8 ml enoxaparin sodium 150 mg/ml prefilled syringe",
            "Enoxaparin",
            "Enoxaparin (Injectable)",
            "enoxaparin",
            "enoxaparin (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HORIZANT XR",
        "route": "Oral Pill",
        "fullName": "HORIZANT XR (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "HORIZANT",
            "HORIZANT XR",
            "HORIZANT XR (Oral Pill)",
            "gabapentin enacarbil 300 MG Extended Release Oral Tablet",
            "gabapentin enacarbil 300 mg extended release oral tablet",
            "gabapentin enacarbil 600 MG Extended Release Oral Tablet",
            "gabapentin enacarbil 600 mg extended release oral tablet",
            "horizant",
            "horizant xr",
            "horizant xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "60%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Pyridostigmine",
        "route": "Oral Pill",
        "fullName": "Pyridostigmine (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "PYRIDOSTIGMINE",
            "Pyridostigmine",
            "Pyridostigmine (Oral Pill)",
            "pyRIDostigmine",
            "pyRIDostigmine (Oral Pill)",
            "pyridostigmine",
            "pyridostigmine (oral pill)",
            "pyridostigmine bromide 30 MG Oral Tablet",
            "pyridostigmine bromide 30 mg oral tablet",
            "pyridostigmine bromide 60 MG Oral Tablet",
            "pyridostigmine bromide 60 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "70%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ferrous sulfate",
        "route": "Oral Liquid",
        "fullName": "Ferrous sulfate (Oral Liquid)",
        "totalCount": 10,
        "searchTerms": [
            "Ferrous sulfate",
            "Ferrous sulfate (Oral Liquid)",
            "ferrous sulfate",
            "ferrous sulfate (oral liquid)",
            "ferrous sulfate 44 MG/ML Oral Solution",
            "ferrous sulfate 44 mg/ml oral solution",
            "ferrous sulfate 60 MG/ML Oral Solution",
            "ferrous sulfate 60 mg/ml oral solution",
            "ferrous sulfate 75 MG/ML Oral Solution",
            "ferrous sulfate 75 mg/ml oral solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Glycopyrronium",
        "route": "Oral Pill",
        "fullName": "Glycopyrronium (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Glycopyrronium",
            "Glycopyrronium (Oral Pill)",
            "glycopyrrolate 1 MG Oral Tablet",
            "glycopyrrolate 1 mg oral tablet",
            "glycopyrrolate 1.5 MG Oral Tablet",
            "glycopyrrolate 1.5 mg oral tablet",
            "glycopyrrolate 2 MG Oral Tablet",
            "glycopyrrolate 2 mg oral tablet",
            "glycopyrronium",
            "glycopyrronium (oral pill)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "70%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "60%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Vitamin D 3",
        "route": "Oral Pill",
        "fullName": "Vitamin D 3 (Oral Pill)",
        "totalCount": 10,
        "searchTerms": ["VITAMIN D 3", "Vitamin D 3", "vitamin d 3"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Brimonidine/Timolol",
        "route": "Ophthalmic",
        "fullName": "Brimonidine/Timolol (Ophthalmic)",
        "totalCount": 10,
        "searchTerms": [
            "Brimonidine/Timolol",
            "Brimonidine/Timolol (Ophthalmic)",
            "brimonidine tartrate 2 MG/ML / timolol 5 MG/ML Ophthalmic Solution",
            "brimonidine tartrate 2 mg/ml / timolol 5 mg/ml ophthalmic solution",
            "brimonidine/timolol",
            "brimonidine/timolol (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Magnesium sulfate/Potassium sulfate/Sodium sulfate",
        "route": "Pack",
        "fullName": "Magnesium sulfate/Potassium sulfate/Sodium sulfate (Pack)",
        "totalCount": 10,
        "searchTerms": [
            "Magnesium sulfate/Potassium sulfate/Sodium sulfate",
            "Magnesium sulfate/Potassium sulfate/Sodium sulfate (Pack)",
            "magnesium sulfate/potassium sulfate/sodium sulfate",
            "magnesium sulfate/potassium sulfate/sodium sulfate (pack)",
            "{2 (480 ML) (magnesium sulfate 0.0277 MEQ/ML / potassium sulfate 0.0374 MEQ/ML / sodium sulfate 0.257 MEQ/ML Oral Solution) } Pack",
            "{2 (480 ml) (magnesium sulfate 0.0277 meq/ml / potassium sulfate 0.0374 meq/ml / sodium sulfate 0.257 meq/ml oral solution) } pack"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ascorbic acid/Folic acid/Iron carbonyl/Vitamin B12",
        "route": "Oral Pill",
        "fullName": "Ascorbic acid/Folic acid/Iron carbonyl/Vitamin B12 (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Ascorbic acid/Folic acid/Iron carbonyl/Vitamin B12",
            "Ascorbic acid/Folic acid/Iron carbonyl/Vitamin B12 (Oral Pill)",
            "ascorbic acid 250 MG / folic acid 1 MG / iron carbonyl 100 MG / vitamin B12 0.025 MG Oral Tablet",
            "ascorbic acid 250 mg / folic acid 1 mg / iron carbonyl 100 mg / vitamin b12 0.025 mg oral tablet",
            "ascorbic acid/folic acid/iron carbonyl/vitamin b12",
            "ascorbic acid/folic acid/iron carbonyl/vitamin b12 (oral pill)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Diclofenac/Fluorouracil",
        "route": "Topical",
        "fullName": "Diclofenac/Fluorouracil (Topical)",
        "totalCount": 10,
        "searchTerms": [
            "Diclofenac/Fluorouracil",
            "Diclofenac/Fluorouracil (Topical)",
            "diclofenac sodium 10 MG/ML / fluorouracil 50 MG/ML Topical Cream",
            "diclofenac sodium 10 mg/ml / fluorouracil 50 mg/ml topical cream",
            "diclofenac/fluorouracil",
            "diclofenac/fluorouracil (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CAPLYTA",
        "route": "Oral Pill",
        "fullName": "CAPLYTA (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "CAPLYTA",
            "CAPLYTA (Oral Pill)",
            "Lumateperone 42 MG Oral Capsule",
            "caplyta",
            "caplyta (oral pill)",
            "lumateperone 42 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "42 mg",
                "pct": "90%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lubiprostone",
        "route": "Oral Pill",
        "fullName": "Lubiprostone (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Amitiza",
            "Lubiprostone",
            "Lubiprostone (Oral Pill)",
            "Lubiprostone (Oral)",
            "amitiza",
            "lubiprostone",
            "lubiprostone (oral pill)",
            "lubiprostone (oral)",
            "lubiprostone 0.008 MG Oral Capsule",
            "lubiprostone 0.008 mg oral capsule",
            "lubiprostone 0.024 MG Oral Capsule",
            "lubiprostone 0.024 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "24 mcg",
                "pct": "70%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "60%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Acetaminophen/Chlorpheniramine/Dextromethorphan/Phenylephrine",
        "route": "Oral Pill",
        "fullName": "Acetaminophen/Chlorpheniramine/Dextromethorphan/Phenylephrine (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Acetaminophen/Chlorpheniramine/Dextromethorphan/Phenylephrine",
            "Acetaminophen/Chlorpheniramine/Dextromethorphan/Phenylephrine (Oral Pill)",
            "acetaminophen 325 MG / chlorpheniramine maleate 2 MG / dextromethorphan hydrobromide 10 MG / phenylephrine hydrochloride 5 MG Oral Capsule",
            "acetaminophen 325 mg / chlorpheniramine maleate 2 mg / dextromethorphan hydrobromide 10 mg / phenylephrine hydrochloride 5 mg oral capsule",
            "acetaminophen/chlorpheniramine/dextromethorphan/phenylephrine",
            "acetaminophen/chlorpheniramine/dextromethorphan/phenylephrine (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VIAGRA",
        "route": "Oral Pill",
        "fullName": "VIAGRA (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "VIAGRA",
            "VIAGRA (Oral Pill)",
            "sildenafil 100 MG Oral Tablet",
            "sildenafil 100 mg oral tablet",
            "sildenafil 25 MG Oral Tablet",
            "sildenafil 25 mg oral tablet",
            "sildenafil 50 MG Oral Tablet",
            "sildenafil 50 mg oral tablet",
            "viagra",
            "viagra (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Metoclopramide",
        "route": "Oral Liquid",
        "fullName": "Metoclopramide (Oral Liquid)",
        "totalCount": 10,
        "searchTerms": [
            "Metoclopramide",
            "Metoclopramide (Oral Liquid)",
            "metoclopramide",
            "metoclopramide (oral liquid)",
            "metoclopramide 1 MG/ML Oral Solution",
            "metoclopramide 1 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium carbonate/Cholecalciferol/Vitamin K1",
        "route": "Chewable",
        "fullName": "Calcium carbonate/Cholecalciferol/Vitamin K1 (Chewable)",
        "totalCount": 10,
        "searchTerms": [
            "Calcium carbonate/Cholecalciferol/Vitamin K1",
            "Calcium carbonate/Cholecalciferol/Vitamin K1 (Chewable)",
            "calcium carbonate 1250 MG / cholecalciferol 100 UNT / vitamin K1 0.04 MG Chewable Tablet",
            "calcium carbonate 1250 mg / cholecalciferol 100 unt / vitamin k1 0.04 mg chewable tablet",
            "calcium carbonate/cholecalciferol/vitamin k1",
            "calcium carbonate/cholecalciferol/vitamin k1 (chewable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Famotidine",
        "route": "Injectable",
        "fullName": "Famotidine (Injectable)",
        "totalCount": 10,
        "searchTerms": [
            "2 ML famotidine 10 MG/ML Injection",
            "2 ml famotidine 10 mg/ml injection",
            "50 ML famotidine 0.4 MG/ML Injection",
            "50 ml famotidine 0.4 mg/ml injection",
            "Famotidine",
            "Famotidine (Injectable)",
            "famotidine",
            "famotidine (injectable)",
            "famotidine 10 MG/ML Injectable Solution",
            "famotidine 10 mg/ml injectable solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FEMARA",
        "route": "Oral Pill",
        "fullName": "FEMARA (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "FEMARA",
            "FEMARA (Oral Pill)",
            "femara",
            "femara (oral pill)",
            "letrozole 2.5 MG Oral Tablet",
            "letrozole 2.5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2.5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DALIRESP",
        "route": "Oral Pill",
        "fullName": "DALIRESP (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "DALIRESP",
            "DALIRESP (Oral Pill)",
            "daliresp",
            "daliresp (oral pill)",
            "roflumilast 0.5 MG Oral Tablet",
            "roflumilast 0.5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "60%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Linaclotide",
        "route": "Oral Pill",
        "fullName": "Linaclotide (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Linaclotide",
            "Linaclotide (Oral Pill)",
            "linaclotide",
            "linaclotide (Oral)",
            "linaclotide (oral pill)",
            "linaclotide (oral)",
            "linaclotide 0.145 MG Oral Capsule",
            "linaclotide 0.145 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "0.145 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "CELLCEPT",
        "route": "Oral Pill",
        "fullName": "CELLCEPT (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "CELLCEPT",
            "CELLCEPT (Oral Pill)",
            "cellcept",
            "cellcept (oral pill)",
            "mycophenolate mofetil 250 MG Oral Capsule",
            "mycophenolate mofetil 250 mg oral capsule",
            "mycophenolate mofetil 500 MG Oral Tablet",
            "mycophenolate mofetil 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ADVIL",
        "route": "Oral Liquid",
        "fullName": "ADVIL (Oral Liquid)",
        "totalCount": 10,
        "searchTerms": [
            "ADVIL",
            "ADVIL (Oral Liquid)",
            "advil",
            "advil (oral liquid)",
            "ibuprofen 20 MG/ML Oral Suspension",
            "ibuprofen 20 mg/ml oral suspension",
            "ibuprofen 40 MG/ML Oral Suspension",
            "ibuprofen 40 mg/ml oral suspension"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lidocaine/Prilocaine",
        "route": "Topical",
        "fullName": "Lidocaine/Prilocaine (Topical)",
        "totalCount": 10,
        "searchTerms": [
            "Lidocaine/Prilocaine",
            "Lidocaine/Prilocaine (Topical)",
            "lidocaine 25 MG/ML / prilocaine 25 MG/ML Topical Cream",
            "lidocaine 25 mg/ml / prilocaine 25 mg/ml topical cream",
            "lidocaine/prilocaine",
            "lidocaine/prilocaine (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "DEBROX",
        "route": "Otic",
        "fullName": "DEBROX (Otic)",
        "totalCount": 10,
        "searchTerms": [
            "DEBROX",
            "DEBROX (Otic)",
            "carbamide peroxide 65 MG/ML Otic Solution",
            "carbamide peroxide 65 mg/ml otic solution",
            "debrox",
            "debrox (otic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "50%"
            },
            {
                "value": "Twice daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H61.20",
                "description": "Impacted cerumen, unspecified ear",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "Chlorhexidine",
        "route": "Mouthwash",
        "fullName": "Chlorhexidine (Mouthwash)",
        "totalCount": 10,
        "searchTerms": [
            "Chlorhexidine",
            "Chlorhexidine (Mouthwash)",
            "chlorhexidine",
            "chlorhexidine (mouthwash)",
            "chlorhexidine gluconate 1.2 MG/ML Mouthwash",
            "chlorhexidine gluconate 1.2 mg/ml mouthwash"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Pilocarpine",
        "route": "Ophthalmic",
        "fullName": "Pilocarpine (Ophthalmic)",
        "totalCount": 10,
        "searchTerms": [
            "Pilocarpine",
            "Pilocarpine (Ophthalmic)",
            "pilocarpine",
            "pilocarpine (ophthalmic)",
            "pilocarpine hydrochloride 10 MG/ML Ophthalmic Solution",
            "pilocarpine hydrochloride 10 mg/ml ophthalmic solution",
            "pilocarpine hydrochloride 20 MG/ML Ophthalmic Solution",
            "pilocarpine hydrochloride 20 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Indapamide",
        "route": "Oral Pill",
        "fullName": "Indapamide (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Indapamide",
            "Indapamide (Oral Pill)",
            "Indapamide (Oral)",
            "indapamide",
            "indapamide (oral pill)",
            "indapamide (oral)",
            "indapamide 1.25 MG Oral Tablet",
            "indapamide 1.25 mg oral tablet",
            "indapamide 2.5 MG Oral Tablet",
            "indapamide 2.5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2.5 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "BENEFIBER",
        "route": "Oral Solution Powder",
        "fullName": "BENEFIBER (Oral Solution Powder)",
        "totalCount": 10,
        "searchTerms": [
            "BENEFIBER",
            "BENEFIBER (Oral Solution Powder)",
            "benefiber",
            "benefiber (oral solution powder)",
            "wheat dextrin 3000 MG Powder for Oral Solution",
            "wheat dextrin 3000 mg powder for oral solution"
        ],
        "dosages": [
            {
                "value": "3 g",
                "pct": "80%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "60%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Polyvinyl alcohol",
        "route": "Ophthalmic",
        "fullName": "Polyvinyl alcohol (Ophthalmic)",
        "totalCount": 10,
        "searchTerms": [
            "POLYVINYL ALCOHOL",
            "Polyvinyl alcohol",
            "Polyvinyl alcohol (Ophthalmic)",
            "polyvinyl alcohol",
            "polyvinyl alcohol (ophthalmic)",
            "polyvinyl alcohol 0.014 ML/ML Ophthalmic Solution",
            "polyvinyl alcohol 0.014 ml/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H04.123",
                "description": "Dry eye syndrome of bilateral lacrimal glands",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "ZINC SULFATE",
        "route": "Oral Pill",
        "fullName": "ZINC SULFATE (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "ZINC SULFATE",
            "Zinc Sulfate",
            "Zinc sulfate",
            "Zinc sulfate (Oral Pill)",
            "zinc sulfate",
            "zinc sulfate (oral pill)",
            "zinc sulfate 66 MG Oral Tablet",
            "zinc sulfate 66 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "220 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lisinopril/HCTZ",
        "route": "Oral Pill",
        "fullName": "Lisinopril/HCTZ (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Lisinopril/HCTZ",
            "Lisinopril/HCTZ (Oral)",
            "Zestoretic",
            "lisinopril/hctz",
            "lisinopril/hctz (oral)",
            "zestoretic"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Cefpodoxime",
        "route": "Oral Pill",
        "fullName": "Cefpodoxime (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Cefpodoxime",
            "Cefpodoxime (Oral Pill)",
            "cefpodoxime",
            "cefpodoxime (Oral)",
            "cefpodoxime (oral pill)",
            "cefpodoxime (oral)",
            "cefpodoxime 200 MG Oral Tablet",
            "cefpodoxime 200 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N39.0",
                "description": "Urinary tract infection, site not specified",
                "pct": "78%"
            }
        ]
    },
    {
        "name": "AUGMENTIN",
        "route": "Oral Pill",
        "fullName": "AUGMENTIN (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "AUGMENTIN",
            "AUGMENTIN (Oral Pill)",
            "amoxicillin 500 MG / clavulanate 125 MG Oral Tablet",
            "amoxicillin 500 mg / clavulanate 125 mg oral tablet",
            "amoxicillin 875 MG / clavulanate 125 MG Oral Tablet",
            "amoxicillin 875 mg / clavulanate 125 mg oral tablet",
            "augmentin",
            "augmentin (oral pill)"
        ],
        "dosages": [
            {
                "value": "875-125 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DONEPEZIL HYDROCHLORIDE",
        "route": "Oral Pill",
        "fullName": "DONEPEZIL HYDROCHLORIDE (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Aricept",
            "DONEPEZIL HYDROCHLORIDE",
            "Donepezil Hydrochloride",
            "Donepezil Hydrochloride (Oral)",
            "aricept",
            "donepezil hydrochloride",
            "donepezil hydrochloride (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "50%"
            },
            {
                "value": "5 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G30.9",
                "description": "Alzheimer's disease, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "CALMOSEPTINE",
        "route": "Topical",
        "fullName": "CALMOSEPTINE (Topical)",
        "totalCount": 10,
        "searchTerms": [
            "CALMOSEPTINE",
            "CALMOSEPTINE (Topical)",
            "calmoseptine",
            "calmoseptine (topical)",
            "lanolin 0.157 MG/MG / menthol 0.0044 MG/MG / petrolatum 0.24 MG/MG / zinc oxide 0.206 MG/MG Topical Ointment",
            "lanolin 0.157 mg/mg / menthol 0.0044 mg/mg / petrolatum 0.24 mg/mg / zinc oxide 0.206 mg/mg topical ointment"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Aspirin Chewable",
        "route": "Oral Pill",
        "fullName": "Aspirin Chewable (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "ASPIRIN CHEWABLE",
            "ASPIRIN CHEWABLE (Oral)",
            "Aspirin Chewable",
            "Aspirin Chewable (Oral)",
            "BAYER ASPIRIN",
            "Bayer Childrens",
            "Bayer Low Dose",
            "St. Joseph Aspirin",
            "aspirin chewable",
            "aspirin chewable (oral)",
            "bayer aspirin",
            "bayer childrens",
            "bayer low dose",
            "st. joseph aspirin"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "Chewable",
                "pct": "70%"
            }
        ],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "70%"
            }
        ]
    },
    {
        "name": "Oyster Shell Calcium - Supplement",
        "route": "Oral Pill",
        "fullName": "Oyster Shell Calcium - Supplement (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "OS-CAL 500 + D",
            "Oyster Shell Calcium",
            "Oyster Shell Calcium - Supplement",
            "Oyster Shell Calcium - Supplement (Oral)",
            "os-cal 500 + d",
            "oyster shell calcium",
            "oyster shell calcium - supplement",
            "oyster shell calcium - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "50%"
            },
            {
                "value": "Once daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "90%"
            }
        ]
    },
    {
        "name": "Anoro Ellipta",
        "route": "Inhaler",
        "fullName": "Anoro Ellipta (Inhaler)",
        "totalCount": 10,
        "searchTerms": [
            "ANORO ELLIPTA",
            "ANORO ELLIPTA (Inhaler)",
            "Anoro Ellipta",
            "Anoro Ellipta (Inhaler)",
            "anoro ellipta",
            "anoro ellipta (inhaler)"
        ],
        "dosages": [
            {
                "value": "62.5 mcg",
                "pct": "70%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J44.9",
                "description": "Chronic obstructive pulmonary disease, unspecified",
                "pct": "89%"
            }
        ]
    },
    {
        "name": "OXYBUTYNIN CHLORIDE",
        "route": "Oral Pill",
        "fullName": "OXYBUTYNIN CHLORIDE (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "DITROPAN XL",
            "Ditropan",
            "Ditropan XL",
            "OXYBUTYNIN CHLORIDE",
            "Oxybutynin Chloride",
            "Oxybutynin Chloride (Oral)",
            "Oxybutynin chloride",
            "Oxybutynin chloride (Oral)",
            "ditropan",
            "ditropan xl",
            "oxyBUTYnin Chloride",
            "oxyBUTYnin Chloride (Oral)",
            "oxybutynin chloride",
            "oxybutynin chloride (oral)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "60%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "90%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Insulin glargine-yfgn",
        "route": "Injectable",
        "fullName": "Insulin glargine-yfgn (Injectable)",
        "totalCount": 10,
        "searchTerms": [
            "Basaglar",
            "Insulin Glargine-yfgn",
            "Insulin Glargine-yfgn (Injectable)",
            "Lantus",
            "basaglar",
            "insulin glargine-yfgn",
            "insulin glargine-yfgn (injectable)",
            "lantus"
        ],
        "dosages": [
            {
                "value": "100 units",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "70%"
            }
        ]
    },
    {
        "name": "Acetaminophen ER",
        "route": "Oral Pill",
        "fullName": "Acetaminophen ER (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Acetaminophen ER",
            "Acetaminophen ER (Oral)",
            "Midol",
            "Tylenol 8 Hour",
            "Tylenol Arthritis",
            "acetaminophen er",
            "acetaminophen er (oral)",
            "midol",
            "tylenol 8 hour",
            "tylenol arthritis"
        ],
        "dosages": [
            {
                "value": "650 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "60%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "80%"
            },
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "50%"
            }
        ]
    },
    {
        "name": "Sacubitril-Valsartan",
        "route": "Oral Pill",
        "fullName": "Sacubitril-Valsartan (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Entresto",
            "Sacubitril-Valsartan",
            "Sacubitril-Valsartan (Oral)",
            "entresto",
            "sacubitril-valsartan",
            "sacubitril-valsartan (Oral)",
            "sacubitril-valsartan (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "80%"
            }
        ]
    },
    {
        "name": "FEXOFENADINE HCL",
        "route": "Oral Pill",
        "fullName": "FEXOFENADINE HCL (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Allegra 180",
            "Allegra Allergy",
            "FEXOFENADINE HCL",
            "Fexofenadine HCL",
            "Fexofenadine HCL (Oral)",
            "Fexofenadine HCl",
            "Fexofenadine HCl (Oral)",
            "allegra 180",
            "allegra allergy",
            "fexofenadine hcl",
            "fexofenadine hcl (oral)"
        ],
        "dosages": [
            {
                "value": "180 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Basaglar KwikPen (insulin glargine)",
        "route": "Injectable",
        "fullName": "Basaglar KwikPen (insulin glargine) (Injectable)",
        "totalCount": 10,
        "searchTerms": [
            "Basaglar KwikPen (insulin glargine)",
            "Basaglar KwikPen (insulin glargine) (Injectable)",
            "basaglar kwikpen (insulin glargine)",
            "basaglar kwikpen (insulin glargine) (injectable)"
        ],
        "dosages": [
            {
                "value": "100 units",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "50%"
            }
        ],
        "adminNotes": [
            {
                "value": "For Single Patient Use Only",
                "pct": "50%"
            }
        ],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Promethazine",
        "route": "Oral Pill",
        "fullName": "Promethazine (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "Promethazine",
            "Promethazine (Oral Pill)",
            "promethazine",
            "promethazine (oral pill)",
            "promethazine hydrochloride 12.5 MG Oral Tablet",
            "promethazine hydrochloride 12.5 mg oral tablet",
            "promethazine hydrochloride 25 MG Oral Tablet",
            "promethazine hydrochloride 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "12.5 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TEKTURNA HCT",
        "route": "Oral Pill",
        "fullName": "TEKTURNA HCT (Oral Pill)",
        "totalCount": 10,
        "searchTerms": [
            "TEKTURNA HCT",
            "TEKTURNA HCT (Oral Pill)",
            "aliskiren 150 MG / hydrochlorothiazide 12.5 MG Oral Tablet",
            "aliskiren 150 MG / hydrochlorothiazide 25 MG Oral Tablet",
            "aliskiren 150 mg / hydrochlorothiazide 12.5 mg oral tablet",
            "aliskiren 150 mg / hydrochlorothiazide 25 mg oral tablet",
            "aliskiren 300 MG / hydrochlorothiazide 12.5 MG Oral Tablet",
            "aliskiren 300 MG / hydrochlorothiazide 25 MG Oral Tablet",
            "aliskiren 300 mg / hydrochlorothiazide 12.5 mg oral tablet",
            "aliskiren 300 mg / hydrochlorothiazide 25 mg oral tablet",
            "tekturna hct",
            "tekturna hct (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BION TEARS",
        "route": "Ophthalmic",
        "fullName": "BION TEARS (Ophthalmic)",
        "totalCount": 10,
        "searchTerms": [
            "BION TEARS",
            "BION TEARS (Ophthalmic)",
            "bion tears",
            "bion tears (ophthalmic)",
            "dextran 70 1 MG/ML / hypromellose 3 MG/ML Ophthalmic Solution",
            "dextran 70 1 mg/ml / hypromellose 3 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Four times daily",
                "pct": "50%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ferrous fumarate",
        "route": "Chewable",
        "fullName": "Ferrous fumarate (Chewable)",
        "totalCount": 10,
        "searchTerms": [
            "Ferrous fumarate",
            "Ferrous fumarate (Chewable)",
            "ferrous fumarate",
            "ferrous fumarate (chewable)",
            "ferrous fumarate 75 MG Chewable Tablet",
            "ferrous fumarate 75 mg chewable tablet"
        ],
        "dosages": [
            {
                "value": "325 mg",
                "pct": "50%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "70%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Fish Oil Omega 3 OTC supplement",
        "route": "Oral Pill",
        "fullName": "Fish Oil Omega 3 OTC supplement (Oral Pill)",
        "totalCount": 10,
        "searchTerms": ["Fish Oil Omega 3 OTC supplement", "fish oil omega 3 otc supplement"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Areds",
        "route": "Oral Pill",
        "fullName": "Areds (Oral Pill)",
        "totalCount": 10,
        "searchTerms": ["AREDS", "Areds", "areds"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "80%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "REMERON",
        "route": "Oral Disintegrating",
        "fullName": "REMERON (Oral Disintegrating)",
        "totalCount": 9,
        "searchTerms": [
            "REMERON",
            "REMERON (Oral Disintegrating)",
            "mirtazapine 15 MG Disintegrating Oral Tablet",
            "mirtazapine 15 mg disintegrating oral tablet",
            "mirtazapine 30 MG Disintegrating Oral Tablet",
            "mirtazapine 30 mg disintegrating oral tablet",
            "remeron",
            "remeron (oral disintegrating)"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "67%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "56%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Methylphenidate XR",
        "route": "Oral Pill",
        "fullName": "Methylphenidate XR (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "8 HR methylphenidate hydrochloride 10 MG Extended Release Oral Tablet",
            "8 hr methylphenidate hydrochloride 10 mg extended release oral tablet",
            "Methylphenidate XR",
            "Methylphenidate XR (Oral Pill)",
            "methylphenidate xr",
            "methylphenidate xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F90.9",
                "description": "Attention-deficit hyperactivity disorder, unspecified type",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "SEROquel XR",
        "route": "Oral Pill",
        "fullName": "SEROquel XR (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "24 HR quetiapine 150 MG Extended Release Oral Tablet",
            "24 HR quetiapine 200 MG Extended Release Oral Tablet",
            "24 HR quetiapine 300 MG Extended Release Oral Tablet",
            "24 HR quetiapine 400 MG Extended Release Oral Tablet",
            "24 hr quetiapine 150 mg extended release oral tablet",
            "24 hr quetiapine 200 mg extended release oral tablet",
            "24 hr quetiapine 300 mg extended release oral tablet",
            "24 hr quetiapine 400 mg extended release oral tablet",
            "SEROQUEL",
            "SEROquel XR",
            "SEROquel XR (Oral Pill)",
            "seroquel",
            "seroquel xr",
            "seroquel xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "56%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Galantamine",
        "route": "Oral Pill",
        "fullName": "Galantamine (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Galantamine",
            "Galantamine (Oral Pill)",
            "galantamine",
            "galantamine (oral pill)",
            "galantamine 12 MG Oral Tablet",
            "galantamine 12 mg oral tablet",
            "galantamine 4 MG Oral Tablet",
            "galantamine 4 mg oral tablet",
            "galantamine 8 MG Oral Tablet",
            "galantamine 8 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Atomoxetine",
        "route": "Oral Pill",
        "fullName": "Atomoxetine (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "ATOMOXETINE",
            "ATOMOXETINE (Oral)",
            "Atomoxetine",
            "Atomoxetine (Oral Pill)",
            "atomoxetine",
            "atomoxetine (oral pill)",
            "atomoxetine (oral)",
            "atomoxetine 10 MG Oral Capsule",
            "atomoxetine 10 mg oral capsule",
            "atomoxetine 100 MG Oral Capsule",
            "atomoxetine 100 mg oral capsule",
            "atomoxetine 40 MG Oral Capsule",
            "atomoxetine 40 mg oral capsule",
            "atomoxetine 80 MG Oral Capsule",
            "atomoxetine 80 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Docusate/Sennosides, USP",
        "route": "Oral Pill",
        "fullName": "Docusate/Sennosides, USP (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Docusate/Sennosides, USP",
            "Docusate/Sennosides, USP (Oral Pill)",
            "docusate sodium 50 MG / sennosides, USP 8.6 MG Oral Capsule",
            "docusate sodium 50 mg / sennosides, usp 8.6 mg oral capsule",
            "docusate/sennosides, usp",
            "docusate/sennosides, usp (oral pill)"
        ],
        "dosages": [
            {
                "value": "50-8.6 mg",
                "pct": "89%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Flecainide",
        "route": "Oral Pill",
        "fullName": "Flecainide (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Flecainide",
            "Flecainide (Oral Pill)",
            "flecainide",
            "flecainide (oral pill)",
            "flecainide acetate 100 MG Oral Tablet",
            "flecainide acetate 100 mg oral tablet",
            "flecainide acetate 50 MG Oral Tablet",
            "flecainide acetate 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "67%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "56%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ZADITOR",
        "route": "Ophthalmic",
        "fullName": "ZADITOR (Ophthalmic)",
        "totalCount": 9,
        "searchTerms": [
            "ZADITOR",
            "ZADITOR (Ophthalmic)",
            "ketotifen 0.25 MG/ML Ophthalmic Solution",
            "ketotifen 0.25 mg/ml ophthalmic solution",
            "zaditor",
            "zaditor (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "KAPSPARGO XR",
        "route": "Oral Pill",
        "fullName": "KAPSPARGO XR (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "24 HR metoprolol succinate 100 MG Extended Release Oral Capsule",
            "24 HR metoprolol succinate 25 MG Extended Release Oral Capsule",
            "24 hr metoprolol succinate 100 mg extended release oral capsule",
            "24 hr metoprolol succinate 25 mg extended release oral capsule",
            "KAPSPARGO",
            "KAPSPARGO XR",
            "KAPSPARGO XR (Oral Pill)",
            "kapspargo",
            "kapspargo xr",
            "kapspargo xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Benazepril/Hydrochlorothiazide",
        "route": "Oral Pill",
        "fullName": "Benazepril/Hydrochlorothiazide (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Benazepril/Hydrochlorothiazide",
            "Benazepril/Hydrochlorothiazide (Oral Pill)",
            "Benazepril/hydroCHLOROthiazide",
            "Benazepril/hydroCHLOROthiazide (Oral Pill)",
            "benazepril hydrochloride 10 MG / hydrochlorothiazide 12.5 MG Oral Tablet",
            "benazepril hydrochloride 10 mg / hydrochlorothiazide 12.5 mg oral tablet",
            "benazepril hydrochloride 20 MG / hydrochlorothiazide 25 MG Oral Tablet",
            "benazepril hydrochloride 20 mg / hydrochlorothiazide 25 mg oral tablet",
            "benazepril/hydrochlorothiazide",
            "benazepril/hydrochlorothiazide (oral pill)"
        ],
        "dosages": [
            {
                "value": "20-25 mg",
                "pct": "67%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DUREZOL",
        "route": "Ophthalmic",
        "fullName": "DUREZOL (Ophthalmic)",
        "totalCount": 9,
        "searchTerms": [
            "DUREZOL",
            "DUREZOL (Ophthalmic)",
            "difluprednate 0.5 MG/ML Ophthalmic Suspension",
            "difluprednate 0.5 mg/ml ophthalmic suspension",
            "durezol",
            "durezol (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "JULUCA",
        "route": "Oral Pill",
        "fullName": "JULUCA (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "JULUCA",
            "JULUCA (Oral Pill)",
            "Juluca",
            "Juluca (Oral)",
            "dolutegravir 50 MG / rilpivirine 25 MG Oral Tablet",
            "dolutegravir 50 mg / rilpivirine 25 mg oral tablet",
            "juluca",
            "juluca (oral pill)",
            "juluca (oral)"
        ],
        "dosages": [
            {
                "value": "50-25 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "B20",
                "description": "Human immunodeficiency virus [HIV] disease",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "SYSTANE COMPLETE",
        "route": "Ophthalmic",
        "fullName": "SYSTANE COMPLETE (Ophthalmic)",
        "totalCount": 9,
        "searchTerms": [
            "SYSTANE COMPLETE",
            "SYSTANE COMPLETE (Ophthalmic)",
            "propylene glycol 6 MG/ML Ophthalmic Solution",
            "propylene glycol 6 mg/ml ophthalmic solution",
            "systane complete",
            "systane complete (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Albuterol",
        "route": "Oral Liquid",
        "fullName": "Albuterol (Oral Liquid)",
        "totalCount": 9,
        "searchTerms": [
            "Albuterol",
            "Albuterol (Oral Liquid)",
            "albuterol",
            "albuterol (oral liquid)"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "KENALOG",
        "route": "Topical",
        "fullName": "KENALOG (Topical)",
        "totalCount": 9,
        "searchTerms": [
            "KENALOG",
            "KENALOG (Topical)",
            "kenalog",
            "kenalog (topical)",
            "triamcinolone acetonide 0.147 MG/ML Topical Spray",
            "triamcinolone acetonide 0.147 mg/ml topical spray"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "azaTHIOprine",
        "route": "Oral Pill",
        "fullName": "azaTHIOprine (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "AZATHIOPRINE",
            "Azathioprine",
            "Azathioprine (Oral)",
            "azaTHIOprine",
            "azaTHIOprine (Oral Pill)",
            "azathioprine",
            "azathioprine (oral pill)",
            "azathioprine (oral)",
            "azathioprine 50 MG Oral Tablet",
            "azathioprine 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "89%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "STEGLATRO",
        "route": "Oral Pill",
        "fullName": "STEGLATRO (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "STEGLATRO",
            "STEGLATRO (Oral Pill)",
            "Steglatro",
            "Steglatro (Oral)",
            "ertugliflozin 15 MG Oral Tablet",
            "ertugliflozin 15 mg oral tablet",
            "ertugliflozin 5 MG Oral Tablet",
            "ertugliflozin 5 mg oral tablet",
            "steglatro",
            "steglatro (oral pill)",
            "steglatro (oral)"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "56%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PREZCOBIX",
        "route": "Oral Pill",
        "fullName": "PREZCOBIX (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "PREZCOBIX",
            "PREZCOBIX (Oral Pill)",
            "Prezcobix",
            "Prezcobix (Oral)",
            "cobicistat 150 MG / darunavir 800 MG Oral Tablet",
            "cobicistat 150 mg / darunavir 800 mg oral tablet",
            "prezcobix",
            "prezcobix (oral pill)",
            "prezcobix (oral)"
        ],
        "dosages": [
            {
                "value": "150-800 mg",
                "pct": "78%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Benztropine",
        "route": "Injectable",
        "fullName": "Benztropine (Injectable)",
        "totalCount": 9,
        "searchTerms": [
            "2 ML benztropine mesylate 1 MG/ML Injection",
            "2 ml benztropine mesylate 1 mg/ml injection",
            "Benztropine",
            "Benztropine (Injectable)",
            "benztropine",
            "benztropine (injectable)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "89%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Glucosamine",
        "route": "Oral Pill",
        "fullName": "Glucosamine (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "GLUCOSAMINE",
            "Glucosamine",
            "Glucosamine (Oral Pill)",
            "glucosamine",
            "glucosamine (oral pill)",
            "glucosamine hydrochloride 750 MG Oral Tablet",
            "glucosamine hydrochloride 750 mg oral tablet",
            "glucosamine sulfate 500 MG Oral Capsule",
            "glucosamine sulfate 500 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NEXLETOL",
        "route": "Oral Pill",
        "fullName": "NEXLETOL (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "NEXLETOL",
            "NEXLETOL (Oral Pill)",
            "Nexletol",
            "Nexletol (Oral)",
            "nexletol",
            "nexletol (oral pill)",
            "nexletol (oral)"
        ],
        "dosages": [
            {
                "value": "180 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "56%"
            }
        ]
    },
    {
        "name": "Acetaminophen/Butalbital",
        "route": "Oral Pill",
        "fullName": "Acetaminophen/Butalbital (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Acetaminophen/Butalbital",
            "Acetaminophen/Butalbital (Oral Pill)",
            "acetaminophen 300 MG / butalbital 50 MG Oral Tablet",
            "acetaminophen 300 mg / butalbital 50 mg oral tablet",
            "acetaminophen 325 MG / butalbital 25 MG Oral Tablet",
            "acetaminophen 325 MG / butalbital 50 MG Oral Tablet",
            "acetaminophen 325 mg / butalbital 25 mg oral tablet",
            "acetaminophen 325 mg / butalbital 50 mg oral tablet",
            "acetaminophen/butalbital",
            "acetaminophen/butalbital (oral pill)"
        ],
        "dosages": [
            {
                "value": "325-50 mg",
                "pct": "56%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "56%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VOQUEZNA",
        "route": "Oral Pill",
        "fullName": "VOQUEZNA (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "VOQUEZNA",
            "VOQUEZNA (Oral Pill)",
            "VOQUEZNA (Oral)",
            "Voquezna",
            "Voquezna (Oral)",
            "voquezna",
            "voquezna (oral pill)",
            "voquezna (oral)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "67%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Pantoprazole Sodium DR",
        "route": "Oral Pill",
        "fullName": "Pantoprazole Sodium DR (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Pantoprazole Sodium DR",
            "Pantoprazole Sodium DR (Oral)",
            "Protonix",
            "pantoprazole sodium dr",
            "pantoprazole sodium dr (oral)",
            "protonix"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Tylenol 8HR Arthritis Pain",
        "route": "Oral Pill",
        "fullName": "Tylenol 8HR Arthritis Pain (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Tylenol 8HR Arthritis Pain",
            "Tylenol 8HR Arthritis Pain (Oral)",
            "tylenol 8hr arthritis pain",
            "tylenol 8hr arthritis pain (oral)"
        ],
        "dosages": [
            {
                "value": "650 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "67%"
            }
        ],
        "adminNotes": [
            {
                "value": "Pain reliever/fever reducer",
                "pct": "56%"
            }
        ],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "78%"
            },
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "Estradiol",
        "route": "Vaginal",
        "fullName": "Estradiol (Vaginal)",
        "totalCount": 9,
        "searchTerms": ["Estradiol", "Estradiol (Vaginal)", "estradiol", "estradiol (vaginal)"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N95.2",
                "description": "Postmenopausal atrophic vaginitis",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Lidocaine Pain Relief Patch",
        "route": "Topical",
        "fullName": "Lidocaine Pain Relief Patch (Topical)",
        "totalCount": 9,
        "searchTerms": [
            "Lidocaine Pain Relief Patch",
            "Lidocaine Pain Relief Patch (Topical)",
            "lidocaine pain relief patch",
            "lidocaine pain relief patch (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "56%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "56%"
            }
        ]
    },
    {
        "name": "Vitamin B Complex - Supplement",
        "route": "Oral Pill",
        "fullName": "Vitamin B Complex - Supplement (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "B-Complex",
            "B-Complex Cap",
            "Vitamin B Complex - Supplement",
            "Vitamin B Complex - Supplement (Oral)",
            "b-complex",
            "b-complex cap",
            "vitamin b complex - supplement",
            "vitamin b complex - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ferosul - Supplement",
        "route": "Oral Pill",
        "fullName": "Ferosul - Supplement (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "FeroSul - Supplement",
            "FeroSul - Supplement (Oral)",
            "Ferosul - Supplement",
            "Ferosul - Supplement (Oral)",
            "ferosul - supplement",
            "ferosul - supplement (oral)"
        ],
        "dosages": [
            {
                "value": "325 mg",
                "pct": "78%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "D50.9",
                "description": "Iron deficiency anemia, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Magnesium citrate",
        "route": "Oral Liquid",
        "fullName": "Magnesium citrate (Oral Liquid)",
        "totalCount": 9,
        "searchTerms": [
            "Magnesium citrate",
            "Magnesium citrate (Oral Liquid)",
            "magnesium citrate",
            "magnesium citrate (oral liquid)",
            "magnesium citrate 58.2 MG/ML Oral Solution",
            "magnesium citrate 58.2 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "1.746 g",
                "pct": "67%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Azelastine HCl",
        "route": "Ophthalmic",
        "fullName": "Azelastine HCl (Ophthalmic)",
        "totalCount": 9,
        "searchTerms": [
            "Azelastine HCl",
            "Azelastine HCl (Ophthalmic)",
            "Optivar",
            "azelastine hcl",
            "azelastine hcl (ophthalmic)",
            "optivar"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Divalproex Sodium",
        "route": "Oral Pill",
        "fullName": "Divalproex Sodium (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Depakote",
            "Depakote DR",
            "Divalproex Sodium",
            "Divalproex Sodium (Oral)",
            "depakote",
            "depakote dr",
            "divalproex sodium",
            "divalproex sodium (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F31.9",
                "description": "Bipolar disorder, unspecified",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "Ammonium Lactate Lotion",
        "route": "Topical",
        "fullName": "Ammonium Lactate Lotion (Topical)",
        "totalCount": 9,
        "searchTerms": [
            "Ammonium Lactate Lotion",
            "Ammonium Lactate Lotion (Topical)",
            "Lac-Hydrin",
            "ammonium lactate lotion",
            "ammonium lactate lotion (Topical)",
            "ammonium lactate lotion (topical)",
            "lac-hydrin"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "56%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "L85.3",
                "description": "Xerosis cutis",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Valsartan/HCTZ",
        "route": "Oral Pill",
        "fullName": "Valsartan/HCTZ (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Diovan HCT",
            "VALSARTAN/HCTZ",
            "VALSARTAN/HCTZ (Oral)",
            "Valsartan/HCTZ",
            "Valsartan/HCTZ (Oral)",
            "diovan hct",
            "valsartan/hctz",
            "valsartan/hctz (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "buPROPion XL",
        "route": "Oral Pill",
        "fullName": "buPROPion XL (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "BUPROPION XL",
            "BUPROPION XL (Oral)",
            "Bupropion XL",
            "Bupropion XL (Oral)",
            "Wellbutrin XL",
            "buPROPion XL",
            "buPROPion XL (Oral)",
            "bupropion xl",
            "bupropion xl (oral)",
            "wellbutrin xl"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "56%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "67%"
            }
        ]
    },
    {
        "name": "Candesartan/Hydrochlorothiazide",
        "route": "Oral Pill",
        "fullName": "Candesartan/Hydrochlorothiazide (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Candesartan/Hydrochlorothiazide",
            "Candesartan/Hydrochlorothiazide (Oral Pill)",
            "Candesartan/hydroCHLOROthiazide",
            "Candesartan/hydroCHLOROthiazide (Oral Pill)",
            "candesartan cilexetil 16 MG / hydrochlorothiazide 12.5 MG Oral Tablet",
            "candesartan cilexetil 16 mg / hydrochlorothiazide 12.5 mg oral tablet",
            "candesartan cilexetil 32 MG / hydrochlorothiazide 12.5 MG Oral Tablet",
            "candesartan cilexetil 32 mg / hydrochlorothiazide 12.5 mg oral tablet",
            "candesartan/hydrochlorothiazide",
            "candesartan/hydrochlorothiazide (oral pill)"
        ],
        "dosages": [
            {
                "value": "32-12.5 mg",
                "pct": "56%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DOXEPIN HCL",
        "route": "Oral Pill",
        "fullName": "DOXEPIN HCL (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "DOXEPIN HCL",
            "Doxepin HCL",
            "Doxepin HCL (Oral)",
            "Doxepin HCl",
            "Doxepin HCl (Oral)",
            "Sinequan",
            "doxepin hcl",
            "doxepin hcl (oral)",
            "sinequan"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "Refresh Optive",
        "route": "Ophthalmic",
        "fullName": "Refresh Optive (Ophthalmic)",
        "totalCount": 9,
        "searchTerms": [
            "Refresh Optive",
            "Refresh Optive (Ophthalmic)",
            "refresh optive",
            "refresh optive (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H04.123",
                "description": "Dry eye syndrome of bilateral lacrimal glands",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Linzess (linaclotide)",
        "route": "Oral Pill",
        "fullName": "Linzess (linaclotide) (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Linzess (linaCLOtide)",
            "Linzess (linaCLOtide) (Oral)",
            "Linzess (linaclotide)",
            "Linzess (linaclotide) (Oral)",
            "linzess (linaclotide)",
            "linzess (linaclotide) (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [
            {
                "value": "Keep in original container to protect from moisture",
                "pct": "67%"
            }
        ],
        "diagnoses": [
            {
                "code": "K59.00",
                "description": "Constipation, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ergocalciferol - Supplement",
        "route": "Oral Pill",
        "fullName": "Ergocalciferol - Supplement (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "DRISDOL",
            "Drisdol",
            "ERGOCALCIFEROL - Supplement",
            "ERGOCALCIFEROL - Supplement (Oral)",
            "Ergocalciferol - Supplement",
            "Ergocalciferol - Supplement (Oral)",
            "drisdol",
            "ergocalciferol - Supplement",
            "ergocalciferol - Supplement (Oral)",
            "ergocalciferol - supplement",
            "ergocalciferol - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Budesonide and Formoterol Fumarate Dihydrate",
        "route": "Inhaler",
        "fullName": "Budesonide and Formoterol Fumarate Dihydrate (Inhaler)",
        "totalCount": 9,
        "searchTerms": [
            "Budesonide and Formoterol Fumarate Dihydrate",
            "Budesonide and Formoterol Fumarate Dihydrate (Inhaler)",
            "Symbicort",
            "budesonide and formoterol fumarate dihydrate",
            "budesonide and formoterol fumarate dihydrate (inhaler)",
            "symbicort"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "89%"
            }
        ]
    },
    {
        "name": "INCRUSE ELLIPTA",
        "route": "Inhaler",
        "fullName": "INCRUSE ELLIPTA (Inhaler)",
        "totalCount": 9,
        "searchTerms": [
            "INCRUSE ELLIPTA",
            "Incruse Ellipta",
            "Incruse Ellipta (Inhaler)",
            "incruse ellipta",
            "incruse ellipta (inhaler)"
        ],
        "dosages": [
            {
                "value": "62.5 mcg",
                "pct": "89%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PIOGLITAZONE HCL",
        "route": "Oral Pill",
        "fullName": "PIOGLITAZONE HCL (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "Actos",
            "PIOGLITAZONE HCL",
            "PIOGLITAZONE HCL (Oral)",
            "Pioglitazone HCL",
            "Pioglitazone HCL (Oral)",
            "Pioglitazone HCl",
            "Pioglitazone HCl (Oral)",
            "actos",
            "pioglitazone hcl",
            "pioglitazone hcl (oral)"
        ],
        "dosages": [
            {
                "value": "15 mg",
                "pct": "56%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "LOSARTAN POTASSIUM-HYDROCHLOROTHIAZIDE",
        "route": "Oral Pill",
        "fullName": "LOSARTAN POTASSIUM-HYDROCHLOROTHIAZIDE (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "LOSARTAN POTASSIUM-HYDROCHLOROTHIAZIDE",
            "losartan potassium-hydrochlorothiazide"
        ],
        "dosages": [
            {
                "value": "12.5 mg",
                "pct": "78%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "JENTADUETO XR",
        "route": "Oral Pill",
        "fullName": "JENTADUETO XR (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "24 HR linagliptin 2.5 MG / metformin hydrochloride 1000 MG Extended Release Oral Tablet",
            "24 HR linagliptin 5 MG / metformin hydrochloride 1000 MG Extended Release Oral Tablet",
            "24 hr linagliptin 2.5 mg / metformin hydrochloride 1000 mg extended release oral tablet",
            "24 hr linagliptin 5 mg / metformin hydrochloride 1000 mg extended release oral tablet",
            "JENTADUETO",
            "JENTADUETO XR",
            "JENTADUETO XR (Oral Pill)",
            "jentadueto",
            "jentadueto xr",
            "jentadueto xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "56%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "STIOLTO",
        "route": "Inhalant",
        "fullName": "STIOLTO (Inhalant)",
        "totalCount": 9,
        "searchTerms": [
            "28 ACTUAT olodaterol 0.0025 MG/ACTUAT / tiotropium 0.0025 MG/ACTUAT Inhalation Spray",
            "28 actuat olodaterol 0.0025 mg/actuat / tiotropium 0.0025 mg/actuat inhalation spray",
            "STIOLTO",
            "STIOLTO (Inhalant)",
            "stiolto",
            "stiolto (inhalant)"
        ],
        "dosages": [
            {
                "value": "2.5-2.5 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DEXILANT",
        "route": "Oral Disintegrating",
        "fullName": "DEXILANT (Oral Disintegrating)",
        "totalCount": 9,
        "searchTerms": [
            "DEXILANT",
            "DEXILANT (Oral Disintegrating)",
            "dexilant",
            "dexilant (oral disintegrating)",
            "dexlansoprazole 30 MG Disintegrating Oral Tablet",
            "dexlansoprazole 30 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "78%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "56%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LYRICA XR",
        "route": "Oral Pill",
        "fullName": "LYRICA XR (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "24 HR pregabalin 165 MG Extended Release Oral Tablet",
            "24 HR pregabalin 330 MG Extended Release Oral Tablet",
            "24 HR pregabalin 82.5 MG Extended Release Oral Tablet",
            "24 hr pregabalin 165 mg extended release oral tablet",
            "24 hr pregabalin 330 mg extended release oral tablet",
            "24 hr pregabalin 82.5 mg extended release oral tablet",
            "LYRICA",
            "LYRICA XR",
            "LYRICA XR (Oral Pill)",
            "lyrica",
            "lyrica xr",
            "lyrica xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EVISTA",
        "route": "Oral Pill",
        "fullName": "EVISTA (Oral Pill)",
        "totalCount": 9,
        "searchTerms": [
            "EVISTA",
            "EVISTA (Oral Pill)",
            "evista",
            "evista (oral pill)",
            "raloxifene hydrochloride 60 MG Oral Tablet",
            "raloxifene hydrochloride 60 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "89%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "78%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EUCERIN ECZEMA RELIEF",
        "route": "Topical",
        "fullName": "EUCERIN ECZEMA RELIEF (Topical)",
        "totalCount": 9,
        "searchTerms": [
            "EUCERIN ECZEMA RELIEF",
            "EUCERIN ECZEMA RELIEF (Topical)",
            "colloidal oatmeal 10 MG/ML Topical Cream",
            "colloidal oatmeal 10 mg/ml topical cream",
            "eucerin eczema relief",
            "eucerin eczema relief (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Loperamide",
        "route": "Chewable",
        "fullName": "Loperamide (Chewable)",
        "totalCount": 9,
        "searchTerms": [
            "Loperamide",
            "Loperamide (Chewable)",
            "loperamide",
            "loperamide (chewable)",
            "loperamide hydrochloride 2 MG Chewable Tablet",
            "loperamide hydrochloride 2 mg chewable tablet"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ZOFRAN",
        "route": "Oral Disintegrating",
        "fullName": "ZOFRAN (Oral Disintegrating)",
        "totalCount": 9,
        "searchTerms": [
            "ZOFRAN",
            "ZOFRAN (Oral Disintegrating)",
            "ondansetron 4 MG Disintegrating Oral Tablet",
            "ondansetron 4 mg disintegrating oral tablet",
            "ondansetron 8 MG Disintegrating Oral Tablet",
            "ondansetron 8 mg disintegrating oral tablet",
            "zofran",
            "zofran (oral disintegrating)"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "89%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "89%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Mag Oxide",
        "route": "Oral Pill",
        "fullName": "Mag Oxide (Oral Pill)",
        "totalCount": 9,
        "searchTerms": ["Mag Oxide", "mag oxide"],
        "dosages": [
            {
                "value": "400 mg",
                "pct": "67%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "67%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ESTRACE",
        "route": "Vaginal",
        "fullName": "ESTRACE (Vaginal)",
        "totalCount": 8,
        "searchTerms": [
            "ESTRACE",
            "ESTRACE (Vaginal)",
            "estrace",
            "estrace (vaginal)",
            "estradiol 0.1 MG/ML Vaginal Cream",
            "estradiol 0.1 mg/ml vaginal cream"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PEPCID",
        "route": "Oral Liquid",
        "fullName": "PEPCID (Oral Liquid)",
        "totalCount": 8,
        "searchTerms": [
            "PEPCID",
            "PEPCID (Oral Liquid)",
            "famotidine 8 MG/ML Oral Suspension",
            "famotidine 8 mg/ml oral suspension",
            "pepcid",
            "pepcid (oral liquid)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "KEPPRA",
        "route": "Oral Liquid",
        "fullName": "KEPPRA (Oral Liquid)",
        "totalCount": 8,
        "searchTerms": [
            "KEPPRA",
            "KEPPRA (Oral Liquid)",
            "keppra",
            "keppra (oral liquid)",
            "levetiracetam 100 MG/ML Oral Solution",
            "levetiracetam 100 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TROKENDI XR",
        "route": "Oral Pill",
        "fullName": "TROKENDI XR (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "24 HR topiramate 100 MG Extended Release Oral Capsule",
            "24 HR topiramate 200 MG Extended Release Oral Capsule",
            "24 HR topiramate 50 MG Extended Release Oral Capsule",
            "24 hr topiramate 100 mg extended release oral capsule",
            "24 hr topiramate 200 mg extended release oral capsule",
            "24 hr topiramate 50 mg extended release oral capsule",
            "TROKENDI",
            "TROKENDI XR",
            "TROKENDI XR (Oral Pill)",
            "trokendi",
            "trokendi xr",
            "trokendi xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "QUEtiapine XR",
        "route": "Oral Pill",
        "fullName": "QUEtiapine XR (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "24 HR quetiapine 200 MG Extended Release Oral Tablet",
            "24 HR quetiapine 300 MG Extended Release Oral Tablet",
            "24 hr quetiapine 200 mg extended release oral tablet",
            "24 hr quetiapine 300 mg extended release oral tablet",
            "QUEtiapine XR",
            "QUEtiapine XR (Oral Pill)",
            "quetiapine xr",
            "quetiapine xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "valGANciclovir",
        "route": "Oral Pill",
        "fullName": "valGANciclovir (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "valGANciclovir",
            "valGANciclovir (Oral Pill)",
            "valganciclovir",
            "valganciclovir (oral pill)",
            "valganciclovir 450 MG Oral Tablet",
            "valganciclovir 450 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "450 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Polyethylene glycol 3350/Potassium chloride/Sodium bicarbonate/Sodium chloride",
        "route": "Oral Solution Powder",
        "fullName": "Polyethylene glycol 3350/Potassium chloride/Sodium bicarbonate/Sodium chloride (Oral Solution Powder)",
        "totalCount": 8,
        "searchTerms": [
            "Polyethylene glycol 3350/Potassium chloride/Sodium bicarbonate/Sodium chloride",
            "Polyethylene glycol 3350/Potassium chloride/Sodium bicarbonate/Sodium chloride (Oral Solution Powder)",
            "polyethylene glycol 3350 210000 MG / potassium chloride 740 MG / sodium bicarbonate 2860 MG / sodium chloride 5600 MG Powder for Oral Solution",
            "polyethylene glycol 3350 210000 mg / potassium chloride 740 mg / sodium bicarbonate 2860 mg / sodium chloride 5600 mg powder for oral solution",
            "polyethylene glycol 3350/potassium chloride/sodium bicarbonate/sodium chloride",
            "polyethylene glycol 3350/potassium chloride/sodium bicarbonate/sodium chloride (oral solution powder)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MURO 128",
        "route": "Ophthalmic",
        "fullName": "MURO 128 (Ophthalmic)",
        "totalCount": 8,
        "searchTerms": [
            "MURO 128",
            "MURO 128 (Ophthalmic)",
            "muro 128",
            "muro 128 (ophthalmic)",
            "sodium chloride 0.000855 MEQ/MG Ophthalmic Ointment",
            "sodium chloride 0.000855 meq/mg ophthalmic ointment",
            "sodium chloride 0.342 MEQ/ML Ophthalmic Solution",
            "sodium chloride 0.342 meq/ml ophthalmic solution",
            "sodium chloride 0.854 MEQ/ML Ophthalmic Solution",
            "sodium chloride 0.854 meq/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "D3 DOTS",
        "route": "Oral Pill",
        "fullName": "D3 DOTS (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "D3 DOTS",
            "D3 DOTS (Oral Pill)",
            "cholecalciferol 0.05 MG Oral Tablet",
            "cholecalciferol 0.05 mg oral tablet",
            "d3 dots",
            "d3 dots (oral pill)"
        ],
        "dosages": [
            {
                "value": "50 mcg",
                "pct": "75%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Zolpidem XR",
        "route": "Oral Pill",
        "fullName": "Zolpidem XR (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Zolpidem XR",
            "Zolpidem XR (Oral Pill)",
            "zolpidem tartrate 12.5 MG Extended Release Oral Tablet",
            "zolpidem tartrate 12.5 mg extended release oral tablet",
            "zolpidem tartrate 6.25 MG Extended Release Oral Tablet",
            "zolpidem tartrate 6.25 mg extended release oral tablet",
            "zolpidem xr",
            "zolpidem xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "12.5 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DELTASONE",
        "route": "Oral Pill",
        "fullName": "DELTASONE (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "DELTASONE",
            "DELTASONE (Oral Pill)",
            "deltasone",
            "deltasone (oral pill)",
            "prednisone 20 MG Oral Tablet",
            "prednisone 20 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ibuprofen",
        "route": "Oral Liquid",
        "fullName": "Ibuprofen (Oral Liquid)",
        "totalCount": 8,
        "searchTerms": [
            "Ibuprofen",
            "Ibuprofen (Oral Liquid)",
            "ibuprofen",
            "ibuprofen (oral liquid)",
            "ibuprofen 20 MG/ML Oral Suspension",
            "ibuprofen 20 mg/ml oral suspension"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DEEP SEA",
        "route": "Nasal",
        "fullName": "DEEP SEA (Nasal)",
        "totalCount": 8,
        "searchTerms": [
            "DEEP SEA",
            "DEEP SEA (Nasal)",
            "deep sea",
            "deep sea (nasal)",
            "sodium chloride 0.111 MEQ/ML Nasal Spray",
            "sodium chloride 0.111 meq/ml nasal spray"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cefuroxime",
        "route": "Oral Pill",
        "fullName": "Cefuroxime (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Cefuroxime",
            "Cefuroxime (Oral Pill)",
            "Cefuroxime (Oral)",
            "cefuroxime",
            "cefuroxime (oral pill)",
            "cefuroxime (oral)",
            "cefuroxime 250 MG Oral Tablet",
            "cefuroxime 250 mg oral tablet",
            "cefuroxime 500 MG Oral Tablet",
            "cefuroxime 500 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DECALCITROL",
        "route": "Oral Pill",
        "fullName": "DECALCITROL (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "DECALCITROL",
            "DECALCITROL (Oral Pill)",
            "cholecalciferol 1.25 MG Oral Tablet",
            "cholecalciferol 1.25 mg oral tablet",
            "decalcitrol",
            "decalcitrol (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LORazepam",
        "route": "Injectable",
        "fullName": "LORazepam (Injectable)",
        "totalCount": 8,
        "searchTerms": [
            "1 ML lorazepam 2 MG/ML Injection",
            "1 ML lorazepam 4 MG/ML Injection",
            "1 ml lorazepam 2 mg/ml injection",
            "1 ml lorazepam 4 mg/ml injection",
            "LORazepam",
            "LORazepam (Injectable)",
            "lorazepam",
            "lorazepam (injectable)"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "methylPREDNISolone",
        "route": "Oral Pill",
        "fullName": "methylPREDNISolone (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "methylPREDNISolone",
            "methylPREDNISolone (Oral Pill)",
            "methylPREDNISolone (Oral)",
            "methylprednisolone",
            "methylprednisolone (oral pill)",
            "methylprednisolone (oral)",
            "methylprednisolone 4 MG Oral Tablet",
            "methylprednisolone 4 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "METAMUCIL",
        "route": "Oral Pill",
        "fullName": "METAMUCIL (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "METAMUCIL",
            "METAMUCIL (Oral Pill)",
            "metamucil",
            "metamucil (oral pill)",
            "psyllium 400 MG Oral Capsule",
            "psyllium 400 mg oral capsule",
            "psyllium 500 MG Oral Capsule",
            "psyllium 500 mg oral capsule",
            "psyllium 525 MG Oral Capsule",
            "psyllium 525 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dulaglutide",
        "route": "Injectable",
        "fullName": "Dulaglutide (Injectable)",
        "totalCount": 8,
        "searchTerms": [
            "0.5 ML dulaglutide 1.5 MG/ML Auto-Injector",
            "0.5 ml dulaglutide 1.5 mg/ml auto-injector",
            "Dulaglutide",
            "Dulaglutide (Injectable)",
            "dulaglutide",
            "dulaglutide (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CARAFATE",
        "route": "Oral Liquid",
        "fullName": "CARAFATE (Oral Liquid)",
        "totalCount": 8,
        "searchTerms": [
            "CARAFATE",
            "CARAFATE (Oral Liquid)",
            "carafate",
            "carafate (oral liquid)",
            "sucralfate 100 MG/ML Oral Suspension",
            "sucralfate 100 mg/ml oral suspension"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CEQUA",
        "route": "Ophthalmic",
        "fullName": "CEQUA (Ophthalmic)",
        "totalCount": 8,
        "searchTerms": [
            "CEQUA",
            "CEQUA (Ophthalmic)",
            "cequa",
            "cequa (ophthalmic)",
            "cyclosporine 0.9 MG/ML Ophthalmic Solution",
            "cyclosporine 0.9 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CHANTIX",
        "route": "Oral Pill",
        "fullName": "CHANTIX (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "CHANTIX",
            "CHANTIX (Oral Pill)",
            "chantix",
            "chantix (oral pill)",
            "varenicline 0.5 MG Oral Tablet",
            "varenicline 0.5 mg oral tablet",
            "varenicline 1 MG Oral Tablet",
            "varenicline 1 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Acetaminophen/Dextromethorphan/Doxylamine",
        "route": "Oral Liquid",
        "fullName": "Acetaminophen/Dextromethorphan/Doxylamine (Oral Liquid)",
        "totalCount": 8,
        "searchTerms": [
            "Acetaminophen/Dextromethorphan/Doxylamine",
            "Acetaminophen/Dextromethorphan/Doxylamine (Oral Liquid)",
            "acetaminophen 21.7 MG/ML / dextromethorphan hydrobromide 1 MG/ML / doxylamine succinate 0.417 MG/ML Oral Solution",
            "acetaminophen 21.7 mg/ml / dextromethorphan hydrobromide 1 mg/ml / doxylamine succinate 0.417 mg/ml oral solution",
            "acetaminophen 33.3 MG/ML / dextromethorphan hydrobromide 1 MG/ML / doxylamine succinate 0.417 MG/ML Oral Solution",
            "acetaminophen 33.3 mg/ml / dextromethorphan hydrobromide 1 mg/ml / doxylamine succinate 0.417 mg/ml oral solution",
            "acetaminophen/dextromethorphan/doxylamine",
            "acetaminophen/dextromethorphan/doxylamine (oral liquid)"
        ],
        "dosages": [
            {
                "value": "500-15-6.255 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OYSCO D",
        "route": "Oral Pill",
        "fullName": "OYSCO D (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "OYSCO D",
            "OYSCO D (Oral Pill)",
            "calcium carbonate 625 MG / cholecalciferol 125 UNT Oral Tablet",
            "calcium carbonate 625 mg / cholecalciferol 125 unt oral tablet",
            "oysco d",
            "oysco d (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OTEZLA",
        "route": "Oral Pill",
        "fullName": "OTEZLA (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "OTEZLA",
            "OTEZLA (Oral Pill)",
            "Otezla",
            "Otezla (Oral)",
            "apremilast 30 MG Oral Tablet",
            "apremilast 30 mg oral tablet",
            "otezla",
            "otezla (oral pill)",
            "otezla (oral)"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Bicalutamide",
        "route": "Oral Pill",
        "fullName": "Bicalutamide (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Bicalutamide",
            "Bicalutamide (Oral Pill)",
            "bicalutamide",
            "bicalutamide (oral pill)",
            "bicalutamide 50 MG Oral Tablet",
            "bicalutamide 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Sodium chloride",
        "route": "Inhalant",
        "fullName": "Sodium chloride (Inhalant)",
        "totalCount": 8,
        "searchTerms": [
            "Sodium chloride",
            "Sodium chloride (Inhalant)",
            "sodium chloride",
            "sodium chloride (inhalant)",
            "sodium chloride 60 MG/ML Inhalation Solution",
            "sodium chloride 60 mg/ml inhalation solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ROBAXIN",
        "route": "Oral Pill",
        "fullName": "ROBAXIN (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "ROBAXIN",
            "ROBAXIN (Oral Pill)",
            "methocarbamol 500 MG Oral Tablet",
            "methocarbamol 500 mg oral tablet",
            "methocarbamol 750 MG Oral Tablet",
            "methocarbamol 750 mg oral tablet",
            "robaxin",
            "robaxin (oral pill)"
        ],
        "dosages": [
            {
                "value": "750 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Risedronate",
        "route": "Oral Pill",
        "fullName": "Risedronate (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Risedronate",
            "Risedronate (Oral Pill)",
            "risedronate",
            "risedronate (oral pill)",
            "risedronate sodium 150 MG Oral Tablet",
            "risedronate sodium 150 mg oral tablet",
            "risedronate sodium 35 MG Delayed Release Oral Tablet",
            "risedronate sodium 35 MG Oral Tablet",
            "risedronate sodium 35 mg delayed release oral tablet",
            "risedronate sodium 35 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Oxybutynin",
        "route": "Oral Liquid",
        "fullName": "Oxybutynin (Oral Liquid)",
        "totalCount": 8,
        "searchTerms": [
            "Oxybutynin",
            "Oxybutynin (Oral Liquid)",
            "oxyBUTYnin",
            "oxyBUTYnin (Oral Liquid)",
            "oxybutynin",
            "oxybutynin (oral liquid)",
            "oxybutynin chloride 1 MG/ML Oral Solution",
            "oxybutynin chloride 1 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VIIBRYD",
        "route": "Oral Pill",
        "fullName": "VIIBRYD (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "VIIBRYD",
            "VIIBRYD (Oral Pill)",
            "viibryd",
            "viibryd (oral pill)",
            "vilazodone hydrochloride 10 MG Oral Tablet",
            "vilazodone hydrochloride 10 mg oral tablet",
            "vilazodone hydrochloride 20 MG Oral Tablet",
            "vilazodone hydrochloride 20 mg oral tablet",
            "vilazodone hydrochloride 40 MG Oral Tablet",
            "vilazodone hydrochloride 40 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Rifampin",
        "route": "Oral Pill",
        "fullName": "Rifampin (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Rifampin",
            "Rifampin (Oral Pill)",
            "rifAMPin",
            "rifAMPin (Oral Pill)",
            "rifampin",
            "rifampin (oral pill)",
            "rifampin 150 MG Oral Capsule",
            "rifampin 150 mg oral capsule",
            "rifampin 300 MG Oral Capsule",
            "rifampin 300 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "GUAIFENESIN",
        "route": "Oral Liquid",
        "fullName": "GUAIFENESIN (Oral Liquid)",
        "totalCount": 8,
        "searchTerms": [
            "GUAIFENESIN",
            "Guaifenesin",
            "guaiFENesin",
            "guaiFENesin (Oral Liquid)",
            "guaifenesin",
            "guaifenesin (oral liquid)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BELSOMRA",
        "route": "Oral Pill",
        "fullName": "BELSOMRA (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "BELSOMRA",
            "BELSOMRA (Oral Pill)",
            "Belsomra",
            "Belsomra (Oral)",
            "belsomra",
            "belsomra (oral pill)",
            "belsomra (oral)",
            "suvorexant 10 MG Oral Tablet",
            "suvorexant 10 mg oral tablet",
            "suvorexant 5 MG Oral Tablet",
            "suvorexant 5 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "QULIPTA",
        "route": "Oral Pill",
        "fullName": "QULIPTA (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "QULIPTA",
            "QULIPTA (Oral Pill)",
            "QULIPTA (Oral)",
            "Qulipta",
            "Qulipta (Oral)",
            "qulipta",
            "qulipta (oral pill)",
            "qulipta (oral)"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "88%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G43.909",
                "description": "Migraine, unsp, not intractable, without status migrainosus",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "Diclofenac/Lidocaine",
        "route": "Topical",
        "fullName": "Diclofenac/Lidocaine (Topical)",
        "totalCount": 8,
        "searchTerms": [
            "Diclofenac/Lidocaine",
            "Diclofenac/Lidocaine (Topical)",
            "diclofenac/lidocaine",
            "diclofenac/lidocaine (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RANOLAZINE",
        "route": "Oral Pill",
        "fullName": "RANOLAZINE (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "RANOLAZINE",
            "Ranolazine",
            "Ranolazine (Oral)",
            "ranolazine",
            "ranolazine (Oral)",
            "ranolazine (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "88%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DOK",
        "route": "Oral Pill",
        "fullName": "DOK (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "DOK",
            "DOK (Oral Pill)",
            "docusate sodium 100 MG Oral Capsule",
            "docusate sodium 100 MG Oral Tablet",
            "docusate sodium 100 mg oral capsule",
            "docusate sodium 100 mg oral tablet",
            "dok",
            "dok (oral pill)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TIRZEPATIDE",
        "route": "Injectable",
        "fullName": "TIRZEPATIDE (Injectable)",
        "totalCount": 8,
        "searchTerms": [
            "Tirzepatide",
            "Tirzepatide (Injectable)",
            "tirzepatide",
            "tirzepatide (Injectable)",
            "tirzepatide (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "88%"
            }
        ]
    },
    {
        "name": "Ketorolac",
        "route": "Oral Pill",
        "fullName": "Ketorolac (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Ketorolac",
            "Ketorolac (Oral Pill)",
            "Ketorolac (Oral)",
            "ketorolac",
            "ketorolac (oral pill)",
            "ketorolac (oral)",
            "ketorolac tromethamine 10 MG Oral Tablet",
            "ketorolac tromethamine 10 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FERREX-150",
        "route": "Oral Pill",
        "fullName": "FERREX-150 (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "FERREX-150",
            "FERREX-150 (Oral Pill)",
            "ferrex-150",
            "ferrex-150 (oral pill)",
            "polysaccharide iron complex 150 MG Oral Capsule",
            "polysaccharide iron complex 150 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SAVELLA",
        "route": "Oral Pill",
        "fullName": "SAVELLA (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "SAVELLA",
            "SAVELLA (Oral Pill)",
            "Savella",
            "Savella (Oral)",
            "milnacipran hydrochloride 100 MG Oral Tablet",
            "milnacipran hydrochloride 100 mg oral tablet",
            "milnacipran hydrochloride 25 MG Oral Tablet",
            "milnacipran hydrochloride 25 mg oral tablet",
            "savella",
            "savella (oral pill)",
            "savella (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Bethanechol",
        "route": "Oral Pill",
        "fullName": "Bethanechol (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Bethanechol",
            "Bethanechol (Oral Pill)",
            "bethanechol",
            "bethanechol (oral pill)",
            "bethanechol chloride 10 MG Oral Tablet",
            "bethanechol chloride 10 mg oral tablet",
            "bethanechol chloride 25 MG Oral Tablet",
            "bethanechol chloride 25 mg oral tablet",
            "bethanechol chloride 50 MG Oral Tablet",
            "bethanechol chloride 50 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Divalproex Sod DR",
        "route": "Oral Pill",
        "fullName": "Divalproex Sod DR (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "DIVALPROEX SOD DR",
            "DIVALPROEX SOD DR (Oral)",
            "Divalproex SOD DR",
            "Divalproex SOD DR (Oral)",
            "Divalproex Sod DR",
            "Divalproex Sod DR (Oral)",
            "divalproex sod dr",
            "divalproex sod dr (oral)"
        ],
        "dosages": [
            {
                "value": "250 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OMEGA-3-ACID ETHYL ESTERS",
        "route": "Oral Pill",
        "fullName": "OMEGA-3-ACID ETHYL ESTERS (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Lovaza",
            "OMEGA-3-ACID ETHYL ESTERS",
            "Omega-3-Acid Ethyl Esters",
            "Omega-3-Acid Ethyl Esters (Oral)",
            "Omega-3-acid ethyl esters",
            "Omega-3-acid ethyl esters (Oral)",
            "lovaza",
            "omega-3-acid ethyl esters",
            "omega-3-acid ethyl esters (oral)"
        ],
        "dosages": [
            {
                "value": "1 g",
                "pct": "62%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Budesonide and Formoterol Fumarate Dihydrate Inhalation Aerosol",
        "route": "Inhaler",
        "fullName": "Budesonide and Formoterol Fumarate Dihydrate Inhalation Aerosol (Inhaler)",
        "totalCount": 8,
        "searchTerms": [
            "Budesonide and Formoterol Fumarate Dihydrate Inhalation Aerosol",
            "Budesonide and Formoterol Fumarate Dihydrate Inhalation Aerosol (Inhaler)",
            "Symbicort",
            "budesonide and formoterol fumarate dihydrate inhalation aerosol",
            "budesonide and formoterol fumarate dihydrate inhalation aerosol (inhaler)",
            "symbicort"
        ],
        "dosages": [
            {
                "value": "160 mcg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "DULOXETINE HCL DR",
        "route": "Oral Pill",
        "fullName": "DULOXETINE HCL DR (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "CYMBALTA",
            "DULOXETINE HCL DR",
            "DULOXETINE HCL DR (Oral)",
            "Duloxetine HCL DR",
            "Duloxetine HCL DR (Oral)",
            "Duloxetine HCl DR",
            "Duloxetine HCl DR (Oral)",
            "cymbalta",
            "duloxetine hcl dr",
            "duloxetine hcl dr (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Losartan-HCTZ",
        "route": "Oral Pill",
        "fullName": "Losartan-HCTZ (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "HYZAAR",
            "Hyzaar",
            "LOSARTAN-HCTZ",
            "LOSARTAN-HCTZ (Oral)",
            "Losartan-HCTZ",
            "Losartan-HCTZ (Oral)",
            "hyzaar",
            "losartan-hctz",
            "losartan-hctz (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Oxycodone/APAP",
        "route": "Oral Pill",
        "fullName": "Oxycodone/APAP (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Oxycodone/APAP",
            "Oxycodone/APAP (Oral)",
            "Percocet",
            "oxycodone/apap",
            "oxycodone/apap (oral)",
            "percocet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "Hydrochlorothiazide/Irbesartan",
        "route": "Oral Pill",
        "fullName": "Hydrochlorothiazide/Irbesartan (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Hydrochlorothiazide/Irbesartan",
            "Hydrochlorothiazide/Irbesartan (Oral Pill)",
            "hydroCHLOROthiazide/Irbesartan",
            "hydroCHLOROthiazide/Irbesartan (Oral Pill)",
            "hydrochlorothiazide 12.5 MG / irbesartan 150 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / irbesartan 300 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / irbesartan 150 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / irbesartan 300 mg oral tablet",
            "hydrochlorothiazide/irbesartan",
            "hydrochlorothiazide/irbesartan (oral pill)"
        ],
        "dosages": [
            {
                "value": "12.5-150 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HCTZ",
        "route": "Oral Pill",
        "fullName": "HCTZ (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "HCTZ",
            "HCTZ (Oral)",
            "HydroDIURIL",
            "Microzide",
            "hctz",
            "hctz (oral)",
            "hydrodiuril",
            "microzide"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Amiodarone HCl",
        "route": "Oral Pill",
        "fullName": "Amiodarone HCl (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "AMIODARONE HCL",
            "AMIODARONE HCL (Oral)",
            "Amiodarone HCL",
            "Amiodarone HCL (Oral)",
            "Amiodarone HCl",
            "Amiodarone HCl (Oral)",
            "Amiodarone Hcl",
            "Amiodarone Hcl (Oral)",
            "Cordarone Tabs",
            "Pacerone",
            "amiodarone hcl",
            "amiodarone hcl (oral)",
            "cordarone tabs",
            "pacerone"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I48.91",
                "description": "Unspecified atrial fibrillation",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "URSODIOL",
        "route": "Oral Pill",
        "fullName": "URSODIOL (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Actigall",
            "URSODIOL",
            "Urso 250",
            "Ursodiol",
            "Ursodiol (Oral)",
            "actigall",
            "urso 250",
            "ursodiol",
            "ursodiol (oral)"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Hydrochlorothiazide/Telmisartan",
        "route": "Oral Pill",
        "fullName": "Hydrochlorothiazide/Telmisartan (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Hydrochlorothiazide/Telmisartan",
            "Hydrochlorothiazide/Telmisartan (Oral Pill)",
            "Micardis",
            "hydroCHLOROthiazide/Telmisartan",
            "hydroCHLOROthiazide/Telmisartan (Oral Pill)",
            "hydrochlorothiazide 12.5 MG / telmisartan 40 MG Oral Tablet",
            "hydrochlorothiazide 12.5 MG / telmisartan 80 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / telmisartan 40 mg oral tablet",
            "hydrochlorothiazide 12.5 mg / telmisartan 80 mg oral tablet",
            "hydrochlorothiazide 25 MG / telmisartan 80 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / telmisartan 80 mg oral tablet",
            "hydrochlorothiazide/telmisartan",
            "hydrochlorothiazide/telmisartan (oral pill)",
            "micardis"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Magnesium - Supplement",
        "route": "Oral Pill",
        "fullName": "Magnesium - Supplement (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Magnesium - Supplement",
            "Magnesium - Supplement (Oral)",
            "magnesium - supplement",
            "magnesium - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E83.42",
                "description": "Hypomagnesemia",
                "pct": "62%"
            }
        ]
    },
    {
        "name": "SOLIQUA",
        "route": "Injectable",
        "fullName": "SOLIQUA (Injectable)",
        "totalCount": 8,
        "searchTerms": [
            "3 ML insulin glargine 100 UNT/ML / lixisenatide 0.033 MG/ML Pen Injector",
            "3 ml insulin glargine 100 unt/ml / lixisenatide 0.033 mg/ml pen injector",
            "SOLIQUA",
            "SOLIQUA (Injectable)",
            "soliqua",
            "soliqua (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ammonium Lactate Cream",
        "route": "Topical",
        "fullName": "Ammonium Lactate Cream (Topical)",
        "totalCount": 8,
        "searchTerms": [
            "Ammonium Lactate Cream",
            "Ammonium Lactate Cream (Topical)",
            "Lac-Hydrin",
            "ammonium lactate cream",
            "ammonium lactate cream (Topical)",
            "ammonium lactate cream (topical)",
            "lac-hydrin"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "L85.3",
                "description": "Xerosis cutis",
                "pct": "88%"
            }
        ]
    },
    {
        "name": "Ondansetron HCl",
        "route": "Oral Pill",
        "fullName": "Ondansetron HCl (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "ONDANSETRON HCL",
            "ONDANSETRON HCL (Oral)",
            "Ondansetron HCL",
            "Ondansetron HCL (Oral)",
            "Ondansetron HCl",
            "Ondansetron HCl (Oral)",
            "ondansetron hcl",
            "ondansetron hcl (oral)"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "88%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R11.0",
                "description": "Nausea",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Tylenol Extra Strength Acetaminophen",
        "route": "Oral Pill",
        "fullName": "Tylenol Extra Strength Acetaminophen (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Tylenol Extra Strength Acetaminophen",
            "Tylenol Extra Strength Acetaminophen (Oral)",
            "tylenol extra strength acetaminophen",
            "tylenol extra strength acetaminophen (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R52",
                "description": "Pain, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "losartan (COZAAR)",
        "route": "Oral Pill",
        "fullName": "losartan (COZAAR) (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Losartan (Cozaar)",
            "Losartan (Cozaar) (Oral)",
            "losartan (COZAAR)",
            "losartan (COZAAR) (Oral)",
            "losartan (Cozaar)",
            "losartan (Cozaar) (Oral)",
            "losartan (cozaar)",
            "losartan (cozaar) (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Dorzolamide Hydrochloride and Timolol Maleate",
        "route": "Ophthalmic",
        "fullName": "Dorzolamide Hydrochloride and Timolol Maleate (Ophthalmic)",
        "totalCount": 8,
        "searchTerms": [
            "Dorzolamide Hydrochloride and Timolol Maleate",
            "Dorzolamide Hydrochloride and Timolol Maleate (Ophthalmic)",
            "dorzolamide hydrochloride and timolol maleate",
            "dorzolamide hydrochloride and timolol maleate (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H40.9",
                "description": "Unspecified glaucoma",
                "pct": "75%"
            }
        ]
    },
    {
        "name": "AUSTEDO",
        "route": "Oral Pill",
        "fullName": "AUSTEDO (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "AUSTEDO",
            "AUSTEDO (Oral Pill)",
            "austedo",
            "austedo (oral pill)",
            "deutetrabenazine 12 MG Oral Tablet",
            "deutetrabenazine 12 mg oral tablet",
            "deutetrabenazine 6 MG Oral Tablet",
            "deutetrabenazine 6 mg oral tablet",
            "deutetrabenazine 9 MG Oral Tablet",
            "deutetrabenazine 9 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "REGULOID",
        "route": "Oral Suspension Powder",
        "fullName": "REGULOID (Oral Suspension Powder)",
        "totalCount": 8,
        "searchTerms": [
            "REGULOID",
            "REGULOID (Oral Suspension Powder)",
            "psyllium 3400 MG Powder for Oral Suspension",
            "psyllium 3400 mg powder for oral suspension",
            "reguloid",
            "reguloid (oral suspension powder)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Misoprostol",
        "route": "Oral Pill",
        "fullName": "Misoprostol (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Misoprostol",
            "Misoprostol (Oral Pill)",
            "Misoprostol (Oral)",
            "misoprostol",
            "misoprostol (oral pill)",
            "misoprostol (oral)",
            "misoprostol 0.1 MG Oral Tablet",
            "misoprostol 0.1 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DICLOFENAC EPOLAMINE",
        "route": "Topical",
        "fullName": "DICLOFENAC EPOLAMINE (Topical)",
        "totalCount": 8,
        "searchTerms": [
            "DICLOFENAC EPOLAMINE",
            "Diclofenac Epolamine",
            "Diclofenac Epolamine (Topical)",
            "diclofenac epolamine",
            "diclofenac epolamine (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "medroxyPROGESTERone",
        "route": "Injectable",
        "fullName": "medroxyPROGESTERone (Injectable)",
        "totalCount": 8,
        "searchTerms": [
            "0.65 ML medroxyprogesterone acetate 160 MG/ML Prefilled Syringe",
            "0.65 ml medroxyprogesterone acetate 160 mg/ml prefilled syringe",
            "1 ML medroxyprogesterone acetate 150 MG/ML Injection",
            "1 ml medroxyprogesterone acetate 150 mg/ml injection",
            "medroxyPROGESTERone",
            "medroxyPROGESTERone (Injectable)",
            "medroxyprogesterone",
            "medroxyprogesterone (injectable)",
            "medroxyprogesterone acetate 400 MG/ML Injectable Suspension",
            "medroxyprogesterone acetate 400 mg/ml injectable suspension"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dimethicone/Miconazole/Zinc oxide",
        "route": "Topical",
        "fullName": "Dimethicone/Miconazole/Zinc oxide (Topical)",
        "totalCount": 8,
        "searchTerms": [
            "Dimethicone/Miconazole/Zinc oxide",
            "Dimethicone/Miconazole/Zinc oxide (Topical)",
            "dimethicone 100 MG/ML / miconazole nitrate 20 MG/ML / zinc oxide 100 MG/ML Topical Spray",
            "dimethicone 100 mg/ml / miconazole nitrate 20 mg/ml / zinc oxide 100 mg/ml topical spray",
            "dimethicone/miconazole/zinc oxide",
            "dimethicone/miconazole/zinc oxide (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Caffeine/Magnesium salicylate",
        "route": "Oral Pill",
        "fullName": "Caffeine/Magnesium salicylate (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Caffeine/Magnesium salicylate",
            "Caffeine/Magnesium salicylate (Oral Pill)",
            "caffeine 50 MG / magnesium salicylate 162.5 MG Oral Tablet",
            "caffeine 50 mg / magnesium salicylate 162.5 mg oral tablet",
            "caffeine/magnesium salicylate",
            "caffeine/magnesium salicylate (oral pill)"
        ],
        "dosages": [
            {
                "value": "50-162.5 mg",
                "pct": "88%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "AMARYL",
        "route": "Oral Pill",
        "fullName": "AMARYL (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "AMARYL",
            "AMARYL (Oral Pill)",
            "amaryl",
            "amaryl (oral pill)",
            "glimepiride 1 MG Oral Tablet",
            "glimepiride 1 mg oral tablet",
            "glimepiride 2 MG Oral Tablet",
            "glimepiride 2 mg oral tablet",
            "glimepiride 4 MG Oral Tablet",
            "glimepiride 4 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "4 mg",
                "pct": "75%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FOLBECAL XR",
        "route": "Oral Pill",
        "fullName": "FOLBECAL XR (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "24 HR calcium carbonate 200 MG / folic acid 1 MG / pyridoxine 75 MG / vitamin B12 0.012 MG Extended Release Oral Tablet",
            "24 hr calcium carbonate 200 mg / folic acid 1 mg / pyridoxine 75 mg / vitamin b12 0.012 mg extended release oral tablet",
            "FOLBECAL",
            "FOLBECAL XR",
            "FOLBECAL XR (Oral Pill)",
            "folbecal",
            "folbecal xr",
            "folbecal xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Potassium gluconate",
        "route": "Oral Pill",
        "fullName": "Potassium gluconate (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "Potassium gluconate",
            "Potassium gluconate (Oral Pill)",
            "potassium gluconate",
            "potassium gluconate (oral pill)",
            "potassium gluconate 2 MEQ Oral Tablet",
            "potassium gluconate 2 meq oral tablet",
            "potassium gluconate 2.13 MEQ Oral Tablet",
            "potassium gluconate 2.13 meq oral tablet",
            "potassium gluconate 2.35 MEQ Oral Tablet",
            "potassium gluconate 2.35 meq oral tablet",
            "potassium gluconate 2.5 MEQ Oral Tablet",
            "potassium gluconate 2.5 meq oral tablet",
            "potassium gluconate 2.6 MEQ Oral Tablet",
            "potassium gluconate 2.6 meq oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EXELON",
        "route": "Oral Pill",
        "fullName": "EXELON (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "EXELON",
            "EXELON (Oral Pill)",
            "exelon",
            "exelon (oral pill)",
            "rivastigmine 1.5 MG Oral Capsule",
            "rivastigmine 1.5 mg oral capsule",
            "rivastigmine 3 MG Oral Capsule",
            "rivastigmine 3 mg oral capsule",
            "rivastigmine 4.5 MG Oral Capsule",
            "rivastigmine 4.5 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MAPAP PM",
        "route": "Oral Pill",
        "fullName": "MAPAP PM (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "MAPAP PM",
            "MAPAP PM (Oral Pill)",
            "acetaminophen 500 MG / diphenhydramine hydrochloride 25 MG Oral Tablet",
            "acetaminophen 500 mg / diphenhydramine hydrochloride 25 mg oral tablet",
            "mapap pm",
            "mapap pm (oral pill)"
        ],
        "dosages": [
            {
                "value": "500-25 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "62%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BENTYL",
        "route": "Oral Pill",
        "fullName": "BENTYL (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "BENTYL",
            "BENTYL (Oral Pill)",
            "bentyl",
            "bentyl (oral pill)",
            "dicyclomine hydrochloride 10 MG Oral Capsule",
            "dicyclomine hydrochloride 10 mg oral capsule",
            "dicyclomine hydrochloride 20 MG Oral Tablet",
            "dicyclomine hydrochloride 20 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Phenytoin",
        "route": "Chewable",
        "fullName": "Phenytoin (Chewable)",
        "totalCount": 8,
        "searchTerms": [
            "Phenytoin",
            "Phenytoin (Chewable)",
            "phenytoin",
            "phenytoin (chewable)",
            "phenytoin 50 MG Chewable Tablet",
            "phenytoin 50 mg chewable tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ANTIVERT",
        "route": "Oral Pill",
        "fullName": "ANTIVERT (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "ANTIVERT",
            "ANTIVERT (Oral Pill)",
            "antivert",
            "antivert (oral pill)",
            "meclizine hydrochloride 12.5 MG Oral Tablet",
            "meclizine hydrochloride 12.5 mg oral tablet",
            "meclizine hydrochloride 25 MG Oral Tablet",
            "meclizine hydrochloride 25 mg oral tablet",
            "meclizine hydrochloride 50 MG Oral Tablet",
            "meclizine hydrochloride 50 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TOBRADEX",
        "route": "Ophthalmic",
        "fullName": "TOBRADEX (Ophthalmic)",
        "totalCount": 8,
        "searchTerms": [
            "TOBRADEX",
            "TOBRADEX (Ophthalmic)",
            "dexamethasone 0.5 MG/ML / tobramycin 3 MG/ML Ophthalmic Suspension",
            "dexamethasone 0.5 mg/ml / tobramycin 3 mg/ml ophthalmic suspension",
            "dexamethasone 1 MG/ML / tobramycin 3 MG/ML Ophthalmic Suspension",
            "dexamethasone 1 mg/ml / tobramycin 3 mg/ml ophthalmic suspension",
            "tobradex",
            "tobradex (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ALTACE",
        "route": "Oral Pill",
        "fullName": "ALTACE (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "ALTACE",
            "ALTACE (Oral Pill)",
            "altace",
            "altace (oral pill)",
            "ramipril 10 MG Oral Capsule",
            "ramipril 10 mg oral capsule",
            "ramipril 2.5 MG Oral Capsule",
            "ramipril 2.5 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "62%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "75%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SENOKOT-S",
        "route": "Oral Pill",
        "fullName": "SENOKOT-S (Oral Pill)",
        "totalCount": 8,
        "searchTerms": [
            "SENOKOT-S",
            "SENOKOT-S (Oral Pill)",
            "docusate sodium 50 MG / sennosides, USP 8.6 MG Oral Tablet",
            "docusate sodium 50 mg / sennosides, usp 8.6 mg oral tablet",
            "senokot-s",
            "senokot-s (oral pill)"
        ],
        "dosages": [
            {
                "value": "50-8.6 mg",
                "pct": "88%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NEPHPLEX RX",
        "route": "Oral Pill",
        "fullName": "NEPHPLEX RX (Oral Pill)",
        "totalCount": 8,
        "searchTerms": ["NEPHPLEX RX", "nephplex rx"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Daily Vite",
        "route": "Oral Pill",
        "fullName": "Daily Vite (Oral Pill)",
        "totalCount": 8,
        "searchTerms": ["Daily Vite", "daily vite"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CoQ10",
        "route": "Oral Pill",
        "fullName": "CoQ10 (Oral Pill)",
        "totalCount": 8,
        "searchTerms": ["COQ10", "CoQ10", "coq10"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "88%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Metoprolol",
        "route": "Injectable",
        "fullName": "Metoprolol (Injectable)",
        "totalCount": 7,
        "searchTerms": [
            "5 ML metoprolol tartrate 1 MG/ML Cartridge",
            "5 ml metoprolol tartrate 1 mg/ml cartridge",
            "Metoprolol",
            "Metoprolol (Injectable)",
            "metoprolol",
            "metoprolol (injectable)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dextromethorphan/guaiFENesin/Phenylephrine",
        "route": "Oral Liquid",
        "fullName": "Dextromethorphan/guaiFENesin/Phenylephrine (Oral Liquid)",
        "totalCount": 7,
        "searchTerms": [
            "Dextromethorphan/guaiFENesin/Phenylephrine",
            "Dextromethorphan/guaiFENesin/Phenylephrine (Oral Liquid)",
            "dextromethorphan hydrobromide 6 MG/ML / guaifenesin 40 MG/ML / phenylephrine hydrochloride 1.5 MG/ML Oral Solution",
            "dextromethorphan hydrobromide 6 mg/ml / guaifenesin 40 mg/ml / phenylephrine hydrochloride 1.5 mg/ml oral solution",
            "dextromethorphan/guaifenesin/phenylephrine",
            "dextromethorphan/guaifenesin/phenylephrine (oral liquid)"
        ],
        "dosages": [
            {
                "value": "30-200-7.5 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Chlorzoxazone",
        "route": "Oral Pill",
        "fullName": "Chlorzoxazone (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Chlorzoxazone",
            "Chlorzoxazone (Oral Pill)",
            "Chlorzoxazone (Oral)",
            "chlorzoxazone",
            "chlorzoxazone (oral pill)",
            "chlorzoxazone (oral)",
            "chlorzoxazone 250 MG Oral Tablet",
            "chlorzoxazone 250 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Abiraterone",
        "route": "Oral Pill",
        "fullName": "Abiraterone (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Abiraterone",
            "Abiraterone (Oral Pill)",
            "abiraterone",
            "abiraterone (oral pill)",
            "abiraterone acetate 250 MG Oral Tablet",
            "abiraterone acetate 250 mg oral tablet",
            "abiraterone acetate 500 MG Oral Tablet",
            "abiraterone acetate 500 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CALTRATE",
        "route": "Oral Pill",
        "fullName": "CALTRATE (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "CALTRATE",
            "CALTRATE (Oral Pill)",
            "calcium carbonate 1500 MG Oral Tablet",
            "calcium carbonate 1500 mg oral tablet",
            "caltrate",
            "caltrate (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Rifaximin",
        "route": "Oral Pill",
        "fullName": "Rifaximin (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Rifaximin",
            "Rifaximin (Oral Pill)",
            "rifAXIMin",
            "rifAXIMin (Oral Pill)",
            "rifaximin",
            "rifaximin (oral pill)",
            "rifaximin 550 MG Oral Tablet",
            "rifaximin 550 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "550 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Pyridoxine/Thiamine/Vitamin B12",
        "route": "Oral Pill",
        "fullName": "Pyridoxine/Thiamine/Vitamin B12 (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Pyridoxine/Thiamine/Vitamin B12",
            "Pyridoxine/Thiamine/Vitamin B12 (Oral Pill)",
            "pyridoxine hydrochloride 100 MG / thiamine hydrochloride 100 MG / vitamin B12 0.2 MG Oral Tablet",
            "pyridoxine hydrochloride 100 mg / thiamine hydrochloride 100 mg / vitamin b12 0.2 mg oral tablet",
            "pyridoxine/thiamine/vitamin b12",
            "pyridoxine/thiamine/vitamin b12 (oral pill)"
        ],
        "dosages": [
            {
                "value": "100-100-0.2 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "XOLAIR",
        "route": "Injectable",
        "fullName": "XOLAIR (Injectable)",
        "totalCount": 7,
        "searchTerms": [
            "XOLAIR",
            "XOLAIR (Injectable)",
            "omalizumab 150 MG Injection",
            "omalizumab 150 mg injection",
            "xolair",
            "xolair (injectable)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Furosemide",
        "route": "Injectable",
        "fullName": "Furosemide (Injectable)",
        "totalCount": 7,
        "searchTerms": [
            "10 ML furosemide 10 MG/ML Injection",
            "10 ml furosemide 10 mg/ml injection",
            "2 ML furosemide 10 MG/ML Injection",
            "2 ml furosemide 10 mg/ml injection",
            "4 ML furosemide 10 MG/ML Injection",
            "4 ml furosemide 10 mg/ml injection",
            "Furosemide",
            "Furosemide (Injectable)",
            "furosemide",
            "furosemide (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Q-SORB CO Q-10",
        "route": "Oral Pill",
        "fullName": "Q-SORB CO Q-10 (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Q-SORB CO Q-10",
            "Q-SORB CO Q-10 (Oral Pill)",
            "q-sorb co q-10",
            "q-sorb co q-10 (oral pill)",
            "ubidecarenone 100 MG Oral Capsule",
            "ubidecarenone 100 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LUNESTA",
        "route": "Oral Pill",
        "fullName": "LUNESTA (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "LUNESTA",
            "LUNESTA (Oral Pill)",
            "Lunesta",
            "Lunesta (Oral)",
            "eszopiclone 1 MG Oral Tablet",
            "eszopiclone 1 mg oral tablet",
            "eszopiclone 2 MG Oral Tablet",
            "eszopiclone 2 mg oral tablet",
            "eszopiclone 3 MG Oral Tablet",
            "eszopiclone 3 mg oral tablet",
            "lunesta",
            "lunesta (oral pill)",
            "lunesta (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BRIVIACT",
        "route": "Oral Pill",
        "fullName": "BRIVIACT (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "BRIVIACT",
            "BRIVIACT (Oral Pill)",
            "brivaracetam 25 MG Oral Tablet",
            "brivaracetam 25 mg oral tablet",
            "brivaracetam 50 MG Oral Tablet",
            "brivaracetam 50 mg oral tablet",
            "briviact",
            "briviact (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Megestrol",
        "route": "Oral Liquid",
        "fullName": "Megestrol (Oral Liquid)",
        "totalCount": 7,
        "searchTerms": [
            "Megestrol",
            "Megestrol (Oral Liquid)",
            "megestrol",
            "megestrol (oral liquid)",
            "megestrol acetate 125 MG/ML Oral Suspension",
            "megestrol acetate 125 mg/ml oral suspension",
            "megestrol acetate 40 MG/ML Oral Suspension",
            "megestrol acetate 40 mg/ml oral suspension"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Pyridoxine",
        "route": "Oral Pill",
        "fullName": "Pyridoxine (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Pyridoxine",
            "Pyridoxine (Oral Pill)",
            "pyridoxine",
            "pyridoxine (oral pill)",
            "pyridoxine hydrochloride 25 MG Oral Tablet",
            "pyridoxine hydrochloride 25 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "25 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dalfampridine XR",
        "route": "Oral Pill",
        "fullName": "Dalfampridine XR (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "12 HR dalfampridine 10 MG Extended Release Oral Tablet",
            "12 hr dalfampridine 10 mg extended release oral tablet",
            "Dalfampridine XR",
            "Dalfampridine XR (Oral Pill)",
            "dalfampridine xr",
            "dalfampridine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "AMBIEN XR",
        "route": "Oral Pill",
        "fullName": "AMBIEN XR (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "AMBIEN",
            "AMBIEN XR",
            "AMBIEN XR (Oral Pill)",
            "ambien",
            "ambien xr",
            "ambien xr (oral pill)",
            "zolpidem tartrate 12.5 MG Extended Release Oral Tablet",
            "zolpidem tartrate 12.5 mg extended release oral tablet",
            "zolpidem tartrate 6.25 MG Extended Release Oral Tablet",
            "zolpidem tartrate 6.25 mg extended release oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Atovaquone",
        "route": "Oral Liquid",
        "fullName": "Atovaquone (Oral Liquid)",
        "totalCount": 7,
        "searchTerms": [
            "Atovaquone",
            "Atovaquone (Oral Liquid)",
            "atovaquone",
            "atovaquone (oral liquid)",
            "atovaquone 150 MG/ML Oral Suspension",
            "atovaquone 150 mg/ml oral suspension"
        ],
        "dosages": [
            {
                "value": "750 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HYDROmorphone XR",
        "route": "Oral Pill",
        "fullName": "HYDROmorphone XR (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "24 HR hydromorphone hydrochloride 32 MG Extended Release Oral Tablet",
            "24 hr hydromorphone hydrochloride 32 mg extended release oral tablet",
            "HYDROmorphone XR",
            "HYDROmorphone XR (Oral Pill)",
            "hydromorphone xr",
            "hydromorphone xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OSCAL 500",
        "route": "Oral Pill",
        "fullName": "OSCAL 500 (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "OSCAL 500",
            "OSCAL 500 (Oral Pill)",
            "calcium carbonate 1250 MG Oral Tablet",
            "calcium carbonate 1250 mg oral tablet",
            "oscal 500",
            "oscal 500 (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ZITHROMAX",
        "route": "Oral Pill",
        "fullName": "ZITHROMAX (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "ZITHROMAX",
            "ZITHROMAX (Oral Pill)",
            "azithromycin 250 MG Oral Tablet",
            "azithromycin 250 mg oral tablet",
            "azithromycin 500 MG Oral Tablet",
            "azithromycin 500 mg oral tablet",
            "zithromax",
            "zithromax (oral pill)"
        ],
        "dosages": [
            {
                "value": "250 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MOTRIN",
        "route": "Oral Liquid",
        "fullName": "MOTRIN (Oral Liquid)",
        "totalCount": 7,
        "searchTerms": [
            "MOTRIN",
            "MOTRIN (Oral Liquid)",
            "ibuprofen 20 MG/ML Oral Suspension",
            "ibuprofen 20 mg/ml oral suspension",
            "ibuprofen 40 MG/ML Oral Suspension",
            "ibuprofen 40 mg/ml oral suspension",
            "motrin",
            "motrin (oral liquid)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TEGretol",
        "route": "Oral Pill",
        "fullName": "TEGretol (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "TEGRETOL",
            "TEGretol",
            "TEGretol (Oral Pill)",
            "carbamazepine 200 MG Oral Tablet",
            "carbamazepine 200 mg oral tablet",
            "tegretol",
            "tegretol (oral pill)"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "AMPYRA XR",
        "route": "Oral Pill",
        "fullName": "AMPYRA XR (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "12 HR dalfampridine 10 MG Extended Release Oral Tablet",
            "12 hr dalfampridine 10 mg extended release oral tablet",
            "AMPYRA",
            "AMPYRA XR",
            "AMPYRA XR (Oral Pill)",
            "ampyra",
            "ampyra xr",
            "ampyra xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Insulin analog, degludec",
        "route": "Injectable",
        "fullName": "Insulin analog, degludec (Injectable)",
        "totalCount": 7,
        "searchTerms": [
            "3 ML insulin degludec 100 UNT/ML Pen Injector",
            "3 ml insulin degludec 100 unt/ml pen injector",
            "Insulin analog, degludec",
            "Insulin analog, degludec (Injectable)",
            "insulin analog, degludec",
            "insulin analog, degludec (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROGRAF",
        "route": "Oral Pill",
        "fullName": "PROGRAF (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "PROGRAF",
            "PROGRAF (Oral Pill)",
            "prograf",
            "prograf (oral pill)",
            "tacrolimus 1 MG Oral Capsule",
            "tacrolimus 1 mg oral capsule",
            "tacrolimus 5 MG Oral Capsule",
            "tacrolimus 5 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "POMALYST",
        "route": "Oral Pill",
        "fullName": "POMALYST (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "POMALYST",
            "POMALYST (Oral Pill)",
            "Pomalyst",
            "Pomalyst (Oral)",
            "pomalidomide 2 MG Oral Capsule",
            "pomalidomide 2 mg oral capsule",
            "pomalyst",
            "pomalyst (oral pill)",
            "pomalyst (oral)"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ACTEMRA",
        "route": "Injectable",
        "fullName": "ACTEMRA (Injectable)",
        "totalCount": 7,
        "searchTerms": [
            "0.9 ML tocilizumab 180 MG/ML Prefilled Syringe",
            "0.9 ml tocilizumab 180 mg/ml prefilled syringe",
            "4 ML tocilizumab 20 MG/ML Injection",
            "4 ml tocilizumab 20 mg/ml injection",
            "ACTEMRA",
            "ACTEMRA (Injectable)",
            "actemra",
            "actemra (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LOVENOX",
        "route": "Injectable",
        "fullName": "LOVENOX (Injectable)",
        "totalCount": 7,
        "searchTerms": [
            "0.3 ML enoxaparin sodium 100 MG/ML Prefilled Syringe",
            "0.3 ml enoxaparin sodium 100 mg/ml prefilled syringe",
            "0.4 ML enoxaparin sodium 100 MG/ML Prefilled Syringe",
            "0.4 ml enoxaparin sodium 100 mg/ml prefilled syringe",
            "LOVENOX",
            "LOVENOX (Injectable)",
            "lovenox",
            "lovenox (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Acetaminophen/Butalbital/Caffeine/Codeine",
        "route": "Oral Pill",
        "fullName": "Acetaminophen/Butalbital/Caffeine/Codeine (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Acetaminophen/Butalbital/Caffeine/Codeine",
            "Acetaminophen/Butalbital/Caffeine/Codeine (Oral Pill)",
            "acetaminophen 300 MG / butalbital 50 MG / caffeine 40 MG / codeine phosphate 30 MG Oral Capsule",
            "acetaminophen 300 mg / butalbital 50 mg / caffeine 40 mg / codeine phosphate 30 mg oral capsule",
            "acetaminophen/butalbital/caffeine/codeine",
            "acetaminophen/butalbital/caffeine/codeine (oral pill)"
        ],
        "dosages": [
            {
                "value": "300-50-40-30 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "XCOPRI",
        "route": "Oral Pill",
        "fullName": "XCOPRI (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "XCOPRI",
            "XCOPRI (Oral Pill)",
            "cenobamate 100 MG Oral Tablet",
            "cenobamate 100 mg oral tablet",
            "cenobamate 200 MG Oral Tablet",
            "cenobamate 200 mg oral tablet",
            "xcopri",
            "xcopri (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PREVACID",
        "route": "Oral Pill",
        "fullName": "PREVACID (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "PREVACID",
            "PREVACID (Oral Pill)",
            "lansoprazole 15 MG Delayed Release Oral Capsule",
            "lansoprazole 15 mg delayed release oral capsule",
            "lansoprazole 30 MG Delayed Release Oral Capsule",
            "lansoprazole 30 mg delayed release oral capsule",
            "prevacid",
            "prevacid (oral pill)"
        ],
        "dosages": [
            {
                "value": "30 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NEO-POLYCIN",
        "route": "Ophthalmic",
        "fullName": "NEO-POLYCIN (Ophthalmic)",
        "totalCount": 7,
        "searchTerms": [
            "NEO-POLYCIN",
            "NEO-POLYCIN (Ophthalmic)",
            "bacitracin 0.4 UNT/MG / neomycin 0.0035 MG/MG / polymyxin B 10 UNT/MG Ophthalmic Ointment",
            "bacitracin 0.4 unt/mg / neomycin 0.0035 mg/mg / polymyxin b 10 unt/mg ophthalmic ointment",
            "neo-polycin",
            "neo-polycin (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Zinc gluconate",
        "route": "Oral Pill",
        "fullName": "Zinc gluconate (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Zinc gluconate",
            "Zinc gluconate (Oral Pill)",
            "zinc gluconate",
            "zinc gluconate (oral pill)",
            "zinc gluconate 50 MG Oral Tablet",
            "zinc gluconate 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dextromethorphan/guaiFENesin",
        "route": "Oral Liquid",
        "fullName": "Dextromethorphan/guaiFENesin (Oral Liquid)",
        "totalCount": 7,
        "searchTerms": [
            "Dextromethorphan/guaiFENesin",
            "Dextromethorphan/guaiFENesin (Oral Liquid)",
            "dextromethorphan hydrobromide 0.667 MG/ML / guaifenesin 13.3 MG/ML Oral Solution",
            "dextromethorphan hydrobromide 0.667 mg/ml / guaifenesin 13.3 mg/ml oral solution",
            "dextromethorphan hydrobromide 1 MG/ML / guaifenesin 20 MG/ML Oral Solution",
            "dextromethorphan hydrobromide 1 mg/ml / guaifenesin 20 mg/ml oral solution",
            "dextromethorphan/guaifenesin",
            "dextromethorphan/guaifenesin (oral liquid)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ONFI",
        "route": "Oral Pill",
        "fullName": "ONFI (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "ONFI",
            "ONFI (Oral Pill)",
            "clobazam 10 MG Oral Tablet",
            "clobazam 10 mg oral tablet",
            "onfi",
            "onfi (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Tranexamic acid",
        "route": "Oral Pill",
        "fullName": "Tranexamic acid (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Tranexamic Acid",
            "Tranexamic Acid (Oral)",
            "Tranexamic acid",
            "Tranexamic acid (Oral Pill)",
            "tranexamic acid",
            "tranexamic acid (oral pill)",
            "tranexamic acid (oral)"
        ],
        "dosages": [
            {
                "value": "650 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Entacapone",
        "route": "Oral Pill",
        "fullName": "Entacapone (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Entacapone",
            "Entacapone (Oral Pill)",
            "entacapone",
            "entacapone (oral pill)",
            "entacapone 200 MG Oral Tablet",
            "entacapone 200 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "200 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NovoLIN N",
        "route": "Injectable",
        "fullName": "NovoLIN N (Injectable)",
        "totalCount": 7,
        "searchTerms": [
            "3 ML insulin isophane, human 100 UNT/ML Pen Injector",
            "3 ml insulin isophane, human 100 unt/ml pen injector",
            "NOVOLIN N",
            "NovoLIN N",
            "NovoLIN N (Injectable)",
            "novolin n",
            "novolin n (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Hydrocortisone",
        "route": "Rectal",
        "fullName": "Hydrocortisone (Rectal)",
        "totalCount": 7,
        "searchTerms": [
            "Hydrocortisone",
            "Hydrocortisone (Rectal)",
            "Proctosol-HC",
            "hydrocortisone",
            "hydrocortisone (rectal)",
            "proctosol-hc"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K64.9",
                "description": "Unspecified hemorrhoids",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "GENTEAL",
        "route": "Ophthalmic",
        "fullName": "GENTEAL (Ophthalmic)",
        "totalCount": 7,
        "searchTerms": [
            "GENTEAL",
            "GENTEAL (Ophthalmic)",
            "genteal",
            "genteal (ophthalmic)",
            "hypromellose 2 MG/ML Ophthalmic Solution",
            "hypromellose 2 mg/ml ophthalmic solution",
            "hypromellose 3 MG/ML Ophthalmic Solution",
            "hypromellose 3 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OS-CAL 500 WITH D",
        "route": "Oral Pill",
        "fullName": "OS-CAL 500 WITH D (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "OS-CAL 500 WITH D",
            "OS-CAL 500 WITH D (Oral Pill)",
            "os-cal 500 with d",
            "os-cal 500 with d (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BEVESPI",
        "route": "Inhalant",
        "fullName": "BEVESPI (Inhalant)",
        "totalCount": 7,
        "searchTerms": [
            "120 ACTUAT formoterol fumarate 0.0048 MG/ACTUAT / glycopyrrolate 0.009 MG/ACTUAT Metered Dose Inhaler",
            "120 actuat formoterol fumarate 0.0048 mg/actuat / glycopyrrolate 0.009 mg/actuat metered dose inhaler",
            "BEVESPI",
            "BEVESPI (Inhalant)",
            "bevespi",
            "bevespi (inhalant)"
        ],
        "dosages": [
            {
                "value": "4.8-9 mcg",
                "pct": "86%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EMGALITY",
        "route": "Injectable",
        "fullName": "EMGALITY (Injectable)",
        "totalCount": 7,
        "searchTerms": [
            "1 ML galcanezumab-gnlm 120 MG/ML Auto-Injector",
            "1 ml galcanezumab-gnlm 120 mg/ml auto-injector",
            "EMGALITY",
            "EMGALITY (Injectable)",
            "emgality",
            "emgality (injectable)"
        ],
        "dosages": [
            {
                "value": "120 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Desonide",
        "route": "Topical",
        "fullName": "Desonide (Topical)",
        "totalCount": 7,
        "searchTerms": [
            "DESONIDE",
            "Desonide",
            "Desonide (Topical)",
            "desonide",
            "desonide (topical)",
            "desonide 0.5 MG/ML Topical Cream",
            "desonide 0.5 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROCTO-MED",
        "route": "Topical",
        "fullName": "PROCTO-MED (Topical)",
        "totalCount": 7,
        "searchTerms": [
            "PROCTO-MED",
            "PROCTO-MED (Topical)",
            "hydrocortisone 25 MG/ML Topical Cream",
            "hydrocortisone 25 mg/ml topical cream",
            "procto-med",
            "procto-med (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Clindamycin",
        "route": "Oral Pill",
        "fullName": "Clindamycin (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Clindamycin",
            "Clindamycin (Oral Pill)",
            "Clindamycin (Oral)",
            "clindamycin",
            "clindamycin (oral pill)",
            "clindamycin (oral)",
            "clindamycin 300 MG Oral Capsule",
            "clindamycin 300 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cefadroxil",
        "route": "Oral Pill",
        "fullName": "Cefadroxil (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "CEFADROXIL",
            "CEFADROXIL (Oral)",
            "Cefadroxil",
            "Cefadroxil (Oral Pill)",
            "cefadroxil",
            "cefadroxil (oral pill)",
            "cefadroxil (oral)",
            "cefadroxil 500 MG Oral Capsule",
            "cefadroxil 500 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Capsaicin",
        "route": "Topical",
        "fullName": "Capsaicin (Topical)",
        "totalCount": 7,
        "searchTerms": [
            "Capsaicin",
            "Capsaicin (Topical)",
            "capsaicin",
            "capsaicin (topical)",
            "capsaicin 0.08 MG/MG Medicated Patch",
            "capsaicin 0.08 mg/mg medicated patch",
            "capsaicin 2.5 MG/ML Topical Cream",
            "capsaicin 2.5 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ARISTADA",
        "route": "Injectable",
        "fullName": "ARISTADA (Injectable)",
        "totalCount": 7,
        "searchTerms": [
            "1.6 ML aripiprazole lauroxil 276 MG/ML Prefilled Syringe",
            "1.6 ml aripiprazole lauroxil 276 mg/ml prefilled syringe",
            "2.4 ML aripiprazole lauroxil 276 MG/ML Prefilled Syringe",
            "2.4 ml aripiprazole lauroxil 276 mg/ml prefilled syringe",
            "3.9 ML aripiprazole lauroxil 273 MG/ML Prefilled Syringe",
            "3.9 ml aripiprazole lauroxil 273 mg/ml prefilled syringe",
            "ARISTADA",
            "ARISTADA (Injectable)",
            "aristada",
            "aristada (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LAC-HYDRIN",
        "route": "Topical",
        "fullName": "LAC-HYDRIN (Topical)",
        "totalCount": 7,
        "searchTerms": [
            "LAC-HYDRIN",
            "LAC-HYDRIN (Topical)",
            "ammonium lactate 120 MG/ML Topical Lotion",
            "ammonium lactate 120 mg/ml topical lotion",
            "lac-hydrin",
            "lac-hydrin (topical)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "L85.3",
                "description": "Xerosis cutis",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "Tenofovir disoproxil",
        "route": "Oral Pill",
        "fullName": "Tenofovir disoproxil (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Tenofovir Disoproxil",
            "Tenofovir Disoproxil (Oral)",
            "Tenofovir disoproxil",
            "Tenofovir disoproxil (Oral Pill)",
            "tenofovir disoproxil",
            "tenofovir disoproxil (oral pill)",
            "tenofovir disoproxil (oral)",
            "tenofovir disoproxil fumarate 200 MG Oral Tablet",
            "tenofovir disoproxil fumarate 200 mg oral tablet",
            "tenofovir disoproxil fumarate 250 MG Oral Tablet",
            "tenofovir disoproxil fumarate 250 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "fluvoxaMINE XR",
        "route": "Oral Pill",
        "fullName": "fluvoxaMINE XR (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "24 HR fluvoxamine maleate 100 MG Extended Release Oral Capsule",
            "24 HR fluvoxamine maleate 150 MG Extended Release Oral Capsule",
            "24 hr fluvoxamine maleate 100 mg extended release oral capsule",
            "24 hr fluvoxamine maleate 150 mg extended release oral capsule",
            "fluvoxaMINE XR",
            "fluvoxaMINE XR (Oral Pill)",
            "fluvoxamine xr",
            "fluvoxamine xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "AVAPRO",
        "route": "Oral Pill",
        "fullName": "AVAPRO (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "AVAPRO",
            "AVAPRO (Oral Pill)",
            "avapro",
            "avapro (oral pill)",
            "irbesartan 150 MG Oral Tablet",
            "irbesartan 150 mg oral tablet",
            "irbesartan 300 MG Oral Tablet",
            "irbesartan 300 mg oral tablet",
            "irbesartan 75 MG Oral Tablet",
            "irbesartan 75 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Magnesium glycinate",
        "route": "Oral Pill",
        "fullName": "Magnesium glycinate (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Magnesium glycinate",
            "Magnesium glycinate (Oral Pill)",
            "magnesium glycinate",
            "magnesium glycinate (oral pill)"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ROZEREM",
        "route": "Oral Pill",
        "fullName": "ROZEREM (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "ROZEREM",
            "ROZEREM (Oral Pill)",
            "ramelteon 8 MG Oral Tablet",
            "ramelteon 8 mg oral tablet",
            "rozerem",
            "rozerem (oral pill)"
        ],
        "dosages": [
            {
                "value": "8 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "XOPENEX",
        "route": "Inhalant",
        "fullName": "XOPENEX (Inhalant)",
        "totalCount": 7,
        "searchTerms": [
            "200 ACTUAT levalbuterol 0.045 MG/ACTUAT Metered Dose Inhaler",
            "200 actuat levalbuterol 0.045 mg/actuat metered dose inhaler",
            "XOPENEX",
            "XOPENEX (Inhalant)",
            "levalbuterol 2.5 MG/ML Inhalation Solution",
            "levalbuterol 2.5 mg/ml inhalation solution",
            "xopenex",
            "xopenex (inhalant)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Albuterol",
        "route": "Oral Pill",
        "fullName": "Albuterol (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Albuterol",
            "Albuterol (Oral Pill)",
            "albuterol",
            "albuterol (oral pill)",
            "albuterol 2 MG Oral Tablet",
            "albuterol 2 mg oral tablet",
            "albuterol 4 MG Oral Tablet",
            "albuterol 4 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Kerendia (finerenone)",
        "route": "Oral Pill",
        "fullName": "Kerendia (finerenone) (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Kerendia (finerenone)",
            "Kerendia (finerenone) (Oral)",
            "kerendia (finerenone)",
            "kerendia (finerenone) (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "Film-coated tablets",
                "pct": "71%"
            }
        ],
        "diagnoses": []
    },
    {
        "name": "Tamsulosin Hydrochloride",
        "route": "Oral Pill",
        "fullName": "Tamsulosin Hydrochloride (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Flomax",
            "Tamsulosin Hydrochloride",
            "Tamsulosin Hydrochloride (Oral)",
            "flomax",
            "tamsulosin hydrochloride",
            "tamsulosin hydrochloride (oral)"
        ],
        "dosages": [
            {
                "value": "0.4 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "N40.1",
                "description": "Enlarged prostate with lower urinary tract symptoms",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Citalopram HBr",
        "route": "Oral Pill",
        "fullName": "Citalopram HBr (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Celexa",
            "Celexa 20mg",
            "Citalopram HBR",
            "Citalopram HBR (Oral)",
            "Citalopram HBr",
            "Citalopram HBr (Oral)",
            "celexa",
            "celexa 20mg",
            "citalopram hbr",
            "citalopram hbr (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "86%"
            }
        ]
    },
    {
        "name": "bupropion HCL XL",
        "route": "Oral Pill",
        "fullName": "bupropion HCL XL (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "BUPROPION HCL XL",
            "BUPROPION HCL XL (Oral)",
            "Bupropion HCL XL",
            "Bupropion HCL XL (Oral)",
            "Bupropion HCl XL",
            "Bupropion HCl XL (Oral)",
            "Bupropion Hcl Xl",
            "Bupropion Hcl Xl (Oral)",
            "buPROPion HCL XL",
            "buPROPion HCL XL (Oral)",
            "bupropion HCL XL",
            "bupropion hcl xl",
            "bupropion hcl xl (oral)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.9",
                "description": "Major depressive disorder, single episode, unspecified",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "Brimonidine Tartrate Ophthalmic Solution",
        "route": "Ophthalmic",
        "fullName": "Brimonidine Tartrate Ophthalmic Solution (Ophthalmic)",
        "totalCount": 7,
        "searchTerms": [
            "Brimonidine Tartrate Ophthalmic Solution",
            "Brimonidine Tartrate Ophthalmic Solution (Ophthalmic)",
            "brimonidine tartrate ophthalmic solution",
            "brimonidine tartrate ophthalmic solution (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Benztropine Mesylate",
        "route": "Oral Pill",
        "fullName": "Benztropine Mesylate (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Benztropine Mesylate",
            "Benztropine Mesylate (Oral)",
            "Benztropine mesylate",
            "Benztropine mesylate (Oral)",
            "benztropine mesylate",
            "benztropine mesylate (oral)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G20",
                "description": "Parkinson's disease",
                "pct": "86%"
            }
        ]
    },
    {
        "name": "VENLAFAXINE HCL ER",
        "route": "Oral Pill",
        "fullName": "VENLAFAXINE HCL ER (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "VENLAFAXINE HCL ER",
            "Venlafaxine HCL ER",
            "Venlafaxine HCL ER (Oral)",
            "Venlafaxine HCl ER",
            "Venlafaxine HCl ER (Oral)",
            "venlafaxine hcl er",
            "venlafaxine hcl er (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Cyclobenzaprine HCl",
        "route": "Oral Pill",
        "fullName": "Cyclobenzaprine HCl (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Cyclobenzaprine HCl",
            "Cyclobenzaprine HCl (Oral)",
            "cyclobenzaprine hcl",
            "cyclobenzaprine hcl (oral)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M62.838",
                "description": "Other muscle spasm",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Nature's Truth B-12 - Supplement",
        "route": "Oral Pill",
        "fullName": "Nature's Truth B-12 - Supplement (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Nature's Truth B-12 - Supplement",
            "Nature's Truth B-12 - Supplement (Oral)",
            "nature's truth b-12 - supplement",
            "nature's truth b-12 - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "Vegan",
                "pct": "86%"
            },
            {
                "value": "Non-GMO",
                "pct": "86%"
            },
            {
                "value": "Gluten Free",
                "pct": "71%"
            }
        ],
        "diagnoses": [
            {
                "code": "D51.9",
                "description": "Vitamin B12 deficiency anemia, unspecified",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "Methenamine Hippurate",
        "route": "Oral Pill",
        "fullName": "Methenamine Hippurate (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "HIPREX",
            "Hiprex",
            "METHENAMINE HIPPURATE",
            "Methenamine Hippurate",
            "Methenamine Hippurate (Oral)",
            "hiprex",
            "methenamine hippurate",
            "methenamine hippurate (Oral)",
            "methenamine hippurate (oral)"
        ],
        "dosages": [
            {
                "value": "1 g",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Janumet (sitagliptin and metformin HCl)",
        "route": "Oral Pill",
        "fullName": "Janumet (sitagliptin and metformin HCl) (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Janumet (sitagliptin and metformin HCl)",
            "Janumet (sitagliptin and metformin HCl) (Oral)",
            "janumet (sitagliptin and metformin hcl)",
            "janumet (sitagliptin and metformin hcl) (oral)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "LISINOPRIL-HCTZ",
        "route": "Oral Pill",
        "fullName": "LISINOPRIL-HCTZ (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "LISINOPRIL-HCTZ",
            "LISINOPRIL-HCTZ (Oral)",
            "Lisinopril-HCTZ",
            "Lisinopril-HCTZ (Oral)",
            "lisinopril-hctz",
            "lisinopril-hctz (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "RALOXIFENE HCL",
        "route": "Oral Pill",
        "fullName": "RALOXIFENE HCL (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Evista",
            "RALOXIFENE HCL",
            "Raloxifene HCl",
            "Raloxifene HCl (Oral)",
            "evista",
            "raloxifene hcl",
            "raloxifene hcl (oral)"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Labetalol HCl",
        "route": "Oral Pill",
        "fullName": "Labetalol HCl (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "LABETALOL HCL",
            "LABETALOL HCL (Oral)",
            "Labetalol HCL",
            "Labetalol HCL (Oral)",
            "Labetalol HCl",
            "Labetalol HCl (Oral)",
            "labetalol hcl",
            "labetalol hcl (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "BROVANA",
        "route": "Inhalant",
        "fullName": "BROVANA (Inhalant)",
        "totalCount": 7,
        "searchTerms": [
            "BROVANA",
            "BROVANA (Inhalant)",
            "arformoterol 0.0075 MG/ML Inhalation Solution",
            "arformoterol 0.0075 mg/ml inhalation solution",
            "brovana",
            "brovana (inhalant)"
        ],
        "dosages": [
            {
                "value": "15 mcg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ESOMEPRAZOLE MAGNESIUM",
        "route": "Oral Pill",
        "fullName": "ESOMEPRAZOLE MAGNESIUM (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "ESOMEPRAZOLE MAGNESIUM",
            "Esomeprazole Magnesium",
            "Esomeprazole Magnesium (Oral)",
            "Nexium DR",
            "esomeprazole magnesium",
            "esomeprazole magnesium (oral)",
            "nexium dr"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Potassium CL ER",
        "route": "Oral Pill",
        "fullName": "Potassium CL ER (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "POTASSIUM CL ER",
            "Potassium CL ER",
            "Potassium CL ER (Oral)",
            "Potassium Cl ER",
            "Potassium Cl ER (Oral)",
            "potassium cl er",
            "potassium cl er (oral)"
        ],
        "dosages": [
            {
                "value": "20 meq",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VALACYCLOVIR HCL",
        "route": "Oral Pill",
        "fullName": "VALACYCLOVIR HCL (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "VALACYCLOVIR HCL",
            "Valacyclovir HCL",
            "Valacyclovir HCL (Oral)",
            "Valacyclovir HCl",
            "Valacyclovir HCl (Oral)",
            "Valacyclovir Hcl",
            "Valacyclovir Hcl (Oral)",
            "Valtrex",
            "valacyclovir hcl",
            "valacyclovir hcl (oral)",
            "valtrex"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cetirizine",
        "route": "Chewable",
        "fullName": "Cetirizine (Chewable)",
        "totalCount": 7,
        "searchTerms": [
            "Cetirizine",
            "Cetirizine (Chewable)",
            "cetirizine",
            "cetirizine (chewable)",
            "cetirizine hydrochloride 10 MG Chewable Tablet",
            "cetirizine hydrochloride 10 mg chewable tablet",
            "cetirizine hydrochloride 5 MG Chewable Tablet",
            "cetirizine hydrochloride 5 mg chewable tablet"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "86%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Xarelto (rivaroxaban)",
        "route": "Oral Pill",
        "fullName": "Xarelto (rivaroxaban) (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "Xarelto (Rivaroxaban)",
            "Xarelto (Rivaroxaban) (Oral)",
            "Xarelto (rivaroxaban)",
            "Xarelto (rivaroxaban) (Oral)",
            "xarelto (rivaroxaban)",
            "xarelto (rivaroxaban) (oral)"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Amitriptyline HCl",
        "route": "Oral Pill",
        "fullName": "Amitriptyline HCl (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "AMITRIPTYLINE HCL",
            "AMITRIPTYLINE HCL (Oral)",
            "Amitriptyline HCL",
            "Amitriptyline HCL (Oral)",
            "Amitriptyline HCl",
            "Amitriptyline HCl (Oral)",
            "ELAVIL",
            "amitriptyline hcl",
            "amitriptyline hcl (oral)",
            "elavil"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F32.A",
                "description": "Depression, unspecified",
                "pct": "71%"
            }
        ]
    },
    {
        "name": "MULTIGEN",
        "route": "Oral Pill",
        "fullName": "MULTIGEN (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "MULTIGEN",
            "MULTIGEN (Oral Pill)",
            "calcium ascorbate 150 MG / calcium threonate 2 MG / ferrous asparto glycinate 70 MG / liver stomach concentrate 50 MG / succinic acid 75 MG / vitamin B12 0.01 MG Oral Tablet",
            "calcium ascorbate 150 mg / calcium threonate 2 mg / ferrous asparto glycinate 70 mg / liver stomach concentrate 50 mg / succinic acid 75 mg / vitamin b12 0.01 mg oral tablet",
            "multigen",
            "multigen (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SENNA PLUS",
        "route": "Oral Pill",
        "fullName": "SENNA PLUS (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "SENNA PLUS",
            "Senna Plus",
            "Senna Plus (Oral)",
            "senna plus",
            "senna plus (oral)"
        ],
        "dosages": [
            {
                "value": "8.6 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LOTEMAX",
        "route": "Ophthalmic",
        "fullName": "LOTEMAX (Ophthalmic)",
        "totalCount": 7,
        "searchTerms": [
            "LOTEMAX",
            "LOTEMAX (Ophthalmic)",
            "lotemax",
            "lotemax (ophthalmic)",
            "loteprednol etabonate 0.0038 MG/MG Ophthalmic Gel",
            "loteprednol etabonate 0.0038 mg/mg ophthalmic gel",
            "loteprednol etabonate 0.005 MG/MG Ophthalmic Gel",
            "loteprednol etabonate 0.005 MG/MG Ophthalmic Ointment",
            "loteprednol etabonate 0.005 mg/mg ophthalmic gel",
            "loteprednol etabonate 0.005 mg/mg ophthalmic ointment"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PAROXETINE HCL",
        "route": "Oral Pill",
        "fullName": "PAROXETINE HCL (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "PAROXETINE HCL",
            "PAROXETINE HCL (Oral)",
            "Paroxetine HCL",
            "Paroxetine HCL (Oral)",
            "Paroxetine HCl",
            "Paroxetine HCl (Oral)",
            "Paxil",
            "paroxetine hcl",
            "paroxetine hcl (oral)",
            "paxil"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "fluvoxaMINE",
        "route": "Oral Pill",
        "fullName": "fluvoxaMINE (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "fluvoxaMINE",
            "fluvoxaMINE (Oral Pill)",
            "fluvoxamine",
            "fluvoxamine (oral pill)",
            "fluvoxamine maleate 100 MG Oral Tablet",
            "fluvoxamine maleate 100 mg oral tablet",
            "fluvoxamine maleate 25 MG Oral Tablet",
            "fluvoxamine maleate 25 mg oral tablet",
            "fluvoxamine maleate 50 MG Oral Tablet",
            "fluvoxamine maleate 50 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FOLGARD OS",
        "route": "Oral Pill",
        "fullName": "FOLGARD OS (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "FOLGARD OS",
            "FOLGARD OS (Oral Pill)",
            "boron 1.5 MG / calcium carbonate 500 MG / cholecalciferol 300 UNT / folic acid 1.1 MG / magnesium oxide 100 MG / pyridoxine 12.5 MG / vitamin B12 0.25 MG Oral Tablet",
            "boron 1.5 mg / calcium carbonate 500 mg / cholecalciferol 300 unt / folic acid 1.1 mg / magnesium oxide 100 mg / pyridoxine 12.5 mg / vitamin b12 0.25 mg oral tablet",
            "folgard os",
            "folgard os (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VISINE DRY EYE RELIEF",
        "route": "Ophthalmic",
        "fullName": "VISINE DRY EYE RELIEF (Ophthalmic)",
        "totalCount": 7,
        "searchTerms": [
            "VISINE DRY EYE RELIEF",
            "VISINE DRY EYE RELIEF (Ophthalmic)",
            "glycerin 2 MG/ML / hypromellose 2 MG/ML / polyethylene glycol 400 10 MG/ML Ophthalmic Solution",
            "glycerin 2 mg/ml / hypromellose 2 mg/ml / polyethylene glycol 400 10 mg/ml ophthalmic solution",
            "visine dry eye relief",
            "visine dry eye relief (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Doxepin",
        "route": "Topical",
        "fullName": "Doxepin (Topical)",
        "totalCount": 7,
        "searchTerms": [
            "Doxepin",
            "Doxepin (Topical)",
            "doxepin",
            "doxepin (topical)",
            "doxepin hydrochloride 50 MG/ML Topical Cream",
            "doxepin hydrochloride 50 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROVERA",
        "route": "Oral Pill",
        "fullName": "PROVERA (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "PROVERA",
            "PROVERA (Oral Pill)",
            "medroxyprogesterone acetate 10 MG Oral Tablet",
            "medroxyprogesterone acetate 10 mg oral tablet",
            "medroxyprogesterone acetate 2.5 MG Oral Tablet",
            "medroxyprogesterone acetate 2.5 mg oral tablet",
            "medroxyprogesterone acetate 5 MG Oral Tablet",
            "medroxyprogesterone acetate 5 mg oral tablet",
            "provera",
            "provera (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "METOPIRONE",
        "route": "Oral Pill",
        "fullName": "METOPIRONE (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "METOPIRONE",
            "METOPIRONE (Oral Pill)",
            "metopirone",
            "metopirone (oral pill)",
            "metyrapone 250 MG Oral Capsule",
            "metyrapone 250 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "250 mg",
                "pct": "71%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Niacin XR",
        "route": "Oral Pill",
        "fullName": "Niacin XR (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "24 HR niacin 1000 MG Extended Release Oral Tablet",
            "24 hr niacin 1000 mg extended release oral tablet",
            "Niacin XR",
            "Niacin XR (Oral Pill)",
            "niacin xr",
            "niacin xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Bacitracin/Hydrocortisone/Neomycin/Polymyxin B",
        "route": "Ophthalmic",
        "fullName": "Bacitracin/Hydrocortisone/Neomycin/Polymyxin B (Ophthalmic)",
        "totalCount": 7,
        "searchTerms": [
            "Bacitracin/Hydrocortisone/Neomycin/Polymyxin B",
            "Bacitracin/Hydrocortisone/Neomycin/Polymyxin B (Ophthalmic)",
            "bacitracin zinc 0.4 UNT/MG / hydrocortisone acetate 0.01 MG/MG / neomycin sulfate 0.0035 MG/MG / polymyxin B sulfate 10 UNT/MG Ophthalmic Ointment",
            "bacitracin zinc 0.4 unt/mg / hydrocortisone acetate 0.01 mg/mg / neomycin sulfate 0.0035 mg/mg / polymyxin b sulfate 10 unt/mg ophthalmic ointment",
            "bacitracin/hydrocortisone/neomycin/polymyxin b",
            "bacitracin/hydrocortisone/neomycin/polymyxin b (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Miconazole",
        "route": "Topical",
        "fullName": "Miconazole (Topical)",
        "totalCount": 7,
        "searchTerms": [
            "Miconazole",
            "Miconazole (Topical)",
            "miconazole",
            "miconazole (topical)",
            "miconazole nitrate 10 MG/ML Topical Spray",
            "miconazole nitrate 10 mg/ml topical spray"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "KEFLEX",
        "route": "Oral Pill",
        "fullName": "KEFLEX (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "KEFLEX",
            "KEFLEX (Oral Pill)",
            "cephalexin 500 MG Oral Capsule",
            "cephalexin 500 mg oral capsule",
            "keflex",
            "keflex (oral pill)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DEPAKENE",
        "route": "Oral Pill",
        "fullName": "DEPAKENE (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "DEPAKENE",
            "DEPAKENE (Oral Pill)",
            "depakene",
            "depakene (oral pill)",
            "valproic acid 250 MG Oral Capsule",
            "valproic acid 250 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MICARDIS",
        "route": "Oral Pill",
        "fullName": "MICARDIS (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "MICARDIS",
            "MICARDIS (Oral Pill)",
            "micardis",
            "micardis (oral pill)",
            "telmisartan 20 MG Oral Tablet",
            "telmisartan 20 mg oral tablet",
            "telmisartan 40 MG Oral Tablet",
            "telmisartan 40 mg oral tablet",
            "telmisartan 80 MG Oral Tablet",
            "telmisartan 80 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SILTUSSIN",
        "route": "Oral Liquid",
        "fullName": "SILTUSSIN (Oral Liquid)",
        "totalCount": 7,
        "searchTerms": [
            "SILTUSSIN",
            "SILTUSSIN (Oral Liquid)",
            "guaifenesin 20 MG/ML Oral Solution",
            "guaifenesin 20 mg/ml oral solution",
            "siltussin",
            "siltussin (oral liquid)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Three times daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PAMELOR",
        "route": "Oral Pill",
        "fullName": "PAMELOR (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "PAMELOR",
            "PAMELOR (Oral Pill)",
            "nortriptyline 10 MG Oral Capsule",
            "nortriptyline 10 mg oral capsule",
            "nortriptyline 25 MG Oral Capsule",
            "nortriptyline 25 mg oral capsule",
            "pamelor",
            "pamelor (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "At bedtime",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EZALLOR",
        "route": "Oral Pill",
        "fullName": "EZALLOR (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "EZALLOR",
            "EZALLOR (Oral Pill)",
            "ezallor",
            "ezallor (oral pill)",
            "rosuvastatin 10 MG Oral Capsule",
            "rosuvastatin 10 mg oral capsule",
            "rosuvastatin 20 MG Oral Capsule",
            "rosuvastatin 20 mg oral capsule",
            "rosuvastatin 40 MG Oral Capsule",
            "rosuvastatin 40 mg oral capsule",
            "rosuvastatin 5 MG Oral Capsule",
            "rosuvastatin 5 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Estrogens, conjugated (USP)/MedroxyPROGESTERone",
        "route": "Pack",
        "fullName": "Estrogens, conjugated (USP)/MedroxyPROGESTERone (Pack)",
        "totalCount": 7,
        "searchTerms": [
            "Estrogens, conjugated (USP)/MedroxyPROGESTERone",
            "Estrogens, conjugated (USP)/MedroxyPROGESTERone (Pack)",
            "estrogens, conjugated (usp)/medroxyprogesterone",
            "estrogens, conjugated (usp)/medroxyprogesterone (pack)",
            "{28 (estrogens, conjugated (USP) 0.3 MG / medroxyprogesterone acetate 1.5 MG Oral Tablet) } Pack",
            "{28 (estrogens, conjugated (USP) 0.625 MG / medroxyprogesterone acetate 2.5 MG Oral Tablet) } Pack",
            "{28 (estrogens, conjugated (USP) 0.625 MG / medroxyprogesterone acetate 5 MG Oral Tablet) } Pack",
            "{28 (estrogens, conjugated (usp) 0.3 mg / medroxyprogesterone acetate 1.5 mg oral tablet) } pack",
            "{28 (estrogens, conjugated (usp) 0.625 mg / medroxyprogesterone acetate 2.5 mg oral tablet) } pack",
            "{28 (estrogens, conjugated (usp) 0.625 mg / medroxyprogesterone acetate 5 mg oral tablet) } pack"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DRISDOL",
        "route": "Oral Liquid",
        "fullName": "DRISDOL (Oral Liquid)",
        "totalCount": 7,
        "searchTerms": [
            "DRISDOL",
            "DRISDOL (Oral Liquid)",
            "drisdol",
            "drisdol (oral liquid)",
            "ergocalciferol 0.2 MG/ML Oral Solution",
            "ergocalciferol 0.2 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "0.2 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BYDUREON",
        "route": "Injectable",
        "fullName": "BYDUREON (Injectable)",
        "totalCount": 7,
        "searchTerms": [
            "BYDUREON",
            "BYDUREON (Injectable)",
            "bydureon",
            "bydureon (injectable)",
            "exenatide 2 MG Injection",
            "exenatide 2 mg injection"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LOPID",
        "route": "Oral Pill",
        "fullName": "LOPID (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "LOPID",
            "LOPID (Oral Pill)",
            "gemfibrozil 600 MG Oral Tablet",
            "gemfibrozil 600 mg oral tablet",
            "lopid",
            "lopid (oral pill)"
        ],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LOMOTIL",
        "route": "Oral Pill",
        "fullName": "LOMOTIL (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "LOMOTIL",
            "LOMOTIL (Oral Pill)",
            "atropine sulfate 0.025 MG / diphenoxylate hydrochloride 2.5 MG Oral Tablet",
            "atropine sulfate 0.025 mg / diphenoxylate hydrochloride 2.5 mg oral tablet",
            "lomotil",
            "lomotil (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "XYZAL",
        "route": "Oral Pill",
        "fullName": "XYZAL (Oral Pill)",
        "totalCount": 7,
        "searchTerms": [
            "XYZAL",
            "XYZAL (Oral Pill)",
            "levocetirizine dihydrochloride 5 MG Oral Tablet",
            "levocetirizine dihydrochloride 5 mg oral tablet",
            "xyzal",
            "xyzal (oral pill)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cranberry Concentrate",
        "route": "Oral Pill",
        "fullName": "Cranberry Concentrate (Oral Pill)",
        "totalCount": 7,
        "searchTerms": ["Cranberry Concentrate", "cranberry concentrate"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Nystatin Powder",
        "route": "Oral Pill",
        "fullName": "Nystatin Powder (Oral Pill)",
        "totalCount": 7,
        "searchTerms": ["NYSTATIN POWDER", "Nystatin Powder", "nystatin powder"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "stimulant laxative plus",
        "route": "Oral Pill",
        "fullName": "stimulant laxative plus (Oral Pill)",
        "totalCount": 7,
        "searchTerms": ["stimulant laxative plus"],
        "dosages": [
            {
                "value": "8.6 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "71%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TAB A VIT",
        "route": "Oral Pill",
        "fullName": "TAB A VIT (Oral Pill)",
        "totalCount": 7,
        "searchTerms": ["TAB A VIT", "Tab A Vit", "tab a vit"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "86%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ascorbic acid/Folic acid/Niacin/Riboflavin/Sodium fluoride/Thiamine/Vitamin A/Vitamin B12/Vitamin B6/Vitamin D/Vitamin E",
        "route": "Chewable",
        "fullName": "Ascorbic acid/Folic acid/Niacin/Riboflavin/Sodium fluoride/Thiamine/Vitamin A/Vitamin B12/Vitamin B6/Vitamin D/Vitamin E (Chewable)",
        "totalCount": 6,
        "searchTerms": [
            "Ascorbic acid/Folic acid/Niacin/Riboflavin/Sodium fluoride/Thiamine/Vitamin A/Vitamin B12/Vitamin B6/Vitamin D/Vitamin E",
            "Ascorbic acid/Folic acid/Niacin/Riboflavin/Sodium fluoride/Thiamine/Vitamin A/Vitamin B12/Vitamin B6/Vitamin D/Vitamin E (Chewable)",
            "ascorbic acid 60 MG / folic acid 0.3 MG / niacin 13.5 MG / riboflavin 1.2 MG / sodium fluoride 0.55 MG / thiamine 1.05 MG / vitamin A 2500 UNT / vitamin B12 0.0045 MG / vitamin B6 1.05 MG / vitamin D 400 UNT / vitamin E 15 UNT Chewable Tablet",
            "ascorbic acid 60 MG / folic acid 0.3 MG / niacin 13.5 MG / riboflavin 1.2 MG / sodium fluoride 1.1 MG / thiamine 1.05 MG / vitamin A 2500 UNT / vitamin B12 0.0045 MG / vitamin B6 1.05 MG / vitamin D 400 UNT / vitamin E 15 UNT Chewable Tablet",
            "ascorbic acid 60 MG / folic acid 0.3 MG / niacin 13.5 MG / riboflavin 1.2 MG / sodium fluoride 2.2 MG / thiamine 1.05 MG / vitamin A 2500 UNT / vitamin B12 0.0045 MG / vitamin B6 1.05 MG / vitamin D 400 UNT / vitamin E 15 UNT Chewable Tablet",
            "ascorbic acid 60 mg / folic acid 0.3 mg / niacin 13.5 mg / riboflavin 1.2 mg / sodium fluoride 0.55 mg / thiamine 1.05 mg / vitamin a 2500 unt / vitamin b12 0.0045 mg / vitamin b6 1.05 mg / vitamin d 400 unt / vitamin e 15 unt chewable tablet",
            "ascorbic acid 60 mg / folic acid 0.3 mg / niacin 13.5 mg / riboflavin 1.2 mg / sodium fluoride 1.1 mg / thiamine 1.05 mg / vitamin a 2500 unt / vitamin b12 0.0045 mg / vitamin b6 1.05 mg / vitamin d 400 unt / vitamin e 15 unt chewable tablet",
            "ascorbic acid 60 mg / folic acid 0.3 mg / niacin 13.5 mg / riboflavin 1.2 mg / sodium fluoride 2.2 mg / thiamine 1.05 mg / vitamin a 2500 unt / vitamin b12 0.0045 mg / vitamin b6 1.05 mg / vitamin d 400 unt / vitamin e 15 unt chewable tablet",
            "ascorbic acid/folic acid/niacin/riboflavin/sodium fluoride/thiamine/vitamin a/vitamin b12/vitamin b6/vitamin d/vitamin e",
            "ascorbic acid/folic acid/niacin/riboflavin/sodium fluoride/thiamine/vitamin a/vitamin b12/vitamin b6/vitamin d/vitamin e (chewable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Insulin glargine-yfgn",
        "route": "U-100",
        "fullName": "Insulin glargine-yfgn (U-100)",
        "totalCount": 6,
        "searchTerms": [
            "Insulin glargine-yfgn",
            "Insulin glargine-yfgn (U-100)",
            "insulin glargine-yfgn",
            "insulin glargine-yfgn (u-100)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CITALOPRAM HYDROBROMIDE",
        "route": "Oral Pill",
        "fullName": "CITALOPRAM HYDROBROMIDE (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "CITALOPRAM HYDROBROMIDE",
            "Citalopram Hydrobromide",
            "Citalopram Hydrobromide (Oral)",
            "citalopram hydrobromide",
            "citalopram hydrobromide (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LEVAQUIN",
        "route": "Oral Pill",
        "fullName": "LEVAQUIN (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "LEVAQUIN",
            "LEVAQUIN (Oral Pill)",
            "levaquin",
            "levaquin (oral pill)",
            "levofloxacin 250 MG Oral Tablet",
            "levofloxacin 250 mg oral tablet",
            "levofloxacin 500 MG Oral Tablet",
            "levofloxacin 500 mg oral tablet",
            "levofloxacin 750 MG Oral Tablet",
            "levofloxacin 750 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Omeprazole",
        "route": "Oral Disintegrating",
        "fullName": "Omeprazole (Oral Disintegrating)",
        "totalCount": 6,
        "searchTerms": [
            "Omeprazole",
            "Omeprazole (Oral Disintegrating)",
            "omeprazole",
            "omeprazole (oral disintegrating)",
            "omeprazole 20 MG Disintegrating Oral Tablet",
            "omeprazole 20 mg disintegrating oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Allergy Relief",
        "route": "Oral Pill",
        "fullName": "Allergy Relief (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Allergy Relief",
            "Allergy Relief (Oral)",
            "allergy relief",
            "allergy relief (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ORENCIA",
        "route": "Injectable",
        "fullName": "ORENCIA (Injectable)",
        "totalCount": 6,
        "searchTerms": [
            "1 ML abatacept 125 MG/ML Prefilled Syringe",
            "1 ml abatacept 125 mg/ml prefilled syringe",
            "ORENCIA",
            "ORENCIA (Injectable)",
            "orencia",
            "orencia (injectable)"
        ],
        "dosages": [
            {
                "value": "125 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ROCALTROL",
        "route": "Oral Pill",
        "fullName": "ROCALTROL (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "ROCALTROL",
            "ROCALTROL (Oral Pill)",
            "calcitriol 0.00025 MG Oral Capsule",
            "calcitriol 0.00025 mg oral capsule",
            "rocaltrol",
            "rocaltrol (oral pill)"
        ],
        "dosages": [
            {
                "value": "0.25 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dolutegravir",
        "route": "Oral Pill",
        "fullName": "Dolutegravir (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Dolutegravir",
            "Dolutegravir (Oral Pill)",
            "dolutegravir",
            "dolutegravir (oral pill)",
            "dolutegravir 50 MG Oral Tablet",
            "dolutegravir 50 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Acetaminophen/Phenylephrine",
        "route": "Oral Pill",
        "fullName": "Acetaminophen/Phenylephrine (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Acetaminophen/Phenylephrine",
            "Acetaminophen/Phenylephrine (Oral Pill)",
            "acetaminophen 325 MG / phenylephrine hydrochloride 5 MG Oral Tablet",
            "acetaminophen 325 mg / phenylephrine hydrochloride 5 mg oral tablet",
            "acetaminophen/phenylephrine",
            "acetaminophen/phenylephrine (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Atropine/Diphenoxylate",
        "route": "Oral Pill",
        "fullName": "Atropine/Diphenoxylate (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Atropine/Diphenoxylate",
            "Atropine/Diphenoxylate (Oral Pill)",
            "atropine sulfate 0.025 MG / diphenoxylate hydrochloride 2.5 MG Oral Tablet",
            "atropine sulfate 0.025 mg / diphenoxylate hydrochloride 2.5 mg oral tablet",
            "atropine/diphenoxylate",
            "atropine/diphenoxylate (oral pill)"
        ],
        "dosages": [
            {
                "value": "0.025-2.5 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HumaLOG MIX",
        "route": "Injectable",
        "fullName": "HumaLOG MIX (Injectable)",
        "totalCount": 6,
        "searchTerms": [
            "3 ML insulin lispro 25 UNT/ML / insulin lispro protamine, human 75 UNT/ML Pen Injector",
            "3 ML insulin lispro 50 UNT/ML / insulin lispro protamine, human 50 UNT/ML Pen Injector",
            "3 ml insulin lispro 25 unt/ml / insulin lispro protamine, human 75 unt/ml pen injector",
            "3 ml insulin lispro 50 unt/ml / insulin lispro protamine, human 50 unt/ml pen injector",
            "HUMALOG MIX",
            "HumaLOG MIX",
            "HumaLOG MIX (Injectable)",
            "humalog mix",
            "humalog mix (injectable)",
            "insulin lispro 25 UNT/ML / insulin lispro protamine, human 75 UNT/ML Injectable Suspension",
            "insulin lispro 25 unt/ml / insulin lispro protamine, human 75 unt/ml injectable suspension"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Allopurinol/Lesinurad",
        "route": "Oral Pill",
        "fullName": "Allopurinol/Lesinurad (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Allopurinol/Lesinurad",
            "Allopurinol/Lesinurad (Oral Pill)",
            "allopurinol 200 MG / lesinurad 200 MG Oral Tablet",
            "allopurinol 200 mg / lesinurad 200 mg oral tablet",
            "allopurinol 300 MG / lesinurad 200 MG Oral Tablet",
            "allopurinol 300 mg / lesinurad 200 mg oral tablet",
            "allopurinol/lesinurad",
            "allopurinol/lesinurad (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SILVADENE",
        "route": "Topical",
        "fullName": "SILVADENE (Topical)",
        "totalCount": 6,
        "searchTerms": [
            "SILVADENE",
            "SILVADENE (Topical)",
            "silvadene",
            "silvadene (topical)",
            "silver sulfadiazine 10 MG/ML Topical Cream",
            "silver sulfadiazine 10 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Hydrocortisone/Lidocaine",
        "route": "Topical",
        "fullName": "Hydrocortisone/Lidocaine (Topical)",
        "totalCount": 6,
        "searchTerms": [
            "Hydrocortisone/Lidocaine",
            "Hydrocortisone/Lidocaine (Topical)",
            "hydrocortisone acetate 5 MG/ML / lidocaine hydrochloride 30 MG/ML Topical Cream",
            "hydrocortisone acetate 5 mg/ml / lidocaine hydrochloride 30 mg/ml topical cream",
            "hydrocortisone/lidocaine",
            "hydrocortisone/lidocaine (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Tamoxifen",
        "route": "Oral Pill",
        "fullName": "Tamoxifen (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Tamoxifen",
            "Tamoxifen (Oral Pill)",
            "tamoxifen",
            "tamoxifen (oral pill)",
            "tamoxifen 20 MG Oral Tablet",
            "tamoxifen 20 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "AURYXIA",
        "route": "Oral Pill",
        "fullName": "AURYXIA (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "AURYXIA",
            "AURYXIA (Oral Pill)",
            "auryxia",
            "auryxia (oral pill)",
            "ferric citrate 1000 MG Oral Tablet",
            "ferric citrate 1000 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium acetate",
        "route": "Oral Liquid",
        "fullName": "Calcium acetate (Oral Liquid)",
        "totalCount": 6,
        "searchTerms": [
            "Calcium acetate",
            "Calcium acetate (Oral Liquid)",
            "calcium acetate",
            "calcium acetate (oral liquid)",
            "calcium acetate 133 MG/ML Oral Solution",
            "calcium acetate 133 mg/ml oral solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dabigatran etexilate",
        "route": "Oral Pill",
        "fullName": "Dabigatran etexilate (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Dabigatran Etexilate",
            "Dabigatran Etexilate (Oral)",
            "Dabigatran etexilate",
            "Dabigatran etexilate (Oral Pill)",
            "dabigatran etexilate",
            "dabigatran etexilate (oral pill)",
            "dabigatran etexilate (oral)",
            "dabigatran etexilate 150 MG Oral Capsule",
            "dabigatran etexilate 150 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OXcarbazepine",
        "route": "Oral Liquid",
        "fullName": "OXcarbazepine (Oral Liquid)",
        "totalCount": 6,
        "searchTerms": [
            "OXcarbazepine",
            "OXcarbazepine (Oral Liquid)",
            "oxcarbazepine",
            "oxcarbazepine (oral liquid)",
            "oxcarbazepine 60 MG/ML Oral Suspension",
            "oxcarbazepine 60 mg/ml oral suspension"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium gluconate",
        "route": "Oral Pill",
        "fullName": "Calcium gluconate (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Calcium gluconate",
            "Calcium gluconate (Oral Pill)",
            "calcium gluconate",
            "calcium gluconate (oral pill)",
            "calcium gluconate 538 MG Oral Tablet",
            "calcium gluconate 538 mg oral tablet",
            "calcium gluconate 650 MG Oral Tablet",
            "calcium gluconate 650 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Evolocumab",
        "route": "Injectable",
        "fullName": "Evolocumab (Injectable)",
        "totalCount": 6,
        "searchTerms": [
            "1 ML evolocumab 140 MG/ML Auto-Injector",
            "1 ml evolocumab 140 mg/ml auto-injector",
            "Evolocumab",
            "Evolocumab (Injectable)",
            "evolocumab",
            "evolocumab (injectable)"
        ],
        "dosages": [
            {
                "value": "140 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Potassium chloride",
        "route": "Effervescent",
        "fullName": "Potassium chloride (Effervescent)",
        "totalCount": 6,
        "searchTerms": [
            "Potassium chloride",
            "Potassium chloride (Effervescent)",
            "potassium chloride",
            "potassium chloride (effervescent)",
            "potassium chloride 25 MEQ Effervescent Oral Tablet",
            "potassium chloride 25 meq effervescent oral tablet"
        ],
        "dosages": [
            {
                "value": "25 meq",
                "pct": "83%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Amphetamine/Dextroamphetamine",
        "route": "Oral Pill",
        "fullName": "Amphetamine/Dextroamphetamine (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Amphetamine/Dextroamphetamine",
            "Amphetamine/Dextroamphetamine (Oral Pill)",
            "amphetamine aspartate 1.875 MG / amphetamine sulfate 1.875 MG / dextroamphetamine saccharate 1.875 MG / dextroamphetamine sulfate 1.875 MG Oral Tablet",
            "amphetamine aspartate 1.875 mg / amphetamine sulfate 1.875 mg / dextroamphetamine saccharate 1.875 mg / dextroamphetamine sulfate 1.875 mg oral tablet",
            "amphetamine/dextroamphetamine",
            "amphetamine/dextroamphetamine (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Alcaftadine",
        "route": "Ophthalmic",
        "fullName": "Alcaftadine (Ophthalmic)",
        "totalCount": 6,
        "searchTerms": [
            "Alcaftadine",
            "Alcaftadine (Ophthalmic)",
            "alcaftadine",
            "alcaftadine (ophthalmic)",
            "alcaftadine 2.5 MG/ML Ophthalmic Solution",
            "alcaftadine 2.5 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NYAMYC",
        "route": "Topical",
        "fullName": "NYAMYC (Topical)",
        "totalCount": 6,
        "searchTerms": [
            "NYAMYC",
            "NYAMYC (Topical)",
            "nyamyc",
            "nyamyc (topical)",
            "nystatin 100 UNT/MG Topical Powder",
            "nystatin 100 unt/mg topical powder"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "COREG XR",
        "route": "Oral Pill",
        "fullName": "COREG XR (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "24 HR carvedilol phosphate 10 MG Extended Release Oral Capsule",
            "24 HR carvedilol phosphate 20 MG Extended Release Oral Capsule",
            "24 HR carvedilol phosphate 40 MG Extended Release Oral Capsule",
            "24 hr carvedilol phosphate 10 mg extended release oral capsule",
            "24 hr carvedilol phosphate 20 mg extended release oral capsule",
            "24 hr carvedilol phosphate 40 mg extended release oral capsule",
            "COREG",
            "COREG XR",
            "COREG XR (Oral Pill)",
            "coreg",
            "coreg xr",
            "coreg xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cromolyn",
        "route": "Ophthalmic",
        "fullName": "Cromolyn (Ophthalmic)",
        "totalCount": 6,
        "searchTerms": [
            "Cromolyn",
            "Cromolyn (Ophthalmic)",
            "cromolyn",
            "cromolyn (ophthalmic)",
            "cromolyn sodium 40 MG/ML Ophthalmic Solution",
            "cromolyn sodium 40 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Norethindrone",
        "route": "Oral Pill",
        "fullName": "Norethindrone (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Norethindrone",
            "Norethindrone (Oral Pill)",
            "norethindrone",
            "norethindrone (oral pill)",
            "norethindrone acetate 5 MG Oral Tablet",
            "norethindrone acetate 5 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Riboflavin",
        "route": "Oral Pill",
        "fullName": "Riboflavin (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Riboflavin",
            "Riboflavin (Oral Pill)",
            "riboflavin",
            "riboflavin (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OFLOXACIN",
        "route": "Ophthalmic",
        "fullName": "OFLOXACIN (Ophthalmic)",
        "totalCount": 6,
        "searchTerms": [
            "OFLOXACIN",
            "Ofloxacin",
            "Ofloxacin (Ophthalmic)",
            "ofloxacin",
            "ofloxacin (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EXCEDRIN",
        "route": "Oral Pill",
        "fullName": "EXCEDRIN (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "EXCEDRIN",
            "EXCEDRIN (Oral Pill)",
            "acetaminophen 250 MG / aspirin 250 MG / caffeine 65 MG Oral Tablet",
            "acetaminophen 250 mg / aspirin 250 mg / caffeine 65 mg oral tablet",
            "excedrin",
            "excedrin (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lithium",
        "route": "Oral Pill",
        "fullName": "Lithium (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Lithium",
            "Lithium (Oral Pill)",
            "lithium",
            "lithium (oral pill)",
            "lithium orotate 5 MG Oral Capsule",
            "lithium orotate 5 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "APTIOM",
        "route": "Oral Pill",
        "fullName": "APTIOM (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "APTIOM",
            "APTIOM (Oral Pill)",
            "aptiom",
            "aptiom (oral pill)",
            "eslicarbazepine acetate 400 MG Oral Tablet",
            "eslicarbazepine acetate 400 mg oral tablet",
            "eslicarbazepine acetate 800 MG Oral Tablet",
            "eslicarbazepine acetate 800 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VYVANSE",
        "route": "Oral Pill",
        "fullName": "VYVANSE (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "VYVANSE",
            "VYVANSE (Oral Pill)",
            "Vyvanse",
            "Vyvanse (Oral)",
            "lisdexamfetamine dimesylate 10 MG Oral Capsule",
            "lisdexamfetamine dimesylate 10 mg oral capsule",
            "lisdexamfetamine dimesylate 30 MG Oral Capsule",
            "lisdexamfetamine dimesylate 30 mg oral capsule",
            "lisdexamfetamine dimesylate 40 MG Oral Capsule",
            "lisdexamfetamine dimesylate 40 mg oral capsule",
            "vyvanse",
            "vyvanse (oral pill)",
            "vyvanse (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lidocaine",
        "route": "Mucosal",
        "fullName": "Lidocaine (Mucosal)",
        "totalCount": 6,
        "searchTerms": [
            "Lidocaine",
            "Lidocaine (Mucosal)",
            "lidocaine",
            "lidocaine (mucosal)",
            "lidocaine hydrochloride 20 MG/ML Mucous Membrane Topical Solution",
            "lidocaine hydrochloride 20 mg/ml mucous membrane topical solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OXTELLAR XR",
        "route": "Oral Pill",
        "fullName": "OXTELLAR XR (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "OXTELLAR XR",
            "OXTELLAR XR (Oral Pill)",
            "oxtellar xr",
            "oxtellar xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Tretinoin",
        "route": "Topical",
        "fullName": "Tretinoin (Topical)",
        "totalCount": 6,
        "searchTerms": [
            "Tretinoin",
            "Tretinoin (Topical)",
            "tretinoin",
            "tretinoin (topical)",
            "tretinoin 0.25 MG/ML Topical Cream",
            "tretinoin 0.25 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FLORASTOR",
        "route": "Oral Pill",
        "fullName": "FLORASTOR (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "FLORASTOR",
            "FLORASTOR (Oral Pill)",
            "Florastor",
            "Saccharomyces boulardii 250 MG Oral Capsule",
            "florastor",
            "florastor (oral pill)",
            "saccharomyces boulardii 250 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "250 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "cloNIDine",
        "route": "Transdermal",
        "fullName": "cloNIDine (Transdermal)",
        "totalCount": 6,
        "searchTerms": [
            "cloNIDine",
            "cloNIDine (Transdermal)",
            "clonidine",
            "clonidine (transdermal)"
        ],
        "dosages": [
            {
                "value": "4.17 mcg",
                "pct": "83%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Sulindac",
        "route": "Oral Pill",
        "fullName": "Sulindac (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Sulindac",
            "Sulindac (Oral Pill)",
            "Sulindac (Oral)",
            "sulindac",
            "sulindac (oral pill)",
            "sulindac (oral)",
            "sulindac 150 MG Oral Tablet",
            "sulindac 150 mg oral tablet",
            "sulindac 200 MG Oral Tablet",
            "sulindac 200 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ciprofloxacin/dexAMETHasone",
        "route": "Otic",
        "fullName": "Ciprofloxacin/dexAMETHasone (Otic)",
        "totalCount": 6,
        "searchTerms": [
            "Ciprofloxacin/dexAMETHasone",
            "Ciprofloxacin/dexAMETHasone (Otic)",
            "ciprofloxacin/dexamethasone",
            "ciprofloxacin/dexamethasone (otic)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Phenazopyridine",
        "route": "Oral Pill",
        "fullName": "Phenazopyridine (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Phenazopyridine",
            "Phenazopyridine (Oral Pill)",
            "Phenazopyridine (Oral)",
            "Pyridium",
            "phenazopyridine",
            "phenazopyridine (oral pill)",
            "phenazopyridine (oral)",
            "phenazopyridine hydrochloride 200 MG Oral Tablet",
            "phenazopyridine hydrochloride 200 mg oral tablet",
            "pyridium"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PRISTIQ XR",
        "route": "Oral Pill",
        "fullName": "PRISTIQ XR (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "24 HR desvenlafaxine succinate 25 MG Extended Release Oral Tablet",
            "24 HR desvenlafaxine succinate 50 MG Extended Release Oral Tablet",
            "24 hr desvenlafaxine succinate 25 mg extended release oral tablet",
            "24 hr desvenlafaxine succinate 50 mg extended release oral tablet",
            "PRISTIQ",
            "PRISTIQ XR",
            "PRISTIQ XR (Oral Pill)",
            "pristiq",
            "pristiq xr",
            "pristiq xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BLINK TEARS",
        "route": "Ophthalmic",
        "fullName": "BLINK TEARS (Ophthalmic)",
        "totalCount": 6,
        "searchTerms": [
            "BLINK TEARS",
            "BLINK TEARS (Ophthalmic)",
            "blink tears",
            "blink tears (ophthalmic)",
            "polyethylene glycol 400 2.5 MG/ML Ophthalmic Solution",
            "polyethylene glycol 400 2.5 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ergocalciferol",
        "route": "Oral Liquid",
        "fullName": "Ergocalciferol (Oral Liquid)",
        "totalCount": 6,
        "searchTerms": [
            "Ergocalciferol",
            "Ergocalciferol (Oral Liquid)",
            "ergocalciferol",
            "ergocalciferol (oral liquid)"
        ],
        "dosages": [
            {
                "value": "0.2 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E55.9",
                "description": "Vitamin D deficiency, unspecified",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "Pitavastatin",
        "route": "Oral Pill",
        "fullName": "Pitavastatin (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Pitavastatin",
            "Pitavastatin (Oral Pill)",
            "Pitavastatin (Oral)",
            "pitavastatin",
            "pitavastatin (oral pill)",
            "pitavastatin (oral)",
            "pitavastatin magnesium 1 MG Oral Tablet",
            "pitavastatin magnesium 1 mg oral tablet",
            "pitavastatin magnesium 2 MG Oral Tablet",
            "pitavastatin magnesium 2 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Magnesium gluconate",
        "route": "Oral Pill",
        "fullName": "Magnesium gluconate (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Magnesium gluconate",
            "Magnesium gluconate (Oral Pill)",
            "magnesium gluconate",
            "magnesium gluconate (oral pill)",
            "magnesium gluconate 500 MG Oral Tablet",
            "magnesium gluconate 500 mg oral tablet",
            "magnesium gluconate 550 MG Oral Tablet",
            "magnesium gluconate 550 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cyclopentolate",
        "route": "Ophthalmic",
        "fullName": "Cyclopentolate (Ophthalmic)",
        "totalCount": 6,
        "searchTerms": [
            "Cyclopentolate",
            "Cyclopentolate (Ophthalmic)",
            "cyclopentolate",
            "cyclopentolate (ophthalmic)",
            "cyclopentolate hydrochloride 10 MG/ML Ophthalmic Solution",
            "cyclopentolate hydrochloride 10 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "URSO FORTE",
        "route": "Oral Pill",
        "fullName": "URSO FORTE (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "URSO FORTE",
            "URSO FORTE (Oral Pill)",
            "urso forte",
            "urso forte (oral pill)",
            "ursodiol 500 MG Oral Tablet",
            "ursodiol 500 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Colesevelam",
        "route": "Oral Pill",
        "fullName": "Colesevelam (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Colesevelam",
            "Colesevelam (Oral Pill)",
            "colesevelam",
            "colesevelam (oral pill)",
            "colesevelam hydrochloride 625 MG Oral Tablet",
            "colesevelam hydrochloride 625 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "625 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Amlodipine-Benazepril",
        "route": "Oral Pill",
        "fullName": "Amlodipine-Benazepril (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "AMLODIPINE-BENAZEPRIL",
            "AMLODIPINE-BENAZEPRIL (Oral)",
            "Amlodipine-Benazepril",
            "Amlodipine-Benazepril (Oral)",
            "Lotrel",
            "amLODIPine-benazepril",
            "amLODIPine-benazepril (Oral)",
            "amlodipine-benazepril",
            "amlodipine-benazepril (oral)",
            "lotrel"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Repatha SureClick",
        "route": "Injectable",
        "fullName": "Repatha SureClick (Injectable)",
        "totalCount": 6,
        "searchTerms": [
            "Repatha SureClick",
            "Repatha SureClick (Injectable)",
            "repatha sureclick",
            "repatha sureclick (injectable)"
        ],
        "dosages": [
            {
                "value": "140 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E78.5",
                "description": "Hyperlipidemia, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Albuterol Sulfate HFA Inhalation Aerosol",
        "route": "Inhaler",
        "fullName": "Albuterol Sulfate HFA Inhalation Aerosol (Inhaler)",
        "totalCount": 6,
        "searchTerms": [
            "Albuterol Sulfate HFA Inhalation Aerosol",
            "Albuterol Sulfate HFA Inhalation Aerosol (Inhaler)",
            "Ventolin HFA",
            "albuterol sulfate hfa inhalation aerosol",
            "albuterol sulfate hfa inhalation aerosol (inhaler)",
            "ventolin hfa"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ibandronate Sodium",
        "route": "Oral Pill",
        "fullName": "Ibandronate Sodium (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "BONIVA",
            "Boniva",
            "IBANDRONATE SODIUM",
            "IBANDRONATE SODIUM (Oral)",
            "Ibandronate Sodium",
            "Ibandronate Sodium (Oral)",
            "boniva",
            "ibandronate sodium",
            "ibandronate sodium (oral)"
        ],
        "dosages": [
            {
                "value": "150 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once monthly",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M81.0",
                "description": "Age-related osteoporosis w/o current pathological fracture",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Bisoprolol Fumarate",
        "route": "Oral Pill",
        "fullName": "Bisoprolol Fumarate (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Bisoprolol Fumarate",
            "Bisoprolol Fumarate (Oral)",
            "Zebeta",
            "bisoprolol fumarate",
            "bisoprolol fumarate (oral)",
            "zebeta"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lurasidone HCl",
        "route": "Oral Pill",
        "fullName": "Lurasidone HCl (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Latuda",
            "Lurasidone HCL",
            "Lurasidone HCL (Oral)",
            "Lurasidone HCl",
            "Lurasidone HCl (Oral)",
            "latuda",
            "lurasidone hcl",
            "lurasidone hcl (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Benazepril HCl",
        "route": "Oral Pill",
        "fullName": "Benazepril HCl (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "BENAZEPRIL HCL",
            "BENAZEPRIL HCL (Oral)",
            "Benazepril HCL",
            "Benazepril HCL (Oral)",
            "Benazepril HCl",
            "Benazepril HCl (Oral)",
            "Lotensin",
            "benazepril hcl",
            "benazepril hcl (oral)",
            "lotensin"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Trulicity (dulaglutide)",
        "route": "Injectable",
        "fullName": "Trulicity (dulaglutide) (Injectable)",
        "totalCount": 6,
        "searchTerms": [
            "Trulicity (Dulaglutide)",
            "Trulicity (Dulaglutide) (Injectable)",
            "Trulicity (dulaglutide)",
            "Trulicity (dulaglutide) (Injectable)",
            "trulicity (dulaglutide)",
            "trulicity (dulaglutide) (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "JANTOVEN",
        "route": "Oral Pill",
        "fullName": "JANTOVEN (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "JANTOVEN",
            "JANTOVEN (Oral Pill)",
            "jantoven",
            "jantoven (oral pill)",
            "warfarin sodium 1 MG Oral Tablet",
            "warfarin sodium 1 mg oral tablet",
            "warfarin sodium 2.5 MG Oral Tablet",
            "warfarin sodium 2.5 mg oral tablet",
            "warfarin sodium 5 MG Oral Tablet",
            "warfarin sodium 5 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Nature Made Magnesium - Supplement",
        "route": "Oral Pill",
        "fullName": "Nature Made Magnesium - Supplement (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Nature Made Magnesium - Supplement",
            "Nature Made Magnesium - Supplement (Oral)",
            "nature made magnesium - supplement",
            "nature made magnesium - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "Supports muscle relaxation",
                "pct": "83%"
            }
        ],
        "diagnoses": []
    },
    {
        "name": "Duloxetine DR",
        "route": "Oral Pill",
        "fullName": "Duloxetine DR (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Cymbalta",
            "Duloxetine DR",
            "Duloxetine DR (Oral)",
            "cymbalta",
            "duloxetine dr",
            "duloxetine dr (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Rena-Vite - Supplement",
        "route": "Oral Pill",
        "fullName": "Rena-Vite - Supplement (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "RENA-VITE - Supplement",
            "RENA-VITE - Supplement (Oral)",
            "Rena-Vite - Supplement",
            "Rena-Vite - Supplement (Oral)",
            "rena-vite - Supplement",
            "rena-vite - Supplement (Oral)",
            "rena-vite - supplement",
            "rena-vite - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Amoxicillin",
        "route": "Oral Liquid",
        "fullName": "Amoxicillin (Oral Liquid)",
        "totalCount": 6,
        "searchTerms": [
            "Amoxicillin",
            "Amoxicillin (Oral Liquid)",
            "amoxicillin",
            "amoxicillin (oral liquid)",
            "amoxicillin 50 MG/ML Oral Suspension",
            "amoxicillin 50 mg/ml oral suspension",
            "amoxicillin 80 MG/ML Oral Suspension",
            "amoxicillin 80 mg/ml oral suspension"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Pantoprazole (Protonix)",
        "route": "Oral Pill",
        "fullName": "Pantoprazole (Protonix) (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Pantoprazole (Protonix)",
            "Pantoprazole (Protonix) (Oral)",
            "pantoprazole (PROTONIX)",
            "pantoprazole (PROTONIX) (Oral)",
            "pantoprazole (protonix)",
            "pantoprazole (protonix) (oral)"
        ],
        "dosages": [
            {
                "value": "40 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "K21.9",
                "description": "Gastro-esophageal reflux disease without esophagitis",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "Oxybutynin ER",
        "route": "Oral Pill",
        "fullName": "Oxybutynin ER (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Oxybutynin ER",
            "Oxybutynin ER (Oral)",
            "oxyBUTYnin ER",
            "oxyBUTYnin ER (Oral)",
            "oxybutynin er",
            "oxybutynin er (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "levETIRAcetam (Keppra)",
        "route": "Oral Pill",
        "fullName": "levETIRAcetam (Keppra) (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Levetiracetam (Keppra)",
            "Levetiracetam (Keppra) (Oral)",
            "levETIRAcetam (Keppra)",
            "levETIRAcetam (Keppra) (Oral)",
            "levetiracetam (keppra)",
            "levetiracetam (keppra) (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G40.909",
                "description": "Epilepsy, unsp, not intractable, without status epilepticus",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "WARFARIN SODIUM",
        "route": "Oral Pill",
        "fullName": "WARFARIN SODIUM (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Coumadin",
            "WARFARIN SODIUM",
            "WARFARIN SODIUM (Oral)",
            "Warfarin Sodium",
            "Warfarin Sodium (Oral)",
            "coumadin",
            "warfarin sodium",
            "warfarin sodium (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Myrbetriq (mirabegron)",
        "route": "Oral Pill",
        "fullName": "Myrbetriq (mirabegron) (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Myrbetriq (mirabegron)",
            "Myrbetriq (mirabegron) (Oral)",
            "myrbetriq (mirabegron)",
            "myrbetriq (mirabegron) (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Sertraline Hydrochloride",
        "route": "Oral Pill",
        "fullName": "Sertraline Hydrochloride (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Sertraline Hydrochloride",
            "Sertraline Hydrochloride (Oral)",
            "Zoloft",
            "sertraline hydrochloride",
            "sertraline hydrochloride (oral)",
            "zoloft"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Doxycycline Hyclate",
        "route": "Oral Pill",
        "fullName": "Doxycycline Hyclate (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Doxycycline Hyclate",
            "Doxycycline Hyclate (Oral)",
            "Morgidox",
            "Targadox",
            "doxycycline hyclate",
            "doxycycline hyclate (oral)",
            "morgidox",
            "targadox"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ranolazine ER",
        "route": "Oral Pill",
        "fullName": "Ranolazine ER (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Ranexa",
            "Ranolazine ER",
            "Ranolazine ER (Oral)",
            "ranexa",
            "ranolazine er",
            "ranolazine er (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PRAZOSIN HCL",
        "route": "Oral Pill",
        "fullName": "PRAZOSIN HCL (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "MINIPRESS 1 MG",
            "PRAZOSIN HCL",
            "PRAZOSIN HCL (Oral)",
            "Prazosin HCL",
            "Prazosin HCL (Oral)",
            "Prazosin HCl",
            "Prazosin HCl (Oral)",
            "minipress 1 mg",
            "prazosin hcl",
            "prazosin hcl (oral)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Multivitamin Adult - Supplement",
        "route": "Oral Pill",
        "fullName": "Multivitamin Adult - Supplement (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "MULTIVITAMIN ADULT - Supplement",
            "MULTIVITAMIN ADULT - Supplement (Oral)",
            "Multivitamin Adult - Supplement",
            "Multivitamin Adult - Supplement (Oral)",
            "multivitamin adult - supplement",
            "multivitamin adult - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "metFORMIN (GLUCOPHAGE)",
        "route": "Oral Pill",
        "fullName": "metFORMIN (GLUCOPHAGE) (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Metformin (Glucophage)",
            "Metformin (Glucophage) (Oral)",
            "metFORMIN (GLUCOPHAGE)",
            "metFORMIN (GLUCOPHAGE) (Oral)",
            "metformin (GLUCOPHAGE)",
            "metformin (GLUCOPHAGE) (Oral)",
            "metformin (glucophage)",
            "metformin (glucophage) (oral)"
        ],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Budesonide Inhalation Suspension",
        "route": "Inhaler",
        "fullName": "Budesonide Inhalation Suspension (Inhaler)",
        "totalCount": 6,
        "searchTerms": [
            "Budesonide Inhalation Suspension",
            "Budesonide Inhalation Suspension (Inhaler)",
            "budesonide inhalation suspension",
            "budesonide inhalation suspension (inhaler)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Fluticasone Propionate and Salmeterol",
        "route": "Inhaler",
        "fullName": "Fluticasone Propionate and Salmeterol (Inhaler)",
        "totalCount": 6,
        "searchTerms": [
            "Advair Diskus",
            "Fluticasone Propionate and Salmeterol",
            "Fluticasone Propionate and Salmeterol (Inhaler)",
            "advair diskus",
            "fluticasone propionate and salmeterol",
            "fluticasone propionate and salmeterol (inhaler)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Centrum Silver Adults 50+ - Supplement",
        "route": "Oral Pill",
        "fullName": "Centrum Silver Adults 50+ - Supplement (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Centrum Silver ADULTS 50+ - Supplement",
            "Centrum Silver ADULTS 50+ - Supplement (Oral)",
            "Centrum Silver Adults 50+ - Supplement",
            "Centrum Silver Adults 50+ - Supplement (Oral)",
            "centrum silver adults 50+ - supplement",
            "centrum silver adults 50+ - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "Sacubitril and Valsartan",
        "route": "Oral Pill",
        "fullName": "Sacubitril and Valsartan (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Sacubitril and Valsartan",
            "Sacubitril and Valsartan (Oral)",
            "sacubitril and valsartan",
            "sacubitril and valsartan (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I50.9",
                "description": "Heart failure, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Refresh Tears Lubricant Eye Drops",
        "route": "Ophthalmic",
        "fullName": "Refresh Tears Lubricant Eye Drops (Ophthalmic)",
        "totalCount": 6,
        "searchTerms": [
            "Refresh Tears Lubricant Eye Drops",
            "Refresh Tears Lubricant Eye Drops (Ophthalmic)",
            "refresh tears lubricant eye drops",
            "refresh tears lubricant eye drops (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "H04.123",
                "description": "Dry eye syndrome of bilateral lacrimal glands",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ketoconazole Cream",
        "route": "Topical",
        "fullName": "Ketoconazole Cream (Topical)",
        "totalCount": 6,
        "searchTerms": [
            "Ketoconazole Cream",
            "Ketoconazole Cream (Topical)",
            "ketoconazole cream",
            "ketoconazole cream (Topical)",
            "ketoconazole cream (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "gabapentin (NEURONTIN)",
        "route": "Oral Pill",
        "fullName": "gabapentin (NEURONTIN) (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Gabapentin (Neurontin)",
            "Gabapentin (Neurontin) (Oral)",
            "gabapentin (NEURONTIN)",
            "gabapentin (NEURONTIN) (Oral)",
            "gabapentin (Neurontin)",
            "gabapentin (Neurontin) (Oral)",
            "gabapentin (neurontin)",
            "gabapentin (neurontin) (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "G89.29",
                "description": "Other chronic pain",
                "pct": "83%"
            }
        ]
    },
    {
        "name": "Testosterone",
        "route": "Injectable",
        "fullName": "Testosterone (Injectable)",
        "totalCount": 6,
        "searchTerms": [
            "1 ML testosterone cypionate 200 MG/ML Injection",
            "1 ml testosterone cypionate 200 mg/ml injection",
            "3 ML testosterone undecanoate 250 MG/ML Injection",
            "3 ml testosterone undecanoate 250 mg/ml injection",
            "TESTOSTERONE",
            "Testosterone",
            "Testosterone (Injectable)",
            "testosterone",
            "testosterone (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Hydrochlorothiazide/Spironolactone",
        "route": "Oral Pill",
        "fullName": "Hydrochlorothiazide/Spironolactone (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Hydrochlorothiazide/Spironolactone",
            "Hydrochlorothiazide/Spironolactone (Oral Pill)",
            "hydroCHLOROthiazide/Spironolactone",
            "hydroCHLOROthiazide/Spironolactone (Oral Pill)",
            "hydrochlorothiazide 25 MG / spironolactone 25 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / spironolactone 25 mg oral tablet",
            "hydrochlorothiazide/spironolactone",
            "hydrochlorothiazide/spironolactone (oral pill)"
        ],
        "dosages": [
            {
                "value": "25-25 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "XHANCE",
        "route": "Nasal",
        "fullName": "XHANCE (Nasal)",
        "totalCount": 6,
        "searchTerms": [
            "XHANCE",
            "XHANCE (Nasal)",
            "fluticasone propionate 0.093 MG/ACTUAT Metered Dose Nasal Spray",
            "fluticasone propionate 0.093 mg/actuat metered dose nasal spray",
            "xhance",
            "xhance (nasal)"
        ],
        "dosages": [
            {
                "value": "93 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ROPINIROLE HCL",
        "route": "Oral Pill",
        "fullName": "ROPINIROLE HCL (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "ROPINIROLE HCL",
            "Ropinirole HCL",
            "Ropinirole HCL (Oral)",
            "rOPINIRole HCl",
            "rOPINIRole HCl (Oral)",
            "rOPINIrole HCL",
            "rOPINIrole HCL (Oral)",
            "rOPINIrole HCl",
            "rOPINIrole HCl (Oral)",
            "ropinirole hcl",
            "ropinirole hcl (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Mometasone",
        "route": "Inhalant",
        "fullName": "Mometasone (Inhalant)",
        "totalCount": 6,
        "searchTerms": [
            "120 ACTUAT mometasone furoate 0.1 MG/ACTUAT Metered Dose Inhaler",
            "120 ACTUAT mometasone furoate 0.2 MG/ACTUAT Metered Dose Inhaler",
            "120 actuat mometasone furoate 0.1 mg/actuat metered dose inhaler",
            "120 actuat mometasone furoate 0.2 mg/actuat metered dose inhaler",
            "Mometasone",
            "Mometasone (Inhalant)",
            "mometasone",
            "mometasone (inhalant)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Gentamicin",
        "route": "Topical",
        "fullName": "Gentamicin (Topical)",
        "totalCount": 6,
        "searchTerms": [
            "Gentamicin",
            "Gentamicin (Topical)",
            "gentamicin",
            "gentamicin (topical)",
            "gentamicin 0.001 MG/MG Topical Ointment",
            "gentamicin 0.001 mg/mg topical ointment",
            "gentamicin 1 MG/ML Topical Cream",
            "gentamicin 1 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DECADRON",
        "route": "Oral Pill",
        "fullName": "DECADRON (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "DECADRON",
            "DECADRON (Oral Pill)",
            "decadron",
            "decadron (oral pill)",
            "dexamethasone 0.5 MG Oral Tablet",
            "dexamethasone 0.5 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VIMOVO",
        "route": "Oral Pill",
        "fullName": "VIMOVO (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "VIMOVO",
            "VIMOVO (Oral Pill)",
            "esomeprazole 20 MG / naproxen 500 MG Delayed Release Oral Tablet",
            "esomeprazole 20 mg / naproxen 500 mg delayed release oral tablet",
            "vimovo",
            "vimovo (oral pill)"
        ],
        "dosages": [
            {
                "value": "20-500 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Quinapril",
        "route": "Oral Pill",
        "fullName": "Quinapril (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Quinapril",
            "Quinapril (Oral Pill)",
            "quinapril",
            "quinapril (oral pill)",
            "quinapril 10 MG Oral Tablet",
            "quinapril 10 mg oral tablet",
            "quinapril 20 MG Oral Tablet",
            "quinapril 20 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CILOXAN",
        "route": "Ophthalmic",
        "fullName": "CILOXAN (Ophthalmic)",
        "totalCount": 6,
        "searchTerms": [
            "CILOXAN",
            "CILOXAN (Ophthalmic)",
            "ciloxan",
            "ciloxan (ophthalmic)",
            "ciprofloxacin 3 MG/ML Ophthalmic Solution",
            "ciprofloxacin 3 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PRANDIN",
        "route": "Oral Pill",
        "fullName": "PRANDIN (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "PRANDIN",
            "PRANDIN (Oral Pill)",
            "prandin",
            "prandin (oral pill)",
            "repaglinide 0.5 MG Oral Tablet",
            "repaglinide 0.5 mg oral tablet",
            "repaglinide 2 MG Oral Tablet",
            "repaglinide 2 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FIBERCON",
        "route": "Oral Pill",
        "fullName": "FIBERCON (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "FIBERCON",
            "FIBERCON (Oral Pill)",
            "calcium polycarbophil 625 MG Oral Tablet",
            "calcium polycarbophil 625 mg oral tablet",
            "fibercon",
            "fibercon (oral pill)"
        ],
        "dosages": [
            {
                "value": "625 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ascorbic acid/Biotin/Copper sulfate/Docusate/Folic acid/Iron carbonyl/Vitamin B12/Vitamin E XR",
        "route": "Oral Pill",
        "fullName": "Ascorbic acid/Biotin/Copper sulfate/Docusate/Folic acid/Iron carbonyl/Vitamin B12/Vitamin E XR (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "24 HR ascorbic acid 500 MG / biotin 0.15 MG / copper sulfate 3 MG / dl-alpha tocopheryl acetate 30 UNT / docusate sodium 50 MG / folic acid 1 MG / iron carbonyl 150 MG / vitamin B12 0.06 MG Extended Release Oral Tablet",
            "24 hr ascorbic acid 500 mg / biotin 0.15 mg / copper sulfate 3 mg / dl-alpha tocopheryl acetate 30 unt / docusate sodium 50 mg / folic acid 1 mg / iron carbonyl 150 mg / vitamin b12 0.06 mg extended release oral tablet",
            "Ascorbic acid/Biotin/Copper sulfate/Docusate/Folic acid/Iron carbonyl/Vitamin B12/Vitamin E XR",
            "Ascorbic acid/Biotin/Copper sulfate/Docusate/Folic acid/Iron carbonyl/Vitamin B12/Vitamin E XR (Oral Pill)",
            "ascorbic acid/biotin/copper sulfate/docusate/folic acid/iron carbonyl/vitamin b12/vitamin e xr",
            "ascorbic acid/biotin/copper sulfate/docusate/folic acid/iron carbonyl/vitamin b12/vitamin e xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VISTARIL",
        "route": "Oral Pill",
        "fullName": "VISTARIL (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "VISTARIL",
            "VISTARIL (Oral Pill)",
            "hydroxyzine pamoate 25 MG Oral Capsule",
            "hydroxyzine pamoate 25 mg oral capsule",
            "hydroxyzine pamoate 50 MG Oral Capsule",
            "hydroxyzine pamoate 50 mg oral capsule",
            "vistaril",
            "vistaril (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROPRINAL",
        "route": "Oral Pill",
        "fullName": "PROPRINAL (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "PROPRINAL",
            "PROPRINAL (Oral Pill)",
            "ibuprofen 200 MG Oral Tablet",
            "ibuprofen 200 mg oral tablet",
            "proprinal",
            "proprinal (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PAMPRIN MULTI-SYMPTOM",
        "route": "Oral Pill",
        "fullName": "PAMPRIN MULTI-SYMPTOM (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "PAMPRIN MULTI-SYMPTOM",
            "PAMPRIN MULTI-SYMPTOM (Oral Pill)",
            "acetaminophen 500 MG / pamabrom 25 MG / pyrilamine maleate 15 MG Oral Tablet",
            "acetaminophen 500 mg / pamabrom 25 mg / pyrilamine maleate 15 mg oral tablet",
            "pamprin multi-symptom",
            "pamprin multi-symptom (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EPINEPHrine/Lidocaine",
        "route": "Injectable",
        "fullName": "EPINEPHrine/Lidocaine (Injectable)",
        "totalCount": 6,
        "searchTerms": [
            "20 ML epinephrine 0.005 MG/ML / lidocaine hydrochloride 20 MG/ML Injection",
            "20 ml epinephrine 0.005 mg/ml / lidocaine hydrochloride 20 mg/ml injection",
            "EPINEPHrine/Lidocaine",
            "EPINEPHrine/Lidocaine (Injectable)",
            "epinephrine 0.01 MG/ML / lidocaine hydrochloride 10 MG/ML Injectable Solution",
            "epinephrine 0.01 MG/ML / lidocaine hydrochloride 20 MG/ML Injectable Solution",
            "epinephrine 0.01 mg/ml / lidocaine hydrochloride 10 mg/ml injectable solution",
            "epinephrine 0.01 mg/ml / lidocaine hydrochloride 20 mg/ml injectable solution",
            "epinephrine/lidocaine",
            "epinephrine/lidocaine (injectable)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OXAYDO",
        "route": "Oral Pill",
        "fullName": "OXAYDO (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "OXAYDO",
            "OXAYDO (Oral Pill)",
            "oxaydo",
            "oxaydo (oral pill)",
            "oxycodone hydrochloride 5 MG Oral Tablet",
            "oxycodone hydrochloride 5 mg oral tablet",
            "oxycodone hydrochloride 7.5 MG Oral Tablet",
            "oxycodone hydrochloride 7.5 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Zaleplon",
        "route": "Oral Pill",
        "fullName": "Zaleplon (Oral Pill)",
        "totalCount": 6,
        "searchTerms": [
            "Zaleplon",
            "Zaleplon (Oral Pill)",
            "zaleplon",
            "zaleplon (oral pill)",
            "zaleplon 10 MG Oral Capsule",
            "zaleplon 10 mg oral capsule",
            "zaleplon 5 MG Oral Capsule",
            "zaleplon 5 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "AMLACTIN AP",
        "route": "Topical",
        "fullName": "AMLACTIN AP (Topical)",
        "totalCount": 6,
        "searchTerms": [
            "AMLACTIN AP",
            "AMLACTIN AP (Topical)",
            "amlactin ap",
            "amlactin ap (topical)",
            "ammonium lactate 120 MG/ML / pramoxine hydrochloride 10 MG/ML Topical Cream",
            "ammonium lactate 120 mg/ml / pramoxine hydrochloride 10 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "KETODAN",
        "route": "Topical",
        "fullName": "KETODAN (Topical)",
        "totalCount": 6,
        "searchTerms": [
            "KETODAN",
            "KETODAN (Topical)",
            "ketoconazole 20 MG/ML Topical Foam",
            "ketoconazole 20 mg/ml topical foam",
            "ketodan",
            "ketodan (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PREPARATION H CREAM",
        "route": "Rectal",
        "fullName": "PREPARATION H CREAM (Rectal)",
        "totalCount": 6,
        "searchTerms": [
            "PREPARATION H CREAM",
            "PREPARATION H CREAM (Rectal)",
            "glycerin 144 MG/ML / petrolatum 150 MG/ML / phenylephrine hydrochloride 2.5 MG/ML / pramoxine hydrochloride 10 MG/ML Rectal Cream",
            "glycerin 144 mg/ml / petrolatum 150 mg/ml / phenylephrine hydrochloride 2.5 mg/ml / pramoxine hydrochloride 10 mg/ml rectal cream",
            "preparation h cream",
            "preparation h cream (rectal)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "One a Day Womens 50+ Tab",
        "route": "Oral Pill",
        "fullName": "One a Day Womens 50+ Tab (Oral Pill)",
        "totalCount": 6,
        "searchTerms": ["One a Day Womens 50+ Tab", "one a day womens 50+ tab"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Mucus Relief ER",
        "route": "Oral Pill",
        "fullName": "Mucus Relief ER (Oral Pill)",
        "totalCount": 6,
        "searchTerms": ["Mucus Relief ER", "mucus relief er"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium-Vit D3",
        "route": "Oral Pill",
        "fullName": "Calcium-Vit D3 (Oral Pill)",
        "totalCount": 6,
        "searchTerms": ["Calcium-Vit D3", "calcium-vit d3"],
        "dosages": [
            {
                "value": "600-400 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OYSTER SHELL CALCIUM",
        "route": "Oral Pill",
        "fullName": "OYSTER SHELL CALCIUM (Oral Pill)",
        "totalCount": 6,
        "searchTerms": ["OYSTER SHELL CALCIUM", "oyster shell calcium"],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "83%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cyancobalamin",
        "route": "Oral Pill",
        "fullName": "Cyancobalamin (Oral Pill)",
        "totalCount": 6,
        "searchTerms": ["Cyancobalamin", "cyancobalamin"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Turmeric Root Extract",
        "route": "Oral Pill",
        "fullName": "Turmeric Root Extract (Oral Pill)",
        "totalCount": 6,
        "searchTerms": ["Turmeric Root Extract", "turmeric root extract"],
        "dosages": [
            {
                "value": "500 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "83%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Glucose Monitoring Kit",
        "route": "Oral Pill",
        "fullName": "Glucose Monitoring Kit (Oral Pill)",
        "totalCount": 6,
        "searchTerms": ["Glucose Monitoring Kit", "glucose monitoring kit"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RAYOS",
        "route": "Oral Pill",
        "fullName": "RAYOS (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "RAYOS",
            "RAYOS (Oral Pill)",
            "prednisone 1 MG Delayed Release Oral Tablet",
            "prednisone 1 mg delayed release oral tablet",
            "prednisone 5 MG Delayed Release Oral Tablet",
            "prednisone 5 mg delayed release oral tablet",
            "rayos",
            "rayos (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "REVLIMID",
        "route": "Oral Pill",
        "fullName": "REVLIMID (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "REVLIMID",
            "REVLIMID (Oral Pill)",
            "lenalidomide 10 MG Oral Capsule",
            "lenalidomide 10 mg oral capsule",
            "lenalidomide 2.5 MG Oral Capsule",
            "lenalidomide 2.5 mg oral capsule",
            "lenalidomide 5 MG Oral Capsule",
            "lenalidomide 5 mg oral capsule",
            "revlimid",
            "revlimid (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "IRON",
        "route": "Oral Pill",
        "fullName": "IRON (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["IRON", "Iron", "iron"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ZYTIGA",
        "route": "Oral Pill",
        "fullName": "ZYTIGA (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "ZYTIGA",
            "ZYTIGA (Oral Pill)",
            "Zytiga",
            "abiraterone acetate 250 MG Oral Tablet",
            "abiraterone acetate 250 mg oral tablet",
            "abiraterone acetate 500 MG Oral Tablet",
            "abiraterone acetate 500 mg oral tablet",
            "zytiga",
            "zytiga (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium phosphate/Magnesium carbonate/Potassium chloride",
        "route": "Oral Pill",
        "fullName": "Calcium phosphate/Magnesium carbonate/Potassium chloride (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Calcium phosphate/Magnesium carbonate/Potassium chloride",
            "Calcium phosphate/Magnesium carbonate/Potassium chloride (Oral Pill)",
            "calcium phosphate 0.132 MEQ / magnesium carbonate 0.107 MEQ / potassium chloride 0.537 MEQ Oral Tablet",
            "calcium phosphate 0.132 meq / magnesium carbonate 0.107 meq / potassium chloride 0.537 meq oral tablet",
            "calcium phosphate/magnesium carbonate/potassium chloride",
            "calcium phosphate/magnesium carbonate/potassium chloride (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "QVAR",
        "route": "Inhalant",
        "fullName": "QVAR (Inhalant)",
        "totalCount": 5,
        "searchTerms": [
            "120 ACTUAT beclomethasone dipropionate 0.04 MG/ACTUAT Metered Dose Inhaler",
            "120 ACTUAT beclomethasone dipropionate 0.08 MG/ACTUAT Metered Dose Inhaler",
            "120 actuat beclomethasone dipropionate 0.04 mg/actuat metered dose inhaler",
            "120 actuat beclomethasone dipropionate 0.08 mg/actuat metered dose inhaler",
            "QVAR",
            "QVAR (Inhalant)",
            "qvar",
            "qvar (inhalant)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LIORESAL",
        "route": "Injectable",
        "fullName": "LIORESAL (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "5 ML baclofen 2 MG/ML Injection",
            "5 ml baclofen 2 mg/ml injection",
            "LIORESAL",
            "LIORESAL (Injectable)",
            "Lioresal",
            "lioresal",
            "lioresal (injectable)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lactate/Urea",
        "route": "Topical",
        "fullName": "Lactate/Urea (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "Lactate/Urea",
            "Lactate/Urea (Topical)",
            "ammonium lactate 100 MG/ML / urea 200 MG/ML Topical Cream",
            "ammonium lactate 100 mg/ml / urea 200 mg/ml topical cream",
            "ammonium lactate 120 MG/ML / urea 200 MG/ML Topical Foam",
            "ammonium lactate 120 mg/ml / urea 200 mg/ml topical foam",
            "lactate/urea",
            "lactate/urea (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Lisinopril",
        "route": "Oral Liquid",
        "fullName": "Lisinopril (Oral Liquid)",
        "totalCount": 5,
        "searchTerms": [
            "Lisinopril",
            "Lisinopril (Oral Liquid)",
            "lisinopril",
            "lisinopril (oral liquid)",
            "lisinopril 1 MG/ML Oral Solution",
            "lisinopril 1 mg/ml oral solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ERLEADA",
        "route": "Oral Pill",
        "fullName": "ERLEADA (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "ERLEADA",
            "ERLEADA (Oral Pill)",
            "apalutamide 60 MG Oral Tablet",
            "apalutamide 60 mg oral tablet",
            "erleada",
            "erleada (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Propylene glycol",
        "route": "Ophthalmic",
        "fullName": "Propylene glycol (Ophthalmic)",
        "totalCount": 5,
        "searchTerms": [
            "Propylene glycol",
            "Propylene glycol (Ophthalmic)",
            "propylene glycol",
            "propylene glycol (ophthalmic)",
            "propylene glycol 6 MG/ML Ophthalmic Solution",
            "propylene glycol 6 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "amLODIPine",
        "route": "Oral Liquid",
        "fullName": "amLODIPine (Oral Liquid)",
        "totalCount": 5,
        "searchTerms": [
            "amLODIPine",
            "amLODIPine (Oral Liquid)",
            "amlodipine",
            "amlodipine (oral liquid)",
            "amlodipine 1 MG/ML Oral Suspension",
            "amlodipine 1 mg/ml oral suspension"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "cycloSPORINE",
        "route": "Oral Pill",
        "fullName": "cycloSPORINE (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "cycloSPORINE",
            "cycloSPORINE (Oral Pill)",
            "cyclosporine",
            "cyclosporine (oral pill)",
            "cyclosporine 25 MG Oral Capsule",
            "cyclosporine 25 mg oral capsule",
            "cyclosporine, modified 100 MG Oral Capsule",
            "cyclosporine, modified 100 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HumuLIN N",
        "route": "Injectable",
        "fullName": "HumuLIN N (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "3 ML insulin isophane, human 100 UNT/ML Pen Injector",
            "3 ml insulin isophane, human 100 unt/ml pen injector",
            "HUMULIN N",
            "HumuLIN N",
            "HumuLIN N (Injectable)",
            "humulin n",
            "humulin n (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Trospium XR",
        "route": "Oral Pill",
        "fullName": "Trospium XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "24 HR trospium chloride 60 MG Extended Release Oral Capsule",
            "24 hr trospium chloride 60 mg extended release oral capsule",
            "Trospium XR",
            "Trospium XR (Oral Pill)",
            "trospium xr",
            "trospium xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "60 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TAGRISSO",
        "route": "Oral Pill",
        "fullName": "TAGRISSO (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "TAGRISSO",
            "TAGRISSO (Oral Pill)",
            "osimertinib 80 MG Oral Tablet",
            "osimertinib 80 mg oral tablet",
            "tagrisso",
            "tagrisso (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Oxymetazoline",
        "route": "Nasal",
        "fullName": "Oxymetazoline (Nasal)",
        "totalCount": 5,
        "searchTerms": [
            "Oxymetazoline",
            "Oxymetazoline (Nasal)",
            "oxymetazoline",
            "oxymetazoline (nasal)",
            "oxymetazoline hydrochloride 0.5 MG/ML Nasal Solution",
            "oxymetazoline hydrochloride 0.5 mg/ml nasal solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "XTANDI",
        "route": "Oral Pill",
        "fullName": "XTANDI (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "XTANDI",
            "XTANDI (Oral Pill)",
            "enzalutamide 40 MG Oral Capsule",
            "enzalutamide 40 mg oral capsule",
            "xtandi",
            "xtandi (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Diclofenac XR",
        "route": "Oral Pill",
        "fullName": "Diclofenac XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "24 HR diclofenac sodium 100 MG Extended Release Oral Tablet",
            "24 hr diclofenac sodium 100 mg extended release oral tablet",
            "Diclofenac XR",
            "Diclofenac XR (Oral Pill)",
            "diclofenac xr",
            "diclofenac xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "GlyBURIDE/metFORMIN",
        "route": "Oral Pill",
        "fullName": "GlyBURIDE/metFORMIN (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "GlyBURIDE/metFORMIN",
            "GlyBURIDE/metFORMIN (Oral Pill)",
            "glyburide 1.25 MG / metformin hydrochloride 250 MG Oral Tablet",
            "glyburide 1.25 mg / metformin hydrochloride 250 mg oral tablet",
            "glyburide 2.5 MG / metformin hydrochloride 500 MG Oral Tablet",
            "glyburide 2.5 mg / metformin hydrochloride 500 mg oral tablet",
            "glyburide 5 MG / metformin hydrochloride 500 MG Oral Tablet",
            "glyburide 5 mg / metformin hydrochloride 500 mg oral tablet",
            "glyburide/metformin",
            "glyburide/metformin (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Naproxen/SUMAtriptan",
        "route": "Oral Pill",
        "fullName": "Naproxen/SUMAtriptan (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Naproxen/SUMAtriptan",
            "Naproxen/SUMAtriptan (Oral Pill)",
            "naproxen sodium 60 MG / sumatriptan 10 MG Oral Tablet",
            "naproxen sodium 60 mg / sumatriptan 10 mg oral tablet",
            "naproxen/sumatriptan",
            "naproxen/sumatriptan (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Darunavir",
        "route": "Oral Pill",
        "fullName": "Darunavir (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Darunavir",
            "Darunavir (Oral Pill)",
            "darunavir",
            "darunavir (oral pill)",
            "darunavir 800 MG Oral Tablet",
            "darunavir 800 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "800 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ritonavir",
        "route": "Oral Pill",
        "fullName": "Ritonavir (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Ritonavir",
            "Ritonavir (Oral Pill)",
            "Ritonavir (Oral)",
            "ritonavir",
            "ritonavir (oral pill)",
            "ritonavir (oral)",
            "ritonavir 100 MG Oral Capsule",
            "ritonavir 100 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ISENTRESS",
        "route": "Oral Pill",
        "fullName": "ISENTRESS (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "ISENTRESS",
            "ISENTRESS (Oral Pill)",
            "isentress",
            "isentress (oral pill)",
            "raltegravir 400 MG Oral Tablet",
            "raltegravir 400 mg oral tablet",
            "raltegravir 600 MG Oral Tablet",
            "raltegravir 600 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Diclofenac",
        "route": "Ophthalmic",
        "fullName": "Diclofenac (Ophthalmic)",
        "totalCount": 5,
        "searchTerms": [
            "Diclofenac",
            "Diclofenac (Ophthalmic)",
            "diclofenac",
            "diclofenac (ophthalmic)",
            "diclofenac sodium 1 MG/ML Ophthalmic Solution",
            "diclofenac sodium 1 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FLOXIN",
        "route": "Otic",
        "fullName": "FLOXIN (Otic)",
        "totalCount": 5,
        "searchTerms": [
            "FLOXIN",
            "FLOXIN (Otic)",
            "floxin",
            "floxin (otic)",
            "ofloxacin 3 MG/ML Otic Solution",
            "ofloxacin 3 mg/ml otic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LOTRIMIN",
        "route": "Topical",
        "fullName": "LOTRIMIN (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "LOTRIMIN",
            "LOTRIMIN (Topical)",
            "clotrimazole 10 MG/ML Topical Cream",
            "clotrimazole 10 mg/ml topical cream",
            "lotrimin",
            "lotrimin (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MUCINEX XR",
        "route": "Oral Pill",
        "fullName": "MUCINEX XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "12 HR guaifenesin 1200 MG Extended Release Oral Tablet",
            "12 HR guaifenesin 600 MG Extended Release Oral Tablet",
            "12 hr guaifenesin 1200 mg extended release oral tablet",
            "12 hr guaifenesin 600 mg extended release oral tablet",
            "MUCINEX",
            "MUCINEX XR",
            "MUCINEX XR (Oral Pill)",
            "mucinex",
            "mucinex xr",
            "mucinex xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Midazolam",
        "route": "Nasal",
        "fullName": "Midazolam (Nasal)",
        "totalCount": 5,
        "searchTerms": [
            "Midazolam",
            "Midazolam (Nasal)",
            "midazolam",
            "midazolam (nasal)",
            "midazolam 50 MG/ML Nasal Spray",
            "midazolam 50 mg/ml nasal spray"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cyproheptadine",
        "route": "Oral Liquid",
        "fullName": "Cyproheptadine (Oral Liquid)",
        "totalCount": 5,
        "searchTerms": [
            "Cyproheptadine",
            "Cyproheptadine (Oral Liquid)",
            "cyproheptadine",
            "cyproheptadine (oral liquid)",
            "cyproheptadine hydrochloride 0.4 MG/ML Oral Solution",
            "cyproheptadine hydrochloride 0.4 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TEMOVATE",
        "route": "Topical",
        "fullName": "TEMOVATE (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "Emollient clobetasol propionate 0.5 MG/ML Topical Cream",
            "TEMOVATE",
            "TEMOVATE (Topical)",
            "clobetasol propionate 0.0005 MG/MG Topical Gel",
            "clobetasol propionate 0.0005 mg/mg topical gel",
            "emollient clobetasol propionate 0.5 mg/ml topical cream",
            "temovate",
            "temovate (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Pramipexole XR",
        "route": "Oral Pill",
        "fullName": "Pramipexole XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "24 HR pramipexole dihydrochloride 2.25 MG Extended Release Oral Tablet",
            "24 HR pramipexole dihydrochloride 3.75 MG Extended Release Oral Tablet",
            "24 hr pramipexole dihydrochloride 2.25 mg extended release oral tablet",
            "24 hr pramipexole dihydrochloride 3.75 mg extended release oral tablet",
            "Pramipexole XR",
            "Pramipexole XR (Oral Pill)",
            "pramipexole xr",
            "pramipexole xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Selegiline",
        "route": "Oral Pill",
        "fullName": "Selegiline (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Selegiline",
            "Selegiline (Oral Pill)",
            "selegiline",
            "selegiline (oral pill)",
            "selegiline hydrochloride 5 MG Oral Capsule",
            "selegiline hydrochloride 5 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ascorbic acid/Folic acid/Iron carbonyl/Vitamin B12 XR",
        "route": "Oral Pill",
        "fullName": "Ascorbic acid/Folic acid/Iron carbonyl/Vitamin B12 XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "24 HR ascorbic acid 320 MG / folic acid 1 MG / iron carbonyl 100 MG / vitamin B12 0.025 MG Extended Release Oral Capsule",
            "24 hr ascorbic acid 320 mg / folic acid 1 mg / iron carbonyl 100 mg / vitamin b12 0.025 mg extended release oral capsule",
            "Ascorbic acid/Folic acid/Iron carbonyl/Vitamin B12 XR",
            "Ascorbic acid/Folic acid/Iron carbonyl/Vitamin B12 XR (Oral Pill)",
            "ascorbic acid/folic acid/iron carbonyl/vitamin b12 xr",
            "ascorbic acid/folic acid/iron carbonyl/vitamin b12 xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "UNIRETIC",
        "route": "Oral Pill",
        "fullName": "UNIRETIC (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "UNIRETIC",
            "UNIRETIC (Oral Pill)",
            "hydrochlorothiazide 12.5 MG / moexipril hydrochloride 15 MG Oral Tablet",
            "hydrochlorothiazide 12.5 mg / moexipril hydrochloride 15 mg oral tablet",
            "hydrochlorothiazide 25 MG / moexipril hydrochloride 15 MG Oral Tablet",
            "hydrochlorothiazide 25 mg / moexipril hydrochloride 15 mg oral tablet",
            "uniretic",
            "uniretic (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PRINIVIL",
        "route": "Oral Pill",
        "fullName": "PRINIVIL (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "PRINIVIL",
            "PRINIVIL (Oral Pill)",
            "lisinopril 10 MG Oral Tablet",
            "lisinopril 10 mg oral tablet",
            "lisinopril 20 MG Oral Tablet",
            "lisinopril 20 mg oral tablet",
            "prinivil",
            "prinivil (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NUBEQA",
        "route": "Oral Pill",
        "fullName": "NUBEQA (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "NUBEQA",
            "NUBEQA (Oral Pill)",
            "darolutamide 300 MG Oral Tablet",
            "darolutamide 300 mg oral tablet",
            "nubeqa",
            "nubeqa (oral pill)"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Mexiletine",
        "route": "Oral Pill",
        "fullName": "Mexiletine (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Mexiletine",
            "Mexiletine (Oral Pill)",
            "mexiletine",
            "mexiletine (oral pill)",
            "mexiletine hydrochloride 150 MG Oral Capsule",
            "mexiletine hydrochloride 150 mg oral capsule",
            "mexiletine hydrochloride 200 MG Oral Capsule",
            "mexiletine hydrochloride 200 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "WAL-FEX",
        "route": "Oral Pill",
        "fullName": "WAL-FEX (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "WAL-FEX",
            "WAL-FEX (Oral Pill)",
            "fexofenadine hydrochloride 180 MG Oral Tablet",
            "fexofenadine hydrochloride 180 mg oral tablet",
            "fexofenadine hydrochloride 60 MG Oral Tablet",
            "fexofenadine hydrochloride 60 mg oral tablet",
            "wal-fex",
            "wal-fex (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dantrolene",
        "route": "Oral Pill",
        "fullName": "Dantrolene (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Dantrolene",
            "Dantrolene (Oral Pill)",
            "dantrolene",
            "dantrolene (oral pill)",
            "dantrolene sodium 100 MG Oral Capsule",
            "dantrolene sodium 100 mg oral capsule",
            "dantrolene sodium 50 MG Oral Capsule",
            "dantrolene sodium 50 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Progesterone",
        "route": "Oral Pill",
        "fullName": "Progesterone (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Progesterone",
            "Progesterone (Oral Pill)",
            "Progesterone (Oral)",
            "progesterone",
            "progesterone (oral pill)",
            "progesterone (oral)",
            "progesterone 200 MG Oral Capsule",
            "progesterone 200 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ARIMIDEX",
        "route": "Oral Pill",
        "fullName": "ARIMIDEX (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "ARIMIDEX",
            "ARIMIDEX (Oral Pill)",
            "anastrozole 1 MG Oral Tablet",
            "anastrozole 1 mg oral tablet",
            "arimidex",
            "arimidex (oral pill)"
        ],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium carbonate",
        "route": "Chewable",
        "fullName": "Calcium carbonate (Chewable)",
        "totalCount": 5,
        "searchTerms": [
            "Calcium carbonate",
            "Calcium carbonate (Chewable)",
            "calcium carbonate",
            "calcium carbonate (chewable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "guaiFENesin XR",
        "route": "Oral Pill",
        "fullName": "guaiFENesin XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "guaiFENesin XR",
            "guaiFENesin XR (Oral Pill)",
            "guaifenesin xr",
            "guaifenesin xr (oral pill)"
        ],
        "dosages": [
            {
                "value": "600 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PHARBETOL",
        "route": "Oral Pill",
        "fullName": "PHARBETOL (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "PHARBETOL",
            "PHARBETOL (Oral Pill)",
            "acetaminophen 325 MG Oral Tablet",
            "acetaminophen 325 mg oral tablet",
            "acetaminophen 500 MG Oral Tablet",
            "acetaminophen 500 mg oral tablet",
            "pharbetol",
            "pharbetol (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Isoniazid",
        "route": "Oral Pill",
        "fullName": "Isoniazid (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Isoniazid",
            "Isoniazid (Oral Pill)",
            "Isoniazid (Oral)",
            "isoniazid",
            "isoniazid (oral pill)",
            "isoniazid (oral)",
            "isoniazid 300 MG Oral Tablet",
            "isoniazid 300 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "300 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Bictegravir/Emtricitabine/Tenofovir alafenamide",
        "route": "Oral Pill",
        "fullName": "Bictegravir/Emtricitabine/Tenofovir alafenamide (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Bictegravir/Emtricitabine/Tenofovir alafenamide",
            "Bictegravir/Emtricitabine/Tenofovir alafenamide (Oral Pill)",
            "bictegravir/emtricitabine/tenofovir alafenamide",
            "bictegravir/emtricitabine/tenofovir alafenamide (oral pill)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "scopolamine",
        "route": "Transdermal",
        "fullName": "scopolamine (Transdermal)",
        "totalCount": 5,
        "searchTerms": [
            "72 HR scopolamine 0.0139 MG/HR Transdermal System",
            "72 hr scopolamine 0.0139 mg/hr transdermal system",
            "Scopolamine",
            "Scopolamine (Transdermal)",
            "scopolamine",
            "scopolamine (transdermal)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BREYNA",
        "route": "Inhalant",
        "fullName": "BREYNA (Inhalant)",
        "totalCount": 5,
        "searchTerms": ["BREYNA", "BREYNA (Inhalant)", "breyna", "breyna (inhalant)"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OPSUMIT",
        "route": "Oral Pill",
        "fullName": "OPSUMIT (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "OPSUMIT",
            "OPSUMIT (Oral Pill)",
            "macitentan 10 MG Oral Tablet",
            "macitentan 10 mg oral tablet",
            "opsumit",
            "opsumit (oral pill)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "GAS-X",
        "route": "Chewable",
        "fullName": "GAS-X (Chewable)",
        "totalCount": 5,
        "searchTerms": [
            "GAS-X",
            "GAS-X (Chewable)",
            "gas-x",
            "gas-x (chewable)",
            "simethicone 80 MG Chewable Tablet",
            "simethicone 80 mg chewable tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Dofetilide",
        "route": "Oral Pill",
        "fullName": "Dofetilide (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Dofetilide",
            "Dofetilide (Oral Pill)",
            "Dofetilide (Oral)",
            "dofetilide",
            "dofetilide (oral pill)",
            "dofetilide (oral)",
            "dofetilide 0.125 MG Oral Capsule",
            "dofetilide 0.125 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ENVARSUS XR",
        "route": "Oral Pill",
        "fullName": "ENVARSUS XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "24 HR tacrolimus 4 MG Extended Release Oral Tablet",
            "24 hr tacrolimus 4 mg extended release oral tablet",
            "ENVARSUS",
            "ENVARSUS XR",
            "ENVARSUS XR (Oral Pill)",
            "Envarsus XR",
            "Envarsus XR (Oral)",
            "envarsus",
            "envarsus xr",
            "envarsus xr (oral pill)",
            "envarsus xr (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CONSTULOSE",
        "route": "Oral Liquid",
        "fullName": "CONSTULOSE (Oral Liquid)",
        "totalCount": 5,
        "searchTerms": [
            "CONSTULOSE",
            "CONSTULOSE (Oral Liquid)",
            "constulose",
            "constulose (oral liquid)",
            "lactulose 667 MG/ML Oral Solution",
            "lactulose 667 mg/ml oral solution"
        ],
        "dosages": [
            {
                "value": "10 g",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RELAFEN",
        "route": "Oral Pill",
        "fullName": "RELAFEN (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "RELAFEN",
            "RELAFEN (Oral Pill)",
            "nabumetone 1000 MG Oral Tablet",
            "nabumetone 1000 mg oral tablet",
            "relafen",
            "relafen (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BACITRACIN",
        "route": "Topical",
        "fullName": "BACITRACIN (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "BACITRACIN",
            "Bacitracin",
            "Bacitracin (Topical)",
            "bacitracin",
            "bacitracin (topical)",
            "bacitracin zinc 0.5 UNT/MG Topical Ointment",
            "bacitracin zinc 0.5 unt/mg topical ointment"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Umeclidinium/Vilanterol",
        "route": "Inhalant",
        "fullName": "Umeclidinium/Vilanterol (Inhalant)",
        "totalCount": 5,
        "searchTerms": [
            "7 ACTUAT umeclidinium 0.0625 MG/ACTUAT / vilanterol 0.025 MG/ACTUAT Dry Powder Inhaler",
            "7 actuat umeclidinium 0.0625 mg/actuat / vilanterol 0.025 mg/actuat dry powder inhaler",
            "Umeclidinium/Vilanterol",
            "Umeclidinium/Vilanterol (Inhalant)",
            "umeclidinium/vilanterol",
            "umeclidinium/vilanterol (inhalant)"
        ],
        "dosages": [
            {
                "value": "62.5-25 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Zinc acetate",
        "route": "Oral Pill",
        "fullName": "Zinc acetate (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Zinc acetate",
            "Zinc acetate (Oral Pill)",
            "zinc acetate",
            "zinc acetate (oral pill)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FOLIC ACID 1mg",
        "route": "Oral Pill",
        "fullName": "FOLIC ACID 1mg (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["FOLIC ACID 1mg", "folic acid 1mg"],
        "dosages": [
            {
                "value": "1 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Cabergoline",
        "route": "Oral Pill",
        "fullName": "Cabergoline (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Cabergoline",
            "Cabergoline (Oral Pill)",
            "Cabergoline (Oral)",
            "cabergoline",
            "cabergoline (oral pill)",
            "cabergoline (oral)",
            "cabergoline 0.5 MG Oral Tablet",
            "cabergoline 0.5 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Carisoprodol",
        "route": "Oral Pill",
        "fullName": "Carisoprodol (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Carisoprodol",
            "Carisoprodol (Oral Pill)",
            "Carisoprodol (Oral)",
            "carisoprodol",
            "carisoprodol (oral pill)",
            "carisoprodol (oral)",
            "carisoprodol 250 MG Oral Tablet",
            "carisoprodol 250 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "RABEprazole",
        "route": "Oral Pill",
        "fullName": "RABEprazole (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Aciphex",
            "RABEprazole",
            "RABEprazole (Oral Pill)",
            "Rabeprazole",
            "Rabeprazole (Oral)",
            "aciphex",
            "rabeprazole",
            "rabeprazole (oral pill)",
            "rabeprazole (oral)",
            "rabeprazole sodium 20 MG Delayed Release Oral Tablet",
            "rabeprazole sodium 20 mg delayed release oral tablet"
        ],
        "dosages": [
            {
                "value": "20 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Vitamin A",
        "route": "Oral Pill",
        "fullName": "Vitamin A (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["Vitamin A", "Vitamin A (Oral Pill)", "vitamin a", "vitamin a (oral pill)"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Enalapril/Hydrochlorothiazide",
        "route": "Oral Pill",
        "fullName": "Enalapril/Hydrochlorothiazide (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Enalapril/Hydrochlorothiazide",
            "Enalapril/Hydrochlorothiazide (Oral Pill)",
            "Enalapril/hydroCHLOROthiazide",
            "Enalapril/hydroCHLOROthiazide (Oral Pill)",
            "enalapril maleate 10 MG / hydrochlorothiazide 25 MG Oral Tablet",
            "enalapril maleate 10 mg / hydrochlorothiazide 25 mg oral tablet",
            "enalapril maleate 5 MG / hydrochlorothiazide 12.5 MG Oral Tablet",
            "enalapril maleate 5 mg / hydrochlorothiazide 12.5 mg oral tablet",
            "enalapril/hydrochlorothiazide",
            "enalapril/hydrochlorothiazide (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "IMBRUVICA",
        "route": "Oral Pill",
        "fullName": "IMBRUVICA (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "IMBRUVICA",
            "IMBRUVICA (Oral Pill)",
            "ibrutinib 140 MG Oral Capsule",
            "ibrutinib 140 mg oral capsule",
            "ibrutinib 420 MG Oral Tablet",
            "ibrutinib 420 mg oral tablet",
            "imbruvica",
            "imbruvica (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Potassium citrate XR",
        "route": "Oral Pill",
        "fullName": "Potassium citrate XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Potassium citrate XR",
            "Potassium citrate XR (Oral Pill)",
            "potassium citrate 10 MEQ Extended Release Oral Tablet",
            "potassium citrate 10 meq extended release oral tablet",
            "potassium citrate 5 MEQ Extended Release Oral Tablet",
            "potassium citrate 5 meq extended release oral tablet",
            "potassium citrate xr",
            "potassium citrate xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DELTA D3",
        "route": "Oral Pill",
        "fullName": "DELTA D3 (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["DELTA D3", "DELTA D3 (Oral Pill)", "delta d3", "delta d3 (oral pill)"],
        "dosages": [
            {
                "value": "10 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MAALOX PLUS",
        "route": "Oral Liquid",
        "fullName": "MAALOX PLUS (Oral Liquid)",
        "totalCount": 5,
        "searchTerms": [
            "MAALOX PLUS",
            "MAALOX PLUS (Oral Liquid)",
            "aluminum hydroxide 40 MG/ML / magnesium hydroxide 40 MG/ML / simethicone 4 MG/ML Oral Suspension",
            "aluminum hydroxide 40 mg/ml / magnesium hydroxide 40 mg/ml / simethicone 4 mg/ml oral suspension",
            "maalox plus",
            "maalox plus (oral liquid)"
        ],
        "dosages": [
            {
                "value": "200-200-20 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Aspirin MCD",
        "route": "Oral Pill",
        "fullName": "Aspirin MCD (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "ASPIR-LOW MCD",
            "ASPIRIN MCD",
            "ASPIRIN MCD (Oral)",
            "Aspirin MCD",
            "Aspirin MCD (Oral)",
            "Bayer Aspirin Low Dose",
            "Ecotrin",
            "aspir-low mcd",
            "aspirin mcd",
            "aspirin mcd (oral)",
            "bayer aspirin low dose",
            "ecotrin"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Olmesartan-HCTZ",
        "route": "Oral Pill",
        "fullName": "Olmesartan-HCTZ (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "BENICAR HCT",
            "Olmesartan-HCTZ",
            "Olmesartan-HCTZ (Oral)",
            "Olmesartan-Hctz",
            "Olmesartan-Hctz (Oral)",
            "Olmesartan-hctz",
            "Olmesartan-hctz (Oral)",
            "benicar hct",
            "olmesartan-hctz",
            "olmesartan-hctz (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ipratropium Bromide and Albuterol Sulfate",
        "route": "Inhaler",
        "fullName": "Ipratropium Bromide and Albuterol Sulfate (Inhaler)",
        "totalCount": 5,
        "searchTerms": [
            "DuoNeb",
            "Duoneb",
            "Ipratropium Bromide and Albuterol Sulfate",
            "Ipratropium Bromide and Albuterol Sulfate (Inhaler)",
            "duoneb",
            "ipratropium bromide and albuterol sulfate",
            "ipratropium bromide and albuterol sulfate (inhaler)"
        ],
        "dosages": [
            {
                "value": "0.5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Vitamin B-1 - Supplement",
        "route": "Oral Pill",
        "fullName": "Vitamin B-1 - Supplement (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Vitamin B-1 - Supplement",
            "Vitamin B-1 - Supplement (Oral)",
            "vitamin b-1 - supplement",
            "vitamin b-1 - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E51.9",
                "description": "Thiamine deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Bayer Aspirin Low Dose",
        "route": "Oral Pill",
        "fullName": "Bayer Aspirin Low Dose (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Bayer Aspirin Low Dose",
            "Bayer Aspirin Low Dose (Oral)",
            "bayer aspirin low dose",
            "bayer aspirin low dose (oral)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "NSAID",
                "pct": "100%"
            },
            {
                "value": "Pain reliever",
                "pct": "100%"
            }
        ],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Nature's Bounty Biotin - Supplement",
        "route": "Oral Pill",
        "fullName": "Nature's Bounty Biotin - Supplement (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Nature's Bounty Biotin - Supplement",
            "Nature's Bounty Biotin - Supplement (Oral)",
            "nature's bounty biotin - supplement",
            "nature's bounty biotin - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "St. Joseph Low Dose Aspirin",
        "route": "Oral Pill",
        "fullName": "St. Joseph Low Dose Aspirin (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "St. Joseph Low Dose Aspirin",
            "St. Joseph Low Dose Aspirin (Oral)",
            "st. joseph low dose aspirin",
            "st. joseph low dose aspirin (oral)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Calcium + D - Supplement",
        "route": "Oral Pill",
        "fullName": "Calcium + D - Supplement (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "CALCARB 600 WITH VITAMIN",
            "Calcium + D - Supplement",
            "Calcium + D - Supplement (Oral)",
            "Caltrate 600 with Vitamin D",
            "calcarb 600 with vitamin",
            "calcium + d - supplement",
            "calcium + d - supplement (oral)",
            "caltrate 600 with vitamin d"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Albuterol Sulfate Inhalation Aerosol HFA",
        "route": "Inhaler",
        "fullName": "Albuterol Sulfate Inhalation Aerosol HFA (Inhaler)",
        "totalCount": 5,
        "searchTerms": [
            "Albuterol Sulfate Inhalation Aerosol HFA",
            "Albuterol Sulfate Inhalation Aerosol HFA (Inhaler)",
            "albuterol sulfate inhalation aerosol hfa",
            "albuterol sulfate inhalation aerosol hfa (inhaler)"
        ],
        "dosages": [
            {
                "value": "90 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "ALPHAGAN P",
        "route": "Ophthalmic",
        "fullName": "ALPHAGAN P (Ophthalmic)",
        "totalCount": 5,
        "searchTerms": [
            "ALPHAGAN P",
            "Alphagan P",
            "Alphagan P (Ophthalmic)",
            "alphagan p",
            "alphagan p (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Multivitamins - Supplement",
        "route": "Oral Pill",
        "fullName": "Multivitamins - Supplement (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Multivitamins - Supplement",
            "Multivitamins - Supplement (Oral)",
            "multivitamins - supplement",
            "multivitamins - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Midodrine HCl",
        "route": "Oral Pill",
        "fullName": "Midodrine HCl (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Midodrine HCL",
            "Midodrine HCL (Oral)",
            "Midodrine HCl",
            "Midodrine HCl (Oral)",
            "midodrine hcl",
            "midodrine hcl (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I95.1",
                "description": "Orthostatic hypotension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "SYSTANE LUBRICANT EYE DROPS",
        "route": "Ophthalmic",
        "fullName": "SYSTANE LUBRICANT EYE DROPS (Ophthalmic)",
        "totalCount": 5,
        "searchTerms": [
            "SYSTANE LUBRICANT EYE DROPS",
            "Systane Lubricant Eye Drops",
            "Systane Lubricant Eye Drops (Ophthalmic)",
            "systane lubricant eye drops",
            "systane lubricant eye drops (ophthalmic)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Metoprolol XL",
        "route": "Oral Pill",
        "fullName": "Metoprolol XL (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "METOPROLOL XL",
            "METOPROLOL XL (Oral)",
            "Metoprolol XL",
            "Metoprolol XL (Oral)",
            "TOPROL XL",
            "Toprol XL",
            "metoprolol xl",
            "metoprolol xl (oral)",
            "toprol xl"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "budesonide-formoterol",
        "route": "Inhaler",
        "fullName": "budesonide-formoterol (Inhaler)",
        "totalCount": 5,
        "searchTerms": [
            "budesonide-formoterol",
            "budesonide-formoterol (Inhaler)",
            "budesonide-formoterol (inhaler)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J45.909",
                "description": "Unspecified asthma, uncomplicated",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Aspirin E.C.",
        "route": "Oral Pill",
        "fullName": "Aspirin E.C. (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Aspirin E.C.",
            "Aspirin E.C. (Oral)",
            "Ecotrin",
            "aspirin e.c.",
            "aspirin e.c. (oral)",
            "ecotrin"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I25.10",
                "description": "Athscl heart disease of native coronary artery w/o ang pctrs",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Nature's Bounty B-12 - Supplement",
        "route": "Oral Pill",
        "fullName": "Nature's Bounty B-12 - Supplement (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Nature's Bounty B-12 - Supplement",
            "Nature's Bounty B-12 - Supplement (Oral)",
            "nature's bounty b-12 - supplement",
            "nature's bounty b-12 - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ascorbic Acid - Supplement",
        "route": "Oral Pill",
        "fullName": "Ascorbic Acid - Supplement (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Acerola C",
            "Ascorbic Acid - Supplement",
            "Ascorbic Acid - Supplement (Oral)",
            "Easy-C Immune Health",
            "acerola c",
            "ascorbic acid - Supplement",
            "ascorbic acid - Supplement (Oral)",
            "ascorbic acid - supplement",
            "ascorbic acid - supplement (oral)",
            "easy-c immune health"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E56.9",
                "description": "Vitamin deficiency, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Metoprolol ER Succinate",
        "route": "Oral Pill",
        "fullName": "Metoprolol ER Succinate (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Metoprolol ER Succinate",
            "Metoprolol ER Succinate (Oral)",
            "metoprolol er succinate",
            "metoprolol er succinate (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "ZEPBOUND",
        "route": "Injectable",
        "fullName": "ZEPBOUND (Injectable)",
        "totalCount": 5,
        "searchTerms": ["ZEPBOUND", "ZEPBOUND (Injectable)", "zepbound", "zepbound (injectable)"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E66.9",
                "description": "Obesity, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "furosemide (LASIX)",
        "route": "Oral Pill",
        "fullName": "furosemide (LASIX) (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Furosemide (Lasix)",
            "Furosemide (Lasix) (Oral)",
            "furosemide (LASIX)",
            "furosemide (LASIX) (Oral)",
            "furosemide (lasix)",
            "furosemide (lasix) (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CVS Health Low Dose Aspirin",
        "route": "Oral Pill",
        "fullName": "CVS Health Low Dose Aspirin (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "CVS Health Low Dose Aspirin",
            "CVS Health Low Dose Aspirin (Oral)",
            "cvs health low dose aspirin",
            "cvs health low dose aspirin (oral)"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [
            {
                "value": "Pain reliever (NSAID)",
                "pct": "100%"
            },
            {
                "value": "Enteric coated tablets",
                "pct": "100%"
            }
        ],
        "diagnoses": []
    },
    {
        "name": "Vascepa (icosapent ethyl)",
        "route": "Oral Pill",
        "fullName": "Vascepa (icosapent ethyl) (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Vascepa (icosapent ethyl)",
            "Vascepa (icosapent ethyl) (Oral)",
            "vascepa (icosapent ethyl)",
            "vascepa (icosapent ethyl) (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Tradjenta (linagliptin)",
        "route": "Oral Pill",
        "fullName": "Tradjenta (linagliptin) (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Tradjenta (linagliptin)",
            "Tradjenta (linagliptin) (Oral)",
            "tradjenta (linagliptin)",
            "tradjenta (linagliptin) (oral)"
        ],
        "dosages": [
            {
                "value": "5 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Fluocinolone",
        "route": "Topical",
        "fullName": "Fluocinolone (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "Fluocinolone",
            "Fluocinolone (Topical)",
            "fluocinolone",
            "fluocinolone (topical)",
            "fluocinolone acetonide 0.00025 MG/MG Topical Ointment",
            "fluocinolone acetonide 0.00025 mg/mg topical ointment",
            "fluocinolone acetonide 0.1 MG/ML Topical Cream",
            "fluocinolone acetonide 0.1 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Azelastine Hydrochloride",
        "route": "Nasal",
        "fullName": "Azelastine Hydrochloride (Nasal)",
        "totalCount": 5,
        "searchTerms": [
            "Azelastine Hydrochloride",
            "Azelastine Hydrochloride (Nasal)",
            "azelastine hydrochloride",
            "azelastine hydrochloride (nasal)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "MOTEGRITY",
        "route": "Oral Pill",
        "fullName": "MOTEGRITY (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "MOTEGRITY",
            "MOTEGRITY (Oral Pill)",
            "Motegrity",
            "Motegrity (Oral)",
            "motegrity",
            "motegrity (oral pill)",
            "motegrity (oral)",
            "prucalopride 2 MG Oral Tablet",
            "prucalopride 2 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "2 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Liothyronine",
        "route": "Oral Pill",
        "fullName": "Liothyronine (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Liothyronine",
            "Liothyronine (Oral Pill)",
            "liothyronine",
            "liothyronine (oral pill)",
            "liothyronine sodium 0.005 MG Oral Tablet",
            "liothyronine sodium 0.005 mg oral tablet",
            "liothyronine sodium 0.05 MG Oral Tablet",
            "liothyronine sodium 0.05 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Azelastine HCl",
        "route": "Nasal",
        "fullName": "Azelastine HCl (Nasal)",
        "totalCount": 5,
        "searchTerms": [
            "Azelastine HCL",
            "Azelastine HCL (Nasal)",
            "Azelastine HCl",
            "Azelastine HCl (Nasal)",
            "azelastine HCl",
            "azelastine HCl (Nasal)",
            "azelastine hcl",
            "azelastine hcl (nasal)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "J30.9",
                "description": "Allergic rhinitis, unspecified",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Ondansetron ODT",
        "route": "Oral Pill",
        "fullName": "Ondansetron ODT (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Ondansetron ODT",
            "Ondansetron ODT (Oral)",
            "Zofran ODT",
            "ondansetron ODT",
            "ondansetron ODT (Oral)",
            "ondansetron odt",
            "ondansetron odt (oral)",
            "zofran odt"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R11.0",
                "description": "Nausea",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Bausch + Lomb PreserVision AREDS 2 Formula - Supplement",
        "route": "Oral Pill",
        "fullName": "Bausch + Lomb PreserVision AREDS 2 Formula - Supplement (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Bausch + Lomb PreserVision AREDS 2 Formula - Supplement",
            "Bausch + Lomb PreserVision AREDS 2 Formula - Supplement (Oral)",
            "bausch + lomb preservision areds 2 formula - supplement",
            "bausch + lomb preservision areds 2 formula - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [
            {
                "value": "Eye vitamin and mineral supplement",
                "pct": "100%"
            }
        ],
        "diagnoses": []
    },
    {
        "name": "NovoLog Mix 70/30 FlexPen",
        "route": "Injectable",
        "fullName": "NovoLog Mix 70/30 FlexPen (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "NovoLog Mix 70/30 FlexPen",
            "NovoLog Mix 70/30 FlexPen (Injectable)",
            "Novolog Mix 70/30 FlexPen",
            "Novolog Mix 70/30 FlexPen (Injectable)",
            "novolog mix 70/30 flexpen",
            "novolog mix 70/30 flexpen (injectable)"
        ],
        "dosages": [
            {
                "value": "100 units",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "ATORVASTATIN cal",
        "route": "Oral Pill",
        "fullName": "ATORVASTATIN cal (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "ATORVASTATIN CAL",
            "ATORVASTATIN CAL (Oral)",
            "ATORVASTATIN cal",
            "Atorvastatin Cal",
            "Atorvastatin Cal (Oral)",
            "Lipitor",
            "atorvastatin cal",
            "atorvastatin cal (oral)",
            "lipitor"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Nature Made Super B-Complex with C - Supplement",
        "route": "Oral Pill",
        "fullName": "Nature Made Super B-Complex with C - Supplement (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Nature Made Super B-Complex with C - Supplement",
            "Nature Made Super B-Complex with C - Supplement (Oral)",
            "nature made super b-complex with c - supplement",
            "nature made super b-complex with c - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Aspirin DR",
        "route": "Oral Pill",
        "fullName": "Aspirin DR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "ASPIRIN DR",
            "ASPIRIN DR (Oral)",
            "Aspirin DR",
            "Aspirin DR (Oral)",
            "BAYER LOW DOSE",
            "Bayer Low Dose Aspirin",
            "Ecotrin",
            "aspirin dr",
            "aspirin dr (oral)",
            "bayer low dose",
            "bayer low dose aspirin",
            "ecotrin"
        ],
        "dosages": [
            {
                "value": "81 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LOSARTAN POT",
        "route": "Oral Pill",
        "fullName": "LOSARTAN POT (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "LOSARTAN POT",
            "LOSARTAN POT (Oral)",
            "Losartan POT",
            "Losartan POT (Oral)",
            "Losartan Pot",
            "Losartan Pot (Oral)",
            "losartan pot",
            "losartan pot (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SUMATRIPTAN SUCCINATE",
        "route": "Oral Pill",
        "fullName": "SUMATRIPTAN SUCCINATE (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Imitrex",
            "SUMATRIPTAN SUCCINATE",
            "Sumatriptan Succinate",
            "Sumatriptan Succinate (Oral)",
            "imitrex",
            "sumatriptan succinate",
            "sumatriptan succinate (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ferrous Gluconate - Supplement",
        "route": "Oral Pill",
        "fullName": "Ferrous Gluconate - Supplement (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Ferrous Gluconate - Supplement",
            "Ferrous Gluconate - Supplement (Oral)",
            "ferrous gluconate - supplement",
            "ferrous gluconate - supplement (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ultra thin lancets",
        "route": "Injectable",
        "fullName": "Ultra thin lancets (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "Ultra Thin Lancets",
            "Ultra Thin Lancets (Injectable)",
            "Ultra thin lancets",
            "ultra thin lancets",
            "ultra thin lancets (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "tamsulosin (FLOMAX)",
        "route": "Oral Pill",
        "fullName": "tamsulosin (FLOMAX) (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Tamsulosin (Flomax)",
            "Tamsulosin (Flomax) (Oral)",
            "taMSULOSIN (FLOMAX)",
            "taMSULOSIN (FLOMAX) (Oral)",
            "tamsulosin (FLOMAX)",
            "tamsulosin (FLOMAX) (Oral)",
            "tamsulosin (flomax)",
            "tamsulosin (flomax) (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "LOSARTAN POTASSIUM-HCTZ",
        "route": "Oral Pill",
        "fullName": "LOSARTAN POTASSIUM-HCTZ (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Hyzaar",
            "LOSARTAN POTASSIUM-HCTZ",
            "Losartan Potassium-HCTZ",
            "Losartan Potassium-HCTZ (Oral)",
            "hyzaar",
            "losartan potassium-hctz",
            "losartan potassium-hctz (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Oxycodone-Acetaminophen",
        "route": "Oral Pill",
        "fullName": "Oxycodone-Acetaminophen (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Oxycodone-Acetaminophen",
            "Oxycodone-Acetaminophen (Oral)",
            "Oxycodone-acetaminophen",
            "Oxycodone-acetaminophen (Oral)",
            "oxyCODONE-acetaminophen",
            "oxyCODONE-acetaminophen (Oral)",
            "oxycodone-acetaminophen",
            "oxycodone-acetaminophen (oral)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "As needed",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Sacubitril, Valsartan",
        "route": "Oral Pill",
        "fullName": "Sacubitril, Valsartan (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "ENTRESTO",
            "Entresto",
            "SACUBITRIL, VALSARTAN",
            "SACUBITRIL, VALSARTAN (Oral)",
            "Sacubitril, Valsartan",
            "Sacubitril, Valsartan (Oral)",
            "entresto",
            "sacubitril, valsartan",
            "sacubitril, valsartan (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Escitalopram Oxalate",
        "route": "Oral Pill",
        "fullName": "Escitalopram Oxalate (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "ESCITALOPRAM OXALATE",
            "ESCITALOPRAM OXALATE (Oral)",
            "Escitalopram Oxalate",
            "Escitalopram Oxalate (Oral)",
            "escitalopram oxalate",
            "escitalopram oxalate (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "F41.1",
                "description": "Generalized anxiety disorder",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Tresiba FlexTouch (insulin degludec)",
        "route": "Injectable",
        "fullName": "Tresiba FlexTouch (insulin degludec) (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "TRESIBA FlexTouch (insulin degludec)",
            "TRESIBA FlexTouch (insulin degludec) (Injectable)",
            "Tresiba FlexTouch (Insulin Degludec)",
            "Tresiba FlexTouch (Insulin Degludec) (Injectable)",
            "Tresiba FlexTouch (insulin degludec)",
            "Tresiba FlexTouch (insulin degludec) (Injectable)",
            "tresiba flextouch (insulin degludec)",
            "tresiba flextouch (insulin degludec) (injectable)"
        ],
        "dosages": [
            {
                "value": "100 units",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Multivitamin Tablet",
        "route": "Oral Pill",
        "fullName": "Multivitamin Tablet (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["Multivitamin Tablet", "multivitamin tablet"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Psyllium",
        "route": "Oral Suspension Powder",
        "fullName": "Psyllium (Oral Suspension Powder)",
        "totalCount": 5,
        "searchTerms": [
            "Psyllium",
            "Psyllium (Oral Suspension Powder)",
            "psyllium",
            "psyllium (oral suspension powder)",
            "psyllium 3500 MG Powder for Oral Suspension",
            "psyllium 3500 mg powder for oral suspension",
            "psyllium 6000 MG Powder for Oral Suspension",
            "psyllium 6000 mg powder for oral suspension"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Bromfenac",
        "route": "Ophthalmic",
        "fullName": "Bromfenac (Ophthalmic)",
        "totalCount": 5,
        "searchTerms": [
            "Bromfenac",
            "Bromfenac (Ophthalmic)",
            "bromfenac",
            "bromfenac (ophthalmic)",
            "bromfenac 0.75 MG/ML Ophthalmic Solution",
            "bromfenac 0.75 mg/ml ophthalmic solution",
            "bromfenac 0.9 MG/ML Ophthalmic Solution",
            "bromfenac 0.9 mg/ml ophthalmic solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Admelog SoloStar (insulin lispro)",
        "route": "Injectable",
        "fullName": "Admelog SoloStar (insulin lispro) (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "Admelog SoloStar (insulin lispro)",
            "Admelog SoloStar (insulin lispro) (Injectable)",
            "admelog solostar (insulin lispro)",
            "admelog solostar (insulin lispro) (injectable)"
        ],
        "dosages": [
            {
                "value": "100 units",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "E11.9",
                "description": "Type 2 diabetes mellitus without complications",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Breztri Aerosphere",
        "route": "Inhaler",
        "fullName": "Breztri Aerosphere (Inhaler)",
        "totalCount": 5,
        "searchTerms": [
            "BREZTRI AEROSPHERE",
            "BREZTRI AEROSPHERE (Inhaler)",
            "Breztri Aerosphere",
            "Breztri Aerosphere (Inhaler)",
            "breztri aerosphere",
            "breztri aerosphere (inhaler)"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Twice daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Nifedipine XL",
        "route": "Oral Pill",
        "fullName": "Nifedipine XL (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "NIFEdipine XL",
            "NIFEdipine XL (Oral)",
            "Nifedipine XL",
            "Nifedipine XL (Oral)",
            "Procardia XL",
            "nifedipine xl",
            "nifedipine xl (oral)",
            "procardia xl"
        ],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "I10",
                "description": "Essential (primary) hypertension",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "hydroxychloroquine sulfate",
        "route": "Oral Pill",
        "fullName": "hydroxychloroquine sulfate (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "HYDROXYCHLOROQUINE SULFATE",
            "HYDROXYCHLOROQUINE SULFATE (Oral)",
            "Hydroxychloroquine Sulfate",
            "Hydroxychloroquine Sulfate (Oral)",
            "Plaquenil",
            "hydroxychloroquine sulfate",
            "hydroxychloroquine sulfate (oral)",
            "plaquenil"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "guanFACINE XR",
        "route": "Oral Pill",
        "fullName": "guanFACINE XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "24 HR guanfacine 2 MG Extended Release Oral Tablet",
            "24 hr guanfacine 2 mg extended release oral tablet",
            "guanFACINE XR",
            "guanFACINE XR (Oral Pill)",
            "guanfacine xr",
            "guanfacine xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Escitalopram",
        "route": "Oral Liquid",
        "fullName": "Escitalopram (Oral Liquid)",
        "totalCount": 5,
        "searchTerms": [
            "Escitalopram",
            "Escitalopram (Oral Liquid)",
            "escitalopram",
            "escitalopram (oral liquid)",
            "escitalopram 1 MG/ML Oral Solution",
            "escitalopram 1 mg/ml oral solution"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Oxybutynin Chloride ER",
        "route": "Oral Pill",
        "fullName": "Oxybutynin Chloride ER (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Ditropan",
            "Ditropan XL",
            "Oxybutynin Chloride ER",
            "Oxybutynin Chloride ER (Oral)",
            "ditropan",
            "ditropan xl",
            "oxyBUTYnin CHLORIDE ER",
            "oxyBUTYnin CHLORIDE ER (Oral)",
            "oxybutynin chloride er",
            "oxybutynin chloride er (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "R32",
                "description": "Unspecified urinary incontinence",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Diclofenac Epolamine Topical System",
        "route": "Topical",
        "fullName": "Diclofenac Epolamine Topical System (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "Diclofenac Epolamine Topical System",
            "Diclofenac Epolamine Topical System (Topical)",
            "diclofenac epolamine topical system",
            "diclofenac epolamine topical system (Topical)",
            "diclofenac epolamine topical system (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": [
            {
                "code": "M19.90",
                "description": "Unspecified osteoarthritis, unspecified site",
                "pct": "100%"
            }
        ]
    },
    {
        "name": "Levothyroxin",
        "route": "Oral Pill",
        "fullName": "Levothyroxin (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Levothyroxin",
            "Levothyroxin (Oral)",
            "SYNTHROID",
            "levothyroxin",
            "levothyroxin (oral)",
            "synthroid"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ENBREL",
        "route": "Injectable",
        "fullName": "ENBREL (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "1 ML etanercept 50 MG/ML Auto-Injector",
            "1 ml etanercept 50 mg/ml auto-injector",
            "ENBREL",
            "ENBREL (Injectable)",
            "enbrel",
            "enbrel (injectable)"
        ],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [
            {
                "value": "Weekly",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "JOURNAVX",
        "route": "Oral Pill",
        "fullName": "JOURNAVX (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["JOURNAVX", "JOURNAVX (Oral Pill)", "journavx", "journavx (oral pill)"],
        "dosages": [
            {
                "value": "50 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "metroNIDAZOLE",
        "route": "Topical",
        "fullName": "metroNIDAZOLE (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "metroNIDAZOLE",
            "metroNIDAZOLE (Topical)",
            "metronidazole",
            "metronidazole (topical)",
            "metronidazole 7.5 MG/ML Topical Cream",
            "metronidazole 7.5 MG/ML Topical Lotion",
            "metronidazole 7.5 mg/ml topical cream",
            "metronidazole 7.5 mg/ml topical lotion"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "URSO",
        "route": "Oral Pill",
        "fullName": "URSO (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "URSO",
            "URSO (Oral Pill)",
            "urso",
            "urso (oral pill)",
            "ursodiol 250 MG Oral Tablet",
            "ursodiol 250 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VIT D",
        "route": "Oral Pill",
        "fullName": "VIT D (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "DRISDOL",
            "Drisdol",
            "VIT D",
            "VIT D (Oral)",
            "Vit D",
            "Vit D (Oral)",
            "drisdol",
            "vit d",
            "vit d (oral)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NORVIR",
        "route": "Oral Pill",
        "fullName": "NORVIR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "NORVIR",
            "NORVIR (Oral Pill)",
            "norvir",
            "norvir (oral pill)",
            "ritonavir 100 MG Oral Capsule",
            "ritonavir 100 mg oral capsule"
        ],
        "dosages": [
            {
                "value": "100 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Econazole",
        "route": "Topical",
        "fullName": "Econazole (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "Econazole",
            "Econazole (Topical)",
            "econazole",
            "econazole (topical)",
            "econazole nitrate 10 MG/ML Topical Cream",
            "econazole nitrate 10 MG/ML Topical Foam",
            "econazole nitrate 10 mg/ml topical cream",
            "econazole nitrate 10 mg/ml topical foam"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Acyclovir",
        "route": "Topical",
        "fullName": "Acyclovir (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "Acyclovir",
            "Acyclovir (Topical)",
            "acyclovir",
            "acyclovir (topical)",
            "acyclovir 50 MG/ML Topical Cream",
            "acyclovir 50 mg/ml topical cream"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Etodolac",
        "route": "Oral Pill",
        "fullName": "Etodolac (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Etodolac",
            "Etodolac (Oral Pill)",
            "etodolac",
            "etodolac (oral pill)",
            "etodolac 200 MG Oral Capsule",
            "etodolac 200 mg oral capsule",
            "etodolac 400 MG Oral Tablet",
            "etodolac 400 mg oral tablet",
            "etodolac 500 MG Oral Tablet",
            "etodolac 500 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PEPCID COMPLETE",
        "route": "Chewable",
        "fullName": "PEPCID COMPLETE (Chewable)",
        "totalCount": 5,
        "searchTerms": [
            "PEPCID COMPLETE",
            "PEPCID COMPLETE (Chewable)",
            "calcium carbonate 800 MG / famotidine 10 MG / magnesium hydroxide 165 MG Chewable Tablet",
            "calcium carbonate 800 mg / famotidine 10 mg / magnesium hydroxide 165 mg chewable tablet",
            "pepcid complete",
            "pepcid complete (chewable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Fibrinogen/Thrombin",
        "route": "Topical",
        "fullName": "Fibrinogen/Thrombin (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "Fibrinogen/Thrombin",
            "Fibrinogen/Thrombin (Topical)",
            "fibrinogen concentrate (human) 337 MG / Thrombin (Human) 123 UNT Medicated Patch",
            "fibrinogen concentrate (human) 337 mg / thrombin (human) 123 unt medicated patch",
            "fibrinogen/thrombin",
            "fibrinogen/thrombin (topical)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TYLENOL BE READY KIT",
        "route": "Pack",
        "fullName": "TYLENOL BE READY KIT (Pack)",
        "totalCount": 5,
        "searchTerms": [
            "TYLENOL BE READY KIT",
            "TYLENOL BE READY KIT (Pack)",
            "tylenol be ready kit",
            "tylenol be ready kit (pack)",
            "{24 (acetaminophen 160 MG Chewable Tablet [Tylenol]) / 1 (120 ML) (acetaminophen 32 MG/ML Oral Suspension [Tylenol]) } Pack",
            "{24 (acetaminophen 160 mg chewable tablet [tylenol]) / 1 (120 ml) (acetaminophen 32 mg/ml oral suspension [tylenol]) } pack"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "STANBACK HEADACHE POWDER REFORMULATED JAN 2011",
        "route": "Oral Powder",
        "fullName": "STANBACK HEADACHE POWDER REFORMULATED JAN 2011 (Oral Powder)",
        "totalCount": 5,
        "searchTerms": [
            "STANBACK HEADACHE POWDER REFORMULATED JAN 2011",
            "STANBACK HEADACHE POWDER REFORMULATED JAN 2011 (Oral Powder)",
            "aspirin 845 MG / caffeine 65 MG Oral Powder",
            "aspirin 845 mg / caffeine 65 mg oral powder",
            "stanback headache powder reformulated jan 2011",
            "stanback headache powder reformulated jan 2011 (oral powder)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "SYNALGOS-DC",
        "route": "Oral Pill",
        "fullName": "SYNALGOS-DC (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "SYNALGOS-DC",
            "SYNALGOS-DC (Oral Pill)",
            "aspirin 356.4 MG / caffeine 30 MG / dihydrocodeine bitartrate 16 MG Oral Capsule",
            "aspirin 356.4 mg / caffeine 30 mg / dihydrocodeine bitartrate 16 mg oral capsule",
            "synalgos-dc",
            "synalgos-dc (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OSENI",
        "route": "Oral Pill",
        "fullName": "OSENI (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "OSENI",
            "OSENI (Oral Pill)",
            "alogliptin 12.5 MG / pioglitazone 30 MG Oral Tablet",
            "alogliptin 12.5 mg / pioglitazone 30 mg oral tablet",
            "alogliptin 25 MG / pioglitazone 15 MG Oral Tablet",
            "alogliptin 25 mg / pioglitazone 15 mg oral tablet",
            "oseni",
            "oseni (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DUEXIS",
        "route": "Oral Pill",
        "fullName": "DUEXIS (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "DUEXIS",
            "DUEXIS (Oral Pill)",
            "duexis",
            "duexis (oral pill)",
            "famotidine 26.6 MG / ibuprofen 800 MG Oral Tablet",
            "famotidine 26.6 mg / ibuprofen 800 mg oral tablet"
        ],
        "dosages": [
            {
                "value": "26.6-800 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "ELAVIL",
        "route": "Oral Pill",
        "fullName": "ELAVIL (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "ELAVIL",
            "ELAVIL (Oral Pill)",
            "amitriptyline hydrochloride 25 MG Oral Tablet",
            "amitriptyline hydrochloride 25 mg oral tablet",
            "elavil",
            "elavil (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "NUPRO CHLORHEXIDINE",
        "route": "Mouthwash",
        "fullName": "NUPRO CHLORHEXIDINE (Mouthwash)",
        "totalCount": 5,
        "searchTerms": [
            "NUPRO CHLORHEXIDINE",
            "NUPRO CHLORHEXIDINE (Mouthwash)",
            "chlorhexidine gluconate 1.2 MG/ML Mouthwash",
            "chlorhexidine gluconate 1.2 mg/ml mouthwash",
            "nupro chlorhexidine",
            "nupro chlorhexidine (mouthwash)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FORTEO",
        "route": "Injectable",
        "fullName": "FORTEO (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "28 ACTUAT teriparatide 0.02 MG/ACTUAT Pen Injector",
            "28 actuat teriparatide 0.02 mg/actuat pen injector",
            "FORTEO",
            "FORTEO (Injectable)",
            "forteo",
            "forteo (injectable)"
        ],
        "dosages": [
            {
                "value": "20 mcg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Hydrocortisone/Lidocaine",
        "route": "Rectal",
        "fullName": "Hydrocortisone/Lidocaine (Rectal)",
        "totalCount": 5,
        "searchTerms": [
            "Hydrocortisone/Lidocaine",
            "Hydrocortisone/Lidocaine (Rectal)",
            "hydrocortisone acetate 0.0055 MG/MG / lidocaine hydrochloride 0.028 MG/MG Rectal Gel",
            "hydrocortisone acetate 0.0055 mg/mg / lidocaine hydrochloride 0.028 mg/mg rectal gel",
            "hydrocortisone acetate 0.025 MG/MG / lidocaine hydrochloride 0.03 MG/MG Rectal Gel",
            "hydrocortisone acetate 0.025 mg/mg / lidocaine hydrochloride 0.03 mg/mg rectal gel",
            "hydrocortisone acetate 20 MG/ML / lidocaine hydrochloride 20 MG/ML Rectal Cream",
            "hydrocortisone acetate 20 mg/ml / lidocaine hydrochloride 20 mg/ml rectal cream",
            "hydrocortisone/lidocaine",
            "hydrocortisone/lidocaine (rectal)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "HIPREX",
        "route": "Oral Pill",
        "fullName": "HIPREX (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "HIPREX",
            "HIPREX (Oral Pill)",
            "hiprex",
            "hiprex (oral pill)",
            "methenamine hippurate 1000 MG Oral Tablet",
            "methenamine hippurate 1000 mg oral tablet"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OMEGAVEN",
        "route": "Injectable",
        "fullName": "OMEGAVEN (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "50 ML fish oil (containing omega-3 acids) 100 MG/ML Injection",
            "50 ml fish oil (containing omega-3 acids) 100 mg/ml injection",
            "OMEGAVEN",
            "OMEGAVEN (Injectable)",
            "omegaven",
            "omegaven (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ciprofloxacin",
        "route": "Injectable",
        "fullName": "Ciprofloxacin (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "100 ML ciprofloxacin 2 MG/ML Injection",
            "100 ml ciprofloxacin 2 mg/ml injection",
            "20 ML ciprofloxacin 10 MG/ML Injection",
            "20 ml ciprofloxacin 10 mg/ml injection",
            "200 ML ciprofloxacin 2 MG/ML Injection",
            "200 ml ciprofloxacin 2 mg/ml injection",
            "Ciprofloxacin",
            "Ciprofloxacin (Injectable)",
            "ciprofloxacin",
            "ciprofloxacin (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "DULCOLAX",
        "route": "Rectal",
        "fullName": "DULCOLAX (Rectal)",
        "totalCount": 5,
        "searchTerms": [
            "DULCOLAX",
            "DULCOLAX (Rectal)",
            "bisacodyl 10 MG Rectal Suppository",
            "bisacodyl 10 mg rectal suppository",
            "dulcolax",
            "dulcolax (rectal)"
        ],
        "dosages": [
            {
                "value": "10 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "QUEtiapine",
        "route": "Pack",
        "fullName": "QUEtiapine (Pack)",
        "totalCount": 5,
        "searchTerms": [
            "QUEtiapine",
            "QUEtiapine (Pack)",
            "quetiapine",
            "quetiapine (pack)",
            "{1 (24 HR quetiapine 200 MG Extended Release Oral Tablet) / 11 (24 HR quetiapine 300 MG Extended Release Oral Tablet) / 3 (24 HR quetiapine 50 MG Extended Release Oral Tablet) } Pack",
            "{1 (24 hr quetiapine 200 mg extended release oral tablet) / 11 (24 hr quetiapine 300 mg extended release oral tablet) / 3 (24 hr quetiapine 50 mg extended release oral tablet) } pack"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "GABLOFEN",
        "route": "Injectable",
        "fullName": "GABLOFEN (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "20 ML baclofen 0.5 MG/ML Prefilled Syringe",
            "20 ML baclofen 1 MG/ML Injection",
            "20 ML baclofen 1 MG/ML Prefilled Syringe",
            "20 ML baclofen 2 MG/ML Injection",
            "20 ml baclofen 0.5 mg/ml prefilled syringe",
            "20 ml baclofen 1 mg/ml injection",
            "20 ml baclofen 1 mg/ml prefilled syringe",
            "20 ml baclofen 2 mg/ml injection",
            "GABLOFEN",
            "GABLOFEN (Injectable)",
            "gablofen",
            "gablofen (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "BACTROBAN",
        "route": "Topical",
        "fullName": "BACTROBAN (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "BACTROBAN",
            "BACTROBAN (Topical)",
            "bactroban",
            "bactroban (topical)",
            "mupirocin 0.02 MG/MG Topical Ointment",
            "mupirocin 0.02 mg/mg topical ointment"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "VICODIN",
        "route": "Oral Pill",
        "fullName": "VICODIN (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "VICODIN",
            "VICODIN (Oral Pill)",
            "acetaminophen 300 MG / hydrocodone bitartrate 5 MG Oral Tablet",
            "acetaminophen 300 mg / hydrocodone bitartrate 5 mg oral tablet",
            "vicodin",
            "vicodin (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "WELLBUTRIN",
        "route": "Oral Pill",
        "fullName": "WELLBUTRIN (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "WELLBUTRIN",
            "WELLBUTRIN (Oral Pill)",
            "bupropion hydrochloride 100 MG Oral Tablet",
            "bupropion hydrochloride 100 mg oral tablet",
            "wellbutrin",
            "wellbutrin (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "OLANZapine",
        "route": "Injectable",
        "fullName": "OLANZapine (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "OLANZapine",
            "OLANZapine (Injectable)",
            "olanzapine",
            "olanzapine (injectable)",
            "olanzapine 210 MG Injection",
            "olanzapine 210 mg injection",
            "olanzapine 300 MG Injection",
            "olanzapine 300 mg injection",
            "olanzapine 405 MG Injection",
            "olanzapine 405 mg injection"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "MACROBID",
        "route": "Oral Pill",
        "fullName": "MACROBID (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "MACROBID",
            "MACROBID (Oral Pill)",
            "macrobid",
            "macrobid (oral pill)",
            "nitrofurantoin, macrocrystals 25 MG / nitrofurantoin, monohydrate 75 MG Oral Capsule",
            "nitrofurantoin, macrocrystals 25 mg / nitrofurantoin, monohydrate 75 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Loxapine",
        "route": "Oral Pill",
        "fullName": "Loxapine (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Loxapine",
            "Loxapine (Oral Pill)",
            "loxapine",
            "loxapine (oral pill)",
            "loxapine 10 MG Oral Capsule",
            "loxapine 10 mg oral capsule",
            "loxapine 25 MG Oral Capsule",
            "loxapine 25 mg oral capsule",
            "loxapine 50 MG Oral Capsule",
            "loxapine 50 mg oral capsule"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "CARTIA XR",
        "route": "Oral Pill",
        "fullName": "CARTIA XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "24 HR diltiazem hydrochloride 120 MG Extended Release Oral Capsule",
            "24 HR diltiazem hydrochloride 180 MG Extended Release Oral Capsule",
            "24 hr diltiazem hydrochloride 120 mg extended release oral capsule",
            "24 hr diltiazem hydrochloride 180 mg extended release oral capsule",
            "CARTIA",
            "CARTIA XR",
            "CARTIA XR (Oral Pill)",
            "cartia",
            "cartia xr",
            "cartia xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Melatonin/Pyridoxine XR",
        "route": "Oral Pill",
        "fullName": "Melatonin/Pyridoxine XR (Oral Pill)",
        "totalCount": 5,
        "searchTerms": [
            "Melatonin/Pyridoxine XR",
            "Melatonin/Pyridoxine XR (Oral Pill)",
            "melatonin 2.5 MG / pyridoxine hydrochloride 10 MG Extended Release Oral Tablet",
            "melatonin 2.5 mg / pyridoxine hydrochloride 10 mg extended release oral tablet",
            "melatonin/pyridoxine xr",
            "melatonin/pyridoxine xr (oral pill)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TIROSINT",
        "route": "Oral Liquid",
        "fullName": "TIROSINT (Oral Liquid)",
        "totalCount": 5,
        "searchTerms": [
            "TIROSINT",
            "TIROSINT (Oral Liquid)",
            "levothyroxine sodium 0.025 MG/ML Oral Solution",
            "levothyroxine sodium 0.025 mg/ml oral solution",
            "levothyroxine sodium 0.05 MG/ML Oral Solution",
            "levothyroxine sodium 0.05 mg/ml oral solution",
            "tirosint",
            "tirosint (oral liquid)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "TAB A VITE",
        "route": "Oral Pill",
        "fullName": "TAB A VITE (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["TAB A VITE", "tab a vite"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "PROSIGHT",
        "route": "Oral Pill",
        "fullName": "PROSIGHT (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["PROSIGHT", "prosight"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "EUCERIN CALMING ITCH RELIEF",
        "route": "Topical",
        "fullName": "EUCERIN CALMING ITCH RELIEF (Topical)",
        "totalCount": 5,
        "searchTerms": [
            "EUCERIN CALMING ITCH RELIEF",
            "EUCERIN CALMING ITCH RELIEF (Topical)",
            "eucerin calming itch relief",
            "eucerin calming itch relief (topical)",
            "menthol 1 MG/ML Topical Lotion",
            "menthol 1 mg/ml topical lotion"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Paliperidone",
        "route": "Injectable",
        "fullName": "Paliperidone (Injectable)",
        "totalCount": 5,
        "searchTerms": [
            "0.875 ML paliperidone palmitate 312 MG/ML Prefilled Syringe",
            "0.875 ml paliperidone palmitate 312 mg/ml prefilled syringe",
            "1.5 ML paliperidone palmitate 156 MG/ML Prefilled Syringe",
            "1.5 ml paliperidone palmitate 156 mg/ml prefilled syringe",
            "2.625 ML paliperidone palmitate 312 MG/ML Prefilled Syringe",
            "2.625 ml paliperidone palmitate 312 mg/ml prefilled syringe",
            "Paliperidone",
            "Paliperidone (Injectable)",
            "paliperidone",
            "paliperidone (injectable)"
        ],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Garlic",
        "route": "Oral Pill",
        "fullName": "Garlic (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["GARLIC", "Garlic", "garlic"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Fish oil omega 3",
        "route": "Oral Pill",
        "fullName": "Fish oil omega 3 (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["Fish oil omega 3", "fish oil omega 3"],
        "dosages": [
            {
                "value": "1000 mg",
                "pct": "100%"
            }
        ],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Ensure",
        "route": "Oral Pill",
        "fullName": "Ensure (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["Ensure", "ensure"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "FLORANEX",
        "route": "Oral Pill",
        "fullName": "FLORANEX (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["FLORANEX", "Floranex", "floranex"],
        "dosages": [],
        "frequencies": [],
        "adminNotes": [],
        "diagnoses": []
    },
    {
        "name": "Probiotic Acidophilus",
        "route": "Oral Pill",
        "fullName": "Probiotic Acidophilus (Oral Pill)",
        "totalCount": 5,
        "searchTerms": ["Probiotic Acidophilus", "probiotic acidophilus"],
        "dosages": [],
        "frequencies": [
            {
                "value": "Once daily",
                "pct": "100%"
            }
        ],
        "adminNotes": [],
        "diagnoses": []
    }
]
